webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function lookupOrAppend(conversionTable, _default_append) {
    return function (string) {
        if (conversionTable.hasOwnProperty(string))
            return conversionTable[string];
        if (!_default_append)
            throw new Error("I do not know how to modify the following string: "
                + string +
                ". "
                + "Change your TeX file or submit a feature request at "
                + "https://github.com/digitalheir/tex-to-unicode/issues.");
        return string + _default_append;
    };
}
exports.lookupOrAppend = lookupOrAppend;
//# sourceMappingURL=command-expander.js.map

/***/ }),
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.simpleSuffix = function (modifier) {
    return function (char) {
        return char + modifier;
    };
};
exports.isSingleTerm = /^.$|^[0-9]+$/;
function addParenthesis(n) {
    return "(" + n + ")";
}
exports.addParenthesis = addParenthesis;
//# sourceMappingURL=util.js.map

/***/ }),
/* 14 */,
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Backbone, _, $) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _localization = __webpack_require__(3);

var _localization2 = _interopRequireDefault(_localization);

var _iconButton = __webpack_require__(34);

var _iconButton2 = _interopRequireDefault(_iconButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Additional dependencies: jQuery, underscore.
/**
 * Dataset metedata.
 */
var DatasetMetadata = Backbone.Model.extend({});

/**
 * A dataset. In Galaxy, datasets are associated with a history, so
 * this object is also known as a HistoryDatasetAssociation.
 */
var Dataset = Backbone.Model.extend({
    defaults: {
        id: "",
        type: "",
        name: "",
        hda_ldda: "hda",
        metadata: null
    },

    initialize: function initialize() {
        // Metadata can be passed in as a model or a set of attributes; if it's
        // already a model, there's no need to set metadata.
        if (!this.get("metadata")) {
            this._set_metadata();
        }

        // Update metadata on change.
        this.on("change", this._set_metadata, this);
    },

    _set_metadata: function _set_metadata() {
        var metadata = new DatasetMetadata();

        // Move metadata from dataset attributes to metadata object.
        _.each(_.keys(this.attributes), function (k) {
            if (k.indexOf("metadata_") === 0) {
                // Found metadata.
                var new_key = k.split("metadata_")[1];
                metadata.set(new_key, this.attributes[k]);
                delete this.attributes[k];
            }
        }, this);

        // Because this is an internal change, silence it.
        this.set("metadata", metadata, { silent: true });
    },

    /**
     * Returns dataset metadata for a given attribute.
     */
    get_metadata: function get_metadata(attribute) {
        return this.attributes.metadata.get(attribute);
    },

    urlRoot: Galaxy.root + "api/datasets"
});

/**
 * A tabular dataset. This object extends dataset to provide incremental chunked data.
 */
var TabularDataset = Dataset.extend({
    defaults: _.extend({}, Dataset.prototype.defaults, {
        chunk_url: null,
        first_data_chunk: null,
        offset: 0,
        at_eof: false
    }),

    initialize: function initialize(options) {
        Dataset.prototype.initialize.call(this);

        // If first data chunk is available, next chunk is 1.
        if (this.attributes.first_data_chunk) {
            this.attributes.offset = this.attributes.first_data_chunk.offset;
        }
        this.attributes.chunk_url = Galaxy.root + "dataset/display?dataset_id=" + this.id;
        this.attributes.url_viz = Galaxy.root + "visualization";
    },

    /**
     * Returns a jQuery Deferred object that resolves to the next data chunk or null if at EOF.
     */
    get_next_chunk: function get_next_chunk() {
        // If already at end of file, do nothing.
        if (this.attributes.at_eof) {
            return null;
        }

        // Get next chunk.
        var self = this;

        var next_chunk = $.Deferred();
        $.getJSON(this.attributes.chunk_url, {
            offset: self.attributes.offset
        }).success(function (chunk) {
            var rval;
            if (chunk.ck_data !== "") {
                // Found chunk.
                rval = chunk;
                self.attributes.offset = chunk.offset;
            } else {
                // At EOF.
                self.attributes.at_eof = true;
                rval = null;
            }
            next_chunk.resolve(rval);
        });

        return next_chunk;
    }
});

var DatasetCollection = Backbone.Collection.extend({
    model: Dataset
});

/**
 * Provides a base for table-based, dynamic view of a tabular dataset.
 * Do not instantiate directly; use either TopLevelTabularDatasetChunkedView
 * or EmbeddedTabularDatasetChunkedView.
 */
var TabularDatasetChunkedView = Backbone.View.extend({
    /**
     * Initialize view and, importantly, set a scroll element.
     */
    initialize: function initialize(options) {
        // Row count for rendering.
        this.row_count = 0;
        this.loading_chunk = false;

        // load trackster button
        new TabularButtonTracksterView({
            model: options.model,
            $el: this.$el
        });
    },

    expand_to_container: function expand_to_container() {
        if (this.$el.height() < this.scroll_elt.height()) {
            this.attempt_to_fetch();
        }
    },

    attempt_to_fetch: function attempt_to_fetch(func) {
        var self = this;
        if (!this.loading_chunk && this.scrolled_to_bottom()) {
            this.loading_chunk = true;
            this.loading_indicator.show();
            $.when(self.model.get_next_chunk()).then(function (result) {
                if (result) {
                    self._renderChunk(result);
                    self.loading_chunk = false;
                }
                self.loading_indicator.hide();
                self.expand_to_container();
            });
        }
    },

    render: function render() {
        // Add loading indicator.
        this.loading_indicator = $("<div/>").attr("id", "loading_indicator");
        this.$el.append(this.loading_indicator);

        // Add data table and header.
        var data_table = $("<table/>").attr({
            id: "content_table",
            cellpadding: 0
        });
        this.$el.append(data_table);
        var column_names = this.model.get_metadata("column_names");
        var header_container = $("<thead/>").appendTo(data_table);
        var header_row = $("<tr/>").appendTo(header_container);
        if (column_names) {
            header_row.append("<th>" + column_names.join("</th><th>") + "</th>");
        } else {
            for (var j = 1; j <= this.model.get_metadata("columns"); j++) {
                header_row.append("<th>" + j + "</th>");
            }
        }

        // Render first chunk.
        var self = this;

        var first_chunk = this.model.get("first_data_chunk");
        if (first_chunk) {
            // First chunk is bootstrapped, so render now.
            this._renderChunk(first_chunk);
        } else {
            // No bootstrapping, so get first chunk and then render.
            $.when(self.model.get_next_chunk()).then(function (result) {
                self._renderChunk(result);
            });
        }

        // -- Show new chunks during scrolling. --

        // Set up chunk loading when scrolling using the scrolling element.
        this.scroll_elt.scroll(function () {
            self.attempt_to_fetch();
        });
    },

    /**
     * Returns true if user has scrolled to the bottom of the view.
     */
    scrolled_to_bottom: function scrolled_to_bottom() {
        return false;
    },

    // -- Helper functions. --

    _renderCell: function _renderCell(cell_contents, index, colspan) {
        var $cell = $("<td>").text(cell_contents);
        var column_types = this.model.get_metadata("column_types");
        if (colspan !== undefined) {
            $cell.attr("colspan", colspan).addClass("stringalign");
        } else if (column_types) {
            if (index < column_types.length) {
                if (column_types[index] === "str" || column_types[index] === "list") {
                    /* Left align all str columns, right align the rest */
                    $cell.addClass("stringalign");
                }
            }
        }
        return $cell;
    },

    _renderRow: function _renderRow(line) {
        // Check length of cells to ensure this is a complete row.
        var cells = line.split("\t");

        var row = $("<tr>");
        var num_columns = this.model.get_metadata("columns");

        if (this.row_count % 2 !== 0) {
            row.addClass("dark_row");
        }

        if (cells.length === num_columns) {
            _.each(cells, function (cell_contents, index) {
                row.append(this._renderCell(cell_contents, index));
            }, this);
        } else if (cells.length > num_columns) {
            // SAM file or like format with optional metadata included.
            _.each(cells.slice(0, num_columns - 1), function (cell_contents, index) {
                row.append(this._renderCell(cell_contents, index));
            }, this);
            row.append(this._renderCell(cells.slice(num_columns - 1).join("\t"), num_columns - 1));
        } else if (cells.length === 1) {
            // Comment line, just return the one cell.
            row.append(this._renderCell(line, 0, num_columns));
        } else {
            // cells.length is greater than one, but less than num_columns.  Render cells and pad tds.
            // Possibly a SAM file or like format with optional metadata missing.
            // Could also be a tabular file with a line with missing columns.
            _.each(cells, function (cell_contents, index) {
                row.append(this._renderCell(cell_contents, index));
            }, this);
            _.each(_.range(num_columns - cells.length), function () {
                row.append($("<td>"));
            });
        }

        this.row_count++;
        return row;
    },

    _renderChunk: function _renderChunk(chunk) {
        var data_table = this.$el.find("table");
        _.each(chunk.ck_data.split("\n"), function (line, index) {
            if (line !== "") {
                data_table.append(this._renderRow(line));
            }
        }, this);
    }
});

/**
 * Tabular view that is placed at the top level of page. Scrolling occurs
 * view top-level elements outside of view.
 */
var TopLevelTabularDatasetChunkedView = TabularDatasetChunkedView.extend({
    initialize: function initialize(options) {
        TabularDatasetChunkedView.prototype.initialize.call(this, options);

        // Scrolling happens in top-level elements.
        var scroll_elt = _.find(this.$el.parents(), function (p) {
            return $(p).css("overflow") === "auto";
        });

        // If no scrolling element found, use window.
        if (!scroll_elt) {
            scroll_elt = window;
        }

        // Wrap scrolling element for easy access.
        this.scroll_elt = $(scroll_elt);
    },

    /**
     * Returns true if user has scrolled to the bottom of the view.
     */
    scrolled_to_bottom: function scrolled_to_bottom() {
        return this.$el.height() - this.scroll_elt.scrollTop() - this.scroll_elt.height() <= 0;
    }
});

/**
 * Tabular view tnat is embedded in a page. Scrolling occurs in view's el.
 */
var EmbeddedTabularDatasetChunkedView = TabularDatasetChunkedView.extend({
    initialize: function initialize(options) {
        TabularDatasetChunkedView.prototype.initialize.call(this, options);

        // Because view is embedded, set up div to do scrolling.
        this.scroll_elt = this.$el.css({
            position: "relative",
            overflow: "scroll",
            height: options.height || "500px"
        });
    },

    /**
     * Returns true if user has scrolled to the bottom of the view.
     */
    scrolled_to_bottom: function scrolled_to_bottom() {
        return this.$el.scrollTop() + this.$el.innerHeight() >= this.el.scrollHeight;
    }
});

/** Button for trackster visualization */
var TabularButtonTracksterView = Backbone.View.extend({
    // gene region columns
    col: {
        chrom: null,
        start: null,
        end: null
    },

    // url for trackster
    url_viz: null,

    // dataset id
    dataset_id: null,

    // database key
    genome_build: null,

    // data type
    file_ext: null,

    // backbone initialize
    initialize: function initialize(options) {
        // check if environment is available
        var Galaxy = parent.Galaxy;

        // link galaxy modal or create one
        if (Galaxy && Galaxy.modal) {
            this.modal = Galaxy.modal;
        }

        // link galaxy frames
        if (Galaxy && Galaxy.frame) {
            this.frame = Galaxy.frame;
        }

        // check
        if (!this.modal || !this.frame) {
            return;
        }

        // model/metadata
        var model = options.model;
        var metadata = model.get("metadata");

        // check for datatype
        if (!model.get("file_ext")) {
            return;
        }

        // get data type
        this.file_ext = model.get("file_ext");

        // check for bed-file format
        if (this.file_ext == "bed") {
            // verify that metadata exists
            if (metadata.get("chromCol") && metadata.get("startCol") && metadata.get("endCol")) {
                // read in columns
                this.col.chrom = metadata.get("chromCol") - 1;
                this.col.start = metadata.get("startCol") - 1;
                this.col.end = metadata.get("endCol") - 1;
            } else {
                console.log("TabularButtonTrackster : Bed-file metadata incomplete.");
                return;
            }
        }

        // check for vcf-file format
        if (this.file_ext == "vcf") {
            // search array
            var search = function search(str, array) {
                for (var j = 0; j < array.length; j++) {
                    if (array[j].match(str)) return j;
                }return -1;
            };

            // load


            this.col.chrom = search("Chrom", metadata.get("column_names"));
            this.col.start = search("Pos", metadata.get("column_names"));
            this.col.end = null;

            // verify that metadata exists
            if (this.col.chrom == -1 || this.col.start == -1) {
                console.log("TabularButtonTrackster : VCF-file metadata incomplete.");
                return;
            }
        }

        // check
        if (this.col.chrom === undefined) {
            return;
        }

        // get dataset id
        if (model.id) {
            this.dataset_id = model.id;
        } else {
            console.log("TabularButtonTrackster : Dataset identification is missing.");
            return;
        }

        // get url
        if (model.get("url_viz")) {
            this.url_viz = model.get("url_viz");
        } else {
            console.log("TabularButtonTrackster : Url for visualization controller is missing.");
            return;
        }

        // get genome_build / database key
        if (model.get("genome_build")) {
            this.genome_build = model.get("genome_build");
        }

        // create the icon
        var btn_viz = new _iconButton2.default.IconButtonView({
            model: new _iconButton2.default.IconButton({
                title: (0, _localization2.default)("Visualize"),
                icon_class: "chart_curve",
                id: "btn_viz"
            })
        });

        // set element
        this.setElement(options.$el);

        // add to element
        this.$el.append(btn_viz.render().$el);

        // hide the button
        this.hide();
    },

    /** Add event handlers */
    events: {
        "mouseover tr": "show",
        mouseleave: "hide"
    },

    // show button
    show: function show(e) {
        var self = this;

        // is numeric
        function is_numeric(n) {
            return !isNaN(parseFloat(n)) && isFinite(n);
        }

        // check
        if (this.col.chrom === null) return;

        // get selected data line
        var row = $(e.target).parent();

        // verify that location has been found
        var chrom = row.children().eq(this.col.chrom).html();
        var start = row.children().eq(this.col.start).html();

        // end is optional
        var end = this.col.end ? row.children().eq(this.col.end).html() : start;

        // double check location
        if (!chrom.match("^#") && chrom !== "" && is_numeric(start)) {
            // get target gene region
            var btn_viz_pars = {
                dataset_id: this.dataset_id,
                gene_region: chrom + ":" + start + "-" + end
            };

            // get button position
            var offset = row.offset();
            var left = offset.left - 10;
            var top = offset.top - $(window).scrollTop() + 3;

            // update css
            $("#btn_viz").css({
                position: "fixed",
                top: top + "px",
                left: left + "px"
            });
            $("#btn_viz").off("click");
            $("#btn_viz").click(function () {
                self.frame.add({
                    title: (0, _localization2.default)("Trackster"),
                    url: self.url_viz + "/trackster?" + $.param(btn_viz_pars)
                });
            });

            // show the button
            $("#btn_viz").show();
        } else {
            // hide the button
            $("#btn_viz").hide();
        }
    },

    /** hide button */
    hide: function hide() {
        this.$("#btn_viz").hide();
    }
});

// -- Utility functions. --

/**
 * Create a model, attach it to a view, render view, and attach it to a parent element.
 */
var createModelAndView = function createModelAndView(model, view, model_config, parent_elt) {
    // Create model, view.
    var a_view = new view({
        model: new model(model_config)
    });

    // Render view and add to parent element.
    a_view.render();
    if (parent_elt) {
        parent_elt.append(a_view.$el);
    }

    return a_view;
};

/**
 * Create a tabular dataset chunked view (and requisite tabular dataset model)
 * and appends to parent_elt.
 */
var createTabularDatasetChunkedView = function createTabularDatasetChunkedView(options) {
    // If no model, create and set model from dataset config.
    if (!options.model) {
        options.model = new TabularDataset(options.dataset_config);
    }

    var parent_elt = options.parent_elt;
    var embedded = options.embedded;

    // Clean up options so that only needed options are passed to view.
    delete options.embedded;
    delete options.parent_elt;
    delete options.dataset_config;

    // Create and set up view.
    var view = embedded ? new EmbeddedTabularDatasetChunkedView(options) : new TopLevelTabularDatasetChunkedView(options);
    view.render();

    if (parent_elt) {
        parent_elt.append(view.$el);
        // If we're sticking this in another element, once it's appended check
        // to make sure we've filled enough space.
        // Without this, the scroll elements don't work.
        view.expand_to_container();
    }

    return view;
};

exports.default = {
    Dataset: Dataset,
    TabularDataset: TabularDataset,
    DatasetCollection: DatasetCollection,
    TabularDatasetChunkedView: TabularDatasetChunkedView,
    createTabularDatasetChunkedView: createTabularDatasetChunkedView
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(1), __webpack_require__(0)))

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, Backbone) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _localization = __webpack_require__(3);

var _localization2 = _interopRequireDefault(_localization);

var _underscore = __webpack_require__(1);

var _ = _interopRequireWildcard(_underscore);

var _data = __webpack_require__(15);

var _data2 = _interopRequireDefault(_data);

var _util = __webpack_require__(20);

var _util2 = _interopRequireDefault(_util);

var _config = __webpack_require__(36);

var _config2 = _interopRequireDefault(_config);

var _gridView = __webpack_require__(28);

var _gridView2 = _interopRequireDefault(_gridView);

var _uiTabs = __webpack_require__(85);

var _uiTabs2 = _interopRequireDefault(_uiTabs);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Mixin for returning custom JSON representation from toJSON. Class attribute to_json_keys defines a set of attributes
 * to include in the representation; to_json_mappers defines mappers for returned objects.
 */
var CustomToJSON = {
    /**
     * Returns JSON representation of object using to_json_keys and to_json_mappers.
     */
    toJSON: function toJSON() {
        var self = this;
        var json = {};
        _.each(self.constructor.to_json_keys, function (k) {
            var val = self.get(k);
            if (k in self.constructor.to_json_mappers) {
                val = self.constructor.to_json_mappers[k](val, self);
            }
            json[k] = val;
        });
        return json;
    }
};

/**
 * Model, view, and controller objects for Galaxy visualization framework.
 *
 * Models have no references to views, instead using events to indicate state
 * changes; this is advantageous because multiple views can use the same object
 * and models can be used without views.
 */

/**
 * Use a popup grid to select datasets from histories or libraries. After datasets are selected,
 * track definitions are obtained from the server and the success_fn is called with the list of
 * definitions for selected datasets.
 */
var select_datasets = function select_datasets(filters, success_fn) {
    // history dataset selection tab
    var history_grid = new _gridView2.default({
        url_base: Galaxy.root + "visualization/list_history_datasets",
        filters: filters,
        embedded: true
    });

    // library dataset selection tab
    var library_grid = new _gridView2.default({
        url_base: Galaxy.root + "visualization/list_library_datasets",
        embedded: true
    });

    // build tabs
    var tabs = new _uiTabs2.default.View();
    tabs.add({
        id: "histories",
        title: (0, _localization2.default)("Histories"),
        $el: $("<div/>").append(history_grid.$el)
    });
    tabs.add({
        id: "libraries",
        title: (0, _localization2.default)("Libraries"),
        $el: $("<div/>").append(library_grid.$el)
    });

    // modal
    Galaxy.modal.show({
        title: (0, _localization2.default)("Select datasets for new tracks"),
        body: tabs.$el,
        closing_events: true,
        buttons: {
            Cancel: function Cancel() {
                Galaxy.modal.hide();
            },
            Add: function Add() {
                var requests = [];
                tabs.$("input.grid-row-select-checkbox[name=id]:checked").each(function () {
                    window.console.log($(this).val());
                    requests[requests.length] = $.ajax({
                        url: Galaxy.root + "api/datasets/" + $(this).val(),
                        dataType: "json",
                        data: {
                            data_type: "track_config",
                            hda_ldda: tabs.current() == "histories" ? "hda" : "ldda"
                        }
                    });
                });
                // To preserve order, wait until there are definitions for all tracks and then add
                // them sequentially.
                $.when.apply($, requests).then(function () {
                    // jQuery always returns an Array for arguments, so need to look at first element
                    // to determine whether multiple requests were made and consequently how to
                    // map arguments to track definitions.
                    var track_defs = arguments[0] instanceof Array ? $.map(arguments, function (arg) {
                        return arg[0];
                    }) : [arguments[0]];
                    success_fn(track_defs);
                });
                Galaxy.modal.hide();
            }
        }
    });
};

// --------- Models ---------

/**
 * Canvas manager is used to create canvases for browsers as well as providing a pattern cache
 */
var CanvasManager = function CanvasManager(default_font) {
    this.default_font = default_font !== undefined ? default_font : "9px Monaco, Lucida Console, monospace";

    this.dummy_canvas = this.new_canvas();
    this.dummy_context = this.dummy_canvas.getContext("2d");
    this.dummy_context.font = this.default_font;

    this.char_width_px = this.dummy_context.measureText("A").width;

    this.patterns = {};

    // FIXME: move somewhere to make this more general
    this.load_pattern("right_strand", "/visualization/strand_right.png");
    this.load_pattern("left_strand", "/visualization/strand_left.png");
    this.load_pattern("right_strand_inv", "/visualization/strand_right_inv.png");
    this.load_pattern("left_strand_inv", "/visualization/strand_left_inv.png");
};

_.extend(CanvasManager.prototype, {
    load_pattern: function load_pattern(key, path) {
        var patterns = this.patterns;
        var dummy_context = this.dummy_context;
        var image = new Image();
        image.src = Galaxy.root + "static/images" + path;
        image.onload = function () {
            patterns[key] = dummy_context.createPattern(image, "repeat");
        };
    },
    get_pattern: function get_pattern(key) {
        return this.patterns[key];
    },
    new_canvas: function new_canvas() {
        var canvas = $("<canvas/>")[0];
        // Keep a reference back to the manager
        canvas.manager = this;
        return canvas;
    }
});

/**
 * Generic cache that handles key/value pairs. Keys can be any object that can be
 * converted to a String and compared.
 */
var Cache = Backbone.Model.extend({
    defaults: {
        num_elements: 20,
        // Objects in cache; indexes into cache are strings of keys.
        obj_cache: null,
        // key_ary contains keys for objects in cache.
        key_ary: null
    },

    initialize: function initialize(options) {
        this.clear();
    },

    /**
     * Get an element from the cache using its key.
     */
    get_elt: function get_elt(key) {
        var obj_cache = this.attributes.obj_cache;
        var key_ary = this.attributes.key_ary;
        var key_str = key.toString();

        var index = _.indexOf(key_ary, function (k) {
            return k.toString() === key_str;
        });

        // Update cache.
        if (index !== -1) {
            // Object is in cache, so update it.
            if (obj_cache[key_str].stale) {
                // Object is stale: remove key and object.
                key_ary.splice(index, 1);
                delete obj_cache[key_str];
            } else {
                // Move key to back because it is most recently used.
                this.move_key_to_end(key, index);
            }
        }

        return obj_cache[key_str];
    },

    /**
     * Put an element into the cache.
     */
    set_elt: function set_elt(key, value) {
        var obj_cache = this.attributes.obj_cache;
        var key_ary = this.attributes.key_ary;
        var key_str = key.toString();
        var num_elements = this.attributes.num_elements;

        // Update keys, objects.
        if (!obj_cache[key_str]) {
            // Add object to cache.

            if (key_ary.length >= num_elements) {
                // Cache full, so remove first element.
                var deleted_key = key_ary.shift();
                delete obj_cache[deleted_key.toString()];
            }

            // Add key.
            key_ary.push(key);
        }

        // Add object.
        obj_cache[key_str] = value;
        return value;
    },

    /**
     * Move key to end of cache. Keys are removed from the front, so moving a key to the end
     * delays the key's removal.
     */
    move_key_to_end: function move_key_to_end(key, index) {
        this.attributes.key_ary.splice(index, 1);
        this.attributes.key_ary.push(key);
    },

    /**
     * Clear all elements from the cache.
     */
    clear: function clear() {
        this.attributes.obj_cache = {};
        this.attributes.key_ary = [];
    },

    /** Returns the number of elements in the cache. */
    size: function size() {
        return this.attributes.key_ary.length;
    },

    /** Returns key most recently added to cache. */
    most_recently_added: function most_recently_added() {
        return this.size() === 0 ? null : // Most recent key is at the end of key array.
        this.attributes.key_ary[this.attributes.key_ary.length - 1];
    }
});

/**
 * Data manager for genomic data. Data is connected to and queryable by genomic regions.
 */
var GenomeDataManager = Cache.extend({
    defaults: _.extend({}, Cache.prototype.defaults, {
        dataset: null,
        genome: null,
        init_data: null,
        min_region_size: 200,
        filters_manager: null,
        data_type: "data",
        data_mode_compatible: function data_mode_compatible(entry, mode) {
            return true;
        },
        can_subset: function can_subset(entry) {
            return false;
        }
    }),

    /**
     * Initialization.
     */
    initialize: function initialize(options) {
        Cache.prototype.initialize.call(this);

        // Set initial entries in data manager.
        var initial_entries = this.get("init_data");
        if (initial_entries) {
            this.add_data(initial_entries);
        }
    },

    /**
     * Add data entries to manager; each entry should be a dict with attributes region (key), data, and data_type.
     * If necessary, manager size is increased to hold all data.
     */
    add_data: function add_data(entries) {
        // Increase size to accomodate all entries.
        if (this.get("num_elements") < entries.length) {
            this.set("num_elements", entries.length);
        }

        // Put data into manager.
        var self = this;
        _.each(entries, function (entry) {
            self.set_data(entry.region, entry);
        });
    },

    /**
     * Returns deferred that resolves to true when dataset is ready (or false if dataset
     * cannot be used).
     */
    data_is_ready: function data_is_ready() {
        var dataset = this.get("dataset");
        var ready_deferred = $.Deferred();

        var // If requesting raw data, query dataset state; if requesting (converted) data,
        // need to query converted datasets state.
        query_type = this.get("data_type") === "raw_data" ? "state" : this.get("data_type") === "data" ? "converted_datasets_state" : "error";

        var ss_deferred = new _util2.default.ServerStateDeferred({
            ajax_settings: {
                url: this.get("dataset").url(),
                data: {
                    hda_ldda: dataset.get("hda_ldda"),
                    data_type: query_type
                },
                dataType: "json"
            },
            interval: 5000,
            success_fn: function success_fn(response) {
                return response !== "pending";
            }
        });

        $.when(ss_deferred.go()).then(function (response) {
            ready_deferred.resolve(response === "ok" || response === "data");
        });
        return ready_deferred;
    },

    /**
     * Perform a feature search from server; returns Deferred object that resolves when data is available.
     */
    search_features: function search_features(query) {
        var dataset = this.get("dataset");

        var params = {
            query: query,
            hda_ldda: dataset.get("hda_ldda"),
            data_type: "features"
        };

        return $.getJSON(dataset.url(), params);
    },

    /**
     * Load data from server and manages data entries. Adds a Deferred to manager
     * for region; when data becomes available, replaces Deferred with data.
     * Returns the Deferred that resolves when data is available.
     */
    load_data: function load_data(region, mode, resolution, extra_params) {
        // Setup data request params.
        var dataset = this.get("dataset");

        var params = {
            data_type: this.get("data_type"),
            chrom: region.get("chrom"),
            low: region.get("start"),
            high: region.get("end"),
            mode: mode,
            resolution: resolution,
            hda_ldda: dataset.get("hda_ldda")
        };

        $.extend(params, extra_params);

        // Add track filters to params.
        var filters_manager = this.get("filters_manager");
        if (filters_manager) {
            var filter_names = [];
            var filters = filters_manager.filters;
            for (var i = 0; i < filters.length; i++) {
                filter_names.push(filters[i].name);
            }
            params.filter_cols = JSON.stringify(filter_names);
        }

        // Do request.
        var manager = this;

        var entry = $.getJSON(dataset.url(), params, function (result) {
            // Add region to the result.
            result.region = region;
            manager.set_data(region, result);
        });

        this.set_data(region, entry);
        return entry;
    },

    /**
     * Get data from dataset.
     */
    get_data: function get_data(region, mode, resolution, extra_params) {
        // Look for entry and return if it's a deferred or if data available is compatible with mode.
        var entry = this.get_elt(region);
        if (entry && (_util2.default.is_deferred(entry) || this.get("data_mode_compatible")(entry, mode))) {
            return entry;
        }

        //
        // Look in cache for data that can be used.
        // TODO: this logic could be improved if the visualization knew whether
        // the data was "index" or "data."
        //
        var key_ary = this.get("key_ary");

        var obj_cache = this.get("obj_cache");
        var entry_region;
        var is_subregion;
        for (var i = 0; i < key_ary.length; i++) {
            entry_region = key_ary[i];

            if (entry_region.contains(region)) {
                is_subregion = true;

                // This entry has data in the requested range. Return if data
                // is compatible and can be subsetted.
                entry = obj_cache[entry_region.toString()];
                if (_util2.default.is_deferred(entry) || this.get("data_mode_compatible")(entry, mode) && this.get("can_subset")(entry)) {
                    this.move_key_to_end(entry_region, i);

                    // If there's data, subset it.
                    if (!_util2.default.is_deferred(entry)) {
                        var subset_entry = this.subset_entry(entry, region);
                        this.set_data(region, subset_entry);
                        entry = subset_entry;
                    }

                    return entry;
                }
            }
        }

        // FIXME: There _may_ be instances where region is a subregion of another entry but cannot be
        // subsetted. For these cases, do not increase length because region will never be found (and
        // an infinite loop will occur.)
        // If needed, extend region to make it minimum size.
        if (!is_subregion && region.length() < this.attributes.min_region_size) {
            // IDEA: alternative heuristic is to find adjacent cache entry to region and use that to extend.
            // This would prevent bad extensions when zooming in/out while still preserving the behavior
            // below.

            // Use copy of region to avoid changing actual region.
            region = region.copy();

            // Use heuristic to extend region: extend relative to last data request.
            var last_request = this.most_recently_added();
            if (!last_request || region.get("start") > last_request.get("start")) {
                // This request is after the last request, so extend right.
                region.set("end", region.get("start") + this.attributes.min_region_size);
            } else {
                // This request is after the last request, so extend left.
                region.set("start", region.get("end") - this.attributes.min_region_size);
            }

            // Trim region to avoid invalid coordinates.
            region.set("genome", this.attributes.genome);
            region.trim();
        }

        return this.load_data(region, mode, resolution, extra_params);
    },

    /**
     * Alias for set_elt for readbility.
     */
    set_data: function set_data(region, entry) {
        this.set_elt(region, entry);
    },

    /** "Deep" data request; used as a parameter for DataManager.get_more_data() */
    DEEP_DATA_REQ: "deep",

    /** "Broad" data request; used as a parameter for DataManager.get_more_data() */
    BROAD_DATA_REQ: "breadth",

    /**
     * Gets more data for a region using either a depth-first or a breadth-first approach.
     */
    get_more_data: function get_more_data(region, mode, resolution, extra_params, req_type) {
        var cur_data = this._mark_stale(region);
        if (!(cur_data && this.get("data_mode_compatible")(cur_data, mode))) {
            console.log("ERROR: problem with getting more data: current data is not compatible");
            return;
        }

        //
        // Set parameters based on request type.
        //
        var query_low = region.get("start");
        if (req_type === this.DEEP_DATA_REQ) {
            // Use same interval but set start_val to skip data that's already in cur_data.
            $.extend(extra_params, {
                start_val: cur_data.data.length + 1
            });
        } else if (req_type === this.BROAD_DATA_REQ) {
            // To get past an area of extreme feature depth, set query low to be after either
            // (a) the maximum high or HACK/FIXME (b) the end of the last feature returned.
            query_low = (cur_data.max_high ? cur_data.max_high : cur_data.data[cur_data.data.length - 1][2]) + 1;
        }
        var query_region = region.copy().set("start", query_low);

        //
        // Get additional data, append to current data, and set new data. Use a custom deferred object
        // to signal when new data is available.
        //
        var data_manager = this;

        var new_data_request = this.load_data(query_region, mode, resolution, extra_params);

        var new_data_available = $.Deferred();
        // load_data sets cache to new_data_request, but use custom deferred object so that signal and data
        // is all data, not just new data.
        this.set_data(region, new_data_available);
        $.when(new_data_request).then(function (result) {
            // Update data and message.
            if (result.data) {
                result.data = cur_data.data.concat(result.data);
                if (result.max_low) {
                    result.max_low = cur_data.max_low;
                }
                if (result.message) {
                    // HACK: replace number in message with current data length. Works but is ugly.
                    result.message = result.message.replace(/[0-9]+/, result.data.length);
                }
            }
            data_manager.set_data(region, result);
            new_data_available.resolve(result);
        });
        return new_data_available;
    },

    /**
     * Returns true if more detailed data can be obtained for entry.
     */
    can_get_more_detailed_data: function can_get_more_detailed_data(region) {
        var cur_data = this.get_elt(region);

        // Can only get more detailed data for bigwig data that has less than 8000 data points.
        // Summary tree returns *way* too much data, and 8000 data points ~ 500KB.
        return cur_data.dataset_type === "bigwig" && cur_data.data.length < 8000;
    },

    /**
     * Returns more detailed data for an entry.
     */
    get_more_detailed_data: function get_more_detailed_data(region, mode, resolution, detail_multiplier, extra_params) {
        // Mark current entry as stale.
        var cur_data = this._mark_stale(region);
        if (!cur_data) {
            console.log("ERROR getting more detailed data: no current data");
            return;
        }

        if (!extra_params) {
            extra_params = {};
        }

        // Use additional parameters to get more detailed data.
        if (cur_data.dataset_type === "bigwig") {
            // FIXME: constant should go somewhere.
            extra_params.num_samples = 1000 * detail_multiplier;
        }

        return this.load_data(region, mode, resolution, extra_params);
    },

    /**
     * Marks cache data as stale.
     */
    _mark_stale: function _mark_stale(region) {
        var entry = this.get_elt(region);
        if (!entry) {
            console.log("ERROR: no data to mark as stale: ", this.get("dataset"), region.toString());
        }
        entry.stale = true;
        return entry;
    },

    /**
     * Returns an array of data with each entry representing one chromosome/contig
     * of data or, if data is not available, returns a Deferred that resolves to the
     * data when it becomes available.
     */
    get_genome_wide_data: function get_genome_wide_data(genome) {
        // -- Get all data. --

        var self = this;

        var all_data_available = true;

        var //  Map chromosome info into genome data.
        gw_data = _.map(genome.get("chroms_info").chrom_info, function (chrom_info) {
            var chrom_data = self.get_elt(new GenomeRegion({
                chrom: chrom_info.chrom,
                start: 0,
                end: chrom_info.len
            }));

            // Set flag if data is not available.
            if (!chrom_data) {
                all_data_available = false;
            }

            return chrom_data;
        });

        // -- If all data is available, return it. --
        if (all_data_available) {
            return gw_data;
        }

        // -- All data is not available, so load from server. --

        var deferred = $.Deferred();
        $.getJSON(this.get("dataset").url(), { data_type: "genome_data" }, function (genome_wide_data) {
            self.add_data(genome_wide_data.data);
            deferred.resolve(genome_wide_data.data);
        });

        return deferred;
    },

    /**
     * Returns entry with only data in the subregion.
     */
    subset_entry: function subset_entry(entry, subregion) {
        // Dictionary from entry type to function for subsetting data.
        var subset_fns = {
            bigwig: function bigwig(data, subregion) {
                return _.filter(data, function (data_point) {
                    return data_point[0] >= subregion.get("start") && data_point[0] <= subregion.get("end");
                });
            },
            refseq: function refseq(data, subregion) {
                var seq_start = subregion.get("start") - entry.region.get("start");
                return entry.data.slice(seq_start, seq_start + subregion.length());
            }
        };

        // Subset entry if there is a function for subsetting and regions are not the same.
        var subregion_data = entry.data;
        if (!entry.region.same(subregion) && entry.dataset_type in subset_fns) {
            subregion_data = subset_fns[entry.dataset_type](entry.data, subregion);
        }

        // Return entry with subregion's data.
        return {
            region: subregion,
            data: subregion_data,
            dataset_type: entry.dataset_type
        };
    }
});

var GenomeReferenceDataManager = GenomeDataManager.extend({
    initialize: function initialize(options) {
        // Use generic object in place of dataset and set urlRoot to fetch data.
        var dataset_placeholder = new Backbone.Model();
        dataset_placeholder.urlRoot = options.data_url;
        this.set("dataset", dataset_placeholder);
    },

    load_data: function load_data(region, mode, resolution, extra_params) {
        // Fetch data if region is not too large.
        return region.length() <= 100000 ? GenomeDataManager.prototype.load_data.call(this, region, mode, resolution, extra_params) : { data: null, region: region };
    }
});

/**
 * A genome build.
 */
var Genome = Backbone.Model.extend({
    defaults: {
        name: null,
        key: null,
        chroms_info: null
    },

    initialize: function initialize(options) {
        this.id = options.dbkey;
    },

    /**
     * Shorthand for getting to chromosome information.
     */
    get_chroms_info: function get_chroms_info() {
        return this.attributes.chroms_info.chrom_info;
    },

    /**
     * Returns a GenomeRegion object denoting a complete chromosome.
     */
    get_chrom_region: function get_chrom_region(chr_name) {
        // FIXME: use findWhere in underscore 1.4
        var chrom_info = _.find(this.get_chroms_info(), function (chrom_info) {
            return chrom_info.chrom === chr_name;
        });
        return new GenomeRegion({
            chrom: chrom_info.chrom,
            end: chrom_info.len
        });
    },

    /** Returns the length of a chromosome. */
    get_chrom_len: function get_chrom_len(chr_name) {
        // FIXME: use findWhere in underscore 1.4
        return _.find(this.get_chroms_info(), function (chrom_info) {
            return chrom_info.chrom === chr_name;
        }).len;
    }
});

/**
 * A genomic region.
 */
var GenomeRegion = Backbone.Model.extend({
    defaults: {
        chrom: null,
        start: 0,
        end: 0,
        str_val: null,
        genome: null
    },

    /**
     * Returns true if this region is the same as a given region.
     * It does not test the genome right now.
     */
    same: function same(region) {
        return this.attributes.chrom === region.get("chrom") && this.attributes.start === region.get("start") && this.attributes.end === region.get("end");
    },

    /**
     * If from_str specified, use it to initialize attributes.
     */
    initialize: function initialize(options) {
        if (options.from_str) {
            var pieces = options.from_str.split(":");
            var chrom = pieces[0];
            var start_end = pieces[1].split("-");
            this.set({
                chrom: chrom,
                start: parseInt(start_end[0], 10),
                end: parseInt(start_end[1], 10)
            });
        }

        // Keep a copy of region's string value for fast lookup.
        this.attributes.str_val = this.get("chrom") + ":" + this.get("start") + "-" + this.get("end");

        // Set str_val on attribute change.
        this.on("change", function () {
            this.attributes.str_val = this.get("chrom") + ":" + this.get("start") + "-" + this.get("end");
        }, this);
    },

    copy: function copy() {
        return new GenomeRegion({
            chrom: this.get("chrom"),
            start: this.get("start"),
            end: this.get("end")
        });
    },

    length: function length() {
        return this.get("end") - this.get("start");
    },

    /** Returns region in canonical form chrom:start-end */
    toString: function toString() {
        return this.attributes.str_val;
    },

    toJSON: function toJSON() {
        return {
            chrom: this.get("chrom"),
            start: this.get("start"),
            end: this.get("end")
        };
    },

    /**
     * Compute the type of overlap between this region and another region. The overlap is computed relative to the given/second region;
     * hence, OVERLAP_START indicates that the first region overlaps the start (but not the end) of the second region.
     */
    compute_overlap: function compute_overlap(a_region) {
        var first_chrom = this.get("chrom");
        var second_chrom = a_region.get("chrom");
        var first_start = this.get("start");
        var second_start = a_region.get("start");
        var first_end = this.get("end");
        var second_end = a_region.get("end");
        var overlap;

        // Compare chroms.
        if (first_chrom && second_chrom && first_chrom !== second_chrom) {
            return GenomeRegion.overlap_results.DIF_CHROMS;
        }

        // Compare regions.
        if (first_start < second_start) {
            if (first_end < second_start) {
                overlap = GenomeRegion.overlap_results.BEFORE;
            } else if (first_end < second_end) {
                overlap = GenomeRegion.overlap_results.OVERLAP_START;
            } else {
                // first_end >= second_end
                overlap = GenomeRegion.overlap_results.CONTAINS;
            }
        } else if (first_start > second_start) {
            if (first_start > second_end) {
                overlap = GenomeRegion.overlap_results.AFTER;
            } else if (first_end <= second_end) {
                overlap = GenomeRegion.overlap_results.CONTAINED_BY;
            } else {
                overlap = GenomeRegion.overlap_results.OVERLAP_END;
            }
        } else {
            // first_start === second_start
            overlap = first_end >= second_end ? GenomeRegion.overlap_results.CONTAINS : GenomeRegion.overlap_results.CONTAINED_BY;
        }

        return overlap;
    },

    /**
     * Trim a region to match genome's constraints.
     */
    trim: function trim(genome) {
        // Assume that all chromosome/contigs start at 0.
        if (this.attributes.start < 0) {
            this.attributes.start = 0;
        }

        // Only try to trim the end if genome is set.
        if (this.attributes.genome) {
            var chrom_len = this.attributes.genome.get_chrom_len(this.attributes.chrom);
            if (this.attributes.end > chrom_len) {
                this.attributes.end = chrom_len - 1;
            }
        }

        return this;
    },

    /**
     * Returns true if this region contains a given region.
     */
    contains: function contains(a_region) {
        return this.compute_overlap(a_region) === GenomeRegion.overlap_results.CONTAINS;
    },

    /**
     * Returns true if regions overlap.
     */
    overlaps: function overlaps(a_region) {
        return _.intersection([this.compute_overlap(a_region)], [GenomeRegion.overlap_results.DIF_CHROMS, GenomeRegion.overlap_results.BEFORE, GenomeRegion.overlap_results.AFTER]).length === 0;
    }
}, {
    overlap_results: {
        DIF_CHROMS: 1000,
        BEFORE: 1001,
        CONTAINS: 1002,
        OVERLAP_START: 1003,
        OVERLAP_END: 1004,
        CONTAINED_BY: 1005,
        AFTER: 1006
    }
});

var GenomeRegionCollection = Backbone.Collection.extend({
    model: GenomeRegion
});

/**
 * A genome browser bookmark.
 */
var BrowserBookmark = Backbone.Model.extend({
    defaults: {
        region: null,
        note: ""
    },

    initialize: function initialize(options) {
        this.set("region", new GenomeRegion(options.region));
    }
});

/**
 * Bookmarks collection.
 */
var BrowserBookmarkCollection = Backbone.Collection.extend({
    model: BrowserBookmark
});

/**
 * A track of data in a genome visualization.
 */
// TODO: rename to Track and merge with Trackster's Track object.
var BackboneTrack = Backbone.Model.extend(CustomToJSON).extend({
    defaults: {
        mode: "Auto"
    },

    initialize: function initialize(options) {
        this.set("dataset", new _data2.default.Dataset(options.dataset));

        // -- Set up config settings. --
        var models = [{
            key: "name",
            default_value: this.get("dataset").get("name")
        }, { key: "color" }, {
            key: "min_value",
            label: "Min Value",
            type: "float",
            default_value: 0
        }, {
            key: "max_value",
            label: "Max Value",
            type: "float",
            default_value: 1
        }];

        this.set("config", _config2.default.ConfigSettingCollection.from_models_and_saved_values(models, options.prefs));

        // -- Set up data manager. --
        var preloaded_data = this.get("preloaded_data");
        if (preloaded_data) {
            preloaded_data = preloaded_data.data;
        } else {
            preloaded_data = [];
        }
        this.set("data_manager", new GenomeDataManager({
            dataset: this.get("dataset"),
            init_data: preloaded_data
        }));
    }
}, {
    // This definition matches that produced by to_dict() methods in tracks.js
    to_json_keys: ["track_type", "dataset", "prefs", "mode", "filters", "tool_state"],
    to_json_mappers: {
        prefs: function prefs(p, self) {
            if (_.size(p) === 0) {
                p = {
                    name: self.get("config").get("name").get("value"),
                    color: self.get("config").get("color").get("value")
                };
            }
            return p;
        },
        dataset: function dataset(d) {
            return {
                id: d.id,
                hda_ldda: d.get("hda_ldda")
            };
        }
    }
});

var BackboneTrackCollection = Backbone.Collection.extend({
    model: BackboneTrack
});

/**
 * A visualization.
 */
var Visualization = Backbone.Model.extend({
    defaults: {
        title: "",
        type: ""
    },

    urlRoot: Galaxy.root + "api/visualizations",

    /**
     * POSTs visualization's JSON to its URL using the parameter 'vis_json'
     * Note: This is necessary because (a) Galaxy requires keyword args and
     * (b) Galaxy does not handle PUT now.
     */
    save: function save() {
        return $.ajax({
            url: this.url(),
            type: "POST",
            dataType: "json",
            data: {
                vis_json: JSON.stringify(this)
            }
        });
    }
});

/**
 * A visualization of genome data.
 */
var GenomeVisualization = Visualization.extend(CustomToJSON).extend({
    defaults: _.extend({}, Visualization.prototype.defaults, {
        dbkey: "",
        drawables: null,
        bookmarks: null,
        viewport: null
    }),

    initialize: function initialize(options) {
        // Replace drawables with tracks.
        this.set("drawables", new BackboneTrackCollection(options.tracks));

        var models = [];
        this.set("config", _config2.default.ConfigSettingCollection.from_models_and_saved_values(models, options.prefs));

        // Clear track and data definitions to avoid storing large objects.
        this.unset("tracks");
        this.get("drawables").each(function (d) {
            d.unset("preloaded_data");
        });
    },

    /**
     * Add a track or array of tracks to the visualization.
     */
    add_tracks: function add_tracks(tracks) {
        this.get("drawables").add(tracks);
    }
}, {
    // This definition matches that produced by to_dict() methods in tracks.js
    to_json_keys: ["view", "viewport", "bookmarks"],

    to_json_mappers: {
        view: function view(dummy, self) {
            return {
                obj_type: "View",
                prefs: {
                    name: self.get("title"),
                    content_visible: true
                },
                drawables: self.get("drawables")
            };
        }
    }
});

/**
 * -- Routers --
 */

/**
 * Router for track browser.
 */
var TrackBrowserRouter = Backbone.Router.extend({
    initialize: function initialize(options) {
        var _this = this;

        this.view = options.view;

        // Can't put regular expression in routes dictionary.
        // NOTE: parentheses are used to denote parameters returned to callback.
        this.route(/([\w]+)$/, "change_location");
        this.route(/([\w+]+:[\d,]+-[\d,]+)$/, "change_location");

        // Handle navigate events from view.
        this.view.on("navigate", function (new_loc) {
            _this.navigate(new_loc);
        });
    },

    change_location: function change_location(new_loc) {
        this.view.go_to(new_loc);
    }
});

exports.default = {
    BackboneTrack: BackboneTrack,
    BrowserBookmark: BrowserBookmark,
    BrowserBookmarkCollection: BrowserBookmarkCollection,
    Cache: Cache,
    CanvasManager: CanvasManager,
    Genome: Genome,
    GenomeDataManager: GenomeDataManager,
    GenomeRegion: GenomeRegion,
    GenomeRegionCollection: GenomeRegionCollection,
    GenomeVisualization: GenomeVisualization,
    GenomeReferenceDataManager: GenomeReferenceDataManager,
    TrackBrowserRouter: TrackBrowserRouter,
    Visualization: Visualization,
    select_datasets: select_datasets
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(2)))

/***/ }),
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Backbone, $) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * Stringifies a number adding commas for digit grouping as per North America.
 */
function commatize(number) {
    number += ""; // Convert to string
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(number)) {
        number = number.replace(rgx, "$1" + "," + "$2");
    }
    return number;
}

/**
 * Helper to determine if object is jQuery deferred.
 */
var is_deferred = function is_deferred(d) {
    return "promise" in d;
};

/**
 * Implementation of a server-state based deferred. Server is repeatedly polled, and when
 * condition is met, deferred is resolved.
 */
var ServerStateDeferred = Backbone.Model.extend({
    defaults: {
        ajax_settings: {},
        interval: 1000,
        success_fn: function success_fn(result) {
            return true;
        }
    },

    /**
     * Returns a deferred that resolves when success function returns true.
     */
    go: function go() {
        var deferred = $.Deferred();
        var self = this;
        var ajax_settings = self.get("ajax_settings");
        var success_fn = self.get("success_fn");
        var interval = self.get("interval");

        var _go = function _go() {
            $.ajax(ajax_settings).success(function (result) {
                if (success_fn(result)) {
                    // Result is good, so resolve.
                    deferred.resolve(result);
                } else {
                    // Result not good, try again.
                    setTimeout(_go, interval);
                }
            });
        };

        _go();
        return deferred;
    }
});

/**
 * Returns a random color in hexadecimal format that is sufficiently different from a single color
 * or set of colors.
 * @param colors a color or list of colors in the format '#RRGGBB'
 */
var get_random_color = function get_random_color(colors) {
    // Default for colors is white.
    if (!colors) {
        colors = "#ffffff";
    }

    // If needed, create list of colors.
    if (typeof colors === "string") {
        colors = [colors];
    }

    // Convert colors to numbers.
    for (var i = 0; i < colors.length; i++) {
        colors[i] = parseInt(colors[i].slice(1), 16);
    }

    // -- Perceived brightness and difference formulas are from
    // -- http://www.w3.org/WAI/ER/WD-AERT/#color-contrast

    // Compute perceived color brightness (based on RGB-YIQ transformation):
    var brightness = function brightness(r, g, b) {
        return (r * 299 + g * 587 + b * 114) / 1000;
    };

    // Compute color difference:
    var difference = function difference(r1, g1, b1, r2, g2, b2) {
        return Math.max(r1, r2) - Math.min(r1, r2) + (Math.max(g1, g2) - Math.min(g1, g2)) + (Math.max(b1, b2) - Math.min(b1, b2));
    };

    // Create new random color.
    var new_color;

    var nr;
    var ng;
    var nb;
    var other_color;
    var or;
    var og;
    var ob;
    var n_brightness;
    var o_brightness;
    var diff;
    var ok = false;
    var num_tries = 0;
    do {
        // New color is never white b/c random in [0,1)
        new_color = Math.round(Math.random() * 0xffffff);
        nr = (new_color & 0xff0000) >> 16;
        ng = (new_color & 0x00ff00) >> 8;
        nb = new_color & 0x0000ff;
        n_brightness = brightness(nr, ng, nb);
        ok = true;
        for (i = 0; i < colors.length; i++) {
            other_color = colors[i];
            or = (other_color & 0xff0000) >> 16;
            og = (other_color & 0x00ff00) >> 8;
            ob = other_color & 0x0000ff;
            o_brightness = brightness(or, og, ob);
            diff = difference(nr, ng, nb, or, og, ob);
            // These thresholds may need to be adjusted. Brightness difference range is 125;
            // color difference range is 500.
            if (Math.abs(n_brightness - o_brightness) < 40 || diff < 200) {
                ok = false;
                break;
            }
        }

        num_tries++;
    } while (!ok && num_tries <= 10);

    // Add 0x1000000 to left pad number with 0s.
    return "#" + (0x1000000 + new_color).toString(16).substr(1, 6);
};

exports.default = {
    commatize: commatize,
    is_deferred: is_deferred,
    ServerStateDeferred: ServerStateDeferred,
    get_random_color: get_random_color
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(0)))

/***/ }),
/* 21 */,
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

"use_strict";

var $ = _jquery2.default;

// ============================================================================
/**
 * Make an element with text editable: (a) when user clicks on text, a textbox/area
 * is provided for editing; (b) when enter key pressed, element's text is set and on_finish
 * is called.
 */
$.fn.make_text_editable = function (config_dict) {
    // Get config options.
    var num_cols = "num_cols" in config_dict ? config_dict.num_cols : 30;

    var num_rows = "num_rows" in config_dict ? config_dict.num_rows : 4;

    var use_textarea = "use_textarea" in config_dict ? config_dict.use_textarea : false;

    var on_finish = "on_finish" in config_dict ? config_dict.on_finish : null;
    var help_text = "help_text" in config_dict ? config_dict.help_text : null;

    // Add element behavior.
    var container = $(this);
    container.addClass("editable-text").click(function (e) {
        // If there's already an input element, editing is active, so do nothing.
        if ($(this).children(":input").length > 0) {
            return;
        }

        container.removeClass("editable-text");

        // Handler for setting element text.
        var set_text = function set_text(new_text) {
            container.find(":input").remove();

            if (new_text !== "") {
                container.text(new_text);
            } else {
                // No text; need a line so that there is a click target.
                container.html("<br>");
            }
            container.addClass("editable-text");

            if (on_finish) {
                on_finish(new_text);
            }
        };

        // Create input element(s) for editing.
        var cur_text = "cur_text" in config_dict ? config_dict.cur_text : container.text();

        var input_elt;
        var button_elt;

        if (use_textarea) {
            input_elt = $("<textarea/>").attr({ rows: num_rows, cols: num_cols }).text($.trim(cur_text)).keyup(function (e) {
                if (e.keyCode === 27) {
                    // Escape key.
                    set_text(cur_text);
                }
            });
            button_elt = $("<button/>").text("Done").click(function () {
                set_text(input_elt.val());
                // Return false so that click does not propogate to container.
                return false;
            });
        } else {
            input_elt = $("<input type='text'/>").attr({ value: $.trim(cur_text), size: num_cols }).blur(function () {
                set_text(cur_text);
            }).keyup(function (e) {
                if (e.keyCode === 27) {
                    // Escape key.
                    $(this).trigger("blur");
                } else if (e.keyCode === 13) {
                    // Enter key.
                    set_text($(this).val());
                }

                // Do not propogate event to avoid unwanted side effects.
                e.stopPropagation();
            });
        }

        // Replace text with input object(s) and focus & select.
        container.text("");
        container.append(input_elt);
        if (button_elt) {
            container.append(button_elt);
        }
        input_elt.focus();
        input_elt.select();

        // Do not propogate to elements below b/c that blurs input and prevents it from being used.
        e.stopPropagation();
    });

    // Add help text if there some.
    if (help_text) {
        container.attr("title", help_text).tooltip();
    }

    return container;
};

// ============================================================================

/***/ }),
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _backbone = __webpack_require__(7);

var Backbone = _interopRequireWildcard(_backbone);

var _underscore = __webpack_require__(1);

var _ = _interopRequireWildcard(_underscore);

var _utils = __webpack_require__(5);

var _utils2 = _interopRequireDefault(_utils);

var _gridModel = __webpack_require__(83);

var _gridModel2 = _interopRequireDefault(_gridModel);

var _gridTemplate = __webpack_require__(84);

var _gridTemplate2 = _interopRequireDefault(_gridTemplate);

var _popupMenu = __webpack_require__(56);

var _popupMenu2 = _interopRequireDefault(_popupMenu);

var _loadingIndicator = __webpack_require__(38);

var _loadingIndicator2 = _interopRequireDefault(_loadingIndicator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/* global $ */
// This is necessary so that, when nested arrays are used in ajax/post/get methods, square brackets ('[]') are
// not appended to the identifier of a nested array.
$.ajaxSettings.traditional = true;

// grid view
exports.default = Backbone.View.extend({
    // model
    grid: null,

    // Initialize
    initialize: function initialize(grid_config) {
        this.grid = new _gridModel2.default();
        this.title = grid_config.title;
        this.active_tab = grid_config.active_tab;
        var self = this;
        window.add_tag_to_grid_filter = function (tag_name, tag_value) {
            // Put tag name and value together.
            var tag = tag_name + (tag_value !== undefined && tag_value !== "" ? ":" + tag_value : "");
            var advanced_search = $("#advanced-search").is(":visible");
            if (!advanced_search) {
                $("#standard-search").slideToggle("fast");
                $("#advanced-search").slideToggle("fast");
            }
            self.add_filter_condition("tags", tag);
        };

        if (grid_config.url_base && !grid_config.items) {
            _loadingIndicator2.default.markViewAsLoading(this);
            var url_data = grid_config.url_data || {};
            _.each(grid_config.filters, function (v, k) {
                url_data["f-" + k] = v;
            });
            $.ajax({
                url: grid_config.url_base + "?" + $.param(url_data),
                success: function success(response) {
                    response.embedded = grid_config.embedded;
                    response.filters = grid_config.filters || {};
                    self.init_grid(response);
                }
            });
        } else {
            // set element
            this.setElement("<div>");
            this.init_grid(grid_config);
        }

        // fix padding
        if (grid_config.use_panels) {
            $("#center").css({
                padding: "10px",
                overflow: "auto"
            });
        }
    },

    // refresh frames
    handle_refresh: function handle_refresh(refresh_frames) {
        if (refresh_frames) {
            if ($.inArray("history", refresh_frames) > -1) {
                if (window.top.Galaxy && window.top.Galaxy.currHistoryPanel) {
                    window.top.Galaxy.currHistoryPanel.loadCurrentHistory();
                }
            }
        }
    },

    // Initialize
    init_grid: function init_grid(grid_config) {
        this.grid.set(grid_config);

        // get options
        var options = this.grid.attributes;

        if (this.allow_title_display && options.title) {
            _utils2.default.setWindowTitle(options.title);
        }
        // handle refresh requests
        this.handle_refresh(options.refresh_frames);

        // strip protocol and domain
        var url = this.grid.get("url_base");
        url = url.replace(/^.*\/\/[^\/]+/, "");
        this.grid.set("url_base", url);

        // append main template
        this.$el.html(_gridTemplate2.default.grid(options));

        // update div contents
        this.$el.find("#grid-table-header").html(_gridTemplate2.default.header(options));
        this.$el.find("#grid-table-body").html(_gridTemplate2.default.body(options));
        this.$el.find("#grid-table-footer").html(_gridTemplate2.default.footer(options));

        // update message
        if (options.message) {
            this.$el.find("#grid-message").html(_gridTemplate2.default.message(options));
            var self = this;
            if (options.use_hide_message) {
                window.setTimeout(function () {
                    self.$el.find("#grid-message").html("");
                }, 5000);
            }
        }

        // configure elements
        this.init_grid_elements();
        this.init_grid_controls();

        // attach global event handler
        // TODO: redundant (the onload/standard page handlers do this) - but needed because these are constructed after page ready
        if (window.init_refresh_on_change) {
            window.init_refresh_on_change();
        }
    },

    // Initialize grid controls
    init_grid_controls: function init_grid_controls() {
        // link
        var self = this;

        // Initialize grid operation button.
        this.$el.find(".operation-button").each(function () {
            $(this).off();
            $(this).click(function () {
                self.submit_operation(this);
                return false;
            });
        });

        // Initialize text filters to select text on click and use normal font when user is typing.
        this.$el.find("input[type=text]").each(function () {
            $(this).off();
            $(this).click(function () {
                $(this).select();
            }).keyup(function () {
                $(this).css("font-style", "normal");
            });
        });

        // Initialize sort links.
        this.$el.find(".sort-link").each(function () {
            $(this).off();
            $(this).click(function () {
                self.set_sort_condition($(this).attr("sort_key"));
                return false;
            });
        });

        // Initialize text filters.
        this.$el.find(".text-filter-form").each(function () {
            $(this).off();
            $(this).submit(function () {
                var column_key = $(this).attr("column_key");
                var text_input_obj = $("#input-" + column_key + "-filter");
                var text_input = text_input_obj.val();
                text_input_obj.val("");
                self.add_filter_condition(column_key, text_input);
                return false;
            });
        });

        // Initialize categorical filters.
        this.$el.find(".text-filter-val > a").each(function () {
            $(this).off();
            $(this).click(function () {
                // Remove visible element.
                $(this).parent().remove();

                // Remove filter condition.
                self.remove_filter_condition($(this).attr("filter_key"), $(this).attr("filter_val"));

                // Return
                return false;
            });
        });

        // Initialize categorical filters.
        this.$el.find(".categorical-filter > a").each(function () {
            $(this).off();
            $(this).click(function () {
                self.set_categorical_filter($(this).attr("filter_key"), $(this).attr("filter_val"));
                return false;
            });
        });

        // Initialize standard, advanced search toggles.
        this.$el.find(".advanced-search-toggle").each(function () {
            $(this).off();
            $(this).click(function () {
                self.$el.find("#standard-search").slideToggle("fast");
                self.$el.find("#advanced-search").slideToggle("fast");
                return false;
            });
        });

        // Add event to check all box
        this.$el.find("#check_all").off();
        this.$el.find("#check_all").on("click", function () {
            self.check_all_items();
        });
    },

    // Initialize grid elements.
    init_grid_elements: function init_grid_elements() {
        // Initialize grid selection checkboxes.
        this.$el.find(".grid").each(function () {
            var checkboxes = $(this).find("input.grid-row-select-checkbox");
            var check_count = $(this).find("span.grid-selected-count");
            var update_checked = function update_checked() {
                check_count.text($(checkboxes).filter(":checked").length);
            };

            $(checkboxes).each(function () {
                $(this).change(update_checked);
            });
            update_checked();
        });

        // Initialize ratings.
        if (this.$el.find(".community_rating_star").length !== 0) this.$el.find(".community_rating_star").rating({});

        // get options
        var options = this.grid.attributes;
        var self = this;

        //
        // add page click events
        //
        this.$el.find(".page-link-grid > a").each(function () {
            $(this).click(function () {
                self.set_page($(this).attr("page_num"));
                return false;
            });
        });

        //
        // add inbound/outbound events
        //
        this.$el.find(".use-target").each(function () {
            $(this).click(function () {
                self.execute({
                    href: $(this).attr("href"),
                    target: $(this).attr("target")
                });
                return false;
            });
        });

        // empty grid?
        var items_length = options.items.length;
        if (items_length === 0) {
            return;
        }

        // add operation popup menus
        _.each(options.items, function (item, index) {
            var button = self.$("#grid-" + item.encode_id + "-popup").off();
            var popup = new _popupMenu2.default(button);
            _.each(options.operations, function (operation) {
                self.add_operation(popup, operation, item);
            });
        });
    },

    /** Add an operation to the items menu */
    add_operation: function add_operation(popup, operation, item) {
        var self = this;
        var settings = item.operation_config[operation.label];
        if (settings.allowed && operation.allow_popup) {
            popup.addItem({
                html: operation.label,
                href: settings.url_args,
                target: settings.target,
                confirmation_text: operation.confirm,
                func: function func(e) {
                    e.preventDefault();
                    var label = $(e.target).html();
                    if (operation.onclick) {
                        operation.onclick(item.encode_id);
                    } else {
                        self.execute(this.findItemByHtml(label));
                    }
                }
            });
        }
    },

    // Add a condition to the grid filter; this adds the condition and refreshes the grid.
    add_filter_condition: function add_filter_condition(name, value) {
        // Do nothing is value is empty.
        if (value === "") {
            return false;
        }

        // Add condition to grid.
        this.grid.add_filter(name, value, true);

        // Add button that displays filter and provides a button to delete it.
        var t = $(_gridTemplate2.default.filter_element(name, value));
        var self = this;
        t.click(function () {
            // Remove visible element.
            $(this).remove();

            // Remove filter condition.
            self.remove_filter_condition(name, value);
        });

        // append to container
        var container = this.$el.find("#" + name + "-filtering-criteria");
        container.append(t);

        // execute
        this.go_page_one();
        this.execute();
    },

    // Remove a condition to the grid filter; this adds the condition and refreshes the grid.
    remove_filter_condition: function remove_filter_condition(name, value) {
        // Remove filter condition.
        this.grid.remove_filter(name, value);

        // Execute
        this.go_page_one();
        this.execute();
    },

    // Set sort condition for grid.
    set_sort_condition: function set_sort_condition(col_key) {
        // Set new sort condition. New sort is col_key if sorting new column; if reversing sort on
        // currently sorted column, sort is reversed.
        var cur_sort = this.grid.get("sort_key");
        var new_sort = col_key;
        if (cur_sort.indexOf(col_key) !== -1) {
            // Reverse sort.
            if (cur_sort.substring(0, 1) !== "-") {
                new_sort = "-" + col_key;
            }
        }

        // Remove sort arrows elements.
        this.$el.find(".sort-arrow").remove();

        // Add sort arrow element to new sort column.
        var sort_arrow = new_sort.substring(0, 1) == "-" ? "&uarr;" : "&darr;";
        var t = $("<span>" + sort_arrow + "</span>").addClass("sort-arrow");

        // Add to header
        this.$el.find("#" + col_key + "-header").append(t);

        // Update grid.
        this.grid.set("sort_key", new_sort);
        this.go_page_one();
        this.execute();
    },

    // Set new value for categorical filter.
    set_categorical_filter: function set_categorical_filter(name, new_value) {
        // Update filter hyperlinks to reflect new filter value.
        var category_filter = this.grid.get("categorical_filters")[name];

        var cur_value = this.grid.get("filters")[name];
        var self = this;
        this.$el.find("." + name + "-filter").each(function () {
            var text = $.trim($(this).text());
            var filter = category_filter[text];
            var filter_value = filter[name];
            if (filter_value == new_value) {
                // Remove filter link since grid will be using this filter. It is assumed that
                // this element has a single child, a hyperlink/anchor with text.
                $(this).empty();
                $(this).addClass("current-filter");
                $(this).append(text);
            } else if (filter_value == cur_value) {
                // Add hyperlink for this filter since grid will no longer be using this filter. It is assumed that
                // this element has a single child, a hyperlink/anchor.
                $(this).empty();
                var t = $("<a href=\"#\">" + text + "</a>");
                t.click(function () {
                    self.set_categorical_filter(name, filter_value);
                });
                $(this).removeClass("current-filter");
                $(this).append(t);
            }
        });

        // Update grid.
        this.grid.add_filter(name, new_value);
        this.go_page_one();
        this.execute();
    },

    // Set page to view.
    set_page: function set_page(new_page) {
        // Update page hyperlink to reflect new page.
        var self = this;
        this.$el.find(".page-link").each(function () {
            var id = $(this).attr("id");

            var // Id has form 'page-link-<page_num>
            page_num = parseInt(id.split("-")[2], 10);

            var cur_page = self.grid.get("cur_page");
            var text;
            if (page_num === new_page) {
                // Remove link to page since grid will be on this page. It is assumed that
                // this element has a single child, a hyperlink/anchor with text.
                text = $(this).children().text();
                $(this).empty();
                $(this).addClass("inactive-link");
                $(this).text(text);
            } else if (page_num === cur_page) {
                // Add hyperlink to this page since grid will no longer be on this page. It is assumed that
                // this element has a single child, a hyperlink/anchor.
                text = $(this).text();
                $(this).empty();
                $(this).removeClass("inactive-link");
                var t = $("<a href=\"#\">" + text + "</a>");
                t.click(function () {
                    self.set_page(page_num);
                });
                $(this).append(t);
            }
        });

        if (new_page === "all") {
            this.grid.set("cur_page", new_page);
        } else {
            this.grid.set("cur_page", parseInt(new_page, 10));
        }
        this.execute();
    },

    // confirmation/submission of operation request
    submit_operation: function submit_operation(operation_button, confirmation_text) {
        // identify operation
        var operation_name = $(operation_button).val();

        // verify any item is selected
        var number_of_checked_ids = this.$el.find('input[name="id"]:checked').length;
        if (number_of_checked_ids < 1) {
            return false;
        }

        // Check to see if there's grid confirmation text for this operation
        var operation = _.findWhere(this.grid.attributes.operations, {
            label: operation_name
        });
        if (operation && !confirmation_text) {
            confirmation_text = operation.confirm || "";
        }

        // collect ids
        var item_ids = [];
        this.$el.find("input[name=id]:checked").each(function () {
            item_ids.push($(this).val());
        });

        // execute operation
        var options = {
            operation: operation_name,
            id: item_ids,
            confirmation_text: confirmation_text
        };
        if (operation.target == "top" || operation.target == "center") {
            options = _.extend(options, {
                href: operation.href,
                target: operation.target
            });
        }
        this.execute(options);
        return true;
    },

    check_all_items: function check_all_items() {
        var check = this.$(".grid-row-select-checkbox");
        var state = this.$("#check_all").prop("checked");
        _.each(check, function (c) {
            $(c).prop("checked", state);
        });
        this.init_grid_elements();
    },

    // Go back to page one; this is useful when a filter is applied.
    go_page_one: function go_page_one() {
        // Need to go back to page 1 if not showing all.
        var cur_page = this.grid.get("cur_page");
        if (cur_page !== null && cur_page !== undefined && cur_page !== "all") {
            this.grid.set("cur_page", 1);
        }
    },

    //
    // execute operations and hyperlink requests
    //
    execute: function execute(options) {
        // get url
        var id = null;
        var href = null;
        var operation = null;
        var confirmation_text = null;
        var target = null;

        // check for options
        if (options) {
            // get options
            href = options.href;
            operation = options.operation;
            id = options.id;
            confirmation_text = options.confirmation_text;
            target = options.target;

            // check if input contains the operation tag
            if (href !== undefined && href.indexOf("operation=") != -1) {
                // Get operation, id in hyperlink's href.
                var href_parts = href.split("?");
                if (href_parts.length > 1) {
                    var href_parms_str = href_parts[1];
                    var href_parms = href_parms_str.split("&");
                    for (var index = 0; index < href_parms.length; index++) {
                        if (href_parms[index].indexOf("operation") != -1) {
                            // Found operation parm; get operation value.
                            operation = href_parms[index].split("=")[1];
                            operation = operation.replace(/\+/g, " ");
                        } else if (href_parms[index].indexOf("id") != -1) {
                            // Found id parm; get id value.
                            id = href_parms[index].split("=")[1];
                        }
                    }
                }
            }
        }

        // check for operation details
        if (operation && id) {
            // show confirmation box
            if (confirmation_text && confirmation_text !== "" && confirmation_text != "None" && confirmation_text != "null") if (!window.confirm(confirmation_text)) return false;

            // use small characters for operation?!
            operation = operation.toLowerCase();

            // Update grid.
            this.grid.set({
                operation: operation,
                item_ids: id
            });

            // Do operation. If operation cannot be performed asynchronously, redirect to location.
            if (target == "top") {
                window.top.location = href + "?" + $.param(this.grid.get_url_data());
            } else if (target == "center") {
                $("#galaxy_main").attr("src", href + "?" + $.param(this.grid.get_url_data()));
            } else {
                this.update_grid();
            }

            // done
            return false;
        }

        // refresh grid
        if (href) {
            this.go_to(target, href);
            return false;
        }

        // refresh grid
        this.update_grid();

        // done
        return false;
    },

    // go to url
    go_to: function go_to(target, href) {
        // get slide status
        var advanced_search = this.$el.find("#advanced-search").is(":visible");
        this.grid.set("advanced_search", advanced_search);

        // get default url
        if (!href) {
            href = this.grid.get("url_base") + "?" + $.param(this.grid.get_url_data());
        }

        // clear grid of transient request attributes.
        this.grid.set({
            operation: undefined,
            item_ids: undefined
        });
        switch (target) {
            case "center":
                $("#galaxy_main").attr("src", href);
                break;
            case "top":
                window.top.location = href;
                break;
            default:
                window.location = href;
        }
    },

    // Update grid.
    update_grid: function update_grid() {
        // If there's an operation, do POST; otherwise, do GET.
        var method = this.grid.get("operation") ? "POST" : "GET";

        // Show overlay to indicate loading and prevent user actions.
        this.$el.find(".loading-elt-overlay").show();
        var self = this;
        $.ajax({
            type: method,
            url: self.grid.get("url_base"),
            data: self.grid.get_url_data(),
            error: function error() {
                alert("Grid refresh failed");
            },
            success: function success(response_text) {
                // backup
                var embedded = self.grid.get("embedded");
                var insert = self.grid.get("insert");
                var advanced_search = self.$el.find("#advanced-search").is(":visible");

                // request new configuration
                var json = response_text;

                // update
                json.embedded = embedded;
                json.insert = insert;
                json.advanced_search = advanced_search;

                // Initialize new grid config
                self.init_grid(json);

                // Hide loading overlay.
                self.$el.find(".loading-elt-overlay").hide();
            },
            complete: function complete() {
                // Clear grid of transient request attributes.
                self.grid.set({
                    operation: undefined,
                    item_ids: undefined
                });
            }
        });
    }
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 29 */,
/* 30 */,
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(32));
__export(__webpack_require__(33));
__export(__webpack_require__(97));
//# sourceMappingURL=main.js.map

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function updateProperties(target, values, opt_keys, opt_attributes) {
    if (opt_attributes === void 0) { opt_attributes = {
        writable: true,
        enumerable: true,
        configurable: true
    }; }
    if (!(target instanceof Object))
        throw new TypeError('"target" isn\'t an Object instance');
    if (values === undefined)
        return;
    if (!(values instanceof Object))
        throw new TypeError('"properties" isn\'t an Object instance');
    if (opt_attributes === undefined) {
        opt_attributes = { writable: true, enumerable: true, configurable: true };
    }
    else if (!(opt_attributes instanceof Object)) {
        throw new TypeError('"attributes" isn\'t an Object instance');
    }
    if (opt_keys === undefined) {
        for (var key in values) {
            if (values[key] !== undefined) {
                Object.defineProperty(target, key, Object.create(opt_attributes, { value: { value: values[key] } }));
            }
        }
    }
    else if (opt_keys instanceof Array) {
        opt_keys.forEach(function (key) {
            if (values[key] !== undefined) {
                Object.defineProperty(target, key, Object.create(opt_attributes, { value: { value: values[key] } }));
            }
        });
    }
    else if (opt_keys instanceof Object) {
        for (var targetKey in opt_keys) {
            var key = opt_keys[targetKey];
            if (values[key] !== undefined)
                Object.defineProperty(target, targetKey, Object.create(opt_attributes, { value: { value: values[key] } }));
        }
    }
    else {
        throw new TypeError('"keys" isn\'t an Object instance');
    }
}
exports.updateProperties = updateProperties;
function testProperties(target, values, opt_keys, opt_skipUndefined) {
    if (opt_skipUndefined === void 0) { opt_skipUndefined = true; }
    if (!(target instanceof Object))
        throw new TypeError('"target" isn\'t an Object instance');
    if (values === undefined)
        return true;
    if (!(values instanceof Object))
        throw new TypeError('"properties" isn\'t an Object instance');
    if (opt_skipUndefined === undefined)
        opt_skipUndefined = true;
    if (opt_keys === undefined) {
        for (var key in values) {
            if (target[key] !== values[key]
                && !(values[key] === undefined && opt_skipUndefined))
                return false;
        }
    }
    else if (opt_keys instanceof Array) {
        return opt_keys.every(function (key) {
            return target[key] === values[key] || (values[key] === undefined && opt_skipUndefined);
        });
    }
    else if (opt_keys instanceof Object) {
        for (var targetKey in opt_keys) {
            var key = opt_keys[targetKey];
            if (target[targetKey] !== values[key] && !(values[key] === undefined && opt_skipUndefined))
                return false;
        }
    }
    else {
        throw new TypeError('"keys" isn\'t an Object instance');
    }
    return true;
}
exports.testProperties = testProperties;
exports.mustBeNumber = function (a, msg) {
    if (!(isNumber(a)))
        throw new TypeError(msg ? msg : "Expected number");
    return a;
};
function isNumber(x) {
    return typeof x === "number";
}
exports.isNumber = isNumber;
function isString(x) {
    return typeof x === "string";
}
exports.isString = isString;
function mustNotBeUndefined(x, msg) {
    if (!x)
        throw new Error(msg);
    return x;
}
exports.mustNotBeUndefined = mustNotBeUndefined;
function mustBeObject(o, msg) {
    if (!(o instanceof Object))
        throw new TypeError(msg ? msg : "Expected Object");
    return o;
}
exports.mustBeObject = mustBeObject;
function mustBeString(o, msg) {
    if (typeof o !== "string")
        throw new TypeError(msg ? msg : "Expected string");
    return o;
}
exports.mustBeString = mustBeString;
function mustBeArray(a, msg) {
    if (!(isArray(a)))
        throw new TypeError(msg ? msg : "Expected Array");
    return a;
}
exports.mustBeArray = mustBeArray;
function isArray(x) {
    return !!x && x.constructor === Array;
}
exports.isArray = isArray;
exports.mconcat = function (mappend) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    return args.reduceRight(mappend);
};
exports.snd = function (pair) { return pair[1]; };
function concatMap(arr, f) {
    return [].concat.apply([], arr.map(f));
}
exports.concatMap = concatMap;
//# sourceMappingURL=Utils.js.map

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Utils_1 = __webpack_require__(32);
var CategoryCode_1 = __webpack_require__(44);
function isMeasure(x) {
    return isBuiltInMeasure(x) || isCustomMeasure(x);
}
exports.isMeasure = isMeasure;
exports.measureTypes = {
    "pt": true,
    "mm": true,
    "cm": true,
    "in": true,
    "ex": true,
    "em": true,
};
function isMeasureType(x) {
    return exports.measureTypes.hasOwnProperty(x);
}
exports.isMeasureType = isMeasureType;
function isBuiltInMeasure(x) {
    return isMeasureType(x.type) && Utils_1.isNumber(x.value);
}
exports.isBuiltInMeasure = isBuiltInMeasure;
function isCustomMeasure(x) {
    return isLaTeXBlock(x.expression);
}
exports.isCustomMeasure = isCustomMeasure;
exports.mathTypes = {
    Parentheses: "Parentheses",
    Square: "Square",
    Dollar: "Dollar"
};
function isMathType(x) {
    if (x === undefined)
        return false;
    else
        switch (x) {
            case "Parentheses":
            case "Square":
            case "Dollar":
                return true;
            default:
                return false;
        }
}
exports.isMathType = isMathType;
function isNameHaving(x, name) {
    return x !== undefined && (name === undefined
        ? typeof x.name === "string"
        : name === x.name);
}
exports.isNameHaving = isNameHaving;
function isTextHaving(x) {
    return x !== undefined && typeof x.text === "string";
}
exports.isTextHaving = isTextHaving;
function isLaTeXHaving(x) {
    return x !== undefined && Utils_1.isArray(x.latex);
}
exports.isLaTeXHaving = isLaTeXHaving;
function isArgumentHaving(x) {
    return x.arguments instanceof Array;
}
exports.isArgumentHaving = isArgumentHaving;
exports.typeTeXSeq = "TeXSeq";
exports.typeTeXEnv = "TeXEnv";
exports.typeTeXBraces = "TeXBraces";
exports.typeTeXComment = "TeXComment";
exports.typeTeXRaw = "TeXRaw";
exports.typeTeXComm = "TeXComm";
exports.typeTeXCommS = "TeXCommS";
var SubOrSuperSymbol;
(function (SubOrSuperSymbol) {
    SubOrSuperSymbol[SubOrSuperSymbol["SUP"] = 0] = "SUP";
    SubOrSuperSymbol[SubOrSuperSymbol["SUB"] = 1] = "SUB";
})(SubOrSuperSymbol = exports.SubOrSuperSymbol || (exports.SubOrSuperSymbol = {}));
function isSubOrSuperSymbol(x) {
    return x === SubOrSuperSymbol.SUP || x === SubOrSuperSymbol.SUB;
}
exports.isSubOrSuperSymbol = isSubOrSuperSymbol;
exports.fromStringLaTeX = function (x) { return newTeXRaw(exports.protectString(x)); };
exports.protectString = function (s) {
    var newString = [];
    for (var i = 0; i < s.length; i++)
        newString.push(protectChar(s.charAt(i)));
    return newString.join();
};
function protectChar(c) {
    switch (c) {
        case "#":
            return "\\#";
        case "$":
            return "\\$";
        case "%":
            return "\\%";
        case "^":
            return "\\^{}";
        case "&":
            return "\\&";
        case "{":
            return "\\{";
        case "}":
            return "\\}";
        case "~":
            return "\\~{}";
        case "\\":
            return "\\textbackslash{}";
        case "_":
            return "\\_{}";
        default:
            return c;
    }
}
exports.protectChar = protectChar;
function isTypeHaving(x) {
    var anyOfTypes = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        anyOfTypes[_i - 1] = arguments[_i];
    }
    return anyOfTypes.length === 0 ? typeof x.type === "string" : anyOfTypes.some(function (type) { return x.type === type; });
}
exports.isTypeHaving = isTypeHaving;
function isLaTeXBlock(x) {
    return isLaTeXRaw(x) || isLaTeXNoRaw(x);
}
exports.isLaTeXBlock = isLaTeXBlock;
function isLaTeXNoRaw(x) {
    return isTeXEmpty(x)
        || isTeXChar(x)
        || isTeXComm(x)
        || isTeXEnv(x)
        || isTeXMath(x)
        || isTeXLineBreak(x)
        || isTeXBraces(x)
        || isTeXComment(x);
}
exports.isLaTeXNoRaw = isLaTeXNoRaw;
function isLaTeXRaw(x) {
    return isTeXEmpty(x)
        || isTeXRaw(x)
        || isTeXComm(x)
        || isTeXEnv(x)
        || isTeXMath(x)
        || isTeXLineBreak(x)
        || isTeXBraces(x)
        || isTeXComment(x);
}
exports.isLaTeXRaw = isLaTeXRaw;
function isTeXRaw(x) {
    return x !== undefined
        && x.type !== undefined
        && isTextHaving(x) && isTypeHaving(x, exports.typeTeXRaw);
}
exports.isTeXRaw = isTeXRaw;
function isTeXChar(x) {
    return x !== undefined
        && typeof x.string === "string"
        && typeof x.category === "number";
}
exports.isTeXChar = isTeXChar;
function isTeXComm(x) {
    return isNameHaving(x)
        && isArgumentHaving(x)
        && isTypeHaving(x, exports.typeTeXComm, exports.typeTeXCommS);
}
exports.isTeXComm = isTeXComm;
function isTeXCommS(x) {
    return isTeXComm(x) && x.arguments.length === 0;
}
exports.isTeXCommS = isTeXCommS;
function isTeXEnv(x, name) {
    return isTypeHaving(x, exports.typeTeXEnv);
}
exports.isTeXEnv = isTeXEnv;
function isTeXMath(x) {
    return isLaTeXHaving(x) && isTypeHaving(x) && isMathType(x.type);
}
exports.isTeXMath = isTeXMath;
function isTeXLineBreak(x) {
    return x !== undefined && typeof x.noNewPage === "boolean" && (x.measure === undefined || isMeasure(x.measure));
}
exports.isTeXLineBreak = isTeXLineBreak;
function isSubOrSuperScript(x) {
    return isSubOrSuperSymbol(x.type);
}
exports.isSubOrSuperScript = isSubOrSuperScript;
function isTeXBraces(x) {
    return isLaTeXHaving(x) && isTypeHaving(x, exports.typeTeXBraces);
}
exports.isTeXBraces = isTeXBraces;
function isFixArg(x) {
    return isTypeHaving(x, "FixArg");
}
exports.isFixArg = isFixArg;
function isOptArg(x) {
    return isTypeHaving(x, "OptArg");
}
exports.isOptArg = isOptArg;
function isTeXComment(x) {
    return isTextHaving(x) && isTypeHaving(x, exports.typeTeXComment);
}
exports.isTeXComment = isTeXComment;
function isTeXEmpty(e) {
    return e !== undefined && Object.keys(e).length === 0;
}
exports.isTeXEmpty = isTeXEmpty;
function newFixArg(l) {
    return { type: "FixArg", latex: l };
}
exports.newFixArg = newFixArg;
function newOptArg(l) {
    return l.length === 1 ? { type: "OptArg", latex: l } : { type: "MOptArg", latex: l };
}
exports.newOptArg = newOptArg;
function newSymArg(l) {
    return { type: "SymArg", latex: [l] };
}
exports.newSymArg = newSymArg;
function newParArg(l) {
    return { type: "ParArg", latex: [l] };
}
exports.newParArg = newParArg;
function newMOptArg(l) {
    return { type: "MOptArg", latex: l };
}
exports.newMOptArg = newMOptArg;
function newMSymArg(l) {
    return { type: "MSymArg", latex: l };
}
exports.newMSymArg = newMSymArg;
function newMParArg(l) {
    return { type: "MParArg", latex: l };
}
exports.newMParArg = newMParArg;
function newCommandS(name) {
    return {
        name: name,
        arguments: [],
        type: exports.typeTeXCommS
    };
}
exports.newCommandS = newCommandS;
function newTeXRaw(text) {
    return {
        text: text,
        type: exports.typeTeXRaw,
        characterCategories: CategoryCode_1.convertToTeXCharsDefault(text)
    };
}
exports.newTeXRaw = newTeXRaw;
function newTeXMath(type, startSymbol, endSymbol, latex) {
    return {
        latex: latex,
        type: type,
        startSymbol: startSymbol,
        endSymbol: endSymbol
    };
}
exports.newTeXMath = newTeXMath;
function newTeXBraces(latex) {
    return {
        latex: [latex],
        type: exports.typeTeXBraces
    };
}
exports.newTeXBraces = newTeXBraces;
exports.newTeXMathDol = function (latex) {
    return newTeXMath("Dollar", "$", "$", latex);
};
function newTeXComment(text) {
    return {
        text: text,
        type: exports.typeTeXComment
    };
}
exports.newTeXComment = newTeXComment;
function newTeXComm(name) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    return {
        name: name,
        arguments: args,
        type: exports.typeTeXComm
    };
}
exports.newTeXComm = newTeXComm;
function newSubOrSuperScript(type, symbol, args) {
    return {
        type: type,
        symbol: symbol,
        arguments: args
    };
}
exports.newSubOrSuperScript = newSubOrSuperScript;
function newTeXEnv(name, latex) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    return {
        name: name,
        latex: latex,
        arguments: args,
        type: exports.typeTeXEnv
    };
}
exports.newTeXEnv = newTeXEnv;
function stringifyLaTeX(tex) {
    var arr = [];
    (stringifyLaTeXInner(tex, arr));
    return arr.join("");
}
exports.stringifyLaTeX = stringifyLaTeX;
function stringifyLaTeXInner(tex, soFar) {
    if (isTeXComm(tex)) {
        soFar.push("\\", tex.name);
        tex.arguments.forEach(function (l) { return stringifyLaTeXInner(l, soFar); });
    }
    else if (isTeXEnv(tex))
        throw new Error("not supported yet");
    else if (isTeXMath(tex)) {
        soFar.push(tex.startSymbol);
        tex.latex.forEach(function (t) { return stringifyLaTeXInner(t, soFar); });
        soFar.push(tex.endSymbol);
    }
    else if (isTeXLineBreak(tex))
        soFar.push("\n");
    else if (isSubOrSuperScript(tex)) {
        soFar.push(tex.symbol);
        if (tex.arguments)
            tex.arguments.forEach(function (arg) { return (stringifyLaTeXInner(arg, soFar)); });
    }
    else if (isTeXBraces(tex)) {
        soFar.push("{");
        tex.latex.forEach(function (t) { return stringifyLaTeXInner(t, soFar); });
        soFar.push("}");
    }
    else if (isTeXComment(tex)) {
        soFar.push("%" + tex.text + "\n");
    }
    else if (isTeXRaw(tex))
        soFar.push(tex.text);
    else if (isTeXChar(tex))
        throw new Error("not supported yet");
    else if (isFixArg(tex)) {
        soFar.push("{");
        tex.latex.forEach(function (t) { return stringifyLaTeXInner(t, soFar); });
        soFar.push("}");
    }
    else if (isOptArg(tex)) {
        soFar.push("[");
        tex.latex.forEach(function (t) { return stringifyLaTeXInner(t, soFar); });
        soFar.push("]");
    }
    else
        throw new Error("Did not recognize " + JSON.stringify(tex));
}
//# sourceMappingURL=Syntax.js.map

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Backbone, _, $) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
//=============================================================================
/**
 * backbone model for icon buttons
 */
var IconButton = Backbone.Model.extend({
    defaults: {
        title: "",
        icon_class: "",
        on_click: null,
        menu_options: null,
        is_menu_button: true,
        id: null,
        href: null,
        target: null,
        enabled: true,
        visible: true,
        tooltip_config: {}
    }
});

/**
 *  backbone view for icon buttons
 */
var IconButtonView = Backbone.View.extend({
    initialize: function initialize() {
        // better rendering this way
        this.model.attributes.tooltip_config = { placement: "bottom" };
        this.model.bind("change", this.render, this);
    },

    render: function render() {
        // hide tooltip
        this.$el.tooltip("hide");

        var new_elem = this.template(this.model.toJSON());
        // configure tooltip
        new_elem.tooltip(this.model.get("tooltip_config"));
        this.$el.replaceWith(new_elem);
        this.setElement(new_elem);
        return this;
    },

    events: {
        click: "click"
    },

    click: function click(event) {
        // if on_click pass to that function
        if (_.isFunction(this.model.get("on_click"))) {
            this.model.get("on_click")(event);
            return false;
        }
        // otherwise, bubble up ( to href or whatever )
        return true;
    },

    // generate html element
    template: function template(options) {
        var buffer = "title=\"" + options.title + "\" class=\"icon-button";

        if (options.is_menu_button) {
            buffer += " menu-button";
        }

        buffer += " " + options.icon_class;

        if (!options.enabled) {
            buffer += "_disabled";
        }

        // close class tag
        buffer += '"';

        if (options.id) {
            buffer += " id=\"" + options.id + "\"";
        }

        buffer += " href=\"" + options.href + "\"";
        // add target for href
        if (options.target) {
            buffer += " target=\"" + options.target + "\"";
        }
        // set visibility
        if (!options.visible) {
            buffer += ' style="display: none;"';
        }

        // enabled/disabled
        if (options.enabled) {
            buffer = "<a " + buffer + "/>";
        } else {
            buffer = "<span " + buffer + "/>";
        }

        // return element
        return $(buffer);
    }
});

// define collection
var IconButtonCollection = Backbone.Collection.extend({
    model: IconButton
});

/**
 * menu with multiple icon buttons
 * views are not needed nor used for individual buttons
 */
var IconButtonMenuView = Backbone.View.extend({
    tagName: "div",

    initialize: function initialize() {
        this.render();
    },

    render: function render() {
        // initialize icon buttons
        var self = this;
        this.collection.each(function (button) {
            // create and add icon button to menu
            var elt = $("<a/>").attr("href", "javascript:void(0)").attr("title", button.attributes.title).addClass("icon-button menu-button").addClass(button.attributes.icon_class).appendTo(self.$el).click(button.attributes.on_click);

            // configure tooltip
            if (button.attributes.tooltip_config) {
                elt.tooltip(button.attributes.tooltip_config);
            }

            // add popup menu to icon
            var menu_options = button.get("options");
            if (menu_options) {
                make_popupmenu(elt, menu_options);
            }
        });

        // return
        return this;
    }
});

/**
 * Returns an IconButtonMenuView for the provided configuration.
 * Configuration is a list of dictionaries where each dictionary
 * defines an icon button. Each dictionary must have the following
 * elements: icon_class, title, and on_click.
 */
var create_icon_buttons_menu = function create_icon_buttons_menu(config, global_config) {
    // initialize global configuration
    if (!global_config) global_config = {};

    // create and initialize menu
    var buttons = new IconButtonCollection(_.map(config, function (button_config) {
        return new IconButton(_.extend(button_config, global_config));
    }));

    // return menu
    return new IconButtonMenuView({ collection: buttons });
};

//=============================================================================
exports.default = {
    IconButton: IconButton,
    IconButtonView: IconButtonView,
    IconButtonCollection: IconButtonCollection,
    IconButtonMenuView: IconButtonMenuView,
    create_icon_buttons_menu: create_icon_buttons_menu
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(1), __webpack_require__(0)))

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
// ============================================================================
function get(key, queryString) {
    queryString = queryString || window.location.search.substr(1);
    var keyRegex = new RegExp(key + "=([^&#$]+)", "g");
    var matches = queryString.match(keyRegex);
    if (!matches || !matches.length) {
        return undefined;
    }
    matches = _.map(matches, function (match) {
        return decodeURIComponent(match.substr(key.length + 1).replace(/\+/g, " "));
    });
    if (matches.length === 1) {
        return matches[0];
    }
    return matches;
}

function parse(queryString) {
    if (!queryString) {
        return {};
    }
    var parsed = {};
    var split = queryString.split("&");
    split.forEach(function (pairString) {
        var pair = pairString.split("=");
        parsed[pair[0]] = decodeURI(pair[1]);
    });
    return parsed;
}

// ============================================================================
exports.default = {
    get: get,
    parse: parse
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _underscore = __webpack_require__(1);

var _ = _interopRequireWildcard(_underscore);

var _backbone = __webpack_require__(2);

var Backbone = _interopRequireWildcard(_backbone);

var _util = __webpack_require__(20);

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/* global $ */
/* global Galaxy */

/**
 * A configuration setting. Currently key is used as id.
 */
var ConfigSetting = Backbone.Model.extend({
    initialize: function initialize(options) {
        // Use key as id for now.
        var key = this.get("key");
        this.set("id", key);

        // Set defaults based on key.
        var defaults = _.find([{
            key: "name",
            label: "Name",
            type: "text",
            default_value: ""
        }, {
            key: "color",
            label: "Color",
            type: "color",
            default_value: null
        }, {
            key: "min_value",
            label: "Min Value",
            type: "float",
            default_value: null
        }, {
            key: "max_value",
            label: "Max Value",
            type: "float",
            default_value: null
        }, {
            key: "mode",
            type: "string",
            default_value: this.mode,
            hidden: true
        }, {
            key: "height",
            type: "int",
            default_value: 32,
            hidden: true
        }, {
            key: "pos_color",
            label: "Positive Color",
            type: "color",
            default_value: "#FF8C00"
        }, {
            key: "neg_color",
            label: "Negative Color",
            type: "color",
            default_value: "#4169E1"
        }, {
            key: "block_color",
            label: "Block color",
            type: "color",
            default_value: null
        }, {
            key: "label_color",
            label: "Label color",
            type: "color",
            default_value: "black"
        }, {
            key: "show_insertions",
            label: "Show insertions",
            type: "bool",
            default_value: false
        }, {
            key: "show_counts",
            label: "Show summary counts",
            type: "bool",
            default_value: true
        }, {
            key: "reverse_strand_color",
            label: "Antisense strand color",
            type: "color",
            default_value: null
        }, {
            key: "show_differences",
            label: "Show differences only",
            type: "bool",
            default_value: true
        }], function (s) {
            return s.key === key;
        });
        if (defaults) {
            this.set(_.extend({}, defaults, options));
        }

        if (this.get("value") === undefined && this.get("default_value") !== undefined) {
            // Use default to set value (if present).
            this.set_value(this.get("default_value"));

            // If no default value for color config, set random color.
            if (!this.get("value") && this.get("type") === "color") {
                // For color setting, set random color.
                this.set("value", _util2.default.get_random_color());
            }
        }
    },

    /**
     * Cast and set value. This should be instead of
     *  setting.set('value', new_value)
     */
    set_value: function set_value(value, options) {
        var type = this.get("type");

        if (type === "float") {
            value = parseFloat(value);
        } else if (type === "int") {
            value = parseInt(value, 10);
        }
        // TODO: handle casting from string to bool?

        this.set({ value: value }, options);
    }
});

/**
 * Collection of config settings.
 */
var ConfigSettingCollection = Backbone.Collection.extend({
    model: ConfigSetting,

    /**
     * Save settings as a dictionary of key-value pairs.
     * This function is needed for backwards compatibility.
     */
    to_key_value_dict: function to_key_value_dict() {
        var rval = {};
        this.each(function (setting) {
            rval[setting.get("key")] = setting.get("value");
        });

        return rval;
    },

    /**
     * Returns value for a given key. Returns undefined if there is no setting with the specified key.
     */
    get_value: function get_value(key) {
        var s = this.get(key);
        if (s) {
            return s.get("value");
        }

        return undefined;
    },

    /**
     * Set value for a setting.
     */
    set_value: function set_value(key, value, options) {
        var s = this.get(key);
        if (s) {
            return s.set_value(value, options);
        }

        return undefined;
    },

    /**
     * Set default value for a setting.
     */
    set_default_value: function set_default_value(key, default_value) {
        var s = this.get(key);
        if (s) {
            return s.set("default_value", default_value);
        }

        return undefined;
    }
}, {
    /**
     * Utility function that creates a ConfigSettingsCollection from a set of models
     * and a saved_values dictionary.
     */
    from_models_and_saved_values: function from_models_and_saved_values(models, saved_values) {
        // If there are saved values, copy models and update with saved values.
        if (saved_values) {
            models = _.map(models, function (m) {
                return _.extend({}, m, { value: saved_values[m.key] });
            });
        }

        return new ConfigSettingCollection(models);
    }
});

/**
 * Viewer for config settings collection.
 */
var ConfigSettingCollectionView = Backbone.View.extend({
    className: "config-settings-view",

    /**
     * Renders form for editing configuration settings.
     */
    render: function render() {
        var container = this.$el;

        this.collection.each(function (param, index) {
            // Hidden params have no representation in the form
            if (param.get("hidden")) {
                return;
            }

            // Build row for param.
            var id = "param_" + index;

            var type = param.get("type");
            var value = param.get("value");
            var row = $("<div class='form-row' />").appendTo(container);
            row.append($("<label />").attr("for", id).text(param.get("label") + ":"));
            // Draw parameter as checkbox
            if (type === "bool") {
                row.append($('<input type="checkbox" />').attr("id", id).attr("name", id).attr("checked", value));
            } else if (type === "text") {
                // Draw parameter as textbox
                row.append($('<input type="text"/>').attr("id", id).val(value).click(function () {
                    $(this).select();
                }));
            } else if (type === "select") {
                // Draw parameter as select area
                var select = $("<select />").attr("id", id);
                _.each(param.get("options"), function (option) {
                    $("<option/>").text(option.label).attr("value", option.value).appendTo(select);
                });
                select.val(value);
                row.append(select);
            } else if (type === "color") {
                // Draw parameter as color picker
                var container_div = $("<div/>").appendTo(row);

                var input = $("<input />").attr("id", id).attr("name", id).val(value).css("float", "left").appendTo(container_div).click(function (e) {
                    // Hide other pickers.
                    $(".tooltip").removeClass("in");

                    // Show input's color picker.
                    var tip = $(this).siblings(".tooltip").addClass("in");
                    tip.css({
                        // left: $(this).position().left + ( $(input).width() / 2 ) - 60,
                        // top: $(this).position().top + $(this.height)
                        left: $(this).position().left + $(this).width() + 5,
                        top: $(this).position().top - $(tip).height() / 2 + $(this).height() / 2
                    }).show();

                    // Click management:

                    // Keep showing tip if clicking in tip.
                    tip.click(function (e) {
                        e.stopPropagation();
                    });

                    // Hide tip if clicking outside of tip.
                    $(document).bind("click.color-picker", function () {
                        tip.hide();
                        $(document).unbind("click.color-picker");
                    });

                    // No propagation to avoid triggering document click (and tip hiding) above.
                    e.stopPropagation();
                });
                // Icon for setting a new random color; behavior set below.
                var new_color_icon = $("<a href='javascript:void(0)'/>").addClass("icon-button arrow-circle").appendTo(container_div).attr("title", "Set new random color").tooltip();

                // Color picker in tool tip style.
                var tip = $("<div class='tooltip right' style='position: absolute;' />").appendTo(container_div).hide();

                // Inner div for padding purposes
                var tip_inner = $("<div class='tooltip-inner' style='text-align: inherit'></div>").appendTo(tip);

                $("<div class='tooltip-arrow'></div>").appendTo(tip);

                var farb_obj = $.farbtastic(tip_inner, {
                    width: 100,
                    height: 100,
                    callback: input,
                    color: value
                });

                // Clear floating.
                container_div.append($("<div/>").css("clear", "both"));

                // Use function to fix farb_obj value.
                (function (fixed_farb_obj) {
                    new_color_icon.click(function () {
                        fixed_farb_obj.setColor(_util2.default.get_random_color());
                    });
                })(farb_obj);
            } else {
                row.append($("<input />").attr("id", id).attr("name", id).val(value));
            }
            // Help text
            if (param.help) {
                row.append($("<div class='help'/>").text(param.help));
            }
        });

        return this;
    },

    /**
     * Render view in modal.
     */
    render_in_modal: function render_in_modal(title) {
        // Set up handlers for cancel, ok button and for handling esc key.
        var self = this;

        var cancel_fn = function cancel_fn() {
            Galaxy.modal.hide();
            $(window).unbind("keypress.check_enter_esc");
        };

        var ok_fn = function ok_fn() {
            Galaxy.modal.hide();
            $(window).unbind("keypress.check_enter_esc");
            self.update_from_form();
        };

        var check_enter_esc = function check_enter_esc(e) {
            if ((e.keyCode || e.which) === 27) {
                // Escape key
                cancel_fn();
            } else if ((e.keyCode || e.which) === 13) {
                // Enter key
                ok_fn();
            }
        };

        // Set keypress handler.
        $(window).bind("keypress.check_enter_esc", check_enter_esc);

        // Show modal.
        if (this.$el.children().length === 0) {
            this.render();
        }
        Galaxy.modal.show({
            title: title || "Configure",
            body: this.$el,
            buttons: {
                Cancel: cancel_fn,
                OK: ok_fn
            }
        });
    },

    /**
     * Update settings with new values entered via form.
     */
    update_from_form: function update_from_form() {
        var self = this;
        this.collection.each(function (setting, index) {
            if (!setting.get("hidden")) {
                // Set value from view.
                var id = "param_" + index;
                var value = self.$el.find("#" + id).val();
                if (setting.get("type") === "bool") {
                    value = self.$el.find("#" + id).is(":checked");
                }
                setting.set_value(value);
            }
        });
    }
});

exports.default = {
    ConfigSetting: ConfigSetting,
    ConfigSettingCollection: ConfigSettingCollection,
    ConfigSettingCollectionView: ConfigSettingCollectionView
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 37 */,
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

"use_strict";

var $ = _jquery2.default;
//TODO: too specific to history panel
function LoadingIndicator($where, options) {
    var self = this;
    // defaults
    options = _jquery2.default.extend({
        cover: false
    }, options || {});

    function render() {
        var html = ['<div class="loading-indicator">', '<div class="loading-indicator-text">', '<span class="fa fa-spinner fa-spin fa-lg"></span>', '<span class="loading-indicator-message">loading...</span>', "</div>", "</div>"].join("\n");

        var $indicator = $(html).hide().css(options.css || {
            position: "fixed"
        });

        var $text = $indicator.children(".loading-indicator-text");

        if (options.cover) {
            $indicator.css({
                "z-index": 2,
                top: $where.css("top"),
                bottom: $where.css("bottom"),
                left: $where.css("left"),
                right: $where.css("right"),
                opacity: 0.5,
                "background-color": "white",
                "text-align": "center"
            });
            $text = $indicator.children(".loading-indicator-text").css({
                "margin-top": "20px"
            });
        } else {
            $text = $indicator.children(".loading-indicator-text").css({
                margin: "12px 0px 0px 10px",
                opacity: "0.85",
                color: "grey"
            });
            $text.children(".loading-indicator-message").css({
                margin: "0px 8px 0px 0px",
                "font-style": "italic"
            });
        }
        return $indicator;
    }

    self.show = function (msg, speed, callback) {
        msg = msg || "loading...";
        speed = speed || "fast";
        // remove previous
        $where.parent().find(".loading-indicator").remove();
        // since position is fixed - we insert as sibling
        self.$indicator = render().insertBefore($where);
        self.message(msg);
        self.$indicator.fadeIn(speed, callback);
        return self;
    };

    self.message = function (msg) {
        self.$indicator.find("i").text(msg);
    };

    self.hide = function (speed, callback) {
        speed = speed || "fast";
        if (self.$indicator && self.$indicator.length) {
            self.$indicator.fadeOut(speed, function () {
                self.$indicator.remove();
                if (callback) {
                    callback();
                }
            });
        } else {
            if (callback) {
                callback();
            }
        }
        return self;
    };
    return self;
}

var markViewAsLoading = function markViewAsLoading(view) {
    view.setElement($('<div><div class="loading"></div></div>'));
    new LoadingIndicator(view.$(".loading")).show();
};

//============================================================================
exports.default = {
    LoadingIndicator: LoadingIndicator,
    markViewAsLoading: markViewAsLoading
};

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _backbone = __webpack_require__(7);

var Backbone = _interopRequireWildcard(_backbone);

var _underscore = __webpack_require__(1);

var _ = _interopRequireWildcard(_underscore);

var _utils = __webpack_require__(5);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/**
 * A plugin for initializing select2 input items.
 * Make sure the select2 library itself is loaded beforehand.
 * Also the element to which select2 will be appended has to
 * be created before select2 initialization (and passed as option).
 */
var View = Backbone.View.extend({
    // options
    optionsDefault: {
        css: "",
        placeholder: "No data available",
        data: [],
        value: null,
        multiple: false,
        minimumInputLength: 0,
        maximumTextLength: 100,
        // example format of initial data: "id:name,55:anotherrole@role.com,27:role@role.com"
        initialData: ""
    },

    // initialize
    initialize: function initialize(options) {
        // configure options
        this.options = _utils2.default.merge(options, this.optionsDefault);

        // create new element
        this.setElement(this._template(this.options));

        // check if container exists
        if (!this.options.container) {
            console.log("ui-select::initialize() : container not specified.");
            return;
        }

        // add to dom
        this.options.container.append(this.$el);

        // link selection dictionary
        this.select_data = this.options.data;

        // refresh
        this._refresh();

        if (!this.options.multiple) {
            // initial value
            if (this.options.value) {
                this._setValue(this.options.value);
            }

            // add change event
            var self = this;
            if (this.options.onchange) {
                this.$el.on("change", function () {
                    self.options.onchange(self.value());
                });
            }
        }
    },

    // value
    value: function value(new_value) {
        // get current id/value
        var before = this._getValue();

        // check if new_value is defined
        if (new_value !== undefined) {
            this._setValue(new_value);
        }

        // get current id/value
        var after = this._getValue();

        // fire onchange
        if (after != before && this.options.onchange) {
            this.options.onchange(after);
        }

        // return current value
        return after;
    },

    // label
    text: function text() {
        return this.$el.select2("data").text;
    },

    // disabled
    disabled: function disabled() {
        return !this.$el.select2("enable");
    },

    // enable
    enable: function enable() {
        this.$el.select2("enable", true);
    },

    // disable
    disable: function disable() {
        this.$el.select2("enable", false);
    },

    // add
    add: function add(options) {
        // add options
        this.select_data.push({
            id: options.id,
            text: options.text
        });

        // refresh
        this._refresh();
    },

    // remove
    del: function del(id) {
        // search option
        var index = this._getIndex(id);

        // check if found
        if (index != -1) {
            // remove options
            this.select_data.splice(index, 1);

            // refresh
            this._refresh();
        }
    },

    // remove
    remove: function remove() {
        this.$el.select2("destroy");
    },

    // update
    update: function update(options) {
        // copy options
        this.select_data = [];
        for (var key in options.data) {
            this.select_data.push(options.data[key]);
        }

        // refresh
        this._refresh();
    },

    // refresh
    _refresh: function _refresh() {
        var _this = this;

        var select_opt = void 0;
        // add select2 data based on type of input
        if (!this.options.multiple) {
            if (this.select_data) {
                this.select_data.map(function (value) {
                    var mx = _this.options.maximumTextLength + 3;
                    if (value.text && value.text.length > mx) {
                        var pos = value.text.indexOf("(" + value.id + ")");
                        pos = pos != -1 && pos < mx ? pos : mx;
                        var sub = value.text.substring(0, pos).replace(/[\ \.]*$/, "");
                        value.text = sub + "...(" + value.id + ")";
                    }
                });
            }
            var selected = this._getValue();
            select_opt = {
                data: this.select_data,
                containerCssClass: this.options.css,
                placeholder: this.options.placeholder,
                dropdownAutoWidth: true
            };
            this.$el.select2(select_opt);
            // select previous value (if exists)
            this._setValue(selected);
        } else {
            select_opt = {
                multiple: this.options.multiple,
                containerCssClass: this.options.css,
                placeholder: this.options.placeholder,
                minimumInputLength: this.options.minimumInputLength,
                ajax: this.options.ajax,
                dropdownCssClass: this.options.dropdownCssClass,
                escapeMarkup: this.options.escapeMarkup,
                formatResult: this.options.formatResult,
                formatSelection: this.options.formatSelection,
                initSelection: this.options.initSelection,
                initialData: this.options.initialData
            };
            this.$el.select2(select_opt);
        }
    },

    // get index
    _getIndex: function _getIndex(value) {
        // returns the index of the searched value
        _.findIndex(this.select_data, { id: value });
    },

    // get value
    _getValue: function _getValue() {
        return this.$el.select2("val");
    },

    // set value
    _setValue: function _setValue(new_value) {
        var index = this._getIndex(new_value);
        if (index == -1) {
            if (this.select_data.length > 0) {
                new_value = this.select_data[0].id;
            }
        }
        this.$el.select2("val", new_value);
    },

    // element
    _template: function _template(options) {
        return "<input type=\"hidden\" value=\"" + this.options.initialData + "\"/>";
    }
});

exports.default = {
    View: View
};

/***/ }),
/* 40 */,
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Citations_vue_vue_type_script_lang_js__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Citations_vue_vue_type_script_lang_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Citations_vue_vue_type_script_lang_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Citations_vue_vue_type_script_lang_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Citations_vue_vue_type_script_lang_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Citations_vue_vue_type_script_lang_js___default.a); 

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _axios = __webpack_require__(21);

var _axios2 = _interopRequireDefault(_axios);

var _bibtexParse = __webpack_require__(93);

var bibtexParse = _interopRequireWildcard(_bibtexParse);

var _latexToUnicodeConverter = __webpack_require__(94);

var _latexParser = __webpack_require__(31);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    props: {
        source: {
            type: String,
            required: true
        },
        id: {
            type: String,
            required: true
        },
        viewRender: {
            type: Boolean,
            requried: false,
            default: true
        }
    },
    data: function data() {
        return {
            citations: [],
            content: "",
            errors: []
        };
    },

    computed: {
        formattedReferences: function formattedReferences() {
            var _this = this;

            return this.citations.reduce(function (a, b) {
                return a.concat("<p class=\"formatted-reference\">" + _this.formattedReference(b) + "</p>");
            }, "");
        }
    },
    created: function created() {
        var _this2 = this;

        _axios2.default.get(Galaxy.root + "api/" + this.source + "/" + this.id + "/citations").then(function (response) {
            _this2.content = "";
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = response.data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var rawCitation = _step.value;

                    try {
                        var citation = {
                            fields: {},
                            entryType: undefined
                        };
                        var parsed = bibtexParse.toJSON(rawCitation.content);
                        if (parsed) {
                            parsed = _.first(parsed);
                            citation.entryType = parsed.entryType || undefined;
                            for (var key in parsed.entryTags) {
                                citation.fields[key.toLowerCase()] = parsed.entryTags[key];
                            }
                        }
                        _this2.citations.push(citation);
                        _this2.content += rawCitation.content;
                    } catch (err) {
                        console.warn("Error parsing bibtex: " + err);
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }).catch(function (e) {
            console.error(e);
        });
    },
    methods: {
        formattedReference: function formattedReference(citation) {
            var entryType = citation.entryType;
            var fields = citation.fields;

            var ref = "";
            var authorsAndYear = this._asSentence((fields.author ? fields.author : "") + (fields.year ? " (" + fields.year + ")" : "")) + " ";
            var title = fields.title || "";
            var pages = fields.pages ? "pp. " + fields.pages : "";
            var address = fields.address;
            if (entryType == "article") {
                var volume = (fields.volume ? fields.volume : "") + (fields.number ? " (" + fields.number + ")" : "") + (pages ? ", " + pages : "");
                ref = authorsAndYear + this._asSentence(title) + (fields.journal ? "In <em>" + fields.journal + ", " : "") + this._asSentence(volume) + this._asSentence(fields.address) + "</em>";
            } else if (entryType == "inproceedings" || entryType == "proceedings") {
                ref = authorsAndYear + this._asSentence(title) + (fields.booktitle ? "In <em>" + fields.booktitle + ", " : "") + (pages ? pages : "") + (address ? ", " + address : "") + ".</em>";
            } else if (entryType == "mastersthesis" || entryType == "phdthesis") {
                ref = authorsAndYear + this._asSentence(title) + (fields.howpublished ? fields.howpublished + ". " : "") + (fields.note ? fields.note + "." : "");
            } else if (entryType == "techreport") {
                ref = authorsAndYear + this._asSentence(title) + this._asSentence(fields.institution) + this._asSentence(fields.number) + this._asSentence(fields.type);
            } else if (entryType == "book" || entryType == "inbook" || entryType == "incollection") {
                ref = authorsAndYear + " " + this._formatBookInfo(fields);
            } else {
                ref = authorsAndYear + " " + this._asSentence(title) + this._asSentence(fields.howpublished) + this._asSentence(fields.note);
            }
            var doiUrl = "";
            if (fields.doi) {
                doiUrl = "https://doi.org/" + fields.doi;
                ref += "[<a href=\"" + doiUrl + "\" target=\"_blank\">doi:" + fields.doi + "</a>]";
            }
            var url = fields.url || doiUrl;
            if (url) {
                ref += "[<a href=\"" + url + "\" target=\"_blank\">Link</a>]";
            }
            return (0, _latexToUnicodeConverter.convertLaTeX)({ onError: function onError(error, latex) {
                    return "{" + (0, _latexParser.stringifyLaTeX)(latex) + "}";
                } }, ref);
        },
        _formatBookInfo: function _formatBookInfo(fields) {
            var info = "";
            if (fields.chapter) {
                info += fields.chapter + " in ";
            }
            if (fields.title) {
                info += "<em>" + fields.title + "</em>";
            }
            if (fields.editor) {
                info += ", Edited by " + fields.editor + ", ";
            }
            if (fields.publisher) {
                info += ", " + fields.publisher;
            }
            if (fields.pages) {
                info += ", pp. " + fields.pages;
            }
            if (fields.series) {
                info += ", <em>" + fields.series + "</em>";
            }
            if (fields.volume) {
                info += ", Vol." + fields.volume;
            }
            if (fields.issn) {
                info += ", ISBN: " + fields.issn;
            }
            return info + ".";
        },
        _asSentence: function _asSentence(str) {
            return str && str.trim() ? str + ". " : "";
        },
        toggleViewRender: function toggleViewRender() {
            this.viewRender = !this.viewRender;
        }
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.supportedMarkups = {
    "ascii": true,
    "unicode": true,
    "html": true
};
//# sourceMappingURL=options.js.map

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultCategories = function (char) {
    switch (char) {
        case "\\":
            return 0;
        case "{":
            return 1;
        case "}":
            return 2;
        case "$":
            return 3;
        case "&":
            return 4;
        case "\r":
            return 5;
        case "#":
            return 6;
        case "^":
            return 7;
        case "_":
            return 8;
        case "\0":
            return 9;
        case " ":
            return 10;
        case "~":
            return 13;
        case "%":
            return 14;
        case "\d":
            return 15;
        default:
            return 11;
    }
};
function convertToTeXCharsDefault(str) {
    return convertToTeXChars(exports.defaultCategories, str);
}
exports.convertToTeXCharsDefault = convertToTeXCharsDefault;
function convertToTeXChars(categoryMap, str) {
    var chars = [];
    for (var i = 0; i < str.length; i++) {
        var charAt = str.charAt(i);
        chars.push({
            string: charAt,
            category: categoryMap(charAt)
        });
    }
    return chars;
}
exports.convertToTeXChars = convertToTeXChars;
//# sourceMappingURL=CategoryCode.js.map

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

!function(n,t){ true?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.Parsimmon=t():n.Parsimmon=t()}(this,function(){return function(n){function t(e){if(r[e])return r[e].exports;var u=r[e]={i:e,l:!1,exports:{}};return n[e].call(u.exports,u,u.exports,t),u.l=!0,u.exports}var r={};return t.m=n,t.c=r,t.i=function(n){return n},t.d=function(n,r,e){t.o(n,r)||Object.defineProperty(n,r,{configurable:!1,enumerable:!0,get:e})},t.n=function(n){var r=n&&n.__esModule?function(){return n.default}:function(){return n};return t.d(r,"a",r),r},t.o=function(n,t){return Object.prototype.hasOwnProperty.call(n,t)},t.p="",t(t.s=0)}([function(n,t,r){"use strict";function e(n){if(!(this instanceof e))return new e(n);this._=n}function u(n){return n instanceof e}function i(n){return"[object Array]"==={}.toString.call(n)}function o(n,t){return{status:!0,index:n,value:t,furthest:-1,expected:[]}}function a(n,t){return{status:!1,index:-1,value:null,furthest:n,expected:[t]}}function f(n,t){if(!t)return n;if(n.furthest>t.furthest)return n;var r=n.furthest===t.furthest?s(n.expected,t.expected):t.expected;return{status:n.status,index:n.index,value:n.value,furthest:t.furthest,expected:r}}function c(n,t){var r=n.slice(0,t).split("\n");return{offset:t,line:r.length,column:r[r.length-1].length+1}}function s(n,t){var r=n.length,e=t.length;if(0===r)return t;if(0===e)return n;for(var u={},i=0;i<r;i++)u[n[i]]=!0;for(var o=0;o<e;o++)u[t[o]]=!0;var a=[];for(var f in u)u.hasOwnProperty(f)&&a.push(f);return a.sort(),a}function l(n){if(!u(n))throw new Error("not a parser: "+n)}function h(n){if(!i(n))throw new Error("not an array: "+n)}function p(n){if("number"!=typeof n)throw new Error("not a number: "+n)}function d(n){if(!(n instanceof RegExp))throw new Error("not a regexp: "+n);for(var t=w(n),r=0;r<t.length;r++){var e=t.charAt(r);if("i"!==e&&"m"!==e&&"u"!==e)throw new Error('unsupported regexp flag "'+e+'": '+n)}}function v(n){if("function"!=typeof n)throw new Error("not a function: "+n)}function g(n){if("string"!=typeof n)throw new Error("not a string: "+n)}function m(n){return 1===n.length?n[0]:"one of "+n.join(", ")}function y(n,t){var r=t.index,e=r.offset;if(e===n.length)return", got the end of the input";var u=e>0?"'...":"'",i=n.length-e>12?"...'":"'";return" at line "+r.line+" column "+r.column+", got "+u+n.slice(e,e+12)+i}function x(n,t){return"expected "+m(t.expected)+y(n,t)}function w(n){var t=""+n;return t.slice(t.lastIndexOf("/")+1)}function E(n){return RegExp("^(?:"+n.source+")",w(n))}function _(){for(var n=[].slice.call(arguments),t=n.length,r=0;r<t;r+=1)l(n[r]);return e(function(r,e){for(var u,i=new Array(t),a=0;a<t;a+=1){if(u=f(n[a]._(r,e),u),!u.status)return u;i[a]=u.value,e=u.index}return f(o(e,i),u)})}function b(){for(var n={},t=0,r=[].slice.call(arguments),a=r.length,c=0;c<a;c+=1){var s=r[c];if(!u(s)){if(i(s)){if(2===s.length&&"string"==typeof s[0]&&u(s[1])){var l=s[0];if(n[l])throw new Error("seqObj: duplicate key "+l);n[l]=!0,t++;continue}}throw new Error("seqObj arguments must be parsers or [string, parser] array pairs.")}}if(0===t)throw new Error("seqObj expects at least one named parser, found zero");return e(function(n,t){for(var e,u={},c=0;c<a;c+=1){var s,l;if(i(r[c])?(s=r[c][0],l=r[c][1]):(s=null,l=r[c]),e=f(l._(n,t),e),!e.status)return e;s&&(u[s]=e.value),t=e.index}return f(o(t,u),e)})}function O(){var n=[].slice.call(arguments);if(0===n.length)throw new Error("seqMap needs at least one argument");var t=n.pop();return v(t),_.apply(null,n).map(function(n){return t.apply(null,n)})}function k(n){var t={};for(var r in n)({}).hasOwnProperty.call(n,r)&&function(r){var e=function(){return n[r](t)};t[r]=G(e)}(r);return t}function j(){var n=[].slice.call(arguments),t=n.length;if(0===t)return F("zero alternates");for(var r=0;r<t;r+=1)l(n[r]);return e(function(t,r){for(var e,u=0;u<n.length;u+=1)if(e=f(n[u]._(t,r),e),e.status)return e;return e})}function P(n,t){return q(n,t).or(z([]))}function q(n,t){l(n),l(t);var r=t.then(n).many();return n.chain(function(n){return r.map(function(t){return[n].concat(t)})})}function A(n){g(n);var t="'"+n+"'";return e(function(r,e){var u=e+n.length,i=r.slice(e,u);return i===n?o(u,i):a(e,t)})}function B(n,t){d(n),arguments.length>=2?p(t):t=0;var r=E(n),u=""+n;return e(function(n,e){var i=r.exec(n.slice(e));if(i){if(0<=t&&t<=i.length){var f=i[0],c=i[t];return o(e+f.length,c)}return a(e,"valid match group (0 to "+i.length+") in "+u)}return a(e,u)})}function z(n){return e(function(t,r){return o(r,n)})}function F(n){return e(function(t,r){return a(r,n)})}function M(n){if(u(n))return e(function(t,r){var e=n._(t,r);return e.index=r,e.value="",e});if("string"==typeof n)return M(A(n));if(n instanceof RegExp)return M(B(n));throw new Error("not a string, regexp, or parser: "+n)}function R(n){return l(n),e(function(t,r){var e=n._(t,r),u=t.slice(r,e.index);return e.status?a(r,'not "'+u+'"'):o(r,null)})}function L(n){return v(n),e(function(t,r){var e=t.charAt(r);return r<t.length&&n(e)?o(r+1,e):a(r,"a character matching "+n)})}function S(n){return L(function(t){return n.indexOf(t)>=0})}function W(n){return L(function(t){return n.indexOf(t)<0})}function I(n){return e(n(o,a))}function C(n,t){return L(function(r){return n<=r&&r<=t}).desc(n+"-"+t)}function D(n){return v(n),e(function(t,r){for(var e=r;e<t.length&&n(t.charAt(e));)e++;return o(e,t.slice(r,e))})}function G(n,t){arguments.length<2&&(t=n,n=void 0);var r=e(function(n,e){return r._=t()._,r._(n,e)});return n?r.desc(n):r}function H(){return F("fantasy-land/empty")}var J=e.prototype;J.parse=function(n){if("string"!=typeof n)throw new Error(".parse must be called with a string as its argument");var t=this.skip(T)._(n,0);return t.status?{status:!0,value:t.value}:{status:!1,index:c(n,t.furthest),expected:t.expected}},J.tryParse=function(n){var t=this.parse(n);if(t.status)return t.value;var r=x(n,t),e=new Error(r);throw e.type="ParsimmonError",e.result=t,e},J.or=function(n){return j(this,n)},J.trim=function(n){return this.wrap(n,n)},J.wrap=function(n,t){return O(n,this,t,function(n,t){return t})},J.thru=function(n){return n(this)},J.then=function(n){return l(n),_(this,n).map(function(n){return n[1]})},J.many=function(){var n=this;return e(function(t,r){for(var e=[],u=void 0;;){if(u=f(n._(t,r),u),!u.status)return f(o(r,e),u);r=u.index,e.push(u.value)}})},J.tie=function(){return this.map(function(n){h(n);for(var t="",r=0;r<n.length;r++)g(n[r]),t+=n[r];return t})},J.times=function(n,t){var r=this;return arguments.length<2&&(t=n),p(n),p(t),e(function(e,u){for(var i=[],a=void 0,c=void 0,s=0;s<n;s+=1){if(a=r._(e,u),c=f(a,c),!a.status)return c;u=a.index,i.push(a.value)}for(;s<t&&(a=r._(e,u),c=f(a,c),a.status);s+=1)u=a.index,i.push(a.value);return f(o(u,i),c)})},J.result=function(n){return this.map(function(){return n})},J.atMost=function(n){return this.times(0,n)},J.atLeast=function(n){return O(this.times(n),this.many(),function(n,t){return n.concat(t)})},J.map=function(n){v(n);var t=this;return e(function(r,e){var u=t._(r,e);return u.status?f(o(u.index,n(u.value)),u):u})},J.skip=function(n){return _(this,n).map(function(n){return n[0]})},J.mark=function(){return O(K,this,K,function(n,t,r){return{start:n,value:t,end:r}})},J.node=function(n){return O(K,this,K,function(t,r,e){return{name:n,value:r,start:t,end:e}})},J.sepBy=function(n){return P(this,n)},J.sepBy1=function(n){return q(this,n)},J.lookahead=function(n){return this.skip(M(n))},J.notFollowedBy=function(n){return this.skip(R(n))},J.desc=function(n){var t=this;return e(function(r,e){var u=t._(r,e);return u.status||(u.expected=[n]),u})},J.fallback=function(n){return this.or(z(n))},J.ap=function(n){return O(n,this,function(n,t){return n(t)})},J.chain=function(n){var t=this;return e(function(r,e){var u=t._(r,e);return u.status?f(n(u.value)._(r,u.index),u):u})},J.concat=J.or,J.empty=H,J.of=z,J["fantasy-land/ap"]=J.ap,J["fantasy-land/chain"]=J.chain,J["fantasy-land/concat"]=J.concat,J["fantasy-land/empty"]=J.empty,J["fantasy-land/of"]=J.of,J["fantasy-land/map"]=J.map;var K=e(function(n,t){return o(t,c(n,t))}),N=e(function(n,t){return t>=n.length?a(t,"any character"):o(t+1,n.charAt(t))}),Q=e(function(n,t){return o(n.length,n.slice(t))}),T=e(function(n,t){return t<n.length?a(t,"EOF"):o(t,null)}),U=B(/[0-9]/).desc("a digit"),V=B(/[0-9]*/).desc("optional digits"),X=B(/[a-z]/i).desc("a letter"),Y=B(/[a-z]*/i).desc("optional letters"),Z=B(/\s*/).desc("optional whitespace"),$=B(/\s+/).desc("whitespace");e.all=Q,e.alt=j,e.any=N,e.createLanguage=k,e.custom=I,e.digit=U,e.digits=V,e.empty=H,e.eof=T,e.fail=F,e.formatError=x,e.index=K,e.isParser=u,e.lazy=G,e.letter=X,e.letters=Y,e.lookahead=M,e.makeFailure=a,e.makeSuccess=o,e.noneOf=W,e.notFollowedBy=R,e.of=z,e.oneOf=S,e.optWhitespace=Z,e.Parser=e,e.range=C,e.regex=B,e.regexp=B,e.sepBy=P,e.sepBy1=q,e.seq=_,e.seqMap=O,e.seqObj=b,e.string=A,e.succeed=z,e.takeWhile=D,e.test=L,e.whitespace=$,e["fantasy-land/empty"]=H,e["fantasy-land/of"]=z,n.exports=e}])});

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function unknownCommandError(cmd) {
    return new Error("I do not know command " + cmd);
}
exports.unknownCommandError = unknownCommandError;
//# sourceMappingURL=unknown-command.js.map

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function createCommandHandler(name, optionalArguments, argumentCount, apply) {
    return { name: name, optionalArguments: optionalArguments, argumentCount: argumentCount, apply: apply };
}
exports.createCommandHandler = createCommandHandler;
function createKnownCommandWithOptArgs(name, optionalArguments, argumentCount) {
    return { name: name, optionalArguments: optionalArguments, argumentCount: argumentCount };
}
exports.createKnownCommandWithOptArgs = createKnownCommandWithOptArgs;
function createKnownCommandWithArgs(name, argumentCount) {
    return {
        name: name,
        optionalArguments: 0,
        argumentCount: argumentCount
    };
}
exports.createKnownCommandWithArgs = createKnownCommandWithArgs;
//# sourceMappingURL=KnownCommand.js.map

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.formattingText = {
    textbb: true,
    textbf: true,
    textfrak: true,
    textit: true,
    texttt: true,
    textcal: true,
    textsup: true,
    textsub: true,
    textsuperscript: true,
    textsubscript: true,
};
exports.formattingNoMode = {
    bb: true,
    bf: true,
    frak: true,
    it: true,
    tt: true,
    cal: true,
    mono: true,
    sup: true,
    sub: true,
    superscript: true,
    subscript: true,
};
exports.formattingMath = {
    mathbb: true,
    mathbf: true,
    mathfrak: true,
    mathit: true,
    mathtt: true,
    mathcal: true,
    mathsup: true,
    mathsub: true,
    mathsuperscript: true,
    mathsubscript: true,
};
function isBbCmd(x) {
    return x === "bb" || x === "mathbb" || x === "textbb";
}
exports.isBbCmd = isBbCmd;
function isBfCmd(x) {
    return x === "bf" || x === "mathbf" || x === "textbf";
}
exports.isBfCmd = isBfCmd;
function isMonoCmd(x) {
    return x === "mono";
}
exports.isMonoCmd = isMonoCmd;
function isFrakCmd(x) {
    return x === "frak" || x === "mathfrak" || x === "textfrak";
}
exports.isFrakCmd = isFrakCmd;
function isItCmd(x) {
    return x === "it" || x === "mathit" || x === "textit";
}
exports.isItCmd = isItCmd;
function isTtCmd(x) {
    return x === "tt" || x === "mathtt" || x === "texttt";
}
exports.isTtCmd = isTtCmd;
function isCalCmd(x) {
    return x === "cal" || x === "mathcal" || x === "textcal";
}
exports.isCalCmd = isCalCmd;
function isSupCmd(x) {
    return x === "sup"
        || x === "mathsup"
        || x === "textsup"
        || x === "superscript"
        || x === "mathsuperscript"
        || x === "textsuperscript";
}
exports.isSupCmd = isSupCmd;
function isSubCmd(x) {
    return x === "sub"
        || x === "mathsub"
        || x === "textsub"
        || x === "subscript"
        || x === "mathsubscript"
        || x === "textsubscript";
}
exports.isSubCmd = isSubCmd;
function isFormattingCmd(x) {
    return exports.formattingText.hasOwnProperty(x) ||
        exports.formattingMath.hasOwnProperty(x) ||
        exports.formattingNoMode.hasOwnProperty(x);
}
exports.isFormattingCmd = isFormattingCmd;
//# sourceMappingURL=formatting.js.map

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.superscriptCharacters = {
    "0": "⁰",
    "1": "¹",
    "2": "²",
    "3": "³",
    "4": "⁴",
    "5": "⁵",
    "6": "⁶",
    "7": "⁷",
    "8": "⁸",
    "9": "⁹",
    "+": "⁺",
    "-": "⁻",
    "=": "⁼",
    "(": "⁽",
    ")": "⁾",
    "a": "ᵃ",
    "b": "ᵇ",
    "c": "ᶜ",
    "d": "ᵈ",
    "e": "ᵉ",
    "f": "ᶠ",
    "g": "ᵍ",
    "h": "ʰ",
    "i": "ⁱ",
    "j": "ʲ",
    "k": "ᵏ",
    "l": "ˡ",
    "m": "ᵐ",
    "n": "ⁿ",
    "o": "ᵒ",
    "p": "ᵖ",
    "r": "ʳ",
    "s": "ˢ",
    "t": "ᵗ",
    "u": "ᵘ",
    "v": "ᵛ",
    "w": "ʷ",
    "x": "ˣ",
    "y": "ʸ",
    "z": "ᶻ",
    "A": "ᴬ",
    "B": "ᴮ",
    "D": "ᴰ",
    "E": "ᴱ",
    "G": "ᴳ",
    "H": "ᴴ",
    "I": "ᴵ",
    "J": "ᴶ",
    "K": "ᴷ",
    "L": "ᴸ",
    "M": "ᴹ",
    "N": "ᴺ",
    "O": "ᴼ",
    "P": "ᴾ",
    "R": "ᴿ",
    "T": "ᵀ",
    "U": "ᵁ",
    "V": "ⱽ",
    "W": "ᵂ",
    "α": "ᵅ",
    "β": "ᵝ",
    "γ": "ᵞ",
    "δ": "ᵟ",
    "∊": "ᵋ",
    "θ": "ᶿ",
    "ι": "ᶥ",
    "Φ": "ᶲ",
    "φ": "ᵠ",
    "χ": "ᵡ"
};
function isSuperscriptCharacter(x) {
    return exports.superscriptCharacters.hasOwnProperty(x);
}
exports.isSuperscriptCharacter = isSuperscriptCharacter;
exports.translateCharToSuperscript = function (char) { return isSuperscriptCharacter(char) ? exports.superscriptCharacters[char] : undefined; };
//# sourceMappingURL=superscript.js.map

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.runesMap = {
    "ra": {
        "\\ae": "ᚨ",
        "\\c": {
            unicode: "ᚳ",
            note: "approximation",
        },
        "\\d": {
            unicode: "ᛞ",
            note: "approximation",
        },
        "\\ea": "ᛠ",
        "\\G": "ᚸ",
        "\\g": {
            unicode: "ᚸ",
            note: "approximation",
        },
        "\\h": "ᚬ",
        "\\j": "ᛄ",
        "\\k": "ᛤ",
        "\\ng": "ᛝ",
        "\\OE": {
            unicode: "ᛟ",
            note: "approximation",
        },
        "\\oe": "ᛟ",
        "\\rex": {
            unicode: "𐎟",
            note: "approximation",
        },
        "\\seight": {
            unicode: "⦚",
            note: "approximation",
        },
        "\\sfive": {
            unicode: "⦚",
            note: "approximation",
        },
        "\\sfour": {
            unicode: "⦚",
            note: "approximation",
        },
        "\\sseven": {
            unicode: "⦚",
            note: "approximation",
        },
        "\\ssix": {
            unicode: "⦚",
            note: "approximation",
        },
        "\\stan": {
            unicode: "ᛥ",
            note: "approximation",
        },
        "\\STAN": "ᛥ",
        "\\sthree": "ᛊ",
        "\\th": "ᚦ",
        "\\y": {
            unicode: "ᚤ",
            note: "approximation",
        },
        "a": "ᚪ",
        "B": {
            unicode: "ᛒ",
            note: "approximation",
        },
        "b": "ᛒ",
        "c": "ᚳ",
        "D": {
            unicode: "ᛞ",
            note: "approximation",
        },
        "d": "ᛞ",
        "e": "ᛖ",
        "F": {
            unicode: "ᚠ",
            note: "approximation",
        },
        "f": "ᚠ",
        "g": "ᚷ",
        "H": {
            unicode: "ᚺ",
            note: "approximation",
        },
        "h": "ᚻ",
        "i": "ᛁ",
        "I": {
            unicode: "ᛇ",
            "latex2": "\\\"i"
        },
        "\\\"i": "ᛇ",
        "J": {
            unicode: "+",
            note: "approximation",
        },
        "j": "ᚼ",
        "k": "ᚲ",
        "l": "ᛚ",
        "m": "ᛗ",
        "n": "ᚾ",
        "o": "ᚩ",
        "P": {
            unicode: "⥏",
            note: "approximation",
        },
        "p": "ᛈ",
        "q": "ᛢ",
        "r": "ᚱ",
        "S": {
            unicode: "⦚",
            note: "approximation",
        },
        "s": "ᛋ",
        "t": "ᛏ",
        "U": {
            unicode: "Λ",
            note: "approximation",
        },
        "u": "ᚢ",
        "w": "ᚹ",
        "x": "ᛉ",
        "Y": {
            unicode: "ᚥ",
            note: "approximation",
        },
        "y": {
            unicode: "ᚣ",
            note: "approximation",
        }
    },
    "rc": {
        "\\A": "ᚼ",
        "\\a": {
            unicode: "┝",
            note: "approximation",
        },
        "\\d": {
            unicode: "⋈",
            note: "approximation",
        },
        "\\h": "ᚻ",
        "\\i": {
            unicode: "⥍",
            note: "approximation",
        },
        "\\ing": {
            unicode: "ᛄ",
            note: "approximation",
        },
        "\\Ing": {
            unicode: "ᛄ",
            note: "approximation",
        },
        "\\ING": "ᛄ",
        "\\j": {
            unicode: "ᛃ",
            note: "approximation",
        },
        "\\k": {
            unicode: "⌵",
            note: "approximation",
        },
        "\\K": {
            unicode: "Υ",
            note: "approximation",
        },
        "\\ng": "ᛜ",
        "\\NG": {
            unicode: "⸋",
            note: "approximation",
        },
        "\\p": {
            unicode: "ᛒ", note: "but with dot in lower"
        },
        "\\R": "ᛦ",
        "\\RR": {
            unicode: "ᛯ",
            note: "approximation",
        },
        "\\s": "ᛋ",
        "\\S": "ᛋ",
        "\\seight": {
            unicode: "⦚",
            note: "approximation",
        },
        "\\sfive": {
            unicode: "⦚",
            note: "approximation",
        },
        "\\sseven": {
            unicode: "⦚",
            note: "approximation",
        },
        "\\sthree": {
            unicode: "⦚",
            note: "approximation",
        },
        "\\th": "ᚦ",
        "a": "ᚨ",
        "A": "ᛋ",
        "b": "ᛒ",
        "B": {
            unicode: "ᛒ",
            note: "approximation",
        },
        "d": "ᛞ",
        "D": {
            unicode: "▯",
            note: "approximation",
        },
        "e": "ᛖ",
        "E": {
            unicode: "⨅",
            note: "approximation",
        },
        "f": {
            unicode: "ᚠ",
            note: "but skinny"
        },
        "F": "ᚠ",
        "g": "ᚷ",
        "h": "ᚺ",
        "H": {
            unicode: "𝖭",
            note: "approximation",
        },
        "i": "ᛁ",
        "I": {
            unicode: "⥌",
            note: "approximation",
        }, "\\\"i": {
            unicode: "⥌",
            note: "approximation",
        },
        "j": "ᛃ",
        "J": {
            unicode: "ϟ",
            note: "but with box"
        },
        "k": "ᚲ",
        "K": {
            unicode: "Ⴤ",
            note: "approximation",
        },
        "l": "ᛚ",
        "m": "ᛗ",
        "n": "ᚾ",
        "o": "ᛟ",
        "p": "ᛈ",
        "P": {
            unicode: "P",
            note: "approximation",
        },
        "r": "ᚱ",
        "R": "ᛉ",
        "s": "ᛊ",
        "\\sfour": "ᛊ",
        "S": {
            unicode: "⦚",
            note: "approximation",
        },
        "t": "ᛏ",
        "T": {
            unicode: "ᛏ",
            note: "approximation",
        },
        "u": "ᚢ",
        "U": {
            unicode: "Λ",
            note: "approximation",
        },
        "w": "ᚹ"
    },
    "rm": {
        "\\a": "ᛆ", ".a": "ᛆ",
        "\\adot": {
            note: "ᛂ+ᛅ",
        }, "'a": {
            note: "ᛂ+ᛅ",
        },
        "\\c": "ᛍ", ".c": "ᛍ",
        "\\D": {
            note: "Arrow with two dots",
        }, "T": {
            note: "Arrow with two dots",
        },
        "\\e": {
            unicode: "⟊",
            note: "approximation",
        }, "=i": {
            unicode: "⟊",
            note: "approximation",
        },
        "\\g": {
            unicode: "?",
            note: "approximation",
        }, "=k": {
            unicode: "?",
            note: "approximation",
        },
        "\\h": {
            unicode: "⚹",
            note: "approximation",
        },
        "\\l": "ᛛ", ".l": "ᛛ",
        "\\lbar": {
            note: "ᛚ with bar",
        }, "=l": {
            note: "ᛚ with bar",
        },
        "\\ldot": {
            note: "ᛚ with dot",
        }, "'l": {
            note: "ᛚ with dot",
        },
        "\\lflag": {
            note: "ᛚ with flag",
        }, "~l": {
            note: "ᛚ with flag",
        },
        "\\lring": {
            note: "ᛚ with ring",
        }, "^l": {
            note: "ᛚ with ring",
        },
        "\\m": {
            unicode: "ᚴ",
            note: "but mirrored"
        },
        "\\n": {
            unicode: "ᛀ",
            note: "approximation",
        }, ".n": {
            unicode: "ᛀ",
            note: "approximation",
        },
        "\\N": "ᛀ", ".N": "ᛀ",
        "\\ndot": {
            note: "ᚿ+ᛀ",
        }, "'n": {
            note: "ᚿ+ᛀ",
        },
        "\\p": {
            unicode: "ᛒ",
            note: "but with dot in lower"
        }, ".b": {
            unicode: "ᛒ",
            note: "but with dot in lower"
        },
        "\\P": "ᛕ",
        "\\Pdots": {
            note: "ᛕ with dots",
        },
        "\\q": {
            note: "ᚴ mirrored",
        },
        "\\Q": {
            note: "ᛕ mirrored",
        },
        "\\r": {
            unicode: "?",
            note: "approximation",
        },
        "\\rdot": {
            note: "ᚱ with dot",
        }, ".r": {
            note: "ᚱ with dot",
        },
        "\\tbar": {
            unicode: "ᛑ",
            note: "but with bar"
        }, "=t": {
            unicode: "ᛑ",
            note: "but with bar"
        },
        "\\tdot": {
            unicode: "ᛑ",
            note: "but dot translated upper left"
        }, "'t": {
            unicode: "ᛑ",
            note: "but dot translated upper left"
        },
        "\\tflag": {
            unicode: "ᛑ",
            note: "but with flag"
        }, "~t": {
            unicode: "ᛑ",
            note: "but with flag"
        },
        "\\tring": {
            unicode: "ᛑ",
            note: "but with ring"
        }, "^t": {
            unicode: "ᛑ",
            note: "but with ring"
        },
        "a": "ᛆ",
        "A": {
            unicode: "ᛆ",
            note: "but with bigger leg"
        },
        "b": "ᛒ",
        "B": {
            unicode: "ᛒ",
            note: "but like b"
        },
        "c": "ᛌ",
        "C": {
            unicode: "ᛍ",
            note: "approximation",
        }, "^c": {
            unicode: "ᛍ",
            note: "approximation",
        },
        "d": "ᛑ", ".t": "ᛑ",
        "D": {
            note: "ᛏ+ᛂ",
        }, ".T": {
            note: "ᛏ+ᛂ",
        },
        "e": "ᛂ", ".i": "ᛂ",
        "E": {
            unicode: "ᛂ",
            note: "but with ring"
        }, "^i": {
            unicode: "ᛂ",
            note: "but with ring"
        },
        "f": "ᚠ",
        "F": {
            note: "ᚠ with extra branch",
        },
        "g": "ᚵ", ".k": "ᚵ",
        "G": {
            unicode: "ᚵ",
            note: "but dot translated bottom left"
        }, "'k": {
            unicode: "ᚵ",
            note: "but dot translated bottom left"
        },
        "h": "ᚼ",
        "H": {
            unicode: "✳",
            note: "approximation",
        },
        "i": "ᛧ",
        "k": "ᚴ",
        "l": "ᛚ",
        "m": "ᛘ",
        "n": "ᚿ",
        "N": "ᚾ",
        "o": "ᚮ",
        "p": "ᛔ",
        "P": "ᚹ",
        "q": {
            note: "ᚹ mirrored",
        },
        "r": "ᚱ"
    },
    "rn": {
        ".i": "ᛂ", "e": "ᛂ",
        ".k": "ᚵ", "g": "ᚵ",
        ".u": "ᚤ", "y": "ᚤ",
        "\\m": {
            note: "ᛘ with dots",
        },
        "M": {
            note: "⫯ with plus",
        }, "\\M": {
            note: "⫯ with plus",
        },
        "\\A": "ᚬ",
        "\\bar": {
            unicode: "❘",
            note: "approximation",
        }, "!": {
            unicode: "❘",
            note: "approximation",
        },
        "\\cross": "⨯", "*": "⨯",
        "\\dot": "᛫", ".": "᛫",
        "\\doublebar": "¦",
        "\\doublecross": {
            note: "two stacked x's",
        },
        "\\doubledot": "᛬", ":": "᛬",
        "\\doubleeye": "᛬",
        "\\doubleplus": {
            unicode: "‡",
            note: "approximation",
        },
        "\\eye": "᛫",
        "\\pentdot": {
            unicode: "⹘",
            note: "proposal",
        },
        "\\penteye": "⸭",
        "\\plus": "᛭", "+": "᛭",
        "\\quaddot": "⁞",
        "\\quadeye": {
            unicode: "⁘",
            note: "approximation",
        },
        "\\star": {
            unicode: "*",
            note: "approximation",
        },
        "\\th": "ᚦ",
        "\\TH": {
            unicode: "ᚦ",
            note: "approximation",
        },
        "\\triplebar": "┆",
        "\\triplecross": {
            note: "three stacked x's",
        },
        "\\tripledot": "⁝",
        "\\tripleeye": "⋮",
        "\\tripleplus": {
            note: "three stacked plusses",
        },
        "A": "ᚭ",
        "a": "ᛅ",
        "b": "ᛒ",
        "B": {
            unicode: "ᛒ",
            note: "but skinny"
        },
        "f": "ᚠ",
        "F": {
            unicode: "ᚠ",
            note: "but skinny"
        },
        "h": "ᚼ",
        "i": "ᛁ",
        "k": "ᚴ",
        "l": "ᛚ",
        "m": "ᛘ",
        "n": "ᚾ",
        "r": "ᚱ",
        "R": "ᛣ",
        "s": "ᛋ",
        "S": {
            unicode: "𝗁",
            note: "but with sharp corner",
        },
        "t": "ᛏ",
        "u": {
            "latex1": "u"
        }
    },
    "rt": {},
    "rl": {
        "\\A": {
            unicode: "ߌ",
            note: "approximation"
        },
        "\\th": "ᛧ",
        "A": {
            unicode: "`",
            note: "approximation"
        },
        "a": {
            unicode: "´",
            note: "approximation"
        },
        "b": {
            unicode: "´",
            note: "approximation"
        },
        "f": {
            unicode: "ߌ",
            note: "approximation"
        },
        "h": "ᛙ",
        "i": "ᛁ",
        "k": "ᛍ",
        "l": {
            unicode: "`",
            note: "approximation"
        },
        "m": {
            unicode: ":",
            note: "approximation"
        },
        "n": {
            unicode: "`",
            note: "approximation"
        },
        "r": {
            unicode: "⎧",
            note: "approximation"
        },
        "R": {
            unicode: ":",
            note: "approximation"
        },
        "s": "ᛧ",
        "t": {
            unicode: "´",
            note: "approximation"
        },
        "u": {
            unicode: "⎫",
            note: "approximation"
        }
    }
};
exports.isRuneType = function (x) { return exports.runesMap.hasOwnProperty(x); };
exports.runeUnicode = function (type, innerLatex) {
    var runesType = exports.runesMap[type];
    if (!runesType)
        return undefined;
    var found = runesType[innerLatex];
    if (typeof found === "string")
        return found;
    if (found.unicode)
        return found.unicode;
    return undefined;
};
//# sourceMappingURL=runes.js.map

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var space_1 = __webpack_require__(132);
var diacritic_1 = __webpack_require__(133);
var formatting_1 = __webpack_require__(48);
var runes_1 = __webpack_require__(50);
exports.oneArgsCommands = Object.assign({}, space_1.spaceCmds1arg, formatting_1.formattingText, formatting_1.formattingMath, formatting_1.formattingNoMode, diacritic_1.diacriticsTextMode, diacritic_1.diacriticsMathMode, runes_1.runesMap, {
    "cyrchar": true,
    "vec": true,
    "mono": true,
    "ding": true,
    "dingbat": true,
    "ElsevierGlyph": true,
    "elsevierglyph": true,
    "elsevier": true,
    "Elsevier": true,
});
function is1argsCommand(name) {
    return exports.oneArgsCommands.hasOwnProperty(name);
}
exports.is1argsCommand = is1argsCommand;
//# sourceMappingURL=index.js.map

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(143);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(27)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../node_modules/vue-loader/lib/index.js?{\"loaders\":{\"js\":\"babel-loader\"}}!./Citations.vue?vue&type=style&index=0&lang=css", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../node_modules/vue-loader/lib/index.js?{\"loaders\":{\"js\":\"babel-loader\"}}!./Citations.vue?vue&type=style&index=0&lang=css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(1);

var _ = _interopRequireWildcard(_underscore);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var $ = _jquery2.default;
//============================================================================
/** Returns a jQuery object containing a clickable font-awesome button.
 *      options:
 *          tooltipConfig   : option map for bootstrap tool tip
 *          classes         : array of class names (will always be classed as icon-btn)
 *          disabled        : T/F - add the 'disabled' class?
 *          title           : tooltip/title string
 *          target          : optional href target
 *          href            : optional href
 *          faIcon          : which font awesome icon to use
 *          onclick         : function to call when the button is clicked
 */
var faIconButton = function faIconButton(options) {
    options = options || {};
    options.tooltipConfig = options.tooltipConfig || {
        placement: "bottom"
    };

    options.classes = ["icon-btn"].concat(options.classes || []);
    if (options.disabled) {
        options.classes.push("disabled");
    }

    var html = ['<a class="', options.classes.join(" "), '"', options.title ? " title=\"" + options.title + "\"" : "", !options.disabled && options.target ? " target=\"" + options.target + "\"" : "", ' href="', !options.disabled && options.href ? options.href : "javascript:void(0);", '">',
    // could go with something less specific here - like 'html'
    '<span class="fa ', options.faIcon, '"></span>', "</a>"].join("");
    var $button = $(html).tooltip(options.tooltipConfig);
    if (_.isFunction(options.onclick)) {
        $button.click(function (ev) {
            $button.tooltip("hide");
            $button.parent().attr("tabindex", -1).focus();
            options.onclick.apply(this, arguments);
        });
    }
    return $button;
};

//============================================================================
exports.default = faIconButton;

/***/ }),
/* 54 */,
/* 55 */,
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Backbone, $, _, jQuery) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
// =============================================================================
/**
 * view for a popup menu
 */
var PopupMenu = Backbone.View.extend({
    //TODO: maybe better as singleton off the Galaxy obj
    /** Cache the desired button element and options, set up the button click handler
     *  NOTE: attaches this view as HTML/jQ data on the button for later use.
     */
    initialize: function initialize($button, options) {
        // default settings
        this.$button = $button;
        if (!this.$button.length) {
            this.$button = $("<div/>");
        }
        this.options = options || [];
        this.$button.data("popupmenu", this);

        // set up button click -> open menu behavior
        var menu = this;
        this.$button.click(function (event) {
            // if there's already a menu open, remove it
            $(".popmenu-wrapper").remove();
            menu._renderAndShow(event);
            return false;
        });
    },

    // render the menu, append to the page body at the click position, and set up the 'click-away' handlers, show
    _renderAndShow: function _renderAndShow(clickEvent) {
        this.render();
        this.$el.appendTo("body").css(this._getShownPosition(clickEvent)).show();
        this._setUpCloseBehavior();
    },

    // render the menu
    // this menu doesn't attach itself to the DOM ( see _renderAndShow )
    render: function render() {
        // render the menu body absolute and hidden, fill with template
        this.$el.addClass("popmenu-wrapper").hide().css({ position: "absolute" }).html(this.template(this.$button.attr("id"), this.options));

        // set up behavior on each link/anchor elem
        if (this.options.length) {
            var menu = this;
            //precondition: there should be one option per li
            this.$el.find("li").each(function (i, li) {
                var option = menu.options[i];

                // if the option has 'func', call that function when the anchor is clicked
                if (option.func) {
                    $(this).children("a.popupmenu-option").click(function (event) {
                        option.func.call(menu, event, option);
                        // We must preventDefault otherwise clicking "cancel"
                        // on a purge or something still navigates and causes
                        // the action.
                        event.preventDefault();
                        // bubble up so that an option click will call the close behavior
                    });
                }
            });
        }
        return this;
    },

    template: function template(id, options) {
        return ['<ul id="', id, '-menu" class="dropdown-menu">', this._templateOptions(options), "</ul>"].join("");
    },

    _templateOptions: function _templateOptions(options) {
        if (!options.length) {
            return "<li>(no options)</li>";
        }
        return _.map(options, function (option) {
            if (option.divider) {
                return '<li class="divider"></li>';
            } else if (option.header) {
                return ['<li class="head"><a href="javascript:void(0);">', option.html, "</a></li>"].join("");
            }
            var href = option.href || "javascript:void(0);";
            var target = option.target ? " target=\"" + option.target + "\"" : "";

            var check = option.checked ? '<span class="fa fa-check"></span>' : "";

            return ['<li><a class="popupmenu-option" href="', href, '"', target, ">", check, option.html, "</a></li>"].join("");
        }).join("");
    },

    // get the absolute position/offset for the menu
    _getShownPosition: function _getShownPosition(clickEvent) {
        // display menu horiz. centered on click...
        var menuWidth = this.$el.width();
        var x = clickEvent.pageX - menuWidth / 2;

        // adjust to handle horiz. scroll and window dimensions ( draw entirely on visible screen area )
        x = Math.min(x, $(document).scrollLeft() + $(window).width() - menuWidth - 5);
        x = Math.max(x, $(document).scrollLeft() + 5);
        return {
            top: clickEvent.pageY,
            left: x
        };
    },

    // bind an event handler to all available frames so that when anything is clicked
    // the menu is removed from the DOM and the event handler unbinds itself
    _setUpCloseBehavior: function _setUpCloseBehavior() {
        var menu = this;
        //TODO: alternately: focus hack, blocking overlay, jquery.blockui

        // function to close popup and unbind itself
        function closePopup(event) {
            $(document).off("click.close_popup");
            if (window && window.parent !== window) {
                try {
                    $(window.parent.document).off("click.close_popup");
                } catch (err) {}
            } else {
                try {
                    $("iframe#galaxy_main").contents().off("click.close_popup");
                } catch (err) {}
            }
            menu.remove();
        }

        $("html").one("click.close_popup", closePopup);
        if (window && window.parent !== window) {
            try {
                $(window.parent.document).find("html").one("click.close_popup", closePopup);
            } catch (err) {}
        } else {
            try {
                $("iframe#galaxy_main").contents().one("click.close_popup", closePopup);
            } catch (err) {}
        }
    },

    // add a menu option/item at the given index
    addItem: function addItem(item, index) {
        // append to end if no index
        index = index >= 0 ? index : this.options.length;
        this.options.splice(index, 0, item);
        return this;
    },

    // remove a menu option/item at the given index
    removeItem: function removeItem(index) {
        if (index >= 0) {
            this.options.splice(index, 1);
        }
        return this;
    },

    // search for a menu option by its html
    findIndexByHtml: function findIndexByHtml(html) {
        for (var i = 0; i < this.options.length; i++) {
            if (_.has(this.options[i], "html") && this.options[i].html === html) {
                return i;
            }
        }
        return null;
    },

    // search for a menu option by its html
    findItemByHtml: function findItemByHtml(html) {
        return this.options[this.findIndexByHtml(html)];
    },

    // string representation
    toString: function toString() {
        return "PopupMenu";
    }
});
/** shortcut to new for when you don't need to preserve the ref */
PopupMenu.create = function _create($button, options) {
    return new PopupMenu($button, options);
};

// -----------------------------------------------------------------------------
// the following class functions are bridges from the original make_popupmenu and make_popup_menus
// to the newer backbone.js PopupMenu

/** Create a PopupMenu from simple map initial_options activated by clicking button_element.
 *      Converts initial_options to object array used by PopupMenu.
 *  @param {jQuery|DOMElement} button_element element which, when clicked, activates menu
 *  @param {Object} initial_options map of key -> values, where
 *      key is option text, value is fn to call when option is clicked
 *  @returns {PopupMenu} the PopupMenu created
 */
PopupMenu.make_popupmenu = function (button_element, initial_options) {
    var convertedOptions = [];
    _.each(initial_options, function (optionVal, optionKey) {
        var newOption = { html: optionKey };

        // keys with null values indicate: header
        if (optionVal === null) {
            // !optionVal? (null only?)
            newOption.header = true;

            // keys with function values indicate: a menu option
        } else if (jQuery.type(optionVal) === "function") {
            newOption.func = optionVal;
        }
        //TODO:?? any other special optionVals?
        // there was no divider option originally
        convertedOptions.push(newOption);
    });
    return new PopupMenu($(button_element), convertedOptions);
};

/** Find all anchors in $parent (using selector) and covert anchors into a PopupMenu options map.
 *  @param {jQuery} $parent the element that contains the links to convert to options
 *  @param {String} selector jq selector string to find links
 *  @returns {Object[]} the options array to initialize a PopupMenu
 */
//TODO: lose parent and selector, pass in array of links, use map to return options
PopupMenu.convertLinksToOptions = function ($parent, selector) {
    $parent = $($parent);
    selector = selector || "a";
    var options = [];
    $parent.find(selector).each(function (elem, i) {
        var option = {};
        var $link = $(elem);

        // convert link text to the option text (html) and the href into the option func
        option.html = $link.text();
        if ($link.attr("href")) {
            var linkHref = $link.attr("href");
            var linkTarget = $link.attr("target");
            var confirmText = $link.attr("confirm");

            option.func = function () {
                // if there's a "confirm" attribute, throw up a confirmation dialog, and
                //  if the user cancels - do nothing
                if (confirmText && !confirm(confirmText)) {
                    return;
                }

                // if there's no confirm attribute, or the user accepted the confirm dialog:
                switch (linkTarget) {
                    // relocate the center panel
                    case "_parent":
                        window.parent.location = linkHref;
                        break;

                    // relocate the entire window
                    case "_top":
                        window.top.location = linkHref;
                        break;

                    // relocate this panel
                    default:
                        window.location = linkHref;
                }
            };
        }
        options.push(option);
    });
    return options;
};

/** Create a single popupmenu from existing DOM button and anchor elements
 *  @param {jQuery} $buttonElement the element that when clicked will open the menu
 *  @param {jQuery} $menuElement the element that contains the anchors to convert into a menu
 *  @param {String} menuElementLinkSelector jq selector string used to find anchors to be made into menu options
 *  @returns {PopupMenu} the PopupMenu (Backbone View) that can render, control the menu
 */
PopupMenu.fromExistingDom = function ($buttonElement, $menuElement, menuElementLinkSelector) {
    $buttonElement = $($buttonElement);
    $menuElement = $($menuElement);
    var options = PopupMenu.convertLinksToOptions($menuElement, menuElementLinkSelector);
    // we're done with the menu (having converted it to an options map)
    $menuElement.remove();
    return new PopupMenu($buttonElement, options);
};

/** Create all popupmenus within a document or a more specific element
 *  @param {DOMElement} parent the DOM element in which to search for popupmenus to build (defaults to document)
 *  @param {String} menuSelector jq selector string to find popupmenu menu elements (defaults to "div[popupmenu]")
 *  @param {Function} buttonSelectorBuildFn the function to build the jq button selector.
 *      Will be passed $menuElement, parent.
 *      (Defaults to return '#' + $menuElement.attr( 'popupmenu' ); )
 *  @returns {PopupMenu[]} array of popupmenus created
 */
PopupMenu.make_popup_menus = function (parent, menuSelector, buttonSelectorBuildFn) {
    parent = parent || document;
    // orig. Glx popupmenu menus have a (non-std) attribute 'popupmenu'
    //  which contains the id of the button that activates the menu
    menuSelector = menuSelector || "div[popupmenu]";
    // default to (orig. Glx) matching button to menu by using the popupmenu attr of the menu as the id of the button
    buttonSelectorBuildFn = buttonSelectorBuildFn || function ($menuElement, parent) {
        return "#" + $menuElement.attr("popupmenu");
    };

    // aggregate and return all PopupMenus
    var popupMenusCreated = [];
    $(parent).find(menuSelector).each(function () {
        var $menuElement = $(this);

        var $buttonElement = $(parent).find(buttonSelectorBuildFn($menuElement, parent));

        popupMenusCreated.push(PopupMenu.fromDom($buttonElement, $menuElement));
        $buttonElement.addClass("popup");
    });
    return popupMenusCreated;
};

// =============================================================================
exports.default = PopupMenu;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(0), __webpack_require__(1), __webpack_require__(0)))

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Backbone, $) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _underscore = __webpack_require__(1);

var _ = _interopRequireWildcard(_underscore);

var _util = __webpack_require__(20);

var _util2 = _interopRequireDefault(_util);

var _data = __webpack_require__(15);

var _data2 = _interopRequireDefault(_data);

var _toolForm = __webpack_require__(68);

var _toolForm2 = _interopRequireDefault(_toolForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/**
 * Mixin for tracking model visibility.
 */
/**
 * Model, view, and controller objects for Galaxy tools and tool panel.
 */

var VisibilityMixin = {
    hidden: false,

    show: function show() {
        this.set("hidden", false);
    },

    hide: function hide() {
        this.set("hidden", true);
    },

    toggle: function toggle() {
        this.set("hidden", !this.get("hidden"));
    },

    is_visible: function is_visible() {
        return !this.attributes.hidden;
    }
};

/**
 * A tool parameter.
 */
var ToolParameter = Backbone.Model.extend({
    defaults: {
        name: null,
        label: null,
        type: null,
        value: null,
        html: null,
        num_samples: 5
    },

    initialize: function initialize(options) {
        this.attributes.html = unescape(this.attributes.html);
    },

    copy: function copy() {
        return new ToolParameter(this.toJSON());
    },

    set_value: function set_value(value) {
        this.set("value", value || "");
    }
});

var ToolParameterCollection = Backbone.Collection.extend({
    model: ToolParameter
});

/**
 * A data tool parameter.
 */
var DataToolParameter = ToolParameter.extend({});

/**
 * An integer tool parameter.
 */
var IntegerToolParameter = ToolParameter.extend({
    set_value: function set_value(value) {
        this.set("value", parseInt(value, 10));
    },

    /**
     * Returns samples from a tool input.
     */
    get_samples: function get_samples() {
        return d3.scale.linear().domain([this.get("min"), this.get("max")]).ticks(this.get("num_samples"));
    }
});

var FloatToolParameter = IntegerToolParameter.extend({
    set_value: function set_value(value) {
        this.set("value", parseFloat(value));
    }
});

/**
 * A select tool parameter.
 */
var SelectToolParameter = ToolParameter.extend({
    /**
     * Returns tool options.
     */
    get_samples: function get_samples() {
        return _.map(this.get("options"), function (option) {
            return option[0];
        });
    }
});

// Set up dictionary of parameter types.
ToolParameter.subModelTypes = {
    integer: IntegerToolParameter,
    float: FloatToolParameter,
    data: DataToolParameter,
    select: SelectToolParameter
};

/**
 * A Galaxy tool.
 */
var Tool = Backbone.Model.extend({
    // Default attributes.
    defaults: {
        id: null,
        name: null,
        description: null,
        target: null,
        inputs: [],
        outputs: []
    },

    urlRoot: Galaxy.root + "api/tools",

    initialize: function initialize(options) {
        // Set parameters.
        this.set("inputs", new ToolParameterCollection(_.map(options.inputs, function (p) {
            var p_class = ToolParameter.subModelTypes[p.type] || ToolParameter;
            return new p_class(p);
        })));
    },

    /**
     *
     */
    toJSON: function toJSON() {
        var rval = Backbone.Model.prototype.toJSON.call(this);

        // Convert inputs to JSON manually.
        rval.inputs = this.get("inputs").map(function (i) {
            return i.toJSON();
        });
        return rval;
    },

    /**
     * Removes inputs of a particular type; this is useful because not all inputs can be handled by
     * client and server yet.
     */
    remove_inputs: function remove_inputs(types) {
        var tool = this;

        var incompatible_inputs = tool.get("inputs").filter(function (input) {
            return types.indexOf(input.get("type")) !== -1;
        });

        tool.get("inputs").remove(incompatible_inputs);
    },

    /**
     * Returns object copy, optionally including only inputs that can be sampled.
     */
    copy: function copy(only_samplable_inputs) {
        var copy = new Tool(this.toJSON());

        // Return only samplable inputs if flag is set.
        if (only_samplable_inputs) {
            var valid_inputs = new Backbone.Collection();
            copy.get("inputs").each(function (input) {
                if (input.get_samples()) {
                    valid_inputs.push(input);
                }
            });
            copy.set("inputs", valid_inputs);
        }

        return copy;
    },

    apply_search_results: function apply_search_results(results) {
        _.indexOf(results, this.attributes.id) !== -1 ? this.show() : this.hide();
        return this.is_visible();
    },

    /**
     * Set a tool input's value.
     */
    set_input_value: function set_input_value(name, value) {
        this.get("inputs").find(function (input) {
            return input.get("name") === name;
        }).set("value", value);
    },

    /**
     * Set many input values at once.
     */
    set_input_values: function set_input_values(inputs_dict) {
        var self = this;
        _.each(_.keys(inputs_dict), function (input_name) {
            self.set_input_value(input_name, inputs_dict[input_name]);
        });
    },

    /**
     * Run tool; returns a Deferred that resolves to the tool's output(s).
     */
    run: function run() {
        return this._run();
    },

    /**
     * Rerun tool using regions and a target dataset.
     */
    rerun: function rerun(target_dataset, regions) {
        return this._run({
            action: "rerun",
            target_dataset_id: target_dataset.id,
            regions: regions
        });
    },

    /**
     * Returns input dict for tool's inputs.
     */
    get_inputs_dict: function get_inputs_dict() {
        var input_dict = {};
        this.get("inputs").each(function (input) {
            input_dict[input.get("name")] = input.get("value");
        });
        return input_dict;
    },

    /**
     * Run tool; returns a Deferred that resolves to the tool's output(s).
     * NOTE: this method is a helper method and should not be called directly.
     */
    _run: function _run(additional_params) {
        // Create payload.
        var payload = _.extend({
            tool_id: this.id,
            inputs: this.get_inputs_dict()
        }, additional_params);

        // Because job may require indexing datasets, use server-side
        // deferred to ensure that job is run. Also use deferred that
        // resolves to outputs from tool.
        var run_deferred = $.Deferred();

        var ss_deferred = new _util2.default.ServerStateDeferred({
            ajax_settings: {
                url: this.urlRoot,
                data: JSON.stringify(payload),
                dataType: "json",
                contentType: "application/json",
                type: "POST"
            },
            interval: 2000,
            success_fn: function success_fn(response) {
                return response !== "pending";
            }
        });

        // Run job and resolve run_deferred to tool outputs.
        $.when(ss_deferred.go()).then(function (result) {
            run_deferred.resolve(new _data2.default.DatasetCollection(result));
        });
        return run_deferred;
    }
});
_.extend(Tool.prototype, VisibilityMixin);

/**
 * Tool view.
 */
var ToolView = Backbone.View.extend({});

/**
 * Wrap collection of tools for fast access/manipulation.
 */
var ToolCollection = Backbone.Collection.extend({
    model: Tool
});

/**
 * Label or section header in tool panel.
 */
var ToolSectionLabel = Backbone.Model.extend(VisibilityMixin);

/**
 * Section of tool panel with elements (labels and tools).
 */
var ToolSection = Backbone.Model.extend({
    defaults: {
        elems: [],
        open: false
    },

    clear_search_results: function clear_search_results() {
        _.each(this.attributes.elems, function (elt) {
            elt.show();
        });

        this.show();
        this.set("open", false);
    },

    apply_search_results: function apply_search_results(results) {
        var all_hidden = true;
        var cur_label;
        _.each(this.attributes.elems, function (elt) {
            if (elt instanceof ToolSectionLabel) {
                cur_label = elt;
                cur_label.hide();
            } else if (elt instanceof Tool) {
                if (elt.apply_search_results(results)) {
                    all_hidden = false;
                    if (cur_label) {
                        cur_label.show();
                    }
                }
            }
        });

        if (all_hidden) {
            this.hide();
        } else {
            this.show();
            this.set("open", true);
        }
    }
});
_.extend(ToolSection.prototype, VisibilityMixin);

/**
 * Tool search that updates results when query is changed. Result value of null
 * indicates that query was not run; if not null, results are from search using
 * query.
 */
var ToolSearch = Backbone.Model.extend({
    defaults: {
        search_hint_string: "search tools",
        min_chars_for_search: 3,
        clear_btn_url: "",
        visible: true,
        query: "",
        results: null,
        // ESC (27) will clear the input field and tool search filters
        clear_key: 27
    },

    urlRoot: Galaxy.root + "api/tools",

    initialize: function initialize() {
        this.on("change:query", this.do_search);
    },

    /**
     * Do the search and update the results.
     */
    do_search: function do_search() {
        var query = this.attributes.query;

        // If query is too short, do not search.
        if (query.length < this.attributes.min_chars_for_search) {
            this.set("results", null);
            return;
        }

        // Do search via AJAX.
        var q = query;
        // Stop previous ajax-request
        if (this.timer) {
            clearTimeout(this.timer);
        }
        // Start a new ajax-request in X ms
        $("#search-clear-btn").hide();
        $("#search-spinner").show();
        var self = this;
        this.timer = setTimeout(function () {
            // log the search to analytics if present
            if (typeof ga !== "undefined") {
                ga("send", "pageview", Galaxy.root + "?q=" + q);
            }
            $.get(self.urlRoot, { q: q }, function (data) {
                self.set("results", data);
                $("#search-spinner").hide();
                $("#search-clear-btn").show();
            }, "json");
        }, 400);
    },

    clear_search: function clear_search() {
        this.set("query", "");
        this.set("results", null);
    }
});
_.extend(ToolSearch.prototype, VisibilityMixin);

/**
 * Tool Panel.
 */
var ToolPanel = Backbone.Model.extend({
    initialize: function initialize(options) {
        this.attributes.tool_search = options.tool_search;
        this.attributes.tool_search.on("change:results", this.apply_search_results, this);
        this.attributes.tools = options.tools;
        this.attributes.layout = new Backbone.Collection(this.parse(options.layout));
    },

    /**
     * Parse tool panel dictionary and return collection of tool panel elements.
     */
    parse: function parse(response) {
        // Recursive function to parse tool panel elements.
        var self = this;

        var // Helper to recursively parse tool panel.
        parse_elt = function parse_elt(elt_dict) {
            var type = elt_dict.model_class;
            // There are many types of tools; for now, anything that ends in 'Tool'
            // is treated as a generic tool.
            if (type.indexOf("Tool") === type.length - 4) {
                return self.attributes.tools.get(elt_dict.id);
            } else if (type === "ToolSection") {
                // Parse elements.
                var elems = _.map(elt_dict.elems, parse_elt);
                elt_dict.elems = elems;
                return new ToolSection(elt_dict);
            } else if (type === "ToolSectionLabel") {
                return new ToolSectionLabel(elt_dict);
            }
        };

        return _.map(response, parse_elt);
    },

    clear_search_results: function clear_search_results() {
        this.get("layout").each(function (panel_elt) {
            if (panel_elt instanceof ToolSection) {
                panel_elt.clear_search_results();
            } else {
                // Label or tool, so just show.
                panel_elt.show();
            }
        });
    },

    apply_search_results: function apply_search_results() {
        var results = this.get("tool_search").get("results");
        if (results === null) {
            this.clear_search_results();
            return;
        }

        var cur_label = null;
        this.get("layout").each(function (panel_elt) {
            if (panel_elt instanceof ToolSectionLabel) {
                cur_label = panel_elt;
                cur_label.hide();
            } else if (panel_elt instanceof Tool) {
                if (panel_elt.apply_search_results(results)) {
                    if (cur_label) {
                        cur_label.show();
                    }
                }
            } else {
                // Starting new section, so clear current label.
                cur_label = null;
                panel_elt.apply_search_results(results);
            }
        });
    }
});

/**
 * View classes for Galaxy tools and tool panel.
 *
 * Views use the templates defined below for rendering. Views update as needed
 * based on (a) model/collection events and (b) user interactions; in this sense,
 * they are controllers are well and the HTML is the real view in the MVC architecture.
 */

/**
 * Base view that handles visibility based on model's hidden attribute.
 */
var BaseView = Backbone.View.extend({
    initialize: function initialize() {
        this.model.on("change:hidden", this.update_visible, this);
        this.update_visible();
    },
    update_visible: function update_visible() {
        this.model.attributes.hidden ? this.$el.hide() : this.$el.show();
    }
});

/**
 * Link to a tool.
 */
var ToolLinkView = BaseView.extend({
    tagName: "div",

    render: function render() {
        // create element
        var $link = $("<div/>");
        $link.append(templates.tool_link(this.model.toJSON()));

        var formStyle = this.model.get("form_style", null);
        // open upload dialog for upload tool
        if (this.model.id === "upload1") {
            $link.find("a").on("click", function (e) {
                e.preventDefault();
                Galaxy.upload.show();
            });
        } else if (formStyle === "regular") {
            // regular tools
            var self = this;
            $link.find("a").on("click", function (e) {
                e.preventDefault();
                Galaxy.router.push("/", {
                    tool_id: self.model.id,
                    version: self.model.get("version")
                });
            });
        }

        // add element
        this.$el.append($link);
        return this;
    }
});

/**
 * Panel label/section header.
 */
var ToolSectionLabelView = BaseView.extend({
    tagName: "div",
    className: "toolPanelLabel",

    render: function render() {
        this.$el.append($("<span/>").text(this.model.attributes.text));
        return this;
    }
});

/**
 * Panel section.
 */
var ToolSectionView = BaseView.extend({
    tagName: "div",
    className: "toolSectionWrapper",

    initialize: function initialize() {
        BaseView.prototype.initialize.call(this);
        this.model.on("change:open", this.update_open, this);
    },

    render: function render() {
        // Build using template.
        this.$el.append(templates.panel_section(this.model.toJSON()));

        // Add tools to section.
        var section_body = this.$el.find(".toolSectionBody");
        _.each(this.model.attributes.elems, function (elt) {
            if (elt instanceof Tool) {
                var tool_view = new ToolLinkView({
                    model: elt,
                    className: "toolTitle"
                });
                tool_view.render();
                section_body.append(tool_view.$el);
            } else if (elt instanceof ToolSectionLabel) {
                var label_view = new ToolSectionLabelView({
                    model: elt
                });
                label_view.render();
                section_body.append(label_view.$el);
            } else {
                // TODO: handle nested section bodies?
            }
        });
        return this;
    },

    events: {
        "click .toolSectionTitle > a": "toggle"
    },

    /**
     * Toggle visibility of tool section.
     */
    toggle: function toggle() {
        this.model.set("open", !this.model.attributes.open);
    },

    /**
     * Update whether section is open or close.
     */
    update_open: function update_open() {
        this.model.attributes.open ? this.$el.children(".toolSectionBody").slideDown("fast") : this.$el.children(".toolSectionBody").slideUp("fast");
    }
});

var ToolSearchView = Backbone.View.extend({
    tagName: "div",
    id: "tool-search",
    className: "bar",

    events: {
        click: "focus_and_select",
        "keyup :input": "query_changed",
        "change :input": "query_changed",
        "click #search-clear-btn": "clear"
    },

    render: function render() {
        this.$el.append(templates.tool_search(this.model.toJSON()));
        if (!this.model.is_visible()) {
            this.$el.hide();
        }

        this.$el.find("[title]").tooltip();
        return this;
    },

    focus_and_select: function focus_and_select() {
        this.$el.find(":input").focus().select();
    },

    clear: function clear() {
        this.model.clear_search();
        this.$el.find(":input").val("");
        this.focus_and_select();
        return false;
    },

    query_changed: function query_changed(evData) {
        // check for the 'clear key' (ESC) first
        if (this.model.attributes.clear_key && this.model.attributes.clear_key === evData.which) {
            this.clear();
            return false;
        }
        this.model.set("query", this.$el.find(":input").val());
    }
});

/**
 * Tool panel view. Events triggered include:
 * tool_link_click(click event, tool_model)
 */
var ToolPanelView = Backbone.View.extend({
    tagName: "div",
    className: "toolMenu",

    /**
     * Set up view.
     */
    initialize: function initialize() {
        this.model.get("tool_search").on("change:results", this.handle_search_results, this);
    },

    render: function render() {
        var self = this;

        // Render search.
        var search_view = new ToolSearchView({
            model: this.model.get("tool_search")
        });
        search_view.render();
        // FIXME: This is a little ugly because it navigates through the parent
        //        element, but good enough until this is all `.vue`
        self.$el.closest(".unified-panel").find(".unified-panel-controls").append(search_view.$el);

        // Render panel.
        this.model.get("layout").each(function (panel_elt) {
            if (panel_elt instanceof ToolSection) {
                var section_title_view = new ToolSectionView({
                    model: panel_elt
                });
                section_title_view.render();
                self.$el.append(section_title_view.$el);
            } else if (panel_elt instanceof Tool) {
                var tool_view = new ToolLinkView({
                    model: panel_elt,
                    className: "toolTitleNoSection"
                });
                tool_view.render();
                self.$el.append(tool_view.$el);
            } else if (panel_elt instanceof ToolSectionLabel) {
                var label_view = new ToolSectionLabelView({
                    model: panel_elt
                });
                label_view.render();
                self.$el.append(label_view.$el);
            }
        });

        // Setup tool link click eventing.
        self.$el.find("a.tool-link").click(function (e) {
            // Tool id is always the first class.
            var tool_id = $(this).attr("class").split(/\s+/)[0];

            var tool = self.model.get("tools").get(tool_id);

            self.trigger("tool_link_click", e, tool);
        });

        return this;
    },

    handle_search_results: function handle_search_results() {
        var results = this.model.get("tool_search").get("results");
        if (results && results.length === 0) {
            $("#search-no-results").show();
        } else {
            $("#search-no-results").hide();
        }
    }
});

/**
 * View for working with a tool: setting parameters and inputs and executing the tool.
 */
var ToolFormView = Backbone.View.extend({
    className: "toolForm",

    render: function render() {
        this.$el.children().remove();
        this.$el.append(templates.tool_form(this.model.toJSON()));
    }
});

/**
 * Integrated tool menu + tool execution.
 */
var IntegratedToolMenuAndView = Backbone.View.extend({
    className: "toolMenuAndView",

    initialize: function initialize() {
        this.tool_panel_view = new ToolPanelView({
            collection: this.collection
        });
        this.tool_form_view = new ToolFormView();
    },

    render: function render() {
        // Render and append tool panel.
        this.tool_panel_view.render();
        this.tool_panel_view.$el.css("float", "left");
        this.$el.append(this.tool_panel_view.$el);

        // Append tool form view.
        this.tool_form_view.$el.hide();
        this.$el.append(this.tool_form_view.$el);

        // On tool link click, show tool.
        var self = this;
        this.tool_panel_view.on("tool_link_click", function (e, tool) {
            // Prevents click from activating link:
            e.preventDefault();
            // Show tool that was clicked on:
            self.show_tool(tool);
        });
    },

    /**
     * Fetch and display tool.
     */
    show_tool: function show_tool(tool) {
        var self = this;
        tool.fetch().done(function () {
            self.tool_form_view.model = tool;
            self.tool_form_view.render();
            self.tool_form_view.$el.show();
            $("#left").width("650px");
        });
    }
});

// TODO: move into relevant views
var templates = {
    // the search bar at the top of the tool panel
    tool_search: _.template("<input id=\"tool-search-query\" class=\"search-query parent-width\" name=\"query\"\n                placeholder=\"<%- search_hint_string %>\" autocomplete=\"off\" type=\"text\" />\n         <a id=\"search-clear-btn\" title=\"clear search (esc)\"> </a>\n         <span id=\"search-spinner\" class=\"search-spinner fa fa-spinner fa-spin\"></span>\n    "),

    // the category level container in the tool panel (e.g. 'Get Data', 'Text Manipulation')
    panel_section: _.template(['<div class="toolSectionTitle" id="title_<%- id %>">', '<a href="javascript:void(0)"><span><%- name %></span></a>', "</div>", '<div id="<%- id %>" class="toolSectionBody" style="display: none;">', '<div class="toolSectionBg"></div>', "<div>"].join("")),

    // a single tool's link in the tool panel; will load the tool form in the center panel
    tool_link: _.template(['<a class="<%- id %> tool-link" href="<%= link %>" target="<%- target %>" minsizehint="<%- min_width %>">', '<span class="labels">', "<% _.each( labels, function( label ){ %>", '<span class="badge badge-primary badge-<%- label %>">', "<%- label %>", "</span>", "<% }); %>", "</span>", '<span class="tool-old-link">', "<%- name %>", "</span>", " <%- description %>", "</a>"].join("")),

    // the tool form for entering tool parameters, viewing help and executing the tool
    // loaded when a tool link is clicked in the tool panel
    tool_form: _.template(['<div class="toolFormTitle"><%- tool.name %> (version <%- tool.version %>)</div>', '<div class="toolFormBody">', "<% _.each( tool.inputs, function( input ){ %>", '<div class="form-row">', '<label for="<%- input.name %>"><%- input.label %>:</label>', '<div class="form-row-input">', "<%= input.html %>", "</div>", '<div class="toolParamHelp" style="clear: both;">', "<%- input.help %>", "</div>", '<div style="clear: both;"></div>', "</div>", "<% }); %>", "</div>", '<div class="form-row form-actions">', '<input type="submit" class="btn btn-primary" name="runtool_btn" value="Execute" />', "</div>", '<div class="toolHelp">', '<div class="toolHelpBody"><% tool.help %></div>', "</div>"
    // TODO: we need scoping here because 'help' is the dom for the help menu in the masthead
    // which implies a leaky variable that I can't find
    ].join(""), { variable: "tool" })
};

// Exports
exports.default = {
    ToolParameter: ToolParameter,
    IntegerToolParameter: IntegerToolParameter,
    SelectToolParameter: SelectToolParameter,
    Tool: Tool,
    ToolCollection: ToolCollection,
    ToolSearch: ToolSearch,
    ToolPanel: ToolPanel,
    ToolPanelView: ToolPanelView,
    ToolFormView: ToolFormView
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(0)))

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, _) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _localization = __webpack_require__(3);

var _localization2 = _interopRequireDefault(_localization);

var _utils = __webpack_require__(5);

var _utils2 = _interopRequireDefault(_utils);

var _deferred = __webpack_require__(162);

var _deferred2 = _interopRequireDefault(_deferred);

var _uiMisc = __webpack_require__(11);

var _uiMisc2 = _interopRequireDefault(_uiMisc);

var _formView = __webpack_require__(30);

var _formView2 = _interopRequireDefault(_formView);

var _webhooks = __webpack_require__(29);

var _webhooks2 = _interopRequireDefault(_webhooks);

var _Citations = __webpack_require__(70);

var _Citations2 = _interopRequireDefault(_Citations);

var _vue = __webpack_require__(18);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _formView2.default.extend({
    initialize: function initialize(options) {
        var self = this;
        this.deferred = new _deferred2.default();
        _formView2.default.prototype.initialize.call(this, options);

        // optional model update
        this._update(this.model.get("initialmodel"));

        // listen to history panel
        if (this.model.get("listen_to_history") && parent.Galaxy && parent.Galaxy.currHistoryPanel) {
            this.listenTo(parent.Galaxy.currHistoryPanel.collection, "change", function () {
                self.model.get("onchange")();
            });
        }
        // destroy dom elements
        this.$el.on("remove", function () {
            self._destroy();
        });
    },

    /** Allows tool form variation to update tool model */
    _update: function _update(callback) {
        var self = this;
        callback = callback || this.model.get("buildmodel");
        if (callback) {
            this.deferred.reset();
            this.deferred.execute(function (process) {
                callback(process, self);
                process.then(function () {
                    self._render();
                });
            });
        } else {
            this._render();
        }
    },

    /** Wait for deferred build processes before removal */
    _destroy: function _destroy() {
        var self = this;
        this.$el.off().hide();
        this.deferred.execute(function () {
            _formView2.default.prototype.remove.call(self);
            Galaxy.emit.debug("tool-form-base::_destroy()", "Destroy view.");
        });
    },

    /** Build form */
    _render: function _render() {
        var self = this;
        var options = this.model.attributes;
        this.model.set({
            title: options.fixed_title || "<b>" + options.name + "</b> " + options.description + " (Galaxy Version " + options.version + ")",
            operations: !options.hide_operations && this._operations(),
            onchange: function onchange() {
                self.deferred.reset();
                self.deferred.execute(function (process) {
                    self.model.get("postchange")(process, self);
                    if (self.model.get("listen_to_history")) {
                        process.then(function () {
                            self.stopListening(parent.Galaxy.currHistoryPanel.collection);
                        });
                    }
                });
            }
        });
        this.render();
        if (!this.model.get("collapsible")) {
            this.$el.append($("<div/>").addClass("ui-margin-top-large").append(this._footer()));
        }
        options.tool_errors && this.message.update({
            status: "danger",
            message: options.tool_errors,
            persistent: true
        });
        this.show_message && this.message.update({
            status: "success",
            message: "Now you are using '" + options.name + "' version " + options.version + ", id '" + options.id + "'.",
            persistent: false
        });
        this.show_message = true;
    },

    /** Create tool operation menu */
    _operations: function _operations() {
        var self = this;
        var options = this.model.attributes;

        // button for version selection
        var versions_button = new _uiMisc2.default.ButtonMenu({
            icon: "fa-cubes",
            title: !options.narrow && "Versions" || null,
            tooltip: "Select another tool version"
        });
        if (!options.sustain_version && options.versions && options.versions.length > 1) {
            for (var i in options.versions) {
                var version = options.versions[i];
                if (version != options.version) {
                    versions_button.addMenu({
                        title: "Switch to " + version,
                        version: version,
                        icon: "fa-cube",
                        onclick: function onclick() {
                            // here we update the tool version (some tools encode the version also in the id)
                            self.model.set("id", options.id.replace(options.version, this.version));
                            self.model.set("version", this.version);
                            self._update();
                        }
                    });
                }
            }
        } else {
            versions_button.$el.hide();
        }

        // button for options e.g. search, help
        var menu_button = new _uiMisc2.default.ButtonMenu({
            id: "options",
            icon: "fa-caret-down",
            title: !options.narrow && "Options" || null,
            tooltip: "View available options"
        });
        if (options.biostar_url) {
            menu_button.addMenu({
                icon: "fa-question-circle",
                title: "Question?",
                onclick: function onclick() {
                    window.open(options.biostar_url + "/p/new/post/");
                }
            });
            menu_button.addMenu({
                icon: "fa-search",
                title: (0, _localization2.default)("Search"),
                onclick: function onclick() {
                    window.open(options.biostar_url + "/local/search/page/?q=" + options.name);
                }
            });
        }
        menu_button.addMenu({
            icon: "fa-share",
            title: (0, _localization2.default)("Share"),
            onclick: function onclick() {
                prompt("Copy to clipboard: Ctrl+C, Enter", window.location.origin + Galaxy.root + "root?tool_id=" + options.id);
            }
        });

        // add admin operations
        if (Galaxy.user && Galaxy.user.get("is_admin")) {
            menu_button.addMenu({
                icon: "fa-download",
                title: (0, _localization2.default)("Download"),
                onclick: function onclick() {
                    window.location.href = Galaxy.root + "api/tools/" + options.id + "/download";
                }
            });
        }

        // button for version selection
        if (options.requirements && options.requirements.length > 0) {
            menu_button.addMenu({
                icon: "fa-info-circle",
                title: (0, _localization2.default)("Requirements"),
                onclick: function onclick() {
                    if (!this.requirements_visible || self.portlet.collapsed) {
                        this.requirements_visible = true;
                        self.portlet.expand();
                        self.message.update({
                            persistent: true,
                            message: self._templateRequirements(options),
                            status: "info"
                        });
                    } else {
                        this.requirements_visible = false;
                        self.message.update({ message: "" });
                    }
                }
            });
        }

        // add toolshed url
        if (options.sharable_url) {
            menu_button.addMenu({
                icon: "fa-external-link",
                title: (0, _localization2.default)("See in Tool Shed"),
                onclick: function onclick() {
                    window.open(options.sharable_url);
                }
            });
        }

        // add tool menu webhooks
        _webhooks2.default.load({
            type: "tool-menu",
            callback: function callback(webhooks) {
                webhooks.each(function (model) {
                    var webhook = model.toJSON();
                    if (webhook.activate && webhook.config.function) {
                        menu_button.addMenu({
                            icon: webhook.config.icon,
                            title: webhook.config.title,
                            onclick: function onclick() {
                                var func = new Function("options", webhook.config.function);
                                func(options);
                            }
                        });
                    }
                });
            }
        });

        return {
            menu: menu_button,
            versions: versions_button
        };
    },

    /** Create footer */
    _footer: function _footer() {
        var options = this.model.attributes;
        var $el = $("<div/>").append(this._templateHelp(options));
        if (options.citations) {
            var citationInstance = _vue2.default.extend(_Citations2.default);
            var vm = document.createElement("div");
            $el.append(vm);
            new citationInstance({
                propsData: {
                    id: options.id,
                    source: "tools"
                }
            }).$mount(vm);
        }
        return $el;
    },

    /** Templates */
    _templateHelp: function _templateHelp(options) {
        var $tmpl = $("<div/>").addClass("ui-form-help").append(options.help);
        $tmpl.find("a").attr("target", "_blank");
        $tmpl.find("img").each(function () {
            var img_src = $(this).attr("src");
            if (img_src.indexOf("admin_toolshed") !== -1) {
                $(this).attr("src", Galaxy.root + img_src);
            }
        });
        return $tmpl;
    },

    _templateRequirements: function _templateRequirements(options) {
        var nreq = options.requirements.length;
        if (nreq > 0) {
            var requirements_message = "This tool requires ";
            _.each(options.requirements, function (req, i) {
                requirements_message += req.name + (req.version ? " (Version " + req.version + ")" : "") + (i < nreq - 2 ? ", " : i == nreq - 2 ? " and " : "");
            });
            var requirements_link = $("<a/>").attr("target", "_blank").attr("href", "https://galaxyproject.org/tools/requirements/").text("here");
            return $("<span/>").append(requirements_message + ". Click ").append(requirements_link).append(" for more information.");
        }
        return "No requirements found.";
    }
});
/**
    This is the base class of the tool form plugin. This class is e.g. inherited by the regular and the workflow tool form.
*/
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(1)))

/***/ }),
/* 59 */,
/* 60 */,
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _underscore = __webpack_require__(1);

var _ = _interopRequireWildcard(_underscore);

var _backbone = __webpack_require__(2);

var Backbone = _interopRequireWildcard(_backbone);

var _baseMvc = __webpack_require__(6);

var _baseMvc2 = _interopRequireDefault(_baseMvc);

var _localization = __webpack_require__(3);

var _localization2 = _interopRequireDefault(_localization);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var logNamespace = "user";
//==============================================================================
/** @class Model for a Galaxy user (including anonymous users).
 *  @name User
 */
var User = Backbone.Model.extend(_baseMvc2.default.LoggableMixin).extend(
/** @lends User.prototype */{
    _logNamespace: logNamespace,

    /** API location for this resource */
    urlRoot: function urlRoot() {
        return Galaxy.root + "api/users";
    },

    /** Model defaults
     *  Note: don't check for anon-users with the username as the default is '(anonymous user)'
     *      a safer method is if( !user.get( 'email' ) ) -> anon user
     */
    defaults: /** @lends User.prototype */{
        id: null,
        username: "(" + (0, _localization2.default)("anonymous user") + ")",
        email: "",
        total_disk_usage: 0,
        nice_total_disk_usage: "",
        quota_percent: null,
        is_admin: false
    },

    /** Set up and bind events
     *  @param {Object} data Initial model data.
     */
    initialize: function initialize(data) {
        this.log("User.initialize:", data);

        this.on("loaded", function (model, resp) {
            this.log(this + " has loaded:", model, resp);
        });
        this.on("change", function (model, data) {
            this.log(this + " has changed:", model, data.changes);
        });
    },

    isAnonymous: function isAnonymous() {
        return !this.get("email");
    },

    isAdmin: function isAdmin() {
        return this.get("is_admin");
    },

    /** Load a user with the API using an id.
     *      If getting an anonymous user or no access to a user id, pass the User.CURRENT_ID_STR
     *      (e.g. 'current') and the API will return the current transaction's user data.
     *  @param {String} idOrCurrent encoded user id or the User.CURRENT_ID_STR
     *  @param {Object} options hash to pass to Backbone.Model.fetch. Can contain success, error fns.
     *  @fires loaded when the model has been loaded from the API, passing the newModel and AJAX response.
     */
    loadFromApi: function loadFromApi(idOrCurrent, options) {
        idOrCurrent = idOrCurrent || User.CURRENT_ID_STR;

        options = options || {};
        var model = this;
        var userFn = options.success;

        /** @ignore */
        options.success = function (newModel, response) {
            model.trigger("loaded", newModel, response);
            if (userFn) {
                userFn(newModel, response);
            }
        };

        // requests for the current user must have a sep. constructed url (fetch don't work, ma)
        if (idOrCurrent === User.CURRENT_ID_STR) {
            options.url = this.urlRoot + "/" + User.CURRENT_ID_STR;
        }
        return Backbone.Model.prototype.fetch.call(this, options);
    },

    /** Clears all data from the sessionStorage.
     */
    clearSessionStorage: function clearSessionStorage() {
        for (var key in sessionStorage) {
            //TODO: store these under the user key so we don't have to do this
            // currently only history
            if (key.indexOf("history:") === 0) {
                sessionStorage.removeItem(key);
            } else if (key === "history-panel") {
                sessionStorage.removeItem(key);
            }
        }
    },

    /** string representation */
    toString: function toString() {
        var userInfo = [this.get("username")];
        if (this.get("id")) {
            userInfo.unshift(this.get("id"));
            userInfo.push(this.get("email"));
        }
        return "User(" + userInfo.join(":") + ")";
    }
});

// string to send to tell server to return this transaction's user (see api/users.py)
User.CURRENT_ID_STR = "current";

// class method to load the current user via the api and return that model
User.getCurrentUserFromApi = function (options) {
    var currentUser = new User();
    currentUser.loadFromApi(User.CURRENT_ID_STR, options);
    return currentUser;
};

// (stub) collection for users (shouldn't be common unless admin UI)
var UserCollection = Backbone.Collection.extend(_baseMvc2.default.LoggableMixin).extend({
    model: User,
    urlRoot: function urlRoot() {
        return Galaxy.root + "api/users";
    }
    //logger  : console,
});

//==============================================================================
exports.default = {
    User: User
};

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_DataDialog_vue_vue_type_script_lang_js__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_DataDialog_vue_vue_type_script_lang_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_DataDialog_vue_vue_type_script_lang_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_DataDialog_vue_vue_type_script_lang_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_DataDialog_vue_vue_type_script_lang_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_DataDialog_vue_vue_type_script_lang_js___default.a); 

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _axios = __webpack_require__(21);

var _axios2 = _interopRequireDefault(_axios);

var _vue = __webpack_require__(18);

var _vue2 = _interopRequireDefault(_vue);

var _bootstrapVue = __webpack_require__(76);

var _bootstrapVue2 = _interopRequireDefault(_bootstrapVue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_bootstrapVue2.default); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    props: {
        callback: {
            type: Function,
            required: true
        }
    },
    computed: {
        modalTitle: function modalTitle() {
            if (this.errorMessage) {
                return "Failed to load datasets";
            } else if (!this.optionsShow) {
                return "Loading datasets";
            }
        }
    },
    data: function data() {
        return {
            fields: {
                name: {
                    sortable: true
                },
                extension: {
                    sortable: true
                },
                update_time: {
                    sortable: true
                }
            },
            filter: null,
            nItems: 0,
            currentPage: 0,
            perPage: 10,
            items: [],
            errorMessage: null,
            errorShow: true,
            historyId: null,
            modalShow: true,
            optionsShow: false
        };
    },

    created: function created() {
        this.load();
    },
    methods: {
        filtered: function filtered(items) {
            this.nItems = items.length;
        },
        clicked: function clicked(record) {
            var host = window.location.protocol + "//" + window.location.hostname + ":" + window.location.port;
            this.callback(host + "/" + record.url + "/display");
            this.modalShow = false;
        },
        load: function load() {
            var _this = this;

            this.historyId = Galaxy.currHistoryPanel && Galaxy.currHistoryPanel.model.id;
            if (this.historyId) {
                _axios2.default.get(Galaxy.root + "api/histories/" + this.historyId + "/contents").then(function (response) {
                    _this.items = response.data;
                    _this.optionsShow = true;
                }).catch(function (e) {
                    if (e.response) {
                        _this.errorMessage = e.response.data.err_msg || e.response.statusText + " (" + e.response.status + ")";
                    } else {
                        _this.errorMessage = "Server unavailable.";
                    }
                });
            } else {
                this.errorMessage = "History not accessible.";
            }
        }
    }
};

/***/ }),
/* 64 */,
/* 65 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(188);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(27)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../node_modules/vue-loader/lib/index.js?{\"loaders\":{\"js\":\"babel-loader\"}}!./DataDialog.vue?vue&type=style&index=0&lang=css", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../node_modules/vue-loader/lib/index.js?{\"loaders\":{\"js\":\"babel-loader\"}}!./DataDialog.vue?vue&type=style&index=0&lang=css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _localization = __webpack_require__(3);

var _localization2 = _interopRequireDefault(_localization);

var _underscore = __webpack_require__(1);

var _ = _interopRequireWildcard(_underscore);

var _backbone = __webpack_require__(2);

var Backbone = _interopRequireWildcard(_backbone);

var _tracks = __webpack_require__(67);

var _tracks2 = _interopRequireDefault(_tracks);

var _visualization = __webpack_require__(16);

var _visualization2 = _interopRequireDefault(_visualization);

var _iconButton = __webpack_require__(34);

var _iconButton2 = _interopRequireDefault(_iconButton);

var _queryStringParsing = __webpack_require__(35);

var _queryStringParsing2 = _interopRequireDefault(_queryStringParsing);

var _gridView = __webpack_require__(28);

var _gridView2 = _interopRequireDefault(_gridView);

var _utils = __webpack_require__(5);

var _utils2 = _interopRequireDefault(_utils);

__webpack_require__(173);

__webpack_require__(172);

__webpack_require__(174);

__webpack_require__(73);

__webpack_require__(176);

__webpack_require__(158);

__webpack_require__(157);

__webpack_require__(175);

__webpack_require__(22);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Top-level trackster code, used for creating/loading visualizations and user interface elements.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


/* global Galaxy */
/* global $ */

/**
 * User interface controls for trackster
 */
var TracksterUI = function (_Backbone$Model) {
    _inherits(TracksterUI, _Backbone$Model);

    function TracksterUI(options) {
        _classCallCheck(this, TracksterUI);

        return _possibleConstructorReturn(this, (TracksterUI.__proto__ || Object.getPrototypeOf(TracksterUI)).call(this, options));
    }

    _createClass(TracksterUI, [{
        key: "initialize",
        value: function initialize(baseURL) {
            this.baseURL = baseURL;
            _utils2.default.cssLoadFile("static/style/jquery.rating.css");
            _utils2.default.cssLoadFile("static/style/autocomplete_tagging.css");
            _utils2.default.cssLoadFile("static/style/jquery-ui/smoothness/jquery-ui.css");
            _utils2.default.cssLoadFile("static/style/library.css");
            _utils2.default.cssLoadFile("static/style/trackster.css");
        }

        /**
         * Save visualization, returning a Deferred object for the remote call to save.
         */

    }, {
        key: "save_viz",
        value: function save_viz() {
            var _this2 = this;

            // show dialog
            Galaxy.modal.show({ title: "Saving...", body: "progress" });

            // Save bookmarks.
            var bookmarks = [];
            $(".bookmark").each(function () {
                bookmarks.push({
                    position: $(_this2).children(".position").text(),
                    annotation: $(_this2).children(".annotation").text()
                });
            });

            // FIXME: give unique IDs to Drawables and save overview as ID.
            var overview_track_name = this.view.overview_drawable ? this.view.overview_drawable.config.get_value("name") : null;

            var viz_config = {
                view: this.view.to_dict(),
                viewport: {
                    chrom: this.view.chrom,
                    start: this.view.low,
                    end: this.view.high,
                    overview: overview_track_name
                },
                bookmarks: bookmarks
            };

            // Make call to save visualization.
            return $.ajax({
                url: Galaxy.root + "visualization/save",
                type: "POST",
                dataType: "json",
                data: {
                    id: this.view.vis_id,
                    title: this.view.config.get_value("name"),
                    dbkey: this.view.dbkey,
                    type: "trackster",
                    vis_json: JSON.stringify(viz_config)
                }
            }).success(function (vis_info) {
                Galaxy.modal.hide();
                _this2.view.vis_id = vis_info.vis_id;
                _this2.view.has_changes = false;

                // Needed to set URL when first saving a visualization.
                window.history.pushState({}, "", vis_info.url + window.top.location.hash);
            }).error(function () {
                // show dialog
                Galaxy.modal.show({
                    title: (0, _localization2.default)("Could Not Save"),
                    body: "Could not save visualization. Please try again later.",
                    buttons: {
                        Cancel: function Cancel() {
                            Galaxy.modal.hide();
                        }
                    }
                });
            });
        }

        /**
         * Create button menu
         */

    }, {
        key: "createButtonMenu",
        value: function createButtonMenu() {
            var _this3 = this;

            var menu = _iconButton2.default.create_icon_buttons_menu([{
                icon_class: "plus-button",
                title: (0, _localization2.default)("Add tracks"),
                on_click: function on_click() {
                    _visualization2.default.select_datasets({ dbkey: _this3.view.dbkey }, function (new_tracks) {
                        _.each(new_tracks, function (track) {
                            _this3.view.add_drawable(_tracks2.default.object_from_template(track, _this3.view, _this3.view));
                        });
                    });
                }
            }, {
                icon_class: "block--plus",
                title: (0, _localization2.default)("Add group"),
                on_click: function on_click() {
                    _this3.view.add_drawable(new _tracks2.default.DrawableGroup(_this3.view, _this3.view, {
                        name: "New Group"
                    }));
                }
            }, {
                icon_class: "bookmarks",
                title: (0, _localization2.default)("Bookmarks"),
                on_click: function on_click() {
                    // HACK -- use style to determine if panel is hidden and hide/show accordingly.
                    window.force_right_panel($("div#right").css("right") == "0px" ? "hide" : "show");
                }
            }, {
                icon_class: "globe",
                title: (0, _localization2.default)("Circster"),
                on_click: function on_click() {
                    window.top.location = _this3.baseURL + "visualization/circster?id=" + _this3.view.vis_id;
                }
            }, {
                icon_class: "disk--arrow",
                title: (0, _localization2.default)("Save"),
                on_click: function on_click() {
                    _this3.save_viz();
                }
            }, {
                icon_class: "cross-circle",
                title: (0, _localization2.default)("Close"),
                on_click: function on_click() {
                    _this3.handle_unsaved_changes(_this3.view);
                }
            }], {
                tooltip_config: { placement: "bottom" }
            });

            this.buttonMenu = menu;
            return menu;
        }

        /**
         * Add bookmark.
         */

    }, {
        key: "add_bookmark",
        value: function add_bookmark(position, annotation, editable) {
            var _this4 = this;

            // Create HTML.
            var bookmarks_container = $("#right .unified-panel-body");

            var new_bookmark = $("<div/>").addClass("bookmark").appendTo(bookmarks_container);

            var position_div = $("<div/>").addClass("position").appendTo(new_bookmark);

            //position_link
            $("<a href=''/>").text(position).appendTo(position_div).click(function () {
                _this4.view.go_to(position);
                return false;
            });

            var annotation_div = $("<div/>").text(annotation).appendTo(new_bookmark);

            // If editable, enable bookmark deletion and annotation editing.
            if (editable) {
                var delete_icon_container = $("<div/>").addClass("delete-icon-container").prependTo(new_bookmark).click(function () {
                    // Remove bookmark.
                    new_bookmark.slideUp("fast");
                    new_bookmark.remove();
                    _this4.view.has_changes = true;
                    return false;
                });

                // delete_icon
                $("<a href=''/>").addClass("icon-button delete").appendTo(delete_icon_container);

                annotation_div.make_text_editable({
                    num_rows: 3,
                    use_textarea: true,
                    help_text: "Edit bookmark note"
                }).addClass("annotation");
            }

            this.view.has_changes = true;
            return new_bookmark;
        }

        /**
         * Create a complete Trackster visualization. Returns view.
         */

    }, {
        key: "create_visualization",
        value: function create_visualization(view_config, viewport_config, drawables_config, bookmarks_config, editable) {
            var _this5 = this;

            // Create view.
            this.view = new _tracks2.default.TracksterView(_.extend(view_config, { header: false }));
            this.view.editor = true;

            $.when(this.view.load_chroms_deferred).then(function (chrom_info) {
                var overview_drawable_name = null;
                // Viewport config.
                if (viewport_config) {
                    var chrom = viewport_config.chrom;
                    var start = viewport_config.start;
                    var end = viewport_config.end;
                    overview_drawable_name = viewport_config.overview;

                    if (chrom && start !== undefined && end) {
                        _this5.view.change_chrom(chrom, start, end);
                    } else {
                        // No valid viewport, so use first chromosome.
                        _this5.view.change_chrom(chrom_info[0].chrom);
                    }
                } else {
                    // No viewport, so use first chromosome.
                    _this5.view.change_chrom(chrom_info[0].chrom);
                }

                // Add drawables to view.
                if (drawables_config) {
                    // FIXME: can from_dict() be used to create view and add drawables?
                    for (var i = 0; i < drawables_config.length; i++) {
                        _this5.view.add_drawable(_tracks2.default.object_from_template(drawables_config[i], _this5.view, _this5.view));
                    }
                }

                // Set overview.
                for (var _i = 0; _i < _this5.view.drawables.length; _i++) {
                    if (_this5.view.drawables[_i].config.get_value("name") === overview_drawable_name) {
                        _this5.view.set_overview(_this5.view.drawables[_i]);
                        break;
                    }
                }

                // Load bookmarks.
                if (bookmarks_config) {
                    var bookmark;
                    for (var _i2 = 0; _i2 < bookmarks_config.length; _i2++) {
                        bookmark = bookmarks_config[_i2];
                        _this5.add_bookmark(bookmark.position, bookmark.annotation, editable);
                    }
                }

                // View has no changes as of yet.
                _this5.view.has_changes = false;
            });

            // Final initialization.
            this.set_up_router({ view: this.view });

            // TODO: This is hopefully not necessary anymore, since we're using the instance view.  Do it for compatibility for now.
            return this.view;
        }

        /**
         * Set up location router to use hashes as track browser locations.
         */

    }, {
        key: "set_up_router",
        value: function set_up_router(options) {
            new _visualization2.default.TrackBrowserRouter(options);
            Backbone.history.start();
        }

        /**
         * Set up keyboard navigation for a visualization.
         */

    }, {
        key: "init_keyboard_nav",
        value: function init_keyboard_nav(view) {
            // Keyboard navigation. Scroll ~7% of height when scrolling up/down.
            $(document).keyup(function (e) {
                // Do not navigate if arrow keys used in input element.
                if ($(e.srcElement).is(":input")) {
                    return;
                }

                // Key codes: left == 37, up == 38, right == 39, down == 40
                switch (e.which) {
                    case 37:
                        view.move_fraction(0.25);
                        break;
                    case 38:
                        // var change = Math.round(view.viewport_container.height() / 15.0);
                        view.viewport_container.scrollTop(view.viewport_container.scrollTop() - 20);
                        break;
                    case 39:
                        view.move_fraction(-0.25);
                        break;
                    case 40:
                        // var change = Math.round(view.viewport_container.height() / 15.0);
                        view.viewport_container.scrollTop(view.viewport_container.scrollTop() + 20);
                        break;
                }
            });
        }

        /**
         * Handle unsaved changes in visualization.
         */

    }, {
        key: "handle_unsaved_changes",
        value: function handle_unsaved_changes(view) {
            var _this6 = this;

            if (view.has_changes) {
                Galaxy.modal.show({
                    title: (0, _localization2.default)("Close visualization"),
                    body: "There are unsaved changes to your visualization which will be lost if you do not save them.",
                    buttons: {
                        Cancel: function Cancel() {
                            Galaxy.modal.hide();
                        },
                        "Leave without Saving": function LeaveWithoutSaving() {
                            $(window).off("beforeunload");
                            window.top.location = Galaxy.root + "visualizations/list";
                        },
                        Save: function Save() {
                            $.when(_this6.save_viz()).then(function () {
                                window.top.location = Galaxy.root + "visualizations/list";
                            });
                        }
                    }
                });
            } else {
                window.top.location = Galaxy.root + "visualizations/list";
            }
        }
    }]);

    return TracksterUI;
}(Backbone.Model);

var TracksterUIView = function (_Backbone$View) {
    _inherits(TracksterUIView, _Backbone$View);

    function TracksterUIView(options) {
        _classCallCheck(this, TracksterUIView);

        return _possibleConstructorReturn(this, (TracksterUIView.__proto__ || Object.getPrototypeOf(TracksterUIView)).call(this, options));
    }
    // initalize trackster


    _createClass(TracksterUIView, [{
        key: "initialize",
        value: function initialize() {
            var _this8 = this;

            // load ui
            this.ui = new TracksterUI(Galaxy.root);

            // create button menu
            this.ui.createButtonMenu();

            // attach the button menu to the panel header and float it left
            this.ui.buttonMenu.$el.attr("style", "float: right");

            // add to center panel
            $("#center .unified-panel-header-inner").append(this.ui.buttonMenu.$el);

            // configure right panel
            $("#right .unified-panel-title").append("Bookmarks");
            $("#right .unified-panel-icons").append("<a id='add-bookmark-button' class='icon-button menu-button plus-button' href='javascript:void(0);' title='Add bookmark'></a>");

            // resize view when showing/hiding right panel (bookmarks for now).
            $("#right-border").click(function () {
                _this8.ui.view.resize_window();
            });

            // hide right panel
            window.force_right_panel("hide");

            // check if id is available
            if (window.galaxy_config.app.id) {
                this.view_existing();
            } else if (_queryStringParsing2.default.get("dataset_id")) {
                this.choose_existing_or_new();
            } else {
                this.view_new();
            }
        }
    }, {
        key: "choose_existing_or_new",
        value: function choose_existing_or_new() {
            var _this9 = this;

            var dbkey = _queryStringParsing2.default.get("dbkey");
            var listTracksParams = {};

            var dataset_params = {
                dbkey: dbkey,
                dataset_id: _queryStringParsing2.default.get("dataset_id"),
                hda_ldda: _queryStringParsing2.default.get("hda_ldda"),
                gene_region: _queryStringParsing2.default.get("gene_region")
            };

            if (dbkey) {
                listTracksParams["f-dbkey"] = dbkey;
            }

            Galaxy.modal.show({
                title: "View Data in a New or Saved Visualization?",
                // either have text in here or have to remove body and the header/footer margins
                body: "<p><ul style='list-style: disc inside none'>You can add this dataset as:<li>a new track to one of your existing, saved Trackster sessions if they share the genome build: <b>" + (dbkey || "Not available.") + "</b></li><li>or create a new session with this dataset as the only track</li></ul></p>",
                buttons: {
                    Cancel: function Cancel() {
                        window.top.location = Galaxy.root + "visualizations/list";
                    },
                    "View in saved visualization": function ViewInSavedVisualization() {
                        _this9.view_in_saved(dataset_params);
                    },
                    "View in new visualization": function ViewInNewVisualization() {
                        _this9.view_new();
                    }
                }
            });
        }

        // view

    }, {
        key: "view_in_saved",
        value: function view_in_saved(dataset_params) {
            var _this10 = this;

            var tracks_grid = new _gridView2.default({
                url_base: Galaxy.root + "visualization/list_tracks",
                embedded: true
            });
            Galaxy.modal.show({
                title: (0, _localization2.default)("Add Data to Saved Visualization"),
                body: tracks_grid.$el,
                buttons: {
                    Cancel: function Cancel() {
                        window.top.location = Galaxy.root + "visualizations/list";
                    },
                    "Add to visualization": function AddToVisualization() {
                        $(window.parent.document).find("input[name=id]:checked").each(function () {
                            dataset_params.id = $(_this10).val();
                            window.top.location = Galaxy.root + "visualization/trackster?" + $.param(dataset_params);
                        });
                    }
                }
            });
        }

        // view

    }, {
        key: "view_existing",
        value: function view_existing() {
            // get config
            var viz_config = window.galaxy_config.app.viz_config;

            // view
            this.ui.create_visualization({
                container: $("#center .unified-panel-body"),
                name: viz_config.title,
                vis_id: viz_config.vis_id,
                dbkey: viz_config.dbkey
            }, viz_config.viewport, viz_config.tracks, viz_config.bookmarks, true);

            // initialize editor
            this.init_editor();
        }

        // view

    }, {
        key: "view_new",
        value: function view_new() {
            var _this11 = this;

            // ajax
            $.ajax({
                url: Galaxy.root + "api/genomes?chrom_info=True",
                data: {},
                error: function error() {
                    alert("Couldn't create new browser.");
                },
                success: function success(response) {
                    // show dialog
                    Galaxy.modal.show({
                        title: (0, _localization2.default)("New Visualization"),
                        body: _this11.template_view_new(response),
                        buttons: {
                            Cancel: function Cancel() {
                                window.top.location = Galaxy.root + "visualizations/list";
                            },
                            Create: function Create() {
                                _this11.create_browser($("#new-title").val(), $("#new-dbkey").val());
                                Galaxy.modal.hide();
                            }
                        }
                    });

                    // select default
                    var dbkeys_in_genomes = response.map(function (r) {
                        return r[1];
                    });
                    if (window.galaxy_config.app.default_dbkey && _.contains(dbkeys_in_genomes, window.galaxy_config.app.default_dbkey)) {
                        $("#new-dbkey").val(window.galaxy_config.app.default_dbkey);
                    }

                    // change focus
                    $("#new-title").focus();
                    $("select[name='dbkey']").select2();

                    // to support the large number of options for dbkey, enable scrolling in overlay.
                    $("#overlay").css("overflow", "auto");
                }
            });
        }

        // new browser form

    }, {
        key: "template_view_new",
        value: function template_view_new(response) {
            // start template
            var html = '<form id="new-browser-form" action="javascript:void(0);" method="post" onsubmit="return false;">' + '<div class="form-row">' + '<label for="new-title">Browser name:</label>' + '<div class="form-row-input">' + '<input type="text" name="title" id="new-title" value="Unnamed"></input>' + "</div>" + '<div style="clear: both;"></div>' + "</div>" + '<div class="form-row">' + '<label for="new-dbkey">Reference genome build (dbkey): </label>' + '<div class="form-row-input">' + '<select name="dbkey" id="new-dbkey">';

            // add dbkeys
            for (var i = 0; i < response.length; i++) {
                html += "<option value=\"" + response[i][1] + "\">" + response[i][0] + "</option>";
            }

            // close selection/finalize template
            html += "</select></div><div style=\"clear: both;\"></div></div><div class=\"form-row\">Is the build not listed here? <a href=\"" + Galaxy.root + "custom_builds\" target=\"_top\">Add a Custom Build</a></div></form>";

            // return
            return html;
        }

        // initialization for editor-specific functions.

    }, {
        key: "init_editor",
        value: function init_editor() {
            var _this12 = this;

            // set title
            $("#center .unified-panel-title").text(this.ui.view.config.get_value("name") + " (" + this.ui.view.dbkey + ")");

            // add dataset
            if (window.galaxy_config.app.add_dataset) $.ajax({
                url: Galaxy.root + "api/datasets/" + window.galaxy_config.app.add_dataset,
                data: { hda_ldda: "hda", data_type: "track_config" },
                dataType: "json",
                success: function success(track_data) {
                    _this12.ui.view.add_drawable(_tracks2.default.object_from_template(track_data, _this12.ui.view, _this12.ui.view));
                }
            });

            // initialize icons
            $("#add-bookmark-button").click(function () {
                // add new bookmark.
                var position = _this12.ui.view.chrom + ":" + _this12.ui.view.low + "-" + _this12.ui.view.high;

                var annotation = "Bookmark description";
                return _this12.ui.add_bookmark(position, annotation, true);
            });

            // initialize keyboard
            this.ui.init_keyboard_nav(this.ui.view);

            $(window).on("beforeunload", function () {
                if (_this12.ui.view.has_changes) {
                    return "There are unsaved changes to your visualization that will be lost if you leave this page.";
                }
            });
        }

        // create

    }, {
        key: "create_browser",
        value: function create_browser(name, dbkey) {
            $(document).trigger("convert_to_values");

            this.ui.create_visualization({
                container: $("#center .unified-panel-body"),
                name: name,
                dbkey: dbkey
            }, window.galaxy_config.app.gene_region);

            // initialize editor
            this.init_editor();

            // modify view setting
            this.ui.view.editor = true;
        }
    }]);

    return TracksterUIView;
}(Backbone.View);

exports.default = {
    TracksterUI: TracksterUI,
    GalaxyApp: TracksterUIView
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _localization = __webpack_require__(3);

var _localization2 = _interopRequireDefault(_localization);

var _underscore = __webpack_require__(1);

var _ = _interopRequireWildcard(_underscore);

var _backbone = __webpack_require__(2);

var Backbone = _interopRequireWildcard(_backbone);

var _visualization = __webpack_require__(16);

var _visualization2 = _interopRequireDefault(_visualization);

var _viz_views = __webpack_require__(86);

var _viz_views2 = _interopRequireDefault(_viz_views);

var _util = __webpack_require__(20);

var _util2 = _interopRequireDefault(_util);

var _slotting = __webpack_require__(87);

var _slotting2 = _interopRequireDefault(_slotting);

var _painters = __webpack_require__(88);

var _painters2 = _interopRequireDefault(_painters);

var _filters = __webpack_require__(89);

var _filters2 = _interopRequireDefault(_filters);

var _data = __webpack_require__(15);

var _data2 = _interopRequireDefault(_data);

var _tools = __webpack_require__(57);

var _tools2 = _interopRequireDefault(_tools);

var _config = __webpack_require__(36);

var _config2 = _interopRequireDefault(_config);

var _bbiDataManager = __webpack_require__(144);

var _bbiDataManager2 = _interopRequireDefault(_bbiDataManager);

__webpack_require__(22);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var extend = _.extend;

/* global $ */
/* global Galaxy */

// ---- Web UI specific utilities ----

/**
 * Dictionary of HTML element-JavaScript object relationships.
 */
// TODO: probably should separate moveable objects from containers.
var html_elt_js_obj_dict = {};

/**
 * Designates an HTML as a container.
 */
function is_container(element, obj) {
    html_elt_js_obj_dict[element.attr("id")] = obj;
}

/**
 * Make `element` moveable within parent and sibling elements by dragging `handle` (a selector).
 * Function manages JS objects, containers as well.
 *
 * @param element HTML element to make moveable
 * @param handle_class classname that denotes HTML element to be used as handle
 * @param container_selector selector used to identify possible containers for this element
 * @param element_js_obj JavaScript object associated with element; used
 */
function moveable(element, handle_class, container_selector, element_js_obj) {
    // HACK: set default value for container selector.
    container_selector = ".group";

    // Register element with its object.
    html_elt_js_obj_dict[element.attr("id")] = element_js_obj;

    // Need to provide selector for handle, not class.
    element.bind("drag", { handle: "." + handle_class, relative: true }, function (e, d) {
        var element = $(this);
        var parent = element.parent();
        // Only sorting amongst tracks and groups.
        var children = parent.children(".track,.group");
        var this_obj = html_elt_js_obj_dict[$(this).attr("id")];
        var child;
        var container;
        var top;
        var bottom;
        var i;

        //
        // Enable three types of dragging: (a) out of container; (b) into container;
        // (c) sibling movement, aka sorting. Handle in this order for simplicity.
        //

        // Handle dragging out of container.
        container = $(this).parents(container_selector);
        if (container.length !== 0) {
            top = container.position().top;
            bottom = top + container.outerHeight();
            var cur_container = html_elt_js_obj_dict[container.attr("id")];
            if (d.offsetY < top) {
                // Moving above container.
                $(this).insertBefore(container);
                cur_container.remove_drawable(this_obj);
                cur_container.container.add_drawable_before(this_obj, cur_container);
                return;
            } else if (d.offsetY > bottom) {
                // Moving below container.
                $(this).insertAfter(container);
                cur_container.remove_drawable(this_obj);
                cur_container.container.add_drawable(this_obj);
                return;
            }
        }

        // Handle dragging into container. Child is appended to container's content_div.
        container = null;
        for (i = 0; i < children.length; i++) {
            child = $(children.get(i));
            top = child.position().top;
            bottom = top + child.outerHeight();
            // Dragging into container if child is a container and offset is inside container.
            if (child.is(container_selector) && this !== child.get(0) && d.offsetY >= top && d.offsetY <= bottom) {
                // Append/prepend based on where offsetY is closest to and return.
                if (d.offsetY - top < bottom - d.offsetY) {
                    child.find(".content-div").prepend(this);
                } else {
                    child.find(".content-div").append(this);
                }
                // Update containers. Object may not have container if it is being moved quickly.
                if (this_obj.container) {
                    this_obj.container.remove_drawable(this_obj);
                }
                html_elt_js_obj_dict[child.attr("id")].add_drawable(this_obj);
                return;
            }
        }

        // Handle sibling movement, aka sorting.

        // Determine new position
        for (i = 0; i < children.length; i++) {
            child = $(children.get(i));
            if (d.offsetY < child.position().top &&
            // Cannot move tracks above reference track or intro div.
            !(child.hasClass("reference-track") || child.hasClass("intro"))) {
                break;
            }
        }

        // If not already in the right place, move. Need
        // to handle the end specially since we don't have
        // insert at index
        if (i === children.length) {
            if (this !== children.get(i - 1)) {
                parent.append(this);
                html_elt_js_obj_dict[parent.attr("id")].move_drawable(this_obj, i);
            }
        } else if (this !== children.get(i)) {
            $(this).insertBefore(children.get(i));
            // Need to adjust insert position if moving down because move is changing
            // indices of all list items.
            html_elt_js_obj_dict[parent.attr("id")].move_drawable(this_obj, d.deltaY > 0 ? i - 1 : i);
        }
    }).bind("dragstart", function () {
        $(this).addClass("dragging");
    }).bind("dragend", function () {
        $(this).removeClass("dragging");
    });
}

/**
 * Init constants & functions used throughout trackster.
 */

// Padding at the top of tracks for error messages
var ERROR_PADDING = 20;

// Maximum number of rows un a slotted track
var MAX_FEATURE_DEPTH = 100;

// Minimum width for window for squish to be used.
var MIN_SQUISH_VIEW_WIDTH = 12000;

// Number of pixels per tile, not including left offset.
var TILE_SIZE = 400;

var DEFAULT_DATA_QUERY_WAIT = 5000;

// Maximum number of chromosomes that are selectable at any one time.
var MAX_CHROMS_SELECTABLE = 100;

var DATA_ERROR = "Cannot display dataset due to an error. ";

var DATA_NOCONVERTER = "A converter for this dataset is not installed. Please check your datatypes_conf.xml file.";

var DATA_NONE = "No data for this chrom/contig.";

var DATA_PENDING = "Preparing data. This can take a while for a large dataset. " + "If the visualization is saved and closed, preparation will continue in the background.";

var DATA_CANNOT_RUN_TOOL = "Tool cannot be rerun: ";
//var DATA_LOADING = "Loading data...";
var DATA_OK = "Ready for display";
var TILE_CACHE_SIZE = 10;
//var DATA_CACHE_SIZE = 20;
//
// Numerical/continuous data display modes.
var CONTINUOUS_DATA_MODES = ["Histogram", "Line", "Filled", "Intensity"];

/**
 * Round a number to a given number of decimal places.
 */
function round(num, places) {
    // Default rounding is to integer.
    if (!places) {
        places = 0;
    }

    var val = Math.pow(10, places);
    return Math.round(num * val) / val;
}

/**
 * Check if a server can do byte range requests.
 */
function supportsByteRanges(url) {
    var promise = $.Deferred();
    $.ajax({
        type: "HEAD",
        url: url,
        beforeSend: function beforeSend(xhr) {
            xhr.setRequestHeader("Range", "bytes=0-10");
        },
        success: function success(result, status, xhr) {
            promise.resolve(xhr.status === 206);
        }
    });

    return promise;
}

/**
 * Drawables hierarchy:
 *
 * Drawable
 *    --> DrawableCollection
 *        --> DrawableGroup
 *        --> View
 *    --> Track
 */

/**
 * Base class for all drawable objects. Drawable objects are associated with a view and live in a
 * container. They have the following HTML elements and structure:
 *  <container_div>
 *      <header_div>
 *      <content_div>
 *
 * They optionally have a drag handle class.
 */
var Drawable = function Drawable(view, container, obj_dict) {
    if (!Drawable.id_counter) {
        Drawable.id_counter = 0;
    }
    this.id = Drawable.id_counter++;
    this.view = view;
    this.container = container;
    this.drag_handle_class = obj_dict.drag_handle_class;
    this.is_overview = false;
    this.action_icons = {};

    // -- Set up drawable configuration. --
    this.config = _config2.default.ConfigSettingCollection.from_models_and_saved_values(this.build_config_params(), obj_dict.prefs);

    // If there's no saved name, use object name.
    if (!this.config.get_value("name")) {
        this.config.set_value("name", obj_dict.name);
    }
    if (this.config_onchange) {
        this.config.on("change", this.config_onchange, this);
    }

    // Build Drawable HTML and behaviors.
    this.container_div = this.build_container_div();
    this.header_div = null;

    // Use opt-out policy on header creation because this is the more frequent approach:
    // unless flag set, create header.
    if (obj_dict.header !== false) {
        var header_view = new _viz_views2.default.TrackHeaderView({
            model: this,
            id: this.id
        });

        this.header_div = header_view.$el;
        this.container_div.append(this.header_div);

        // Show icons when users is hovering over track.
        var icons_div = header_view.icons_div;
        this.action_icons = header_view.action_icons;
        this.container_div.hover(function () {
            icons_div.show();
        }, function () {
            icons_div.hide();
        });
    }
};

Drawable.prototype.action_icons_def = [
// Hide/show drawable content.
// FIXME: make this an odict for easier lookup.
{
    name: "toggle_icon",
    title: "Hide/show content",
    css_class: "toggle",
    on_click_fn: function on_click_fn(drawable) {
        if (drawable.config.get_value("content_visible")) {
            drawable.action_icons.toggle_icon.addClass("toggle-expand").removeClass("toggle");
            drawable.hide_contents();
            drawable.config.set_value("content_visible", false);
        } else {
            drawable.action_icons.toggle_icon.addClass("toggle").removeClass("toggle-expand");
            drawable.config.set_value("content_visible", true);
            drawable.show_contents();
        }
    }
},
// Edit settings.
{
    name: "settings_icon",
    title: (0, _localization2.default)("Edit settings"),
    css_class: "gear",
    on_click_fn: function on_click_fn(drawable) {
        var view = new _config2.default.ConfigSettingCollectionView({
            collection: drawable.config
        });
        view.render_in_modal("Configure Track");
    }
},
// Remove.
{
    name: "remove_icon",
    title: (0, _localization2.default)("Remove"),
    css_class: "remove-icon",
    on_click_fn: function on_click_fn(drawable) {
        // Tooltip for remove icon must be deleted when drawable is deleted.
        $(".tooltip").remove();
        drawable.remove();
    }
}];

extend(Drawable.prototype, {
    config_params: [{ key: "name", label: "Name", type: "text", default_value: "" }, {
        key: "content_visible",
        type: "bool",
        default_value: true,
        hidden: true
    }],

    build_config_params: function build_config_params() {
        return this.config_params;
    },

    config_onchange: function config_onchange() {},

    init: function init() {},

    changed: function changed() {
        this.view.changed();
    },

    can_draw: function can_draw() {
        if (this.enabled && this.config.get_value("content_visible")) {
            return true;
        }

        return false;
    },

    request_draw: function request_draw() {},

    _draw: function _draw(options) {},

    /**
     * Returns representation of object in a dictionary for easy saving.
     * Use from_dict to recreate object.
     */
    to_dict: function to_dict() {},

    /**
     * Set drawable name.
     */
    set_name: function set_name(new_name) {
        this.old_name = this.config.get_value("name");
        this.config.set_value("name", new_name);
    },

    /**
     * Revert track name; currently name can be reverted only once.
     */
    revert_name: function revert_name() {
        if (this.old_name) {
            this.config.set_value("name", this.old_name);
        }
    },

    /**
     * Remove drawable (a) from its container and (b) from the HTML.
     */
    remove: function remove() {
        this.changed();

        this.container.remove_drawable(this);
        var view = this.view;
        this.container_div.hide(0, function () {
            $(this).remove();
            // HACK: is there a better way to update the view?
            view.update_intro_div();
        });
    },

    /**
     * Build drawable's container div; this is the parent div for all drawable's elements.
     */
    build_container_div: function build_container_div() {},

    /**
     * Update icons.
     */
    update_icons: function update_icons() {},

    /**
     * Hide drawable's contents.
     */
    hide_contents: function hide_contents() {},

    /**
     * Show drawable's contents.
     */
    show_contents: function show_contents() {},

    /**
     * Returns a shallow copy of all drawables in this drawable.
     */
    get_drawables: function get_drawables() {}
});

/**
 * A collection of drawable objects.
 */
var DrawableCollection = function DrawableCollection(view, container, obj_dict) {
    Drawable.call(this, view, container, obj_dict);

    // Attribute init.
    this.obj_type = obj_dict.obj_type;
    this.drawables = [];
};

extend(DrawableCollection.prototype, Drawable.prototype, {
    /**
     * Unpack and add drawables to the collection.
     */
    unpack_drawables: function unpack_drawables(drawables_array) {
        // Add drawables to collection.
        this.drawables = [];
        var drawable;
        for (var i = 0; i < drawables_array.length; i++) {
            drawable = object_from_template(drawables_array[i], this.view, this);
            this.add_drawable(drawable);
        }
    },

    /**
     * Init each drawable in the collection.
     */
    init: function init() {
        for (var i = 0; i < this.drawables.length; i++) {
            this.drawables[i].init();
        }
    },

    /**
     * Draw each drawable in the collection.
     */
    _draw: function _draw(options) {
        for (var i = 0; i < this.drawables.length; i++) {
            this.drawables[i]._draw(options);
        }
    },

    /**
     * Returns representation of object in a dictionary for easy saving.
     * Use from_dict to recreate object.
     */
    to_dict: function to_dict() {
        var dictified_drawables = [];
        for (var i = 0; i < this.drawables.length; i++) {
            dictified_drawables.push(this.drawables[i].to_dict());
        }
        return {
            prefs: this.config.to_key_value_dict(),
            obj_type: this.obj_type,
            drawables: dictified_drawables
        };
    },

    /**
     * Add a drawable to the end of the collection.
     */
    add_drawable: function add_drawable(drawable) {
        this.drawables.push(drawable);
        drawable.container = this;
        this.changed();
    },

    /**
     * Add a drawable before another drawable.
     */
    add_drawable_before: function add_drawable_before(drawable, other) {
        this.changed();
        var index = this.drawables.indexOf(other);
        if (index !== -1) {
            this.drawables.splice(index, 0, drawable);
            return true;
        }
        return false;
    },

    /**
     * Replace one drawable with another.
     */
    replace_drawable: function replace_drawable(old_drawable, new_drawable, update_html) {
        var index = this.drawables.indexOf(old_drawable);
        if (index !== -1) {
            this.drawables[index] = new_drawable;
            if (update_html) {
                old_drawable.container_div.replaceWith(new_drawable.container_div);
            }
            this.changed();
        }
        return index;
    },

    /**
     * Remove drawable from this collection.
     */
    remove_drawable: function remove_drawable(drawable) {
        var index = this.drawables.indexOf(drawable);
        if (index !== -1) {
            // Found drawable to remove.
            this.drawables.splice(index, 1);
            drawable.container = null;
            this.changed();
            return true;
        }
        return false;
    },

    /**
     * Move drawable to another location in collection.
     */
    move_drawable: function move_drawable(drawable, new_position) {
        var index = this.drawables.indexOf(drawable);
        if (index !== -1) {
            // Remove from current position:
            this.drawables.splice(index, 1);
            // insert into new position:
            this.drawables.splice(new_position, 0, drawable);
            this.changed();
            return true;
        }
        return false;
    },

    /**
     * Returns all drawables in this drawable.
     */
    get_drawables: function get_drawables() {
        return this.drawables;
    },

    /**
     * Returns all <track_type> tracks in collection.
     */
    get_tracks: function get_tracks(track_type) {
        // Initialize queue with copy of drawables array.
        var queue = this.drawables.slice(0);

        var tracks = [];
        var drawable;
        while (queue.length !== 0) {
            drawable = queue.shift();
            if (drawable instanceof track_type) {
                tracks.push(drawable);
            } else if (drawable.drawables) {
                queue = queue.concat(drawable.drawables);
            }
        }
        return tracks;
    }
});

/**
 * A group of drawables that are moveable, visible.
 */
var DrawableGroup = function DrawableGroup(view, container, obj_dict) {
    extend(obj_dict, {
        obj_type: "DrawableGroup",
        drag_handle_class: "group-handle"
    });
    DrawableCollection.call(this, view, container, obj_dict);

    // Set up containers/moving for group: register both container_div and content div as container
    // because both are used as containers (container div to recognize container, content_div to
    // store elements). Group can be moved.
    this.content_div = $("<div/>").addClass("content-div").attr("id", "group_" + this.id + "_content_div").appendTo(this.container_div);
    is_container(this.container_div, this);
    is_container(this.content_div, this);
    moveable(this.container_div, this.drag_handle_class, ".group", this);

    // Set up filters.
    this.filters_manager = new _filters2.default.FiltersManager(this);
    this.header_div.after(this.filters_manager.parent_div);

    // HACK: add div to clear floating elements.
    this.filters_manager.parent_div.after($("<div style='clear: both'/>"));

    // For saving drawables' filter managers when group-level filtering is done:
    this.saved_filters_managers = [];

    // Add drawables.
    if ("drawables" in obj_dict) {
        this.unpack_drawables(obj_dict.drawables);
    }

    // Restore filters.
    if ("filters" in obj_dict) {
        // FIXME: Pass collection_dict to DrawableCollection/Drawable will make this easier.
        var old_manager = this.filters_manager;
        this.filters_manager = new _filters2.default.FiltersManager(this, obj_dict.filters);
        old_manager.parent_div.replaceWith(this.filters_manager.parent_div);

        if (obj_dict.filters.visible) {
            this.setup_multitrack_filtering();
        }
    }
};

extend(DrawableGroup.prototype, Drawable.prototype, DrawableCollection.prototype, {
    action_icons_def: [Drawable.prototype.action_icons_def[0], Drawable.prototype.action_icons_def[1],
    // Replace group with composite track.
    {
        name: "composite_icon",
        title: (0, _localization2.default)("Show composite track"),
        css_class: "layers-stack",
        on_click_fn: function on_click_fn(group) {
            $(".tooltip").remove();
            group.show_composite_track();
        }
    },
    // Toggle track filters.
    {
        name: "filters_icon",
        title: (0, _localization2.default)("Filters"),
        css_class: "ui-slider-050",
        on_click_fn: function on_click_fn(group) {
            // TODO: update Tooltip text.
            if (group.filters_manager.visible()) {
                // Hiding filters.
                group.filters_manager.clear_filters();
                group._restore_filter_managers();
                // TODO: maintain current filter by restoring and setting saved manager's
                // settings to current/shared manager's settings.
                // TODO: need to restore filter managers when moving drawable outside group.
            } else {
                // Showing filters.
                group.setup_multitrack_filtering();
                group.request_draw({ clear_tile_cache: true });
            }
            group.filters_manager.toggle();
        }
    }, Drawable.prototype.action_icons_def[2]],

    build_container_div: function build_container_div() {
        var container_div = $("<div/>").addClass("group").attr("id", "group_" + this.id);
        if (this.container) {
            this.container.content_div.append(container_div);
        }
        return container_div;
    },

    hide_contents: function hide_contents() {
        this.tiles_div.hide();
    },

    show_contents: function show_contents() {
        // Show the contents div and labels (if present)
        this.tiles_div.show();
        // Request a redraw of the content
        this.request_draw();
    },

    update_icons: function update_icons() {
        //
        // Handle update when there are no tracks.
        //
        var num_drawables = this.drawables.length;
        if (num_drawables === 0) {
            this.action_icons.composite_icon.hide();
            this.action_icons.filters_icon.hide();
        } else if (num_drawables === 1) {
            this.action_icons.composite_icon.toggle(this.drawables[0] instanceof CompositeTrack);
            this.action_icons.filters_icon.hide();
        } else {
            // There are 2 or more tracks.

            //
            // Determine if a composite track can be created. Current criteria:
            // (a) all tracks are line tracks;
            //      OR
            // FIXME: this is not enabled right now because it has not been well tested:
            // (b) there is a single FeatureTrack.
            //

            // All tracks the same?
            var i;

            var j;
            var drawable;
            var same_type = true;
            var a_type = this.drawables[0].get_type();
            var num_feature_tracks = 0;
            for (i = 0; i < num_drawables; i++) {
                drawable = this.drawables[i];
                if (drawable.get_type() !== a_type) {
                    break;
                }
                if (drawable instanceof FeatureTrack) {
                    num_feature_tracks++;
                }
            }

            if (same_type && this.drawables[0] instanceof LineTrack) {
                this.action_icons.composite_icon.show();
            } else {
                this.action_icons.composite_icon.hide();
                $(".tooltip").remove();
            }

            //
            // Set up group-level filtering and update filter icon.
            //
            if (num_feature_tracks > 1 && num_feature_tracks === this.drawables.length) {
                //
                // Find shared filters.
                //
                var shared_filters = {};

                var filter;

                // Init shared filters with filters from first drawable.
                drawable = this.drawables[0];
                for (j = 0; j < drawable.filters_manager.filters.length; j++) {
                    filter = drawable.filters_manager.filters[j];
                    shared_filters[filter.name] = [filter];
                }

                // Create lists of shared filters.
                for (i = 1; i < this.drawables.length; i++) {
                    drawable = this.drawables[i];
                    for (j = 0; j < drawable.filters_manager.filters.length; j++) {
                        filter = drawable.filters_manager.filters[j];
                        if (filter.name in shared_filters) {
                            shared_filters[filter.name].push(filter);
                        }
                    }
                }

                //
                // Create filters for shared filters manager. Shared filters manager is group's
                // manager.
                //
                this.filters_manager.remove_all();
                for (var filter_name in shared_filters) {
                    var filters = shared_filters[filter_name];
                    if (filters.length === num_feature_tracks) {
                        // Add new filter.
                        // FIXME: can filter.copy() be used?
                        var new_filter = new _filters2.default.NumberFilter({
                            name: filters[0].name,
                            index: filters[0].index
                        });
                        this.filters_manager.add_filter(new_filter);
                    }
                }

                // Show/hide icon based on filter availability.
                this.action_icons.filters_icon.toggle(this.filters_manager.filters.length > 0);
            } else {
                this.action_icons.filters_icon.hide();
            }
        }
    },

    /**
     * Restore individual track filter managers.
     */
    _restore_filter_managers: function _restore_filter_managers() {
        for (var i = 0; i < this.drawables.length; i++) {
            this.drawables[i].filters_manager = this.saved_filters_managers[i];
        }
        this.saved_filters_managers = [];
    },

    /**
     *
     */
    setup_multitrack_filtering: function setup_multitrack_filtering() {
        // Save tracks' managers and set up shared manager.
        if (this.filters_manager.filters.length > 0) {
            // For all tracks, save current filter manager and set manager to shared (this object's) manager.
            this.saved_filters_managers = [];
            for (var i = 0; i < this.drawables.length; i++) {
                var drawable = this.drawables[i];
                this.saved_filters_managers.push(drawable.filters_manager);
                drawable.filters_manager = this.filters_manager;
            }

            //TODO: hide filters icons for each drawable?
        }
        this.filters_manager.init_filters();
    },

    /**
     * Replace group with a single composite track that includes all group's tracks.
     */
    show_composite_track: function show_composite_track() {
        var composite_track = new CompositeTrack(this.view, this.view, {
            name: this.config.get_value("name"),
            drawables: this.drawables
        });
        this.container.replace_drawable(this, composite_track, true);
        composite_track.request_draw();
    },

    add_drawable: function add_drawable(drawable) {
        DrawableCollection.prototype.add_drawable.call(this, drawable);
        this.update_icons();
    },

    remove_drawable: function remove_drawable(drawable) {
        DrawableCollection.prototype.remove_drawable.call(this, drawable);
        this.update_icons();
    },

    to_dict: function to_dict() {
        // If filters are visible, need to restore original filter managers before converting to dict.
        if (this.filters_manager.visible()) {
            this._restore_filter_managers();
        }

        var obj_dict = extend(DrawableCollection.prototype.to_dict.call(this), {
            filters: this.filters_manager.to_dict()
        });

        // Setup multi-track filtering again.
        if (this.filters_manager.visible()) {
            this.setup_multitrack_filtering();
        }

        return obj_dict;
    },

    request_draw: function request_draw(options) {
        _.each(this.drawables, function (d) {
            d.request_draw(options);
        });
    }
});

/**
 * View object manages a trackster visualization, including tracks and user interactions.
 * Events triggered:
 *      navigate: when browser view changes to a new locations
 */
var TracksterView = Backbone.View.extend({
    initialize: function initialize(obj_dict) {
        extend(obj_dict, {
            obj_type: "View"
        });
        DrawableCollection.call(this, "View", obj_dict.container, obj_dict);
        this.chrom = null;
        this.vis_id = obj_dict.vis_id;
        this.dbkey = obj_dict.dbkey;
        this.stand_alone = obj_dict.stand_alone !== undefined ? obj_dict.stand_alone : true;
        this.label_tracks = [];
        this.tracks_to_be_redrawn = [];
        this.max_low = 0;
        this.max_high = 0;
        this.zoom_factor = 3;
        this.min_separation = 30;
        this.has_changes = false;
        // Deferred object that indicates when view's chrom data has been loaded.
        this.load_chroms_deferred = null;
        this.render();
        this.canvas_manager = new _visualization2.default.CanvasManager(this.container.get(0).ownerDocument);
        this.reset();

        // Define track configuration
        this.config = _config2.default.ConfigSettingCollection.from_models_and_saved_values([{
            key: "name",
            label: "Name",
            type: "text",
            default_value: ""
        }, {
            key: "a_color",
            label: "A Color",
            type: "color",
            default_value: "#FF0000"
        }, {
            key: "c_color",
            label: "C Color",
            type: "color",
            default_value: "#00FF00"
        }, {
            key: "g_color",
            label: "G Color",
            type: "color",
            default_value: "#0000FF"
        }, {
            key: "t_color",
            label: "T Color",
            type: "color",
            default_value: "#FF00FF"
        }, {
            key: "n_color",
            label: "N Color",
            type: "color",
            default_value: "#AAAAAA"
        }], { name: obj_dict.name });
    },

    render: function render() {
        // Attribute init.
        this.requested_redraw = false;

        // Create DOM elements
        var parent_element = this.container;

        var view = this;
        // Top container for things that are fixed at the top
        this.top_container = $("<div/>").addClass("top-container").appendTo(parent_element);
        // Browser content, primary tracks are contained in here
        this.browser_content_div = $("<div/>").addClass("content").appendTo(parent_element);
        // Bottom container for things that are fixed at the bottom
        this.bottom_container = $("<div/>").addClass("bottom-container").appendTo(parent_element);
        // Label track fixed at top
        this.top_labeltrack = $("<div/>").addClass("top-labeltrack").appendTo(this.top_container);
        // Viewport for dragging tracks in center
        this.viewport_container = $("<div/>").addClass("viewport-container").attr("id", "viewport-container").appendTo(this.browser_content_div);
        // Alias viewport_container as content_div so that it matches function of DrawableCollection/Group content_div.
        this.content_div = this.viewport_container;
        is_container(this.viewport_container, view);
        // Introduction div shown when there are no tracks.
        this.intro_div = $("<div/>").addClass("intro").appendTo(this.viewport_container);
        // Add tracks button
        $("<div/>").text("Add Datasets to Visualization").addClass("action-button").appendTo(this.intro_div).click(function () {
            _visualization2.default.select_datasets({ dbkey: view.dbkey }, function (tracks) {
                _.each(tracks, function (track) {
                    view.add_drawable(object_from_template(track, view, view));
                });
            });
        });

        // Navigation at top
        this.nav_container = $("<div/>").addClass("trackster-nav-container").prependTo(this.top_container);
        this.nav = $("<div/>").addClass("trackster-nav").appendTo(this.nav_container);

        if (this.stand_alone) {
            this.nav_container.addClass("stand-alone");
            this.nav.addClass("stand-alone");
        }

        // Overview (scrollbar and overview plot) at bottom
        this.overview = $("<div/>").addClass("overview").appendTo(this.bottom_container);
        this.overview_viewport = $("<div/>").addClass("overview-viewport").appendTo(this.overview);
        this.overview_close = $("<a/>").attr("title", "Close overview").addClass("icon-button overview-close tooltip").hide().appendTo(this.overview_viewport);
        this.overview_highlight = $("<div/>").addClass("overview-highlight").hide().appendTo(this.overview_viewport);
        this.overview_box_background = $("<div/>").addClass("overview-boxback").appendTo(this.overview_viewport);
        this.overview_box = $("<div/>").addClass("overview-box").appendTo(this.overview_viewport);
        this.default_overview_height = this.overview_box.height();

        this.nav_controls = $("<div/>").addClass("nav-controls").appendTo(this.nav);
        this.chrom_select = $("<select/>").attr({ name: "chrom" }).addClass("chrom-nav").append("<option value=''>Loading</option>").appendTo(this.nav_controls);
        var submit_nav = function submit_nav(e) {
            if (e.type === "focusout" || (e.keyCode || e.which) === 13 || (e.keyCode || e.which) === 27) {
                if ((e.keyCode || e.which) !== 27) {
                    // Not escape key
                    view.go_to($(this).val());
                }
                $(this).hide();
                $(this).val("");
                view.location_span.show();
                view.chrom_select.show();
            }

            // Suppress key presses so that they do impact viz.
            e.stopPropagation();
        };
        this.nav_input = $("<input/>").addClass("nav-input").hide().bind("keyup focusout", submit_nav).appendTo(this.nav_controls);
        this.location_span = $("<span/>").addClass("location").attr("title", "Click to change location").tooltip({ placement: "bottom" }).appendTo(this.nav_controls);
        this.location_span.click(function () {
            view.location_span.hide();
            view.chrom_select.hide();
            view.nav_input.val(view.chrom + ":" + view.low + "-" + view.high);
            view.nav_input.css("display", "inline-block");
            view.nav_input.select();
            view.nav_input.focus();
            // Set up autocomplete for tracks' features.
            view.nav_input.autocomplete({
                source: function source(request, response) {
                    // Using current text, query each track and create list of all matching features.
                    var all_features = [];

                    var feature_search_deferreds = $.map(view.get_tracks(FeatureTrack), function (t) {
                        return t.data_manager.search_features(request.term).success(function (dataset_features) {
                            all_features = all_features.concat(dataset_features);
                        });
                    });

                    // When all searching is done, fill autocomplete.
                    $.when.apply($, feature_search_deferreds).done(function () {
                        response($.map(all_features, function (feature) {
                            return {
                                label: feature[0],
                                value: feature[1]
                            };
                        }));
                    });
                },
                minLength: 2
            });
        });
        if (this.vis_id !== undefined) {
            this.hidden_input = $("<input/>").attr("type", "hidden").val(this.vis_id).appendTo(this.nav_controls);
        }

        this.zo_link = $("<a/>").attr("id", "zoom-out").attr("title", "Zoom out").tooltip({ placement: "bottom" }).click(function () {
            view.zoom_out();
        }).appendTo(this.nav_controls);
        this.zi_link = $("<a/>").attr("id", "zoom-in").attr("title", "Zoom in").tooltip({ placement: "bottom" }).click(function () {
            view.zoom_in();
        }).appendTo(this.nav_controls);

        // Get initial set of chroms.
        this.load_chroms_deferred = this.load_chroms({ low: 0 });
        this.chrom_select.bind("change", function () {
            view.change_chrom(view.chrom_select.val());
        });

        /*
        this.browser_content_div.bind("mousewheel", function( e, delta ) {
            if (Math.abs(delta) < 0.5) {
                return;
            }
            if (delta > 0) {
                view.zoom_in(e.pageX, this.viewport_container);
            } else {
                view.zoom_out();
            }
            e.preventDefault();
        });
        */

        // Blur tool/filter inputs when user clicks on content div.
        this.browser_content_div.click(function (e) {
            $(this).find("input").trigger("blur");
        });

        // Double clicking zooms in
        this.browser_content_div.bind("dblclick", function (e) {
            view.zoom_in(e.pageX, this.viewport_container);
        });

        // Dragging the overview box (~ horizontal scroll bar)
        this.overview_box.bind("dragstart", function (e, d) {
            this.current_x = d.offsetX;
        }).bind("drag", function (e, d) {
            var delta = d.offsetX - this.current_x;
            this.current_x = d.offsetX;
            var delta_chrom = Math.round(delta / view.viewport_container.width() * (view.max_high - view.max_low));
            view.move_delta(-delta_chrom);
        });

        this.overview_close.click(function () {
            view.reset_overview();
        });

        // Dragging in the viewport scrolls
        this.viewport_container.bind("draginit", function (e, d) {
            // Disable interaction if started in scrollbar (for webkit)
            if (e.clientX > view.viewport_container.width() - 16) {
                return false;
            }
        }).bind("dragstart", function (e, d) {
            d.original_low = view.low;
            d.current_height = e.clientY;
            d.current_x = d.offsetX;
        }).bind("drag", function (e, d) {
            var container = $(this);
            var delta = d.offsetX - d.current_x;
            var new_scroll = container.scrollTop() - (e.clientY - d.current_height);
            container.scrollTop(new_scroll);
            d.current_height = e.clientY;
            d.current_x = d.offsetX;
            var delta_chrom = Math.round(delta / view.viewport_container.width() * (view.high - view.low));
            view.move_delta(delta_chrom);
        });
        /*
        FIXME: Do not do this for now because it's too jittery. Some kind of gravity approach is
        needed here because moving left/right should be difficult.
         // Also capture mouse wheel for left/right scrolling
        }).bind( 'mousewheel', function( e, d, dx, dy ) {
            // Only handle x axis scrolling; y axis scrolling is
            // handled by the browser when the event bubbles up.
            if (dx) {
                var delta_chrom = Math.round( - dx / view.viewport_container.width() * (view.high - view.low) );
                view.move_delta( delta_chrom );
            }
        });
        */

        // Dragging in the top label track allows selecting a region to zoom in on selected region.
        this.top_labeltrack.bind("dragstart", function (e, d) {
            return $("<div/>").addClass("zoom-area").css("height", view.browser_content_div.height() + view.top_labeltrack.height() + 1).appendTo($(this));
        }).bind("drag", function (e, d) {
            $(d.proxy).css({
                left: Math.min(e.pageX, d.startX) - view.container.offset().left,
                width: Math.abs(e.pageX - d.startX)
            });

            var min = Math.min(e.pageX, d.startX) - view.container.offset().left;

            var max = Math.max(e.pageX, d.startX) - view.container.offset().left;

            var span = view.high - view.low;
            var width = view.viewport_container.width();
            view.update_location(Math.round(min / width * span) + view.low, Math.round(max / width * span) + view.low);
        }).bind("dragend", function (e, d) {
            var min = Math.min(e.pageX, d.startX);
            var max = Math.max(e.pageX, d.startX);
            var span = view.high - view.low;
            var width = view.viewport_container.width();
            var old_low = view.low;
            view.low = Math.round(min / width * span) + old_low;
            view.high = Math.round(max / width * span) + old_low;
            $(d.proxy).remove();
            view.request_redraw();
        });

        // FIXME: this is still wonky for embedded visualizations.
        /*
        // For vertical alignment, track mouse with simple line.
        var mouse_tracker_div = $('<div/>').addClass('mouse-pos').appendTo(parent_element);
         // Show tracker only when hovering over view.
        parent_element.hover(
            function() {
                mouse_tracker_div.show();
                parent_element.mousemove(function(e) {
                    mouse_tracker_div.css({
                        // -1 makes line appear next to the mouse w/o preventing mouse actions.
                        left: e.pageX - parent_element.offset().left - 1
                    });
                });
            },
            function() {
                parent_element.off('mousemove');
                mouse_tracker_div.hide();
            }
        );
        */

        this.add_label_track(new LabelTrack(this, { content_div: this.top_labeltrack }));

        $(window).bind("resize", function () {
            // Stop previous timer.
            if (this.resize_timer) {
                window.clearTimeout(this.resize_timer);
            }

            // When function activated, resize window and redraw.
            this.resize_timer = window.setTimeout(function () {
                view.resize_window();
            }, 500);
        });
        $(document).bind("redraw", function () {
            view.redraw();
        });

        this.reset();
        $(window).trigger("resize");
    },

    get_base_color: function get_base_color(base) {
        return this.config.get_value(base.toLowerCase() + "_color") || this.config.get_value("n_color");
    }
});

// FIXME: need to use this approach to enable inheritance of DrawableCollection functions.
extend(TracksterView.prototype, DrawableCollection.prototype, {
    changed: function changed() {
        this.has_changes = true;
    },

    /** Add or remove intro div depending on view state. */
    update_intro_div: function update_intro_div() {
        this.intro_div.toggle(this.drawables.length === 0);
    },

    /**
     * Triggers navigate events as needed. If there is a delay,
     * then event is triggered only after navigation has stopped.
     */
    trigger_navigate: function trigger_navigate(new_chrom, new_low, new_high, delay) {
        var _this = this;

        // Stop previous timer.
        if (this.timer) {
            window.clearTimeout(this.timer);
        }

        if (delay) {
            // To aggregate calls, use timer and only navigate once
            // location has stabilized.
            this.timer = window.setTimeout(function () {
                _this.trigger("navigate", new_chrom + ":" + new_low + "-" + new_high);
            }, 500);
        } else {
            this.trigger("navigate", new_chrom + ":" + new_low + "-" + new_high);
        }
    },

    update_location: function update_location(low, high) {
        this.location_span.text(_util2.default.commatize(low) + " - " + _util2.default.commatize(high));
        this.nav_input.val(this.chrom + ":" + _util2.default.commatize(low) + "-" + _util2.default.commatize(high));

        // Update location. Only update when there is a valid chrom; when loading vis, there may
        // not be a valid chrom.
        var chrom = this.chrom_select.val();
        if (chrom !== "") {
            this.trigger_navigate(chrom, this.low, this.high, true);
        }
    },

    /**
     * Load chrom data for the view. Returns a jQuery Deferred.
     */
    // FIXME: instead of loading chrom data, should load and store genome object.
    load_chroms: function load_chroms(url_parms) {
        var _this2 = this;

        url_parms.num = MAX_CHROMS_SELECTABLE;

        var chrom_data = $.Deferred();
        $.ajax({
            url: Galaxy.root + "api/genomes/" + this.dbkey,
            data: url_parms,
            dataType: "json",
            success: function success(result) {
                // Do nothing if could not load chroms.
                if (result.chrom_info.length === 0) {
                    return;
                }

                // Load chroms.
                if (result.reference) {
                    var ref_track = new ReferenceTrack(_this2);
                    _this2.add_label_track(ref_track);
                    _this2.reference_track = ref_track;
                }
                _this2.chrom_data = result.chrom_info;

                _this2.chrom_select.html("");
                _this2.chrom_select.append($('<option value="">Select Chrom/Contig</option>'));

                for (var i = 0, len = _this2.chrom_data.length; i < len; i++) {
                    var chrom = _this2.chrom_data[i].chrom;
                    var chrom_option = $("<option>");
                    chrom_option.text(chrom);
                    chrom_option.val(chrom);
                    _this2.chrom_select.append(chrom_option);
                }
                if (result.prev_chroms) {
                    _this2.chrom_select.append($("<option value=\"previous\">Previous " + MAX_CHROMS_SELECTABLE + "</option>"));
                }
                if (result.next_chroms) {
                    _this2.chrom_select.append($("<option value=\"next\">Next " + MAX_CHROMS_SELECTABLE + "</option>"));
                }
                _this2.chrom_start_index = result.start_index;

                chrom_data.resolve(result.chrom_info);
            },
            error: function error() {
                alert("Could not load chroms for this dbkey: " + this.dbkey);
            }
        });
        return chrom_data;
    },

    change_chrom: function change_chrom(chrom, low, high) {
        var view = this;
        // If chrom data is still loading, wait for it.
        if (!view.chrom_data) {
            view.load_chroms_deferred.then(function () {
                view.change_chrom(chrom, low, high);
            });
            return;
        }

        // Don't do anything if chrom is "None" (hackish but some browsers already have this set), or null/blank
        if (!chrom || chrom === "None") {
            return;
        }

        //
        // If user is navigating to previous/next set of chroms, load new chrom set and return.
        //
        if (chrom === "previous") {
            view.load_chroms({
                low: this.chrom_start_index - MAX_CHROMS_SELECTABLE
            });
            return;
        }
        if (chrom === "next") {
            view.load_chroms({
                low: this.chrom_start_index + MAX_CHROMS_SELECTABLE
            });
            return;
        }

        //
        // User is loading a particular chrom. Look first in current set; if not in current set, load new
        // chrom set.
        //
        var found = $.grep(view.chrom_data, function (v, i) {
            return v.chrom === chrom;
        })[0];
        if (found === undefined) {
            // Try to load chrom and then change to chrom.
            view.load_chroms({ chrom: chrom }, function () {
                view.change_chrom(chrom, low, high);
            });
            return;
        } else {
            // Switching to local chrom.
            if (chrom !== view.chrom) {
                view.chrom = chrom;
                view.chrom_select.val(view.chrom);
                view.max_high = found.len - 1; // -1 because we're using 0-based indexing.
                view.reset();

                for (var i = 0, len = view.drawables.length; i < len; i++) {
                    var drawable = view.drawables[i];
                    if (drawable.init) {
                        drawable.init();
                    }
                }
                if (view.reference_track) {
                    view.reference_track.init();
                }
            }

            // Resolve low, high.
            if (low === undefined && high === undefined) {
                // Both are undefined, so view is whole chromosome.
                view.low = 0;
                view.high = view.max_high;
            } else {
                // Low and/or high is defined.
                view.low = low !== undefined ? Math.max(low, 0) : 0;
                if (high === undefined) {
                    // Center visualization around low.
                    // HACK: max resolution is currently 30 bases.
                    view.low = Math.max(view.low - 15, 0);
                    view.high = view.low + 30;
                } else {
                    // High is defined.
                    view.high = Math.min(high, view.max_high);
                }
            }

            view.request_redraw();
        }
    },

    /**
     * Change viewing region to that denoted by string. General format of string is:
     *
     * <chrom>[ {separator}<start>[-<end>] ]
     *
     * where separator can be whitespace or a colon. Examples:
     *
     * chr22
     * chr1:100-200
     * chr7 89999
     * chr8 90000 990000
     */
    go_to: function go_to(str) {
        // Remove commas.
        str = str.replace(/,/g, "");

        // Replace colons and hyphens with space for easy parsing.
        str = str.replace(/:|-/g, " ");

        // Parse new location.
        var chrom_pos = str.split(/\s+/);

        var chrom = chrom_pos[0];
        var new_low = chrom_pos[1] ? parseInt(chrom_pos[1], 10) : undefined;
        var new_high = chrom_pos[2] ? parseInt(chrom_pos[2], 10) : undefined;

        this.change_chrom(chrom, new_low, new_high);
    },

    move_fraction: function move_fraction(fraction) {
        var view = this;
        var span = view.high - view.low;
        this.move_delta(fraction * span);
    },

    move_delta: function move_delta(delta_chrom) {
        //
        // Update low, high.
        //

        var view = this;
        var current_chrom_span = view.high - view.low;
        // Check for left and right boundaries
        if (view.low - delta_chrom < view.max_low) {
            view.low = view.max_low;
            view.high = view.max_low + current_chrom_span;
        } else if (view.high - delta_chrom > view.max_high) {
            view.high = view.max_high;
            view.low = view.max_high - current_chrom_span;
        } else {
            view.high -= delta_chrom;
            view.low -= delta_chrom;
        }

        //
        // Redraw view.
        //

        // Redraw without requesting more data immediately.
        view.request_redraw({ data_fetch: false });

        // Set up timeout to redraw with more data when moving stops.
        if (this.redraw_on_move_fn) {
            window.clearTimeout(this.redraw_on_move_fn);
        }

        this.redraw_on_move_fn = window.setTimeout(function () {
            view.request_redraw();
        }, 200);

        // Navigate.
        var chrom = view.chrom_select.val();
        this.trigger_navigate(chrom, view.low, view.high, true);
    },

    /**
     * Add a drawable to the view.
     */
    add_drawable: function add_drawable(drawable) {
        DrawableCollection.prototype.add_drawable.call(this, drawable);
        drawable.init();
        this.changed();
        this.update_intro_div();

        // When drawable config changes, mark view as changed. This
        // captures most (all?) state change that needs to be saved.
        var self = this;
        drawable.config.on("change", function () {
            self.changed();
        });
    },

    add_label_track: function add_label_track(label_track) {
        label_track.view = this;
        label_track.init();
        this.label_tracks.push(label_track);
    },

    /**
     * Remove drawable from the view.
     */
    remove_drawable: function remove_drawable(drawable, hide) {
        DrawableCollection.prototype.remove_drawable.call(this, drawable);
        if (hide) {
            var view = this;
            drawable.container_div.hide(0, function () {
                $(this).remove();
                view.update_intro_div();
            });
        }
    },

    reset: function reset() {
        this.low = this.max_low;
        this.high = this.max_high;
        this.viewport_container.find(".yaxislabel").remove();
    },

    /**
     * Request that view redraw one or more of view's drawables. If drawable is not specified,
     * all drawables are redrawn.
     */
    request_redraw: function request_redraw(options, drawable) {
        var view = this;

        var // Either redrawing a single drawable or all view's drawables.
        track_list = drawable ? [drawable] : view.drawables;

        // Add/update tracks in track list to redraw list.
        _.each(track_list, function (track) {
            var track_options = _.find(view.tracks_to_be_redrawn, function (to) {
                return to[0] === track;
            });

            if (track_options) {
                // Track already in list; update options.
                track_options[1] = options;
            } else {
                // Track not in list yet.
                view.tracks_to_be_redrawn.push([track, options]);
            }
        });

        // Set up redraw if it has not been requested since last redraw.
        if (!this.requested_redraw) {
            window.requestAnimationFrame(function () {
                view._redraw();
            });
            this.requested_redraw = true;
        }
    },

    /**
     * Redraws view and tracks.
     * NOTE: this method should never be called directly; request_redraw() should be used so
     * that requestAnimationFrame can manage redrawing.
     */
    _redraw: function _redraw() {
        // TODO: move this code to function that does location setting.

        // Clear because requested redraw is being handled now.
        this.requested_redraw = false;

        var low = this.low;
        var high = this.high;

        if (low < this.max_low) {
            low = this.max_low;
        }
        if (high > this.max_high) {
            high = this.max_high;
        }
        var span = this.high - this.low;
        if (this.high !== 0 && span < this.min_separation) {
            high = low + this.min_separation;
        }
        this.low = Math.floor(low);
        this.high = Math.ceil(high);

        this.update_location(this.low, this.high);

        // -- Drawing code --

        // Resolution is a pixel density.
        this.resolution_px_b = this.viewport_container.width() / (this.high - this.low);

        // Overview
        var left_px = this.low / (this.max_high - this.max_low) * this.overview_viewport.width() || 0;
        var width_px = (this.high - this.low) / (this.max_high - this.max_low) * this.overview_viewport.width() || 0;
        var min_width_px = 13;

        this.overview_box.css({
            left: left_px,
            width: Math.max(min_width_px, width_px)
        }).show();
        if (width_px < min_width_px) {
            this.overview_box.css("left", left_px - (min_width_px - width_px) / 2);
        }
        if (this.overview_highlight) {
            this.overview_highlight.css({
                left: left_px,
                width: width_px
            });
        }

        // Draw data tracks.
        _.each(this.tracks_to_be_redrawn, function (track_options) {
            var track = track_options[0];
            var options = track_options[1];
            if (track) {
                track._draw(options);
            }
        });
        this.tracks_to_be_redrawn = [];

        // Draw label tracks.
        _.each(this.label_tracks, function (label_track) {
            label_track._draw();
        });
    },

    zoom_in: function zoom_in(point, container) {
        if (this.max_high === 0 || this.high - this.low <= this.min_separation) {
            return;
        }
        var span = this.high - this.low;
        var cur_center = span / 2 + this.low;
        var new_half = span / this.zoom_factor / 2;
        if (point) {
            cur_center = point / this.viewport_container.width() * (this.high - this.low) + this.low;
        }
        this.low = Math.round(cur_center - new_half);
        this.high = Math.round(cur_center + new_half);

        this.changed();
        this.request_redraw();
    },

    zoom_out: function zoom_out() {
        if (this.max_high === 0) {
            return;
        }
        var span = this.high - this.low;
        var cur_center = span / 2 + this.low;
        var new_half = span * this.zoom_factor / 2;
        this.low = Math.round(cur_center - new_half);
        this.high = Math.round(cur_center + new_half);
        this.changed();
        this.request_redraw();
    },

    /** Resize viewport. Use this method if header/footer content has changed in size. */
    resize_viewport: function resize_viewport() {
        this.viewport_container.height(this.container.height() - this.top_container.height() - this.bottom_container.height());
    },

    /** Called when window is resized. */
    resize_window: function resize_window() {
        this.resize_viewport();
        this.request_redraw();
    },

    /** Show a Drawable in the overview. */
    set_overview: function set_overview(drawable) {
        if (this.overview_drawable) {
            // If drawable to be set as overview is already in overview, do nothing.
            // Otherwise, remove overview.
            if (this.overview_drawable.dataset.id === drawable.dataset.id) {
                return;
            }
            this.overview_viewport.find(".track").remove();
        }

        // Set new overview.
        var overview_drawable = drawable.copy({
            content_div: this.overview_viewport
        });

        var view = this;
        overview_drawable.header_div.hide();
        overview_drawable.is_overview = true;
        view.overview_drawable = overview_drawable;
        this.overview_drawable.postdraw_actions = function () {
            view.overview_highlight.show().height(view.overview_drawable.content_div.height());
            view.overview_viewport.height(view.overview_drawable.content_div.height() + view.overview_box.outerHeight());
            view.overview_close.show();
            view.resize_window();
        };
        view.overview_drawable.request_draw();
        this.changed();
    },

    /** Close and reset overview. */
    reset_overview: function reset_overview() {
        // Update UI.
        $(".tooltip").remove();
        this.overview_viewport.find(".track-tile").remove();
        this.overview_viewport.height(this.default_overview_height);
        this.overview_box.height(this.default_overview_height);
        this.overview_close.hide();
        this.overview_highlight.hide();
        this.resize_window();
        this.overview_drawable = null;
    }
});

/**
 * Encapsulation of a tool that users can apply to tracks/datasets.
 */
var TracksterTool = _tools2.default.Tool.extend({
    defaults: {
        track: null
    },

    initialize: function initialize(options) {
        _tools2.default.Tool.prototype.initialize.call(this, options);

        // Restore tool visibility from state; default to hidden.
        var hidden = true;
        if (options.tool_state !== undefined && options.tool_state.hidden !== undefined) {
            hidden = options.tool_state.hidden;
        }
        this.set("hidden", hidden);

        // FIXME: need to restore tool values from options.tool_state

        // HACK: remove some inputs because Trackster does yet not work with them.
        this.remove_inputs(["data", "hidden_data", "conditional"]);
    },

    state_dict: function state_dict(options) {
        return _.extend(this.get_inputs_dict(), {
            hidden: !this.is_visible()
        });
    }
});

/**
 * View renders tool parameter HTML and updates parameter value as it is changed in the HTML.
 */
var ToolParameterView = Backbone.View.extend({
    events: {
        "change :input": "update_value"
    },

    render: function render() {
        var param_div = this.$el.addClass("param-row");
        var param = this.model;

        // Param label.
        $("<div>").addClass("param-label").text(param.get("label")).appendTo(param_div);
        // Param HTML.
        var html_div = $("<div/>").addClass("param-input").html(param.get("html")).appendTo(param_div);
        // Set initial value.
        html_div.find(":input").val(param.get("value"));

        // Add to clear floating layout.
        $("<div style='clear: both;'/>").appendTo(param_div);
    },

    update_value: function update_value(update_event) {
        this.model.set_value($(update_event.target).val());
    }
});

/**
 * View for TracksterTool.
 */
var TracksterToolView = Backbone.View.extend({
    initialize: function initialize(options) {
        this.model.on("change:hidden", this.set_visible, this);
    },

    /**
     * Render tool UI.
     */
    render: function render() {
        var self = this;
        var tool = this.model;
        var parent_div = this.$el.addClass("dynamic-tool").hide();

        // Prevent div events from propogating to other elements.
        parent_div.bind("drag", function (e) {
            e.stopPropagation();
        }).click(function (e) {
            e.stopPropagation();
        }).bind("dblclick", function (e) {
            e.stopPropagation();
        }).keydown(function (e) {
            e.stopPropagation();
        });

        // Add name, inputs.
        $("<div class='tool-name'>").appendTo(parent_div).text(tool.get("name"));
        tool.get("inputs").each(function (param) {
            // Render parameter.
            var param_view = new ToolParameterView({ model: param });
            param_view.render();
            parent_div.append(param_view.$el);
        });

        // Highlight value for inputs for easy replacement.
        parent_div.find("input").click(function () {
            $(this).select();
        });

        // Add buttons for running on dataset, region.
        var run_tool_row = $("<div>").addClass("param-row").appendTo(parent_div);
        var run_on_dataset_button = $("<input type='submit'>").attr("value", "Run on complete dataset").appendTo(run_tool_row);
        var run_on_region_button = $("<input type='submit'>").attr("value", "Run on visible region").appendTo(run_tool_row);
        run_on_region_button.click(function () {
            // Run tool to create new track.
            self.run_on_region();
        });
        run_on_dataset_button.click(function () {
            self.run_on_dataset();
        });

        if (tool.is_visible()) {
            this.$el.show();
        }
    },

    /**
     * Show or hide tool depending on tool visibility state.
     */
    set_visible: function set_visible() {
        this.$el.toggle(this.model.is_visible());
    },

    /**
     * Update tool parameters.
     */
    update_params: function update_params() {
        for (var i = 0; i < this.params.length; i++) {
            this.params[i].update_value();
        }
    },

    /**
     * Run tool on dataset. Output is placed in dataset's history and no changes to viz are made.
     */
    run_on_dataset: function run_on_dataset() {
        var tool = this.model;
        this.run(
        // URL params.
        {
            target_dataset_id: this.model.get("track").dataset.id,
            action: "rerun",
            tool_id: tool.id
        }, null, function (track_data) {
            Galaxy.modal.show({
                title: tool.get("name") + " is Running",
                body: tool.get("name") + " is running on the complete dataset. Tool outputs are in dataset's history.",
                buttons: {
                    Close: function Close() {
                        Galaxy.modal.hide();
                    }
                }
            });
        });
    },

    /**
     * Run dataset on visible region. This creates a new track and sets the track's contents
     * to the tool's output.
     */
    run_on_region: function run_on_region() {
        //
        // Create track for tool's output immediately to provide user feedback.
        //
        var track = this.model.get("track");

        var tool = this.model;

        var region = new _visualization2.default.GenomeRegion({
            chrom: track.view.chrom,
            start: track.view.low,
            end: track.view.high
        });

        var url_params = {
            target_dataset_id: track.dataset.id,
            action: "rerun",
            tool_id: tool.id,
            regions: [region.toJSON()]
        };

        // Set name of track to include tool name, parameters, and region used.
        var track_name = tool.get("name") + track.tool_region_and_parameters_str(region);

        var container;

        // If track not in a group, create a group for it and add new track to group. If track
        // already in group, add track to group.
        if (track.container === track.view) {
            // Create new group.
            var group = new DrawableGroup(track.view, track.view, {
                name: track.config.get_value("name")
            });

            // Replace track with group.
            var index = track.container.replace_drawable(track, group, false);

            // Update HTML.
            // FIXME: this is ugly way to replace a track with a group -- make this easier via
            // a Drawable or DrawableCollection function.
            group.container_div.insertBefore(track.view.content_div.children()[index]);
            group.add_drawable(track);
            track.container_div.appendTo(group.content_div);
            container = group;
        } else {
            // Use current group.
            container = track.container;
        }

        // Create and init new track.
        var new_track = new track.constructor(track.view, container, {
            name: track_name,
            hda_ldda: "hda"
        });
        new_track.init_for_tool_data();
        new_track.change_mode(track.mode);
        new_track.set_filters_manager(track.filters_manager.copy(new_track));
        new_track.update_icons();
        container.add_drawable(new_track);
        new_track.tiles_div.text("Starting job.");

        // Run tool.
        this.run(url_params, new_track, function (track_data) {
            new_track.set_dataset(new _data2.default.Dataset(track_data));
            new_track.tiles_div.text("Running job.");
            new_track.init();
        });
    },

    /**
     * Run tool using a set of URL params and a success callback.
     */
    run: function run(url_params, new_track, success_callback) {
        // Run tool.
        url_params.inputs = this.model.get_inputs_dict();
        var ss_deferred = new _util2.default.ServerStateDeferred({
            ajax_settings: {
                url: Galaxy.root + "api/tools",
                data: JSON.stringify(url_params),
                dataType: "json",
                contentType: "application/json",
                type: "POST"
            },
            interval: 2000,
            success_fn: function success_fn(response) {
                return response !== "pending";
            }
        });

        // Start with this status message.
        //new_track.container_div.addClass("pending");
        //new_track.content_div.html(DATA_PENDING);

        $.when(ss_deferred.go()).then(function (response) {
            if (response === "no converter") {
                // No converter available for input datasets, so cannot run tool.
                new_track.container_div.addClass("error");
                new_track.content_div.text(DATA_NOCONVERTER);
            } else if (response.error) {
                // General error.
                new_track.container_div.addClass("error");
                new_track.content_div.text(DATA_CANNOT_RUN_TOOL + response.message);
            } else {
                // Job submitted and running.
                success_callback(response);
            }
        });
    }
});

/**
 * Generates scale values based on filter and feature's value for filter.
 */
var FilterScaler = function FilterScaler(filter, default_val) {
    _painters2.default.Scaler.call(this, default_val);
    this.filter = filter;
};

FilterScaler.prototype.gen_val = function (feature_data) {
    // If filter is not initalized yet, return default val.
    if (this.filter.high === Number.MAX_VALUE || this.filter.low === -Number.MAX_VALUE || this.filter.low === this.filter.high) {
        return this.default_val;
    }

    // Scaling value is ratio of (filter's value compared to low) to (complete filter range).
    return (parseFloat(feature_data[this.filter.index]) - this.filter.low) / (this.filter.high - this.filter.low);
};

/**
 * Tiles drawn by tracks.
 */
var Tile = function Tile(track, region, w_scale, canvas, data) {
    this.track = track;
    this.region = region;
    this.low = region.get("start");
    this.high = region.get("end");
    this.w_scale = w_scale;
    this.canvas = canvas;
    // Wrap element in div for background and to provide container for tile-specific elements.
    this.html_elt = $("<div class='track-tile'/>").append(canvas);
    this.data = data;
    this.stale = false;
};

/**
 * Perform pre-display actions.
 */
Tile.prototype.predisplay_actions = function () {};

var LineTrackTile = function LineTrackTile(track, region, w_scale, canvas, data) {
    Tile.call(this, track, region, w_scale, canvas, data);
};
LineTrackTile.prototype.predisplay_actions = function () {};

var FeatureTrackTile = function FeatureTrackTile(track, region, w_scale, canvas, data, mode, message, all_slotted, feature_mapper, incomplete_features, seq_data) {
    // Attribute init.
    Tile.call(this, track, region, w_scale, canvas, data);
    this.mode = mode;
    this.all_slotted = all_slotted;
    this.feature_mapper = feature_mapper;
    this.has_icons = false;
    this.incomplete_features = incomplete_features;
    // Features drawn based on data from other tiles.
    this.other_tiles_features_drawn = {};
    this.seq_data = seq_data;

    // Add message + action icons to tile's html.
    /*
    This does not work right now because a random set of reads is returned by the server.
    When the server can respond with more data systematically, renable these icons.
    if (message) {
        this.has_icons = true;
         var
            tile = this;
            canvas = this.html_elt.children()[0],
            message_div = $("<div/>").addClass("tile-message")
                            // -1 to account for border.
                            .css({'height': ERROR_PADDING, 'width': canvas.width}).prependTo(this.html_elt);
         // Handle message; only message currently is that only the first N elements are displayed.
        var tile_region = new visualization.GenomeRegion({
                chrom: track.view.chrom,
                start: this.low,
                end: this.high
            }),
            num_features = data.length,
            more_down_icon = $("<a/>").addClass("icon more-down")
                                .attr("title", "For speed, only the first " + num_features + " features in this region were obtained from server. Click to get more data including depth")
                                .tooltip().appendTo(message_div),
            more_across_icon = $("<a/>").addClass("icon more-across")
                                .attr("title", "For speed, only the first " + num_features + " features in this region were obtained from server. Click to get more data excluding depth")
                                .tooltip().appendTo(message_div);
         // Set up actions for icons.
        more_down_icon.click(function() {
            // Mark tile as stale, request more data, and redraw track.
            tile.stale = true;
            track.data_manager.get_more_data(tile_region, track.mode, 1 / tile.w_scale, {}, track.data_manager.DEEP_DATA_REQ);
            $(".tooltip").hide();
            track.request_draw();
        }).dblclick(function(e) {
            // Do not propogate as this would normally zoom in.
            e.stopPropagation();
        });
         more_across_icon.click(function() {
            // Mark tile as stale, request more data, and redraw track.
            tile.stale = true;
            track.data_manager.get_more_data(tile_region, track.mode, 1 / tile.w_scale, {}, track.data_manager.BROAD_DATA_REQ);
            $(".tooltip").hide();
            track.request_draw();
        }).dblclick(function(e) {
            // Do not propogate as this would normally zoom in.
            e.stopPropagation();
        });
    }
    */
};
extend(FeatureTrackTile.prototype, Tile.prototype);

/**
 * Sets up support for popups.
 */
FeatureTrackTile.prototype.predisplay_actions = function () {
    /*
    FIXME: use a canvas library to handle popups.
    //
    // Add support for popups.
    //
    var tile = this,
        popups = {};
     // Only show popups in Pack mode.
    if (tile.mode !== "Pack") { return; }
     $(this.html_elt).hover(
    function() {
        this.hovered = true;
        $(this).mousemove();
    },
    function() {
        this.hovered = false;
        // Clear popup if it is still hanging around (this is probably not needed)
        $(this).parents(".track-content").children(".overlay").children(".feature-popup").remove();
    } ).mousemove(function (e) {
        // Use the hover plugin to get a delay before showing popup
        if ( !this.hovered ) { return; }
        // Get feature data for position.
        var
            this_offset = $(this).offset(),
            offsetX = e.pageX - this_offset.left,
            offsetY = e.pageY - this_offset.top,
            feature_data = tile.feature_mapper.get_feature_data(offsetX, offsetY),
            feature_uid = (feature_data ? feature_data[0] : null);
        // Hide visible popup if not over a feature or over a different feature.
        $(this).parents(".track-content").children(".overlay").children(".feature-popup").each(function() {
            if ( !feature_uid ||
                 $(this).attr("id") !== feature_uid.toString() ) {
                $(this).remove();
            }
        });
         if (feature_data) {
            // Get or create popup.
            var popup = popups[feature_uid];
            if (!popup) {
                // Create feature's popup element.
                var feature_dict = {
                        name: feature_data[3],
                        start: feature_data[1],
                        end: feature_data[2],
                        strand: feature_data[4]
                    },
                    filters = tile.track.filters_manager.filters,
                    filter;
                 // Add filter values to feature dict.
                for (var i = 0; i < filters.length; i++) {
                    filter = filters[i];
                    feature_dict[filter.name] = feature_data[filter.index];
                }
                 // Build popup.
                popup = $("<div/>").attr("id", feature_uid).addClass("feature-popup");
                var table = $("<table/>"),
                    key, value, row;
                for (key in feature_dict) {
                    value = feature_dict[key];
                    row = $("<tr/>").appendTo(table);
                    $("<th/>").appendTo(row).text(key);
                    $("<td/>").attr("align", "left").appendTo(row)
                              .text(typeof(value) === 'number' ? round(value, 2) : value);
                }
                popup.append( $("<div class='feature-popup-inner'>").append( table ) );
                popups[feature_uid] = popup;
            }
             // Attach popup to track's overlay.
            popup.appendTo( $(this).parents(".track-content").children(".overlay") );
             // Offsets are within canvas, but popup must be positioned relative to parent element.
            // parseInt strips "px" from left, top measurements. +7 so that mouse pointer does not
            // overlap popup.
            var
                popupX = offsetX + parseInt( tile.html_elt.css("left"), 10 ) - popup.width() / 2,
                popupY = offsetY + parseInt( tile.html_elt.css("top"), 10 ) + 7;
            popup.css("left", popupX + "px").css("top", popupY + "px");
        }
        else if (!e.isPropagationStopped()) {
            // Propogate event to other tiles because overlapping tiles prevent mousemove from being
            // called on tiles under this tile.
            e.stopPropagation();
            $(this).siblings().each(function() {
                $(this).trigger(e);
            });
        }
    })
    .mouseleave(function() {
        $(this).parents(".track-content").children(".overlay").children(".feature-popup").remove();
    });
    */
};

/**
 * Tracks are objects can be added to the View.
 *
 * Track object hierarchy:
 * Track
 * -> LabelTrack
 * -> TiledTrack
 * ----> LineTrack
 * ----> ReferenceTrack
 * ----> FeatureTrack
 * -------> ReadTrack
 * ----> VariantTrack
 */
var Track = function Track(view, container, obj_dict) {
    // For now, track's container is always view.
    extend(obj_dict, {
        drag_handle_class: "draghandle"
    });
    Drawable.call(this, view, container, obj_dict);

    //
    // Attribute init.
    //

    // Set or create dataset.
    this.dataset = null;
    if (obj_dict.dataset) {
        // Dataset can be a Backbone model or a dict that can be used to create a model.
        this.dataset = obj_dict.dataset instanceof Backbone.Model ? obj_dict.dataset : new _data2.default.Dataset(obj_dict.dataset);
    }
    this.dataset_check_type = "converted_datasets_state";
    this.data_url_extra_params = {};
    this.data_query_wait = "data_query_wait" in obj_dict ? obj_dict.data_query_wait : DEFAULT_DATA_QUERY_WAIT;
    // A little ugly creating data manager right now due to transition to Backbone-based objects.
    this.data_manager = "data_manager" in obj_dict ? obj_dict.data_manager : new _visualization2.default.GenomeDataManager({
        dataset: this.dataset,
        // HACK: simulate 'genome' attributes from view for now.
        // View should eventually use Genome object.
        genome: new _visualization2.default.Genome({
            key: view.dbkey,
            chroms_info: {
                chrom_info: view.chrom_data
            }
        }),
        data_mode_compatible: this.data_and_mode_compatible,
        can_subset: this.can_subset
    });

    // Height attributes: min height, max height, and visible height.
    this.min_height_px = 16;
    this.max_height_px = 800;
    this.visible_height_px = this.config.get_value("height");

    //
    // Create content div, which is where track is displayed, and add to container if available.
    //
    this.content_div = $("<div class='track-content'>").appendTo(this.container_div);
    if (this.container) {
        this.container.content_div.append(this.container_div);
        if (!("resize" in obj_dict) || obj_dict.resize) {
            this.add_resize_handle();
        }
    }
};

extend(Track.prototype, Drawable.prototype, {
    action_icons_def: [
    // Change track mode.
    {
        name: "mode_icon",
        title: (0, _localization2.default)("Set display mode"),
        css_class: "chevron-expand",
        on_click_fn: function on_click_fn() {}
    },
    // Hide/show content.
    Drawable.prototype.action_icons_def[0],
    // Set track as overview.
    {
        name: "overview_icon",
        title: (0, _localization2.default)("Set as overview"),
        css_class: "application-dock-270",
        on_click_fn: function on_click_fn(track) {
            track.view.set_overview(track);
        }
    },
    // Edit config.
    Drawable.prototype.action_icons_def[1],
    // Toggle track filters.
    {
        name: "filters_icon",
        title: (0, _localization2.default)("Filters"),
        css_class: "ui-slider-050",
        on_click_fn: function on_click_fn(drawable) {
            // TODO: update Tooltip text.
            if (drawable.filters_manager.visible()) {
                drawable.filters_manager.clear_filters();
            } else {
                drawable.filters_manager.init_filters();
            }
            drawable.filters_manager.toggle();
        }
    },
    // Toggle track tool.
    {
        name: "tools_icon",
        title: (0, _localization2.default)("Tool"),
        css_class: "hammer",
        on_click_fn: function on_click_fn(track) {
            // TODO: update Tooltip text.

            track.tool.toggle();

            // Update track name.
            if (track.tool.is_visible()) {
                track.set_name(track.config.get_value("name") + track.tool_region_and_parameters_str());
            } else {
                track.revert_name();
            }
            // HACK: name change modifies icon placement, which leaves tooltip incorrectly placed.
            $(".tooltip").remove();
        }
    },
    // Go to parameter exploration visualization.
    {
        name: "param_space_viz_icon",
        title: (0, _localization2.default)("Tool parameter space visualization"),
        css_class: "arrow-split",
        on_click_fn: function on_click_fn(track) {
            var html = "\n                    <strong>Tool</strong>:" + track.tool.get("name") + "<br/>\n                    <strong>Dataset</strong>:" + track.config.get_value("name") + "<br/>\n                    <strong>Region(s)</strong>:\n                        <select name=\"regions\">\n                            <option value=\"cur\">current viewing area</option>\n                            <option value=\"bookmarks\">bookmarks</option>\n                            <option value=\"both\">current viewing area and bookmarks</option>\n                        </select>\n                    ";

            var cancel_fn = function cancel_fn() {
                Galaxy.modal.hide();
                $(window).unbind("keypress.check_enter_esc");
            };

            var ok_fn = function ok_fn() {
                var regions_to_use = $('select[name="regions"] option:selected').val();
                var regions;
                var view_region = new _visualization2.default.GenomeRegion({
                    chrom: undefined.view.chrom,
                    start: undefined.view.low,
                    end: undefined.view.high
                });
                var bookmarked_regions = _.map($(".bookmark"), function (elt) {
                    return new _visualization2.default.GenomeRegion({
                        from_str: $(elt).children(".position").text()
                    });
                });

                // Get regions for visualization.
                if (regions_to_use === "cur") {
                    // Use only current region.
                    regions = [view_region];
                } else if (regions_to_use === "bookmarks") {
                    // Use only bookmarks.
                    regions = bookmarked_regions;
                } else {
                    // Use both current region and bookmarks.
                    regions = [view_region].concat(bookmarked_regions);
                }

                Galaxy.modal.hide();

                // Go to visualization.
                window.top.location.href = Galaxy.root + "visualization/sweepster?" + $.param({
                    dataset_id: track.dataset.id,
                    hda_ldda: track.dataset.get("hda_ldda"),
                    regions: JSON.stringify(new Backbone.Collection(regions).toJSON())
                });
            };

            /*
             * TODO: Re-enable this when functional.
            var check_enter_esc = e => {
                if ((e.keyCode || e.which) === 27) {
                    // Escape key
                    cancel_fn();
                } else if ((e.keyCode || e.which) === 13) {
                    // Enter key
                    ok_fn();
                }
            };
            */

            // show dialog
            Galaxy.modal.show({
                title: "Visualize tool parameter space and output from different parameter settings?",
                body: html,
                buttons: { No: cancel_fn, Yes: ok_fn }
            });
        }
    },
    // Remove track.
    Drawable.prototype.action_icons_def[2]],

    can_draw: function can_draw() {
        return this.dataset && Drawable.prototype.can_draw.call(this);
    },

    build_container_div: function build_container_div() {
        return $("<div/>").addClass("track").attr("id", "track_" + this.id);
    },

    /**
     * Set track's dataset.
     */
    set_dataset: function set_dataset(dataset) {
        this.dataset = dataset;
        this.data_manager.set("dataset", dataset);
    },

    /**
     * Action to take during resize.
     */
    on_resize: function on_resize() {
        this.request_draw({ clear_tile_cache: true });
    },

    /**
     * Add resizing handle to drawable's container_div.
     */
    add_resize_handle: function add_resize_handle() {
        var track = this;
        var in_handle = false;
        var in_drag = false;
        var drag_control = $("<div class='track-resize'>");
        // Control shows on hover over track, stays while dragging
        $(track.container_div).hover(function () {
            if (track.config.get_value("content_visible")) {
                in_handle = true;
                drag_control.show();
            }
        }, function () {
            in_handle = false;
            if (!in_drag) {
                drag_control.hide();
            }
        });
        // Update height and force redraw of current view while dragging,
        // clear cache to force redraw of other tiles.
        drag_control.hide().bind("dragstart", function (e, d) {
            in_drag = true;
            d.original_height = $(track.content_div).height();
        }).bind("drag", function (e, d) {
            var new_height = Math.min(Math.max(d.original_height + d.deltaY, track.min_height_px), track.max_height_px);
            $(track.tiles_div).css("height", new_height);
            track.visible_height_px = track.max_height_px === new_height ? 0 : new_height;
            track.on_resize();
        }).bind("dragend", function (e, d) {
            track.tile_cache.clear();
            in_drag = false;
            if (!in_handle) {
                drag_control.hide();
            }
            track.config.set_value("height", track.visible_height_px);
            track.changed();
        }).appendTo(track.container_div);
    },

    /**
     * Hide any elements that are part of the tracks contents area. Should
     * remove as approprite, the track will be redrawn by show_contents.
     */
    hide_contents: function hide_contents() {
        // Hide tiles.
        this.tiles_div.hide();
        // Hide any y axis labels (common to several track types)
        this.container_div.find(".yaxislabel, .track-resize").hide();
    },

    show_contents: function show_contents() {
        // Show the contents div and labels (if present)
        this.tiles_div.show();
        this.container_div.find(".yaxislabel, .track-resize").show();
        // Request a redraw of the content
        this.request_draw();
    },

    /**
     * Returns track type.
     */
    get_type: function get_type() {
        // Order is important: start with most-specific classes and go up the track hierarchy.
        if (this instanceof LabelTrack) {
            return "LabelTrack";
        } else if (this instanceof ReferenceTrack) {
            return "ReferenceTrack";
        } else if (this instanceof LineTrack) {
            return "LineTrack";
        } else if (this instanceof ReadTrack) {
            return "ReadTrack";
        } else if (this instanceof VariantTrack) {
            return "VariantTrack";
        } else if (this instanceof CompositeTrack) {
            return "CompositeTrack";
        } else if (this instanceof FeatureTrack) {
            return "FeatureTrack";
        }
        return "";
    },

    /**
     * Remove visualization content and display message.
     */
    show_message: function show_message(msg_html) {
        this.tiles_div.remove();
        return $("<span/>").addClass("message").html(msg_html).appendTo(this.content_div);
    },

    /**
     * Initialize and draw the track.
     */
    init: function init(retry) {
        // FIXME: track should have a 'state' attribute that is checked on load; this state attribute should be
        // used in this function to determine what action(s) to take.

        var track = this;
        track.enabled = false;
        track.tile_cache.clear();
        track.data_manager.clear();
        /*
        if (!track.content_div.text()) {
            track.content_div.text(DATA_LOADING);
        }
        */
        // Remove old track content (e.g. tiles, messages).
        track.content_div.children().remove();
        track.container_div.removeClass("nodata error pending");

        track.tiles_div = $("<div/>").addClass("tiles").appendTo(track.content_div);

        //
        // Tracks with no dataset id are handled differently.
        // FIXME: is this really necessary?
        //
        if (!track.dataset.id) {
            return;
        }

        // Get dataset state; if state is fine, enable and draw track. Otherwise, show message
        // about track status.
        var init_deferred = $.Deferred();

        var params = {
            hda_ldda: track.dataset.get("hda_ldda"),
            data_type: this.dataset_check_type,
            chrom: track.view.chrom,
            retry: retry
        };

        $.getJSON(this.dataset.url(), params, function (result) {
            if (!result || result === "error" || result.kind === "error") {
                // Dataset is in error state.
                track.container_div.addClass("error");
                var msg_elt = track.show_message(DATA_ERROR);
                if (result.message) {
                    // Add links to (a) show error and (b) try again.
                    msg_elt.append($("<a href='javascript:void(0);'></a>").text("View error").click(function () {
                        Galaxy.modal.show({
                            title: (0, _localization2.default)("Trackster Error"),
                            body: "<pre>" + result.message + "</pre>",
                            buttons: {
                                Close: function Close() {
                                    Galaxy.modal.hide();
                                }
                            }
                        });
                    }));
                    msg_elt.append($("<span/>").text(" "));
                    msg_elt.append($("<a href='javascript:void(0);'></a>").text("Try again").click(function () {
                        track.init(true);
                    }));
                }
            } else if (result === "no converter") {
                track.container_div.addClass("error");
                track.show_message(DATA_NOCONVERTER);
            } else if (result === "no data" || result.data !== undefined && (result.data === null || result.data.length === 0)) {
                track.container_div.addClass("nodata");
                track.show_message(DATA_NONE);
            } else if (result === "pending") {
                track.container_div.addClass("pending");
                track.show_message(DATA_PENDING);
                //$("<img/>").attr("src", image_path + "/yui/rel_interstitial_loading.gif").appendTo(track.tiles_div);
                window.setTimeout(function () {
                    track.init();
                }, track.data_query_wait);
            } else if (result === "data" || result.status === "data") {
                if (result.valid_chroms) {
                    track.valid_chroms = result.valid_chroms;
                    track.update_icons();
                }
                track.tiles_div.text(DATA_OK);
                if (track.view.chrom) {
                    track.tiles_div.text("");
                    track.tiles_div.css("height", track.visible_height_px + "px");
                    track.enabled = true;
                    // predraw_init may be asynchronous, wait for it and then draw
                    $.when.apply($, track.predraw_init()).done(function () {
                        init_deferred.resolve();
                        track.container_div.removeClass("nodata error pending");
                        track.request_draw();
                    });
                } else {
                    init_deferred.resolve();
                }
            }
        });

        this.update_icons();
        return init_deferred;
    },

    /**
     * Additional initialization required before drawing track for the first time.
     */
    predraw_init: function predraw_init() {
        var track = this;
        return $.getJSON(track.dataset.url(), {
            data_type: "data",
            stats: true,
            chrom: track.view.chrom,
            low: 0,
            high: track.view.max_high,
            hda_ldda: track.dataset.get("hda_ldda")
        }, function (result) {
            var data = result.data;

            // Tracks may not have stat data either because there is no data or data is not yet ready.
            if (data && data.min !== undefined && data.max !== undefined) {
                // Compute default minimum and maximum values
                var min_value = data.min;

                var max_value = data.max;
                // If mean and sd are present, use them to compute a ~95% window
                // but only if it would shrink the range on one side
                min_value = Math.floor(Math.min(0, Math.max(min_value, data.mean - 2 * data.sd)));
                max_value = Math.ceil(Math.max(0, Math.min(max_value, data.mean + 2 * data.sd)));
                // Update config, prefs
                track.config.set_default_value("min_value", min_value);
                track.config.set_default_value("max_value", max_value);
                track.config.set_value("min_value", min_value);
                track.config.set_value("max_value", max_value);
            }
        });
    },

    /**
     * Returns all drawables in this drawable.
     */
    get_drawables: function get_drawables() {
        return this;
    }
});

var TiledTrack = function TiledTrack(view, container, obj_dict) {
    Track.call(this, view, container, obj_dict);

    var track = this;

    // Make track moveable.
    moveable(track.container_div, track.drag_handle_class, ".group", track);

    // Attribute init.
    this.filters_manager = new _filters2.default.FiltersManager(this, "filters" in obj_dict ? obj_dict.filters : null);
    // HACK: set filters manager for data manager.
    // FIXME: prolly need function to set filters and update data_manager reference.
    this.data_manager.set("filters_manager", this.filters_manager);
    this.filters_available = false;
    this.tool = obj_dict.tool ? new TracksterTool(_.extend(obj_dict.tool, {
        track: this,
        tool_state: obj_dict.tool_state
    })) : null;
    this.tile_cache = new _visualization2.default.Cache(TILE_CACHE_SIZE);
    this.left_offset = 0;

    if (this.header_div) {
        //
        // Setup filters.
        //
        this.set_filters_manager(this.filters_manager);

        //
        // Create dynamic tool view.
        //
        if (this.tool) {
            var tool_view = new TracksterToolView({ model: this.tool });
            tool_view.render();
            this.dynamic_tool_div = tool_view.$el;
            this.header_div.after(this.dynamic_tool_div);
        }
    }

    // Add tiles_div, overlay_div to content_div.
    this.tiles_div = $("<div/>").addClass("tiles").appendTo(this.content_div);
    if (!this.config.get_value("content_visible")) {
        this.tiles_div.hide();
    }
    this.overlay_div = $("<div/>").addClass("overlay").appendTo(this.content_div);

    if (obj_dict.mode) {
        this.change_mode(obj_dict.mode);
    }
};
extend(TiledTrack.prototype, Drawable.prototype, Track.prototype, {
    action_icons_def: Track.prototype.action_icons_def.concat([
    // Show more rows when all features are not slotted.
    {
        name: "show_more_rows_icon",
        title: "To minimize track height, not all feature rows are displayed. Click to display more rows.",
        css_class: "exclamation",
        on_click_fn: function on_click_fn(track) {
            $(".tooltip").remove();
            track.slotters[track.view.resolution_px_b].max_rows *= 2;
            track.request_draw({ clear_tile_cache: true });
        },
        hide: true
    }]),

    /**
     * Returns a copy of the track. The copy uses the same data manager so that the tracks can share data.
     */
    copy: function copy(container) {
        // Create copy.
        var obj_dict = this.to_dict();
        extend(obj_dict, {
            data_manager: this.data_manager
        });
        var new_track = new this.constructor(this.view, container, obj_dict);
        // Misc. init and return.
        new_track.change_mode(this.mode);
        new_track.enabled = this.enabled;
        return new_track;
    },

    /**
     * Set filters manager + HTML elements.
     */
    set_filters_manager: function set_filters_manager(filters_manager) {
        this.filters_manager = filters_manager;
        this.header_div.after(this.filters_manager.parent_div);
    },

    /**
     * Returns representation of object in a dictionary for easy saving.
     * Use from_dict to recreate object.
     */
    to_dict: function to_dict() {
        return {
            track_type: this.get_type(),
            dataset: {
                id: this.dataset.id,
                hda_ldda: this.dataset.get("hda_ldda")
            },
            prefs: this.config.to_key_value_dict(),
            mode: this.mode,
            filters: this.filters_manager.to_dict(),
            tool_state: this.tool ? this.tool.state_dict() : {}
        };
    },

    /**
     * Set track bounds for current chromosome.
     */
    set_min_max: function set_min_max() {
        var track = this;

        return $.getJSON(track.dataset.url(), {
            data_type: "data",
            stats: true,
            chrom: track.view.chrom,
            low: 0,
            high: track.view.max_high,
            hda_ldda: track.dataset.get("hda_ldda")
        }, function (result) {
            var data = result.data;
            if (isNaN(parseFloat(track.config.get_value("min_value"))) || isNaN(parseFloat(track.config.get_value("max_value")))) {
                // Compute default minimum and maximum values
                var min_value = data.min;

                var max_value = data.max;
                // If mean and sd are present, use them to compute a ~95% window
                // but only if it would shrink the range on one side
                min_value = Math.floor(Math.min(0, Math.max(min_value, data.mean - 2 * data.sd)));
                max_value = Math.ceil(Math.max(0, Math.min(max_value, data.mean + 2 * data.sd)));
                // Update the prefs
                track.config.set_value("min_value", min_value);
                track.config.set_value("max_value", max_value);
            }
        });
    },

    /**
     * Change track's mode.
     */
    change_mode: function change_mode(new_mode) {
        var track = this;
        // TODO: is it necessary to store the mode in two places (.mode and track_config)?
        track.mode = new_mode;
        track.config.set_value("mode", new_mode);
        // FIXME: find a better way to get Auto data w/o clearing cache; using mode in the
        // data manager would work if Auto data were checked for compatibility when a specific
        // mode is chosen.
        if (new_mode === "Auto") {
            this.data_manager.clear();
        }
        track.request_draw({ clear_tile_cache: true });
        this.action_icons.mode_icon.attr("title", "Set display mode (now: " + track.mode + ")");
        return track;
    },

    /**
     * Update track's buttons.
     */
    update_icons: function update_icons() {
        var track = this;

        //
        // Show/hide filter icon.
        //
        track.action_icons.filters_icon.toggle(track.filters_available);

        //
        // Show/hide tool icons.
        //
        track.action_icons.tools_icon.toggle(track.tool !== null);
        track.action_icons.param_space_viz_icon.toggle(track.tool !== null);
    },

    /**
     * Generate a key for the tile cache.
     * TODO: create a TileCache object (like DataCache) and generate key internally.
     */
    _gen_tile_cache_key: function _gen_tile_cache_key(w_scale, tile_region) {
        return w_scale + "_" + tile_region;
    },

    /**
     * Request that track be drawn.
     */
    request_draw: function request_draw(options) {
        if (options && options.clear_tile_cache) {
            this.tile_cache.clear();
        }
        this.view.request_redraw(options, this);
    },

    /**
     * Actions to be taken before drawing.
     */
    before_draw: function before_draw() {
        // Clear because this is set when drawing.
        this.max_height_px = 0;
    },

    /**
     * Draw track. Options include:
     * -force: force a redraw rather than use cached tiles (default: false)
     * -clear_after: clear old tiles after drawing new tiles (default: false)
     * -data_fetch: fetch data if necessary (default: true)
     *
     * NOTE: this function should never be called directly; use request_draw() so that drawing
     * management can be used.
     */
    _draw: function _draw(options) {
        var _this3 = this;

        if (!this.can_draw()) {
            return;
        }

        var clear_after = options && options.clear_after;
        var low = this.view.low;
        var high = this.view.high;
        //var range = high - low;
        var width = this.view.container.width();
        var w_scale = this.view.resolution_px_b;
        var resolution = 1 / w_scale;

        // For overview, adjust high, low, resolution, and w_scale.
        if (this.is_overview) {
            low = this.view.max_low;
            high = this.view.max_high;
            w_scale = width / (this.view.max_high - this.view.max_low);
            resolution = 1 / w_scale;
        }

        this.before_draw();

        //
        // Method for moving and/or removing tiles:
        // (a) mark all elements for removal using class 'remove'
        // (b) during tile drawing/placement, remove class for elements that are moved;
        //     this occurs in show_tile()
        // (c) after drawing tiles, remove elements still marked for removal
        //     (i.e. that still have class 'remove').
        //

        // Step (a) for (re)moving tiles.
        this.tiles_div.children().addClass("remove");

        var // Tile width in bases.
        tile_width = Math.floor(TILE_SIZE * resolution);

        var // Index of first tile that overlaps visible region.
        tile_index = Math.floor(low / tile_width);

        var tile_region;
        var tile_promise;
        var tile_promises = [];
        var tiles = [];
        // Draw tiles.
        while (tile_index * tile_width < high) {
            // Get tile region.
            tile_region = new _visualization2.default.GenomeRegion({
                chrom: this.view.chrom,
                start: tile_index * tile_width,
                // Tile high cannot be larger than view.max_high, which the chromosome length.
                end: Math.min((tile_index + 1) * tile_width, this.view.max_high)
            });
            tile_promise = this.draw_helper(tile_region, w_scale, options);
            tile_promises.push(tile_promise);
            $.when(tile_promise).then(function (tile) {
                tiles.push(tile);
            });

            // Go to next tile.
            tile_index += 1;
        }

        // Step (c) for (re)moving tiles when clear_after is false.
        if (!clear_after) {
            this.tiles_div.children(".remove").removeClass("remove").remove();
        }

        // When all tiles are drawn, call post-draw actions.
        $.when.apply($, tile_promises).then(function () {
            // Step (c) for (re)moving tiles when clear_after is true:
            _this3.tiles_div.children(".remove").remove();

            // Only do postdraw actions for tiles; instances where tiles may not be drawn include:
            // (a) ReferenceTrack without sufficient resolution;
            // (b) data_fetch = false.
            tiles = _.filter(tiles, function (t) {
                return t !== null;
            });
            if (tiles.length !== 0) {
                _this3.postdraw_actions(tiles, width, w_scale, clear_after);
            }
        });
    },

    /**
     * Add a maximum/minimum label to track.
     */
    _add_yaxis_label: function _add_yaxis_label(type, on_change) {
        var _this4 = this;

        var css_class = type === "max" ? "top" : "bottom";
        var text = type === "max" ? "max" : "min";
        var pref_name = type === "max" ? "max_value" : "min_value";
        var label = this.container_div.find(".yaxislabel." + css_class);
        var value = round(this.config.get_value(pref_name), 1);

        // Default action for on_change is to redraw track.
        on_change = on_change || function () {
            _this4.request_draw({ clear_tile_cache: true });
        };

        if (label.length !== 0) {
            // Label already exists, so update value.
            label.text(value);
        } else {
            // Add label.
            label = $("<div/>").text(value).make_text_editable({
                num_cols: 12,
                on_finish: function on_finish(new_val) {
                    $(".tooltip").remove();
                    this.config.set_value(pref_name, round(new_val, 1));
                    on_change();
                },
                help_text: "Set " + text + " value"
            }).addClass("yaxislabel " + css_class).css("color", this.config.get_value("label_color"));
            this.container_div.prepend(label);
        }
    },

    /**
     * Actions to be taken after draw has been completed. Draw is completed when all tiles have been
     * drawn/fetched and shown.
     */
    postdraw_actions: function postdraw_actions(tiles, width, w_scale, clear_after) {
        var _this5 = this;

        var line_track_tiles = _.filter(tiles, function (tile) {
            return tile instanceof LineTrackTile;
        });

        //
        // Take different actions depending on whether there are LineTrack/Coverage tiles.
        //

        if (line_track_tiles.length > 0) {
            // -- Drawing in Coverage mode. --

            // Clear because this is set when drawing.
            this.max_height_px = 0;
            _.each(tiles, function (tile) {
                if (!(tile instanceof LineTrackTile)) {
                    tile.html_elt.remove();
                    _this5.draw_helper(tile.region, w_scale, {
                        force: true,
                        mode: "Coverage"
                    });
                }
            });

            this._add_yaxis_label("max");
        } else {
            // -- Drawing in non-Coverage mode. --

            // Remove Y-axis labels because there are no line track tiles.
            this.container_div.find(".yaxislabel").remove();

            //
            // If some tiles have icons, set padding of tiles without icons so features and rows align.
            //
            var icons_present = _.find(tiles, function (tile) {
                return tile.has_icons;
            });

            if (icons_present) {
                _.each(tiles, function (tile) {
                    if (!tile.has_icons) {
                        // Need to align with other tile(s) that have icons.
                        tile.html_elt.css("padding-top", ERROR_PADDING);
                    }
                });
            }
        }
    },

    /**
     * Returns appropriate display mode based on data.
     */
    get_mode: function get_mode(data) {
        return this.mode;
    },

    /**
     * Update track interface to show display mode being used.
     */
    update_auto_mode: function update_auto_mode(display_mode) {
        // FIXME: needs to be implemented.
    },

    /**
     * Returns a list of drawables to draw. Defaults to current track.
     */
    _get_drawables: function _get_drawables() {
        return [this];
    },

    /**
     * Retrieves from cache, draws, or sets up drawing for a single tile. Returns either a Tile object or a
     * jQuery.Deferred object that is fulfilled when tile can be drawn again. Options include:
     * -force: force a redraw rather than use cached tiles (default: false)
     * -data_fetch: fetch data if necessary (default: true)
     */
    draw_helper: function draw_helper(region, w_scale, options) {
        var _this6 = this;

        // Init options if necessary to avoid having to check if options defined.
        if (!options) {
            options = {};
        }

        var force = options.force;
        var mode = options.mode || this.mode;
        var resolution = 1 / w_scale;

        var drawables = this._get_drawables();
        var key = this._gen_tile_cache_key(w_scale, region);

        var is_tile = function is_tile(o) {
            return o && "track" in o;
        };

        // Check tile cache, if found show existing tile in correct position
        var tile = force ? undefined : this.tile_cache.get_elt(key);
        if (tile) {
            if (is_tile(tile)) {
                this.show_tile(tile, w_scale);
            }
            return tile;
        }

        // If not fetching data, nothing more to do because data is needed to draw tile.
        if (options.data_fetch === false) {
            return null;
        }

        // Function that returns data/Deferreds needed to draw tile.
        var get_tile_data = function get_tile_data() {
            // HACK: if display mode (mode) is in continuous data modes, data mode must be coverage to get coverage data.
            var data_mode = _.find(CONTINUOUS_DATA_MODES, function (m) {
                return m === mode;
            }) ? "Coverage" : mode;

            // Map drawable object to data needed for drawing.
            var tile_data = _.map(drawables, function (d // Get the track data/promise.
            ) {
                return d.data_manager.get_data(region, data_mode, resolution, _this6.data_url_extra_params);
            });

            // Get reference data/promise.
            if (_this6.view.reference_track) {
                tile_data.push(_this6.view.reference_track.data_manager.get_data(region, mode, resolution, _this6.view.reference_track.data_url_extra_params));
            }

            return tile_data;
        };

        //
        // When data is available, draw tile.
        //
        var tile_drawn = $.Deferred();
        this.tile_cache.set_elt(key, tile_drawn);
        $.when.apply($, get_tile_data()).then(function () {
            var tile_data = get_tile_data();
            var tracks_data = tile_data;
            var seq_data;

            // Deferreds may show up here if trying to fetch a subset of data from a superset data chunk
            // that cannot be subsetted. This may occur if the superset has a message. If there is a
            // Deferred, try again from the top. NOTE: this condition could (should?) be handled by the
            // GenomeDataManager in visualization module.
            if (_.find(tile_data, function (d) {
                return _util2.default.is_deferred(d);
            })) {
                _this6.tile_cache.set_elt(key, undefined);
                $.when(_this6.draw_helper(region, w_scale, options)).then(function (tile) {
                    tile_drawn.resolve(tile);
                });
                return;
            }

            // If sequence data is available, subset to get only data in region.
            if (_this6.view.reference_track) {
                seq_data = _this6.view.reference_track.data_manager.subset_entry(tile_data.pop(), region);
            }

            // Get drawing modes, heights for all tracks.
            var drawing_modes = [];
            var drawing_heights = [];

            _.each(drawables, function (d, i) {
                var data = tracks_data[i];
                if (d.mode === "Auto") {
                    d.mode = d.get_mode(data);
                    d.update_auto_mode(d.mode);
                }
                drawing_modes.push(d.mode);
                drawing_heights.push(d.get_canvas_height(data, d.mode, w_scale, width));
            });

            var canvas = _this6.view.canvas_manager.new_canvas();
            var tile_low = region.get("start");
            var tile_high = region.get("end");
            var width = Math.ceil((tile_high - tile_low) * w_scale) + _this6.left_offset;
            var height = _.max(drawing_heights);
            var tile;

            //
            // Draw all tracks on tile.
            //
            canvas.width = width;
            // Height is specified in options or is the height found above.
            canvas.height = options.height || height;
            var ctx = canvas.getContext("2d");
            ctx.translate(_this6.left_offset, 0);
            if (drawables.length > 1) {
                ctx.globalAlpha = 0.5;
                ctx.globalCompositeOperation = "source-over";
            }
            _.each(drawables, function (d, i) {
                tile = d.draw_tile(tracks_data[i], ctx, drawing_modes[i], region, w_scale, seq_data);
            });

            // Don't cache, show if no tile.
            if (tile !== undefined) {
                _this6.tile_cache.set_elt(key, tile);
                _this6.show_tile(tile, w_scale);
            }

            tile_drawn.resolve(tile);
        });

        return tile_drawn;
    },

    /**
     * Returns canvas height needed to display data; return value is an integer that denotes the
     * number of pixels required.
     */
    get_canvas_height: function get_canvas_height(result, mode, w_scale, canvas_width) {
        return this.visible_height_px;
    },

    /**
     * Draw line (bigwig) data onto tile.
     */
    _draw_line_track_tile: function _draw_line_track_tile(result, ctx, mode, region, w_scale) {
        // Set min/max if they are not already set.
        // FIXME: checking for different null/undefined/0 is messy; it would be nice to
        // standardize this.
        if ([undefined, null].indexOf(this.config.get_value("min_value")) !== -1) {
            this.config.set_value("min_value", 0);
        }
        if ([undefined, null, 0].indexOf(this.config.get_value("max_value")) !== -1) {
            this.config.set_value("max_value", _.max(_.map(result.data, function (d) {
                return d[1];
            })) || 0);
        }

        var canvas = ctx.canvas;

        var painter = new _painters2.default.LinePainter(result.data, region.get("start"), region.get("end"), this.config.to_key_value_dict(), mode);

        painter.draw(ctx, canvas.width, canvas.height, w_scale);

        return new LineTrackTile(this, region, w_scale, canvas, result.data);
    },

    /**
     * Draw a track tile.
     * @param result result from server
     * @param ctx canvas context to draw on
     * @param mode mode to draw in
     * @param region region to draw on tile
     * @param w_scale pixels per base
     * @param ref_seq reference sequence data
     */
    draw_tile: function draw_tile(result, ctx, mode, region, w_scale, ref_seq) {},

    /**
     * Show track tile and perform associated actions. Showing tile may actually move
     * an existing tile rather than reshowing it.
     */
    show_tile: function show_tile(tile, w_scale) {
        var tile_element = tile.html_elt;

        // -- Show/move tile element. --

        tile.predisplay_actions();

        // Position tile element based on current viewport.
        var left = Math.round((tile.low - (this.is_overview ? this.view.max_low : this.view.low)) * w_scale);
        if (this.left_offset) {
            left -= this.left_offset;
        }
        tile_element.css("left", left);

        if (tile_element.hasClass("remove")) {
            // Step (b) for (re)moving tiles. See _draw() function for description of algorithm
            // for removing tiles.
            tile_element.removeClass("remove");
        } else {
            // Showing new tile.
            this.tiles_div.append(tile_element);
        }

        // -- Update track, tile heights based on new tile. --

        tile_element.css("height", "auto");

        // Update max height based on current tile's height.
        // BUG/HACK: tile_element.height() returns a height that is always 2 pixels too big, so
        // -2 to get the correct height.
        this.max_height_px = Math.max(this.max_height_px, tile_element.height() - 2);

        // Update height for all tiles based on max height.
        tile_element.parent().children().css("height", this.max_height_px + "px");

        // Update track height based on max height and visible height.
        var track_height = this.max_height_px;
        if (this.visible_height_px !== 0) {
            track_height = Math.min(this.max_height_px, this.visible_height_px);
        }
        this.tiles_div.css("height", track_height + "px");
    },

    /**
     * Utility function that creates a label string describing the region and parameters of a track's tool.
     */
    tool_region_and_parameters_str: function tool_region_and_parameters_str(region) {
        var track = this;
        var region_str = region !== undefined ? region.toString() : "all";
        var param_str = _.values(track.tool.get_inputs_dict()).join(", ");
        return " - region=[" + region_str + "], parameters=[" + param_str + "]";
    },

    /**
     * Returns true if data is compatible with a given mode.
     */
    data_and_mode_compatible: function data_and_mode_compatible(data, mode) {
        // Only handle modes that user can set.
        if (mode === "Auto") {
            return true;
        } else if (mode === "Coverage") {
            // Histogram mode requires bigwig data.
            return data.dataset_type === "bigwig";
        } else if (data.dataset_type === "bigwig" || data.extra_info === "no_detail") {
            // All other modes--Dense, Squish, Pack--require data + details.
            return false;
        } else {
            return true;
        }
    },

    /**
     * Returns true if entry can be subsetted.
     */
    can_subset: function can_subset(entry) {
        // Do not subset entries with a message or data with no detail.
        if (entry.message || entry.extra_info === "no_detail") {
            return false;
        } else if (entry.dataset_type === "bigwig") {
            // Subset only if data is single-bp resolution.
            return entry.data[1][0] - entry.data[0][0] === 1;
        }

        return true;
    },

    /**
     * Set up track to receive tool data.
     */
    init_for_tool_data: function init_for_tool_data() {
        // Set up track to fetch raw data rather than converted data.
        this.data_manager.set("data_type", "raw_data");
        this.data_query_wait = 1000;
        this.dataset_check_type = "state";

        // FIXME: this is optional and is disabled for now because it creates
        // additional converter jobs without a clear benefit because indexing
        // such a small dataset provides little benefit.
        //
        // Set up one-time, post-draw to clear tool execution settings.
        //
        /*
        this.normal_postdraw_actions = this.postdraw_actions;
        this.postdraw_actions = function(tiles, width, w_scale, clear_after) {
            var self = this;
             // Do normal postdraw init.
            self.normal_postdraw_actions(tiles, width, w_scale, clear_after);
             // Tool-execution specific post-draw init:
             // Reset dataset check, wait time.
            self.dataset_check_type = 'converted_datasets_state';
            self.data_query_wait = DEFAULT_DATA_QUERY_WAIT;
             // Reset data URL when dataset indexing has completed/when not pending.
            var ss_deferred = new util.ServerStateDeferred({
                url: self.dataset_state_url,
                url_params: {dataset_id : self.dataset.id, hda_ldda: self.dataset.get('hda_ldda')},
                interval: self.data_query_wait,
                // Set up deferred to check dataset state until it is not pending.
                success_fn: function(result) { return result !== "pending"; }
            });
            $.when(ss_deferred.go()).then(function() {
                // Dataset is indexed, so use converted data.
                self.data_manager.set('data_type', 'data');
            });
             // Reset post-draw actions function.
            self.postdraw_actions = self.normal_postdraw_actions;
        };
        */
    }
});

var LabelTrack = function LabelTrack(view, container) {
    Track.call(this, view, container, {
        resize: false,
        header: false
    });
    this.container_div.addClass("label-track");
};
extend(LabelTrack.prototype, Track.prototype, {
    init: function init() {
        // Enable by default because there should always be data when drawing track.
        this.enabled = true;
    },

    /**
     * Additional initialization required before drawing track for the first time.
     */
    predraw_init: function predraw_init() {},

    _draw: function _draw(options) {
        var view = this.view;
        var range = view.high - view.low;

        var tickDistance = Math.floor(Math.pow(10, Math.floor(Math.log(range) / Math.log(10))));

        var position = Math.floor(view.low / tickDistance) * tickDistance;
        var width = this.view.container.width();
        var new_div = $("<div/>").addClass("label-container");
        while (position < view.high) {
            var screenPosition = Math.floor((position - view.low) / range * width);
            new_div.append($("<div/>").addClass("pos-label").text(_util2.default.commatize(position)).css({
                left: screenPosition
            }));
            position += tickDistance;
        }
        this.content_div.children(":first").remove();
        this.content_div.append(new_div);
    }
});

// FIXME: Composite tracks have code for showing composite tracks with line tracks and
// composite tracks with line + feature tracks. It's probably best if different classes
// are created for each type of composite track.

/**
 * A tiled track composed of multiple other tracks. Composite tracks only work with
 * bigwig data for now.
 */
var CompositeTrack = function CompositeTrack(view, container, obj_dict) {
    TiledTrack.call(this, view, container, obj_dict);

    // Init drawables; each drawable is a copy so that config/preferences
    // are independent of each other. Also init left offset.
    this.drawables = [];
    if ("drawables" in obj_dict) {
        var drawable;
        for (var i = 0; i < obj_dict.drawables.length; i++) {
            drawable = obj_dict.drawables[i];
            this.drawables[i] = object_from_template(drawable, view, null);

            // Track's left offset is the max of all tracks.
            if (drawable.left_offset > this.left_offset) {
                this.left_offset = drawable.left_offset;
            }
        }
        this.enabled = true;
    }

    // Set all feature tracks to use Coverage mode.
    _.each(this.drawables, function (d) {
        if (d instanceof FeatureTrack || d instanceof ReadTrack) {
            d.change_mode("Coverage");
        }
    });

    this.update_icons();

    // HACK: needed for saving object for now. Need to generalize get_type() to all Drawables and use
    // that for object type.
    this.obj_type = "CompositeTrack";
};

extend(CompositeTrack.prototype, TiledTrack.prototype, {
    display_modes: CONTINUOUS_DATA_MODES,

    build_config_params: function build_config_params() {
        return _.union(Drawable.prototype.config_params, [{
            key: "min_value",
            label: "Min Value",
            type: "float",
            default_value: undefined
        }, {
            key: "max_value",
            label: "Max Value",
            type: "float",
            default_value: undefined
        }, {
            key: "mode",
            type: "string",
            default_value: this.mode,
            hidden: true
        }, {
            key: "height",
            type: "int",
            default_value: 30,
            hidden: true
        }]);
    },

    action_icons_def: [
    // Create composite track from group's tracks.
    {
        name: "composite_icon",
        title: (0, _localization2.default)("Show individual tracks"),
        css_class: "layers-stack",
        on_click_fn: function on_click_fn(track) {
            $(".tooltip").remove();
            track.show_group();
        }
    }].concat(TiledTrack.prototype.action_icons_def),

    // HACK: CompositeTrack should inherit from DrawableCollection as well.
    /**
     * Returns representation of object in a dictionary for easy saving.
     * Use from_dict to recreate object.
     */
    to_dict: DrawableCollection.prototype.to_dict,

    add_drawable: DrawableCollection.prototype.add_drawable,

    unpack_drawables: DrawableCollection.prototype.unpack_drawables,

    config_onchange: function config_onchange() {
        this.set_name(this.config.get_value("name"));
        this.request_draw({ clear_tile_cache: true });
    },

    /**
     * Action to take during resize.
     */
    on_resize: function on_resize() {
        // Propogate visible height to other tracks.
        var visible_height = this.visible_height_px;
        _.each(this.drawables, function (d) {
            d.visible_height_px = visible_height;
        });
        Track.prototype.on_resize.call(this);
    },

    /**
     * Change mode for all tracks.
     */
    change_mode: function change_mode(new_mode) {
        TiledTrack.prototype.change_mode.call(this, new_mode);
        for (var i = 0; i < this.drawables.length; i++) {
            this.drawables[i].change_mode(new_mode);
        }
    },

    /**
     * Initialize component tracks and draw composite track when all components are initialized.
     */
    init: function init() {
        // Init components.
        var init_deferreds = [];
        for (var i = 0; i < this.drawables.length; i++) {
            init_deferreds.push(this.drawables[i].init());
        }

        // Draw composite when all tracks available.
        var track = this;
        $.when.apply($, init_deferreds).then(function () {
            track.enabled = true;
            track.request_draw();
        });
    },

    update_icons: function update_icons() {
        // For now, hide filters and tool.
        this.action_icons.filters_icon.hide();
        this.action_icons.tools_icon.hide();
        this.action_icons.param_space_viz_icon.hide();
    },

    can_draw: Drawable.prototype.can_draw,

    _get_drawables: function _get_drawables() {
        return this.drawables;
    },

    /**
     * Replace this track with group that includes individual tracks.
     */
    show_group: function show_group() {
        // Create group with individual tracks.
        var group = new DrawableGroup(this.view, this.container, {
            name: this.config.get_value("name")
        });

        var track;
        for (var i = 0; i < this.drawables.length; i++) {
            track = this.drawables[i];
            track.update_icons();
            group.add_drawable(track);
            track.container = group;
            group.content_div.append(track.container_div);
        }

        // Replace track with group.
        this.container.replace_drawable(this, group, true);
        group.request_draw({ clear_tile_cache: true });
    },

    /**
     * Actions taken before drawing.
     */
    before_draw: function before_draw() {
        // FIXME: this is needed only if there are feature tracks in the composite track.
        // TiledTrack.prototype.before_draw.call(this);

        //
        // Set min, max for tracks to be largest min, max.
        //

        // Get smallest min, biggest max.
        var min = _.min(_.map(this.drawables, function (d) {
            return d.config.get_value("min_value");
        }));

        var max = _.max(_.map(this.drawables, function (d) {
            return d.config.get_value("max_value");
        }));

        this.config.set_value("min_value", min);
        this.config.set_value("max_value", max);

        // Set all tracks to smallest min, biggest max.
        _.each(this.drawables, function (d) {
            d.config.set_value("min_value", min);
            d.config.set_value("max_value", max);
        });
    },

    /**
     * Update minimum, maximum for component tracks.
     */
    update_all_min_max: function update_all_min_max() {
        var min_value = this.config.get_value("min_value");
        var max_value = this.config.get_value("max_value");
        _.each(this.drawables, function (d) {
            d.config.set_value("min_value", min_value);
            d.config.set_value("max_value", max_value);
        });
        this.request_draw({ clear_tile_cache: true });
    },

    /**
     * Actions to be taken after draw has been completed. Draw is completed when all tiles have been
     * drawn/fetched and shown.
     */
    postdraw_actions: function postdraw_actions(tiles, width, w_scale, clear_after) {
        // All tiles must be the same height in order to draw LineTracks, so redraw tiles as needed.
        var max_height = -1;

        var i;
        for (i = 0; i < tiles.length; i++) {
            var height = tiles[i].html_elt.find("canvas").height();
            if (height > max_height) {
                max_height = height;
            }
        }

        for (i = 0; i < tiles.length; i++) {
            var tile = tiles[i];
            if (tile.html_elt.find("canvas").height() !== max_height) {
                this.draw_helper(tile.region, w_scale, {
                    force: true,
                    height: max_height
                });
                tile.html_elt.remove();
            }
        }

        // Wrap function so that it can be called without object reference.
        var track = this;

        var t = function t() {
            track.update_all_min_max();
        };

        // Add min, max labels.
        this._add_yaxis_label("min", t);
        this._add_yaxis_label("max", t);
    }
});

/**
 * Displays reference genome data.
 */
var ReferenceTrack = function ReferenceTrack(view) {
    TiledTrack.call(this, view, { content_div: view.top_labeltrack }, { resize: false, header: false });

    // Use offset to ensure that bases at tile edges are drawn.
    this.left_offset = view.canvas_manager.char_width_px;
    this.container_div.addClass("reference-track");
    this.data_url = Galaxy.root + "api/genomes/" + this.view.dbkey;
    this.data_url_extra_params = { reference: true };
    this.data_manager = new _visualization2.default.GenomeReferenceDataManager({
        data_url: this.data_url,
        can_subset: this.can_subset
    });
    this.hide_contents();
};
extend(ReferenceTrack.prototype, Drawable.prototype, TiledTrack.prototype, {
    build_config_params: function build_config_params() {
        return _.union(Drawable.prototype.config_params, [{
            key: "height",
            type: "int",
            default_value: 13,
            hidden: true
        }]);
    },

    init: function init() {
        this.data_manager.clear();
        // Enable by default because there should always be data when drawing track.
        this.enabled = true;
    },

    /**
     * Additional initialization required before drawing track for the first time.
     */
    predraw_init: function predraw_init() {},

    can_draw: Drawable.prototype.can_draw,

    /**
     * Draws and shows tile if reference data can be displayed; otherwise track is hidden.
     */
    draw_helper: function draw_helper(region, w_scale, options) {
        var cur_visible = this.tiles_div.is(":visible");
        var new_visible;
        var tile = null;
        if (w_scale > this.view.canvas_manager.char_width_px) {
            this.tiles_div.show();
            new_visible = true;
            tile = TiledTrack.prototype.draw_helper.call(this, region, w_scale, options);
        } else {
            new_visible = false;
            this.tiles_div.hide();
        }

        // NOTE: viewport resizing conceptually belongs in postdraw_actions(), but currently
        // postdraw_actions is not called when reference track not shown due to no tiles. If
        // it is moved to postdraw_actions, resize must be called each time because cannot
        // easily detect showing/hiding.

        // If showing or hiding reference track, resize viewport.
        if (cur_visible !== new_visible) {
            this.view.resize_viewport();
        }

        return tile;
    },

    can_subset: function can_subset(entry) {
        return true;
    },

    /**
     * Draw ReferenceTrack tile.
     */
    draw_tile: function draw_tile(data, ctx, mode, region, w_scale) {
        // Try to subset data.
        var subset = this.data_manager.subset_entry(data, region);

        var seq_data = subset.data;

        // Draw sequence data.
        var canvas = ctx.canvas;
        ctx.font = ctx.canvas.manager.default_font;
        ctx.textAlign = "center";
        for (var c = 0, str_len = seq_data.length; c < str_len; c++) {
            ctx.fillStyle = this.view.get_base_color(seq_data[c]);
            ctx.fillText(seq_data[c], Math.floor(c * w_scale), 10);
        }
        return new Tile(this, region, w_scale, canvas, subset);
    }
});

/**
 * Track displays continuous/numerical data. Track expects position data in 1-based format, i.e. wiggle format.
 */
var LineTrack = function LineTrack(view, container, obj_dict) {
    this.mode = "Histogram";
    TiledTrack.call(this, view, container, obj_dict);
    // Need left offset for drawing overlap near tile boundaries.
    this.left_offset = 30;

    // If server has byte-range support, use BBI data manager to read directly from the BBI file.
    // FIXME: there should be a flag to wait for this check to complete before loading the track.
    var self = this;
    $.when(supportsByteRanges(Galaxy.root + "datasets/" + this.dataset.id + "/display")).then(function (supportsByteRanges) {
        if (supportsByteRanges) {
            self.data_manager = new _bbiDataManager2.default.BBIDataManager({
                dataset: self.dataset
            });
        }
    });
};

extend(LineTrack.prototype, Drawable.prototype, TiledTrack.prototype, {
    display_modes: CONTINUOUS_DATA_MODES,

    build_config_params: function build_config_params() {
        return _.union(Drawable.prototype.config_params, [{ key: "color", label: "Color", type: "color" }, {
            key: "min_value",
            label: "Min Value",
            type: "float",
            default_value: undefined
        }, {
            key: "max_value",
            label: "Max Value",
            type: "float",
            default_value: undefined
        }, {
            key: "mode",
            type: "string",
            default_value: this.mode,
            hidden: true
        }, {
            key: "height",
            type: "int",
            default_value: 30,
            hidden: true
        }]);
    },

    config_onchange: function config_onchange() {
        this.set_name(this.config.get_value("name"));
        this.request_draw({ clear_tile_cache: true });
    },

    /**
     * Actions to be taken before drawing.
     */
    // FIXME: can the default behavior be used; right now it breaks during resize.
    before_draw: function before_draw() {},

    /**
     * Draw track tile.
     */
    draw_tile: function draw_tile(result, ctx, mode, region, w_scale) {
        return this._draw_line_track_tile(result, ctx, mode, region, w_scale);
    },

    /**
     * Subset data only if data is at single-base pair resolution.
     */
    can_subset: function can_subset(entry) {
        return entry.data[1][0] - entry.data[0][0] === 1;
    },

    /**
     * Add min, max labels.
     */
    postdraw_actions: function postdraw_actions(tiles, width, w_scale, clear_after) {
        // Add min, max labels.
        this._add_yaxis_label("max");
        this._add_yaxis_label("min");
    }
});

/**
 * Diagonal heatmap for showing interactions data.
 */
var DiagonalHeatmapTrack = function DiagonalHeatmapTrack(view, container, obj_dict) {
    this.mode = "Heatmap";
    TiledTrack.call(this, view, container, obj_dict);
};

extend(DiagonalHeatmapTrack.prototype, Drawable.prototype, TiledTrack.prototype, {
    display_modes: ["Heatmap"],

    build_config_params: function build_config_params() {
        return _.union(Drawable.prototype.config_params, [{
            key: "pos_color",
            label: "Positive Color",
            type: "color",
            default_value: "#FF8C00"
        }, {
            key: "neg_color",
            label: "Negative Color",
            type: "color",
            default_value: "#4169E1"
        }, {
            key: "min_value",
            label: "Min Value",
            type: "int",
            default_value: undefined
        }, {
            key: "max_value",
            label: "Max Value",
            type: "int",
            default_value: undefined
        }, {
            key: "mode",
            type: "string",
            default_value: this.mode,
            hidden: true
        }, {
            key: "height",
            type: "int",
            default_value: 500,
            hidden: true
        }]);
    },

    config_onchange: function config_onchange() {
        this.set_name(this.config.get_value("name"));
        this.request_draw({ clear_tile_cache: true });
    },

    /**
     * Additional initialization required before drawing track for the first time.
     */
    predraw_init: function predraw_init() {
        var track = this;
        return $.getJSON(track.dataset.url(), {
            data_type: "data",
            stats: true,
            chrom: track.view.chrom,
            low: 0,
            high: track.view.max_high,
            hda_ldda: track.dataset.get("hda_ldda")
        }, function (result) {
            // What does this do?  Is it meant to be attached to some higher scope state object?
            // var data = result.data;
        });
    },

    /**
     * Draw tile.
     */
    draw_tile: function draw_tile(result, ctx, mode, region, w_scale) {
        // Paint onto canvas.
        var canvas = ctx.canvas;

        var painter = new _painters2.default.DiagonalHeatmapPainter(result.data, region.get("start"), region.get("end"), this.config.to_key_value_dict(), mode);

        painter.draw(ctx, canvas.width, canvas.height, w_scale);

        return new Tile(this, region, w_scale, canvas, result.data);
    }
});

/**
 * A track that displays features/regions. Track expects position data in BED format, i.e. 0-based, half-open.
 */
var FeatureTrack = function FeatureTrack(view, container, obj_dict) {
    TiledTrack.call(this, view, container, obj_dict);
    this.container_div.addClass("feature-track");
    this.summary_draw_height = 30;
    this.slotters = {};
    this.start_end_dct = {};
    this.left_offset = 200;
    this.set_painter_from_config();
};

extend(FeatureTrack.prototype, Drawable.prototype, TiledTrack.prototype, {
    display_modes: ["Auto", "Coverage", "Dense", "Squish", "Pack"],

    build_config_params: function build_config_params() {
        return _.union(Drawable.prototype.config_params, [{
            key: "block_color",
            label: "Block color",
            type: "color"
        }, {
            key: "reverse_strand_color",
            label: "Antisense strand color",
            type: "color"
        }, {
            key: "label_color",
            label: "Label color",
            type: "color",
            default_value: "black"
        }, {
            key: "show_counts",
            label: "Show summary counts",
            type: "bool",
            default_value: true,
            help: "Show the number of items in each bin when drawing summary histogram"
        }, {
            key: "min_value",
            label: "Histogram minimum",
            type: "float",
            default_value: undefined,
            help: "clear value to set automatically"
        }, {
            key: "max_value",
            label: "Histogram maximum",
            type: "float",
            default_value: undefined,
            help: "clear value to set automatically"
        }, {
            key: "connector_style",
            label: "Connector style",
            type: "select",
            default_value: "fishbones",
            options: [{
                label: "Line with arrows",
                value: "fishbone"
            }, { label: "Arcs", value: "arcs" }]
        }, {
            key: "mode",
            type: "string",
            default_value: this.mode,
            hidden: true
        }, {
            key: "height",
            type: "int",
            default_value: 0,
            hidden: true
        }]);
    },

    config_onchange: function config_onchange() {
        this.set_name(this.config.get_value("name"));
        this.set_painter_from_config();
        this.request_draw({ clear_tile_cache: true });
    },

    set_painter_from_config: function set_painter_from_config() {
        if (this.config.get_value("connector_style") === "arcs") {
            this.painter = _painters2.default.ArcLinkedFeaturePainter;
        } else {
            this.painter = _painters2.default.LinkedFeaturePainter;
        }
    },

    /**
     * Actions to be taken after draw has been completed. Draw is completed when all tiles have been
     * drawn/fetched and shown.
     */
    postdraw_actions: function postdraw_actions(tiles, width, w_scale, clear_after) {
        var _this7 = this;

        TiledTrack.prototype.postdraw_actions.call(this, tiles, width, w_scale, clear_after);

        var line_track_tiles = _.filter(tiles, function (t) {
            return t instanceof LineTrackTile;
        });

        //
        // Finish drawing of features that span multiple tiles. Features that span multiple tiles
        // are labeled incomplete on the tile level because they cannot be completely drawn.
        //
        if (line_track_tiles.length === 0) {
            // Gather incomplete features together.
            var all_incomplete_features = {};
            _.each(_.pluck(tiles, "incomplete_features"), function (inc_features) {
                _.each(inc_features, function (feature) {
                    all_incomplete_features[feature[0]] = feature;
                });
            });

            // Draw incomplete features on each tile.
            _.each(tiles, function (tile) {
                // Remove features already drawn on tile originally.
                var tile_incomplete_features = _.omit(all_incomplete_features, _.map(tile.incomplete_features, function (f) {
                    return f[0];
                }));

                // Remove features already drawn on tile in past postdraw actions.
                tile_incomplete_features = _.omit(tile_incomplete_features, _.keys(tile.other_tiles_features_drawn));

                // Draw tile's incomplete features.
                if (_.size(tile_incomplete_features) !== 0) {
                    // To draw incomplete features, create new canvas, copy original canvas/tile onto new
                    // canvas, and then draw incomplete features on the new canvas.
                    var features = {
                        data: _.values(tile_incomplete_features)
                    };

                    var new_canvas = _this7.view.canvas_manager.new_canvas();
                    var new_canvas_ctx = new_canvas.getContext("2d");
                    new_canvas.height = Math.max(tile.canvas.height, _this7.get_canvas_height(features, tile.mode, tile.w_scale, 100));
                    new_canvas.width = tile.canvas.width;
                    new_canvas_ctx.drawImage(tile.canvas, 0, 0);
                    new_canvas_ctx.translate(_this7.left_offset, 0);
                    var new_tile = _this7.draw_tile(features, new_canvas_ctx, tile.mode, tile.region, tile.w_scale, tile.seq_data);
                    $(tile.canvas).replaceWith($(new_tile.canvas));
                    tile.canvas = new_canvas;
                    _.extend(tile.other_tiles_features_drawn, all_incomplete_features);
                }
            });
        }

        // If mode is Coverage and tiles do not share max, redraw tiles as necessary using new max.
        /*
        This code isn't used right now because Coverage mode uses predefined max in preferences.
        if (track.mode === "Coverage") {
            // Get global max.
            var global_max = -1;
            for (i = 0; i < tiles.length; i++) {
                var cur_max = tiles[i].max_val;
                if (cur_max > global_max) {
                    global_max = cur_max;
                }
            }
             for (i = 0; i < tiles.length; i++) {
                var tile = tiles[i];
                if (tile.max_val !== global_max) {
                    tile.html_elt.remove();
                    track.draw_helper(tile.index, w_scale, { more_tile_data: { force: true, max: global_max } } );
                }
            }
        }
        */

        //
        // Update filter attributes, UI.
        //

        // Update filtering UI.
        if (this.filters_manager) {
            var filters = this.filters_manager.filters;
            var f;
            for (f = 0; f < filters.length; f++) {
                filters[f].update_ui_elt();
            }

            // Determine if filters are available; this is based on the tiles' data.
            // Criteria for filter to be available: (a) it is applicable to tile data and (b) filter min != filter max.
            var filters_available = false;

            var example_feature;
            var filter;
            for (var i = 0; i < tiles.length; i++) {
                if (tiles[i].data.length) {
                    example_feature = tiles[i].data[0];
                    for (f = 0; f < filters.length; f++) {
                        filter = filters[f];
                        if (filter.applies_to(example_feature) && filter.min !== filter.max) {
                            filters_available = true;
                            break;
                        }
                    }
                }
            }

            // If filter availability changed, hide filter div if necessary and update menu.
            if (this.filters_available !== filters_available) {
                this.filters_available = filters_available;
                if (!this.filters_available) {
                    this.filters_manager.hide();
                }
                this.update_icons();
            }
        }

        //
        // If not all features slotted, show icon for showing more rows (slots).
        //
        if (tiles[0] instanceof FeatureTrackTile) {
            var all_slotted = true;
            for (var _i = 0; _i < tiles.length; _i++) {
                if (!tiles[_i].all_slotted) {
                    all_slotted = false;
                    break;
                }
            }
            this.action_icons.show_more_rows_icon.toggle(!all_slotted);
        } else {
            this.action_icons.show_more_rows_icon.hide();
        }
    },

    /**
     * Update track interface to show display mode being used.
     */
    update_auto_mode: function update_auto_mode(mode) {
        if (this.mode === "Auto") {
            if (mode === "no_detail") {
                mode = "feature spans";
            }
            this.action_icons.mode_icon.attr("title", "Set display mode (now: Auto/" + mode + ")");
        }
    },

    /**
     * Place features in slots for drawing (i.e. pack features).
     * this.slotters[level] is created in this method. this.slotters[level]
     * is a Slotter object. Returns the number of slots used to pack features.
     */
    incremental_slots: function incremental_slots(level, features, mode) {
        // Get/create incremental slots for level. If display mode changed,
        // need to create new slots.

        var dummy_context = this.view.canvas_manager.dummy_context;

        var slotter = this.slotters[level];
        if (!slotter || slotter.mode !== mode) {
            slotter = new _slotting2.default.FeatureSlotter(level, mode, MAX_FEATURE_DEPTH, function (x) {
                return dummy_context.measureText(x);
            });
            this.slotters[level] = slotter;
        }

        return slotter.slot_features(features);
    },

    /**
     * Returns appropriate display mode based on data.
     */
    get_mode: function get_mode(data) {
        var mode;
        // HACK: use no_detail mode track is in overview to prevent overview from being too large.
        if (data.extra_info === "no_detail" || this.is_overview) {
            mode = "no_detail";
        } else {
            // Choose b/t Squish and Pack.
            // Proxy measures for using Squish:
            // (a) error message re: limiting number of features shown;
            // (b) X number of features shown;
            // (c) size of view shown.
            // TODO: cannot use (a) and (b) because it requires coordinating mode across tiles;
            // fix this so that tiles are redrawn as necessary to use the same mode.
            //if ( (result.message && result.message.match(/^Only the first [\d]+/)) ||
            //     (result.data && result.data.length > 2000) ||
            //var data = result.data;
            // if ( (data.length && data.length < 4) ||
            //      (this.view.high - this.view.low > MIN_SQUISH_VIEW_WIDTH) ) {
            if (this.view.high - this.view.low > MIN_SQUISH_VIEW_WIDTH) {
                mode = "Squish";
            } else {
                mode = "Pack";
            }
        }
        return mode;
    },

    /**
     * Returns canvas height needed to display data; return value is an integer that denotes the
     * number of pixels required.
     */
    get_canvas_height: function get_canvas_height(result, mode, w_scale, canvas_width) {
        if (mode === "Coverage" || result.dataset_type === "bigwig") {
            return this.summary_draw_height;
        } else {
            // All other modes require slotting.
            var rows_required = this.incremental_slots(w_scale, result.data, mode);
            // HACK: use dummy painter to get required height. Painter should be extended so that get_required_height
            // works as a static function.
            var dummy_painter = new this.painter(null, null, null, this.config.to_key_value_dict(), mode);
            return Math.max(this.min_height_px, dummy_painter.get_required_height(rows_required, canvas_width));
        }
    },

    /**
     * Draw FeatureTrack tile.
     * @param result result from server
     * @param cxt canvas context to draw on
     * @param mode mode to draw in
     * @param region region to draw on tile
     * @param w_scale pixels per base
     * @param ref_seq reference sequence data
     * @param cur_tile true if drawing is occurring on a currently visible tile.
     */
    draw_tile: function draw_tile(result, ctx, mode, region, w_scale, ref_seq, cur_tile) {
        var track = this;
        var canvas = ctx.canvas;
        var tile_low = region.get("start");
        var tile_high = region.get("end");
        var left_offset = this.left_offset;

        // If data is line track data, draw line track tile.
        if (result.dataset_type === "bigwig") {
            return this._draw_line_track_tile(result, ctx, mode, region, w_scale);
        }

        // Handle row-by-row tracks

        // Preprocessing: filter features and determine whether all unfiltered features have been slotted.
        var filtered = [];

        var slots = this.slotters[w_scale].slots;
        var all_slotted = true;
        if (result.data) {
            var filters = this.filters_manager.filters;
            for (var i = 0, len = result.data.length; i < len; i++) {
                var feature = result.data[i];
                var hide_feature = false;
                var filter;
                for (var f = 0, flen = filters.length; f < flen; f++) {
                    filter = filters[f];
                    filter.update_attrs(feature);
                    if (!filter.keep(feature)) {
                        hide_feature = true;
                        break;
                    }
                }
                if (!hide_feature) {
                    // Feature visible.
                    filtered.push(feature);
                    // Set flag if not slotted.
                    if (!(feature[0] in slots)) {
                        all_slotted = false;
                    }
                }
            }
        }

        // Create painter.
        var filter_alpha_scaler = this.filters_manager.alpha_filter ? new FilterScaler(this.filters_manager.alpha_filter) : null;

        var filter_height_scaler = this.filters_manager.height_filter ? new FilterScaler(this.filters_manager.height_filter) : null;

        var painter = new this.painter(filtered, tile_low, tile_high, this.config.to_key_value_dict(), mode, filter_alpha_scaler, filter_height_scaler,
        // HACK: ref_seq only be defined for ReadTracks, and only the ReadPainter accepts that argument
        ref_seq, function (b) {
            return track.view.get_base_color(b);
        });

        var feature_mapper = null;
        var incomplete_features = null;

        ctx.fillStyle = this.config.get_value("block_color");
        ctx.font = ctx.canvas.manager.default_font;
        ctx.textAlign = "right";

        if (result.data) {
            // Draw features.
            var draw_results = painter.draw(ctx, canvas.width, canvas.height, w_scale, slots);
            feature_mapper = draw_results.feature_mapper;
            incomplete_features = draw_results.incomplete_features;
            feature_mapper.translation = -left_offset;
        }

        // If not drawing on current tile, create new tile.
        if (!cur_tile) {
            return new FeatureTrackTile(track, region, w_scale, canvas, result.data, mode, result.message, all_slotted, feature_mapper, incomplete_features, ref_seq);
        }
    }
});

/**
 * Displays variant data.
 */
var VariantTrack = function VariantTrack(view, container, obj_dict) {
    TiledTrack.call(this, view, container, obj_dict);
    this.painter = _painters2.default.VariantPainter;
    this.summary_draw_height = 30;

    // Maximum resolution is ~45 pixels/base, so use this size left offset to ensure that full
    // variant is drawn when variant is at start of tile.
    this.left_offset = 30;
};

extend(VariantTrack.prototype, Drawable.prototype, TiledTrack.prototype, {
    display_modes: ["Auto", "Coverage", "Dense", "Squish", "Pack"],

    build_config_params: function build_config_params() {
        return _.union(Drawable.prototype.config_params, [{
            key: "color",
            label: "Histogram color",
            type: "color"
        }, {
            key: "show_sample_data",
            label: "Show sample data",
            type: "bool",
            default_value: true
        }, {
            key: "show_labels",
            label: "Show summary and sample labels",
            type: "bool",
            default_value: true
        }, {
            key: "summary_height",
            label: "Locus summary height",
            type: "float",
            default_value: 20
        }, {
            key: "mode",
            type: "string",
            default_value: this.mode,
            hidden: true
        }, {
            key: "height",
            type: "int",
            default_value: 0,
            hidden: true
        }]);
    },

    config_onchange: function config_onchange() {
        this.set_name(this.config.get_value("name"));
        this.request_draw({ clear_tile_cache: true });
    },

    /**
     * Draw tile.
     */
    draw_tile: function draw_tile(result, ctx, mode, region, w_scale) {
        // Data could be coverage data or variant data.
        if (result.dataset_type === "bigwig") {
            return this._draw_line_track_tile(result, ctx, "Histogram", region, w_scale);
        } else {
            // result.dataset_type === 'variant'
            var view = this.view;

            var painter = new this.painter(result.data, region.get("start"), region.get("end"), this.config.to_key_value_dict(), mode, function (b) {
                return view.get_base_color(b);
            });

            painter.draw(ctx, ctx.canvas.width, ctx.canvas.height, w_scale);
            return new Tile(this, region, w_scale, ctx.canvas, result.data);
        }
    },

    /**
     * Returns canvas height needed to display data; return value is an integer that denotes the
     * number of pixels required.
     */
    get_canvas_height: function get_canvas_height(result, mode, w_scale, canvas_width) {
        if (result.dataset_type === "bigwig") {
            return this.summary_draw_height;
        } else {
            // HACK: sample_names is not be defined when dataset definition is fetched before
            // dataset is complete (as is done when running tools). In that case, fall back on
            // # of samples in data. This can be fixed by re-requesting dataset definition
            // in init.
            var num_samples = this.dataset.get_metadata("sample_names") ? this.dataset.get_metadata("sample_names").length : 0;
            if (num_samples === 0 && result.data.length !== 0) {
                // Sample data is separated by commas, so this computes # of samples:
                num_samples = result.data[0][7].match(/,/g);
                if (num_samples === null) {
                    num_samples = 1;
                } else {
                    num_samples = num_samples.length + 1;
                }
            }

            var dummy_painter = new this.painter(null, null, null, this.config.to_key_value_dict(), mode);
            return dummy_painter.get_required_height(num_samples);
        }
    },

    /**
     * Additional initialization required before drawing track for the first time.
     */
    predraw_init: function predraw_init() {
        var deferreds = [Track.prototype.predraw_init.call(this)];
        // FIXME: updating dataset metadata is only needed for visual analysis. Can
        // this be moved somewhere else?
        if (!this.dataset.get_metadata("sample_names")) {
            deferreds.push(this.dataset.fetch());
        }
        return deferreds;
    },

    /**
     * Actions to be taken after draw has been completed. Draw is completed when all tiles have been
     * drawn/fetched and shown.
     */
    postdraw_actions: function postdraw_actions(tiles, width, w_scale, clear_after) {
        TiledTrack.prototype.postdraw_actions.call(this, tiles, width, w_scale, clear_after);

        var line_track_tiles = _.filter(tiles, function (t) {
            return t instanceof LineTrackTile;
        });

        // Add summary/sample labels if needed and not already included.
        var sample_names = this.dataset.get_metadata("sample_names");
        if (line_track_tiles.length === 0 && this.config.get_value("show_labels") && sample_names && sample_names.length > 1) {
            var font_size;

            // Add and/or style labels.
            if (this.container_div.find(".yaxislabel.variant").length === 0) {
                // Add summary and sample labels.

                // Add summary label to middle of summary area.
                font_size = this.config.get_value("summary_height") / 2;
                this.tiles_div.prepend($("<div/>").text("Summary").addClass("yaxislabel variant top").css({
                    "font-size": font_size + "px",
                    top: (this.config.get_value("summary_height") - font_size) / 2 + "px"
                }));

                // Show sample labels.
                if (this.config.get_value("show_sample_data")) {
                    var samples_div_html = sample_names.join("<br/>");

                    this.tiles_div.prepend($("<div/>").html(samples_div_html).addClass("yaxislabel variant top sample").css({
                        top: this.config.get_value("summary_height")
                    }));
                }
            }

            // Style labels.

            // Match sample font size to mode.
            font_size = (this.mode === "Squish" ? 5 : 10) + "px";
            $(this.tiles_div).find(".sample").css({
                "font-size": font_size,
                "line-height": font_size
            });
            // Color labels to preference color.
            $(this.tiles_div).find(".yaxislabel").css("color", this.config.get_value("label_color"));
        } else {
            // Remove all labels.
            this.container_div.find(".yaxislabel.variant").remove();
        }
    }
});

/**
 * Track that displays mapped reads. Track expects position data in 1-based, closed format, i.e. SAM/BAM format.
 */
var ReadTrack = function ReadTrack(view, container, obj_dict) {
    FeatureTrack.call(this, view, container, obj_dict);
    this.painter = _painters2.default.ReadPainter;
    this.update_icons();
};

extend(ReadTrack.prototype, Drawable.prototype, TiledTrack.prototype, FeatureTrack.prototype, {
    build_config_params: function build_config_params() {
        return _.union(Drawable.prototype.config_params, [{
            key: "block_color",
            label: "Histogram color",
            type: "color"
        }, {
            key: "detail_block_color",
            label: "Sense strand block color",
            type: "color",
            default_value: "#AAAAAA"
        }, {
            key: "reverse_strand_color",
            label: "Antisense strand block color",
            type: "color",
            default_value: "#DDDDDD"
        }, {
            key: "label_color",
            label: "Label color",
            type: "color",
            default_value: "black"
        }, {
            key: "show_insertions",
            label: "Show insertions",
            type: "bool",
            default_value: false
        }, {
            key: "show_differences",
            label: "Show differences only",
            type: "bool",
            default_value: true
        }, {
            key: "show_counts",
            label: "Show summary counts",
            type: "bool",
            default_value: true
        }, {
            key: "mode",
            type: "string",
            default_value: this.mode,
            hidden: true
        }, {
            key: "min_value",
            label: "Histogram minimum",
            type: "float",
            default_value: undefined,
            help: "clear value to set automatically"
        }, {
            key: "max_value",
            label: "Histogram maximum",
            type: "float",
            default_value: undefined,
            help: "clear value to set automatically"
        }, {
            key: "height",
            type: "int",
            default_value: 0,
            hidden: true
        }]);
    },

    config_onchange: function config_onchange() {
        this.set_name(this.config.get_value("name"));
        this.request_draw({ clear_tile_cache: true });
    }
});

/**
 * Objects that can be added to a view.
 */
var addable_objects = {
    CompositeTrack: CompositeTrack,
    DrawableGroup: DrawableGroup,
    DiagonalHeatmapTrack: DiagonalHeatmapTrack,
    FeatureTrack: FeatureTrack,
    LineTrack: LineTrack,
    ReadTrack: ReadTrack,
    VariantTrack: VariantTrack,
    // For backward compatibility, map vcf track to variant.
    VcfTrack: VariantTrack
};

/**
 * Create new object from a template. A template can be either an object dictionary or an
 * object itself.
 */
var object_from_template = function object_from_template(template, view, container) {
    if ("copy" in template) {
        // Template is an object.
        return template.copy(container);
    } else {
        // Template is a dictionary.
        var drawable_type = template.obj_type;
        // For backward compatibility:
        if (!drawable_type) {
            drawable_type = template.track_type;
        }
        return new addable_objects[drawable_type](view, container, template);
    }
};

exports.default = {
    TracksterView: TracksterView,
    DrawableGroup: DrawableGroup,
    LineTrack: LineTrack,
    FeatureTrack: FeatureTrack,
    DiagonalHeatmapTrack: DiagonalHeatmapTrack,
    ReadTrack: ReadTrack,
    VariantTrack: VariantTrack,
    CompositeTrack: CompositeTrack,
    object_from_template: object_from_template
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Backbone, $, _) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _localization = __webpack_require__(3);

var _localization2 = _interopRequireDefault(_localization);

var _utils = __webpack_require__(5);

var _utils2 = _interopRequireDefault(_utils);

var _uiMisc = __webpack_require__(11);

var _uiMisc2 = _interopRequireDefault(_uiMisc);

var _uiModal = __webpack_require__(19);

var _uiModal2 = _interopRequireDefault(_uiModal);

var _toolFormBase = __webpack_require__(58);

var _toolFormBase2 = _interopRequireDefault(_toolFormBase);

var _webhooks = __webpack_require__(29);

var _webhooks2 = _interopRequireDefault(_webhooks);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var View = Backbone.View.extend({
    initialize: function initialize(options) {
        var self = this;
        this.modal = parent.Galaxy.modal || new _uiModal2.default.View();
        this.form = new _toolFormBase2.default(_utils2.default.merge({
            listen_to_history: true,
            always_refresh: false,
            buildmodel: function buildmodel(process, form) {
                var options = form.model.attributes;

                // build request url
                var build_url = "";
                var build_data = {};
                var job_id = options.job_id;
                if (job_id) {
                    build_url = Galaxy.root + "api/jobs/" + job_id + "/build_for_rerun";
                } else {
                    build_url = Galaxy.root + "api/tools/" + options.id + "/build";
                    build_data = $.extend({}, Galaxy.params);
                    build_data["tool_id"] && delete build_data["tool_id"];
                }
                options.version && (build_data["tool_version"] = options.version);

                // get initial model
                _utils2.default.get({
                    url: build_url,
                    data: build_data,
                    success: function success(data) {
                        if (!data.display) {
                            window.location = Galaxy.root;
                            return;
                        }
                        form.model.set(data);
                        self._customize(form);
                        Galaxy.emit.debug("tool-form-base::_buildModel()", "Initial tool model ready.", data);
                        process.resolve();
                    },
                    error: function error(response, status) {
                        var error_message = response && response.err_msg || "Uncaught error.";
                        if (status == 401) {
                            window.location = Galaxy.root + "user/login?" + $.param({
                                redirect: Galaxy.root + "?tool_id=" + options.id
                            });
                        } else if (form.$el.is(":empty")) {
                            form.$el.prepend(new _uiMisc2.default.Message({
                                message: error_message,
                                status: "danger",
                                persistent: true,
                                large: true
                            }).$el);
                        } else {
                            Galaxy.modal && Galaxy.modal.show({
                                title: (0, _localization2.default)("Tool request failed"),
                                body: error_message,
                                buttons: {
                                    Close: function Close() {
                                        Galaxy.modal.hide();
                                    }
                                }
                            });
                        }
                        Galaxy.emit.debug("tool-form-base::_buildModel()", "Initial tool model request failed.", response);
                        process.reject();
                    }
                });
            },
            postchange: function postchange(process, form) {
                var current_state = {
                    tool_id: form.model.get("id"),
                    tool_version: form.model.get("version"),
                    inputs: $.extend(true, {}, form.data.create())
                };
                form.wait(true);
                Galaxy.emit.debug("tool-form::postchange()", "Sending current state.", current_state);
                _utils2.default.request({
                    type: "POST",
                    url: Galaxy.root + "api/tools/" + form.model.get("id") + "/build",
                    data: current_state,
                    success: function success(data) {
                        form.update(data);
                        form.wait(false);
                        Galaxy.emit.debug("tool-form::postchange()", "Received new model.", data);
                        process.resolve();
                    },
                    error: function error(response) {
                        Galaxy.emit.debug("tool-form::postchange()", "Refresh request failed.", response);
                        process.reject();
                    }
                });
            }
        }, options));
        this.deferred = this.form.deferred;
        this.setElement("<div/>");
        this.$el.append(this.form.$el);
    },

    _customize: function _customize(form) {
        var self = this;
        var options = form.model.attributes;
        // build execute button
        var execute_button = new _uiMisc2.default.Button({
            icon: "fa-check",
            tooltip: "Execute: " + options.name + " (" + options.version + ")",
            title: (0, _localization2.default)("Execute"),
            cls: "btn btn-primary ui-clear-float",
            wait_cls: "btn btn-info ui-clear-float",
            onclick: function onclick() {
                execute_button.wait();
                form.portlet.disable();
                self.submit(options, function () {
                    execute_button.unwait();
                    form.portlet.enable();
                });
            }
        });
        options.buttons = { execute: execute_button };

        // remap feature
        if (options.job_id && options.job_remap) {
            if (options.job_remap === "job_produced_collection_elements") {
                var label = "Replace elements in collection ?";
                var help = "The previous run of this tool failed. Use this option to replace the failed element(s) in the dataset collection that were produced during the previous tool run.";
            } else {
                var label = "Resume dependencies from this job ?";
                var help = "The previous run of this tool failed and other tools were waiting for it to finish successfully. Use this option to resume those tools using the new output(s) of this tool run.";
            }
            options.inputs.push({
                label: label,
                name: "rerun_remap_job_id",
                type: "select",
                display: "radio",
                ignore: "__ignore__",
                value: "__ignore__",
                options: [["Yes", options.job_id], ["No", "__ignore__"]],
                help: help
            });
        }

        // Job Re-use Options
        var extra_user_preferences = {};
        if (Galaxy.user.attributes.preferences && "extra_user_preferences" in Galaxy.user.attributes.preferences) {
            extra_user_preferences = JSON.parse(Galaxy.user.attributes.preferences.extra_user_preferences);
        }
        var use_cached_job = "use_cached_job|use_cached_job_checkbox" in extra_user_preferences ? extra_user_preferences["use_cached_job|use_cached_job_checkbox"] : false;
        if (use_cached_job === "true") {
            options.inputs.push({
                label: "BETA: Attempt to re-use jobs with identical parameters ?",
                help: "This may skip executing jobs that you have already run",
                name: "use_cached_job",
                type: "select",
                display: "radio",
                ignore: "__ignore__",
                value: "__ignore__",
                options: [["No", false], ["Yes", true]]
            });
        }
    },

    /** Submit a regular job.
     * @param{dict}     options   - Specifies tool id and version
     * @param{function} callback  - Called when request has completed
     */
    submit: function submit(options, callback) {
        var self = this;
        var job_def = {
            tool_id: options.id,
            tool_version: options.version,
            inputs: this.form.data.create()
        };
        this.form.trigger("reset");
        if (!self.validate(job_def)) {
            Galaxy.emit.debug("tool-form::submit()", "Submission canceled. Validation failed.");
            callback && callback();
            return;
        }
        if (options.action !== Galaxy.root + "tool_runner/index") {
            var $f = $("<form/>").attr({
                action: options.action,
                method: options.method,
                enctype: options.enctype
            });
            _.each(job_def.inputs, function (value, key) {
                $f.append($("<input/>").attr({ name: key, value: value }));
            });
            $f.hide().appendTo("body").submit().remove();
            callback && callback();
            return;
        }
        Galaxy.emit.debug("tool-form::submit()", "Validation complete.", job_def);
        _utils2.default.request({
            type: "POST",
            url: Galaxy.root + "api/tools",
            data: job_def,
            success: function success(response) {
                callback && callback();
                self.$el.children().hide();
                self.$el.append(self._templateSuccess(response, job_def));
                // Show Webhook if job is running
                if (response.jobs && response.jobs.length > 0) {
                    self.$el.append($("<div/>", { id: "webhook-view" }));
                    var WebhookApp = new _webhooks2.default.WebhookView({
                        type: "tool",
                        toolId: job_def.tool_id
                    });
                }
                parent.Galaxy && parent.Galaxy.currHistoryPanel && parent.Galaxy.currHistoryPanel.refreshContents();
            },
            error: function error(response) {
                callback && callback();
                Galaxy.emit.debug("tool-form::submit", "Submission failed.", response);
                var input_found = false;
                if (response && response.err_data) {
                    var error_messages = self.form.data.matchResponse(response.err_data);
                    for (var input_id in error_messages) {
                        self.form.highlight(input_id, error_messages[input_id]);
                        input_found = true;
                        break;
                    }
                }
                if (!input_found) {
                    self.modal.show({
                        title: (0, _localization2.default)("Job submission failed"),
                        body: self._templateError(job_def, response && response.err_msg),
                        buttons: {
                            Close: function Close() {
                                self.modal.hide();
                            }
                        }
                    });
                }
            }
        });
    },

    /** Validate job dictionary.
     * @param{dict}     job_def   - Job execution dictionary
     */
    validate: function validate(job_def) {
        var _this = this;

        var job_inputs = job_def.inputs;
        var batch_n = -1;
        var batch_src = null;
        for (var job_input_id in job_inputs) {
            var input_value = job_inputs[job_input_id];
            var input_id = this.form.data.match(job_input_id);
            var input_field = this.form.field_list[input_id];
            var input_def = this.form.input_list[input_id];
            if (!input_id || !input_def || !input_field) {
                Galaxy.emit.debug("tool-form::validate()", "Retrieving input objects failed.");
                continue;
            }
            if (!input_def.optional && input_value == null) {
                this.form.highlight(input_id);
                return false;
            }
            if (input_field.validate) {
                // wish there was a way to just reset this input field
                var reset = function reset() {
                    _this.form.trigger("reset");
                };
                var validateObject = input_field.validate(reset);
                if (!validateObject.valid) {
                    this.form.highlight(input_id, validateObject.message);
                    return false;
                }
            }
            if (input_value && input_value.batch) {
                var n = input_value.values.length;
                var src = n > 0 && input_value.values[0] && input_value.values[0].src;
                if (src) {
                    if (batch_src === null) {
                        batch_src = src;
                    } else if (batch_src !== src) {
                        this.form.highlight(input_id, "Please select either dataset or dataset list fields for all batch mode fields.");
                        return false;
                    }
                }
                if (batch_n === -1) {
                    batch_n = n;
                } else if (batch_n !== n) {
                    this.form.highlight(input_id, "Please make sure that you select the same number of inputs for all batch mode fields. This field contains <b>" + n + "</b> selection(s) while a previous field contains <b>" + batch_n + "</b>.");
                    return false;
                }
            }
        }
        return true;
    },

    _getInputs: function _getInputs(job_def) {
        var inputs = [];
        var index = {};
        for (var i in job_def.inputs) {
            var input = job_def.inputs[i];
            if (input && $.isArray(input.values)) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = input.values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var j = _step.value;

                        if (j.src && !index[j.id]) {
                            inputs.push(j);
                            index[j.id] = true;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        }
        return inputs;
    },

    _templateRow: function _templateRow(list, title) {
        var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 3;

        var blurb = "";
        list.sort(function (a, b) {
            return b.hid - a.hid;
        });
        if (list.length > 0) {
            blurb += "<p>" + title + ":</p>";
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = list[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var item = _step2.value;

                    var rowString = max > 0 ? item.hid + ": " + item.name : "...";
                    blurb += "<p class=\"messagerow\">\n                            <b>" + rowString + "</b>\n                          </p>";
                    if (max-- <= 0) {
                        break;
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
        }
        return blurb;
    },

    _templateSuccess: function _templateSuccess(response, job_def) {
        var njobs = response.jobs.length;
        if (njobs > 0) {
            var inputs = this._getInputs(job_def);
            var ninputs = inputs.length;
            var noutputs = response.outputs.length;
            var njobsText = njobs > 1 ? njobs + " jobs" : "1 job";
            var ninputsText = ninputs > 1 ? ninputs + " inputs" : "this input";
            var noutputsText = noutputs > 1 ? noutputs + " outputs" : "this output";
            var tool_name = this.form.model.get("name");
            return "<div class=\"donemessagelarge\">\n                        <p>\n                            Executed <b>" + tool_name + "</b> and successfully added " + njobsText + " to the queue.\n                        </p>\n                        " + this._templateRow(inputs, "The tool uses " + ninputsText) + "\n                        " + this._templateRow(response.outputs, "It produces " + noutputsText) + "\n                        <p>\n                            You can check the status of queued jobs and view the resulting data by refreshing the History panel. When the job has been run the status will change from 'running' to 'finished' if completed successfully or 'error' if problems were encountered.\n                        </p>\n                    </div>";
        } else {
            return this._templateError(response, "Invalid success response. No jobs found.");
        }
    },

    _templateError: function _templateError(response, err_msg) {
        return $("<div/>").addClass("errormessagelarge").append($("<p/>").text("The server could not complete the request. Please contact the Galaxy Team if this error persists. " + (err_msg || ""))).append($("<pre/>").text(JSON.stringify(response, null, 4)));
    }
});
/* This is the regular tool form */
exports.default = {
    View: View
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(0), __webpack_require__(1)))

/***/ }),
/* 69 */,
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Citations_vue_vue_type_template_id_3bd49a6c__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Citations_vue_vue_type_script_lang_js__ = __webpack_require__(41);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__Citations_vue_vue_type_script_lang_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__Citations_vue_vue_type_script_lang_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Citations_vue_vue_type_style_index_0_lang_css__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(17);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__Citations_vue_vue_type_script_lang_js__["default"],
  __WEBPACK_IMPORTED_MODULE_0__Citations_vue_vue_type_template_id_3bd49a6c__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Citations_vue_vue_type_template_id_3bd49a6c__["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Backbone, _) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _baseMvc = __webpack_require__(6);

var _baseMvc2 = _interopRequireDefault(_baseMvc);

var _localization = __webpack_require__(3);

var _localization2 = _interopRequireDefault(_localization);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// =============================================================================
/** A view on any model that has a 'tags' attribute (a list of tag strings)
 *      Incorporates the select2 jQuery plugin for tags display/editing:
 *      http://ivaynberg.github.io/select2/
 */
var TagsEditor = Backbone.View.extend(_baseMvc2.default.LoggableMixin).extend(_baseMvc2.default.HiddenUntilActivatedViewMixin).extend({
    tagName: "div",
    className: "tags-display",
    select_width: "100%",
    events: {},

    /** Set up listeners, parse options */
    initialize: function initialize(options) {
        //console.debug( this, options );
        // only listen to the model only for changes to tags - re-render
        this.show_editor = false;
        if (options.usePrompt === false) {
            this.label = "";
        } else {
            this.label = "<label class=\"prompt\">" + (0, _localization2.default)("Tags") + "</label>";
        }
        this.workflow_mode = options.workflow_mode || false;
        if (this.workflow_mode) {
            this.events.click = "showEditor";
            this.events.keydown = "keydownHandler";
        }
        this.hiddenUntilActivated(options.$activator, options);
    },

    /** Build the DOM elements, call select to on the created input, and set up behaviors */
    render: function render() {
        var self = this;
        if (this.workflow_mode) {
            this.$el.html(this._workflowTemplate());
        } else {
            this.$el.html(this._defaultTemplate());
        }
        this.$input().select2({
            placeholder: "Add tags",
            width: this.workflow_mode ? this.width : this.select_width,
            tags: function tags() {
                // initialize possible tags in the dropdown based on all the tags the user has used so far
                return self._getTagsUsed();
            }
        });

        this._setUpBehaviors();
        return this;
    },

    _hashToName: function _hashToName(tag) {
        if (tag.startsWith("#")) {
            return "name:" + tag.slice(1);
        }
        return tag;
    },

    _nameToHash: function _nameToHash(tag) {
        if (tag.startsWith("name:")) {
            tag = "#" + tag.slice(5);
        }
        return tag;
    },

    /** @returns {String} the html text used to build the view's DOM */
    _defaultTemplate: function _defaultTemplate() {
        return [this.label, this._renderEditor()].join("");
    },

    _workflowTemplate: function _workflowTemplate() {
        // Shows labels by default, event handler controls whether we show tags or editor
        return [this.show_editor ? this._renderEditor() : this._renderTags()].join(" ");
    },

    keydownHandler: function keydownHandler(e) {
        switch (e.which) {
            // esc
            case 27:
                // hide the tag editor when pressing escape
                this.hideEditor();
                break;
        }
    },

    showEditor: function showEditor() {
        this.show_editor = true;
        this.render();
    },

    hideEditor: function hideEditor() {
        this.show_editor = false;
        this.render();
    },

    _renderEditor: function _renderEditor() {
        // set up initial tags by adding as CSV to input vals (necc. to init select2)
        return "<input class=\"tags-input\" value=\"" + this.tagsToCSV() + "\"/>";
    },

    _renderTags: function _renderTags() {
        var tags = this.model.get("tags");
        var addButton = Galaxy.root + "static/images/fugue/tag--plus.png";
        var renderedArray = [];
        _.each(tags, function (tag) {
            tag = tag.indexOf("name:") == 0 ? tag.slice(5) : tag;
            var renderString = "<span class=\"badge badge-primary badge-tags\">" + tag + "</span>";
            renderedArray.push(renderString);
        });
        if (renderedArray.length === 0) {
            // If there are no tags to render we just show the add-tag-button
            renderedArray.push("<img src=" + addButton + " class=\"add-tag-button\" title=\"Add tags\"/>");
        }
        return renderedArray.join(" ");
    },

    /** @returns {String} the sorted, comma-separated tags from the model */
    tagsToCSV: function tagsToCSV() {
        var self = this;
        var tagsArray = this.model.get("tags");
        if (!_.isArray(tagsArray) || _.isEmpty(tagsArray)) {
            return "";
        }
        return tagsArray.map(function (tag) {
            return _.escape(self._nameToHash(tag));
        }).sort().join(",");
    },

    /** @returns {jQuery} the input for this view */
    $input: function $input() {
        return this.$el.find("input.tags-input");
    },

    /** @returns {String[]} all tags used by the current user */
    _getTagsUsed: function _getTagsUsed() {
        //TODO: global
        var self = this;
        return _.map(Galaxy.user.get("tags_used"), self._nameToHash);
    },

    /** set up any event listeners on the view's DOM (mostly handled by select2) */
    _setUpBehaviors: function _setUpBehaviors() {
        var self = this;
        this.$input().on("change", function (event) {
            // Modify any 'hashtag' 'nametags'
            event.val = _.map(event.val, self._hashToName);
            // save the model's tags in either remove or added event
            self.model.save({ tags: event.val });
            // if it's new, add the tag to the users tags
            if (event.added) {
                //??: solve weird behavior in FF on test.galaxyproject.org where
                //  event.added.text is string object: 'String{ 0="o", 1="n", 2="e" }'
                self._addNewTagToTagsUsed("" + event.added.text);
            }
        });
    },

    /** add a new tag (if not already there) to the list of all tags used by the user
     *  @param {String} newTag  the tag to add to the list of used
     */
    _addNewTagToTagsUsed: function _addNewTagToTagsUsed(newTag) {
        //TODO: global
        var tagsUsed = Galaxy.user.get("tags_used");
        if (!_.contains(tagsUsed, newTag)) {
            tagsUsed.push(newTag);
            tagsUsed.sort();
            Galaxy.user.set("tags_used", tagsUsed);
        }
    },

    /** shut down event listeners and remove this view's DOM */
    remove: function remove() {
        this.$input.off();
        this.stopListening(this.model);
        Backbone.View.prototype.remove.call(this);
    },

    /** string rep */
    toString: function toString() {
        return ["TagsEditor(", "" + this.model, ")"].join("");
    }
});

exports.default = {
    TagsEditor: TagsEditor
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(1)))

/***/ }),
/* 72 */,
/* 73 */,
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _underscore = __webpack_require__(1);

var _ = _interopRequireWildcard(_underscore);

var _backbone = __webpack_require__(2);

var Backbone = _interopRequireWildcard(_backbone);

var _baseMvc = __webpack_require__(6);

var _baseMvc2 = _interopRequireDefault(_baseMvc);

var _userModel = __webpack_require__(61);

var _userModel2 = _interopRequireDefault(_userModel);

var _metricsLogger = __webpack_require__(75);

var _metricsLogger2 = _interopRequireDefault(_metricsLogger);

var _addLogging = __webpack_require__(159);

var _addLogging2 = _interopRequireDefault(_addLogging);

var _localization = __webpack_require__(3);

var _localization2 = _interopRequireDefault(_localization);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/* global $ */

// TODO: move into a singleton pattern and have dependents import Galaxy
// ============================================================================
/** Base galaxy client-side application.
 *      Iniitializes:
 *          logger      : the logger/metrics-logger
 *          localize    : the string localizer
 *          config      : the current configuration (any k/v in
 *              galaxy.ini available from the configuration API)
 *          user        : the current user (as a mvc/user/user-model)
 */
function GalaxyApp(options, bootstrapped) {
    var self = this;
    return self._init(options || {}, bootstrapped || {});
}

// add logging shortcuts for this object
(0, _addLogging2.default)(GalaxyApp, "GalaxyApp");

// a debug flag can be set via local storage and made available during script/page loading
var DEBUGGING_KEY = "galaxy:debug";

var NAMESPACE_KEY = DEBUGGING_KEY + ":namespaces";
var FLATTEN_LOG_MESSAGES_KEY = DEBUGGING_KEY + ":flatten";

var localDebugging = false;
try {
    localDebugging = localStorage.getItem(DEBUGGING_KEY) == "true";
} catch (storageErr) {
    console.log((0, _localization2.default)("localStorage not available for debug flag retrieval"));
}

/** initalize options and sub-components */
GalaxyApp.prototype._init = function __init(options, bootstrapped) {
    var self = this;
    _.extend(self, Backbone.Events);
    if (localDebugging) {
        self.logger = console;
        console.debug("debugging galaxy:", "options:", options, "bootstrapped:", bootstrapped);
    }

    self._processOptions(options);

    // add root and url parameters
    self.root = options.root || "/";
    self.params = options.params || {};
    self.session_csrf_token = options.session_csrf_token || null;

    self._initConfig(options.config || {});
    self._patchGalaxy(window.Galaxy);

    self._initLogger(self.options.loggerOptions || {});
    // at this point, either logging or not and namespaces are enabled - chat it up
    self.debug("GalaxyApp.options: ", self.options);
    self.debug("GalaxyApp.config: ", self.config);
    self.debug("GalaxyApp.logger: ", self.logger);

    self._initLocale();
    self.debug("GalaxyApp.localize: ", self.localize);

    self.config = options.config || {};
    self.debug("GalaxyApp.config: ", self.config);

    self._initUser(options.user || {});
    self.debug("GalaxyApp.user: ", self.user);

    self._initUserLocale();
    self.debug("currentLocale: ", sessionStorage.getItem("currentLocale"));

    self._setUpListeners();
    self.trigger("ready", self);

    return self;
};

/** default options */
GalaxyApp.prototype.defaultOptions = {
    /** monkey patch attributes from existing window.Galaxy object? */
    patchExisting: true,
    /** root url of this app */
    root: "/",
    session_csrf_token: null
};

/** filter to options present in defaultOptions (and default to them) */
GalaxyApp.prototype._processOptions = function _processOptions(options) {
    var self = this;
    var defaults = self.defaultOptions;

    self.options = {};
    for (var k in defaults) {
        if (defaults.hasOwnProperty(k)) {
            self.options[k] = options.hasOwnProperty(k) ? options[k] : defaults[k];
        }
    }
    return self;
};

/** parse the config and any extra info derived from it */
GalaxyApp.prototype._initConfig = function _initConfig(config) {
    var self = this;
    self.config = config;

    // give precendence to localdebugging for this setting
    self.config.debug = localDebugging || self.config.debug;

    return self;
};

/** add an option from options if the key matches an option in defaultOptions */
GalaxyApp.prototype._patchGalaxy = function _patchGalaxy(patchWith) {
    var self = this;
    // in case req or plain script tag order has created a prev. version of the Galaxy obj...
    if (self.options.patchExisting && patchWith) {
        // self.debug( 'found existing Galaxy object:', patchWith );
        // ...(for now) monkey patch any added attributes that the previous Galaxy may have had
        //TODO: move those attributes to more formal assignment in GalaxyApp
        for (var k in patchWith) {
            if (patchWith.hasOwnProperty(k)) {
                // self.debug( '\t patching in ' + k + ' to Galaxy:', self[ k ] );
                self[k] = patchWith[k];
            }
        }
    }
};

/** set up the metrics logger (utils/metrics-logger) and pass loggerOptions */
GalaxyApp.prototype._initLogger = function _initLogger(loggerOptions) {
    var self = this;

    // default to console logging at the debug level if the debug flag is set
    if (self.config.debug) {
        loggerOptions.consoleLogger = loggerOptions.consoleLogger || console;
        loggerOptions.consoleLevel = loggerOptions.consoleLevel || _metricsLogger2.default.MetricsLogger.ALL;
        // load any logging namespaces from localStorage if we can
        try {
            loggerOptions.consoleNamespaceWhitelist = localStorage.getItem(NAMESPACE_KEY).split(",");
        } catch (storageErr) {}
        try {
            loggerOptions.consoleFlattenMessages = localStorage.getItem(FLATTEN_LOG_MESSAGES_KEY) == "true";
        } catch (storageErr) {}
        console.log(loggerOptions.consoleFlattenMessages);
    }

    self.logger = new _metricsLogger2.default.MetricsLogger(loggerOptions);
    self.emit = {};
    ["log", "debug", "info", "warn", "error", "metric"].map(function (i) {
        self.emit[i] = function (data) {
            self.logger.emit(i, arguments[0], Array.prototype.slice.call(arguments, 1));
        };
    });

    if (self.config.debug) {
        // add this logger to mvc's loggable mixin so that all models can use the logger
        _baseMvc2.default.LoggableMixin.logger = self.logger;
    }
    return self;
};

/** add the localize fn to this object and the window namespace (as '_l') */
GalaxyApp.prototype._initLocale = function _initLocale(options) {
    var self = this;
    self.debug("_initLocale:", options);
    self.localize = _localization2.default;
    // add to window as global shortened alias
    // TODO: temporary - remove when can require for plugins
    window._l = self.localize;
    return self;
};

/** add the localize fn to this object and the window namespace (as '_l') */
GalaxyApp.prototype._initUserLocale = function _initUserLocale(options) {
    var self = this;

    // Choose best locale
    var global_locale = self.config.default_locale ? self.config.default_locale.toLowerCase() : false;

    var extra_user_preferences = {};
    if (self.user && self.user.attributes.preferences && "extra_user_preferences" in self.user.attributes.preferences) {
        extra_user_preferences = JSON.parse(self.user.attributes.preferences.extra_user_preferences);
    }

    var user_locale = "localization|locale" in extra_user_preferences ? extra_user_preferences["localization|locale"].toLowerCase() : false;

    if (user_locale == "auto") {
        user_locale = false;
    }

    var nav_locale = typeof navigator === "undefined" ? "__root" : (navigator.language || navigator.userLanguage || "__root").toLowerCase();

    var locale = user_locale || global_locale || nav_locale;

    sessionStorage.setItem("currentLocale", locale);
};

/** set up the current user as a Backbone model (mvc/user/user-model) */
GalaxyApp.prototype._initUser = function _initUser(userJSON) {
    var self = this;
    self.debug("_initUser:", userJSON);
    self.user = new _userModel2.default.User(userJSON);
    self.user.logger = self.logger;
    return self;
};

/** Set up DOM/jQuery/Backbone event listeners enabled for all pages */
GalaxyApp.prototype._setUpListeners = function _setUpListeners() {
    var self = this;

    // hook to jq beforeSend to record the most recent ajax call and cache some data about it
    /** cached info about the last ajax call made through jQuery */
    self.lastAjax = {};
    $(document).bind("ajaxSend", function (ev, xhr, options) {
        var data = options.data;
        try {
            data = JSON.parse(data);
        } catch (err) {}

        self.lastAjax = {
            url: location.href.slice(0, -1) + options.url,
            data: data
        };
        //TODO:?? we might somehow manage to *retry* ajax using either this hook or Backbone.sync
    });
    return self;
};

/** Turn debugging/console-output on/off by passing boolean. Pass nothing to get current setting. */
GalaxyApp.prototype.debugging = function _debugging(setting) {
    var self = this;
    try {
        if (setting === undefined) {
            return localStorage.getItem(DEBUGGING_KEY) === "true";
        }
        if (setting) {
            localStorage.setItem(DEBUGGING_KEY, true);
            return true;
        }

        localStorage.removeItem(DEBUGGING_KEY);
        // also remove all namespaces
        self.debuggingNamespaces(null);
    } catch (storageErr) {
        console.log((0, _localization2.default)("localStorage not available for debug flag retrieval"));
    }
    return false;
};

/** Add, remove, or clear namespaces from the debugging filters
 *  Pass no arguments to retrieve the existing namespaces as an array.
 *  Pass in null to clear all namespaces (all logging messages will show now).
 *  Pass in an array of strings or single string of the namespaces to filter to.
 *  Returns the new/current namespaces as an array;
 */
GalaxyApp.prototype.debuggingNamespaces = function _debuggingNamespaces(namespaces) {
    var self = this;
    try {
        if (namespaces === undefined) {
            var csv = localStorage.getItem(NAMESPACE_KEY);
            return typeof csv === "string" ? csv.split(",") : [];
        } else if (namespaces === null) {
            localStorage.removeItem(NAMESPACE_KEY);
        } else {
            localStorage.setItem(NAMESPACE_KEY, namespaces);
        }
        var newSettings = self.debuggingNamespaces();
        if (self.logger) {
            self.logger.options.consoleNamespaceWhitelist = newSettings;
        }
        return newSettings;
    } catch (storageErr) {
        console.log((0, _localization2.default)("localStorage not available for debug namespace retrieval"));
    }
};

/** string rep */
GalaxyApp.prototype.toString = function toString() {
    var userEmail = this.user ? this.user.get("email") || "(anonymous)" : "uninitialized";
    return "GalaxyApp(" + userEmail + ")";
};

// This is not great.  Rework to be a singleton-style Galaxy app accessible/created by import
window.Galaxy = window.Galaxy || new GalaxyApp();

// ============================================================================
exports.default = {
    GalaxyApp: GalaxyApp
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*global window, jQuery, console */
/*=============================================================================
TODO:
    while anon: logs saved to 'logs-null' - this will never post
        unless we manually do so at/after login
        OR prepend when userId and localStorage has 'logs-null'
    wire up _delayPost and test

=============================================================================*/
/** @class MetricsLogger
 *
 *  Object to cache, output, and post log/metric messages to the server.
 *  Meant to be attached to the Galaxy object.
 *
 *  Log from objects by either attaching logger directly:
 *      panel.logger.metric( 'user dataset deletion', panel.user.id, hda.toJSON() )
 *  or using the LoggableMixin or addLogging function:
 *      MyBackboneModel.extend( LoggableMixin ).extend({ ... })
 *      addLogging( MyBackboneModel, 'my-backbone-model' )
 *
 *  Log from templates by calling directly from Galaxy object:
 *      Galaxy.logger.metric( 'template loaded', { ownedByUser : true });
 *
 *  If you attempt to log an un-serializable object (circular reference, window, etc.),
 *  that entry will not be cached (or sent). If you set consoleLevel and consoleLogger
 *  appropriately, a warning will be shown when this happens:
 *      > panel.metric( 'something weird with window', { window : window })
 *      !'Metrics logger could not stringify logArguments: ...'
 */
function MetricsLogger(options) {
    options = options || {};
    var self = this;

    ///** get the current user's id from bootstrapped data or options */
    self.userId = window.bootstrapped && window.bootstrapped.user ? window.bootstrapped.user.id : null;
    self.userId = self.userId || options.userId || null;

    /** the (optional) console to emit logs to */
    self.consoleLogger = options.consoleLogger || null;

    self._init(options);
    return self;
}

//----------------------------------------------------------------------------- defaults and constants
// see: python std lib, logging
MetricsLogger.ALL = 0;
MetricsLogger.LOG = 0;
MetricsLogger.DEBUG = 10;
MetricsLogger.INFO = 20;
MetricsLogger.WARN = 30;
MetricsLogger.ERROR = 40;
// metrics levels here?
//MetricsLogger.MinorEvent  = 45;
//MetricsLogger.MajorEvent  = 50;
MetricsLogger.METRIC = 50;
MetricsLogger.NONE = 100;

/** default options - override these through the constructor */
MetricsLogger.defaultOptions = {
    /** if an incoming message has a level >= this, it will be cached - can also be a string (e.g. 'debug') */
    logLevel: MetricsLogger.NONE,
    /** if an incoming message has a level >= this, it will be output to the console */
    consoleLevel: MetricsLogger.NONE,
    /** the default 'namespace' or label associated with an incoming message (if none is passed) */
    defaultNamespace: "Galaxy",
    /** the namespaces output to the console (all namespaces will be output if this is falsy)
     *  note: applies only to the console (not the event/metrics log/cache)
     */
    consoleNamespaceWhitelist: null,
    /** Force all messages into simple strings. */
    consoleFlattenMessages: false,
    /** the prefix attached to client-side logs to distinguish them in the metrics db */
    clientPrefix: "client.",

    /** the maximum number of messages the cache should hold; if exceeded older messages are removed first */
    maxCacheSize: 3000,
    /** the number of messages accumulate before posting to the server; should be <= maxCacheSize */
    postSize: 1000,
    /** T/F whether to add a timestamp to incoming cached messages */
    addTime: true,
    /** string to prefix to userid for cache web storage */
    cacheKeyPrefix: "logs-",

    /** the relative url to post messages to */
    postUrl: "/api/metrics",
    /** delay before trying post again after two failures */
    delayPostInMs: 1000 * 60 * 10,

    /** an (optional) function that should return an object; used to send additional data with the metrics */
    getPingData: undefined,
    /** an (optional) function that will handle the servers response after successfully posting messages */
    onServerResponse: undefined
};

//----------------------------------------------------------------------------- set up
/** initialize the logger with options, set up instance vars and cache, and add onpageunload to window */
MetricsLogger.prototype._init = function _init(options) {
    var self = this;
    self.options = {};
    for (var k in MetricsLogger.defaultOptions) {
        if (MetricsLogger.defaultOptions.hasOwnProperty(k)) {
            self.options[k] = options.hasOwnProperty(k) ? options[k] : MetricsLogger.defaultOptions[k];
        }
    }
    self.options.logLevel = self._parseLevel(self.options.logLevel);
    self.options.consoleLevel = self._parseLevel(self.options.consoleLevel);
    //self._emitToConsole( 'debug', 'MetricsLogger', 'MetricsLogger.options:', self.options );

    /** is the logger currently sending? */
    self._sending = false;
    /** the setTimeout id if the logger POST has failed more than once */
    self._waiting = null;
    /** the current number of entries to send in a POST */
    self._postSize = self.options.postSize;

    self._initCache();

    return self;
};

/** initialize the cache */
MetricsLogger.prototype._initCache = function _initCache() {
    try {
        this.cache = new LoggingCache({
            maxSize: this.options.maxCacheSize,
            key: this.options.cacheKeyPrefix + this.userId
        });
    } catch (err) {
        this._emitToConsole("warn", "MetricsLogger", ["Could not intitialize logging cache:", err]);
        this.options.logLevel = MetricsLogger.NONE;
    }
};

/** return the numeric log level if level in 'none, debug, log, info, warn, error' */
MetricsLogger.prototype._parseLevel = function _parseLevel(level) {
    var type = typeof level === "undefined" ? "undefined" : _typeof(level);
    if (type === "number") {
        return level;
    }
    if (type === "string") {
        var upper = level.toUpperCase();
        if (MetricsLogger.hasOwnProperty(upper)) {
            return MetricsLogger[upper];
        }
    }
    throw new Error("Unknown log level: " + level);
};

//----------------------------------------------------------------------------- main entry point
/** record a log/message's arguments to the cache and/or the console based on level and namespace */
MetricsLogger.prototype.emit = function emit(level, namespace, logArguments) {
    //this._emitToConsole( 'debug', 'MetricsLogger', [ 'emit:', level, namespace, logArguments ]);
    var self = this;
    namespace = namespace || self.options.defaultNamespace;
    if (!level || !logArguments) {
        return self;
    }
    // add to cache if proper level
    //TODO: respect do not track?
    //if( !navigator.doNotTrack && level >= self.options.logLevel ){
    level = self._parseLevel(level);
    if (level >= self.options.logLevel) {
        self._addToCache(level, namespace, logArguments);
    }
    // also emit to consoleLogger if proper level for that
    if (self.consoleLogger && level >= self.options.consoleLevel) {
        self._emitToConsole(level, namespace, logArguments);
    }
    return self;
};

//----------------------------------------------------------------------------- cache
/** add a message to the cache and if messages.length is high enough post them to the server */
MetricsLogger.prototype._addToCache = function _addToCache(level, namespace, logArguments) {
    this._emitToConsole("debug", "MetricsLogger", ["_addToCache:", arguments, this.options.addTime, this.cache.length()]);
    //this._emitToConsole( 'debug', 'MetricsLogger', [ '\t logArguments:', logArguments ]);
    var self = this;
    // try add to the cache and if we've got _postSize number of entries, attempt to post them to the server
    try {
        var newLength = self.cache.add(self._buildEntry(level, namespace, logArguments));
        if (newLength >= self._postSize) {
            self._postCache();
        }
        // discard entry if an error occurs, but warn if level set to do so
    } catch (err) {
        self._emitToConsole("warn", "MetricsLogger", ["Metrics logger could not stringify logArguments:", namespace, logArguments]);
        self._emitToConsole("error", "MetricsLogger", [err]);
    }
    return self;
};

/** build a log cache entry object from the given level, namespace, and arguments (optionally adding timestamp */
MetricsLogger.prototype._buildEntry = function _buildEntry(level, namespace, logArguments) {
    this._emitToConsole("debug", "MetricsLogger", ["_buildEntry:", arguments]);
    var entry = {
        level: level,
        namespace: this.options.clientPrefix + namespace,
        args: logArguments
    };
    if (this.options.addTime) {
        entry.time = new Date().toISOString();
    }
    return entry;
};

/** post _postSize messages from the cache to the server, removing them if successful
 *      if the post fails, wait until maxCacheSize is accumulated instead and try again then
 *      in addition to the messages from the cache ('metrics'), any info from getPingData (if set) will be sent
 *      onServerResponse will be called (if set) with any response from the server
 */
MetricsLogger.prototype._postCache = function _postCache(options) {
    options = options || {};
    this._emitToConsole("info", "MetricsLogger", ["_postCache", options, this._postSize]);

    // short circuit if we're already sending
    if (!this.options.postUrl || this._sending) {
        return jQuery.when({});
    }

    var self = this;
    var postSize = options.count || self._postSize;

    var // do not splice - remove after *successful* post
    entries = self.cache.get(postSize);

    var entriesLength = entries.length;

    var // use the optional getPingData to add any extra info we may want to send
    postData = typeof self.options.getPingData === "function" ? self.options.getPingData() : {};

    //console.debug( postSize, entriesLength );

    // add the metrics and send
    postData.metrics = JSON.stringify(entries);
    //console.debug( postData.metrics );
    self._sending = true;
    return jQuery.post(self.options.postUrl, postData).always(function () {
        self._sending = false;
    }).fail(function (xhr, status, message) {
        // if we failed the previous time, set the next post target to the max num of entries
        self._postSize = self.options.maxCacheSize;
        //TODO:??
        // log this failure to explain any gap in metrics
        self.emit("error", "MetricsLogger", ["_postCache error:", xhr.readyState, xhr.status, xhr.responseJSON || xhr.responseText]);
        //TODO: still doesn't solve the problem that when cache == max, post will be tried on every emit
        //TODO: see _delayPost
    }).done(function (response) {
        if (typeof self.options.onServerResponse === "function") {
            self.options.onServerResponse(response);
        }
        // only remove if post successful
        self.cache.remove(entriesLength);
        //console.debug( 'removed entries:', entriesLength, 'size now:', self.cache.length() );
        // if we succeeded, reset the post target to the normal num of entries
        self._postSize = self.options.postSize;
    });
    // return the xhr promise
};

/** set _waiting to true and, after delayPostInMs, set it back to false */
MetricsLogger.prototype._delayPost = function _delayPost() {
    //TODO: this won't work between pages
    var self = this;
    self._waiting = setTimeout(function () {
        self._waiting = null;
    }, self.options.delayPostInMs);
};

function usefulToString(arg) {
    var asStr = String(arg);
    if (asStr == "[object Object]") {
        asStr = JSON.stringify(arg);
    }
    return asStr;
}

//----------------------------------------------------------------------------- console
/** output message to console based on level and consoleLogger type */
MetricsLogger.prototype._emitToConsole = function _emitToConsole(level, namespace, logArguments) {
    //console.debug( '_emitToConsole:', level, namespace, logArguments );
    var self = this;

    var whitelist = self.options.consoleNamespaceWhitelist;
    if (!self.consoleLogger) {
        return self;
    }
    // if a whitelist for namespaces is set, bail if this namespace is not in the list
    if (whitelist && whitelist.indexOf(namespace) === -1) {
        return self;
    }

    var args = Array.prototype.slice.call(logArguments, 0);
    args.unshift(namespace);
    if (self.options.consoleFlattenMessages) {
        args = [args.map(usefulToString).join(" ")];
    }
    //TODO: script location and/or source maps?
    //TODO: branch on navigator.userAgent == AIIEEE - it only has log
    if (level >= MetricsLogger.METRIC && typeof self.consoleLogger.info === "function") {
        return self.consoleLogger.info.apply(self.consoleLogger, args);
    } else if (level >= MetricsLogger.ERROR && typeof self.consoleLogger.error === "function") {
        return self.consoleLogger.error.apply(self.consoleLogger, args);
    } else if (level >= MetricsLogger.WARN && typeof self.consoleLogger.warn === "function") {
        self.consoleLogger.warn.apply(self.consoleLogger, args);
    } else if (level >= MetricsLogger.INFO && typeof self.consoleLogger.info === "function") {
        self.consoleLogger.info.apply(self.consoleLogger, args);
    } else if (level >= MetricsLogger.DEBUG && typeof self.consoleLogger.debug === "function") {
        self.consoleLogger.debug.apply(self.consoleLogger, args);
    } else if (typeof self.consoleLogger.log === "function") {
        self.consoleLogger.log.apply(self.consoleLogger, args);
    }
    return self;
};

//----------------------------------------------------------------------------- shortcuts
// generic functions when logging from non-namespaced object (e.g. templates)
/** log to default namespace */
MetricsLogger.prototype.log = function log() {
    this.emit(1, this.options.defaultNamespace, Array.prototype.slice.call(arguments, 0));
};

/** debug to default namespace */
MetricsLogger.prototype.debug = function debug() {
    this.emit(MetricsLogger.DEBUG, this.options.defaultNamespace, Array.prototype.slice.call(arguments, 0));
};

/** info to default namespace */
MetricsLogger.prototype.info = function info() {
    this.emit(MetricsLogger.INFO, this.options.defaultNamespace, Array.prototype.slice.call(arguments, 0));
};

/** warn to default namespace */
MetricsLogger.prototype.warn = function warn() {
    this.emit(MetricsLogger.WARN, this.options.defaultNamespace, Array.prototype.slice.call(arguments, 0));
};

/** error to default namespace */
MetricsLogger.prototype.error = function error() {
    this.emit(MetricsLogger.ERROR, this.options.defaultNamespace, Array.prototype.slice.call(arguments, 0));
};

/** metric to default namespace */
MetricsLogger.prototype.metric = function metric() {
    this.emit(MetricsLogger.METRIC, this.options.defaultNamespace, Array.prototype.slice.call(arguments, 0));
};

/* ============================================================================
TODO:
    need a performance pass - the JSON un/parsing is a bit much

============================================================================ */
/** @class LoggingCache
 *  Simple implementation of cache wrapping an array.
 *
 *  Formats an entry before it's cached and only keeps options.maxSize number
 *  of entries. Older entries are deleted first.
 */
function LoggingCache(options) {
    var self = this;
    return self._init(options || {});
}

/** default options */
LoggingCache.defaultOptions = {
    /** maximum number of entries to keep before discarding oldest */
    maxSize: 5000
};

/** initialize with options */
LoggingCache.prototype._init = function _init(options) {
    if (!this._hasStorage()) {
        //TODO: fall back to jstorage
        throw new Error("LoggingCache needs localStorage");
    }
    if (!options.key) {
        throw new Error("LoggingCache needs key for localStorage");
    }
    this.key = options.key;
    this._initStorage();

    this.maxSize = options.maxSize || LoggingCache.defaultOptions.maxSize;
    return this;
};

/** tests for localStorage fns */
LoggingCache.prototype._hasStorage = function _hasStorage() {
    //TODO: modernizr
    var test = "test";
    try {
        localStorage.setItem(test, test);
        localStorage.removeItem(test);
        return true;
    } catch (e) {
        return false;
    }
};

/** if no localStorage set for key, initialize to empty array */
LoggingCache.prototype._initStorage = function _initStorage() {
    if (localStorage.getItem(this.key) === null) {
        return this.empty();
    }
    return this;
};

/** add an entry to the cache, removing the oldest beforehand if size >= maxSize */
LoggingCache.prototype.add = function add(entry) {
    var self = this;
    var _cache = self._fetchAndParse();
    var overage = _cache.length + 1 - self.maxSize;
    if (overage > 0) {
        _cache.splice(0, overage);
    }
    _cache.push(entry);
    self._unparseAndStore(_cache);
    return _cache.length;
};

/** get the entries from localStorage and parse them */
LoggingCache.prototype._fetchAndParse = function _fetchAndParse() {
    var self = this;
    return JSON.parse(localStorage.getItem(self.key));
};

/** stringify the entries and put them in localStorage */
LoggingCache.prototype._unparseAndStore = function _unparseAndStore(entries) {
    var self = this;
    return localStorage.setItem(self.key, JSON.stringify(entries));
};

///** process the entry before caching */
//LoggingCache.prototype._preprocessEntry = function _preprocessEntry( entry ){
//    return JSON.stringify( entry );
//};

/** return the length --- oh, getters where are you? */
LoggingCache.prototype.length = function length() {
    return this._fetchAndParse().length;
};

/** get count number of entries starting with the oldest */
LoggingCache.prototype.get = function get(count) {
    return this._fetchAndParse().slice(0, count);
};

/** remove count number of entries starting with the oldest */
LoggingCache.prototype.remove = function remove(count) {
    var _cache = this._fetchAndParse();
    var removed = _cache.splice(0, count);
    this._unparseAndStore(_cache);
    return removed;
};

/** empty/clear the entire cache */
LoggingCache.prototype.empty = function empty() {
    localStorage.setItem(this.key, "[]");
    return this;
};

/** stringify count number of entries (but do not remove) */
LoggingCache.prototype.stringify = function stringify(count) {
    return JSON.stringify(this.get(count));
};

/** outputs entire cache to console */
LoggingCache.prototype.print = function print() {
    // popup? (really, carl? a popup?) - easier to copy/paste
    console.log(JSON.stringify(this._fetchAndParse(), null, "  "));
};

//=============================================================================
exports.default = {
    MetricsLogger: MetricsLogger,
    LoggingCache: LoggingCache
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 76 */,
/* 77 */,
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _backbone = __webpack_require__(7);

var Backbone = _interopRequireWildcard(_backbone);

var _menu = __webpack_require__(79);

var _menu2 = _interopRequireDefault(_menu);

var _scratchbook = __webpack_require__(81);

var _scratchbook2 = _interopRequireDefault(_scratchbook);

var _userQuotameter = __webpack_require__(149);

var _userQuotameter2 = _interopRequireDefault(_userQuotameter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/* global Galaxy */
/* global $ */

/** Masthead **/
var View = Backbone.View.extend({
    initialize: function initialize(options) {
        var self = this;
        this.options = options;
        this.setElement(this._template());
        this.$navbarBrandLink = this.$(".navbar-brand");
        this.$navbarBrandImage = this.$(".navbar-brand-image");
        this.$navbarBrandTitle = this.$(".navbar-brand-title");
        this.$navbarTabs = this.$(".navbar-nav");
        this.$quoteMeter = this.$(".quota-meter-container");

        // build tabs
        this.collection = new _menu2.default.Collection();
        this.collection.on("add", function (model) {
            self.$navbarTabs.append(new _menu2.default.Tab({ model: model }).render().$el);
        }).on("reset", function () {
            self.$navbarTabs.empty();
        }).on("dispatch", function (callback) {
            self.collection.each(function (m) {
                callback(m);
            });
        }).fetch(this.options);

        // highlight initial active view
        this.highlight(options.active_view);

        // scratchbook
        Galaxy.frame = this.frame = new _scratchbook2.default({
            collection: this.collection
        });

        // set up the quota meter (And fetch the current user data from trans)
        // add quota meter to masthead
        Galaxy.quotaMeter = this.quotaMeter = new _userQuotameter2.default.UserQuotaMeter({
            model: Galaxy.user,
            el: this.$quoteMeter
        });

        // loop through beforeunload functions if the user attempts to unload the page
        $(window).on("click", function (e) {
            var $download_link = $(e.target).closest("a[download]");
            if ($download_link.length == 1) {
                if ($("iframe[id=download]").length === 0) {
                    $("body").append($("<iframe/>").attr("id", "download").hide());
                }
                $("iframe[id=download]").attr("src", $download_link.attr("href"));
                e.preventDefault();
            }
        }).on("beforeunload", function () {
            var text = "";
            self.collection.each(function (model) {
                var q = model.get("onbeforeunload") && model.get("onbeforeunload")();
                if (q) {
                    text += q + " ";
                }
            });
            if (text !== "") {
                return text;
            }
        });
    },

    render: function render() {
        this.$navbarBrandTitle.html("Galaxy " + (this.options.brand && "/ " + this.options.brand || ""));
        this.$navbarBrandLink.attr("href", this.options.logo_url);
        this.$navbarBrandImage.attr("src", this.options.logo_src);
        this.quotaMeter.render();
        return this;
    },

    highlight: function highlight(id) {
        this.collection.forEach(function (model) {
            model.set("active", model.id == id);
        });
    },

    /** body template */
    _template: function _template() {
        return "\n            <nav id=\"masthead\" class=\"navbar navbar-expand justify-content-center navbar-dark\">\n                <a class=\"navbar-brand\">\n                    <img class=\"navbar-brand-image\"/>\n                    <span class=\"navbar-brand-title\"/>\n                </a>\n                <ul class=\"navbar-nav\"/>\n                <div class=\"quota-meter-container\"/>\n            </nav>";
    }
});

exports.default = {
    View: View
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _backbone = __webpack_require__(7);

var Backbone = _interopRequireWildcard(_backbone);

var _underscore = __webpack_require__(1);

var _ = _interopRequireWildcard(_underscore);

var _communicationServerView = __webpack_require__(80);

var _webhooks = __webpack_require__(29);

var _webhooks2 = _interopRequireDefault(_webhooks);

var _localization = __webpack_require__(3);

var _localization2 = _interopRequireDefault(_localization);

var _utils = __webpack_require__(5);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/* global Galaxy */
/* global $ */

/** Masthead Collection **/
var Collection = Backbone.Collection.extend({
    model: Backbone.Model.extend({
        defaults: {
            visible: true,
            target: "_parent"
        }
    }),
    fetch: function fetch(options) {
        options = options || {};
        this.reset();

        //
        // Chat server tab
        //
        var extendedNavItem = new _communicationServerView.CommunicationServerView();
        this.add(extendedNavItem.render());

        //
        // Analyze data tab.
        //
        this.add({
            id: "analysis",
            title: (0, _localization2.default)("Analyze Data"),
            url: "",
            tooltip: (0, _localization2.default)("Analysis home view"),
            target: "__use_router__"
        });

        //
        // Workflow tab.
        //
        this.add({
            id: "workflow",
            title: (0, _localization2.default)("Workflow"),
            tooltip: (0, _localization2.default)("Chain tools into workflows"),
            disabled: !Galaxy.user.id,
            url: "workflows/list",
            target: "__use_router__"
        });

        //
        // Visualization tab.
        //
        this.add({
            id: "visualization",
            title: (0, _localization2.default)("Visualize"),
            tooltip: (0, _localization2.default)("Visualize datasets"),
            disabled: !Galaxy.user.id,
            menu: [{
                title: (0, _localization2.default)("Create Visualization"),
                url: "visualizations",
                target: "__use_router__"
            }, {
                title: (0, _localization2.default)("Interactive Environments"),
                url: "visualization/gie_list",
                target: "galaxy_main"
            }]
        });

        //
        // 'Shared Items' or Libraries tab.
        //
        this.add({
            id: "shared",
            title: (0, _localization2.default)("Shared Data"),
            url: "library/index",
            tooltip: (0, _localization2.default)("Access published resources"),
            menu: [{
                title: (0, _localization2.default)("Data Libraries"),
                url: "library/list"
            }, {
                title: (0, _localization2.default)("Histories"),
                url: "histories/list_published",
                target: "__use_router__"
            }, {
                title: (0, _localization2.default)("Workflows"),
                url: "workflows/list_published",
                target: "__use_router__"
            }, {
                title: (0, _localization2.default)("Visualizations"),
                url: "visualizations/list_published",
                target: "__use_router__"
            }, {
                title: (0, _localization2.default)("Pages"),
                url: "pages/list_published",
                target: "__use_router__"
            }]
        });

        //
        // Webhooks
        //
        _webhooks2.default.load({
            type: "masthead",
            callback: function callback(webhooks) {
                $(document).ready(function () {
                    webhooks.each(function (model) {
                        var webhook = model.toJSON();
                        if (webhook.activate) {
                            var obj = {
                                id: webhook.id,
                                icon: webhook.config.icon,
                                url: webhook.config.url,
                                tooltip: webhook.config.tooltip,
                                /*jslint evil: true */
                                onclick: webhook.config.function && new Function(webhook.config.function)
                            };

                            // Galaxy.page is undefined for data libraries, workflows pages
                            if (Galaxy.page) {
                                Galaxy.page.masthead.collection.add(obj);
                            } else if (Galaxy.masthead) {
                                Galaxy.masthead.collection.add(obj);
                            }

                            // Append masthead script and styles to Galaxy main
                            _utils2.default.appendScriptStyle(webhook);
                        }
                    });
                });
            }
        });

        //
        // Admin.
        //
        if (Galaxy.user.get("is_admin")) {
            this.add({
                id: "admin",
                title: (0, _localization2.default)("Admin"),
                url: "admin",
                tooltip: (0, _localization2.default)("Administer this Galaxy"),
                cls: "admin-only"
            });
        }

        //
        // Help tab.
        //
        var helpTab = {
            id: "help",
            title: (0, _localization2.default)("Help"),
            tooltip: (0, _localization2.default)("Support, contact, and community"),
            menu: [{
                title: (0, _localization2.default)("Support"),
                url: options.support_url,
                target: "_blank"
            }, {
                title: (0, _localization2.default)("Search"),
                url: options.search_url,
                target: "_blank"
            }, {
                title: (0, _localization2.default)("Mailing Lists"),
                url: options.mailing_lists,
                target: "_blank"
            }, {
                title: (0, _localization2.default)("Videos"),
                url: options.screencasts_url,
                target: "_blank"
            }, {
                title: (0, _localization2.default)("Wiki"),
                url: options.wiki_url,
                target: "_blank"
            }, {
                title: (0, _localization2.default)("How to Cite Galaxy"),
                url: options.citation_url,
                target: "_blank"
            }, {
                title: (0, _localization2.default)("Interactive Tours"),
                url: "tours"
            }]
        };
        if (options.terms_url) {
            helpTab.menu.push({
                title: (0, _localization2.default)("Terms and Conditions"),
                url: options.terms_url,
                target: "_blank"
            });
        }
        if (options.biostar_url) {
            helpTab.menu.unshift({
                title: (0, _localization2.default)("Ask a question"),
                url: "biostar/biostar_question_redirect",
                target: "_blank"
            });
        }
        if (options.biostar_url) {
            helpTab.menu.unshift({
                title: (0, _localization2.default)("Galaxy Biostar"),
                url: options.biostar_url_redirect,
                target: "_blank"
            });
        }
        this.add(helpTab);

        //
        // User tab.
        //
        var userTab = {};
        if (!Galaxy.user.id) {
            if (options.allow_user_creation) {
                userTab = {
                    id: "user",
                    title: (0, _localization2.default)("Login or Register"),
                    cls: "loggedout-only",
                    tooltip: (0, _localization2.default)("Account registration or login"),
                    menu: [{
                        title: (0, _localization2.default)("Login"),
                        url: "user/login",
                        target: "galaxy_main",
                        noscratchbook: true
                    }, {
                        title: (0, _localization2.default)("Register"),
                        url: "user/create",
                        target: "galaxy_main",
                        noscratchbook: true
                    }]
                };
            } else {
                userTab = {
                    id: "user",
                    title: (0, _localization2.default)("Login"),
                    cls: "loggedout-only",
                    tooltip: (0, _localization2.default)("Login"),
                    url: "user/login",
                    target: "galaxy_main",
                    noscratchbook: true
                };
            }
        } else {
            userTab = {
                id: "user",
                title: (0, _localization2.default)("User"),
                cls: "loggedin-only",
                tooltip: (0, _localization2.default)("Account and saved data"),
                menu: [{
                    title: (0, _localization2.default)("Logged in as") + " " + Galaxy.user.get("email")
                }, {
                    title: (0, _localization2.default)("Preferences"),
                    url: "user",
                    target: "__use_router__"
                }, {
                    title: (0, _localization2.default)("Custom Builds"),
                    url: "custom_builds",
                    target: "__use_router__"
                }, {
                    title: (0, _localization2.default)("Logout"),
                    url: "user/logout?session_csrf_token=" + Galaxy.session_csrf_token,
                    target: "_top",
                    divider: true
                }, {
                    title: (0, _localization2.default)("Saved Datasets"),
                    url: "datasets/list",
                    target: "__use_router__"
                }, {
                    title: (0, _localization2.default)("Saved Histories"),
                    url: "histories/list",
                    target: "__use_router__"
                }, {
                    title: (0, _localization2.default)("Saved Pages"),
                    url: "pages/list",
                    target: "__use_router__"
                }, {
                    title: (0, _localization2.default)("Saved Visualizations"),
                    url: "visualizations/list",
                    target: "__use_router__"
                }]
            };
        }
        this.add(userTab);
        return new $.Deferred().resolve().promise();
    }
});

/** Masthead tab **/
var Tab = Backbone.View.extend({
    initialize: function initialize(options) {
        this.model = options.model;
        this.setElement(this._template());
        this.$link = this.$(".nav-link");
        this.$note = this.$(".nav-note");
        this.$menu = this.$(".dropdown-menu");
        this.listenTo(this.model, "change", this.render, this);
    },

    events: {
        "click .nav-link": "_toggleClick"
    },

    render: function render() {
        var _this = this;

        $(".tooltip").remove();
        this.$el.removeClass().addClass(this.model.get("disabled") && "disabled").addClass(this.model.get("active") && "active").addClass(this.model.get("menu") && "dropdown").attr("id", this.model.id).css({
            visibility: this.model.get("visible") && "visible" || "hidden"
        });
        this.model.set("url", this._formatUrl(this.model.get("url")));
        this.$note.html(this.model.get("note") || "").removeClass().addClass("nav-note").addClass(this.model.get("note_cls")).css({
            display: this.model.get("show_note") && "block" || "none"
        });
        this.$link.html(this.model.get("title") || "").removeClass().addClass("nav-link").addClass(this.model.get("cls")).addClass(this.model.get("icon") && "nav-icon fa " + this.model.get("icon")).addClass(this.model.get("menu") && "dropdown-toggle").addClass(this.model.get("toggle") && "toggle").attr("target", this.model.get("target")).attr("href", this.model.get("url")).attr("title", this.model.get("tooltip")).tooltip("dispose");
        if (this.model.get("tooltip")) {
            this.$link.tooltip({ placement: "bottom" });
        }
        if (this.model.get("menu") && this.model.get("show_menu")) {
            this.$menu.show();
            $("#dd-helper").show().off().on("click", function () {
                $("#dd-helper").hide();
                _this.model.set("show_menu", false);
            });
        } else {
            this.$menu.hide();
            $("#dd-helper").hide();
        }
        this.$menu.empty().removeClass();
        if (this.model.get("menu")) {
            _.each(this.model.get("menu"), function (menuItem) {
                _this.$menu.append(_this._buildMenuItem(menuItem));
                if (menuItem.divider) {
                    _this.$menu.append($("<div/>").addClass("dropdown-divider"));
                }
            });
            this.$menu.addClass("dropdown-menu");
            this.$link.append($("<b/>").addClass("caret"));
        }
        return this;
    },

    /** Add new menu item */
    _buildMenuItem: function _buildMenuItem(options) {
        var _this2 = this;

        options = _.defaults(options || {}, {
            title: "",
            url: "",
            target: "_parent",
            noscratchbook: false
        });
        options.url = this._formatUrl(options.url);
        return $("<a/>").addClass("dropdown-item").attr("href", options.url).attr("target", options.target).html(options.title).on("click", function (e) {
            e.preventDefault();
            _this2.model.set("show_menu", false);
            if (options.onclick) {
                options.onclick();
            } else {
                if (options.target == "__use_router__" && typeof Galaxy.page != "undefined") {
                    Galaxy.page.router.push(options.url);
                } else {
                    Galaxy.frame.add(options);
                }
            }
        });
    },

    buildLink: function buildLink(label, url) {
        return $("<div/>").append($("<a/>").attr("href", Galaxy.root + url).html(label)).html();
    },

    /** Handle click event */
    _toggleClick: function _toggleClick(e) {
        var _this3 = this;

        var model = this.model;
        e.preventDefault();
        $(".tooltip").hide();
        model.trigger("dispatch", function (m) {
            if (model.id !== m.id && m.get("menu")) {
                m.set("show_menu", false);
            }
        });
        if (!model.get("disabled")) {
            if (!model.get("menu")) {
                if (model.get("onclick")) {
                    model.get("onclick")();
                } else {
                    if (model.attributes.target == "__use_router__" && typeof Galaxy.page != "undefined") {
                        Galaxy.page.router.push(model.attributes.url);
                    } else {
                        Galaxy.frame.add(model.attributes);
                    }
                }
            } else {
                model.set("show_menu", true);
            }
        } else {
            if (this.$link.popover) {
                this.$link.popover("dispose");
            }
            this.$link.popover({
                html: true,
                placement: "bottom",
                content: "Please " + this.buildLink("login", "user/login?use_panels=True") + " or " + this.buildLink("register", "user/create?use_panels=True") + " to use this feature."
            }).popover("show");
            window.setTimeout(function () {
                _this3.$link.popover("dispose");
            }, 3000);
        }
    },

    /** Url formatting */
    _formatUrl: function _formatUrl(url) {
        return typeof url == "string" && url.indexOf("//") === -1 && url.charAt(0) != "/" ? Galaxy.root + url : url;
    },

    /** body tempate */
    _template: function _template() {
        return "\n            <li class=\"nav-item\">\n                <a class=\"nav-link\"/>\n                <div class=\"nav-note\"/>\n                <div class=\"dropdown-menu\"/>\n            </li>";
    }
});

exports.default = {
    Collection: Collection,
    Tab: Tab
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CommunicationServerView = undefined;

var _backbone = __webpack_require__(7);

var Backbone = _interopRequireWildcard(_backbone);

var _underscore = __webpack_require__(1);

var _ = _interopRequireWildcard(_underscore);

var _localization = __webpack_require__(3);

var _localization2 = _interopRequireDefault(_localization);

var _uiModal = __webpack_require__(19);

var _uiModal2 = _interopRequireDefault(_uiModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/* global $ */

/** Real-time Communication feature **/
var CommunicationServerView = exports.CommunicationServerView = Backbone.View.extend({
    initialize: function initialize() {
        this.modal = null;
    },

    /** makes bootstrap modal and iframe inside it */
    makeModalIframe: function makeModalIframe(e) {
        // make modal
        var host = window.Galaxy.config.communication_server_host;

        var port = window.Galaxy.config.communication_server_port;
        var username = _.escape(window.Galaxy.user.attributes.username);

        var persistent_communication_rooms = _.escape(window.Galaxy.config.persistent_communication_rooms);

        var query_string = "?username=" + username + "&persistent_communication_rooms=" + persistent_communication_rooms;

        var src = host + ":" + port + query_string;
        var $el_chat_modal_header = null;
        var $el_chat_modal_body = null;

        var iframe_template = "<iframe class=\"f-iframe fade in communication-iframe\" src=\"" + src + "\"> </iframe>";

        var header_template = '<i class="fa fa-comment" aria-hidden="true" title="Communicate with other users"></i>' + '<i class="fa fa-expand expand-compress-modal" aria-hidden="true" title="Maximize"></i>' + '<i class="fa fa-times close-modal" aria-hidden="true" title="Close"></i>';

        var frame_height = 350;
        var frame_width = 600;
        var class_names = "ui-modal chat-modal";

        // deletes the chat modal if already present and create one
        if ($(".chat-modal").length > 0) {
            $(".chat-modal").remove();
        }
        // creates a modal
        CommunicationServerView.modal = new _uiModal2.default.View({
            body: iframe_template,
            height: frame_height,
            width: frame_width,
            closing_events: true,
            title_separator: false,
            cls: class_names
        });

        // shows modal
        CommunicationServerView.modal.show();
        $el_chat_modal_header = $(".chat-modal .modal-header");
        $el_chat_modal_body = $(".chat-modal .modal-body");
        // adjusts the css of bootstrap modal for chat
        $el_chat_modal_header.addClass("modal-header-body");
        $el_chat_modal_body.addClass("modal-header-body");
        $el_chat_modal_header.find("h4").remove();
        $el_chat_modal_header.removeAttr("min-height padding border");
        $el_chat_modal_header.append(header_template);
        // click event of the close button for chat
        $(".close-modal").click(function (e) {
            $(".chat-modal").css("display", "none");
        });
        // click event of expand and compress icon
        $(".expand-compress-modal").click(function (e) {
            if ($(".expand-compress-modal").hasClass("fa-expand")) {
                $(".chat-modal .modal-dialog").width("1000px");
                $(".chat-modal .modal-body").height("575px");
                $(".expand-compress-modal").removeClass("fa-expand").addClass("fa-compress");
                $(".expand-compress-modal").attr("title", "Minimize");
                $(".expand-compress-modal").css("margin-left", "96.2%");
            } else {
                $(".chat-modal .modal-dialog").width(frame_width + "px");
                $(".chat-modal .modal-body").height(frame_height + "px");
                $(".expand-compress-modal").removeClass("fa-compress").addClass("fa-expand");
                $(".expand-compress-modal").attr("title", "Maximize");
                $(".expand-compress-modal").css("margin-left", "93.2%");
            }
        });
        return this;
    },

    /**renders the chat icon as a nav item*/
    render: function render() {
        var self = this;
        var navItem = {};
        navItem = {
            id: "show-chat-online",
            icon: "fa-comment-o",
            tooltip: (0, _localization2.default)("Chat online"),
            visible: false,
            onclick: self.makeModalIframe
        };
        return navItem;
    }
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _backbone = __webpack_require__(7);

var Backbone = _interopRequireWildcard(_backbone);

var _underscore = __webpack_require__(1);

var _ = _interopRequireWildcard(_underscore);

var _uiFrames = __webpack_require__(82);

var _uiFrames2 = _interopRequireDefault(_uiFrames);

var _data = __webpack_require__(15);

var _data2 = _interopRequireDefault(_data);

var _visualization = __webpack_require__(16);

var _visualization2 = _interopRequireDefault(_visualization);

var _trackster = __webpack_require__(66);

var _trackster2 = _interopRequireDefault(_trackster);

var _localization = __webpack_require__(3);

var _localization2 = _interopRequireDefault(_localization);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/* global Galaxy */
/* global $ */

exports.default = Backbone.View.extend({
    initialize: function initialize(options) {
        var _this = this;

        options = options || {};
        this.frames = new _uiFrames2.default.View({ visible: false });
        this.setElement(this.frames.$el);
        this.active = false;
        this.buttonActive = options.collection.add({
            id: "enable-scratchbook",
            icon: "fa-th",
            tooltip: (0, _localization2.default)("Enable/Disable Scratchbook"),
            onclick: function onclick() {
                _this.active = !_this.active;
                _this.buttonActive.set({
                    toggle: _this.active,
                    show_note: _this.active,
                    note_cls: _this.active && "fa fa-check"
                });
                if (!_this.active) {
                    _this.frames.hide();
                }
            },
            onbeforeunload: function onbeforeunload() {
                if (_this.frames.length() > 0) {
                    return "You opened " + _this.frames.length() + " frame(s) which will be lost.";
                }
            }
        });
        this.buttonLoad = options.collection.add({
            id: "show-scratchbook",
            icon: "fa-eye",
            tooltip: (0, _localization2.default)("Show/Hide Scratchbook"),
            show_note: true,
            visible: false,
            onclick: function onclick(e) {
                if (_this.frames.visible) {
                    _this.frames.hide();
                } else {
                    _this.frames.show();
                }
            }
        });
        this.frames.on("add remove", function () {
            if (_this.frames.visible && _this.frames.length() === 0) {
                _this.frames.hide();
            }
            _this.buttonLoad.set({
                note: _this.frames.length(),
                visible: _this.frames.length() > 0
            });
        }).on("show hide ", function () {
            _this.buttonLoad.set({
                toggle: _this.frames.visible,
                icon: _this.frames.visible && "fa-eye" || "fa-eye-slash"
            });
        });
        this.history_cache = {};
    },

    /** Add a dataset to the frames */
    addDataset: function addDataset(dataset_id) {
        var self = this;
        var current_dataset = null;
        if (Galaxy && Galaxy.currHistoryPanel) {
            var history_id = Galaxy.currHistoryPanel.collection.historyId;
            this.history_cache[history_id] = {
                name: Galaxy.currHistoryPanel.model.get("name"),
                dataset_ids: []
            };
            Galaxy.currHistoryPanel.collection.each(function (model) {
                if (!model.get("deleted") && model.get("visible")) {
                    self.history_cache[history_id].dataset_ids.push(model.get("id"));
                }
            });
        }
        var _findDataset = function _findDataset(dataset, offset) {
            if (dataset) {
                var history_details = self.history_cache[dataset.get("history_id")];
                if (history_details && history_details.dataset_ids) {
                    var dataset_list = history_details.dataset_ids;
                    var pos = dataset_list.indexOf(dataset.get("id"));
                    if (pos !== -1 && pos + offset >= 0 && pos + offset < dataset_list.length) {
                        return dataset_list[pos + offset];
                    }
                }
            }
        };
        var _loadDatasetOffset = function _loadDatasetOffset(dataset, offset, frame) {
            var new_dataset_id = _findDataset(dataset, offset);
            if (new_dataset_id) {
                self._loadDataset(new_dataset_id, function (new_dataset, config) {
                    current_dataset = new_dataset;
                    frame.model.set(config);
                });
            } else {
                frame.model.trigger("change");
            }
        };
        this._loadDataset(dataset_id, function (dataset, config) {
            current_dataset = dataset;
            self.add(_.extend({
                menu: [{
                    icon: "fa fa-chevron-circle-left",
                    tooltip: (0, _localization2.default)("Previous in History"),
                    onclick: function onclick(frame) {
                        _loadDatasetOffset(current_dataset, -1, frame);
                    },
                    disabled: function disabled() {
                        return !_findDataset(current_dataset, -1);
                    }
                }, {
                    icon: "fa fa-chevron-circle-right",
                    tooltip: (0, _localization2.default)("Next in History"),
                    onclick: function onclick(frame) {
                        _loadDatasetOffset(current_dataset, 1, frame);
                    },
                    disabled: function disabled() {
                        return !_findDataset(current_dataset, 1);
                    }
                }]
            }, config));
        });
    },

    _loadDataset: function _loadDataset(dataset_id, callback) {
        var self = this;
        var dataset = new _data2.default.Dataset({ id: dataset_id });
        $.when(dataset.fetch()).then(function () {
            var is_tabular = _.find(["tabular", "interval"], function (data_type) {
                return dataset.get("data_type").indexOf(data_type) !== -1;
            });
            var title = dataset.get("name");
            var history_details = self.history_cache[dataset.get("history_id")];
            if (history_details) {
                title = history_details.name + ": " + title;
            }
            callback(dataset, is_tabular ? {
                title: title,
                url: null,
                content: _data2.default.createTabularDatasetChunkedView({
                    model: new _data2.default.TabularDataset(dataset.toJSON()),
                    embedded: true,
                    height: "100%"
                }).$el
            } : {
                title: title,
                url: Galaxy.root + "datasets/" + dataset_id + "/display/?preview=True",
                content: null
            });
        });
    },

    /** Add a trackster visualization to the frames. */
    addTrackster: function addTrackster(viz_id) {
        var self = this;
        var viz = new _visualization2.default.Visualization({ id: viz_id });
        $.when(viz.fetch()).then(function () {
            var ui = new _trackster2.default.TracksterUI(Galaxy.root);

            // Construct frame config based on dataset's type.
            var frame_config = {
                title: viz.get("name"),
                type: "other",
                content: function content(parent_elt) {
                    // Create view config.
                    var view_config = {
                        container: parent_elt,
                        name: viz.get("title"),
                        id: viz.id,
                        // FIXME: this will not work with custom builds b/c the dbkey needed to be encoded.
                        dbkey: viz.get("dbkey"),
                        stand_alone: false
                    };

                    var latest_revision = viz.get("latest_revision");
                    var drawables = latest_revision.config.view.drawables;

                    // Set up datasets in drawables.
                    _.each(drawables, function (d) {
                        d.dataset = {
                            hda_ldda: d.hda_ldda,
                            id: d.dataset_id
                        };
                    });
                    ui.create_visualization(view_config, latest_revision.config.viewport, latest_revision.config.view.drawables, latest_revision.config.bookmarks, false);
                }
            };
            self.add(frame_config);
        });
    },

    /** Add and display a new frame/window based on options. */
    add: function add(options) {
        if (options.target == "_blank") {
            window.open(options.url);
        } else if (options.target == "_top" || options.target == "_parent" || options.target == "_self") {
            window.location = options.url;
        } else if (!this.active || options.noscratchbook) {
            var $galaxy_main = $(window.parent.document).find("#galaxy_main");
            if (options.target == "galaxy_main" || options.target == "center") {
                if ($galaxy_main.length === 0) {
                    window.location = this._build_url(options.url, { use_panels: true });
                } else {
                    $galaxy_main.attr("src", options.url);
                }
            } else window.location = options.url;
        } else {
            options.url = this._build_url(options.url, { hide_panels: true, hide_masthead: true });
            this.frames.add(options);
        }
    },

    /** Url helper */
    _build_url: function _build_url(url, options) {
        if (url) {
            url += url.indexOf("?") == -1 ? "?" : "&";
            url += $.param(options, true);
            return url;
        }
    }
}); /** Frame manager uses the ui-frames to create the scratch book masthead icon and functionality **/
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _localization = __webpack_require__(3);

var _localization2 = _interopRequireDefault(_localization);

var _backbone = __webpack_require__(7);

var Backbone = _interopRequireWildcard(_backbone);

var _underscore = __webpack_require__(1);

var _ = _interopRequireWildcard(_underscore);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global $ */
/* global Galaxy */

var FrameView = Backbone.View.extend({
    initialize: function initialize(options) {
        this.model = options && options.model || new Backbone.Model(options);
        this.setElement($("<div/>").addClass("corner frame"));
        this.$el.append($("<div/>").addClass("f-header corner").append($("<div/>").addClass("f-title")).append($("<div/>").addClass("f-icon f-close fa fa-close").tooltip({
            title: (0, _localization2.default)("Close"),
            placement: "bottom"
        }))).append($("<div/>").addClass("f-content")).append($("<div/>").addClass("f-resize f-icon corner fa fa-expand").tooltip({ title: "Resize" })).append($("<div/>").addClass("f-cover"));
        this.$header = this.$(".f-header");
        this.$title = this.$(".f-title");
        this.$content = this.$(".f-content");
        this.render();
        this.listenTo(this.model, "change", this.render, this);
    },

    render: function render() {
        var self = this;
        var options = this.model.attributes;
        this.$title.html(options.title || "");
        this.$header.find(".f-icon-left").remove();
        _.each(options.menu, function (option) {
            var $option = $("<div/>").addClass("f-icon-left").addClass(option.icon);
            if (_.isFunction(option.disabled) && option.disabled()) {
                $option.attr("disabled", true);
            } else {
                $option.on("click", function () {
                    option.onclick(self);
                }).tooltip({
                    title: option.tooltip || "",
                    placement: "bottom"
                });
            }
            self.$header.append($option);
        });
        if (options.url) {
            this.$content.html($("<iframe/>").addClass("f-iframe").attr("scrolling", "auto").attr("src", options.url + (options.url.indexOf("?") === -1 ? "?" : "&") + "widget=True"));
        } else if (options.content) {
            if (_.isFunction(options.content)) {
                options.content(self.$content);
            } else {
                self.$content.html(options.content);
            }
        }
    }
});

/** Scratchbook viewer */
/** Frame view */
var View = Backbone.View.extend({
    defaultOptions: {
        frame: {
            // default frame size in cells
            cols: 6,
            rows: 3
        },
        rows: 1000, // maximum number of rows
        cell: 130, // cell size in px
        margin: 5, // margin between frames
        scroll: 5, // scroll speed
        top_min: 40, // top margin
        frame_max: 9, // maximum number of frames
        visible: true // initial visibility
    },

    cols: 0, // number of columns
    top: 0, // scroll/element top
    top_max: 0, // viewport scrolling state
    frame_z: 0, // frame z-index
    frame_counter: 0, // frame counter
    frame_uid: 0, // unique frame id counter
    frame_list: {}, // list of all frames
    frame_shadow: null, // frame shown as placeholder when moving active frames
    visible: false, // flag indicating if scratchbook viewer is visible or not
    event: {}, // dictionary keeping track of current event

    initialize: function initialize(options) {
        var self = this;
        this.options = _.defaults(options || {}, this.defaultOptions);
        this.visible = this.options.visible;
        this.top = this.top_max = this.options.top_min;
        this.setElement($("<div/>").addClass("galaxy-frame").append($("<div/>").addClass("frame-background")).append($("<div/>").addClass("frame-menu frame-scroll-up fa fa-chevron-up fa-2x")).append($("<div/>").addClass("frame-menu frame-scroll-down fa fa-chevron-down fa-2x")));

        // initialize shadow to guiding drag/resize events
        this.frame_shadow = new Backbone.View({
            el: $("<div/>").addClass("corner frame-shadow")
        });
        this.$el.append(this.frame_shadow.$el);
        this._frameInit(this.frame_shadow, "#frame-shadow");
        this._frameResize(this.frame_shadow, { width: 0, height: 0 });
        this.frame_list["#frame-shadow"] = this.frame_shadow;

        // initialize panel
        if (this.visible) {
            this.show();
        } else {
            this.hide();
        }
        this._panelRefresh();
        $(window).resize(function () {
            if (self.visible) {
                self._panelRefresh();
            }
        });
    },

    /** Render */
    render: function render() {
        this.$(".frame-scroll-up")[this.top != this.options.top_min && "show" || "hide"]();
        this.$(".frame-scroll-down")[this.top != this.top_max && "show" || "hide"]();
    },

    /**
     * Adds and displays a new frame.
     *
     * options:
     *  url     : loaded into an iframe
     *  content : content is treated as a function or raw HTML, function is passed a single
     *              argument that is the frame's content DOM element
     */
    add: function add(options) {
        if (this.frame_counter >= this.options.frame_max) {
            Galaxy.modal.show({
                title: (0, _localization2.default)("Warning"),
                body: "You have reached the maximum number of allowed frames (" + this.options.frame_max + ").",
                buttons: {
                    Close: function Close() {
                        Galaxy.modal.hide();
                    }
                }
            });
        } else {
            var frame_id = "#frame-" + this.frame_uid++;
            if ($(frame_id).length !== 0) {
                Galaxy.modal.show({
                    title: (0, _localization2.default)("Error"),
                    body: "This frame already exists. This page might contain multiple frame managers.",
                    buttons: {
                        Close: function Close() {
                            Galaxy.modal.hide();
                        }
                    }
                });
            } else {
                // initialize new frame elements
                this.top = this.options.top_min;
                var frame = new FrameView(options);
                this.$el.append(frame.$el);

                // set dimensions
                options.width = this._toPixelCoord("width", this.options.frame.cols);
                options.height = this._toPixelCoord("height", this.options.frame.rows);

                // set default z-index and add to ui and frame list
                this.frame_z = parseInt(frame.$el.css("z-index"));
                this.frame_list[frame_id] = frame;
                this.frame_counter++;
                this._frameInit(frame, frame_id);
                this._frameResize(frame, {
                    width: options.width,
                    height: options.height
                });
                this._frameInsert(frame, { top: 0, left: 0 }, true);
                if (!this.visible) {
                    this.show();
                }
                this.trigger("add");
            }
        }
    },

    /** Remove a frame */
    del: function del(frame) {
        var self = this;
        var $frame = frame.$el;
        $frame.fadeOut("fast", function () {
            $frame.remove();
            delete self.frame_list[frame.id];
            self.frame_counter--;
            self._panelRefresh(true);
            self._panelAnimationComplete();
            self.trigger("remove");
        });
    },

    /** Show panel */
    show: function show() {
        this.visible = true;
        this.$el.fadeIn("fast");
        this.trigger("show");
    },

    /** Hide panel */
    hide: function hide() {
        if (!this.event.type) {
            this.visible = false;
            this.$el.fadeOut("fast", function () {
                $(this).hide();
            });
            this.trigger("hide");
        }
    },

    /** Returns the number of frames */
    length: function length() {
        return this.frame_counter;
    },

    /*
        EVENT HANDLING
    */
    events: {
        // global frame events
        mousemove: "_eventFrameMouseMove",
        mouseup: "_eventFrameMouseUp",
        mouseleave: "_eventFrameMouseUp",
        mousewheel: "_eventPanelScroll",
        DOMMouseScroll: "_eventPanelScroll",

        // events fixed to elements
        "mousedown .frame": "_eventFrameMouseDown",
        "mousedown .frame-background": "_eventHide",
        "mousedown .frame-scroll-up": "_eventPanelScroll_up",
        "mousedown .frame-scroll-down": "_eventPanelScroll_down",
        "mousedown .f-close": "_eventFrameClose"
    },

    /** Start drag/resize event */
    _eventFrameMouseDown: function _eventFrameMouseDown(e) {
        $(".tooltip").hide();
        if (!this.event.type) {
            if ($(e.target).hasClass("f-header") || $(e.target).hasClass("f-title")) {
                this.event.type = "drag";
            }
            if ($(e.target).hasClass("f-resize")) {
                this.event.type = "resize";
            }
            if (this.event.type) {
                e.preventDefault();
                this.event.target = this._frameIdentify(e.target);
                this.event.xy = {
                    x: e.originalEvent.pageX,
                    y: e.originalEvent.pageY
                };
                this._frameDragStart(this.event.target);
            }
        }
    },

    /** Processes drag/resize events */
    _eventFrameMouseMove: function _eventFrameMouseMove(e) {
        if (this.event.type) {
            // get mouse motion and delta
            var event_xy_new = {
                x: e.originalEvent.pageX,
                y: e.originalEvent.pageY
            };
            var event_xy_delta = {
                x: event_xy_new.x - this.event.xy.x,
                y: event_xy_new.y - this.event.xy.y
            };
            this.event.xy = event_xy_new;

            // get current screen position and size of frame
            var p = this._frameScreen(this.event.target);

            // drag/resize event
            if (this.event.type == "resize") {
                p.width += event_xy_delta.x;
                p.height += event_xy_delta.y;
                var min_dim = this.options.cell - this.options.margin - 1;
                p.width = Math.max(p.width, min_dim);
                p.height = Math.max(p.height, min_dim);
                this._frameResize(this.event.target, p);
                p.width = this._toGridCoord("width", p.width) + 1;
                p.height = this._toGridCoord("height", p.height) + 1;
                p.width = this._toPixelCoord("width", p.width);
                p.height = this._toPixelCoord("height", p.height);
                this._frameResize(this.frame_shadow, p);
                this._frameInsert(this.frame_shadow, {
                    top: this._toGridCoord("top", p.top),
                    left: this._toGridCoord("left", p.left)
                });
            } else if (this.event.type == "drag") {
                p.left += event_xy_delta.x;
                p.top += event_xy_delta.y;
                this._frameOffset(this.event.target, p);
                var l = {
                    top: this._toGridCoord("top", p.top),
                    left: this._toGridCoord("left", p.left)
                };
                if (l.left !== 0) {
                    l.left++;
                }
                this._frameInsert(this.frame_shadow, l);
            }
        }
    },

    /** Stop drag/resize events */
    _eventFrameMouseUp: function _eventFrameMouseUp(e) {
        if (this.event.type) {
            this._frameDragStop(this.event.target);
            this.event.type = null;
        }
    },

    /** Destroy a frame */
    _eventFrameClose: function _eventFrameClose(e) {
        if (!this.event.type) {
            e.preventDefault();
            this.del(this._frameIdentify(e.target));
        }
    },

    /** Hide all frames */
    _eventHide: function _eventHide(e) {
        if (!this.event.type) {
            this.hide();
        }
    },

    /** Fired when scrolling occurs on panel */
    _eventPanelScroll: function _eventPanelScroll(e) {
        if (!this.event.type && this.visible) {
            // Stop propagation if scrolling is happening inside a frame.
            // TODO: could propagate scrolling if at top/bottom of frame.
            var frames = $(e.srcElement).parents(".frame");
            if (frames.length !== 0) {
                e.stopPropagation();
            } else {
                e.preventDefault();
                this._panelScroll(e.originalEvent.detail ? e.originalEvent.detail : e.originalEvent.wheelDelta / -3);
            }
        }
    },

    /** Handle scroll up event */
    _eventPanelScroll_up: function _eventPanelScroll_up(e) {
        if (!this.event.type) {
            e.preventDefault();
            this._panelScroll(-this.options.scroll);
        }
    },

    /** Handle scroll down */
    _eventPanelScroll_down: function _eventPanelScroll_down(e) {
        if (!this.event.type) {
            e.preventDefault();
            this._panelScroll(this.options.scroll);
        }
    },

    /*
        FRAME EVENTS SUPPORT
    */

    /** Identify the target frame */
    _frameIdentify: function _frameIdentify(target) {
        return this.frame_list["#" + $(target).closest(".frame").attr("id")];
    },

    /** Provides drag support */
    _frameDragStart: function _frameDragStart(frame) {
        this._frameFocus(frame, true);
        var p = this._frameScreen(frame);
        this._frameResize(this.frame_shadow, p);
        this._frameGrid(this.frame_shadow, frame.grid_location);
        frame.grid_location = null;
        this.frame_shadow.$el.show();
        $(".f-cover").show();
    },

    /** Removes drag support */
    _frameDragStop: function _frameDragStop(frame) {
        this._frameFocus(frame, false);
        var p = this._frameScreen(this.frame_shadow);
        this._frameResize(frame, p);
        this._frameGrid(frame, this.frame_shadow.grid_location, true);
        this.frame_shadow.grid_location = null;
        this.frame_shadow.$el.hide();
        $(".f-cover").hide();
        this._panelAnimationComplete();
    },

    /*
        GRID/PIXEL CONVERTER
    */

    /** Converts a pixel to a grid dimension */
    _toGridCoord: function _toGridCoord(type, px) {
        var sign = type == "width" || type == "height" ? 1 : -1;
        if (type == "top") {
            px -= this.top;
        }
        return parseInt((px + sign * this.options.margin) / this.options.cell, 10);
    },

    /** Converts a grid to a pixels dimension */
    _toPixelCoord: function _toPixelCoord(type, g) {
        var sign = type == "width" || type == "height" ? 1 : -1;
        var px = g * this.options.cell - sign * this.options.margin;
        if (type == "top") {
            px += this.top;
        }
        return px;
    },

    /** Converts a pixel to a grid coordinate set */
    _toGrid: function _toGrid(px) {
        return {
            top: this._toGridCoord("top", px.top),
            left: this._toGridCoord("left", px.left),
            width: this._toGridCoord("width", px.width),
            height: this._toGridCoord("height", px.height)
        };
    },

    /** Converts a pixel to a grid coordinate set */
    _toPixel: function _toPixel(g) {
        return {
            top: this._toPixelCoord("top", g.top),
            left: this._toPixelCoord("left", g.left),
            width: this._toPixelCoord("width", g.width),
            height: this._toPixelCoord("height", g.height)
        };
    },

    /* 
        COLLISION DETECTION
    */

    /** Check collisions for a grid coordinate set */
    _isCollision: function _isCollision(g) {
        function is_collision_pair(a, b) {
            return !(a.left > b.left + b.width - 1 || a.left + a.width - 1 < b.left || a.top > b.top + b.height - 1 || a.top + a.height - 1 < b.top);
        }
        for (var i in this.frame_list) {
            var frame = this.frame_list[i];
            if (frame.grid_location !== null && is_collision_pair(g, frame.grid_location)) {
                return true;
            }
        }
        return false;
    },

    /** Return location/grid rank */
    _locationRank: function _locationRank(loc) {
        return loc.top * this.cols + loc.left;
    },

    /*
        PANEL/WINDOW FUNCTIONS
    */

    /** Refresh panel */
    _panelRefresh: function _panelRefresh(animate) {
        this.cols = parseInt($(window).width() / this.options.cell, 10) + 1;
        this._frameInsert(null, null, animate);
    },

    /** Complete panel animation / frames not moving */
    _panelAnimationComplete: function _panelAnimationComplete() {
        var self = this;
        $(".frame").promise().done(function () {
            self._panelScroll(0, true);
        });
    },

    /** Scroll panel */
    _panelScroll: function _panelScroll(delta, animate) {
        var top_new = this.top - this.options.scroll * delta;
        top_new = Math.max(top_new, this.top_max);
        top_new = Math.min(top_new, this.options.top_min);
        if (this.top != top_new) {
            for (var i in this.frame_list) {
                var frame = this.frame_list[i];
                if (frame.grid_location !== null) {
                    var screen_location = {
                        top: frame.screen_location.top - (this.top - top_new),
                        left: frame.screen_location.left
                    };
                    this._frameOffset(frame, screen_location, animate);
                }
            }
            this.top = top_new;
        }
        this.render();
    },

    /*
        FRAME FUNCTIONS
    */

    /** Initialize a new frame */
    _frameInit: function _frameInit(frame, id) {
        frame.id = id;
        frame.screen_location = {};
        frame.grid_location = {};
        frame.grid_rank = null;
        frame.$el.attr("id", id.substring(1));
    },

    /** Insert frame at given location */
    _frameInsert: function _frameInsert(frame, new_loc, animate) {
        var self = this;
        var place_list = [];
        if (frame) {
            frame.grid_location = null;
            place_list.push([frame, this._locationRank(new_loc)]);
        }
        _.each(this.frame_list, function (f) {
            if (f.grid_location !== null) {
                f.grid_location = null;
                place_list.push([f, f.grid_rank]);
            }
        });
        place_list.sort(function (a, b) {
            return a[1] < b[1] ? -1 : a[1] > b[1] ? 1 : 0;
        });
        _.each(place_list, function (place) {
            self._framePlace(place[0], animate);
        });
        this.top_max = 0;
        _.each(this.frame_list, function (f) {
            if (f.grid_location !== null) {
                self.top_max = Math.max(self.top_max, f.grid_location.top + f.grid_location.height);
            }
        });
        this.top_max = $(window).height() - this.top_max * this.options.cell - 2 * this.options.margin;
        this.top_max = Math.min(this.top_max, this.options.top_min);
        this.render();
    },

    /** Naive frame placement */
    _framePlace: function _framePlace(frame, animate) {
        frame.grid_location = null;
        var g = this._toGrid(this._frameScreen(frame));
        var done = false;
        for (var i = 0; i < this.options.rows; i++) {
            for (var j = 0; j < Math.max(1, this.cols - g.width); j++) {
                g.top = i;
                g.left = j;
                if (!this._isCollision(g)) {
                    done = true;
                    break;
                }
            }
            if (done) {
                break;
            }
        }
        if (done) {
            this._frameGrid(frame, g, animate);
        } else {
            console.log("Grid dimensions exceeded.");
        }
    },

    /** Handle frame focussing */
    _frameFocus: function _frameFocus(frame, has_focus) {
        frame.$el.css("z-index", this.frame_z + (has_focus ? 1 : 0));
    },

    /** New left/top position frame */
    _frameOffset: function _frameOffset(frame, p, animate) {
        frame.screen_location.left = p.left;
        frame.screen_location.top = p.top;
        if (animate) {
            this._frameFocus(frame, true);
            var self = this;
            frame.$el.animate({ top: p.top, left: p.left }, "fast", function () {
                self._frameFocus(frame, false);
            });
        } else {
            frame.$el.css({ top: p.top, left: p.left });
        }
    },

    /** Resize frame */
    _frameResize: function _frameResize(frame, p) {
        frame.$el.css({ width: p.width, height: p.height });
        frame.screen_location.width = p.width;
        frame.screen_location.height = p.height;
    },

    /** Push frame to new grid location */
    _frameGrid: function _frameGrid(frame, l, animate) {
        frame.grid_location = l;
        this._frameOffset(frame, this._toPixel(l), animate);
        frame.grid_rank = this._locationRank(l);
    },

    /** Get frame dimensions */
    _frameScreen: function _frameScreen(frame) {
        var p = frame.screen_location;
        return {
            top: p.top,
            left: p.left,
            width: p.width,
            height: p.height
        };
    }
});

exports.default = {
    View: View
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Backbone, _, $) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
// dependencies

// grid model
exports.default = Backbone.Model.extend({
    defaults: {
        url_base: "",
        title_id: undefined,
        async: false,
        async_ops: [],
        categorical_filters: [],
        filters: {},
        sort_key: null,
        show_item_checkboxes: false,
        advanced_search: false,
        cur_page: 1,
        num_pages: 1,
        operation: undefined,
        item_ids: undefined
    },

    /**
     * Add filtering criterion.
     */
    add_filter: function add_filter(key, value, append) {
        // Update URL arg with new condition.
        if (append) {
            // Update or append value.
            var cur_val = this.attributes.filters[key];

            var new_val;
            if (cur_val === null || cur_val === undefined) {
                new_val = value;
            } else if (typeof cur_val == "string") {
                if (cur_val == "All" || cur_val == value) {
                    new_val = value;
                } else {
                    // Replace string with array.
                    var values = [];
                    values[0] = cur_val;
                    values[1] = value;
                    new_val = values;
                }
            } else {
                // Current value is an array.
                new_val = cur_val;
                if (new_val.indexOf(value) === -1) {
                    new_val.push(value);
                }
            }
            this.attributes.filters[key] = new_val;
        } else {
            // Replace value.
            this.attributes.filters[key] = value;
        }
    },

    /**
     * Remove filtering criterion.
     */
    remove_filter: function remove_filter(key, condition) {
        var cur_val = this.attributes.filters[key];
        if (cur_val === null || cur_val === undefined) {
            return false;
        }

        if (typeof cur_val === "string") {
            // overwrite/remove condition.
            this.attributes.filters[key] = "";
        } else {
            // filter contains an array of conditions.
            var condition_index = _.indexOf(cur_val, condition);
            if (condition_index !== -1) {
                cur_val[condition_index] = "";
            }
        }
    },

    /**
     * Returns URL data for obtaining a new grid.
     */
    get_url_data: function get_url_data() {
        var url_data = {
            async: this.attributes.async,
            sort: this.attributes.sort_key,
            page: this.attributes.cur_page,
            show_item_checkboxes: this.attributes.show_item_checkboxes,
            advanced_search: this.attributes.advanced_search
        };

        // Add operation, item_ids only if they have values.
        if (this.attributes.operation) {
            url_data.operation = this.attributes.operation;
        }
        if (this.attributes.item_ids) {
            url_data.id = this.attributes.item_ids;
        }

        // Add filter arguments to data, placing "f-" in front of all arguments.
        var self = this;
        _.each(_.pairs(self.attributes.filters), function (k) {
            url_data["f-" + k[0]] = k[1];
        });
        return url_data;
    },

    // Return URL for obtaining a new grid
    get_url: function get_url(args) {
        return this.get("url_base") + "?" + $.param(this.get_url_data()) + "&" + $.param(args);
    }
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(1), __webpack_require__(0)))

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _utils = __webpack_require__(5);

var _utils2 = _interopRequireDefault(_utils);

var _underscore = __webpack_require__(1);

var _ = _interopRequireWildcard(_underscore);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global $ */

// grid view templates
// dependencies
exports.default = {
    // template
    grid: function grid(options) {
        var tmpl = void 0;
        if (options.embedded) {
            tmpl = this.grid_header(options) + this.grid_table(options);
        } else {
            tmpl = "\n                <div class=\"loading-elt-overlay\"></div>\n                <table class=\"grid-table\">\n                    <tr>\n                        <td width=\"75%\">" + this.grid_header(options) + "</td>\n                        <td></td>\n                        <td></td>\n                    </tr>\n                    <tr>\n                        <td width=\"100%\" id=\"grid-message\" valign=\"top\"></td>\n                        <td></td>\n                        <td></td>\n                    </tr>\n                </table>\n                " + this.grid_table(options) + "\n            ";
        }

        // add info text
        if (options.info_text) {
            tmpl += "<br><div class=\"toolParamHelp\" style=\"clear: both;\">" + options.info_text + "</div>";
        }

        // return
        return tmpl;
    },

    // template
    grid_table: function grid_table() {
        return "\n            <form method=\"post\" onsubmit=\"return false;\">\n                <table id=\"grid-table\" class=\"grid\">\n                    <thead id=\"grid-table-header\"></thead>\n                    <tbody id=\"grid-table-body\"></tbody>\n                    <tfoot id=\"grid-table-footer\"></tfoot>\n                </table>\n            </form>";
    },

    // template
    grid_header: function grid_header(options) {
        var tmpl = '<div class="grid-header">';
        if (!options.embedded) {
            var id_str = "";
            if (options.title_id) {
                id_str += " id=\"" + options.title_id + "\"";
            }
            tmpl += "<h2" + id_str + ">" + options.title + "</h2>";
        }
        if (options.global_actions) {
            tmpl += '<ul class="manage-table-actions">';
            var show_popup = options.global_actions.length >= 3;
            if (show_popup) {
                tmpl += '<li><a class="action-button" id="popup-global-actions" class="menubutton">Actions</a></li>' + '<div popupmenu="popup-global-actions">';
            }
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = options.global_actions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var action = _step.value;

                    tmpl += "<li><a class=\"action-button use-target\" target=\"" + action.target + "\" href=\"" + action.url_args + "\" onclick=\"return false;\" >" + action.label + "</a></li>";
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            if (show_popup) {
                tmpl += "</div>";
            }
            tmpl += "</ul>";
        }
        if (options.insert) {
            tmpl += options.insert;
        }

        // add grid filters
        tmpl += this.grid_filters(options);
        tmpl += "</div>";

        // return template
        return tmpl;
    },

    // template
    header: function header(options) {
        // start
        var tmpl = "<tr>";

        // add checkbox
        if (options.show_item_checkboxes) {
            tmpl += "<th>";
            if (options.items.length > 0) {
                tmpl += '<input type="checkbox" id="check_all" name=select_all_checkbox value="true">' + '<input type="hidden" name=select_all_checkbox value="true">';
            }
            tmpl += "</th>";
        }

        // create header elements
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
            for (var _iterator2 = options.columns[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var column = _step2.value;

                if (column.visible) {
                    tmpl += "<th id=\"" + column.key + "-header\">";
                    if (column.sortable) {
                        tmpl += "<a href=\"javascript:void(0)\" class=\"sort-link\" sort_key=\"" + column.key + "\">" + column.label + "</a>";
                    } else {
                        tmpl += column.label;
                    }
                    tmpl += "<span class=\"sort-arrow\">" + column.extra + "</span></th>";
                }
            }

            // finalize
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                }
            } finally {
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }

        tmpl += "</tr>";

        // return template
        return tmpl;
    },

    // template
    body: function body(options) {
        // initialize
        var tmpl = "";
        var items_length = options.items.length;

        // empty grid?
        if (items_length === 0) {
            // No results.
            tmpl += '<tr><td colspan="100"><em>No Items</em></td></tr>';
        }

        // create rows
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
            for (var _iterator3 = options.items[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                var item = _step3.value;

                // Tag current
                tmpl += "<tr ";
                if (options.current_item_id == item.id) {
                    tmpl += 'class="current"';
                }
                tmpl += ">";

                // Item selection column
                if (options.show_item_checkboxes) {
                    tmpl += "<td style=\"width: 1.5em;\"><input type=\"checkbox\" name=\"id\" value=\"" + item.encode_id + "\" id=\"" + item.encode_id + "\" class=\"grid-row-select-checkbox\" /></td>";
                }

                // Data columns
                var _iteratorNormalCompletion4 = true;
                var _didIteratorError4 = false;
                var _iteratorError4 = undefined;

                try {
                    for (var _iterator4 = options.columns[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                        var column = _step4.value;

                        if (column.visible) {
                            // Nowrap
                            var nowrap = "";
                            if (column.nowrap) {
                                nowrap = 'style="white-space:nowrap;"';
                            }

                            // get column settings
                            var column_settings = item.column_config[column.label];

                            // load attributes
                            var link = column_settings.link;
                            var value = column_settings.value;
                            var target = column_settings.target;

                            // unescape value
                            if ($.type(value) === "string") {
                                value = value.replace(/\/\//g, "/");
                            }

                            // Attach popup menu?
                            var popup_id = "";
                            if (column.attach_popup) {
                                popup_id = "grid-" + item.encode_id + "-popup";
                            }

                            // Check for row wrapping
                            tmpl += "<td " + nowrap + ">";

                            // Determine cell content
                            if (column.delayed) {
                                tmpl += "<div class=\"delayed-value-" + column.key + "\" data-id=\"" + item.encode_id + "\" data-value=\"" + value + "\"><span class=\"fa fa-spinner fa-spin\"></span></div>";
                            } else if (column.attach_popup && link) {
                                tmpl += "<div class=\"btn-group\">\n                                    <button class=\"btn btn-secondary use-target\" target=\"" + target + "\" href=\"" + link + "\" onclick=\"return false;\">" + value + "</button>\n                                    <button id=\"" + popup_id + "\" class=\"btn btn-secondary dropdown-toggle dropdown-toggle-split\" data-toggle=\"dropdown\"/>\n                                </div>";
                            } else if (column.attach_popup) {
                                tmpl += "<button id=\"" + popup_id + "\" class=\"btn dropdown-toggle\" data-toggle=\"dropdown\">" + value + "</button>";
                            } else if (link) {
                                tmpl += "<a class=\"use-target\" target=\"" + target + "\" href=\"" + link + "\" onclick=\"return false;\">" + value + "</a>";
                            } else {
                                tmpl += "<label>" + (value || "") + "</label>";
                            }
                            tmpl += "</td>";
                        }
                    }
                } catch (err) {
                    _didIteratorError4 = true;
                    _iteratorError4 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion4 && _iterator4.return) {
                            _iterator4.return();
                        }
                    } finally {
                        if (_didIteratorError4) {
                            throw _iteratorError4;
                        }
                    }
                }

                tmpl += "</tr>";
            }
        } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                    _iterator3.return();
                }
            } finally {
                if (_didIteratorError3) {
                    throw _iteratorError3;
                }
            }
        }

        return tmpl;
    },

    // template
    footer: function footer(options) {
        // create template string
        var tmpl = "";

        // paging
        if (options.use_paging && options.num_pages > 1) {
            // get configuration
            var num_page_links = options.num_page_links;
            var cur_page_num = options.cur_page_num;
            var num_pages = options.num_pages;

            // First pass on min page.
            var page_link_range = num_page_links / 2;
            var min_page = cur_page_num - page_link_range;
            var min_offset = 0;
            if (min_page <= 0) {
                // Min page is too low.
                min_page = 1;
                min_offset = page_link_range - (cur_page_num - min_page);
            }

            // Set max page.
            var max_range = page_link_range + min_offset;
            var max_page = cur_page_num + max_range;
            var max_offset;
            if (max_page <= num_pages) {
                // Max page is fine.
                max_offset = 0;
            } else {
                // Max page is too high.
                max_page = num_pages;
                // +1 to account for the +1 in the loop below.
                max_offset = max_range - (max_page + 1 - cur_page_num);
            }

            // Second and final pass on min page to add any unused
            // offset from max to min.
            if (max_offset !== 0) {
                min_page -= max_offset;
                if (min_page < 1) {
                    min_page = 1;
                }
            }

            // template header
            tmpl += '<tr id="page-links-row">';
            if (options.show_item_checkboxes) {
                tmpl += "<td></td>";
            }
            tmpl += '<td colspan="100">' + '<span id="page-link-container">' + "Page:";

            if (min_page > 1) {
                tmpl += '<span class="page-link-grid" id="page-link-1"><a href="javascript:void(0);" page_num="1" onclick="return false;">1</a></span> ...';
            }

            // create page urls
            for (var page_index = min_page; page_index < max_page + 1; page_index++) {
                if (page_index == options.cur_page_num) {
                    tmpl += "<span class=\"page-link-grid inactive-link\" id=\"page-link-" + page_index + "\">" + page_index + "</span>";
                } else {
                    tmpl += "<span class=\"page-link-grid\" id=\"page-link-" + page_index + "\"><a href=\"javascript:void(0);\" onclick=\"return false;\" page_num=\"" + page_index + "\">" + page_index + "</a></span>";
                }
            }

            // show last page
            if (max_page < num_pages) {
                tmpl += "...<span class=\"page-link-grid\" id=\"page-link-" + num_pages + "\"><a href=\"javascript:void(0);\" onclick=\"return false;\" page_num=\"" + num_pages + "\">" + num_pages + "</a></span>";
            }
            tmpl += "</span>";

            // Show all link
            tmpl += "\n                    <span class=\"page-link-grid\" id=\"show-all-link-span\"> | <a href=\"javascript:void(0);\" onclick=\"return false;\" page_num=\"all\">Show All</a></span>\n                    </td>\n                </tr>";
        }

        // Grid operations for multiple items.
        if (options.show_item_checkboxes) {
            // start template
            tmpl += "\n                <tr>\n                    <input type=\"hidden\" id=\"operation\" name=\"operation\" value=\"\">\n                    <td></td>\n                    <td colspan=\"100\">\n                        For <span class=\"grid-selected-count\"></span> selected items: \n            ";

            // configure buttons for operations
            var _iteratorNormalCompletion5 = true;
            var _didIteratorError5 = false;
            var _iteratorError5 = undefined;

            try {
                for (var _iterator5 = options.operations[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                    var operation = _step5.value;

                    if (operation.allow_multiple) {
                        tmpl += "<input type=\"button\" value=\"" + operation.label + "\" class=\"operation-button action-button\">&nbsp;";
                    }
                }

                // finalize template
            } catch (err) {
                _didIteratorError5 = true;
                _iteratorError5 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion5 && _iterator5.return) {
                        _iterator5.return();
                    }
                } finally {
                    if (_didIteratorError5) {
                        throw _iteratorError5;
                    }
                }
            }

            tmpl += "</td>" + "</tr>";
        }

        // count global operations
        var found_global = false;
        var _iteratorNormalCompletion6 = true;
        var _didIteratorError6 = false;
        var _iteratorError6 = undefined;

        try {
            for (var _iterator6 = options.operations[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                var _operation = _step6.value;

                if (_operation.global_operation) {
                    found_global = true;
                    break;
                }
            }

            // add global operations
        } catch (err) {
            _didIteratorError6 = true;
            _iteratorError6 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion6 && _iterator6.return) {
                    _iterator6.return();
                }
            } finally {
                if (_didIteratorError6) {
                    throw _iteratorError6;
                }
            }
        }

        if (found_global) {
            tmpl += "<tr>" + '<td colspan="100">';
            var _iteratorNormalCompletion7 = true;
            var _didIteratorError7 = false;
            var _iteratorError7 = undefined;

            try {
                for (var _iterator7 = options.operations[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                    var _operation2 = _step7.value;

                    if (_operation2.global_operation) {
                        tmpl += "<a class=\"action-button\" href=\"" + _operation2.global_operation + "\">" + _operation2.label + "</a>";
                    }
                }
            } catch (err) {
                _didIteratorError7 = true;
                _iteratorError7 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion7 && _iterator7.return) {
                        _iterator7.return();
                    }
                } finally {
                    if (_didIteratorError7) {
                        throw _iteratorError7;
                    }
                }
            }

            tmpl += "</td>" + "</tr>";
        }

        // add legend
        if (options.legend) {
            tmpl += "<tr><td colspan=\"100\">" + options.legend + "</td></tr>";
        }

        // return
        return tmpl;
    },

    // template
    message: function message(options) {
        var status = options.status;
        if (["success", "ok"].indexOf(status) != -1) {
            status = "done";
        }
        return "<p><div class=\"" + status + "message transient-message\">" + _.escape(options.message) + "</div><div style=\"clear: both\"></div></p>";
    },

    // template
    grid_filters: function grid_filters(options) {
        // get filters
        var default_filter_dict = options.default_filter_dict;
        var filters = options.filters;

        // show advanced search if flag set or if there are filters for advanced search fields
        var advanced_search_display = "none";
        if (options.advanced_search) {
            advanced_search_display = "block";
        }

        // identify columns with advanced filtering
        var show_advanced_search_link = false;
        var _iteratorNormalCompletion8 = true;
        var _didIteratorError8 = false;
        var _iteratorError8 = undefined;

        try {
            for (var _iterator8 = options.columns[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
                var column = _step8.value;

                if (column.filterable == "advanced") {
                    var column_key = column.key;
                    var f_key = filters[column_key];
                    var d_key = default_filter_dict[column_key];
                    if (f_key && d_key && f_key != d_key) {
                        advanced_search_display = "block";
                    }
                    show_advanced_search_link = true;
                }
            }

            // hide standard search if advanced is shown
        } catch (err) {
            _didIteratorError8 = true;
            _iteratorError8 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion8 && _iterator8.return) {
                    _iterator8.return();
                }
            } finally {
                if (_didIteratorError8) {
                    throw _iteratorError8;
                }
            }
        }

        var standard_search_display = "block";
        if (advanced_search_display == "block") {
            standard_search_display = "none";
        }

        //
        // standard search
        //
        var tmpl = "<div id=\"standard-search\" style=\"display: " + standard_search_display + ";\"><table><tr><td style=\"padding: 0;\"><table>";

        // add standard filters
        var _iteratorNormalCompletion9 = true;
        var _didIteratorError9 = false;
        var _iteratorError9 = undefined;

        try {
            for (var _iterator9 = options.columns[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
                var _column = _step9.value;

                if (_column.filterable == "standard") {
                    tmpl += this.grid_column_filter(options, _column);
                }
            }

            // finalize standard search
        } catch (err) {
            _didIteratorError9 = true;
            _iteratorError9 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion9 && _iterator9.return) {
                    _iterator9.return();
                }
            } finally {
                if (_didIteratorError9) {
                    throw _iteratorError9;
                }
            }
        }

        tmpl += "</table>" + "</td>" + "</tr>" + "<tr>" + "<td>";

        // show advanced search link in standard display
        if (show_advanced_search_link) {
            tmpl += '<a href="" class="advanced-search-toggle">Advanced Search</a>';
        }

        // finalize standard search display
        tmpl += "</td>" + "</tr>" + "</table>" + "</div>";

        //
        // advanced search
        //
        tmpl += "<div id=\"advanced-search\" style=\"display: " + advanced_search_display + "; margin-top: 5px; border: 1px solid #ccc;\"><table><tr><td style=\"text-align: left\" colspan=\"100\"><a href=\"\" class=\"advanced-search-toggle\">Close Advanced Search</a></td></tr>";

        // add advanced filters
        var _iteratorNormalCompletion10 = true;
        var _didIteratorError10 = false;
        var _iteratorError10 = undefined;

        try {
            for (var _iterator10 = options.columns[Symbol.iterator](), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
                var _column2 = _step10.value;

                if (_column2.filterable == "advanced") {
                    tmpl += this.grid_column_filter(options, _column2);
                }
            }

            // finalize advanced search template
        } catch (err) {
            _didIteratorError10 = true;
            _iteratorError10 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion10 && _iterator10.return) {
                    _iterator10.return();
                }
            } finally {
                if (_didIteratorError10) {
                    throw _iteratorError10;
                }
            }
        }

        tmpl += "</table>" + "</div>";

        // return template
        return tmpl;
    },

    // template
    grid_column_filter: function grid_column_filter(options, column) {
        // collect parameters
        var filters = options.filters;
        var column_label = column.label;
        var column_key = column.key;
        if (column.filterable == "advanced") {
            column_label = column_label.toLowerCase();
        }

        // start
        var tmpl = "<tr>";

        if (column.filterable == "advanced") {
            tmpl += "<td align=\"left\" style=\"padding-left: 10px\">" + column_label + ":</td>";
        }
        tmpl += '<td style="padding-bottom: 1px;">';
        if (column.is_text) {
            tmpl += "<form class=\"text-filter-form\" column_key=\"" + column_key + "\" action=\"" + options.url + "\" method=\"get\" >";
            // Carry forward filtering criteria with hidden inputs.
            var _iteratorNormalCompletion11 = true;
            var _didIteratorError11 = false;
            var _iteratorError11 = undefined;

            try {
                for (var _iterator11 = options.columns[Symbol.iterator](), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
                    var _column3 = _step11.value;

                    var filter_value = filters[_column3.key];
                    if (filter_value) {
                        if (filter_value != "All") {
                            if (_column3.is_text) {
                                filter_value = JSON.stringify(filter_value);
                            }
                            tmpl += "<input type=\"hidden\" id=\"" + _column3.key + "\" name=\"f-" + _column3.key + "\" value=\"" + filter_value + "\"/>";
                        }
                    }
                }
                // Print current filtering criteria and links to delete.
            } catch (err) {
                _didIteratorError11 = true;
                _iteratorError11 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion11 && _iterator11.return) {
                        _iterator11.return();
                    }
                } finally {
                    if (_didIteratorError11) {
                        throw _iteratorError11;
                    }
                }
            }

            tmpl += "<span id=\"" + column_key + "-filtering-criteria\">";

            // add filters
            var column_filter = filters[column_key];
            if (column_filter) {
                // identify type
                var type = $.type(column_filter);

                // single filter value
                if (type == "string") {
                    if (column_filter != "All") {
                        // append template
                        tmpl += this.filter_element(column_key, column_filter);
                    }
                }

                // multiple filter values
                if (type == "array") {
                    for (var i in column_filter) {
                        // copy filters and remove entry
                        var params = column_filter;
                        params = params.slice(i);

                        // append template
                        tmpl += this.filter_element(column_key, column_filter[i]);
                    }
                }
            }

            // close span
            tmpl += "</span>";

            // Set value, size of search input field. Minimum size is 20 characters.
            var value = "";
            var size = 20;
            if (column.filterable == "standard") {
                value = column.label.toLowerCase();
                if (value.length < 20) {
                    size = value.length;
                }
                // +4 to account for space after placeholder
                size = size + 4;
            }

            // print input field for column
            tmpl += "\n                <span class=\"search-box\">\n                    <input class=\"search-box-input\" id=\"input-" + column_key + "-filter\" name=\"f-" + column_key + "\" type=\"text\" placeholder=\"" + value + "\" size=\"" + size + "\"/>\n                    <button type=\"submit\" style=\"background: transparent; border: none; padding: 4px; margin: 0px;\">\n                        <i class=\"fa fa-search\"></i>\n                    </button>\n                </span>\n            </form>";
        } else {
            // filter criteria
            tmpl += "<span id=\"" + column_key + "-filtering-criteria\">";

            // add category filters
            var seperator = false;
            for (var cf_label in options.categorical_filters[column_key]) {
                // get category filter
                var cf = options.categorical_filters[column_key][cf_label];

                // each filter will have only a single argument, so get that single argument
                var cf_key = "";
                var cf_arg = "";
                for (var key in cf) {
                    cf_key = key;
                    cf_arg = cf[key];
                }

                // add seperator
                if (seperator) {
                    tmpl += " | ";
                }
                seperator = true;

                // add category
                var filter = filters[column_key];
                if (filter && cf[column_key] && filter == cf_arg) {
                    tmpl += "<span class=\"categorical-filter " + column_key + "-filter current-filter\">" + cf_label + "</span>";
                } else {
                    tmpl += "<span class=\"categorical-filter " + column_key + "-filter\"><a href=\"javascript:void(0);\" filter_key=\"" + cf_key + "\" filter_val=\"" + cf_arg + "\">" + cf_label + "</a></span>";
                }
            }
            tmpl += "</span>";
        }
        tmpl += "</td>" + "</tr>";

        // return template
        return tmpl;
    },

    // template for filter items
    filter_element: function filter_element(filter_key, filter_value) {
        filter_value = _utils2.default.sanitize(filter_value);
        return "<span class=\"text-filter-val\">" + filter_value + "<a href=\"javascript:void(0);\" filter_key=\"" + filter_key + "\" filter_val=\"" + filter_value + "\"><i class=\"fa fa-times\" style=\"padding-left: 5px; padding-bottom: 6px;\"/></a></span>";
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 85 */,
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Backbone, $) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _underscore = __webpack_require__(1);

var _ = _interopRequireWildcard(_underscore);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/**
 * View for track/group header.
 */
var TrackHeaderView = Backbone.View.extend({
    className: "track-header",

    initialize: function initialize() {
        // Watch and update name changes.
        this.model.config.get("name").on("change:value", this.update_name, this);
        this.render();
    },

    render: function render() {
        this.$el.append($("<div/>").addClass(this.model.drag_handle_class));
        this.$el.append($("<div/>").addClass("track-name").text(this.model.config.get_value("name")));

        // Icons container.
        this.action_icons = {};
        this.render_action_icons();

        // Suppress double clicks in header so that they do not impact viz under header.
        this.$el.dblclick(function (e) {
            e.stopPropagation();
        });

        // Needed for floating elts in header.
        this.$el.append($("<div style='clear: both'/>"));
    },

    update_name: function update_name() {
        this.$el.find(".track-name").text(this.model.config.get_value("name"));
    },

    render_action_icons: function render_action_icons() {
        var self = this;
        this.icons_div = $("<div/>").addClass("track-icons").hide().appendTo(this.$el);
        _.each(this.model.action_icons_def, function (icon_dict) {
            self.add_action_icon(icon_dict.name, icon_dict.title, icon_dict.css_class, icon_dict.on_click_fn, icon_dict.prepend, icon_dict.hide);
        });

        // Set up behavior for modes popup.
        this.set_display_modes(this.model.display_modes);
    },

    /**
     * Add an action icon to this object. Appends icon unless prepend flag is specified.
     */
    add_action_icon: function add_action_icon(name, title, css_class, on_click_fn, prepend, hide) {
        var self = this;
        this.action_icons[name] = $("<a/>").attr("title", title).addClass("icon-button").addClass(css_class).tooltip().click(function () {
            on_click_fn(self.model);
        }).appendTo(this.icons_div);
        if (hide) {
            this.action_icons[name].hide();
        }
    },

    /**
     * Set track's modes and update mode icon popup.
     */
    set_display_modes: function set_display_modes(new_modes, init_mode) {
        if (!new_modes) {
            return;
        }

        // HACK: move this out of view and into track.

        // Set modes, init mode.
        this.model.display_modes = new_modes;
        this.model.mode = init_mode || this.model.config.get_value("mode") || this.model.display_modes[0];

        this.action_icons.mode_icon.attr("title", "Set display mode (now: " + this.mode + ")");

        // Setup popup menu for changing modes.
        var self = this;

        var track = this.model;
        var mode_mapping = {};
        for (var i = 0, len = track.display_modes.length; i < len; i++) {
            var mode = track.display_modes[i];
            mode_mapping[mode] = function (mode) {
                return function () {
                    track.change_mode(mode);
                    // HACK: the popup menu messes with the track's hover event, so manually show/hide
                    // icons div for now.
                    //self.icons_div.show();
                    //track.container_div.mouseleave(function() { track.icons_div.hide(); } );
                };
            }(mode);
        }

        make_popupmenu(this.action_icons.mode_icon, mode_mapping);
    }
});

exports.default = {
    TrackHeaderView: TrackHeaderView
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(0)))

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _underscore = __webpack_require__(1);

var _ = _interopRequireWildcard(_underscore);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var extend = _.extend;

// HACK: LABEL_SPACING is currently duplicated between here and painters
var LABEL_SPACING = 2;

var PACK_SPACING = 5;

/**
 * Hold slotting information for a feature.
 */
var SlottedInfo = function SlottedInfo(slot, feature) {
    this.slot = slot;
    this.feature = feature;
};

/**
 * FeatureSlotter determines slots in which to draw features for vertical
 * packing.
 *
 * This implementation is incremental, any feature assigned a slot will be
 * retained for slotting future features.
 */
var FeatureSlotter = function FeatureSlotter(w_scale, mode, max_rows, measureText) {
    this.slots = {};
    this.start_end_dct = {};
    this.w_scale = w_scale;
    this.mode = mode;
    this.include_label = mode === "Pack";
    this.max_rows = max_rows;
    this.measureText = measureText;
};

/**
 * Slot a set of features, `this.slots` will be updated with slots by id, and
 * the largest slot required for the passed set of features is returned
 */
extend(FeatureSlotter.prototype, {
    /**
     * Get drawing coordinate for a feature.
     */
    _get_draw_coords: function _get_draw_coords(feature) {
        // Get initial draw coordinates using w_scale.
        var draw_start = Math.floor(feature[1] * this.w_scale);

        var draw_end = Math.ceil(feature[2] * this.w_scale);
        var f_name = feature[3];
        //var text_align;

        // Update start, end drawing locations to include feature name.
        // Try to put the name on the left, if not, put on right.
        if (f_name !== undefined && this.include_label) {
            // Add gap for label spacing and extra pack space padding
            // TODO: Fix constants
            var text_len = this.measureText(f_name).width + (LABEL_SPACING + PACK_SPACING);
            if (draw_start - text_len >= 0) {
                draw_start -= text_len;
                //text_align = "left";
            } else {
                draw_end += text_len;
                //text_align = "right";
            }
        }

        /*
        if (slot_num < 0) {
            
            TODO: this is not yet working --
            console.log(feature_uid, "looking for slot with text on the right");
            // Slot not found. If text was on left, try on right and see
            // if slot can be found.
            // TODO: are there any checks we need to do to ensure that text
            // will fit on tile?
            if (text_align === "left") {
                draw_start -= text_len;
                draw_end -= text_len;
                text_align = "right";
                slot_num = find_slot(draw_start, draw_end);
            }
            if (slot_num >= 0) {
                console.log(feature_uid, "found slot with text on the right");
            }
         }
        */

        return [draw_start, draw_end];
    },

    /**
     * Find the first slot such that current feature doesn't overlap any other features in that slot.
     * Returns -1 if no slot was found.
     */
    _find_slot: function _find_slot(draw_coords) {
        // TODO: Use a data structure for faster searching of available slots.
        var draw_start = draw_coords[0];

        var draw_end = draw_coords[1];
        for (var slot_num = 0; slot_num <= this.max_rows; slot_num++) {
            var has_overlap = false;
            var slot = this.start_end_dct[slot_num];
            if (slot !== undefined) {
                // Iterate through features already in slot to see if current feature will fit.
                for (var k = 0, k_len = slot.length; k < k_len; k++) {
                    var s_e = slot[k];
                    if (draw_end > s_e[0] && draw_start < s_e[1]) {
                        // There is overlap
                        has_overlap = true;
                        break;
                    }
                }
            }
            if (!has_overlap) {
                return slot_num;
            }
        }
        return -1;
    },

    /**
     * Slot features.
     */
    slot_features: function slot_features(features) {
        var start_end_dct = this.start_end_dct;
        var undone = [];
        var highest_slot = 0;
        var feature;
        var feature_uid;

        // Loop through features to (a) find those that are not yet slotted and (b) update
        // those that are slotted if new information is availabe. For (a), features already
        // slotted (based on slotting from other tiles) will retain their current slot.
        for (var i = 0, len = features.length; i < len; i++) {
            feature = features[i];
            feature_uid = feature[0];
            var slotted_info = this.slots[feature_uid];

            // Separate and handle slotted vs. unslotted features.
            if (slotted_info) {
                // Feature is slotted; if feature now has larger start/end coordinates,
                // update drawing coordinates.
                if (feature[1] < slotted_info.feature[1] || slotted_info.feature[2] < feature[2]) {
                    // Feature has changed (e.g. a single read now has its pair), so recalculate its
                    // drawing coordinates.
                    var old_draw_coords = this._get_draw_coords(slotted_info.feature);

                    var new_draw_coords = this._get_draw_coords(feature);
                    var slotted_coords = this.start_end_dct[slotted_info.slot];
                    for (var k = 0; k < slotted_coords.length; k++) {
                        var dc = slotted_coords[k];
                        if (dc[0] === old_draw_coords[0] && dc[1] === old_draw_coords[1]) {
                            // Replace old drawing coordinates with new ones.
                            slotted_coords[k] = new_draw_coords;
                        }
                    }
                }
                highest_slot = Math.max(highest_slot, this.slots[feature_uid].slot);
            } else {
                undone.push(i);
            }
        }

        // Slot unslotted features.

        // Do slotting.
        for (var _i = 0, _len = undone.length; _i < _len; _i++) {
            feature = features[undone[_i]];
            feature_uid = feature[0];
            var draw_coords = this._get_draw_coords(feature);

            // Find slot.
            var slot_num = this._find_slot(draw_coords);

            // Do slotting.
            if (slot_num >= 0) {
                // Add current feature to slot.
                if (start_end_dct[slot_num] === undefined) {
                    start_end_dct[slot_num] = [];
                }
                start_end_dct[slot_num].push(draw_coords);
                this.slots[feature_uid] = new SlottedInfo(slot_num, feature);
                highest_slot = Math.max(highest_slot, slot_num);
            }
        }

        // Debugging: view slots data.
        /*
        for (var i = 0; i < MAX_FEATURE_DEPTH; i++) {
            var slot = start_end_dct[i];
            if (slot !== undefined) {
                console.log(i, "*************");
                for (var k = 0, k_len = slot.length; k < k_len; k++) {
                    console.log("\t", slot[k][0], slot[k][1]);
                }
            }
        }
        */
        return highest_slot + 1;
    }
});

exports.default = {
    FeatureSlotter: FeatureSlotter
};

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _underscore = __webpack_require__(1);

var _ = _interopRequireWildcard(_underscore);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Constants specific to feature tracks moved here (HACKING, these should
// basically all be configuration options)
var BEFORE = 1001;
var CONTAINS = 1002;
var OVERLAP_START = 1003;
var OVERLAP_END = 1004;
var CONTAINED_BY = 1005;
var AFTER = 1006;

var DENSE_TRACK_HEIGHT = 10;
var NO_DETAIL_TRACK_HEIGHT = 3;
var SQUISH_TRACK_HEIGHT = 5;
var PACK_TRACK_HEIGHT = 10;
var NO_DETAIL_FEATURE_HEIGHT = 1;
var DENSE_FEATURE_HEIGHT = 9;
var SQUISH_FEATURE_HEIGHT = 3;
var PACK_FEATURE_HEIGHT = 9;
var LABEL_SPACING = 2;
var CONNECTOR_COLOR = "#ccc";

/**
 * Compute the type of overlap between two regions. They are assumed to be on the same chrom/contig.
 * The overlap is computed relative to the second region; hence, OVERLAP_START indicates that the first
 * region overlaps the start (but not the end) of the second region.
 * NOTE: Coordinates are assumed to be in BED format: half open (start is closed, end is open).
 */
function compute_overlap(first_region, second_region) {
    var first_start = first_region[0];
    var first_end = first_region[1];
    var second_start = second_region[0];
    var second_end = second_region[1];
    var overlap;
    if (first_start < second_start) {
        if (first_end <= second_start) {
            overlap = BEFORE;
        } else if (first_end <= second_end) {
            overlap = OVERLAP_START;
        } else {
            // first_end > second_end
            overlap = CONTAINS;
        }
    } else {
        // first_start >= second_start
        if (first_start > second_end) {
            overlap = AFTER;
        } else if (first_end <= second_end) {
            overlap = CONTAINED_BY;
        } else {
            overlap = OVERLAP_END;
        }
    }
    return overlap;
}

/**
 * Returns true if regions overlap.
 */
function is_overlap(first_region, second_region) {
    var overlap = compute_overlap(first_region, second_region);
    return overlap !== BEFORE && overlap !== AFTER;
}

/**
 * Draw a dashed line on a canvas using filled rectangles. This function is based on:
 * http://vetruvet.blogspot.com/2010/10/drawing-dashed-lines-on-html5-canvas.html
 * However, that approach uses lines, which don't seem to render as well, so use
 * rectangles instead.
 */
function dashedLine(ctx, x1, y1, x2, y2, dashLen) {
    if (dashLen === undefined) {
        dashLen = 4;
    }
    var dX = x2 - x1;
    var dY = y2 - y1;
    var dashes = Math.floor(Math.sqrt(dX * dX + dY * dY) / dashLen);
    var dashX = dX / dashes;
    var dashY = dY / dashes;
    var q;

    for (q = 0; q < dashes; q++, x1 += dashX, y1 += dashY) {
        if (q % 2 !== 0) {
            continue;
        }
        ctx.fillRect(x1, y1, dashLen, 1);
    }
}

/**
 * Draw an isosceles triangle that points down.
 */
function drawDownwardEquilateralTriangle(ctx, down_vertex_x, down_vertex_y, side_len) {
    // Compute other two points of triangle.
    var x1 = down_vertex_x - side_len / 2;

    var x2 = down_vertex_x + side_len / 2;
    var y = down_vertex_y - Math.sqrt(side_len * 3 / 2);

    // Draw and fill.
    ctx.beginPath();
    ctx.moveTo(x1, y);
    ctx.lineTo(x2, y);
    ctx.lineTo(down_vertex_x, down_vertex_y);
    ctx.lineTo(x1, y);

    ctx.strokeStyle = this.fillStyle;
    ctx.fill();
    ctx.stroke();
    ctx.closePath();
}

/**
 * Base class for all scalers. Scalers produce values that are used to change (scale) drawing attributes.
 */

var Scaler = function () {
    function Scaler(default_val) {
        _classCallCheck(this, Scaler);

        this.default_val = default_val ? default_val : 1;
    }

    /**
     * Produce a scaling value.
     */


    _createClass(Scaler, [{
        key: "gen_val",
        value: function gen_val(input) {
            return this.default_val;
        }
    }]);

    return Scaler;
}();

/**
 * Results from painter.draw()
 */


var DrawResults = function DrawResults(options) {
    _classCallCheck(this, DrawResults);

    this.incomplete_features = options.incomplete_features;
    this.feature_mapper = options.feature_mapper;
};

/**
 * Base class for painters
 *
 * -- Mode and prefs are both optional
 */


var Painter = function () {
    function Painter(data, view_start, view_end, prefs, mode) {
        _classCallCheck(this, Painter);

        // Data and data properties
        this.data = data;
        this.default_prefs = {};
        // View
        this.view_start = view_start;
        this.view_end = view_end;
        // Drawing prefs
        this.prefs = _.extend({}, this.default_prefs, prefs);
        this.mode = mode;
    }

    _createClass(Painter, [{
        key: "draw",


        /**
         * Draw on the context using a rectangle of width x height using scale w_scale.
         */
        value: function draw(ctx, width, height, w_scale) {}

        /**
         * Get starting drawing position, which is offset a half-base left of coordinate.
         */

    }, {
        key: "get_start_draw_pos",
        value: function get_start_draw_pos(chrom_pos, w_scale) {
            return this._chrom_pos_to_draw_pos(chrom_pos, w_scale, -0.5);
        }

        /**
         * Get end drawing position, which is offset a half-base right of coordinate.
         */

    }, {
        key: "get_end_draw_pos",
        value: function get_end_draw_pos(chrom_pos, w_scale) {
            return this._chrom_pos_to_draw_pos(chrom_pos, w_scale, 0.5);
        }

        /**
         * Get drawing position.
         */

    }, {
        key: "get_draw_pos",
        value: function get_draw_pos(chrom_pos, w_scale) {
            return this._chrom_pos_to_draw_pos(chrom_pos, w_scale, 0);
        }

        /**
         * Convert chromosome position to drawing position.
         */

    }, {
        key: "_chrom_pos_to_draw_pos",
        value: function _chrom_pos_to_draw_pos(chrom_pos, w_scale, offset) {
            return Math.floor(w_scale * (Math.max(0, chrom_pos - this.view_start) + offset));
        }
    }], [{
        key: "default_prefs",
        get: function get() {
            return {};
        }
    }]);

    return Painter;
}();

var LinePainter = function (_Painter) {
    _inherits(LinePainter, _Painter);

    function LinePainter(data, view_start, view_end, prefs, mode) {
        _classCallCheck(this, LinePainter);

        return _possibleConstructorReturn(this, (LinePainter.__proto__ || Object.getPrototypeOf(LinePainter)).call(this, data, view_start, view_end, prefs, mode));
    }

    _createClass(LinePainter, [{
        key: "draw",
        value: function draw(ctx, width, height, w_scale) {
            var in_path = false;
            var min_value = this.prefs.min_value;
            var max_value = this.prefs.max_value;
            var vertical_range = max_value - min_value;
            var height_px = height;
            var view_start = this.view_start;
            var mode = this.mode;
            var data = this.data;

            ctx.save();

            // Pixel position of 0 on the y axis
            var y_zero = Math.round(height + min_value / vertical_range * height);

            // Horizontal line to denote x-axis
            if (mode !== "Intensity") {
                ctx.fillStyle = "#aaa";
                ctx.fillRect(0, y_zero, width, 1);
            }

            ctx.beginPath();
            var x_scaled;
            var y;
            var delta_x_pxs;
            if (data.length > 1) {
                delta_x_pxs = _.map(data.slice(0, -1), function (d, i) {
                    return Math.ceil((data[i + 1][0] - data[i][0]) * w_scale);
                });
            } else {
                delta_x_pxs = [10];
            }

            // Painter color can be in either block_color (FeatureTrack) or color pref (LineTrack).
            var painter_color = this.prefs.block_color || this.prefs.color;

            var // Extract RGB from preference color.
            pref_color = parseInt(painter_color.slice(1), 16);
            var pref_r = (pref_color & 0xff0000) >> 16;
            var pref_g = (pref_color & 0x00ff00) >> 8;
            var pref_b = pref_color & 0x0000ff;
            var top_overflow = false;
            var bot_overflow = false;

            // Paint track.
            var delta_x_px;
            for (var i = 0, len = data.length; i < len; i++) {
                // Reset attributes for next point.
                ctx.fillStyle = ctx.strokeStyle = painter_color;
                top_overflow = bot_overflow = false;
                delta_x_px = delta_x_pxs[i];

                x_scaled = Math.floor((data[i][0] - view_start - 0.5) * w_scale);
                y = data[i][1];

                // Process Y (scaler) value.
                if (y === null) {
                    if (in_path && mode === "Filled") {
                        ctx.lineTo(x_scaled, height_px);
                    }
                    in_path = false;
                    continue;
                }

                // Bound Y value by min, max.
                if (y < min_value) {
                    bot_overflow = true;
                    y = min_value;
                } else if (y > max_value) {
                    top_overflow = true;
                    y = max_value;
                }

                // Draw point.
                if (mode === "Histogram") {
                    // y becomes the bar height in pixels, which is the negated for canvas coords
                    y = Math.round(y / vertical_range * height_px);
                    ctx.fillRect(x_scaled, y_zero, delta_x_px, -y);
                } else if (mode === "Intensity") {
                    var saturation = (y - min_value) / vertical_range;

                    var // Range is [pref_color, 255] where saturation = 0 --> 255 and saturation = 1 --> pref color
                    new_r = Math.round(pref_r + (255 - pref_r) * (1 - saturation));

                    var new_g = Math.round(pref_g + (255 - pref_g) * (1 - saturation));
                    var new_b = Math.round(pref_b + (255 - pref_b) * (1 - saturation));
                    ctx.fillStyle = "rgb(" + new_r + "," + new_g + "," + new_b + ")";
                    ctx.fillRect(x_scaled, 0, delta_x_px, height_px);
                } else {
                    // mode is Coverage/Line or Filled.

                    // Scale Y value.
                    y = Math.round(height_px - (y - min_value) / vertical_range * height_px);
                    if (in_path) {
                        ctx.lineTo(x_scaled, y);
                    } else {
                        in_path = true;
                        if (mode === "Filled") {
                            ctx.moveTo(x_scaled, height_px);
                            ctx.lineTo(x_scaled, y);
                        } else {
                            ctx.moveTo(x_scaled, y);
                            // Use this approach (note: same as for filled) to draw line from 0 to
                            // first data point.
                            //ctx.moveTo(x_scaled, height_px);
                            //ctx.lineTo(x_scaled, y);
                        }
                    }
                }

                // Draw lines at boundaries if overflowing min or max
                ctx.fillStyle = this.prefs.overflow_color;
                if (top_overflow || bot_overflow) {
                    var overflow_x;
                    if (mode === "Histogram" || mode === "Intensity") {
                        overflow_x = delta_x_px;
                    } else {
                        // Line and Filled, which are points
                        x_scaled -= 2; // Move it over to the left so it's centered on the point
                        overflow_x = 4;
                    }
                    if (top_overflow) {
                        ctx.fillRect(x_scaled, 0, overflow_x, 3);
                    }
                    if (bot_overflow) {
                        ctx.fillRect(x_scaled, height_px - 3, overflow_x, 3);
                    }
                }
                ctx.fillStyle = painter_color;
            }
            if (mode === "Filled") {
                if (in_path) {
                    ctx.lineTo(x_scaled, y_zero);
                    ctx.lineTo(0, y_zero);
                }
                ctx.fill();
            } else {
                ctx.stroke();
            }

            ctx.restore();
        }
    }], [{
        key: "default_prefs",
        get: function get() {
            return {
                min_value: undefined,
                max_value: undefined,
                mode: "Histogram",
                color: "#000",
                overflow_color: "#F66"
            };
        }
    }]);

    return LinePainter;
}(Painter);

/**
 * Mapper that contains information about feature locations and data.
 */


var FeaturePositionMapper = function () {
    function FeaturePositionMapper(slot_height) {
        _classCallCheck(this, FeaturePositionMapper);

        this.feature_positions = {};
        this.slot_height = slot_height;
        this.translation = 0;
        this.y_translation = 0;
    }

    /**
     * Map feature data to a position defined by <slot, x_start, x_end>.
     */


    _createClass(FeaturePositionMapper, [{
        key: "map_feature_data",
        value: function map_feature_data(feature_data, slot, x_start, x_end) {
            if (!this.feature_positions[slot]) {
                this.feature_positions[slot] = [];
            }
            this.feature_positions[slot].push({
                data: feature_data,
                x_start: x_start,
                x_end: x_end
            });
        }

        /**
         * Get feature data for position <x, y>
         */

    }, {
        key: "get_feature_data",
        value: function get_feature_data(x, y) {
            // Find slot using Y.
            var slot = Math.floor((y - this.y_translation) / this.slot_height);

            var feature_dict;

            // May not be over a slot due to padding, margin, etc.
            if (!this.feature_positions[slot]) {
                return null;
            }

            // Find feature using X.
            x += this.translation;
            for (var i = 0; i < this.feature_positions[slot].length; i++) {
                feature_dict = this.feature_positions[slot][i];
                if (x >= feature_dict.x_start && x <= feature_dict.x_end) {
                    return feature_dict.data;
                }
            }
        }
    }]);

    return FeaturePositionMapper;
}();

/**
 * Abstract object for painting feature tracks. Subclasses must implement draw_element() for painting to work.
 * Painter uses a 0-based, half-open coordinate system; start coordinate is closed--included--and the end is open.
 * This coordinate system matches the BED format.
 */


var FeaturePainter = function (_Painter2) {
    _inherits(FeaturePainter, _Painter2);

    function FeaturePainter(data, view_start, view_end, prefs, mode, alpha_scaler, height_scaler) {
        _classCallCheck(this, FeaturePainter);

        var _this2 = _possibleConstructorReturn(this, (FeaturePainter.__proto__ || Object.getPrototypeOf(FeaturePainter)).call(this, data, view_start, view_end, prefs, mode));

        _this2.alpha_scaler = alpha_scaler ? alpha_scaler : new Scaler();
        _this2.height_scaler = height_scaler ? height_scaler : new Scaler();
        _this2.max_label_length = 200;
        return _this2;
    }

    _createClass(FeaturePainter, [{
        key: "get_required_height",
        value: function get_required_height(rows_required, width) {
            // y_scale is the height per row
            var required_height = this.get_row_height();

            var y_scale = required_height;
            var mode = this.mode;
            // If using a packing mode, need to multiply by the number of slots used
            if (mode === "no_detail" || mode === "Squish" || mode === "Pack") {
                required_height = rows_required * y_scale;
            }
            return required_height + this.get_top_padding(width);
        }

        /** Extra padding before first row of features */

    }, {
        key: "get_top_padding",
        value: function get_top_padding(width) {
            return 0;
        }

        /**
         * Draw data on ctx using slots and within the rectangle defined by width and height. Returns
         * a FeaturePositionMapper object with information about where features were drawn.
         */

    }, {
        key: "draw",
        value: function draw(ctx, width, height, w_scale, slots) {
            ctx.save();
            ctx.fillStyle = this.prefs.block_color;
            ctx.textAlign = "right";

            var y_scale = this.get_row_height();
            var feature_mapper = new FeaturePositionMapper(y_scale);
            var x_draw_coords;
            var incomplete_features = [];

            for (var i = 0, len = this.data.length; i < len; i++) {
                var feature = this.data[i];
                var feature_uid = feature[0];
                var feature_start = feature[1];
                var feature_end = feature[2];

                // Slot valid only if features are slotted and this feature is slotted;
                // feature may not be due to lack of space.
                var slot = slots && slots[feature_uid] !== undefined ? slots[feature_uid].slot : null;

                // Draw feature if (a) mode is dense or feature is slotted (as it must be for all non-dense modes) and
                // (b) there's overlap between the feature and drawing region.
                if ((this.mode === "Dense" || slot !== null) && feature_start < this.view_end && feature_end > this.view_start) {
                    x_draw_coords = this.draw_element(ctx, this.mode, feature, slot, this.view_start, this.view_end, w_scale, y_scale, width);
                    feature_mapper.map_feature_data(feature, slot, x_draw_coords[0], x_draw_coords[1]);

                    // Add to incomplete features if it's not drawn completely in region.
                    if (feature_start < this.view_start || feature_end > this.view_end) {
                        incomplete_features.push(feature);
                    }
                }
            }

            ctx.restore();

            feature_mapper.y_translation = this.get_top_padding(width);
            return new DrawResults({
                incomplete_features: incomplete_features,
                feature_mapper: feature_mapper
            });
        }

        /**
         * Abstract function for drawing an individual feature.
         */

    }, {
        key: "draw_element",
        value: function draw_element(ctx, mode, feature, slot, tile_low, tile_high, w_scale, y_scale, width) {
            return [0, 0];
        }
    }], [{
        key: "default_prefs",
        get: function get() {
            return {
                block_color: "#FFF",
                connector_color: "#FFF"
            };
        }
    }]);

    return FeaturePainter;
}(Painter);

var LinkedFeaturePainter = function (_FeaturePainter) {
    _inherits(LinkedFeaturePainter, _FeaturePainter);

    function LinkedFeaturePainter(data, view_start, view_end, prefs, mode, alpha_scaler, height_scaler) {
        _classCallCheck(this, LinkedFeaturePainter);

        // Whether to draw a single connector in the background that spans the entire feature (the intron fishbone)
        var _this3 = _possibleConstructorReturn(this, (LinkedFeaturePainter.__proto__ || Object.getPrototypeOf(LinkedFeaturePainter)).call(this, data, view_start, view_end, prefs, mode, alpha_scaler, height_scaler));

        _this3.draw_background_connector = true;
        // Whether to call draw_connector for every pair of blocks
        _this3.draw_individual_connectors = false;
        return _this3;
    }

    /**
     * Height of a single row, depends on mode
     */


    _createClass(LinkedFeaturePainter, [{
        key: "get_row_height",
        value: function get_row_height() {
            var mode = this.mode;
            var height;
            if (mode === "Dense") {
                height = DENSE_TRACK_HEIGHT;
            } else if (mode === "no_detail") {
                height = NO_DETAIL_TRACK_HEIGHT;
            } else if (mode === "Squish") {
                height = SQUISH_TRACK_HEIGHT;
            } else {
                // mode === "Pack"
                height = PACK_TRACK_HEIGHT;
            }
            return height;
        }

        /**
         * Draw a feature. Returns an array with feature's start and end X coordinates.
         */

    }, {
        key: "draw_element",
        value: function draw_element(ctx, mode, feature, slot, tile_low, tile_high, w_scale, y_scale, width) {
            // var feature_uid = feature[0];
            var feature_start = feature[1];
            var feature_end = feature[2];
            var feature_name = feature[3];
            var feature_strand = feature[4];
            // -0.5 to offset region between bases.
            var f_start = Math.floor(Math.max(0, (feature_start - tile_low - 0.5) * w_scale));
            var f_end = Math.ceil(Math.min(width, Math.max(0, (feature_end - tile_low - 0.5) * w_scale)));
            var draw_start = f_start;
            var draw_end = f_end;
            var y_start = (mode === "Dense" ? 0 : 0 + slot) * y_scale + this.get_top_padding(width);
            var thick_start = null;
            var thick_end = null;

            // TODO: is there any reason why block, label color cannot be set at the Painter level?
            // For now, assume '.' === '+'
            var block_color = !feature_strand || feature_strand === "+" || feature_strand === "." ? this.prefs.block_color : this.prefs.reverse_strand_color;
            var label_color = this.prefs.label_color;

            // Set global alpha.
            ctx.globalAlpha = this.alpha_scaler.gen_val(feature);

            // In dense mode, put all data in top slot.
            if (mode === "Dense") {
                slot = 1;
            }

            if (mode === "no_detail") {
                // No details for feature, so only one way to display.
                ctx.fillStyle = block_color;
                ctx.fillRect(f_start, y_start + 5, f_end - f_start, NO_DETAIL_FEATURE_HEIGHT);
            } else {
                // Mode is either Squish or Pack:
                // Feature details.
                var feature_ts = feature[5];

                var feature_te = feature[6];
                var feature_blocks = feature[7];

                var // Whether we are drawing full height or squished features
                full_height = true;

                if (feature_ts && feature_te) {
                    thick_start = Math.floor(Math.max(0, (feature_ts - tile_low) * w_scale));
                    thick_end = Math.ceil(Math.min(width, Math.max(0, (feature_te - tile_low) * w_scale)));
                }

                // Set vars that depend on mode.
                var thin_height;

                var thick_height;
                if (mode === "Squish") {
                    thin_height = 1;
                    thick_height = SQUISH_FEATURE_HEIGHT;
                    full_height = false;
                } else if (mode === "Dense") {
                    thin_height = 5;
                    thick_height = DENSE_FEATURE_HEIGHT;
                } else {
                    // mode === "Pack"
                    thin_height = 5;
                    thick_height = PACK_FEATURE_HEIGHT;
                }

                // Draw feature/feature blocks + connectors.
                if (!feature_blocks) {
                    // If there are no blocks, treat the feature as one big exon.
                    ctx.fillStyle = block_color;
                    ctx.fillRect(f_start, y_start + 1, f_end - f_start, thick_height);
                    // If strand is specified, draw arrows over feature
                    if (feature_strand && full_height) {
                        if (feature_strand === "+") {
                            ctx.fillStyle = ctx.canvas.manager.get_pattern("right_strand_inv");
                        } else if (feature_strand === "-") {
                            ctx.fillStyle = ctx.canvas.manager.get_pattern("left_strand_inv");
                        }
                        ctx.fillRect(f_start, y_start + 1, f_end - f_start, thick_height);
                    }
                } else {
                    //
                    // There are feature blocks and mode is either Squish or Pack.
                    //
                    // Approach: (a) draw whole feature as connector/intron and (b) draw blocks as
                    // needed. This ensures that whole feature, regardless of whether it starts with
                    // a block, is visible.
                    //

                    // Compute y axis start position and height
                    var cur_y_start;

                    var cur_height;
                    if (mode === "Squish" || mode === "Dense") {
                        cur_y_start = y_start + Math.floor(SQUISH_FEATURE_HEIGHT / 2) + 1;
                        cur_height = 1;
                    } else {
                        // mode === "Pack"
                        if (feature_strand) {
                            cur_y_start = y_start;
                            cur_height = thick_height;
                        } else {
                            cur_y_start += SQUISH_FEATURE_HEIGHT / 2 + 1;
                            cur_height = 1;
                        }
                    }

                    // Draw whole feature as connector/intron.
                    if (this.draw_background_connector) {
                        if (mode === "Squish" || mode === "Dense") {
                            ctx.fillStyle = CONNECTOR_COLOR;
                        } else {
                            // mode === "Pack"
                            if (feature_strand) {
                                if (feature_strand === "+") {
                                    ctx.fillStyle = ctx.canvas.manager.get_pattern("right_strand");
                                } else if (feature_strand === "-") {
                                    ctx.fillStyle = ctx.canvas.manager.get_pattern("left_strand");
                                }
                            } else {
                                ctx.fillStyle = CONNECTOR_COLOR;
                            }
                        }
                        ctx.fillRect(f_start, cur_y_start, f_end - f_start, cur_height);
                    }

                    // Draw blocks.
                    for (var k = 0, k_len = feature_blocks.length; k < k_len; k++) {
                        var block = feature_blocks[k];

                        var // -0.5 to offset block between bases.
                        block_start = Math.floor(Math.max(0, (block[0] - tile_low - 0.5) * w_scale));

                        var block_end = Math.ceil(Math.min(width, Math.max((block[1] - tile_low - 0.5) * w_scale)));

                        var last_block_start;
                        var last_block_end;

                        // Skip drawing if block not on tile.
                        if (block_start > block_end) {
                            continue;
                        }

                        // Draw thin block.
                        ctx.fillStyle = block_color;
                        ctx.fillRect(block_start, y_start + (thick_height - thin_height) / 2 + 1, block_end - block_start, thin_height);

                        // If block intersects with thick region, draw block as thick.
                        // - No thick is sometimes encoded as thick_start == thick_end, so don't draw in that case
                        if (thick_start !== undefined && feature_te > feature_ts && !(block_start > thick_end || block_end < thick_start)) {
                            var block_thick_start = Math.max(block_start, thick_start);

                            var block_thick_end = Math.min(block_end, thick_end);
                            ctx.fillRect(block_thick_start, y_start + 1, block_thick_end - block_thick_start, thick_height);
                            if (feature_blocks.length === 1 && mode === "Pack") {
                                // Exactly one block means we have no introns, but do have a distinct "thick" region,
                                // draw arrows over it if in pack mode.
                                if (feature_strand === "+") {
                                    ctx.fillStyle = ctx.canvas.manager.get_pattern("right_strand_inv");
                                } else if (feature_strand === "-") {
                                    ctx.fillStyle = ctx.canvas.manager.get_pattern("left_strand_inv");
                                }
                                // If region is wide enough in pixels, pad a bit
                                if (block_thick_start + 14 < block_thick_end) {
                                    block_thick_start += 2;
                                    block_thick_end -= 2;
                                }
                                ctx.fillRect(block_thick_start, y_start + 1, block_thick_end - block_thick_start, thick_height);
                            }
                        }
                        // Draw individual connectors if required
                        if (this.draw_individual_connectors && last_block_start) {
                            this.draw_connector(ctx, last_block_start, last_block_end, block_start, block_end, y_start);
                        }
                        last_block_start = block_start;
                        last_block_end = block_end;
                    }

                    // FIXME: Height scaling only works in Pack mode right now.
                    if (mode === "Pack") {
                        // Reset alpha so height scaling is not impacted by alpha scaling.
                        ctx.globalAlpha = 1;

                        // Height scaling: draw white lines to reduce height according to height scale factor.
                        ctx.fillStyle = "white"; // TODO: set this to background color.
                        var hscale_factor = this.height_scaler.gen_val(feature);

                        var // Ceil ensures that min height is >= 1.
                        new_height = Math.ceil(thick_height * hscale_factor);

                        var ws_height = Math.round((thick_height - new_height) / 2);
                        if (hscale_factor !== 1) {
                            ctx.fillRect(f_start, cur_y_start + 1, f_end - f_start, ws_height);
                            ctx.fillRect(f_start, cur_y_start + thick_height - ws_height + 1, f_end - f_start, ws_height);
                        }
                    }
                }

                // Reset alpha so that label is not transparent.
                ctx.globalAlpha = 1;

                // Draw label for Pack mode.
                if (feature_name && mode === "Pack" && feature_start > tile_low) {
                    ctx.fillStyle = label_color;
                    // FIXME: assumption here that the entire view starts at 0
                    if (tile_low === 0 && f_start - ctx.measureText(feature_name).width < 0) {
                        ctx.textAlign = "left";
                        ctx.fillText(feature_name, f_end + LABEL_SPACING, y_start + 8, this.max_label_length);
                        draw_end += ctx.measureText(feature_name).width + LABEL_SPACING;
                    } else {
                        ctx.textAlign = "right";
                        ctx.fillText(feature_name, f_start - LABEL_SPACING, y_start + 8, this.max_label_length);
                        draw_start -= ctx.measureText(feature_name).width + LABEL_SPACING;
                    }
                    //ctx.fillStyle = block_color;
                }
            }

            // Reset global alpha.
            ctx.globalAlpha = 1;

            return [draw_start, draw_end];
        }
    }]);

    return LinkedFeaturePainter;
}(FeaturePainter);

var ReadPainter = function (_FeaturePainter2) {
    _inherits(ReadPainter, _FeaturePainter2);

    function ReadPainter(data, view_start, view_end, prefs, mode, alpha_scaler, height_scaler, ref_seq, base_color_fn) {
        _classCallCheck(this, ReadPainter);

        var _this4 = _possibleConstructorReturn(this, (ReadPainter.__proto__ || Object.getPrototypeOf(ReadPainter)).call(this, data, view_start, view_end, prefs, mode, alpha_scaler, height_scaler));

        _this4.ref_seq = ref_seq ? ref_seq.data : null;
        _this4.base_color_fn = base_color_fn;
        return _this4;
    }
    /**
     * Returns height based on mode.
     */


    _createClass(ReadPainter, [{
        key: "get_row_height",
        value: function get_row_height() {
            var height;
            var mode = this.mode;
            if (mode === "Dense") {
                height = DENSE_TRACK_HEIGHT;
            } else if (mode === "Squish") {
                height = SQUISH_TRACK_HEIGHT;
            } else {
                // mode === "Pack"
                height = PACK_TRACK_HEIGHT;
                if (this.prefs.show_insertions) {
                    height *= 2;
                }
            }
            return height;
        }

        /**
         * Parse CIGAR string to get (a) a list of contiguous drawing blocks (MD=X) and
         * (b) an array of [ op_index, op_len ] pairs where op_index is an index into the
         * string 'MIDNSHP=X' Return value is a dictionary with two entries, blocks and cigar
         */

    }, {
        key: "_parse_cigar",
        value: function _parse_cigar(cigar_str) {
            var cigar_ops = "MIDNSHP=X";

            // Parse cigar.
            var blocks = [[0, 0]];

            var cur_block = blocks[0];
            var base_pos = 0;

            var // Parse cigar operations out and update/create blocks as needed.
            parsed_cigar = _.map(cigar_str.match(/[0-9]+[MIDNSHP=X]/g), function (op) {
                // Get operation length, character.
                var op_len = parseInt(op.slice(0, -1), 10),
                    op_char = op.slice(-1);

                // Update drawing block.
                if (op_char === "N") {
                    // At skip, so need to start new block if current block represents
                    // drawing area.
                    if (cur_block[1] !== 0) {
                        cur_block = [base_pos + op_len, base_pos + op_len];
                        blocks.push(cur_block);
                    }
                } else if ("ISHP".indexOf(op_char) === -1) {
                    // Operation is M,D,=,X.
                    cur_block[1] += op_len;
                    base_pos += op_len;
                }

                // Return parsed cigar.
                return [cigar_ops.indexOf(op_char), op_len];
            });

            return {
                blocks: blocks,
                cigar: parsed_cigar
            };
        }

        /**
         * Draw a single read from reference-based read sequence and cigar.
         */

    }, {
        key: "draw_read",
        value: function draw_read(ctx, mode, w_scale, y_start, tile_low, tile_high, feature_start, cigar, strand, read_seq) {
            // Helper function to update base and sequnence offsets.
            var update_base_offset = function update_base_offset(offset, cig_op, cig_len) {
                if ("M=NXD".indexOf(cig_op) !== -1) {
                    offset += cig_len;
                }
                return offset;
            };

            var update_seq_offset = function update_seq_offset(offset, cig_op, cig_len) {
                if ("IX".indexOf(cig_op) !== -1) {
                    offset += cig_len;
                }
                return offset;
            };

            var // Gets drawing coordinate for a sequence coordinate. Assumes closure variables w_scale and tile_low.
            get_draw_coord = function get_draw_coord(sequence_coord // -0.5 to offset sequence between bases.
            ) {
                return Math.floor(Math.max(0, (sequence_coord - tile_low - 0.5) * w_scale));
            };

            ctx.textAlign = "center";
            var tile_region = [tile_low, tile_high];
            var base_offset = 0;
            var seq_offset = 0;
            var gap = Math.round(w_scale / 2);
            var char_width_px = ctx.canvas.manager.char_width_px;

            var block_color = strand === "+" ? this.prefs.detail_block_color : this.prefs.reverse_strand_color;

            var pack_mode = mode === "Pack";

            var draw_height = pack_mode ? PACK_FEATURE_HEIGHT : SQUISH_FEATURE_HEIGHT;

            var rect_y = y_start + 1;
            var paint_utils = new ReadPainterUtils(ctx, draw_height, w_scale, mode);
            var drawing_blocks = [];
            var s_start;
            var s_end;

            // Keep list of items that need to be drawn on top of initial drawing layer.
            var draw_last = [];

            // Parse cigar and get drawing blocks.
            var t = this._parse_cigar(cigar);
            cigar = t.cigar;
            drawing_blocks = t.blocks;

            // Draw blocks.
            for (var i = 0; i < drawing_blocks.length; i++) {
                var block = drawing_blocks[i];

                if (is_overlap([feature_start + block[0], feature_start + block[1]], tile_region)) {
                    s_start = get_draw_coord(feature_start + block[0]);
                    s_end = get_draw_coord(feature_start + block[1]);

                    // Make sure that block is drawn even if it too small to be rendered officially; in this case,
                    // read is drawn at 1px.
                    // TODO: need to ensure that s_start, s_end are calculated the same for both slotting
                    // and drawing.
                    if (s_start === s_end) {
                        s_end += 1;
                    }

                    // Draw read base as rectangle.
                    ctx.fillStyle = block_color;
                    ctx.fillRect(s_start, rect_y, s_end - s_start, draw_height);
                }
            }

            // Draw read features.
            for (var cig_id = 0, len = cigar.length; cig_id < len; cig_id++) {
                var cig = cigar[cig_id];
                var cig_op = "MIDNSHP=X"[cig[0]];
                var cig_len = cig[1];

                var seq_start = feature_start + base_offset;
                s_start = get_draw_coord(seq_start);
                s_end = get_draw_coord(seq_start + cig_len);

                // Skip feature if it's not in tile.
                if (!is_overlap([seq_start, seq_start + cig_len], tile_region)) {
                    // Update offsets.
                    base_offset = update_base_offset(base_offset, cig_op, cig_len);
                    seq_offset = update_seq_offset(seq_offset, cig_op, cig_len);
                    continue;
                }

                // Make sure that read is drawn even if it too small to be rendered officially; in this case,
                // read is drawn at 1px.
                // TODO: need to ensure that s_start, s_end are calculated the same for both slotting
                // and drawing.
                if (s_start === s_end) {
                    s_end += 1;
                }

                // Draw read feature.
                switch (cig_op) {
                    case "H": // Hard clipping.
                    case "S": // Soft clipping.
                    case "P":
                        // Padding.
                        // Sequence not present and not related to alignment; do nothing.
                        break;
                    case "M":
                        // "Match".
                        // Because it's not known whether there is a match, ignore.
                        base_offset += cig_len;
                        break;
                    case "=": // Match with reference.
                    case "X":
                        // Mismatch with reference.
                        //
                        // Draw sequence and/or variants.
                        //

                        // Get sequence to draw.
                        var cur_seq = "";
                        if (cig_op === "X") {
                            // Get sequence from read_seq.
                            cur_seq = read_seq.slice(seq_offset, seq_offset + cig_len);
                        } else if (this.ref_seq) {
                            // && cig_op === '='
                            // Use reference sequence.
                            cur_seq = this.ref_seq.slice(
                            // If read starts after tile start, slice at read start.
                            Math.max(0, seq_start - tile_low),
                            // If read ends before tile end, slice at read end.
                            Math.min(seq_start - tile_low + cig_len, tile_high - tile_low));
                        }

                        // Draw sequence. Because cur_seq starts and read/tile start, go to there to start writing.
                        var start_pos = Math.max(seq_start, tile_low);
                        for (var c = 0; c < cur_seq.length; c++) {
                            // Draw base if showing all (i.e. not showing differences) or there is a mismatch.
                            if (cur_seq && !this.prefs.show_differences || cig_op === "X") {
                                // Draw base.
                                var c_start = Math.floor(Math.max(0, (start_pos + c - tile_low) * w_scale));
                                ctx.fillStyle = this.base_color_fn(cur_seq[c]);
                                if (pack_mode && w_scale > char_width_px) {
                                    ctx.fillText(cur_seq[c], c_start, y_start + 9);
                                } else if (w_scale > 0.05) {
                                    // Require a minimum w_scale so that variants are only drawn when somewhat zoomed in.
                                    ctx.fillRect(c_start - gap, rect_y, Math.max(1, Math.round(w_scale)), draw_height);
                                }
                            }
                        }

                        // Move forward in sequence only if sequence used to get mismatches.
                        if (cig_op === "X") {
                            seq_offset += cig_len;
                        }
                        base_offset += cig_len;

                        break;
                    case "N":
                        // Skipped bases.
                        ctx.fillStyle = CONNECTOR_COLOR;
                        ctx.fillRect(s_start, rect_y + (draw_height - 1) / 2, s_end - s_start, 1);
                        // No change in seq_offset because sequence not used when skipping.
                        base_offset += cig_len;
                        break;
                    case "D":
                        // Deletion.
                        paint_utils.draw_deletion(s_start, rect_y, cig_len);
                        base_offset += cig_len;
                        break;
                    case "I":
                        // Insertion.
                        // Check to see if sequence should be drawn at all by looking at the overlap between
                        // the sequence region and the tile region.
                        var insert_x_coord = s_start - gap;

                        if (is_overlap([seq_start, seq_start + cig_len], tile_region)) {
                            var seq = read_seq.slice(seq_offset, seq_offset + cig_len);
                            // Insertion point is between the sequence start and the previous base: (-gap) moves
                            // back from sequence start to insertion point.
                            if (this.prefs.show_insertions) {
                                //
                                // Show inserted sequence above, centered on insertion point.
                                //

                                // Draw sequence.
                                // X center is offset + start - <half_sequence_length>
                                var x_center = s_start - (s_end - s_start) / 2;
                                if ((mode === "Pack" || this.mode === "Auto") && read_seq !== undefined && w_scale > char_width_px) {
                                    // Draw sequence container.
                                    ctx.fillStyle = "yellow";
                                    ctx.fillRect(x_center - gap, y_start - 9, s_end - s_start, 9);
                                    draw_last[draw_last.length] = {
                                        type: "triangle",
                                        data: [insert_x_coord, y_start + 4, 5]
                                    };
                                    ctx.fillStyle = CONNECTOR_COLOR;
                                    // Based on overlap b/t sequence and tile, get sequence to be drawn.
                                    switch (compute_overlap([seq_start, seq_start + cig_len], tile_region)) {
                                        case OVERLAP_START:
                                            seq = seq.slice(tile_low - seq_start);
                                            break;
                                        case OVERLAP_END:
                                            seq = seq.slice(0, seq_start - tile_high);
                                            break;
                                        case CONTAINED_BY:
                                            // All of sequence drawn.
                                            break;
                                        case CONTAINS:
                                            seq = seq.slice(tile_low - seq_start, seq_start - tile_high);
                                            break;
                                    }
                                    // Draw sequence.
                                    for (var _c = 0, str_len = seq.length; _c < str_len; _c++) {
                                        var _c_start = Math.floor(Math.max(0, (seq_start + _c - tile_low) * w_scale));
                                        ctx.fillText(seq[_c], _c_start - (s_end - s_start) / 2, y_start);
                                    }
                                } else {
                                    // Draw block.
                                    ctx.fillStyle = "yellow";
                                    // TODO: This is a pretty hack-ish way to fill rectangle based on mode.
                                    ctx.fillRect(x_center, y_start + (this.mode !== "Dense" ? 2 : 5), s_end - s_start, mode !== "Dense" ? SQUISH_FEATURE_HEIGHT : DENSE_FEATURE_HEIGHT);
                                }
                            } else {
                                if ((mode === "Pack" || this.mode === "Auto") && read_seq !== undefined && w_scale > char_width_px) {
                                    // Show insertions with a single number at the insertion point.
                                    draw_last.push({
                                        type: "text",
                                        data: [seq.length, insert_x_coord, y_start + 9]
                                    });
                                } else {
                                    // TODO: probably can merge this case with code above.
                                }
                            }
                        }
                        seq_offset += cig_len;
                        // No change to base offset because insertions are drawn above sequence/read.
                        break;
                }
            }

            //
            // Draw last items.
            //
            ctx.fillStyle = "yellow";
            var item;
            var type;
            var data;
            for (var _i = 0; _i < draw_last.length; _i++) {
                item = draw_last[_i];
                type = item.type;
                data = item.data;
                if (type === "text") {
                    ctx.save();
                    ctx.font = "bold " + ctx.font;
                    ctx.fillText(data[0], data[1], data[2]);
                    ctx.restore();
                } else if (type === "triangle") {
                    drawDownwardEquilateralTriangle(ctx, data[0], data[1], data[2]);
                }
            }
        }

        /**
         * Draw a complete read pair
         */

    }, {
        key: "draw_element",
        value: function draw_element(ctx, mode, feature, slot, tile_low, tile_high, w_scale, y_scale, width) {
            // All features need a start, end, and vertical center.
            // var feature_uid = feature[0];
            var feature_start = feature[1];
            var feature_end = feature[2];
            var feature_name = feature[3];

            var // -0.5 to put element between bases.
            f_start = Math.floor(Math.max(-0.5 * w_scale, (feature_start - tile_low - 0.5) * w_scale));

            var f_end = Math.ceil(Math.min(width, Math.max(0, (feature_end - tile_low - 0.5) * w_scale)));

            var y_start = (mode === "Dense" ? 0 : 0 + slot) * y_scale;

            var draw_height = mode === "Pack" ? PACK_FEATURE_HEIGHT : SQUISH_FEATURE_HEIGHT;

            // Draw read.
            if (feature[5] instanceof Array) {
                // Read is paired.
                var connector = true;

                // Draw left/forward read.
                if (feature[4][1] >= tile_low && feature[4][0] <= tile_high && feature[4][2]) {
                    this.draw_read(ctx, mode, w_scale, y_start, tile_low, tile_high, feature[4][0], feature[4][2], feature[4][3], feature[4][4]);
                } else {
                    connector = false;
                }

                // Draw right/reverse read.
                if (feature[5][1] >= tile_low && feature[5][0] <= tile_high && feature[5][2]) {
                    this.draw_read(ctx, mode, w_scale, y_start, tile_low, tile_high, feature[5][0], feature[5][2], feature[5][3], feature[5][4]);
                } else {
                    connector = false;
                }

                // Draw connector if both reads were drawn.
                // TODO: currently, there is no way to connect reads drawn on different tiles; to connect reads on different tiles, data manager
                // code is needed to join mate pairs from different regions. Alternatively, requesting multiple regions of data at once would
                // make it possible to put together more easily.
                // -0.5 to position connector correctly between reads.
                var b1_end = Math.ceil(Math.min(width, Math.max(-0.5 * w_scale, (feature[4][1] - tile_low - 0.5) * w_scale)));

                var b2_start = Math.floor(Math.max(-0.5 * w_scale, (feature[5][0] - tile_low - 0.5) * w_scale));

                if (connector && b2_start > b1_end) {
                    ctx.fillStyle = CONNECTOR_COLOR;
                    var line_height = y_start + 1 + (draw_height - 1) / 2;
                    dashedLine(ctx, b1_end, line_height, b2_start, line_height);
                }
            } else {
                // Read is single.
                this.draw_read(ctx, mode, w_scale, y_start, tile_low, tile_high, feature_start, feature[4], feature[5], feature[6]);
            }
            if (mode === "Pack" && feature_start >= tile_low && feature_name !== ".") {
                // Draw label.
                ctx.fillStyle = this.prefs.label_color;
                if (tile_low === 0 && f_start - ctx.measureText(feature_name).width < 0) {
                    ctx.textAlign = "left";
                    ctx.fillText(feature_name, f_end + LABEL_SPACING, y_start + 9, this.max_label_length);
                } else {
                    ctx.textAlign = "right";
                    ctx.fillText(feature_name, f_start - LABEL_SPACING, y_start + 9, this.max_label_length);
                }
            }

            // FIXME: provide actual coordinates for drawn read.
            return [0, 0];
        }
    }]);

    return ReadPainter;
}(FeaturePainter);

var ArcLinkedFeaturePainter = function (_LinkedFeaturePainter) {
    _inherits(ArcLinkedFeaturePainter, _LinkedFeaturePainter);

    function ArcLinkedFeaturePainter(data, view_start, view_end, prefs, mode, alpha_scaler, height_scaler) {
        _classCallCheck(this, ArcLinkedFeaturePainter);

        // Need to know the longest feature length for adding spacing
        var _this5 = _possibleConstructorReturn(this, (ArcLinkedFeaturePainter.__proto__ || Object.getPrototypeOf(ArcLinkedFeaturePainter)).call(this, data, view_start, view_end, prefs, mode, alpha_scaler, height_scaler));

        _this5.longest_feature_length = _this5.calculate_longest_feature_length();
        _this5.draw_background_connector = false;
        _this5.draw_individual_connectors = true;
        return _this5;
    }

    _createClass(ArcLinkedFeaturePainter, [{
        key: "calculate_longest_feature_length",
        value: function calculate_longest_feature_length() {
            var longest_feature_length = 0;
            for (var i = 0, len = this.data.length; i < len; i++) {
                var feature = this.data[i];
                var feature_start = feature[1];
                var feature_end = feature[2];
                longest_feature_length = Math.max(longest_feature_length, feature_end - feature_start);
            }
            return longest_feature_length;
        }
    }, {
        key: "get_top_padding",
        value: function get_top_padding(width) {
            var view_range = this.view_end - this.view_start;
            var w_scale = width / view_range;
            return Math.min(128, Math.ceil(this.longest_feature_length / 2 * w_scale));
        }
    }, {
        key: "draw_connector",
        value: function draw_connector(ctx, block1_start, block1_end, block2_start, block2_end, y_start) {
            // Arc drawing -- from closest endpoints
            var x_center = (block1_end + block2_start) / 2;
            var radius = block2_start - x_center;
            if (radius > 0) {
                ctx.beginPath();
                ctx.arc(x_center, y_start, block2_start - x_center, Math.PI, 0);
                ctx.stroke();
            }
        }
    }]);

    return ArcLinkedFeaturePainter;
}(LinkedFeaturePainter);

// Color stuff from less.js

var Color = function () {
    function Color(rgb, a) {
        _classCallCheck(this, Color);

        /**
         * The end goal here, is to parse the arguments
         * into an integer triplet, such as `128, 255, 0`
         *
         * This facilitates operations and conversions.
         */
        if (Array.isArray(rgb)) {
            this.rgb = rgb;
        } else if (rgb.length == 6) {
            this.rgb = rgb.match(/.{2}/g).map(function (c) {
                return parseInt(c, 16);
            });
        } else if (rgb.length == 7) {
            this.rgb = rgb.substring(1, 7).match(/.{2}/g).map(function (c) {
                return parseInt(c, 16);
            });
        } else {
            this.rgb = rgb.split("").map(function (c) {
                return parseInt(c + c, 16);
            });
        }
        this.alpha = typeof a === "number" ? a : 1;
    }

    _createClass(Color, [{
        key: "eval",
        value: function _eval() {
            return this;
        }

        //
        // If we have some transparency, the only way to represent it
        // is via `rgba`. Otherwise, we use the hex representation,
        // which has better compatibility with older browsers.
        // Values are capped between `0` and `255`, rounded and zero-padded.
        //

    }, {
        key: "toCSS",
        value: function toCSS() {
            if (this.alpha < 1.0) {
                return "rgba(" + this.rgb.map(function (c) {
                    return Math.round(c);
                }).concat(this.alpha).join(", ") + ")";
            } else {
                return "#" + this.rgb.map(function (i) {
                    i = Math.round(i);
                    i = (i > 255 ? 255 : i < 0 ? 0 : i).toString(16);
                    return i.length === 1 ? "0" + i : i;
                }).join("");
            }
        }
    }, {
        key: "toHSL",
        value: function toHSL() {
            var r = this.rgb[0] / 255;
            var g = this.rgb[1] / 255;
            var b = this.rgb[2] / 255;
            var a = this.alpha;
            var max = Math.max(r, g, b);
            var min = Math.min(r, g, b);
            var h;
            var s;
            var l = (max + min) / 2;
            var d = max - min;

            if (max === min) {
                h = s = 0;
            } else {
                s = l > 0.5 ? d / (2 - max - min) : d / (max + min);

                switch (max) {
                    case r:
                        h = (g - b) / d + (g < b ? 6 : 0);
                        break;
                    case g:
                        h = (b - r) / d + 2;
                        break;
                    case b:
                        h = (r - g) / d + 4;
                        break;
                }
                h /= 6;
            }
            return { h: h * 360, s: s, l: l, a: a };
        }
    }, {
        key: "toARGB",
        value: function toARGB() {
            var argb = [Math.round(this.alpha * 255)].concat(this.rgb);
            return "#" + argb.map(function (i) {
                i = Math.round(i);
                i = (i > 255 ? 255 : i < 0 ? 0 : i).toString(16);
                return i.length === 1 ? "0" + i : i;
            }).join("");
        }
    }, {
        key: "mix",
        value: function mix(color2, weight) {
            var color1 = this;

            var p = weight; // .value / 100.0;
            var w = p * 2 - 1;
            var a = color1.toHSL().a - color2.toHSL().a;

            var w1 = ((w * a == -1 ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
            var w2 = 1 - w1;

            var rgb = [color1.rgb[0] * w1 + color2.rgb[0] * w2, color1.rgb[1] * w1 + color2.rgb[1] * w2, color1.rgb[2] * w1 + color2.rgb[2] * w2];

            var alpha = color1.alpha * p + color2.alpha * (1 - p);

            return new Color(rgb, alpha);
        }
    }]);

    return Color;
}();

// End colors from less.js

var LinearRamp = function () {
    function LinearRamp(start_color, end_color, start_value, end_value) {
        _classCallCheck(this, LinearRamp);

        /**
         * Simple linear gradient
         */
        this.start_color = new Color(start_color);
        this.end_color = new Color(end_color);
        this.start_value = start_value;
        this.end_value = end_value;
        this.value_range = end_value - start_value;
    }

    _createClass(LinearRamp, [{
        key: "map_value",
        value: function map_value(value) {
            value = Math.max(value, this.start_value);
            value = Math.min(value, this.end_value);
            value = (value - this.start_value) / this.value_range;
            // HACK: just red for now
            // return "hsl(0,100%," + (value * 100) + "%)"
            return this.start_color.mix(this.end_color, 1 - value).toCSS();
        }
    }]);

    return LinearRamp;
}();

var SplitRamp = function () {
    function SplitRamp(start_color, middle_color, end_color, start_value, end_value) {
        _classCallCheck(this, SplitRamp);

        /**
         * Two gradients split away from 0
         */
        this.positive_ramp = new LinearRamp(middle_color, end_color, 0, end_value);
        this.negative_ramp = new LinearRamp(middle_color, start_color, 0, -start_value);
        this.start_value = start_value;
        this.end_value = end_value;
    }

    _createClass(SplitRamp, [{
        key: "map_value",
        value: function map_value(value) {
            value = Math.max(value, this.start_value);
            value = Math.min(value, this.end_value);
            if (value >= 0) {
                return this.positive_ramp.map_value(value);
            } else {
                return this.negative_ramp.map_value(-value);
            }
        }
    }]);

    return SplitRamp;
}();

var DiagonalHeatmapPainter = function (_Painter3) {
    _inherits(DiagonalHeatmapPainter, _Painter3);

    function DiagonalHeatmapPainter(data, view_start, view_end, prefs, mode) {
        _classCallCheck(this, DiagonalHeatmapPainter);

        var _this6 = _possibleConstructorReturn(this, (DiagonalHeatmapPainter.__proto__ || Object.getPrototypeOf(DiagonalHeatmapPainter)).call(this, data, view_start, view_end, prefs, mode));

        var i;
        var len;

        if (_this6.prefs.min_value === undefined) {
            var min_value = Infinity;
            for (i = 0, len = _this6.data.length; i < len; i++) {
                min_value = Math.min(min_value, _this6.data[i][6]);
            }
            _this6.prefs.min_value = min_value;
        }
        if (_this6.prefs.max_value === undefined) {
            var max_value = -Infinity;
            for (i = 0, len = _this6.data.length; i < len; i++) {
                max_value = Math.max(max_value, _this6.data[i][6]);
            }
            _this6.prefs.max_value = max_value;
        }
        return _this6;
    }

    _createClass(DiagonalHeatmapPainter, [{
        key: "draw",
        value: function draw(ctx, width, height, w_scale) {
            var min_value = this.prefs.min_value;
            var max_value = this.prefs.max_value;
            var view_start = this.view_start;
            var invsqrt2 = 1 / Math.sqrt(2);

            var ramp = new SplitRamp(this.prefs.neg_color, "#FFFFFF", this.prefs.pos_color, min_value, max_value);

            var d;
            var s1;
            var e1;
            var s2;
            var e2;
            var value;

            var scale = function scale(p) {
                return (p - view_start) * w_scale;
            };

            ctx.save();

            // Draw into triangle, then rotate and scale
            ctx.rotate(-45 * Math.PI / 180);
            ctx.scale(invsqrt2, invsqrt2);

            // Paint track.
            for (var i = 0, len = this.data.length; i < len; i++) {
                d = this.data[i];

                s1 = scale(d[1]);
                e1 = scale(d[2]);
                s2 = scale(d[4]);
                e2 = scale(d[5]);
                value = d[6];

                ctx.fillStyle = ramp.map_value(value);
                ctx.fillRect(s1, s2, e1 - s1, e2 - s2);
            }

            ctx.restore();
        }
    }], [{
        key: "default_prefs",
        get: function get() {
            return {
                min_value: undefined,
                max_value: undefined,
                mode: "Heatmap",
                pos_color: "#FF8C00",
                neg_color: "#4169E1"
            };
        }
    }]);

    return DiagonalHeatmapPainter;
}(Painter);

/**
 * Utilities for painting reads.
 */


var ReadPainterUtils = function () {
    function ReadPainterUtils(ctx, row_height, px_per_base, mode) {
        _classCallCheck(this, ReadPainterUtils);

        this.ctx = ctx;
        this.row_height = row_height;
        this.px_per_base = px_per_base;
        this.draw_details = (mode === "Pack" || mode === "Auto") && px_per_base >= ctx.canvas.manager.char_width_px;
        this.delete_details_thickness = 0.2;
    }

    /**
     * Draw deletion of base(s).
     * @param draw_detail if true, drawing in detail and deletion is drawn more subtly
     */


    _createClass(ReadPainterUtils, [{
        key: "draw_deletion",
        value: function draw_deletion(x, y, len) {
            this.ctx.fillStyle = "black";
            var thickness = (this.draw_details ? this.delete_details_thickness : 1) * this.row_height;
            y += 0.5 * (this.row_height - thickness);
            this.ctx.fillRect(x, y, len * this.px_per_base, thickness);
        }
    }]);

    return ReadPainterUtils;
}();

/**
 * Paints variant data onto canvas.
 */


var VariantPainter = function (_Painter4) {
    _inherits(VariantPainter, _Painter4);

    function VariantPainter(data, view_start, view_end, prefs, mode, base_color_fn) {
        _classCallCheck(this, VariantPainter);

        var _this7 = _possibleConstructorReturn(this, (VariantPainter.__proto__ || Object.getPrototypeOf(VariantPainter)).call(this, data, view_start, view_end, prefs, mode));

        _this7.base_color_fn = base_color_fn;
        _this7.divider_height = 1;
        return _this7;
    }

    /**
     * Height of a single row, depends on mode
     */


    _createClass(VariantPainter, [{
        key: "get_row_height",
        value: function get_row_height() {
            var mode = this.mode;
            var height;
            if (mode === "Dense") {
                height = DENSE_TRACK_HEIGHT;
            } else if (mode === "Squish") {
                height = SQUISH_TRACK_HEIGHT;
            } else {
                // mode === "Pack"
                height = PACK_TRACK_HEIGHT;
            }
            return height;
        }

        /**
         * Returns required height to draw a particular number of samples in a given mode.
         */

    }, {
        key: "get_required_height",
        value: function get_required_height(num_samples) {
            // FIXME: for single-sample data, height should be summary_height when zoomed out and
            // row_height when zoomed in.
            var height = this.prefs.summary_height;

            // If showing sample data, height is summary + divider + samples.
            if (num_samples > 1 && this.prefs.show_sample_data) {
                height += this.divider_height + num_samples * this.get_row_height();
            }
            return height;
        }

        /**
         * Draw on the context using a rectangle of width x height with scale w_scale.
         */

    }, {
        key: "draw",
        value: function draw(ctx, width, height, w_scale) {
            ctx.save();

            var /**
                * Returns dictionary of information about an indel; returns empty if there no indel. Assumes indel is left-aligned.
                * Dict attributes:
                *    -type: 'insertion' or 'deletion'
                *    -start: where the deletion starts relative to reference start
                *    -len: how long the deletion is
                */
            get_indel_info = function get_indel_info(ref, alt) {
                var ref_len = ref.length;
                var alt_len = alt.length;
                var start = 0;
                var len = 1;
                var type = null;
                if (alt === "-") {
                    type = "deletion";
                    len = ref.length;
                } else if (ref.indexOf(alt) === 0 && ref_len > alt_len) {
                    type = "deletion";
                    len = ref_len - alt_len;
                    start = alt_len;
                } else if (alt.indexOf(ref) === 0 && ref_len < alt_len) {
                    // Insertion.
                    type = "insertion";
                    len = alt_len - ref_len;
                    start = alt_len;
                }

                return type !== null ? { type: type, start: start, len: len } : {};
            };

            // Draw.
            var locus_data;

            var pos;
            var ref;
            var alt;
            var sample_gts;
            var allele_counts;
            var variant;
            var draw_x_start;
            var draw_y_start;
            var genotype;

            var // Always draw variants at least 1 pixel wide.
            base_px = Math.max(1, Math.floor(w_scale));

            var // Determine number of samples.
            num_samples = this.data.length ? this.data[0][7].split(",").length : 0;

            var row_height = this.mode === "Squish" ? SQUISH_TRACK_HEIGHT : PACK_TRACK_HEIGHT;

            var // If zoomed out, fill the whole row with feature to make it easier to read;
            // when zoomed in, use feature height so that there are gaps in sample rows.
            feature_height = w_scale < 0.1 ? row_height : this.mode === "Squish" ? SQUISH_FEATURE_HEIGHT : PACK_FEATURE_HEIGHT;

            var draw_summary = true;

            var paint_utils = new ReadPainterUtils(ctx, row_height, w_scale, this.mode);

            var j;

            // If there's a single sample, update drawing variables.
            if (num_samples === 1) {
                row_height = feature_height = w_scale < ctx.canvas.manager.char_width_px ? this.prefs.summary_height : row_height;
                paint_utils.row_height = row_height;
                // No summary when there's a single sample.
                draw_summary = false;
            }

            // Draw divider between summary and samples.
            if (this.prefs.show_sample_data && draw_summary) {
                ctx.fillStyle = "#F3F3F3";
                ctx.globalAlpha = 1;
                ctx.fillRect(0, this.prefs.summary_height - this.divider_height, width, this.divider_height);
            }

            // Draw variants.
            ctx.textAlign = "center";
            for (var i = 0; i < this.data.length; i++) {
                // Get locus data.
                locus_data = this.data[i];
                pos = locus_data[1];
                ref = locus_data[3];
                alt = [locus_data[4].split(",")];
                sample_gts = locus_data[7].split(",");
                allele_counts = locus_data.slice(8);

                // Process alterate values to derive information about each alt.
                alt = _.map(_.flatten(alt), function (a) {
                    var alt_info = {
                        type: "snp",
                        value: a,
                        start: 0
                    };

                    var indel_info = get_indel_info(ref, a);

                    return _.extend(alt_info, indel_info);
                });

                // Only draw locus data if it's in viewing region.
                if (pos < this.view_start || pos > this.view_end) {
                    continue;
                }

                // Draw summary for alleles.
                if (draw_summary) {
                    ctx.fillStyle = "#999999";
                    ctx.globalAlpha = 1;
                    for (j = 0; j < alt.length; j++) {
                        // Draw background for summary.
                        draw_x_start = this.get_start_draw_pos(pos + alt[j].start, w_scale);
                        ctx.fillRect(draw_x_start, 0, base_px, this.prefs.summary_height);
                        draw_y_start = this.prefs.summary_height;
                        // Draw allele fractions onto summary.
                        for (j = 0; j < alt.length; j++) {
                            ctx.fillStyle = alt[j].type === "deletion" ? "black" : this.base_color_fn(alt[j].value);
                            var allele_frac = allele_counts / sample_gts.length;
                            var draw_height = Math.ceil(this.prefs.summary_height * allele_frac);
                            ctx.fillRect(draw_x_start, draw_y_start - draw_height, base_px, draw_height);
                            draw_y_start -= draw_height;
                        }
                    }
                }

                // Done drawing if not showing samples data.
                if (!this.prefs.show_sample_data) {
                    continue;
                }

                // Draw sample genotype(s).
                draw_y_start = draw_summary ? this.prefs.summary_height + this.divider_height : 0;
                for (j = 0; j < sample_gts.length; j++, draw_y_start += row_height) {
                    genotype = sample_gts[j] ? sample_gts[j].split(/\/|\|/) : ["0", "0"];

                    // Get variant to draw and set drawing properties.
                    variant = null;
                    if (genotype[0] === genotype[1]) {
                        if (genotype[0] === ".") {
                            // TODO: draw uncalled variant.
                        } else if (genotype[0] !== "0") {
                            // Homozygous for variant.
                            variant = alt[parseInt(genotype[0], 10) - 1];
                            ctx.globalAlpha = 1;
                        }
                        // else reference
                    } else {
                        // Heterozygous for variant.
                        variant = genotype[0] !== "0" ? genotype[0] : genotype[1];
                        variant = alt[parseInt(variant, 10) - 1];
                        ctx.globalAlpha = 0.5;
                    }

                    // If there's a variant, draw it.
                    if (variant) {
                        draw_x_start = this.get_start_draw_pos(pos + variant.start, w_scale);
                        if (variant.type === "snp") {
                            var snp = variant.value;
                            ctx.fillStyle = this.base_color_fn(snp);
                            if (paint_utils.draw_details) {
                                ctx.fillText(snp, this.get_draw_pos(pos, w_scale), draw_y_start + row_height);
                            } else {
                                ctx.fillRect(draw_x_start, draw_y_start + 1, base_px, feature_height);
                            }
                        } else if (variant.type === "deletion") {
                            paint_utils.draw_deletion(draw_x_start, draw_y_start + 1, variant.len);
                        } else {
                            // TODO: handle insertions.
                        }
                    }
                }
            }

            ctx.restore();
        }
    }]);

    return VariantPainter;
}(Painter);

exports.default = {
    Scaler: Scaler,
    LinePainter: LinePainter,
    LinkedFeaturePainter: LinkedFeaturePainter,
    ReadPainter: ReadPainter,
    ArcLinkedFeaturePainter: ArcLinkedFeaturePainter,
    DiagonalHeatmapPainter: DiagonalHeatmapPainter,
    VariantPainter: VariantPainter
};

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _localization = __webpack_require__(3);

var _localization2 = _interopRequireDefault(_localization);

var _underscore = __webpack_require__(1);

var _ = _interopRequireWildcard(_underscore);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var extend = _.extend;

/**
 * Filters that enable users to show/hide data points dynamically.
 */
var Filter = function Filter(obj_dict) {
    this.manager = null;
    this.name = obj_dict.name;
    // Index into payload to filter.
    this.index = obj_dict.index;
    this.tool_id = obj_dict.tool_id;
    // Name to use for filter when building expression for tool.
    this.tool_exp_name = obj_dict.tool_exp_name;
};

extend(Filter.prototype, {
    /**
     * Convert filter to dictionary.
     */
    to_dict: function to_dict() {
        return {
            name: this.name,
            index: this.index,
            tool_id: this.tool_id,
            tool_exp_name: this.tool_exp_name
        };
    }
});

/**
 * Creates an action icon.
 */
var create_action_icon = function create_action_icon(title, css_class, on_click_fn) {
    return $("<a/>").attr("href", "javascript:void(0);").attr("title", title).addClass("icon-button").addClass(css_class).tooltip().click(on_click_fn);
};

/**
 * Number filters have a min, max as well as a low, high; low and high are used
 */
var NumberFilter = function NumberFilter(obj_dict) {
    //
    // Attribute init.
    //
    Filter.call(this, obj_dict);
    // Filter low/high. These values are used to filter elements.
    this.low = "low" in obj_dict ? obj_dict.low : -Number.MAX_VALUE;
    this.high = "high" in obj_dict ? obj_dict.high : Number.MAX_VALUE;
    // Slide min/max. These values are used to set/update slider.
    this.min = "min" in obj_dict ? obj_dict.min : Number.MAX_VALUE;
    this.max = "max" in obj_dict ? obj_dict.max : -Number.MAX_VALUE;
    // UI elements associated with filter.
    this.container = null;
    this.slider = null;
    this.slider_label = null;

    //
    // Create HTML.
    //

    // Function that supports inline text editing of slider values.
    // Enable users to edit parameter's value via a text box.
    var edit_slider_values = function edit_slider_values(container, span, slider) {
        container.click(function () {
            var cur_value = span.text();
            var max = parseFloat(slider.slider("option", "max"));

            var input_size = max <= 1 ? 4 : max <= 1000000 ? max.toString().length : 6;

            var multi_value = false;
            var slider_row = $(this).parents(".slider-row");

            // Row now has input.
            slider_row.addClass("input");

            // Increase input size if there are two values.
            if (slider.slider("option", "values")) {
                input_size = 2 * input_size + 1;
                multi_value = true;
            }
            span.text("");
            // Temporary input for changing value.
            $("<input type='text'/>").attr("size", input_size).attr("maxlength", input_size).attr("value", cur_value).appendTo(span).focus().select().click(function (e) {
                // Don't want click to propogate up to values_span and restart everything.
                e.stopPropagation();
            }).blur(function () {
                $(this).remove();
                span.text(cur_value);
                slider_row.removeClass("input");
            }).keyup(function (e) {
                if (e.keyCode === 27) {
                    // Escape key.
                    $(this).trigger("blur");
                } else if (e.keyCode === 13) {
                    //
                    // Enter/return key initiates callback. If new value(s) are in slider range,
                    // change value (which calls slider's change() function).
                    //
                    var slider_min = slider.slider("option", "min");

                    var slider_max = slider.slider("option", "max");

                    var invalid = function invalid(a_val) {
                        return isNaN(a_val) || a_val > slider_max || a_val < slider_min;
                    };

                    var new_value = $(this).val();
                    if (!multi_value) {
                        new_value = parseFloat(new_value);
                        if (invalid(new_value)) {
                            alert("Parameter value must be in the range [" + slider_min + "-" + slider_max + "]");
                            return $(this);
                        }
                    } else {
                        // Multi value.
                        new_value = new_value.split("-");
                        new_value = [parseFloat(new_value[0]), parseFloat(new_value[1])];
                        if (invalid(new_value[0]) || invalid(new_value[1])) {
                            alert("Parameter value must be in the range [" + slider_min + "-" + slider_max + "]");
                            return $(this);
                        }
                    }

                    // Updating the slider also updates slider values and removes input.
                    slider.slider(multi_value ? "values" : "value", new_value);
                    slider_row.removeClass("input");
                }
            });
        });
    };

    var filter = this;

    filter.parent_div = $("<div/>").addClass("filter-row slider-row");

    // Set up filter label (name, values).
    var filter_label = $("<div/>").addClass("elt-label").appendTo(filter.parent_div);

    $("<span/>").addClass("slider-name").text(filter.name + "  ").appendTo(filter_label);

    var values_span = $("<span/>").text(this.low + "-" + this.high);

    var values_span_container = $("<span/>").addClass("slider-value").appendTo(filter_label).append("[").append(values_span).append("]");

    filter.values_span = values_span;

    // Set up slider for filter.
    var slider_div = $("<div/>").addClass("slider").appendTo(filter.parent_div);
    filter.control_element = $("<div/>").attr("id", filter.name + "-filter-control").appendTo(slider_div);
    filter.control_element.slider({
        range: true,
        min: this.min,
        max: this.max,
        step: this.get_slider_step(this.min, this.max),
        values: [this.low, this.high],
        slide: function slide(event, ui) {
            filter.slide(event, ui);
        },
        change: function change(event, ui) {
            filter.control_element.slider("option", "slide").call(filter.control_element, event, ui);
        }
    });
    filter.slider = filter.control_element;
    filter.slider_label = values_span;

    // Enable users to edit slider values via text box.
    edit_slider_values(values_span_container, values_span, filter.control_element);

    // Set up filter display controls.
    var display_controls_div = $("<div/>").addClass("display-controls").appendTo(filter.parent_div);
    this.transparency_icon = create_action_icon("Use filter for data transparency", "layer-transparent", function () {
        if (filter.manager.alpha_filter !== filter) {
            // Setting this filter as the alpha filter.
            filter.manager.alpha_filter = filter;
            // Update UI for new filter.
            filter.manager.parent_div.find(".layer-transparent").removeClass("active").hide();
            filter.transparency_icon.addClass("active").show();
        } else {
            // Clearing filter as alpha filter.
            filter.manager.alpha_filter = null;
            filter.transparency_icon.removeClass("active");
        }
        filter.manager.track.request_draw({
            force: true,
            clear_after: true
        });
    }).appendTo(display_controls_div).hide();
    this.height_icon = create_action_icon("Use filter for data height", "arrow-resize-090", function () {
        if (filter.manager.height_filter !== filter) {
            // Setting this filter as the height filter.
            filter.manager.height_filter = filter;
            // Update UI for new filter.
            filter.manager.parent_div.find(".arrow-resize-090").removeClass("active").hide();
            filter.height_icon.addClass("active").show();
        } else {
            // Clearing filter as alpha filter.
            filter.manager.height_filter = null;
            filter.height_icon.removeClass("active");
        }
        filter.manager.track.request_draw({
            force: true,
            clear_after: true
        });
    }).appendTo(display_controls_div).hide();
    filter.parent_div.hover(function () {
        filter.transparency_icon.show();
        filter.height_icon.show();
    }, function () {
        if (filter.manager.alpha_filter !== filter) {
            filter.transparency_icon.hide();
        }
        if (filter.manager.height_filter !== filter) {
            filter.height_icon.hide();
        }
    });

    // Add to clear floating layout.
    $("<div style='clear: both;'/>").appendTo(filter.parent_div);
};
extend(NumberFilter.prototype, {
    /**
     * Convert filter to dictionary.
     */
    to_dict: function to_dict() {
        var obj_dict = Filter.prototype.to_dict.call(this);
        return extend(obj_dict, {
            type: "number",
            min: this.min,
            max: this.max,
            low: this.low,
            high: this.high
        });
    },
    /**
     * Return a copy of filter.
     */
    copy: function copy() {
        return new NumberFilter({
            name: this.name,
            index: this.index,
            tool_id: this.tool_id,
            tool_exp_name: this.tool_exp_name
        });
    },
    /**
     * Get step for slider.
     */
    // FIXME: make this a "static" function.
    get_slider_step: function get_slider_step(min, max) {
        var range = max - min;
        return range <= 2 ? 0.01 : 1;
    },
    /**
     * Handle slide events.
     */
    slide: function slide(event, ui) {
        var values = ui.values;

        // Set new values in UI.
        this.values_span.text(values[0] + "-" + values[1]);

        // Set new values in filter.
        this.low = values[0];
        this.high = values[1];

        // Set timeout to update if filter low, high are stable.
        var self = this;
        setTimeout(function () {
            if (values[0] === self.low && values[1] === self.high) {
                self.manager.track.request_draw({
                    force: true,
                    clear_after: true
                });
            }
        }, 25);
    },
    /**
     * Returns true if filter can be applied to element.
     */
    applies_to: function applies_to(element) {
        if (element.length > this.index) {
            return true;
        }
        return false;
    },
    /**
     * Helper function: returns true if value in in filter's [low, high] range.
     */
    _keep_val: function _keep_val(val) {
        return isNaN(val) || val >= this.low && val <= this.high;
    },
    /**
     * Returns true if (a) element's value(s) is in [low, high] (range is inclusive)
     * or (b) if value is non-numeric and hence unfilterable.
     */
    keep: function keep(element) {
        if (!this.applies_to(element)) {
            // No element to filter on.
            return true;
        }

        // Do filtering.
        var to_filter = element[this.index];
        if (to_filter instanceof Array) {
            var returnVal = true;
            for (var i = 0; i < to_filter.length; i++) {
                if (!this._keep_val(to_filter[i])) {
                    // Exclude element.
                    returnVal = false;
                    break;
                }
            }
            return returnVal;
        } else {
            return this._keep_val(element[this.index]);
        }
    },
    /**
     * Update filter's min and max values based on element's values.
     */
    update_attrs: function update_attrs(element) {
        var updated = false;
        if (!this.applies_to(element)) {
            return updated;
        }

        //
        // Update filter's min, max based on element values.
        //

        // Make value(s) into an Array.
        var values = element[this.index];
        if (!(values instanceof Array)) {
            values = [values];
        }

        // Loop through values and update min, max.
        for (var i = 0; i < values.length; i++) {
            var value = values[i];
            if (value < this.min) {
                this.min = Math.floor(value);
                updated = true;
            }
            if (value > this.max) {
                this.max = Math.ceil(value);
                updated = true;
            }
        }
        return updated;
    },
    /**
     * Update filter's slider.
     */
    update_ui_elt: function update_ui_elt() {
        // Only show filter if min < max because filter is not useful otherwise. This
        // covers all corner cases, such as when min, max have not been defined and
        // when min == max.
        if (this.min < this.max) {
            this.parent_div.show();
        } else {
            this.parent_div.hide();
        }

        var slider_min = this.slider.slider("option", "min");
        var slider_max = this.slider.slider("option", "max");
        if (this.min < slider_min || this.max > slider_max) {
            // Update slider min, max, step.
            this.slider.slider("option", "min", this.min);
            this.slider.slider("option", "max", this.max);
            this.slider.slider("option", "step", this.get_slider_step(this.min, this.max));
            // Refresh slider:
            // TODO: do we want to keep current values or reset to min/max?
            // Currently we reset values:
            this.slider.slider("option", "values", [this.min, this.max]);
            // To use the current values.
            //var values = this.slider.slider( "option", "values" );
            //this.slider.slider( "option", "values", values );
        }
    }
});

/**
 * Manages a set of filters.
 */
var FiltersManager = function FiltersManager(track, obj_dict) {
    this.track = track;
    this.alpha_filter = null;
    this.height_filter = null;
    this.filters = [];

    //
    // Create HTML.
    //

    //
    // Create parent div.
    //
    this.parent_div = $("<div/>").addClass("filters").hide();
    // Disable dragging, double clicking, keys on div so that actions on slider do not impact viz.
    this.parent_div.bind("drag", function (e) {
        e.stopPropagation();
    }).click(function (e) {
        e.stopPropagation();
    }).bind("dblclick", function (e) {
        e.stopPropagation();
    }).bind("keydown", function (e) {
        e.stopPropagation();
    });

    //
    // Restore state from dict.
    //
    if (obj_dict && "filters" in obj_dict) {
        // Second condition needed for backward compatibility.
        var alpha_filter_name = "alpha_filter" in obj_dict ? obj_dict.alpha_filter : null;

        var height_filter_name = "height_filter" in obj_dict ? obj_dict.height_filter : null;

        var filters_dict = obj_dict.filters;
        var filter;
        for (var i = 0; i < filters_dict.length; i++) {
            if (filters_dict[i].type === "number") {
                filter = new NumberFilter(filters_dict[i]);
                this.add_filter(filter);
                if (filter.name === alpha_filter_name) {
                    this.alpha_filter = filter;
                    filter.transparency_icon.addClass("active").show();
                }
                if (filter.name === height_filter_name) {
                    this.height_filter = filter;
                    filter.height_icon.addClass("active").show();
                }
            } else {
                console.log("ERROR: unsupported filter: ", filters_dict[i]);
            }
        }

        if ("visible" in obj_dict && obj_dict.visible) {
            this.parent_div.show();
        }
    }

    // Add button to filter complete dataset.
    if (this.filters.length !== 0) {
        var run_buttons_row = $("<div/>").addClass("param-row").appendTo(this.parent_div);
        var run_on_dataset_button = $("<input type='submit'/>").attr("value", "Run on complete dataset").appendTo(run_buttons_row);
        var filter_manager = this;
        run_on_dataset_button.click(function () {
            filter_manager.run_on_dataset();
        });
    }
};

extend(FiltersManager.prototype, {
    // HTML manipulation and inspection.
    show: function show() {
        this.parent_div.show();
    },
    hide: function hide() {
        this.parent_div.hide();
    },
    toggle: function toggle() {
        this.parent_div.toggle();
    },
    visible: function visible() {
        return this.parent_div.is(":visible");
    },
    /**
     * Returns dictionary for manager.
     */
    to_dict: function to_dict() {
        var obj_dict = {};
        var filter_dicts = [];
        var filter;

        // Include individual filter states.
        for (var i = 0; i < this.filters.length; i++) {
            filter = this.filters[i];
            filter_dicts.push(filter.to_dict());
        }
        obj_dict.filters = filter_dicts;

        // Include transparency, height filters.
        obj_dict.alpha_filter = this.alpha_filter ? this.alpha_filter.name : null;
        obj_dict.height_filter = this.height_filter ? this.height_filter.name : null;

        // Include visibility.
        obj_dict.visible = this.parent_div.is(":visible");

        return obj_dict;
    },
    /**
     * Return a copy of the manager.
     */
    copy: function copy(new_track) {
        var copy = new FiltersManager(new_track);
        for (var i = 0; i < this.filters.length; i++) {
            copy.add_filter(this.filters[i].copy());
        }
        return copy;
    },
    /**
     * Add a filter to the manager.
     */
    add_filter: function add_filter(filter) {
        filter.manager = this;
        this.parent_div.append(filter.parent_div);
        this.filters.push(filter);
    },
    /**
     * Remove all filters from manager.
     */
    remove_all: function remove_all() {
        this.filters = [];
        this.parent_div.children().remove();
    },
    /**
     * Initialize filters.
     */

    init_filters: function init_filters() {
        for (var i = 0; i < this.filters.length; i++) {
            var filter = this.filters[i];
            filter.update_ui_elt();
        }
    },
    /**
     * Clear filters so that they do not impact track display.
     */
    clear_filters: function clear_filters() {
        for (var i = 0; i < this.filters.length; i++) {
            var filter = this.filters[i];
            filter.slider.slider("option", "values", [filter.min, filter.max]);
        }
        this.alpha_filter = null;
        this.height_filter = null;

        // Hide icons for setting filters.
        this.parent_div.find(".icon-button").hide();
    },
    run_on_dataset: function run_on_dataset() {
        // Get or create dictionary item.
        var get_or_create_dict_item = function get_or_create_dict_item(dict, key, new_item) {
            // Add new item to dict if
            if (!(key in dict)) {
                dict[key] = new_item;
            }
            return dict[key];
        };

        //
        // Find and group active filters. Active filters are those being used to hide data.
        // Filters with the same tool id are grouped.
        //
        var active_filters = {};

        var filter;
        var tool_filter_conditions;
        for (var i = 0; i < this.filters.length; i++) {
            filter = this.filters[i];
            if (filter.tool_id) {
                // Add filtering conditions if filter low/high are set.
                if (filter.min !== filter.low) {
                    tool_filter_conditions = get_or_create_dict_item(active_filters, filter.tool_id, []);
                    tool_filter_conditions[tool_filter_conditions.length] = filter.tool_exp_name + " >= " + filter.low;
                }
                if (filter.max !== filter.high) {
                    tool_filter_conditions = get_or_create_dict_item(active_filters, filter.tool_id, []);
                    tool_filter_conditions[tool_filter_conditions.length] = filter.tool_exp_name + " <= " + filter.high;
                }
            }
        }

        //
        // Use tools to run filters.
        //

        // Create list of (tool_id, tool_filters) tuples.
        var active_filters_list = [];
        for (var tool_id in active_filters) {
            active_filters_list[active_filters_list.length] = [tool_id, active_filters[tool_id]];
        }

        // Invoke recursive function to run filters; this enables chaining of filters via
        // iteratively application.
        (function run_filter(input_dataset_id, filters) {
            var // Set up filtering info and params.
            filter_tuple = filters[0];

            var tool_id = filter_tuple[0];
            var tool_filters = filter_tuple[1];
            var tool_filter_str = "(" + tool_filters.join(") and (") + ")";

            var url_params = {
                cond: tool_filter_str,
                input: input_dataset_id,
                target_dataset_id: input_dataset_id,
                tool_id: tool_id
            };

            // Remove current filter.
            filters = filters.slice(1);

            // DBTODO: This will never work, run_tool_url doesn't exist?
            $.getJSON(run_tool_url, url_params, function (response) {
                if (response.error) {
                    // General error.
                    Galaxy.modal.show({
                        title: (0, _localization2.default)("Filter Dataset"),
                        body: "Error running tool " + tool_id,
                        buttons: { Close: Galaxy.modal.hide() }
                    });
                } else if (filters.length === 0) {
                    // No more filters to run.
                    Galaxy.modal.show({
                        title: (0, _localization2.default)("Filtering Dataset"),
                        body: "Filter(s) are running on the complete dataset. Outputs are in dataset's history.",
                        buttons: { Close: Galaxy.modal.hide() }
                    });
                } else {
                    // More filters to run.
                    run_filter(response.dataset_id, filters);
                }
            });
        })(this.track.dataset_id, active_filters_list);
    }
});

exports.default = {
    FiltersManager: FiltersManager,
    NumberFilter: NumberFilter
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 90 */,
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Citations_vue_vue_type_template_id_3bd49a6c__ = __webpack_require__(92);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Citations_vue_vue_type_template_id_3bd49a6c__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Citations_vue_vue_type_template_id_3bd49a6c__["b"]; });


/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('h4',{staticClass:"mb-0",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n        Citations\n        "),(_vm.viewRender)?_c('b-button',{staticClass:"citations-to-bibtex",attrs:{"title":"Show all in BibTeX format."},on:{"click":_vm.toggleViewRender}},[_c('i',{staticClass:"fa fa-pencil-square-o"}),_vm._v("\n            Show BibTeX\n        ")]):_c('b-button',{attrs:{"title":"Return to formatted citation list."},on:{"click":_vm.toggleViewRender}},[_c('i',{staticClass:"fa fa-times"}),_vm._v("\n            Hide BibTeX\n        ")])],1),_vm._v(" "),(_vm.source === 'histories')?_c('div',{staticClass:"infomessage"},[_vm._v("\n        When writing up your analysis, remember to include all references that should be cited in order\n        to completely describe your work. Also, please remember to "),_c('a',{attrs:{"href":"https://galaxyproject.org/citing-galaxy"}},[_vm._v("cite Galaxy")]),_vm._v(".\n    ")]):_vm._e(),_vm._v(" "),(_vm.viewRender)?_c('span',{staticClass:"citations-formatted"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.formattedReferences)}})]):_c('pre',[_vm._v("        "),_c('code',{staticClass:"citations-bibtex"},[_vm._v("\n            "+_vm._s(_vm.content)+"\n        ")]),_vm._v("\n    ")])])}
var staticRenderFns = []



/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

/* start bibtexParse 0.0.24 */

//Original work by Henrik Muehe (c) 2010
//
//CommonJS port by Mikola Lysenko 2013
//
//Port to Browser lib by ORCID / RCPETERS
//
//Issues:
//no comment handling within strings
//no string concatenation
//no variable values yet
//Grammar implemented here:
//bibtex -> (string | preamble | comment | entry)*;
//string -> '@STRING' '{' key_equals_value '}';
//preamble -> '@PREAMBLE' '{' value '}';
//comment -> '@COMMENT' '{' value '}';
//entry -> '@' key '{' key ',' key_value_list '}';
//key_value_list -> key_equals_value (',' key_equals_value)*;
//key_equals_value -> key '=' value;
//value -> value_quotes | value_braces | key;
//value_quotes -> '"' .*? '"'; // not quite
//value_braces -> '{' .*? '"'; // not quite
(function(exports) {

    function BibtexParser() {

        this.months = ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"];
        this.notKey = [',','{','}',' ','='];
        this.pos = 0;
        this.input = "";
        this.entries = new Array();

        this.currentEntry = "";

        this.setInput = function(t) {
            this.input = t;
        };

        this.getEntries = function() {
            return this.entries;
        };

        this.isWhitespace = function(s) {
            return (s == ' ' || s == '\r' || s == '\t' || s == '\n');
        };

        this.match = function(s, canCommentOut) {
            if (canCommentOut == undefined || canCommentOut == null)
                canCommentOut = true;
            this.skipWhitespace(canCommentOut);
            if (this.input.substring(this.pos, this.pos + s.length) == s) {
                this.pos += s.length;
            } else {
                throw "Token mismatch, expected " + s + ", found "
                        + this.input.substring(this.pos);
            };
            this.skipWhitespace(canCommentOut);
        };

        this.tryMatch = function(s, canCommentOut) {
            if (canCommentOut == undefined || canCommentOut == null)
                canCommentOut = true;
            this.skipWhitespace(canCommentOut);
            if (this.input.substring(this.pos, this.pos + s.length) == s) {
                return true;
            } else {
                return false;
            };
            this.skipWhitespace(canCommentOut);
        };

        /* when search for a match all text can be ignored, not just white space */
        this.matchAt = function() {
            while (this.input.length > this.pos && this.input[this.pos] != '@') {
                this.pos++;
            };

            if (this.input[this.pos] == '@') {
                return true;
            };
            return false;
        };

        this.skipWhitespace = function(canCommentOut) {
            while (this.isWhitespace(this.input[this.pos])) {
                this.pos++;
            };
            if (this.input[this.pos] == "%" && canCommentOut == true) {
                while (this.input[this.pos] != "\n") {
                    this.pos++;
                };
                this.skipWhitespace(canCommentOut);
            };
        };

        this.value_braces = function() {
            var bracecount = 0;
            this.match("{", false);
            var start = this.pos;
            var escaped = false;
            while (true) {
                if (!escaped) {
                    if (this.input[this.pos] == '}') {
                        if (bracecount > 0) {
                            bracecount--;
                        } else {
                            var end = this.pos;
                            this.match("}", false);
                            return this.input.substring(start, end);
                        };
                    } else if (this.input[this.pos] == '{') {
                        bracecount++;
                    } else if (this.pos >= this.input.length - 1) {
                        throw "Unterminated value";
                    };
                };
                if (this.input[this.pos] == '\\' && escaped == false)
                    escaped = true;
                else
                    escaped = false;
                this.pos++;
            };
        };

        this.value_comment = function() {
            var str = '';
            var brcktCnt = 0;
            while (!(this.tryMatch("}", false) && brcktCnt == 0)) {
                str = str + this.input[this.pos];
                if (this.input[this.pos] == '{')
                    brcktCnt++;
                if (this.input[this.pos] == '}')
                    brcktCnt--;
                if (this.pos >= this.input.length - 1) {
                    throw "Unterminated value:" + this.input.substring(start);
                };
                this.pos++;
            };
            return str;
        };

        this.value_quotes = function() {
            this.match('"', false);
            var start = this.pos;
            var escaped = false;
            while (true) {
                if (!escaped) {
                    if (this.input[this.pos] == '"') {
                        var end = this.pos;
                        this.match('"', false);
                        return this.input.substring(start, end);
                    } else if (this.pos >= this.input.length - 1) {
                        throw "Unterminated value:" + this.input.substring(start);
                    };
                }
                if (this.input[this.pos] == '\\' && escaped == false)
                    escaped = true;
                else
                    escaped = false;
                this.pos++;
            };
        };

        this.single_value = function() {
            var start = this.pos;
            if (this.tryMatch("{")) {
                return this.value_braces();
            } else if (this.tryMatch('"')) {
                return this.value_quotes();
            } else {
                var k = this.key();
                if (k.match("^[0-9]+$"))
                    return k;
                else if (this.months.indexOf(k.toLowerCase()) >= 0)
                    return k.toLowerCase();
                else
                    throw "Value expected:" + this.input.substring(start) + ' for key: ' + k;

            };
        };

        this.value = function() {
            var values = [];
            values.push(this.single_value());
            while (this.tryMatch("#")) {
                this.match("#");
                values.push(this.single_value());
            };
            return values.join("");
        };

        this.key = function(optional) {
            var start = this.pos;
            while (true) {
                if (this.pos >= this.input.length) {
                    throw "Runaway key";
                };
                                // а-яА-Я is Cyrillic
                //console.log(this.input[this.pos]);
                if (this.notKey.indexOf(this.input[this.pos]) >= 0) {
                    if (optional && this.input[this.pos] != ',') {
                        this.pos = start;
                        return null;
                    };
                    return this.input.substring(start, this.pos);
                } else {
                    this.pos++;

                };
            };
        };

        this.key_equals_value = function() {
            var key = this.key();
            if (this.tryMatch("=")) {
                this.match("=");
                var val = this.value();
                key = key.trim()
                return [ key, val ];
            } else {
                throw "... = value expected, equals sign missing:"
                        + this.input.substring(this.pos);
            };
        };

        this.key_value_list = function() {
            var kv = this.key_equals_value();
            this.currentEntry['entryTags'] = {};
            this.currentEntry['entryTags'][kv[0]] = kv[1];
            while (this.tryMatch(",")) {
                this.match(",");
                // fixes problems with commas at the end of a list
                if (this.tryMatch("}")) {
                    break;
                }
                ;
                kv = this.key_equals_value();
                this.currentEntry['entryTags'][kv[0]] = kv[1];
            };
        };

        this.entry_body = function(d) {
            this.currentEntry = {};
            this.currentEntry['citationKey'] = this.key(true);
            this.currentEntry['entryType'] = d.substring(1);
            if (this.currentEntry['citationKey'] != null) {
                this.match(",");
            }
            this.key_value_list();
            this.entries.push(this.currentEntry);
        };

        this.directive = function() {
            this.match("@");
            return "@" + this.key();
        };

        this.preamble = function() {
            this.currentEntry = {};
            this.currentEntry['entryType'] = 'PREAMBLE';
            this.currentEntry['entry'] = this.value_comment();
            this.entries.push(this.currentEntry);
        };

        this.comment = function() {
            this.currentEntry = {};
            this.currentEntry['entryType'] = 'COMMENT';
            this.currentEntry['entry'] = this.value_comment();
            this.entries.push(this.currentEntry);
        };

        this.entry = function(d) {
            this.entry_body(d);
        };

        this.alernativeCitationKey = function () {
            this.entries.forEach(function (entry) {
                if (!entry.citationKey && entry.entryTags) {
                    entry.citationKey = '';
                    if (entry.entryTags.author) {
                        entry.citationKey += entry.entryTags.author.split(',')[0] += ', ';
                    }
                    entry.citationKey += entry.entryTags.year;
                }
            });
        }

        this.bibtex = function() {
            while (this.matchAt()) {
                var d = this.directive();
                this.match("{");
                if (d.toUpperCase() == "@STRING") {
                    this.string();
                } else if (d.toUpperCase() == "@PREAMBLE") {
                    this.preamble();
                } else if (d.toUpperCase() == "@COMMENT") {
                    this.comment();
                } else {
                    this.entry(d);
                }
                this.match("}");
            };

            this.alernativeCitationKey();
        };
    };

    exports.toJSON = function(bibtex) {
        var b = new BibtexParser();
        b.setInput(bibtex);
        b.bibtex();
        return b.entries;
    };

    /* added during hackathon don't hate on me */
    exports.toBibtex = function(json) {
        var out = '';
        for ( var i in json) {
            out += "@" + json[i].entryType;
            out += '{';
            if (json[i].citationKey)
                out += json[i].citationKey + ', ';
            if (json[i].entry)
                out += json[i].entry ;
            if (json[i].entryTags) {
                var tags = '';
                for (var jdx in json[i].entryTags) {
                    if (tags.length != 0)
                        tags += ', ';
                    tags += jdx + '= {' + json[i].entryTags[jdx] + '}';
                }
                out += tags;
            }
            out += '}\n\n';
        }
        return out;

    };

})( false ? this['bibtexParse'] = {} : exports);

/* end bibtexParse */


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(95));
__export(__webpack_require__(96));
__export(__webpack_require__(43));
__export(__webpack_require__(46));
__export(__webpack_require__(13));
__export(__webpack_require__(47));
__export(__webpack_require__(140));
__export(__webpack_require__(141));
__export(__webpack_require__(51));
//# sourceMappingURL=index.js.map


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.aliases = {
    "mathfrak": "frak",
    "mathcal": "cal",
    "mathbb": "bb",
    "mathbf": "bf",
    "dfrac": "frac",
    "ldots": "dots"
};
//# sourceMappingURL=command-aliases.js.map

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var options_1 = __webpack_require__(43);
var latex_parser_1 = __webpack_require__(31);
var convert_1 = __webpack_require__(98);
function convertLaTeX(options, src) {
    return convertLaTeXBlocks(options, latex_parser_1.mustNotBeUndefined(latex_parser_1.mustBeOk(latex_parser_1.latexParser.parse(src)).value));
}
exports.convertLaTeX = convertLaTeX;
function convertLaTeXToUnicode(src) {
    return convertLaTeXBlocks({
        translateTo: "unicode",
        mode: "Any",
    }, latex_parser_1.mustNotBeUndefined(latex_parser_1.mustBeOk(latex_parser_1.latexParser.parse(src)).value));
}
exports.convertLaTeXToUnicode = convertLaTeXToUnicode;
function convertLaTeXBlocks(options, latex) {
    var translateTo = options.translateTo;
    switch (translateTo) {
        case "html":
            throw new Error("Unsupported format: '"
                + translateTo
                + "'. Use one of: "
                + Object.keys(options_1.supportedMarkups));
        case "unicode":
        default:
            return convert_1.convertLaTeXBlocksToUnicode(options, latex).result;
    }
}
exports.convertLaTeXBlocks = convertLaTeXBlocks;
//# sourceMappingURL=convert.js.map

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var parsimmon_1 = __webpack_require__(45);
var Syntax_1 = __webpack_require__(33);
var Syntax_2 = __webpack_require__(33);
var Utils_1 = __webpack_require__(32);
var parsimmon_2 = __webpack_require__(45);
exports.defaultParserConf = {
    verbatimEnvironments: ["verbatim"]
};
exports.takeTill = function (predicate) { return parsimmon_1.takeWhile(function (c) { return !predicate(c); }); };
var takeTillNewline = parsimmon_1.regexp(/[^\n]*/);
var maybeNewline = parsimmon_1.regexp(/\n?/);
var whitespace = parsimmon_1.regexp(/\s*/m);
var commentSymbol = parsimmon_1.string("%");
function unsafeUnion(xs, ys) {
    var xn = xs.length;
    var yn = ys.length;
    if (xn === 0) {
        return ys;
    }
    else if (yn === 0) {
        return xs;
    }
    var obj = {};
    for (var i = 0; i < xn; i++) {
        obj[xs[i]] = true;
    }
    for (var j = 0; j < yn; j++) {
        obj[ys[j]] = true;
    }
    var keys = [];
    for (var k in obj) {
        if (obj.hasOwnProperty(k)) {
            keys.push(k);
        }
    }
    keys.sort();
    return keys;
}
function mergeReplies(result, last) {
    if (!last) {
        return result;
    }
    if (result.furthest > last.furthest) {
        return result;
    }
    var expected = (result.furthest === last.furthest)
        ? unsafeUnion(result.expected, last.expected)
        : last.expected;
    return {
        status: result.status,
        index: result.index,
        value: result.value,
        furthest: last.furthest,
        expected: expected
    };
}
function manyTillAndMap(manyOf, till, map, initial) {
    return parsimmon_1.Parser(function (input, i) {
        var accum = initial;
        var j = 0;
        var result = undefined;
        while (i < input.length) {
            var endCodonFound = till._(input, i);
            if (endCodonFound.status) {
                i = Utils_1.mustBeNumber(endCodonFound.index);
                break;
            }
            var bigParse = manyOf._(input, i);
            if (isNotOk(bigParse))
                return bigParse;
            result = Utils_1.mustNotBeUndefined(mergeReplies(bigParse, result));
            if (isNotOk(result)) {
                return result;
            }
            j++;
            var value = Utils_1.mustNotBeUndefined(result.value);
            accum = map(accum, value);
            i = Utils_1.mustBeNumber(result.index);
        }
        var result2 = parsimmon_1.makeSuccess(i, accum);
        return mustBeOk(mergeReplies(result2, result));
    });
}
function manyTill(manyOf, till) {
    return manyTillAndMap(manyOf, till, function (a, el) { return a.concat([el]); }, []);
}
function token(parser) {
    return parser.skip(whitespace);
}
function word(str) {
    return parsimmon_1.string(str).thru(token);
}
var lbrace = "{";
var rbrace = "}";
var lbracket = "[";
var rbracket = "]";
var comma = ",";
var colon = ":";
var openingBracket = parsimmon_1.string(lbracket);
var closingBracket = parsimmon_1.string(rbracket);
var isClosingbracket = function (str) { return str === (rbracket); };
exports.notTextDefault = {
    "$": true,
    "%": true,
    "\\": true,
    "{": true,
    "]": true,
    "}": true
};
exports.notTextMathMode = {
    "^": true,
    "_": true,
    "$": true,
    "%": true,
    "\\": true,
    "{": true,
    "]": true,
    "}": true
};
exports.notTextMathModeAndNotClosingBracket = {
    "^": true,
    "_": true,
    "$": true,
    "%": true,
    "\\": true,
    "{": true,
    "}": true
};
exports.notTextDefaultAndNotClosingBracket = {
    "$": true,
    "%": true,
    "\\": true,
    "{": true,
    "}": true
};
function takeAtLeastOneTill(till) {
    return parsimmon_1.Parser(function (str, i) {
        var firstChar = str.charAt(i);
        if (i >= str.length || till(firstChar)) {
            return parsimmon_2.makeFailure(i, "text character");
        }
        else {
            var strz = [firstChar];
            i++;
            var char = str.charAt(i);
            while (!till(char) && i < str.length) {
                strz.push(char);
                i++;
                char = str.charAt(i);
            }
            return parsimmon_1.makeSuccess(i, strz.join(""));
        }
    });
}
function textParser(notText) {
    return takeAtLeastOneTill(isNotText(notText))
        .map(function (match) { return Syntax_2.newTeXRaw(match); });
}
exports.textParser = textParser;
var text = textParser(exports.notTextDefault);
var text2 = textParser(exports.notTextDefaultAndNotClosingBracket);
var spaces = parsimmon_1.regexp(/ */)
    .map(Syntax_2.newTeXRaw);
exports.comment = commentSymbol
    .then(takeTillNewline)
    .skip(maybeNewline)
    .map(Syntax_1.newTeXComment);
exports.specialCharsDefault = {
    "'": true,
    "(": true,
    ")": true,
    ",": true,
    ".": true,
    "-": true,
    '"': true,
    "!": true,
    "^": true,
    "$": true,
    "&": true,
    "#": true,
    "{": true,
    "}": true,
    "%": true,
    "~": true,
    "|": true,
    "/": true,
    ":": true,
    ";": true,
    "=": true,
    "[": true,
    "]": true,
    "\\": true,
    "`": true,
    " ": true
};
function isSpecialCharacter(char, specialChars) {
    var chars = specialChars === undefined ? exports.specialCharsDefault : specialChars;
    return chars.hasOwnProperty(char);
}
exports.isSpecialCharacter = isSpecialCharacter;
function isNotText(notText) {
    return function (char) { return notText.hasOwnProperty(char); };
}
exports.isNotText = isNotText;
exports.mathSymbol = parsimmon_1.string("$");
exports.commandSymbol = parsimmon_1.string("\\");
function latexBlockParser(mode, sub, sup) {
    if (sub === void 0) { sub = "_"; }
    if (sup === void 0) { sup = "^"; }
    switch (mode) {
        case "Math":
            return exports.latexBlockParserMathMode(sub, sup);
        default:
            return exports.latexBlockParserTextMode;
    }
}
exports.latexBlockParser = latexBlockParser;
exports.latexBlockParserTextMode = parsimmon_1.lazy(function () { return parsimmon_1.alt(parsimmon_1.alt(textParser(exports.notTextDefault), exports.dolMath, exports.comment, textParser(exports.notTextDefaultAndNotClosingBracket), exports.environment, command("Paragraph"))); });
exports.latexBlockParserMathMode = function (sub, sup) {
    return parsimmon_1.lazy(function () { return parsimmon_1.alt(parsimmon_1.alt(shiftedScript("Math", sub, sup), textParser(exports.notTextMathMode), exports.dolMath, exports.comment, textParser(exports.notTextMathModeAndNotClosingBracket), exports.environment, command("Math"))); });
};
exports.latexParser = exports.latexBlockParserTextMode.many();
var anonym = parsimmon_1.string(lbrace)
    .then(exports.latexBlockParserTextMode.many())
    .skip(parsimmon_1.string(rbrace));
exports.env = parsimmon_1.Parser(function (input, i) {
    var beginFound = parsimmon_1.string("\\begin")
        .then(parsimmon_1.string(lbrace))
        .then(spaces)
        .then(parsimmon_1.regexp(/[a-zA-Z]+/))
        .skip(spaces)
        .skip(parsimmon_1.string(rbrace))
        ._(input, i);
    if (isNotOk(beginFound))
        return beginFound;
    i = Utils_1.mustBeNumber(beginFound.index);
    var envName = beginFound.value;
    return manyTill(exports.latexBlockParserTextMode, parsimmon_1.string("\\end")
        .then(parsimmon_1.string(lbrace))
        .then(spaces)
        .then(parsimmon_1.string(envName))
        .then(spaces)
        .then(parsimmon_1.string(rbrace))).map(function (latex) { return Syntax_1.newTeXEnv(envName, latex); })._(input, i);
});
exports.environment = parsimmon_1.alt(anonym, exports.env);
exports.specialChar = parsimmon_1.test(isSpecialCharacter);
function isUppercaseAlph(c) {
    return c >= "A" && c <= "Z";
}
function isLowercaseAlph(c) {
    return c >= "a" && c <= "z";
}
exports.endCmd = function (c) { return !isLowercaseAlph(c) && !isUppercaseAlph(c); };
var openingBrace = parsimmon_1.string("{");
var closingBrace = parsimmon_1.string("}");
var isClosingBrace = function (str) { return str === ("}"); };
function fixArg(mode) {
    return openingBrace
        .then(manyTill(latexBlockParser(mode, "_"), closingBrace)).map(Syntax_1.newFixArg);
}
exports.fixArg = fixArg;
function optArg(mode) {
    return openingBracket
        .then(manyTill(latexBlockParser(mode), closingBracket))
        .map(Syntax_1.newOptArg);
}
exports.optArg = optArg;
function cmdArg(mode) {
    return parsimmon_1.alt(fixArg(mode), optArg(mode));
}
exports.cmdArg = cmdArg;
function cmdArgs(mode) {
    return parsimmon_1.alt(parsimmon_1.string("{}").map(function () { return []; }), cmdArg(mode).map(function (s) { return s; }).atLeast(0)).map(function (e) { return e; });
}
exports.cmdArgs = cmdArgs;
function command(mode) {
    return parsimmon_1.seqMap(exports.commandSymbol, parsimmon_1.alt(exports.specialChar, exports.takeTill(exports.endCmd)), cmdArgs(mode), function (ignored, name, argz) {
        return argz !== undefined ? Syntax_1.newTeXComm.apply(void 0, [name].concat(argz)) : Syntax_1.newTeXComm(name);
    }).map(function (res) {
        return res;
    });
}
exports.command = command;
exports.subOrSuperscriptSymbolParser = function (subscriptSymbol, superscriptSymbol) {
    return parsimmon_1.alt(parsimmon_1.string(subscriptSymbol), parsimmon_1.string(superscriptSymbol)).map(function (parsedStr) { return (parsedStr === subscriptSymbol ? Syntax_1.SubOrSuperSymbol.SUB : Syntax_1.SubOrSuperSymbol.SUP); });
};
function shiftedScript(mode, sub, sup) {
    return parsimmon_1.seqMap(exports.subOrSuperscriptSymbolParser(sub, sup), cmdArgs(mode), function (symbol, argz) {
        return Syntax_1.newSubOrSuperScript(symbol, symbol === Syntax_1.SubOrSuperSymbol.SUB ? sub : sup, argz);
    }).map(function (res) {
        return res;
    });
}
exports.shiftedScript = shiftedScript;
exports.dolMath = math();
function math(mathType, sMath, eMath) {
    if (mathType === void 0) { mathType = "Dollar"; }
    if (sMath === void 0) { sMath = "$"; }
    if (eMath === void 0) { eMath = "$"; }
    return parsimmon_1.string(sMath)
        .then(latexBlockParser("Math", "_")
        .many()
        .map(function (str) { return Syntax_1.newTeXMath(mathType, sMath, eMath, str); }))
        .skip(parsimmon_1.string(eMath));
}
function isOk(parse) {
    return parse !== undefined && parse.status === true;
}
exports.isOk = isOk;
function isNotOk(parse) {
    return parse !== undefined && parse.status === false;
}
exports.isNotOk = isNotOk;
function mustBeOk(parse) {
    if (!isOk(parse))
        throw new Error("Expected parse to be success: " + JSON.stringify(parse));
    return parse;
}
exports.mustBeOk = mustBeOk;
//# sourceMappingURL=Parser.js.map

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var latex_parser_1 = __webpack_require__(31);
var unknown_command_1 = __webpack_require__(46);
var index_1 = __webpack_require__(99);
var KnownCommand_1 = __webpack_require__(47);
var index_2 = __webpack_require__(106);
var index_3 = __webpack_require__(51);
var sqrt_1 = __webpack_require__(134);
var index_4 = __webpack_require__(135);
var index_5 = __webpack_require__(138);
var CategoryCode_1 = __webpack_require__(44);
function isString(x) {
    return typeof x === "string";
}
function convertChars(blockIndex, latex) {
    var start = blockIndex;
    do
        blockIndex++;
    while (latex_parser_1.isTeXChar(latex[blockIndex]));
    var chars = latex.slice(start, blockIndex);
    var result = chars.map(function (s) { return s.string; }).join("");
    return {
        result: result,
        blockIndex: blockIndex
    };
}
var regexStartingWhitespace = /^\s*/;
function convertTeXCommand(options, blockIndex, latex, current) {
    var value = convertCommand(options, current);
    if (isString(value)) {
        return {
            result: value,
            blockIndex: blockIndex + 1
        };
    }
    else {
        var gobbledArguments = [];
        var rest = [];
        while (gobbledArguments.length < value.argumentCount && blockIndex < latex.length - 1) {
            blockIndex++;
            var nextWordToGobble = blockIndex;
            if (latex.length < nextWordToGobble - 1)
                throw new Error("Could not gobble " + value.argumentCount + " arguments for " + current.name);
            var nextLaTeXBlock = latex[nextWordToGobble];
            if (latex_parser_1.isTeXRaw(nextLaTeXBlock)) {
                var whitespaces = /\s+/g;
                var followingText = nextLaTeXBlock.text.replace(regexStartingWhitespace, "");
                var restIndex = -1;
                var lastIndex = 0;
                while (gobbledArguments.length < value.argumentCount) {
                    var argMatch = whitespaces.exec(followingText);
                    if (argMatch) {
                        var match = followingText.substring(lastIndex, argMatch.index);
                        restIndex = argMatch.index;
                        lastIndex = argMatch.index + match.length;
                        gobbledArguments.push.apply(gobbledArguments, CategoryCode_1.convertToTeXCharsDefault(match));
                    }
                    else {
                        gobbledArguments.push.apply(gobbledArguments, CategoryCode_1.convertToTeXCharsDefault(followingText));
                        break;
                    }
                }
                if (restIndex >= 0)
                    rest.push((followingText.substring(restIndex)));
            }
            else
                gobbledArguments.push(nextLaTeXBlock);
        }
        blockIndex++;
        var argumentsToApply = gobbledArguments
            .map(function (lll) { return convertLaTeXBlocksToUnicode(options, [lll]).result; })
            .map(latex_parser_1.newTeXRaw)
            .map(function (latex) { return latex_parser_1.newFixArg([latex]); });
        if (argumentsToApply.length < value.argumentCount)
            throw new Error("Could not find enough arguments for command \\" + value.name + ". Expected " + value.argumentCount + ", but found " + argumentsToApply.length);
        if (!value.apply)
            throw new Error("Can't apply " + JSON.stringify(value));
        var result = [
            value.apply(function () {
            }, argumentsToApply)
        ];
        if (rest.length > 0)
            result.push(rest.join(""));
        return {
            result: result.join(""),
            blockIndex: blockIndex
        };
    }
}
function isTeXChar2(x) {
    return x !== undefined
        && typeof x.string === "string"
        && typeof x.category === "number";
}
exports.isTeXChar2 = isTeXChar2;
function convertLaTeXBlocksToUnicode(options, latex) {
    var blockIndex = 0;
    if (latex.length <= 0)
        return {
            result: "",
            blockIndex: blockIndex
        };
    var finalConversion = [];
    while (blockIndex < latex.length) {
        var l = latex[blockIndex];
        try {
            if (isTeXChar2(l)) {
                var convertedChars = convertChars(blockIndex, latex);
                blockIndex = convertedChars.blockIndex;
                finalConversion.push(convertedChars.result);
            }
            else if (latex_parser_1.isTeXComm(l)) {
                var res = convertTeXCommand(options, blockIndex, latex, l);
                blockIndex = res.blockIndex;
                finalConversion.push(res.result);
            }
            else if (latex_parser_1.isFixArg(l) || latex_parser_1.isOptArg(l)) {
                var res = convertLaTeXBlocksToUnicode(options, l.latex);
                finalConversion.push(res.result);
                blockIndex++;
            }
            else if (latex_parser_1.isTextHaving(l)) {
                finalConversion.push(l.text);
                blockIndex++;
            }
            else if (latex_parser_1.isTeXMath(l)) {
                return convertLaTeXBlocksToUnicode(options, l.latex);
            }
            else if (latex_parser_1.isTeXRaw(l)) {
                finalConversion.push(l.text);
                blockIndex++;
            }
            else if (latex_parser_1.isSubOrSuperScript(l)) {
                var args = l.arguments ? l.arguments : [];
                var res = convertTeXCommand(options, blockIndex, latex, latex_parser_1.newTeXComm.apply(void 0, [l.type === latex_parser_1.SubOrSuperSymbol.SUB ? "mathsubscript" : "mathsuperscript"].concat(args)));
                blockIndex = res.blockIndex;
                finalConversion.push(res.result);
            }
            else if (latex_parser_1.isArray(l)) {
                var res = convertLaTeXBlocksToUnicode(options, l);
                finalConversion.push(res.result);
                blockIndex++;
            }
            else {
                throw new Error("Can't handle LaTeX block yet: " + (JSON.stringify(l)) + ". Leave an issue at https://github.com/digitalheir/tex-to-unicode/issues");
            }
        }
        catch (e) {
            if (options.onError !== undefined) {
                var saved = options.onError(e, l);
                if (saved !== undefined) {
                    finalConversion.push(saved);
                    blockIndex++;
                }
                else
                    throw e;
            }
            else
                throw e;
        }
    }
    return {
        result: finalConversion.join(""),
        blockIndex: blockIndex
    };
}
exports.convertLaTeXBlocksToUnicode = convertLaTeXBlocksToUnicode;
function convert1ArgCommand(options, cmd) {
    if (cmd.arguments.length > 0) {
        var expanded = index_2.expand1argsCommand(cmd.name, convertLaTeXBlocksToUnicode(options, [cmd.arguments[0]]).result || "");
        if (cmd.arguments.length > 1)
            return expanded + convertLaTeXBlocksToUnicode(options, cmd.arguments.slice(1)).result;
        else
            return expanded;
    }
    else
        return KnownCommand_1.createCommandHandler(cmd.name, 0, 1, function (cb, texArgs) {
            var firstArg = texArgs[0];
            var rest = texArgs.slice(1);
            var a = index_2.expand1argsCommand(cmd.name, convertLaTeXBlocksToUnicode(options, [firstArg]).result);
            var b = convertLaTeXBlocksToUnicode(options, rest).result;
            return a + b;
        });
}
function convert2ArgCommand(options, cmd) {
    if (cmd.arguments.length > 1) {
        var expanded = index_4.expand2argsCommand(cmd.name, convertLaTeXBlocksToUnicode(options, [cmd.arguments[0]]).result || "", convertLaTeXBlocksToUnicode(options, [cmd.arguments[1]]).result || "");
        if (cmd.arguments.length > 2)
            return expanded + convertLaTeXBlocksToUnicode(options, cmd.arguments.slice(1)).result;
        else
            return expanded;
    }
    else
        return KnownCommand_1.createCommandHandler(cmd.name, 0, 2, function (cb, texArgs) {
            var firstArg = texArgs[0];
            var secondArg = texArgs[1];
            var rest = texArgs.slice(2);
            var a = index_4.expand2argsCommand(cmd.name, convertLaTeXBlocksToUnicode(options, [firstArg]).result, convertLaTeXBlocksToUnicode(options, [secondArg]).result);
            var b = convertLaTeXBlocksToUnicode(options, rest).result;
            return a + b;
        });
}
function convertSqrt(options, cmd) {
    var base = undefined;
    var nucleus = undefined;
    var argIndex = 0;
    while (nucleus === undefined && argIndex < cmd.arguments.length) {
        var arg = cmd.arguments[argIndex];
        var argAsString = convertLaTeXBlocksToUnicode(options, [arg]).result;
        if (latex_parser_1.isOptArg(arg) && !base) {
            base = argAsString;
        }
        else {
            nucleus = argAsString;
        }
        argIndex++;
    }
    if (nucleus)
        return sqrt_1.convertSqrtToUnicode(nucleus, base);
    else
        return KnownCommand_1.createCommandHandler(cmd.name, 1, 1, function (cb, texArgs) {
            var firstArg = texArgs[0];
            var a = sqrt_1.convertSqrtToUnicode(convertLaTeXBlocksToUnicode(options, [firstArg]).result);
            if (texArgs.length > 1) {
                var rest = texArgs.slice(1);
                var b = convertLaTeXBlocksToUnicode(options, rest).result;
                return a + b;
            }
            return a;
        });
}
function convertCommand(options, cmd) {
    var commandName = cmd.name;
    var expanded0args = index_1.expand0argsCommand(commandName);
    if (!!expanded0args)
        if (cmd.arguments && cmd.arguments.length > 0)
            return expanded0args + convertLaTeXBlocksToUnicode(options, cmd.arguments).result;
        else
            return expanded0args;
    else if (index_3.is1argsCommand(commandName)) {
        return convert1ArgCommand(options, cmd);
    }
    else if (index_5.is2argsCommand(commandName)) {
        return convert2ArgCommand(options, cmd);
    }
    else if (commandName === "sqrt") {
        return convertSqrt(options, cmd);
    }
    else {
        throw unknown_command_1.unknownCommandError(commandName);
    }
}
exports.convertCommand = convertCommand;
//# sourceMappingURL=convert.js.map

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var space_1 = __webpack_require__(100);
var symbols_1 = __webpack_require__(101);
var barred_letter_1 = __webpack_require__(102);
var slashed_1 = __webpack_require__(103);
var cyrillic_1 = __webpack_require__(104);
var specialchars_1 = __webpack_require__(105);
exports.expand0argsCommand = function (name) {
    for (var _i = 0, _a = [
        barred_letter_1.barredLUnicode,
        space_1.spaceUnicode,
        slashed_1.slashedOUnicode,
        symbols_1.characterUnicode,
        specialchars_1.specialCharacter,
        cyrillic_1.cyrillicUnicode
    ]; _i < _a.length; _i++) {
        var fn = _a[_i];
        var result = fn(name);
        if (!!result)
            return result;
    }
};
//# sourceMappingURL=index.js.map

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.mathSpace = "\u8287";
exports.spaceCharactersUnicode = {
    ",": "\u2009",
    "quad": "\u2003",
    "qquad": "\u2003\u2003",
    " ": " ",
    "space": " ",
    ";": "　",
    ":": "　",
    "hfill": "\t"
};
function isSpaceCharactersUnicode(x) {
    return exports.spaceCharactersUnicode.hasOwnProperty(x);
}
exports.isSpaceCharactersUnicode = isSpaceCharactersUnicode;
exports.spaceUnicode = function (name) { return isSpaceCharactersUnicode(name) ? exports.spaceCharactersUnicode[name] : undefined; };
//# sourceMappingURL=space.js.map

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.characterUnicodeChart = {
    "leftrightsquigarrow": "↭",
    "Longleftrightarrow": "⟺",
    "blacktriangleright": "▶",
    "longleftrightarrow": "⟷",
    "blacktriangledown": "▼",
    "blacktriangleleft": "◀",
    "leftrightharpoons": "⇋",
    "rightleftharpoons": "⇌",
    "twoheadrightarrow": "↠",
    "circlearrowright": "↻",
    "downharpoonright": "⇂",
    "rightharpoondown": "⇁",
    "rightrightarrows": "⇉",
    "twoheadleftarrow": "↞",
    "vartriangleright": "⊳",
    "bigtriangledown": "▽",
    "circlearrowleft": "↺",
    "curvearrowright": "↷",
    "downharpoonleft": "⇃",
    "leftharpoondown": "↽",
    "leftrightarrows": "⇆",
    "rightleftarrows": "⇄",
    "rightsquigarrow": "⇝",
    "rightthreetimes": "⋌",
    "trianglerighteq": "⊵",
    "vartriangleleft": "⊲",
    "Leftrightarrow": "⇔",
    "Longrightarrow": "⟹",
    "curvearrowleft": "↶",
    "dashrightarrow": "⇢",
    "doublebarwedge": "⩞",
    "downdownarrows": "⇊",
    "hookrightarrow": "↪",
    "leftleftarrows": "⇇",
    "leftrightarrow": "↔",
    "leftthreetimes": "⋋",
    "longrightarrow": "⟶",
    "looparrowright": "↬",
    "rightarrowtail": "↣",
    "rightharpoonup": "⇀",
    "sphericalangle": "∢",
    "textregistered": "®",
    "trianglelefteq": "⊴",
    "upharpoonright": "↾",
    "Longleftarrow": "⟸",
    "bigtriangleup": "△",
    "blacktriangle": "▲",
    "dashleftarrow": "⇠",
    "divideontimes": "⋇",
    "fallingdotseq": "≒",
    "hookleftarrow": "↩",
    "leftarrowtail": "↢",
    "leftharpoonup": "↼",
    "longleftarrow": "⟵",
    "looparrowleft": "↫",
    "measuredangle": "∡",
    "shortparallel": "∥",
    "smallsetminus": "∖",
    "texttrademark": "™",
    "triangleright": "▷",
    "upharpoonleft": "↿",
    "blacklozenge": "◆",
    "risingdotseq": "≓",
    "triangledown": "▽",
    "triangleleft": "◁",
    "Rrightarrow": "⇛",
    "Updownarrow": "⇕",
    "backepsilon": "∍",
    "blacksquare": "■",
    "circledcirc": "⊚",
    "circleddash": "⊝",
    "curlyeqprec": "⋞",
    "curlyeqsucc": "⋟",
    "diamondsuit": "♢",
    "preccurlyeq": "≼",
    "succcurlyeq": "≽",
    "textgreater": ">",
    "thickapprox": "≈",
    "updownarrow": "↕",
    "vartriangle": "△",
    "Lleftarrow": "⇚",
    "Rightarrow": "⇒",
    "circledast": "⊛",
    "complement": "∁",
    "curlywedge": "⋏",
    "longmapsto": "⟼",
    "registered": "®",
    "rightarrow": "→",
    "smallfrown": "⌢",
    "smallsmile": "⌣",
    "sqsubseteq": "⊑",
    "sqsupseteq": "⊒",
    "textlangle": "〈",
    "textrangle": "〉",
    "upuparrows": "⇈",
    "varepsilon": "ε",
    "varnothing": "∅",
    "Downarrow": "⇓",
    "Leftarrow": "⇐",
    "backprime": "‵",
    "bigotimes": "⨂",
    "centerdot": "⋅",
    "copyright": "©",
    "downarrow": "↓",
    "gtreqless": "⋛",
    "heartsuit": "♡",
    "leftarrow": "←",
    "lesseqgtr": "⋚",
    "pitchfork": "⋔",
    "spadesuit": "♠",
    "therefore": "∴",
    "trademark": "™",
    "triangleq": "≜",
    "varpropto": "∝",
    "approxeq": "≊",
    "barwedge": "⊼",
    "bigoplus": "⨁",
    "bigsqcup": "⨆",
    "biguplus": "⨄",
    "bigwedge": "⋀",
    "boxminus": "⊟",
    "boxtimes": "⊠",
    "circledS": "Ⓢ",
    "clubsuit": "♣",
    "curlyvee": "⋎",
    "doteqdot": "≑",
    "emptyset": "∅",
    "intercal": "⊺",
    "leqslant": "⩽",
    "multimap": "⊸",
    "parallel": "∥",
    "setminus": "∖",
    "sqsubset": "⊏",
    "sqsupset": "⊐",
    "subseteq": "⊆",
    "supseteq": "⊇",
    "textless": "<",
    "thicksim": "∼",
    "triangle": "△",
    "varkappa": "ϰ",
    "varsigma": "ς",
    "vartheta": "ϑ",
    "Diamond": "◇",
    "Uparrow": "⇑",
    "Upsilon": "Υ",
    "backsim": "∽",
    "because": "∵",
    "between": "≬",
    "bigodot": "⨀",
    "bigstar": "★",
    "boxplus": "⊞",
    "ddagger": "‡",
    "diamond": "⋄",
    "digamma": "Ϝ",
    "dotplus": "∔",
    "epsilon": "∊",
    "gtrless": "≷",
    "implies": "⇒",
    "leadsto": "↝",
    "lessdot": "⋖",
    "lessgtr": "≶",
    "lesssim": "≲",
    "lozenge": "◊",
    "natural": "♮",
    "nearrow": "↗",
    "nexists": "∄",
    "nwarrow": "↖",
    "partial": "∂",
    "pilcrow": "¶",
    "precsim": "≾",
    "searrow": "↘",
    "section": "§",
    "succsim": "≿",
    "swarrow": "↙",
    "textbar": "|",
    "uparrow": "↑",
    "upsilon": "υ",
    "Bumpeq": "≎",
    "Lambda": "Λ",
    "Subset": "⋐",
    "Supset": "⋑",
    "Vvdash": "⊪",
    "approx": "≈",
    "bigcap": "⋂",
    "bigcup": "⋃",
    "bigvee": "⋁",
    "bowtie": "⋈",
    "boxdot": "⊡",
    "bullet": "∙",
    "bumpeq": "≏",
    "circeq": "≗",
    "coprod": "∐",
    "dagger": "†",
    "daleth": "ד",
    "degree": "°",
    "eqcirc": "≖",
    "exists": "∃",
    "forall": "∀",
    "gtrdot": "⋗",
    "gtrsim": "≳",
    "hslash": "ℏ",
    "lambda": "λ",
    "lfloor": "⌊",
    "ltimes": "⋉",
    "mapsto": "↦",
    "models": "⊨",
    "ominus": "⊖",
    "oslash": "⊘",
    "otimes": "⊗",
    "preceq": "⪯",
    "propto": "∝",
    "rfloor": "⌋",
    "rtimes": "⋊",
    "square": "□",
    "subset": "⊂",
    "succeq": "⪰",
    "supset": "⊃",
    "varphi": "φ",
    "varrho": "ϱ",
    "veebar": "⊻",
    "Delta": "Δ",
    "Gamma": "Γ",
    "Omega": "Ω",
    "Theta": "Θ",
    "Vdash": "⊩",
    "aleph": "ℵ",
    "Alpha": "Α",
    "alpha": "α",
    "angle": "∠",
    "asymp": "≍",
    "cdots": "⋯",
    "cents": "¢",
    "dashv": "⊣",
    "ddots": "⋱",
    "delta": "δ",
    "doteq": "≐",
    "equiv": "≡",
    "frown": "⌢",
    "gamma": "γ",
    "gimel": "ℷ",
    "infty": "∞",
    "kappa": "κ",
    "Kappa": "Κ",
    "lceil": "⌈",
    "nabla": "∇",
    "notin": "∉",
    "omega": "ω",
    "oplus": "⊕",
    "pound": "£",
    "prime": "′",
    "qquad": "  ",
    "rceil": "⌉",
    "sharp": "♯",
    "sigma": "σ",
    "simeq": "≃",
    "smile": "⌣",
    "space": "␣",
    "sqcap": "⊓",
    "sqcup": "⊔",
    "theta": "θ",
    "times": "×",
    "unlhd": "⊴",
    "unrhd": "⊵",
    "uplus": "⊎",
    "vDash": "⊨",
    "varpi": "ϖ",
    "vdash": "⊢",
    "vdots": "⋮",
    "wedge": "∧",
    "Finv": "Ⅎ",
    "Join": "⋈",
    "atop": "¦",
    "beta": "β",
    "Beta": "Β",
    "beth": "ב",
    "cdot": "⋅",
    "circ": "∘",
    "cong": "≅",
    "dots": "…",
    "euro": "€",
    "flat": "♭",
    "geqq": "≧",
    "hbar": "ℏ",
    "iota": "ι",
    "leqq": "≦",
    "odot": "⊙",
    "oint": "∮",
    "perp": "⊥",
    "prec": "≺",
    "prod": "∏",
    "quad": " ",
    "star": "⋆",
    "succ": "≻",
    "surd": "√",
    "zeta": "ζ",
    "Box": "□",
    "Cap": "⋒",
    "Cup": "⋓",
    "Lsh": "↰",
    "Phi": "Φ",
    "Psi": "Ψ",
    "Rsh": "↱",
    "ast": "∗",
    "bot": "⊥",
    "cap": "∩",
    "chi": "χ",
    "Chi": "Χ",
    "cup": "∪",
    "div": "÷",
    "ell": "ℓ",
    "eta": "η",
    "eth": "ð",
    "geq": "≥",
    "ggg": "⋙",
    "int": "∫",
    "leq": "≤",
    "lhd": "⊲",
    "lll": "⋘",
    "mho": "℧",
    "mid": "∣",
    "neg": "¬",
    "neq": "≠",
    "phi": "ϕ",
    "psi": "ψ",
    "rhd": "⊳",
    "rho": "ρ",
    "Rho": "Ρ",
    "sim": "∼",
    "sum": "∑",
    "tau": "τ",
    "Tau": "Τ",
    "top": "⊤",
    "vee": "∨",
    "Im": "ℑ",
    "Pi": "Π",
    "Re": "ℜ",
    "Xi": "Ξ",
    "ge": "≥",
    "gg": "≫",
    "in": "∈",
    "le": "≤",
    "ll": "≪",
    "mp": "∓",
    "mu": "μ",
    "Mu": "Μ",
    "ni": "∋",
    "nu": "ν",
    "Nu": "Ν",
    "pi": "π",
    "pm": "±",
    "wp": "℘",
    "wr": "≀",
    "xi": "ξ",
    "Omicron": "Ο",
    "omicron": "ο",
    "textdollar": "$",
    "textquotesingle": "'",
    "textbackslash": "\\",
    "textasciigrave": "`",
    "lbrace": "{",
    "vert": "|",
    "rbrace": "}",
    "textasciitilde": "~",
    "textexclamdown": "¡",
    "textcent": "¢",
    "textsterling": "£",
    "textcurrency": "¤",
    "textyen": "¥",
    "textbrokenbar": "¦",
    "textsection": "§",
    "textasciidieresis": "¨",
    "textcopyright": "©",
    "textordfeminine": "ª",
    "guillemotleft": "«",
    "lnot": "¬",
    "textasciimacron": "¯",
    "textdegree": "°",
    "textasciiacute": "´",
    "textparagraph": "¶",
    "textordmasculine": "º",
    "guillemotright": "»",
    "textonequarter": "¼",
    "textonehalf": "½",
    "textthreequarters": "¾",
    "textquestiondown": "¿",
    "AA": "Å",
    "AE": "Æ",
    "DH": "Ð",
    "texttimes": "×",
    "TH": "Þ",
    "ss": "ß",
    "aa": "å",
    "ae": "æ",
    "dh": "ð",
    "th": "þ",
    "DJ": "Đ",
    "dj": "đ",
    "Elzxh": "ħ",
    "i": "ı",
    "NG": "Ŋ",
    "ng": "ŋ",
    "OE": "Œ",
    "oe": "œ",
    "texthvlig": "ƕ",
    "textnrleg": "ƞ",
    "textdoublepipe": "ǂ",
    "Elztrna": "ɐ",
    "Elztrnsa": "ɒ",
    "Elzopeno": "ɔ",
    "Elzrtld": "ɖ",
    "Elzschwa": "ə",
    "Elzpgamma": "ɣ",
    "Elzpbgam": "ɤ",
    "Elztrnh": "ɥ",
    "Elzbtdl": "ɬ",
    "Elzrtll": "ɭ",
    "Elztrnm": "ɯ",
    "Elztrnmlr": "ɰ",
    "Elzltlmr": "ɱ",
    "Elzltln": "ɲ",
    "Elzrtln": "ɳ",
    "Elzclomeg": "ɷ",
    "textphi": "ɸ",
    "Elztrnr": "ɹ",
    "Elztrnrl": "ɺ",
    "Elzrttrnr": "ɻ",
    "Elzrl": "ɼ",
    "Elzrtlr": "ɽ",
    "Elzfhr": "ɾ",
    "Elzrtls": "ʂ",
    "Elzesh": "ʃ",
    "Elztrnt": "ʇ",
    "Elzrtlt": "ʈ",
    "Elzpupsil": "ʊ",
    "Elzpscrv": "ʋ",
    "Elzinvv": "ʌ",
    "Elzinvw": "ʍ",
    "Elztrny": "ʎ",
    "Elzrtlz": "ʐ",
    "Elzyogh": "ʒ",
    "Elzglst": "ʔ",
    "Elzreglst": "ʕ",
    "Elzinglst": "ʖ",
    "textturnk": "ʞ",
    "Elzdyogh": "ʤ",
    "Elztesh": "ʧ",
    "textasciicaron": "ˇ",
    "Elzverts": "ˈ",
    "Elzverti": "ˌ",
    "Elzlmrk": "ː",
    "Elzhlmrk": "ˑ",
    "Elzsbrhr": "˒",
    "Elzsblhr": "˓",
    "Elzrais": "˔",
    "Elzlow": "˕",
    "textasciibreve": "˘",
    "textperiodcentered": "˙",
    "texttildelow": "˜",
    "Epsilon": "Ε",
    "Zeta": "Ζ",
    "Eta": "Η",
    "Iota": "Ι",
    "Sigma": "Σ",
    "texttheta": "θ",
    "textvartheta": "ϑ",
    "Stigma": "Ϛ",
    "Digamma": "Ϝ",
    "Koppa": "Ϟ",
    "Sampi": "Ϡ",
    "textTheta": "ϴ",
    "textendash": "–",
    "textemdash": "—",
    "Vert": "‖",
    "Elzreapos": "‛",
    "textquotedblleft": "“",
    "textquotedblright": "”",
    "textdagger": "†",
    "textdaggerdbl": "‡",
    "textbullet": "•",
    "ldots": "…",
    "textperthousand": "‰",
    "textpertenthousand": "‱",
    "guilsinglleft": "‹",
    "guilsinglright": "›",
    "nolinebreak": "⁠",
    "Elzxrat": "℞",
    "nleftarrow": "↚",
    "nrightarrow": "↛",
    "arrowwaveleft": "↜",
    "arrowwaveright": "↝",
    "nleftrightarrow": "↮",
    "dblarrowupdown": "⇅",
    "nLeftarrow": "⇍",
    "nLeftrightarrow": "⇎",
    "nRightarrow": "⇏",
    "DownArrowUpArrow": "⇵",
    "rightangle": "∟",
    "nmid": "∤",
    "nparallel": "∦",
    "surfintegral": "∯",
    "volintegral": "∰",
    "clwintegral": "∱",
    "Colon": "∷",
    "homothetic": "∻",
    "lazysinv": "∾",
    "NotEqualTilde": "≂",
    "approxnotequal": "≆",
    "tildetrpl": "≋",
    "allequal": "≌",
    "NotHumpDownHump": "≎",
    "NotHumpEqual": "≏",
    "estimates": "≙",
    "starequal": "≛",
    "lneqq": "≨",
    "lvertneqq": "≨",
    "gneqq": "≩",
    "gvertneqq": "≩",
    "NotLessLess": "≪",
    "NotGreaterGreater": "≫",
    "lessequivlnt": "≲",
    "greaterequivlnt": "≳",
    "notlessgreater": "≸",
    "notgreaterless": "≹",
    "precapprox": "≾",
    "NotPrecedesTilde": "≾",
    "succapprox": "≿",
    "NotSucceedsTilde": "≿",
    "subsetneq": "⊊",
    "varsubsetneqq": "⊊",
    "supsetneq": "⊋",
    "varsupsetneq": "⊋",
    "NotSquareSubset": "⊏",
    "NotSquareSuperset": "⊐",
    "truestate": "⊧",
    "forcesextra": "⊨",
    "VDash": "⊫",
    "nvdash": "⊬",
    "nvDash": "⊭",
    "nVdash": "⊮",
    "nVDash": "⊯",
    "original": "⊶",
    "image": "⊷",
    "hermitconjmatrix": "⊹",
    "rightanglearc": "⊾",
    "backsimeq": "⋍",
    "verymuchless": "⋘",
    "verymuchgreater": "⋙",
    "Elzsqspne": "⋥",
    "lnsim": "⋦",
    "gnsim": "⋧",
    "precedesnotsimilar": "⋨",
    "succnsim": "⋩",
    "ntriangleleft": "⋪",
    "ntriangleright": "⋫",
    "ntrianglelefteq": "⋬",
    "ntrianglerighteq": "⋭",
    "upslopeellipsis": "⋰",
    "downslopeellipsis": "⋱",
    "perspcorrespond": "⌆",
    "recorder": "⌕",
    "ulcorner": "⌜",
    "urcorner": "⌝",
    "llcorner": "⌞",
    "lrcorner": "⌟",
    "langle": "〈",
    "rangle": "〉",
    "Elzdlcorn": "⎣",
    "lmoustache": "⎰",
    "rmoustache": "⎱",
    "textvisiblespace": "␣",
    "Elzdshfnc": "┆",
    "Elzsqfnw": "┙",
    "diagup": "╱",
    "Elzvrecto": "▯",
    "Elzcirfl": "◐",
    "Elzcirfr": "◑",
    "Elzcirfb": "◒",
    "Elzrvbull": "◘",
    "Elzsqfl": "◧",
    "Elzsqfr": "◨",
    "Elzsqfse": "◪",
    "bigcirc": "◯",
    "rightmoon": "☾",
    "mercury": "☿",
    "venus": "♀",
    "male": "♂",
    "jupiter": "♃",
    "saturn": "♄",
    "uranus": "♅",
    "neptune": "♆",
    "pluto": "♇",
    "aries": "♈",
    "taurus": "♉",
    "gemini": "♊",
    "cancer": "♋",
    "leo": "♌",
    "virgo": "♍",
    "libra": "♎",
    "scorpio": "♏",
    "sagittarius": "♐",
    "capricornus": "♑",
    "aquarius": "♒",
    "pisces": "♓",
    "quarternote": "♩",
    "eighthnote": "♪",
    "UpArrowBar": "⤒",
    "DownArrowBar": "⤓",
    "Elolarr": "⥀",
    "Elorarr": "⥁",
    "ElzRlarr": "⥂",
    "ElzrLarr": "⥄",
    "Elzrarrx": "⥇",
    "LeftRightVector": "⥎",
    "RightUpDownVector": "⥏",
    "DownLeftRightVector": "⥐",
    "LeftUpDownVector": "⥑",
    "LeftVectorBar": "⥒",
    "RightVectorBar": "⥓",
    "RightUpVectorBar": "⥔",
    "RightDownVectorBar": "⥕",
    "DownLeftVectorBar": "⥖",
    "DownRightVectorBar": "⥗",
    "LeftUpVectorBar": "⥘",
    "LeftDownVectorBar": "⥙",
    "LeftTeeVector": "⥚",
    "RightTeeVector": "⥛",
    "RightUpTeeVector": "⥜",
    "RightDownTeeVector": "⥝",
    "DownLeftTeeVector": "⥞",
    "DownRightTeeVector": "⥟",
    "LeftUpTeeVector": "⥠",
    "LeftDownTeeVector": "⥡",
    "UpEquilibrium": "⥮",
    "ReverseUpEquilibrium": "⥯",
    "RoundImplies": "⥰",
    "Elztfnc": "⦀",
    "Elroang": "⦆",
    "Elzddfnc": "⦙",
    "Angle": "⦜",
    "Elzlpargt": "⦠",
    "ElzLap": "⧊",
    "Elzdefas": "⧋",
    "LeftTriangleBar": "⧏",
    "NotLeftTriangleBar": "⧏",
    "RightTriangleBar": "⧐",
    "NotRightTriangleBar": "⧐",
    "RuleDelayed": "⧴",
    "Elxuplus": "⨄",
    "ElzThr": "⨅",
    "Elxsqcup": "⨆",
    "ElzInf": "⨇",
    "ElzSup": "⨈",
    "ElzCint": "⨍",
    "clockoint": "⨏",
    "sqrint": "⨖",
    "ElzTimes": "⨯",
    "amalg": "⨿",
    "ElzAnd": "⩓",
    "ElzOr": "⩔",
    "ElOr": "⩖",
    "Elzminhat": "⩟",
    "Equal": "⩵",
    "nleqslant": "⩽",
    "geqslant": "⩾",
    "ngeqslant": "⩾",
    "lessapprox": "⪅",
    "gtrapprox": "⪆",
    "lneq": "⪇",
    "gneq": "⪈",
    "lnapprox": "⪉",
    "gnapprox": "⪊",
    "lesseqqgtr": "⪋",
    "gtreqqless": "⪌",
    "eqslantless": "⪕",
    "eqslantgtr": "⪖",
    "NestedLessLess": "⪡",
    "NotNestedLessLess": "⪡",
    "NestedGreaterGreater": "⪢",
    "NotNestedGreaterGreater": "⪢",
    "precneqq": "⪵",
    "succneqq": "⪶",
    "precnapprox": "⪹",
    "succnapprox": "⪺",
    "subseteqq": "⫅",
    "nsubseteqq": "⫅",
    "supseteqq": "⫆",
    "subsetneqq": "⫋",
    "supsetneqq": "⫌",
    "Elztdcol": "⫶",
    "openbracketleft": "〚",
    "openbracketright": "〛",
    checkmark: "✓",
    maltese: "✠",
};
function isCharacterUnicode(x) {
    return exports.characterUnicodeChart.hasOwnProperty(x);
}
exports.isCharacterUnicode = isCharacterUnicode;
exports.characterUnicode = function (name) { return isCharacterUnicode(name) ? exports.characterUnicodeChart[name] : undefined; };
//# sourceMappingURL=symbols.js.map

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.barredLUnicodeChart = {
    l: "ł",
    L: "Ł"
};
exports.barredLUnicode = function (name) { return exports.barredLUnicodeChart[name]; };
//# sourceMappingURL=barred-letter.js.map

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.slashed_o = "ø";
exports.slashed_O = "Ø";
exports.slashedOUnicodeChart = {
    "o": exports.slashed_o,
    "O": exports.slashed_O
};
exports.slashedOUnicode = function (char) { return exports.slashedOUnicodeChart[char]; };
//# sourceMappingURL=slashed.js.map

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.cyrillicUnicodeChart = {
    "CYRF": "Ф",
    "CYRII": "І",
    "CYROMEGA": "Ѡ",
    "CYRG": "Г",
    "cyrkvcrs": "ҝ",
    "cyryo": "ё",
    "CYRH": "Х",
    "CYRZHDSC": "Җ",
    "cyrphk": "ҧ",
    "CYRTDSC": "Ҭ",
    "CYRI": "И",
    "cyryi": "ї",
    "CYRDZHE": "Џ",
    "cyriote": "ѥ",
    "CYRK": "К",
    "CYRSHHA": "Һ",
    "CYRL": "Л",
    "CYRM": "М",
    "CYRCHLDSC": "Ӌ",
    "CYRNJE": "Њ",
    "CYRYAT": "Ѣ",
    "CYRA": "А",
    "CYRB": "Б",
    "cyrchrdsc": "ҷ",
    "cyrschwa": "ә",
    "CYRDZE": "Ѕ",
    "CYRIE": "Є",
    "CYRC": "Ц",
    "CYRZH": "Ж",
    "CYRD": "Д",
    "CYRABHCHDSC": "Ҿ",
    "CYRFITA": "Ѳ",
    "CYRE": "Е",
    "CYRABHHA": "Ҩ",
    "cyrya": "я",
    "cyrdzhe": "џ",
    "CYRIOTLYUS": "Ѩ",
    "cyrsemisftsn": "ҍ",
    "CYRV": "В",
    "cyrishrt": "й",
    "cyrdje": "ђ",
    "cyrchldsc": "ӌ",
    "CYRY": "Ү",
    "cyrndsc": "ң",
    "CYRZ": "З",
    "CYRKHCRS": "Ҟ",
    "CYRNG": "Ҥ",
    "CYRCHRDSC": "Ҷ",
    "CYRYHCRS": "Ұ",
    "CYRSHCH": "Щ",
    "CYRUSHRT": "Ў",
    "cyryu": "ю",
    "cyrksi": "ѯ",
    "CYRN": "Н",
    "CYRO": "О",
    "CYRBYUS": "Ѫ",
    "CYRP": "П",
    "CYRZDSC": "Ҙ",
    "CYRAE": "Ӕ",
    "CYRR": "Р",
    "CYRS": "С",
    "CYRT": "Т",
    "CYRABHCH": "Ҽ",
    "cyruk": "ѹ",
    "CYRU": "У",
    "cyrii": "і",
    "CYRSEMISFTSN": "Ҍ",
    "cyrghcrs": "ғ",
    "CYRISHRT": "Й",
    "cyromegatitlo": "ѽ",
    "cyrkbeak": "ҡ",
    "cyrie": "є",
    "cyrzdsc": "ҙ",
    "CYRNDSC": "Ң",
    "CYRGUP": "Ґ",
    "cyrshch": "щ",
    "CYRKHK": "Ӄ",
    "cyrzh": "ж",
    "CYRJE": "Ј",
    "cyrthousands": "҂",
    "cyrabhch": "ҽ",
    "textnumero": "№",
    "cyrng": "ҥ",
    "CYRPSI": "Ѱ",
    "CYRTETSE": "Ҵ",
    "CYRIOTBYUS": "Ѭ",
    "cyrnje": "њ",
    "CYRIOTE": "Ѥ",
    "cyrdze": "ѕ",
    "cyrae": "ӕ",
    "CYRHRDSN": "Ъ",
    "CYRKOPPA": "Ҁ",
    "CYRRTICK": "Ҏ",
    "CYRSCHWA": "Ә",
    "cyrtdsc": "ҭ",
    "CYRGHK": "Ҕ",
    "cyrabhha": "ҩ",
    "cyrshha": "һ",
    "CYRSH": "Ш",
    "cyru": "у",
    "cyrkhcrs": "ҟ",
    "cyrt": "т",
    "CYRERY": "Ы",
    "cyrs": "с",
    "cyrr": "р",
    "CYROT": "Ѿ",
    "cyrlyus": "ѧ",
    "CYRNHK": "Ӈ",
    "CYRSFTSN": "Ь",
    "cyrghk": "ҕ",
    "cyrp": "п",
    "cyrabhdze": "ӡ",
    "cyro": "о",
    "CYRTSHE": "Ћ",
    "cyrn": "н",
    "CYRSDSC": "Ҫ",
    "cyryhcrs": "ұ",
    "cyrpsi": "ѱ",
    "cyrz": "з",
    "cyry": "ү",
    "cyrje": "ј",
    "cyrv": "в",
    "cyrchvcrs": "ҹ",
    "cyrkhk": "ӄ",
    "cyre": "е",
    "cyromega": "ѡ",
    "cyrd": "д",
    "cyrc": "ц",
    "cyrb": "б",
    "CYROTLD": "Ө",
    "cyrgup": "ґ",
    "CYRLJE": "Љ",
    "cyra": "а",
    "CYROMEGATITLO": "Ѽ",
    "CYRGHCRS": "Ғ",
    "CYRCHVCRS": "Ҹ",
    "cyrm": "м",
    "cyrl": "л",
    "cyrsh": "ш",
    "cyrk": "к",
    "cyri": "и",
    "cyrh": "х",
    "CYRHDSC": "Ҳ",
    "CYRIZH": "Ѵ",
    "CYRABHDZE": "Ӡ",
    "cyrkdsc": "қ",
    "cyrg": "г",
    "CYRCH": "Ч",
    "cyrf": "ф",
    "CYRYI": "Ї",
    "cyrmillions": "\u0489",
    "CYRKSI": "Ѯ",
    "CYROMEGARND": "Ѻ",
    "cyrot": "ѿ",
    "cyrtetse": "ҵ",
    "cyrhdsc": "ҳ",
    "cyrushrt": "ў",
    "cyriotlyus": "ѩ",
    "CYRYA": "Я",
    "cyrlje": "љ",
    "cyrotld": "ө",
    "CYRKDSC": "Қ",
    "cyrhrdsn": "ъ",
    "cyrrtick": "ҏ",
    "cyrkoppa": "ҁ",
    "CYRDJE": "Ђ",
    "cyriotbyus": "ѭ",
    "cyrhundredthousands": "\u0488",
    "CYRpalochka": "Ӏ",
    "CYRKVCRS": "Ҝ",
    "cyromegarnd": "ѻ",
    "cyrsftsn": "ь",
    "cyrabhchdsc": "ҿ",
    "cyrzhdsc": "җ",
    "cyrerev": "э",
    "CYRLYUS": "Ѧ",
    "CYRKBEAK": "Ҡ",
    "cyrery": "ы",
    "CYREREV": "Э",
    "cyrnhk": "ӈ",
    "cyrsdsc": "ҫ",
    "cyrch": "ч",
    "cyrtshe": "ћ",
    "CYRPHK": "Ҧ",
    "CYRYO": "Ё",
    "CYRYU": "Ю",
    "CYRUK": "Ѹ",
};
exports.cyrillicUnicode = function (name) { return exports.cyrillicUnicodeChart[name]; };
//# sourceMappingURL=cyrillic.js.map

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.specialCharacters = {
    "i": "ı",
    "j": "ȷ",
    "oe": "œ",
    "OE": "Œ",
    "ae": "æ",
    "AE": "Æ",
    "aa": "å",
    "AA": "Å",
    "o": "ø",
    "O": "Ø",
    "ss": "ß",
    "l": "ł",
    "L": "Ł"
};
function isSpecialCharacter(x) {
    return exports.specialCharacters.hasOwnProperty(x);
}
exports.isSpecialCharacter = isSpecialCharacter;
exports.specialCharacter = function (name) { return isSpecialCharacter(name) ? exports.specialCharacters[name] : undefined; };
//# sourceMappingURL=specialchars.js.map

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = __webpack_require__(107);
var index_2 = __webpack_require__(120);
var cyrillic_1 = __webpack_require__(129);
var dingbats_1 = __webpack_require__(130);
var elsevier_1 = __webpack_require__(131);
var runes_1 = __webpack_require__(50);
function expand1argsCommand(name, arg) {
    switch (name) {
        case "cyrchar":
            var c = cyrillic_1.translateCharToCyrillic(arg);
            if (!!c)
                return c;
            break;
        case "ding":
        case "dingbat":
            var d = dingbats_1.translateCharToDingbat(arg);
            if (!!d)
                return d;
            break;
        case "ElsevierGlyph":
        case "elsevierglyph":
        case "elsevier":
        case "Elsevier":
            var e = elsevier_1.translateCharToElsevier(arg);
            if (!!e)
                return e;
            break;
        default:
            for (var _i = 0, _a = [
                index_1.diacriticUnicode,
                index_2.formattingUnicode,
                runes_1.runeUnicode,
            ]; _i < _a.length; _i++) {
                var fn = _a[_i];
                var result = fn(name, arg);
                if (!!result)
                    return result;
            }
    }
    throw new Error("No implementation found to expand \\" + name + " with argument {" + arg + "}");
}
exports.expand1argsCommand = expand1argsCommand;
//# sourceMappingURL=index.js.map

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var mathring_1 = __webpack_require__(108);
var acute_1 = __webpack_require__(109);
var grave_1 = __webpack_require__(110);
var circumflex_1 = __webpack_require__(111);
var tilde_1 = __webpack_require__(112);
var dieresis_1 = __webpack_require__(113);
var cedilla_1 = __webpack_require__(114);
var caron_1 = __webpack_require__(115);
var util_1 = __webpack_require__(13);
var ogonek_1 = __webpack_require__(116);
var tie_letters_1 = __webpack_require__(117);
var vectorArrow_1 = __webpack_require__(118);
var long_hungarian_umlaut_1 = __webpack_require__(119);
exports.barUnderLetter = util_1.simpleSuffix("\u0331");
exports.dotUnderLetter = util_1.simpleSuffix("\u0323");
exports.breve = util_1.simpleSuffix("\u0306");
exports.macrron = util_1.simpleSuffix("\u0304");
exports.dotOverLetter = util_1.simpleSuffix("\u0307");
exports.modifiersTextModeUnicodeChart = {
    "`": grave_1.graveAccent,
    "'": acute_1.acuteAccent,
    "^": circumflex_1.circumflex,
    "~": tilde_1.tilde,
    "=": exports.macrron,
    ".": exports.dotOverLetter,
    '"': dieresis_1.dieresis,
    "H": long_hungarian_umlaut_1.longHungarianUmlaut,
    "c": cedilla_1.cedilla,
    "k": ogonek_1.ogonek,
    "b": exports.barUnderLetter,
    "d": exports.dotUnderLetter,
    "r": mathring_1.ringOverLetter,
    "u": exports.breve,
    "v": caron_1.caron,
    "t": tie_letters_1.tieLetters,
};
exports.modifiersMathModeUnicodeChart = {
    "check": caron_1.caron,
    "acute": acute_1.acuteAccent,
    "grave": acute_1.acuteAccent,
    "breve": exports.breve,
    "vec": vectorArrow_1.vectorArrow,
    "mathring": mathring_1.ringOverLetter,
};
exports.diacriticUnicode = function (str, arg) {
    var fun = exports.modifiersTextModeUnicodeChart[str];
    if (!fun)
        fun = exports.modifiersMathModeUnicodeChart[str];
    return fun && fun(arg);
};
//# sourceMappingURL=index.js.map

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var command_expander_1 = __webpack_require__(9);
exports.ringOverLetter = command_expander_1.lookupOrAppend({
    a: "å",
    A: "Å",
    y: "ẙ"
}, "\u030A");
//# sourceMappingURL=mathring.js.map

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var command_expander_1 = __webpack_require__(9);
exports.acuteAccent = command_expander_1.lookupOrAppend({
    e: "é",
    y: "ý",
    u: "ú",
    i: "í",
    o: "ó",
    a: "á",
    E: "É",
    Y: "Ý",
    U: "Ú",
    I: "Í",
    O: "Ó",
    A: "Á",
    cyrk: "ќ",
    cyrg: "ѓ",
    CYRK: "Ќ",
    CYRG: "Ѓ",
}, "\u0301");
//# sourceMappingURL=acute.js.map

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var command_expander_1 = __webpack_require__(9);
exports.graveAccent = command_expander_1.lookupOrAppend({
    e: "è",
    u: "ù",
    i: "ì",
    o: "ò",
    a: "à",
    E: "È",
    U: "Ù",
    I: "Ì",
    O: "Ò",
    A: "À"
}, "\u0300");
//# sourceMappingURL=grave.js.map

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var command_expander_1 = __webpack_require__(9);
exports.circumflex = command_expander_1.lookupOrAppend({
    e: "ê",
    u: "û",
    i: "î",
    o: "ô",
    a: "â",
    E: "Ê",
    U: "Û",
    I: "Î",
    O: "Ô",
    A: "Â"
}, "\u0302");
//# sourceMappingURL=circumflex.js.map

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var command_expander_1 = __webpack_require__(9);
exports.tilde = command_expander_1.lookupOrAppend({
    o: "õ",
    a: "ã",
    n: "ñ",
    O: "Õ",
    A: "Ã",
    N: "Ñ"
}, "\u0303");
//# sourceMappingURL=tilde.js.map

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var command_expander_1 = __webpack_require__(9);
exports.dieresis = command_expander_1.lookupOrAppend({
    e: "ë",
    y: "ÿ",
    u: "ü",
    i: "ï",
    o: "ö",
    a: "ä",
    E: "Ë",
    Y: "Ÿ",
    U: "Ü",
    I: "Ï",
    O: "Ö",
    A: "Ä"
}, "\u0308");
//# sourceMappingURL=dieresis.js.map

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var command_expander_1 = __webpack_require__(9);
exports.cedilla = command_expander_1.lookupOrAppend({
    c: "ç"
}, "\u0327");
//# sourceMappingURL=cedilla.js.map

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var command_expander_1 = __webpack_require__(9);
exports.caron = command_expander_1.lookupOrAppend({
    s: "š"
}, "\u030C");
//# sourceMappingURL=caron.js.map

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = __webpack_require__(13);
exports.ogonek = util_1.simpleSuffix("\u0328");
//# sourceMappingURL=ogonek.js.map

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function tieLetters(chars) {
    return tie2Letters(chars.charAt(0), chars.substring(1));
}
exports.tieLetters = tieLetters;
function tie2Letters(a, b) {
    return a + "͡" + b;
}
exports.tie2Letters = tie2Letters;
function isTieLetters(cmdName) {
    return cmdName === "t";
}
exports.isTieLetters = isTieLetters;
//# sourceMappingURL=tie-letters.js.map

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var command_expander_1 = __webpack_require__(9);
exports.vectorArrow = command_expander_1.lookupOrAppend({}, "\u20D7");
//# sourceMappingURL=vectorArrow.js.map

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var command_expander_1 = __webpack_require__(9);
exports.longHungarianUmlaut = command_expander_1.lookupOrAppend({
    o: "ő",
    u: "ű",
    O: "Ő",
    U: "Ű",
}, "\u030B");
//# sourceMappingURL=long-hungarian-umlaut.js.map

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var blackboard_1 = __webpack_require__(121);
var boldfont_1 = __webpack_require__(122);
var fraktur_1 = __webpack_require__(123);
var italic_1 = __webpack_require__(124);
var monospace_1 = __webpack_require__(125);
var textcal_1 = __webpack_require__(126);
var formatting_1 = __webpack_require__(48);
var subscript_1 = __webpack_require__(127);
var superscript_1 = __webpack_require__(49);
var mono_1 = __webpack_require__(128);
exports.formattingUnicode = function (cmdName, arg) {
    var fn = undefined;
    if (formatting_1.isBbCmd(cmdName))
        fn = blackboard_1.translateCharToBlackboard;
    else if (formatting_1.isBfCmd(cmdName))
        fn = boldfont_1.translateCharToBold;
    else if (formatting_1.isFrakCmd(cmdName))
        fn = fraktur_1.translateCharToFraktur;
    else if (formatting_1.isItCmd(cmdName))
        fn = italic_1.translateCharToItalic;
    else if (formatting_1.isTtCmd(cmdName))
        fn = monospace_1.translateCharToMonospace;
    else if (formatting_1.isCalCmd(cmdName))
        fn = textcal_1.translateCharToCalligraphic;
    else if (formatting_1.isSubCmd(cmdName))
        fn = subscript_1.translateCharToSubscript;
    else if (formatting_1.isSupCmd(cmdName))
        fn = superscript_1.translateCharToSuperscript;
    else if (formatting_1.isMonoCmd(cmdName))
        fn = mono_1.translateCharToMono;
    if (!!fn) {
        var fun_1 = fn;
        return arg.split("").map(function (char) { return (fun_1(char) || char); }).join("");
    }
    else
        return undefined;
};
//# sourceMappingURL=index.js.map

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.blackboardCharacters = {
    "A": "𝔸",
    "B": "𝔹",
    "C": "ℂ",
    "D": "𝔻",
    "E": "𝔼",
    "F": "𝔽",
    "G": "𝔾",
    "H": "ℍ",
    "I": "𝕀",
    "J": "𝕁",
    "K": "𝕂",
    "L": "𝕃",
    "M": "𝕄",
    "N": "ℕ",
    "O": "𝕆",
    "P": "ℙ",
    "Q": "ℚ",
    "R": "ℝ",
    "S": "𝕊",
    "T": "𝕋",
    "U": "𝕌",
    "V": "𝕍",
    "W": "𝕎",
    "X": "𝕏",
    "Y": "𝕐",
    "Z": "ℤ",
    "a": "𝕒",
    "b": "𝕓",
    "c": "𝕔",
    "d": "𝕕",
    "e": "𝕖",
    "f": "𝕗",
    "g": "𝕘",
    "h": "𝕙",
    "i": "𝕚",
    "j": "𝕛",
    "k": "𝕜",
    "l": "𝕝",
    "m": "𝕞",
    "n": "𝕟",
    "o": "𝕠",
    "p": "𝕡",
    "q": "𝕢",
    "r": "𝕣",
    "s": "𝕤",
    "t": "𝕥",
    "u": "𝕦",
    "v": "𝕧",
    "w": "𝕨",
    "x": "𝕩",
    "y": "𝕪",
    "z": "𝕫",
    "0": "𝟘",
    "1": "𝟙",
    "2": "𝟚",
    "3": "𝟛",
    "4": "𝟜",
    "5": "𝟝",
    "6": "𝟞",
    "7": "𝟟",
    "8": "𝟠",
    "9": "𝟡"
};
function isBlackboardCharacter(x) {
    return exports.blackboardCharacters.hasOwnProperty(x);
}
exports.isBlackboardCharacter = isBlackboardCharacter;
exports.translateCharToBlackboard = function (char) { return isBlackboardCharacter(char) ? exports.blackboardCharacters[char] : undefined; };
//# sourceMappingURL=blackboard.js.map

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.boldCharacters = {
    "A": "𝐀",
    "B": "𝐁",
    "C": "𝐂",
    "D": "𝐃",
    "E": "𝐄",
    "F": "𝐅",
    "G": "𝐆",
    "H": "𝐇",
    "I": "𝐈",
    "J": "𝐉",
    "K": "𝐊",
    "L": "𝐋",
    "M": "𝐌",
    "N": "𝐍",
    "O": "𝐎",
    "P": "𝐏",
    "Q": "𝐐",
    "R": "𝐑",
    "S": "𝐒",
    "T": "𝐓",
    "U": "𝐔",
    "V": "𝐕",
    "W": "𝐖",
    "X": "𝐗",
    "Y": "𝐘",
    "Z": "𝐙",
    "a": "𝐚",
    "b": "𝐛",
    "c": "𝐜",
    "d": "𝐝",
    "e": "𝐞",
    "f": "𝐟",
    "g": "𝐠",
    "h": "𝐡",
    "i": "𝐢",
    "j": "𝐣",
    "k": "𝐤",
    "l": "𝐥",
    "m": "𝐦",
    "n": "𝐧",
    "o": "𝐨",
    "p": "𝐩",
    "q": "𝐪",
    "r": "𝐫",
    "s": "𝐬",
    "t": "𝐭",
    "u": "𝐮",
    "v": "𝐯",
    "w": "𝐰",
    "x": "𝐱",
    "y": "𝐲",
    "z": "𝐳",
    "Α": "𝚨",
    "Β": "𝚩",
    "Γ": "𝚪",
    "Δ": "𝚫",
    "Ε": "𝚬",
    "Ζ": "𝚭",
    "Η": "𝚮",
    "Θ": "𝚯",
    "Ι": "𝚰",
    "Κ": "𝚱",
    "Λ": "𝚲",
    "Μ": "𝚳",
    "Ν": "𝚴",
    "Ξ": "𝚵",
    "Ο": "𝚶",
    "Π": "𝚷",
    "Ρ": "𝚸",
    "ϴ": "𝚹",
    "Σ": "𝚺",
    "Τ": "𝚻",
    "Υ": "𝚼",
    "Φ": "𝚽",
    "Χ": "𝚾",
    "Ψ": "𝚿",
    "Ω": "𝛀",
    "∇": "𝛁",
    "α": "𝛂",
    "β": "𝛃",
    "γ": "𝛄",
    "δ": "𝛅",
    "ε": "𝛆",
    "ζ": "𝛇",
    "η": "𝛈",
    "θ": "𝛉",
    "ι": "𝛊",
    "κ": "𝛋",
    "λ": "𝛌",
    "μ": "𝛍",
    "ν": "𝛎",
    "ξ": "𝛏",
    "ο": "𝛐",
    "π": "𝛑",
    "ρ": "𝛒",
    "ς": "𝛓",
    "σ": "𝛔",
    "τ": "𝛕",
    "υ": "𝛖",
    "φ": "𝛗",
    "χ": "𝛘",
    "ψ": "𝛙",
    "ω": "𝛚",
    "∂": "𝛛",
    "ϵ": "𝛜",
    "ϑ": "𝛝",
    "ϰ": "𝛞",
    "ϕ": "𝛟",
    "ϱ": "𝛠",
    "ϖ": "𝛡",
    "0": "𝟎",
    "1": "𝟏",
    "2": "𝟐",
    "3": "𝟑",
    "4": "𝟒",
    "5": "𝟓",
    "6": "𝟔",
    "7": "𝟕",
    "8": "𝟖",
    "9": "𝟗"
};
function isBlackboardCharacter(x) {
    return exports.boldCharacters.hasOwnProperty(x);
}
exports.isBlackboardCharacter = isBlackboardCharacter;
exports.translateCharToBold = function (char) { return isBlackboardCharacter(char) ? exports.boldCharacters[char] : undefined; };
//# sourceMappingURL=boldfont.js.map

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.frakturCharacters = {
    "A": "𝔄",
    "B": "𝔅",
    "C": "ℭ",
    "D": "𝔇",
    "E": "𝔈",
    "F": "𝔉",
    "G": "𝔊",
    "H": "ℌ",
    "I": "ℑ",
    "J": "𝔍",
    "K": "𝔎",
    "L": "𝔏",
    "M": "𝔐",
    "N": "𝔑",
    "O": "𝔒",
    "P": "𝔓",
    "Q": "𝔔",
    "R": "ℜ",
    "S": "𝔖",
    "T": "𝔗",
    "U": "𝔘",
    "V": "𝔙",
    "W": "𝔚",
    "X": "𝔛",
    "Y": "𝔜",
    "Z": "ℨ",
    "a": "𝔞",
    "b": "𝔟",
    "c": "𝔠",
    "d": "𝔡",
    "e": "𝔢",
    "f": "𝔣",
    "g": "𝔤",
    "h": "𝔥",
    "i": "𝔦",
    "j": "𝔧",
    "k": "𝔨",
    "l": "𝔩",
    "m": "𝔪",
    "n": "𝔫",
    "o": "𝔬",
    "p": "𝔭",
    "q": "𝔮",
    "r": "𝔯",
    "s": "𝔰",
    "t": "𝔱",
    "u": "𝔲",
    "v": "𝔳",
    "w": "𝔴",
    "x": "𝔵",
    "y": "𝔶",
    "z": "𝔷"
};
function isFrakturCharacter(x) {
    return exports.frakturCharacters.hasOwnProperty(x);
}
exports.isFrakturCharacter = isFrakturCharacter;
exports.translateCharToFraktur = function (char) { return isFrakturCharacter(char) ? exports.frakturCharacters[char] : undefined; };
//# sourceMappingURL=fraktur.js.map

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.italicCharacters = {
    "A": "𝐴",
    "B": "𝐵",
    "C": "𝐶",
    "D": "𝐷",
    "E": "𝐸",
    "F": "𝐹",
    "G": "𝐺",
    "H": "𝐻",
    "I": "𝐼",
    "J": "𝐽",
    "K": "𝐾",
    "L": "𝐿",
    "M": "𝑀",
    "N": "𝑁",
    "O": "𝑂",
    "P": "𝑃",
    "Q": "𝑄",
    "R": "𝑅",
    "S": "𝑆",
    "T": "𝑇",
    "U": "𝑈",
    "V": "𝑉",
    "W": "𝑊",
    "X": "𝑋",
    "Y": "𝑌",
    "Z": "𝑍",
    "a": "𝑎",
    "b": "𝑏",
    "c": "𝑐",
    "d": "𝑑",
    "e": "𝑒",
    "f": "𝑓",
    "g": "𝑔",
    "h": "ℎ",
    "i": "𝑖",
    "j": "𝑗",
    "k": "𝑘",
    "l": "𝑙",
    "m": "𝑚",
    "n": "𝑛",
    "o": "𝑜",
    "p": "𝑝",
    "q": "𝑞",
    "r": "𝑟",
    "s": "𝑠",
    "t": "𝑡",
    "u": "𝑢",
    "v": "𝑣",
    "w": "𝑤",
    "x": "𝑥",
    "y": "𝑦",
    "z": "𝑧",
    "Α": "𝛢",
    "Β": "𝛣",
    "Γ": "𝛤",
    "Δ": "𝛥",
    "Ε": "𝛦",
    "Ζ": "𝛧",
    "Η": "𝛨",
    "Θ": "𝛩",
    "Ι": "𝛪",
    "Κ": "𝛫",
    "Λ": "𝛬",
    "Μ": "𝛭",
    "Ν": "𝛮",
    "Ξ": "𝛯",
    "Ο": "𝛰",
    "Π": "𝛱",
    "Ρ": "𝛲",
    "ϴ": "𝛳",
    "Σ": "𝛴",
    "Τ": "𝛵",
    "Υ": "𝛶",
    "Φ": "𝛷",
    "Χ": "𝛸",
    "Ψ": "𝛹",
    "Ω": "𝛺",
    "∇": "𝛻",
    "α": "𝛼",
    "β": "𝛽",
    "γ": "𝛾",
    "δ": "𝛿",
    "ε": "𝜀",
    "ζ": "𝜁",
    "η": "𝜂",
    "θ": "𝜃",
    "ι": "𝜄",
    "κ": "𝜅",
    "λ": "𝜆",
    "μ": "𝜇",
    "ν": "𝜈",
    "ξ": "𝜉",
    "ο": "𝜊",
    "π": "𝜋",
    "ρ": "𝜌",
    "ς": "𝜍",
    "σ": "𝜎",
    "τ": "𝜏",
    "υ": "𝜐",
    "φ": "𝜑",
    "χ": "𝜒",
    "ψ": "𝜓",
    "ω": "𝜔",
    "∂": "𝜕",
    "ϵ": "𝜖",
    "ϑ": "𝜗",
    "ϰ": "𝜘",
    "ϕ": "𝜙",
    "ϱ": "𝜚",
    "ϖ": "𝜛"
};
function isItalicCharacter(x) {
    return exports.italicCharacters.hasOwnProperty(x);
}
exports.isItalicCharacter = isItalicCharacter;
exports.translateCharToItalic = function (char) { return isItalicCharacter(char) ? exports.italicCharacters[char] : undefined; };
//# sourceMappingURL=italic.js.map

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.monospaceCharacters = {
    "A": "𝙰",
    "B": "𝙱",
    "C": "𝙲",
    "D": "𝙳",
    "E": "𝙴",
    "F": "𝙵",
    "G": "𝙶",
    "H": "𝙷",
    "I": "𝙸",
    "J": "𝙹",
    "K": "𝙺",
    "L": "𝙻",
    "M": "𝙼",
    "N": "𝙽",
    "O": "𝙾",
    "P": "𝙿",
    "Q": "𝚀",
    "R": "𝚁",
    "S": "𝚂",
    "T": "𝚃",
    "U": "𝚄",
    "V": "𝚅",
    "W": "𝚆",
    "X": "𝚇",
    "Y": "𝚈",
    "Z": "𝚉",
    "a": "𝚊",
    "b": "𝚋",
    "c": "𝚌",
    "d": "𝚍",
    "e": "𝚎",
    "f": "𝚏",
    "g": "𝚐",
    "h": "𝚑",
    "i": "𝚒",
    "j": "𝚓",
    "k": "𝚔",
    "l": "𝚕",
    "m": "𝚖",
    "n": "𝚗",
    "o": "𝚘",
    "p": "𝚙",
    "q": "𝚚",
    "r": "𝚛",
    "s": "𝚜",
    "t": "𝚝",
    "u": "𝚞",
    "v": "𝚟",
    "w": "𝚠",
    "x": "𝚡",
    "y": "𝚢",
    "z": "𝚣",
    "0": "𝟶",
    "1": "𝟷",
    "2": "𝟸",
    "3": "𝟹",
    "4": "𝟺",
    "5": "𝟻",
    "6": "𝟼",
    "7": "𝟽",
    "8": "𝟾",
    "9": "𝟿"
};
function isMonospaceCharacter(x) {
    return exports.monospaceCharacters.hasOwnProperty(x);
}
exports.isMonospaceCharacter = isMonospaceCharacter;
exports.translateCharToMonospace = function (char) { return isMonospaceCharacter(char) ? exports.monospaceCharacters[char] : undefined; };
//# sourceMappingURL=monospace.js.map

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.calligraphicLetters = {
    "A": "𝓐",
    "B": "𝓑",
    "C": "𝓒",
    "D": "𝓓",
    "E": "𝓔",
    "F": "𝓕",
    "G": "𝓖",
    "H": "𝓗",
    "I": "𝓘",
    "J": "𝓙",
    "K": "𝓚",
    "L": "𝓛",
    "M": "𝓜",
    "N": "𝓝",
    "O": "𝓞",
    "P": "𝓟",
    "Q": "𝓠",
    "R": "𝓡",
    "S": "𝓢",
    "T": "𝓣",
    "U": "𝓤",
    "V": "𝓥",
    "W": "𝓦",
    "X": "𝓧",
    "Y": "𝓨",
    "Z": "𝓩",
    "a": "𝓪",
    "b": "𝓫",
    "c": "𝓬",
    "d": "𝓭",
    "e": "𝓮",
    "f": "𝓯",
    "g": "𝓰",
    "h": "𝓱",
    "i": "𝓲",
    "j": "𝓳",
    "k": "𝓴",
    "l": "𝓵",
    "m": "𝓶",
    "n": "𝓷",
    "o": "𝓸",
    "p": "𝓹",
    "q": "𝓺",
    "r": "𝓻",
    "s": "𝓼",
    "t": "𝓽",
    "u": "𝓾",
    "v": "𝓿",
    "w": "𝔀",
    "x": "𝔁",
    "y": "𝔂",
    "z": "𝔃"
};
function isCalligraphicLetter(x) {
    return exports.calligraphicLetters.hasOwnProperty(x);
}
exports.isCalligraphicLetter = isCalligraphicLetter;
exports.translateCharToCalligraphic = function (char) { return isCalligraphicLetter(char) ? exports.calligraphicLetters[char] : undefined; };
//# sourceMappingURL=textcal.js.map

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.subscriptCharacters = {
    "0": "₀",
    "1": "₁",
    "2": "₂",
    "3": "₃",
    "4": "₄",
    "5": "₅",
    "6": "₆",
    "7": "₇",
    "8": "₈",
    "9": "₉",
    "+": "₊",
    "-": "₋",
    "=": "₌",
    "(": "₍",
    ")": "₎",
    "a": "ₐ",
    "e": "ₑ",
    "h": "ₕ",
    "i": "ᵢ",
    "j": "ⱼ",
    k: "ₖ",
    l: "ₗ",
    m: "ₘ",
    n: "ₙ",
    "o": "ₒ",
    p: "ₚ",
    "r": "ᵣ",
    s: "ₛ",
    t: "ₜ",
    "u": "ᵤ",
    "v": "ᵥ",
    "x": "ₓ",
    "β": "ᵦ",
    "γ": "ᵧ",
    "ρ": "ᵨ",
    "φ": "ᵩ",
    "χ": "ᵪ"
};
function isSubscriptCharacter(x) {
    return exports.subscriptCharacters.hasOwnProperty(x);
}
exports.isSubscriptCharacter = isSubscriptCharacter;
exports.translateCharToSubscript = function (char) { return isSubscriptCharacter(char) ? exports.subscriptCharacters[char] : undefined; };
//# sourceMappingURL=subscript.js.map

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.monoCharacters = {
    "A": "𝙰",
    "B": "𝙱",
    "C": "𝙲",
    "D": "𝙳",
    "E": "𝙴",
    "F": "𝙵",
    "G": "𝙶",
    "H": "𝙷",
    "I": "𝙸",
    "J": "𝙹",
    "K": "𝙺",
    "L": "𝙻",
    "M": "𝙼",
    "N": "𝙽",
    "O": "𝙾",
    "P": "𝙿",
    "Q": "𝚀",
    "R": "𝚁",
    "S": "𝚂",
    "T": "𝚃",
    "U": "𝚄",
    "V": "𝚅",
    "W": "𝚆",
    "X": "𝚇",
    "Y": "𝚈",
    "Z": "𝚉",
    "a": "𝚊",
    "b": "𝚋",
    "c": "𝚌",
    "d": "𝚍",
    "e": "𝚎",
    "f": "𝚏",
    "g": "𝚐",
    "h": "𝚑",
    "i": "𝚒",
    "j": "𝚓",
    "k": "𝚔",
    "l": "𝚕",
    "m": "𝚖",
    "n": "𝚗",
    "o": "𝚘",
    "p": "𝚙",
    "q": "𝚚",
    "r": "𝚛",
    "s": "𝚜",
    "t": "𝚝",
    "u": "𝚞",
    "v": "𝚟",
    "w": "𝚠",
    "x": "𝚡",
    "y": "𝚢",
    "z": "𝚣",
    "0": "𝟶",
    "1": "𝟷",
    "2": "𝟸",
    "3": "𝟹",
    "4": "𝟺",
    "5": "𝟻",
    "6": "𝟼",
    "7": "𝟽",
    "8": "𝟾",
    "9": "𝟿",
};
function isMonoCharacter(x) {
    return exports.monoCharacters.hasOwnProperty(x);
}
exports.isMonoCharacter = isMonoCharacter;
exports.translateCharToMono = function (char) { return isMonoCharacter(char) ? exports.monoCharacters[char] : undefined; };
//# sourceMappingURL=mono.js.map

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.cyrillicCharacters = {
    "Ф": "Ф",
    "І": "І",
    "Ѡ": "Ѡ",
    "Г": "Г",
    "ҝ": "ҝ",
    "ё": "ё",
    "Х": "Х",
    "Җ": "Җ",
    "ҧ": "ҧ",
    "Ҭ": "Ҭ",
    "И": "И",
    "ї": "ї",
    "Џ": "Џ",
    "ѥ": "ѥ",
    "К": "К",
    "Һ": "Һ",
    "Л": "Л",
    "М": "М",
    "Ӌ": "Ӌ",
    "Њ": "Њ",
    "Ѣ": "Ѣ",
    "А": "А",
    "Б": "Б",
    "ҷ": "ҷ",
    "ә": "ә",
    "Ѕ": "Ѕ",
    "Є": "Є",
    "Ц": "Ц",
    "Ж": "Ж",
    "Д": "Д",
    "Ҿ": "Ҿ",
    "Ѳ": "Ѳ",
    "Е": "Е",
    "Ҩ": "Ҩ",
    "я": "я",
    "џ": "џ",
    "Ѩ": "Ѩ",
    "ҍ": "ҍ",
    "В": "В",
    "й": "й",
    "ђ": "ђ",
    "ӌ": "ӌ",
    "Ү": "Ү",
    "ң": "ң",
    "З": "З",
    "Ҟ": "Ҟ",
    "Ҥ": "Ҥ",
    "Ҷ": "Ҷ",
    "Ұ": "Ұ",
    "Щ": "Щ",
    "Ў": "Ў",
    "ю": "ю",
    "ѯ": "ѯ",
    "Н": "Н",
    "О": "О",
    "Ѫ": "Ѫ",
    "П": "П",
    "Ҙ": "Ҙ",
    "Ӕ": "Ӕ",
    "Р": "Р",
    "С": "С",
    "Т": "Т",
    "Ҽ": "Ҽ",
    "ѹ": "ѹ",
    "У": "У",
    "і": "і",
    "Ҍ": "Ҍ",
    "ғ": "ғ",
    "Й": "Й",
    "ѽ": "ѽ",
    "ҡ": "ҡ",
    "є": "є",
    "ҙ": "ҙ",
    "Ң": "Ң",
    "Ґ": "Ґ",
    "щ": "щ",
    "Ӄ": "Ӄ",
    "ж": "ж",
    "Ј": "Ј",
    "҂": "҂",
    "ҽ": "ҽ",
    "№": "№",
    "ҥ": "ҥ",
    "Ѱ": "Ѱ",
    "Ҵ": "Ҵ",
    "Ѭ": "Ѭ",
    "њ": "њ",
    "Ѥ": "Ѥ",
    "ѕ": "ѕ",
    "ӕ": "ӕ",
    "Ъ": "Ъ",
    "Ҁ": "Ҁ",
    "Ҏ": "Ҏ",
    "Ә": "Ә",
    "ҭ": "ҭ",
    "Ҕ": "Ҕ",
    "ҩ": "ҩ",
    "һ": "һ",
    "Ш": "Ш",
    "у": "у",
    "ҟ": "ҟ",
    "т": "т",
    "Ы": "Ы",
    "с": "с",
    "р": "р",
    "Ѿ": "Ѿ",
    "ѧ": "ѧ",
    "Ӈ": "Ӈ",
    "Ь": "Ь",
    "ҕ": "ҕ",
    "п": "п",
    "ӡ": "ӡ",
    "о": "о",
    "Ћ": "Ћ",
    "н": "н",
    "Ҫ": "Ҫ",
    "ұ": "ұ",
    "ѱ": "ѱ",
    "з": "з",
    "ү": "ү",
    "\u030F": "\u030F",
    "ј": "ј",
    "в": "в",
    "ҹ": "ҹ",
    "ӄ": "ӄ",
    "е": "е",
    "ѡ": "ѡ",
    "д": "д",
    "ц": "ц",
    "б": "б",
    "Ө": "Ө",
    "ґ": "ґ",
    "Љ": "Љ",
    "а": "а",
    "Ѽ": "Ѽ",
    "Ғ": "Ғ",
    "Ҹ": "Ҹ",
    "м": "м",
    "л": "л",
    "ш": "ш",
    "к": "к",
    "и": "и",
    "х": "х",
    "Ҳ": "Ҳ",
    "Ѵ": "Ѵ",
    "Ӡ": "Ӡ",
    "қ": "қ",
    "г": "г",
    "Ч": "Ч",
    "ф": "ф",
    "Ї": "Ї",
    "\u0489": "\u0489",
    "Ѯ": "Ѯ",
    "Ѻ": "Ѻ",
    "ѿ": "ѿ",
    "ҵ": "ҵ",
    "ҳ": "ҳ",
    "ў": "ў",
    "ѩ": "ѩ",
    "Я": "Я",
    "љ": "љ",
    "ө": "ө",
    "Қ": "Қ",
    "ъ": "ъ",
    "ҏ": "ҏ",
    "ҁ": "ҁ",
    "Ђ": "Ђ",
    "ѭ": "ѭ",
    "\u0488": "\u0488",
    "Ӏ": "Ӏ",
    "Ҝ": "Ҝ",
    "ѻ": "ѻ",
    "ь": "ь",
    "ҿ": "ҿ",
    "җ": "җ",
    "э": "э",
    "Ѧ": "Ѧ",
    "Ҡ": "Ҡ",
    "ы": "ы",
    "Э": "Э",
    "ӈ": "ӈ",
    "ҫ": "ҫ",
    "ч": "ч",
    "ћ": "ћ",
    "Ҧ": "Ҧ",
    "Ё": "Ё",
    "Ю": "Ю",
    "Ѹ": "Ѹ",
    "ќ": "ќ",
    "ѓ": "ѓ",
    "Ќ": "Ќ",
    "Ѓ": "Ѓ"
};
exports.isCyrillicCharacter = function (x) {
    return exports.cyrillicCharacters.hasOwnProperty(x);
};
exports.translateCharToCyrillic = function (char) {
    if (exports.isCyrillicCharacter(char))
        return exports.cyrillicCharacters[char];
    else
        return undefined;
};
//# sourceMappingURL=cyrillic.js.map

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.dingbatsUnicodeChart = {
    "33": "✁",
    "34": "✂",
    "35": "✃",
    "36": "✄",
    "37": "☎",
    "38": "✆",
    "39": "✇",
    "40": "✈",
    "41": "✉",
    "42": "☛",
    "43": "☞",
    "44": "✌",
    "45": "✍",
    "46": "✎",
    "47": "✏",
    "48": "✐",
    "49": "✑",
    "50": "✒",
    "51": "✓",
    "52": "✔",
    "53": "✕",
    "54": "✖",
    "55": "✗",
    "56": "✘",
    "57": "✙",
    "58": "✚",
    "59": "✛",
    "60": "✜",
    "61": "✝",
    "62": "✞",
    "63": "✟",
    "64": "✠",
    "65": "✡",
    "66": "✢",
    "67": "✣",
    "68": "✤",
    "69": "✥",
    "70": "✦",
    "71": "✧",
    "72": "★",
    "73": "✩",
    "74": "✪",
    "75": "✫",
    "76": "✬",
    "77": "✭",
    "78": "✮",
    "79": "✯",
    "80": "✰",
    "81": "✱",
    "82": "✲",
    "83": "✳",
    "84": "✴",
    "85": "✵",
    "86": "✶",
    "87": "✷",
    "88": "✸",
    "89": "✹",
    "90": "✺",
    "91": "✻",
    "92": "✼",
    "93": "✽",
    "94": "✾",
    "95": "✿",
    "96": "❀",
    "97": "❁",
    "98": "❂",
    "99": "❃",
    "100": "❄",
    "101": "❅",
    "102": "❆",
    "103": "❇",
    "104": "❈",
    "105": "❉",
    "106": "❊",
    "107": "❋",
    "108": "●",
    "109": "❍",
    "110": "■",
    "111": "❏",
    "112": "❐",
    "113": "❑",
    "114": "❒",
    "115": "▲",
    "116": "▼",
    "117": "◆",
    "118": "❖",
    "119": "◗",
    "120": "❘",
    "121": "❙",
    "122": "❚",
    "123": "❛",
    "124": "❜",
    "125": "❝",
    "126": "❞",
    "161": "❡",
    "162": "❢",
    "163": "❣",
    "164": "❤",
    "165": "❥",
    "166": "❦",
    "167": "❧",
    "168": "♣",
    "169": "♦",
    "170": "♥",
    "171": "♠",
    "172": "①",
    "173": "②",
    "174": "③",
    "175": "④",
    "176": "⑤",
    "177": "⑥",
    "178": "⑦",
    "179": "⑧",
    "180": "⑨",
    "181": "⑩",
    "182": "❶",
    "183": "❷",
    "184": "❸",
    "185": "❹",
    "186": "❺",
    "187": "❻",
    "188": "❼",
    "189": "❽",
    "190": "❾",
    "191": "❿",
    "192": "➀",
    "193": "➁",
    "194": "➂",
    "195": "➃",
    "196": "➄",
    "197": "➅",
    "198": "➆",
    "199": "➇",
    "200": "➈",
    "201": "➉",
    "202": "➊",
    "203": "➋",
    "204": "➌",
    "205": "➍",
    "206": "➎",
    "207": "➏",
    "208": "➐",
    "209": "➑",
    "210": "➒",
    "211": "➓",
    "212": "➔",
    "213": "→",
    "214": "↔",
    "215": "↕",
    "216": "➘",
    "217": "➙",
    "218": "➚",
    "219": "➛",
    "220": "➜",
    "221": "➝",
    "222": "➞",
    "223": "➟",
    "224": "➠",
    "225": "➡",
    "226": "➢",
    "227": "➣",
    "228": "➤",
    "229": "➥",
    "230": "➦",
    "231": "➧",
    "232": "➨",
    "233": "➩",
    "234": "➪",
    "235": "➫",
    "236": "➬",
    "237": "➭",
    "238": "➮",
    "239": "➯",
    "241": "➱",
    "242": "➲",
    "243": "➳",
    "244": "➴",
    "245": "➵",
    "246": "➶",
    "247": "➷",
    "248": "➸",
    "249": "➹",
    "250": "➺",
    "251": "➻",
    "252": "➼",
    "253": "➽",
    "254": "➾"
};
function isDingbatCharacter(x) {
    return exports.dingbatsUnicodeChart.hasOwnProperty(x);
}
exports.isDingbatCharacter = isDingbatCharacter;
exports.translateCharToDingbat = function (char) { return isDingbatCharacter(char) ? exports.dingbatsUnicodeChart[char] : undefined; };
//# sourceMappingURL=dingbats.js.map

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.elsevierGlyphsUnicodeChart = {
    "2129": "℩",
    "21B3": "↳",
    "2232": "∲",
    "2233": "∳",
    "2238": "∸",
    "2242": "≂",
    "225A": "≚",
    "225F": "≟",
    "2274": "≴",
    "2275": "≵",
    "22C0": "⋀",
    "22C1": "⋁",
    "E838": "⌽",
    "E381": "▱",
    "E212": "⤅",
    "E20C": "⤣",
    "E20D": "⤤",
    "E20B": "⤥",
    "E20A": "⤦",
    "E211": "⤧",
    "E20E": "⤨",
    "E20F": "⤩",
    "E210": "⤪",
    "E21C": "⤳",
    "E21D": "⤳",
    "E21A": "⤶",
    "E219": "⤷",
    "E214": "⥼",
    "E215": "⥽",
    "E291": "⦔",
    "E260": "⦵",
    "E61B": "⦶",
    "E372": "⧜",
    "E395": "⨐",
    "E25A": "⨥",
    "E25B": "⨪",
    "E25C": "⨭",
    "E25D": "⨮",
    "E25E": "⨴",
    "E25F": "⨵",
    "E259": "⨼",
    "E36E": "⩕",
    "E30D": "⫫",
    "300A": "《",
    "300B": "》",
    "3018": "〘",
    "3019": "〙",
};
function isElsevierGlyph(x) {
    return exports.elsevierGlyphsUnicodeChart.hasOwnProperty(x);
}
exports.isElsevierGlyph = isElsevierGlyph;
exports.translateCharToElsevier = function (char) { return isElsevierGlyph(char) ? exports.elsevierGlyphsUnicodeChart[char] : undefined; };
//# sourceMappingURL=elsevier.js.map

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.spaceCmds1arg = {
    kern: true,
    hskip: true,
    hspace: true,
    hphantom: true,
};
//# sourceMappingURL=space.js.map

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.diacriticsTextMode = {
    "`": true,
    "'": true,
    "^": true,
    "~": true,
    "=": true,
    ".": true,
    '"': true,
    "H": true,
    "c": true,
    "k": true,
    "b": true,
    "d": true,
    "r": true,
    "u": true,
    "v": true,
};
exports.diacriticsMathMode = {
    "hat": true,
    "widehat": true,
    "check": true,
    "tilde": true,
    "widetilde": true,
    "acute": true,
    "grave": true,
    "dot": true,
    "ddot": true,
    "breve": true,
    "bar": true,
    "vec": true,
    "mathring": true,
};
//# sourceMappingURL=diacritic.js.map

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var superscript_1 = __webpack_require__(49);
function determineSqrtSymbol(base) {
    var trimmd = base ? base.trim() : undefined;
    if (!trimmd)
        return "√";
    switch (trimmd) {
        case "2":
            return "√";
        case "3":
            return "∛";
        case "4":
            return "∜";
        default:
            var chars = [];
            for (var i = 0; i < trimmd.length; i++) {
                var char = superscript_1.translateCharToSuperscript(trimmd.charAt(i));
                if (!char)
                    throw new Error("Could not translate \"" + char + "\" to superscript");
                chars.push(char);
            }
            return chars.join("") + "√";
    }
}
function convertSqrtToUnicode(nucleus, base) {
    var sqrt = determineSqrtSymbol(base);
    var trimmedNucleus = nucleus.trim();
    if (trimmedNucleus === "") {
        return sqrt;
    }
    else {
        return sqrt + "(" + trimmedNucleus + ")";
    }
}
exports.convertSqrtToUnicode = convertSqrtToUnicode;
//# sourceMappingURL=sqrt.js.map

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var frac_1 = __webpack_require__(136);
var binom_1 = __webpack_require__(137);
function expand2argsCommand(name, arg1, arg2) {
    switch (name) {
        case "frac":
        case "nfrac":
        case "cfrac":
        case "xfrac":
        case "sfrac":
            return frac_1.convertFracToUnicode(arg1, arg2);
        case "binom":
            return binom_1.convertBinom(arg1, arg2);
    }
    throw new Error("No implementation found to expand \\" + name + " with arguments {" + arg1 + ", " + arg2);
}
exports.expand2argsCommand = expand2argsCommand;
//# sourceMappingURL=index.js.map

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = __webpack_require__(13);
var zeroWidthNonJoiner = "\u200C";
var regExpDigit = /^[0-9]*$/;
function convertFracToUnicode(n, d) {
    if (n === "1" && d === "2")
        return "½";
    if (n === "1" && d === "3")
        return "⅓";
    if (n === "1" && d === "4")
        return "¼";
    if (n === "1" && d === "5")
        return "⅕";
    if (n === "1" && d === "6")
        return "⅙";
    if (n === "1" && d === "8")
        return "⅛";
    if (n === "2" && d === "3")
        return "⅔";
    if (n === "2" && d === "5")
        return "⅖";
    if (n === "3" && d === "4")
        return "¾";
    if (n === "3" && d === "5")
        return "⅗";
    if (n === "3" && d === "8")
        return "⅜";
    if (n === "4" && d === "5")
        return "⅘";
    if (n === "5" && d === "6")
        return "⅚";
    if (n === "5" && d === "8")
        return "⅝";
    if (n === "7" && d === "8")
        return "⅞";
    if (regExpDigit.test(n) && regExpDigit.test(d)) {
        return zeroWidthNonJoiner + n + "⁄" + d + zeroWidthNonJoiner;
    }
    n = util_1.isSingleTerm.test(n) ? n : util_1.addParenthesis(n);
    d = util_1.isSingleTerm.test(d) ? d : util_1.addParenthesis(d);
    return "(" + n + " / " + d + ")";
}
exports.convertFracToUnicode = convertFracToUnicode;
//# sourceMappingURL=frac.js.map

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = __webpack_require__(13);
var isSingleTerm = /^.$|^[0-9]+$/;
function convertBinom(n, d) {
    n = isSingleTerm.test(n) ? n : util_1.addParenthesis(n);
    d = isSingleTerm.test(d) ? d : util_1.addParenthesis(d);
    return "(" + n + " \u00A6 " + d + ")";
}
exports.convertBinom = convertBinom;
//# sourceMappingURL=binom.js.map

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var frac_1 = __webpack_require__(139);
exports.twoArgsCommands = Object.assign({}, frac_1.fracCmds, {
    "binom": true
});
function is2argsCommand(name) {
    return exports.twoArgsCommands.hasOwnProperty(name);
}
exports.is2argsCommand = is2argsCommand;
//# sourceMappingURL=index.js.map

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.fracCmds = {
    "frac": true,
    "nfrac": true,
    "cfrac": true,
    "xfrac": true,
    "sfrac": true,
};
function isFracCmd(x) {
    return exports.fracCmds.hasOwnProperty(x);
}
exports.isFracCmd = isFracCmd;
//# sourceMappingURL=frac.js.map

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function createKnownCommand(name) {
    return {
        name: name,
        optionalArguments: 0,
        argumentCount: 0
    };
}
exports.createKnownCommand = createKnownCommand;
//# sourceMappingURL=KnownCommand0Args.js.map

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function createKnownCommandWith1Arg(name) {
    return {
        name: name,
        optionalArguments: 0,
        argumentCount: 1
    };
}
exports.createKnownCommandWith1Arg = createKnownCommandWith1Arg;
//# sourceMappingURL=KnownCommand1Args.js.map

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Citations_vue_vue_type_style_index_0_lang_css__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Citations_vue_vue_type_style_index_0_lang_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Citations_vue_vue_type_style_index_0_lang_css__);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Citations_vue_vue_type_style_index_0_lang_css___default.a); 

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(26)(false);
// imports


// module
exports.push([module.i, "pre code{white-space:pre-wrap}", ""]);

// exports


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _visualization = __webpack_require__(16);

var _visualization2 = _interopRequireDefault(_visualization);

var _bigwig = __webpack_require__(145);

var bigwig = _interopRequireWildcard(_bigwig);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Data manager for BBI datasets/files, including BigWig and BigBed.
 */
var BBIDataManager = _visualization2.default.GenomeDataManager.extend({
    /**
     * Load data from server and manage data entries. Adds a Deferred to manager
     * for region; when data becomes available, replaces Deferred with data.
     * Returns the Deferred that resolves when data is available.
     */
    load_data: function load_data(region, mode, resolution, extra_params) {
        var deferred = $.Deferred();
        this.set_data(region, deferred);

        var url = Galaxy.root + "datasets/" + this.get("dataset").id + "/display";

        var self = this;
        var promise = new $.Deferred();
        $.when(bigwig.makeBwg(url)).then(function (bb, err) {
            $.when(bb.readWigData(region.get("chrom"), region.get("start"), region.get("end"))).then(function (data) {
                // Transform data into "bigwig" format for LinePainter. "bigwig" format is an array of 2-element arrays
                // where each element is [position, score]; unlike real bigwig format, no gaps are allowed.
                var result = [];

                var prev = { max: Number.MIN_VALUE };
                data.forEach(function (d) {
                    // If there is a gap between prev and d, fill it with an interval with score 0.
                    // This is necessary for LinePainter to draw correctly.
                    if (prev.max !== d.min - 1) {
                        // +1 to start after previous region.
                        result.push([prev.max + 1, 0]);
                        // -2 = -1 for converting from 1-based to 0-based coordinates,
                        //      -1 for ending before current region.
                        result.push([d.min - 2, 0]);
                    }

                    // Add data point for entry start. -1 to convert from wiggle
                    // 1-based coordinates to 0-based browser coordinates.
                    result.push([d.min - 1, d.score]);

                    // Add data point for entry end:
                    result.push([d.max, d.score]);

                    prev = d;
                });

                var entry = {
                    data: result,
                    region: region,
                    dataset_type: "bigwig"
                };

                self.set_data(region, entry);
                deferred.resolve(entry);
            });
        });

        return deferred;
    }
});

exports.default = {
    BBIDataManager: BBIDataManager
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//
// Author: Jeremy Goecks
//
// Modified from:
//
// Dalliance Genome Explorer
// (c) Thomas Down 2006-2010
//
// bigwig.js: indexed binary WIG (and BED) files
//

// Requirements:
//  * jquery and ajax-native plugin for reading binary data, jquery for promises
//  * spans for working working with genomic intervals
//  * jszlib for decompression.
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(146), __webpack_require__(147), __webpack_require__(148)], __WEBPACK_AMD_DEFINE_RESULT__ = (function(spans, jszlib) {
    "use strict";

    // -- Copied from das.js --

    function DASFeature() {
    }

    function DASGroup(id) {
        if (id)
        this.id = id;
    }

    // -- End copy --

    // -- Copied from bin.js --

    function readInt(ba, offset) {
        return (ba[offset + 3] << 24) | (ba[offset + 2] << 16) | (ba[offset + 1] << 8) | (ba[offset]);
    }

    // -- End copy --

    // Some globals.
    var Range = spans.Range;
    var union = spans.union;
    var intersection = spans.intersection;

    var jszlib_inflate_buffer = jszlib.inflateBuffer;
    var arrayCopy = jszlib.arrayCopy;

    var BIG_WIG_MAGIC = 0x888FFC26;
    var BIG_WIG_MAGIC_BE = 0x26FC8F88;
    var BIG_BED_MAGIC = 0x8789F2EB;
    var BIG_BED_MAGIC_BE = 0xEBF28987;


    var BIG_WIG_TYPE_GRAPH = 1;
    var BIG_WIG_TYPE_VSTEP = 2;
    var BIG_WIG_TYPE_FSTEP = 3;

    var M1 = 256;
    var M2 = 256*256;
    var M3 = 256*256*256;
    var M4 = 256*256*256*256;

    var BED_COLOR_REGEXP = new RegExp("^[0-9]+,[0-9]+,[0-9]+");

    /**
     * Read binary data from a URL using HTTP Range header. Requires jQuery and ajax-native plugin.
     */
    function read(url, start, size) {
        // Taken from bin.js:
        // This may be necessary for Safari:
        //   if ((isSafari || this.opts.salt) && url.indexOf('?') < 0) {
        //       url = url + '?salt=' + b64_sha1('' + Date.now() + ',' + (++seed));
        //   }

        var chunkSizeLimit = Math.pow(10, 6); // 1 MB
        if(size > chunkSizeLimit) {
            // TODO: raise error.
        }

        // Read data from remote file.
        return $.ajax({
            type: 'GET',
            dataType: 'native',
            url: url,
            // Potential timeout on first request to catch mixed-content errors on Chromium.
            timeout: 5000,
            beforeSend: function(xhrObj) {
                // (size - 1) because range is inclusive.
                xhrObj.setRequestHeader("Range", "bytes=" + start + "-" + (start + (size - 1)));
            },
            xhrFields: {
                responseType: 'arraybuffer'
            }
        });
    }

    function bwg_readOffset(ba, o) {
        var offset = ba[o] + ba[o+1]*M1 + ba[o+2]*M2 + ba[o+3]*M3 + ba[o+4]*M4;
        return offset;
    }

    function BigWig() {
    }

    /**
     * Read the chromosome B+ tree header.
     */
    BigWig.prototype.readChromTree = function() {
        var thisB = this;
        this.chromsToIDs = {};
        this.idsToChroms = {};
        this.maxID = 0;

        var udo = this.unzoomedDataOffset;
        var eb = (udo - this.chromTreeOffset) & 3;
        udo = udo + 4 - eb;

        // Read and parse the chrom tree, return the promise so that subsequent actions can be taken.
        return $.when(read(this.url, this.chromTreeOffset, udo - this.chromTreeOffset)).then(function(bpt) {
            var ba = new Uint8Array(bpt);
            var sa = new Int16Array(bpt);
            var la = new Int32Array(bpt);
            var bptMagic = la[0];
            var blockSize = la[1];
            var keySize = la[2];
            var valSize = la[3];
            var itemCount = bwg_readOffset(ba, 16);
            var rootNodeOffset = 32;

            var bptReadNode = function(offset) {
                var nodeType = ba[offset];
                var cnt = sa[(offset/2) + 1];
                offset += 4;
                for (var n = 0; n < cnt; ++n) {
                    if (nodeType === 0) {
                        offset += keySize;
                        var childOffset = bwg_readOffset(ba, offset);
                        offset += 8;
                        childOffset -= thisB.chromTreeOffset;
                        bptReadNode(childOffset);
                    } else {
                        var key = '';
                        for (var ki = 0; ki < keySize; ++ki) {
                            var charCode = ba[offset++];
                            if (charCode !== 0) {
                                key += String.fromCharCode(charCode);
                            }
                        }
                        var chromId = (ba[offset+3]<<24) | (ba[offset+2]<<16) | (ba[offset+1]<<8) | (ba[offset+0]);
                        var chromSize = (ba[offset + 7]<<24) | (ba[offset+6]<<16) | (ba[offset+5]<<8) | (ba[offset+4]);
                        offset += 8;

                        thisB.chromsToIDs[key] = chromId;
                        if (key.indexOf('chr') === 0) {
                            thisB.chromsToIDs[key.substr(3)] = chromId;
                        }
                        thisB.idsToChroms[chromId] = key;
                        thisB.maxID = Math.max(thisB.maxID, chromId);
                    }
                }
            };
            bptReadNode(rootNodeOffset);
        });
    }

    function BigWigView(bwg, cirTreeOffset, cirTreeLength, isSummary) {
        this.bwg = bwg;
        this.cirTreeOffset = cirTreeOffset;
        this.cirTreeLength = cirTreeLength;
        this.isSummary = isSummary;
    }



    BigWigView.prototype.readWigData = function(chrName, min, max) {
        var chr = this.bwg.chromsToIDs[chrName],
            rval;
        if (chr === undefined) {
            // Not an error because some .bwgs won't have data for all chromosomes.
            rval = [];
        } else {
            rval = this.readWigDataById(chr, min, max);
        }

        return rval;
    };

    BigWigView.prototype.readWigDataById = function(chr, min, max) {
        var thisB = this,
            promise = $.Deferred();

        // Read the R-tree index header and then read data again.
        if (!this.cirHeader) {
            $.when(read(thisB.bwg.url, this.cirTreeOffset, 48)).then(function(result) {
                thisB.cirHeader = result;
                var la = new Int32Array(thisB.cirHeader);
                thisB.cirBlockSize = la[1];
                $.when(thisB.readWigDataById(chr, min, max)).then(function(result) {
                    promise.resolve(result);
                });
            });
            return promise;
        }

        var blocksToFetch = [];
        var outstanding = 0;

        var beforeBWG = Date.now();

        var filter = function(chromId, fmin, fmax, toks) {
            return ((chr < 0 || chromId == chr) && fmin <= max && fmax >= min);
        };

        var cirFobRecur = function(offset, level) {
            if (thisB.bwg.instrument)
            console.log('level=' + level + '; offset=' + offset + '; time=' + (Date.now()|0));

            outstanding += offset.length;

            if (offset.length == 1 && offset[0] - thisB.cirTreeOffset == 48 && thisB.cachedCirRoot) {
                cirFobRecur2(thisB.cachedCirRoot, 0, level);
                --outstanding;
                if (outstanding === 0) {
                    $.when(thisB.fetchFeatures(filter, blocksToFetch)).then(function(result) {
                        promise.resolve(result);
                    });
                }
                return;
            }

            var maxCirBlockSpan = 4 +  (thisB.cirBlockSize * 32);   // Upper bound on size, based on a completely full leaf node.
            var spans;
            for (var i = 0; i < offset.length; ++i) {
                var blockSpan = new Range(offset[i], offset[i] + maxCirBlockSpan);
                spans = spans ? union(spans, blockSpan) : blockSpan;
            }

            var fetchRanges = spans.ranges();
            for (var r = 0; r < fetchRanges.length; ++r) {
                var fr = fetchRanges[r];
                cirFobStartFetch(offset, fr, level);
            }
        };

        var cirFobStartFetch = function(offset, fr, level, attempts) {
            var length = fr.max() - fr.min();
            $.when(read(thisB.bwg.url, fr.min(), fr.max() - fr.min())).then(function(resultBuffer) {
                for (var i = 0; i < offset.length; ++i) {
                    if (fr.contains(offset[i])) {
                        cirFobRecur2(resultBuffer, offset[i] - fr.min(), level);

                        if (offset[i] - thisB.cirTreeOffset == 48 && offset[i] - fr.min() === 0)
                            thisB.cachedCirRoot = resultBuffer;

                        --outstanding;
                        if (outstanding === 0) {
                            $.when(thisB.fetchFeatures(filter, blocksToFetch)).then(function(result) {
                                promise.resolve(result);
                            });
                        }
                    }
                }
            });
        };

        var cirFobRecur2 = function(cirBlockData, offset, level) {
            var ba = new Uint8Array(cirBlockData);
            var sa = new Int16Array(cirBlockData);
            var la = new Int32Array(cirBlockData);

            var isLeaf = ba[offset];
            var cnt = sa[offset/2 + 1];
            offset += 4;

            if (isLeaf !== 0) {
                for (var i = 0; i < cnt; ++i) {
                    var lo = offset/4;
                    var startChrom = la[lo];
                    var startBase = la[lo + 1];
                    var endChrom = la[lo + 2];
                    var endBase = la[lo + 3];
                    var blockOffset = bwg_readOffset(ba, offset+16);
                    var blockSize = bwg_readOffset(ba, offset+24);
                    if (((chr < 0 || startChrom < chr) || (startChrom == chr && startBase <= max)) &&
                    ((chr < 0 || endChrom   > chr) || (endChrom == chr && endBase >= min)))
                    {
                        blocksToFetch.push({offset: blockOffset, size: blockSize});
                    }
                    offset += 32;
                }
            } else {
                var recurOffsets = [];
                for (var i = 0; i < cnt; ++i) {
                    var lo = offset/4;
                    var startChrom = la[lo];
                    var startBase = la[lo + 1];
                    var endChrom = la[lo + 2];
                    var endBase = la[lo + 3];
                    var blockOffset = bwg_readOffset(ba, offset+16);
                    if ((chr < 0 || startChrom < chr || (startChrom == chr && startBase <= max)) &&
                    (chr < 0 || endChrom   > chr || (endChrom == chr && endBase >= min)))
                    {
                        recurOffsets.push(blockOffset);
                    }
                    offset += 24;
                }
                if (recurOffsets.length > 0) {
                    cirFobRecur(recurOffsets, level + 1);
                }
            }
        };

        cirFobRecur([thisB.cirTreeOffset + 48], 1);
        return promise;
    };

    /**
     * Fetch data for a set of blocks. Returns a promise that resolves to fetched data.
     */
    BigWigView.prototype.fetchFeatures = function(filter, blocksToFetch) {
        var thisB = this,
            promise = $.Deferred();

        blocksToFetch.sort(function(b0, b1) {
            return (b0.offset|0) - (b1.offset|0);
        });

        if (blocksToFetch.length === 0) {
            return [];
        } else {
            var features = [];
            var createFeature = function(chr, fmin, fmax, opts) {
                if (!opts) {
                    opts = {};
                }

                var f = new DASFeature();
                f._chromId = chr;
                f.segment = thisB.bwg.idsToChroms[chr];
                f.min = fmin;
                f.max = fmax;
                f.type = thisB.bwg.type;

                for (var k in opts) {
                    f[k] = opts[k];
                }

                features.push(f);
            };

            // Recursive function to read blocks of data.
            var tramp = function() {
                if (blocksToFetch.length === 0) {
                    var afterBWG = Date.now();
                    // dlog('BWG fetch took ' + (afterBWG - beforeBWG) + 'ms');
                    return promise.resolve(features);
                }
                else {
                    var block = blocksToFetch[0];
                    if (block.data) {
                        thisB.parseFeatures(block.data, createFeature, filter);
                        blocksToFetch.splice(0, 1);
                        tramp();
                    }
                    else {
                        var fetchStart = block.offset;
                        var fetchSize = block.size;
                        var bi = 1;
                        while (bi < blocksToFetch.length && blocksToFetch[bi].offset == (fetchStart + fetchSize)) {
                            fetchSize += blocksToFetch[bi].size;
                            ++bi;
                        }

                        $.when(read(thisB.bwg.url, fetchStart, fetchSize)).then(function(result) {
                            var offset = 0;
                            var bi = 0;
                            while (offset < fetchSize) {
                                var fb = blocksToFetch[bi];

                                var data;
                                if (thisB.bwg.uncompressBufSize > 0) {
                                    data = jszlib_inflate_buffer(result, offset + 2, fb.size - 2);
                                } else {
                                    var tmp = new Uint8Array(fb.size);    // FIXME is this really the best we can do?
                                    arrayCopy(new Uint8Array(result, offset, fb.size), 0, tmp, 0, fb.size);
                                    data = tmp.buffer;
                                }
                                fb.data = data;

                                offset += fb.size;
                                ++bi;
                            }
                            tramp();
                        });
                    }
                }
            };
            tramp();
        }

        return promise;
    };

    BigWigView.prototype.parseFeatures = function(data, createFeature, filter) {
        var ba = new Uint8Array(data);

        if (this.isSummary) {
            var sa = new Int16Array(data);
            var la = new Int32Array(data);
            var fa = new Float32Array(data);

            var itemCount = data.byteLength/32;
            for (var i = 0; i < itemCount; ++i) {
                var chromId =   la[(i*8)];
                var start =     la[(i*8)+1];
                var end =       la[(i*8)+2];
                var validCnt =  la[(i*8)+3];
                var minVal    = fa[(i*8)+4];
                var maxVal    = fa[(i*8)+5];
                var sumData   = fa[(i*8)+6];
                var sumSqData = fa[(i*8)+7];

                if (filter(chromId, start + 1, end)) {
                    var summaryOpts = {type: 'bigwig', score: sumData/validCnt, maxScore: maxVal};
                    if (this.bwg.type == 'bigbed') {
                        summaryOpts.type = 'density';
                    }
                    createFeature(chromId, start + 1, end, summaryOpts);
                }
            }
        }
        else if (this.bwg.type == 'bigwig') {
            var sa = new Int16Array(data);
            var la = new Int32Array(data);
            var fa = new Float32Array(data);

            var chromId = la[0];
            var blockStart = la[1];
            var blockEnd = la[2];
            var itemStep = la[3];
            var itemSpan = la[4];
            var blockType = ba[20];
            var itemCount = sa[11];

            if (blockType == BIG_WIG_TYPE_FSTEP) {
                for (var i = 0; i < itemCount; ++i) {
                    var score = fa[i + 6];
                    var fmin = blockStart + (i*itemStep) + 1, fmax = blockStart + (i*itemStep) + itemSpan;
                    if (filter(chromId, fmin, fmax))
                    createFeature(chromId, fmin, fmax, {score: score});
                }
            } else if (blockType == BIG_WIG_TYPE_VSTEP) {
                for (var i = 0; i < itemCount; ++i) {
                    var start = la[(i*2) + 6] + 1;
                    var end = start + itemSpan - 1;
                    var score = fa[(i*2) + 7];
                    if (filter(chromId, start, end))
                    createFeature(chromId, start, end, {score: score});
                }
            } else if (blockType == BIG_WIG_TYPE_GRAPH) {
                for (var i = 0; i < itemCount; ++i) {
                    var start = la[(i*3) + 6] + 1;
                    var end   = la[(i*3) + 7];
                    var score = fa[(i*3) + 8];
                    if (start > end) {
                        start = end;
                    }
                    if (filter(chromId, start, end))
                    createFeature(chromId, start, end, {score: score});
                }
            } else {
                console.log('Currently not handling bwgType=' + blockType);
            }
        } else if (this.bwg.type == 'bigbed') {
            var offset = 0;
            var dfc = this.bwg.definedFieldCount;
            var schema = this.bwg.schema;

            while (offset < ba.length) {
                var chromId = (ba[offset+3]<<24) | (ba[offset+2]<<16) | (ba[offset+1]<<8) | (ba[offset+0]);
                var start = (ba[offset+7]<<24) | (ba[offset+6]<<16) | (ba[offset+5]<<8) | (ba[offset+4]);
                var end = (ba[offset+11]<<24) | (ba[offset+10]<<16) | (ba[offset+9]<<8) | (ba[offset+8]);
                offset += 12;
                var rest = '';
                while (true) {
                    var ch = ba[offset++];
                    if (ch != 0) {
                        rest += String.fromCharCode(ch);
                    } else {
                        break;
                    }
                }

                var featureOpts = {};

                var bedColumns;
                if (rest.length > 0) {
                    bedColumns = rest.split('\t');
                } else {
                    bedColumns = [];
                }
                if (bedColumns.length > 0 && dfc > 3) {
                    featureOpts.label = bedColumns[0];
                }
                if (bedColumns.length > 1 && dfc > 4) {
                    var score = parseInt(bedColumns[1]);
                    if (!isNaN(score))
                    featureOpts.score = score;
                }
                if (bedColumns.length > 2 && dfc > 5) {
                    featureOpts.orientation = bedColumns[2];
                }
                if (bedColumns.length > 5 && dfc > 8) {
                    var color = bedColumns[5];
                    if (BED_COLOR_REGEXP.test(color)) {
                        featureOpts.itemRgb = 'rgb(' + color + ')';
                    }
                }

                if (bedColumns.length > dfc-3 && schema) {
                    for (var col = dfc - 3; col < bedColumns.length; ++col) {
                        featureOpts[schema.fields[col+3].name] = bedColumns[col];
                    }
                }

                if (filter(chromId, start + 1, end, bedColumns)) {
                    if (dfc < 12) {
                        createFeature(chromId, start + 1, end, featureOpts);
                    } else {
                        // TODO: add block starts, sizes, thick start, thick end to feature.
                        var thickStart = bedColumns[3]|0;
                        var thickEnd   = bedColumns[4]|0;
                        var blockCount = bedColumns[6]|0;
                        var blockSizes = bedColumns[7].split(',');
                        var blockStarts = bedColumns[8].split(',');

                        if (featureOpts.exonFrames) {
                            var exonFrames = featureOpts.exonFrames.split(',');
                            featureOpts.exonFrames = undefined;
                        }

                        featureOpts.type = 'transcript'
                        var grp = new DASGroup();
                        for (var k in featureOpts) {
                            grp[k] = featureOpts[k];
                        }
                        grp.id = bedColumns[0];
                        grp.segment = this.bwg.idsToChroms[chromId];
                        grp.min = start + 1;
                        grp.max = end;
                        grp.notes = [];
                        featureOpts.groups = [grp];

                        // Moving towards using bigGenePred model, but will
                        // still support old Dalliance-style BED12+gene-name for the
                        // foreseeable future.
                        if (bedColumns.length > 9) {
                            var geneId = featureOpts.geneName || bedColumns[9];
                            var geneName = geneId;
                            if (bedColumns.length > 10) {
                                geneName = bedColumns[10];
                            }
                            if (featureOpts.geneName2)
                            geneName = featureOpts.geneName2;

                            var gg = $.extend({}, grp);
                            gg.id = geneId;
                            gg.label = geneName;
                            gg.type = 'gene';
                            featureOpts.groups.push(gg);
                        }

                        var spanList = [];
                        for (var b = 0; b < blockCount; ++b) {
                            var bmin = (blockStarts[b]|0) + start;
                            var bmax = bmin + (blockSizes[b]|0);
                            var span = new Range(bmin, bmax);
                            spanList.push(span);
                        }
                        var spans = union(spanList);

                        var tsList = spans.ranges();
                        for (var s = 0; s < tsList.length; ++s) {
                            var ts = tsList[s];
                            createFeature(chromId, ts.min() + 1, ts.max(), featureOpts);
                        }

                        if (thickEnd > thickStart) {
                            var codingRegion = (featureOpts.orientation == '+') ?
                            new Range(thickStart, thickEnd + 3) :
                            new Range(thickStart - 3, thickEnd);
                            // +/- 3 to account for stop codon

                            var tl = intersection(spans, codingRegion);
                            if (tl) {
                                featureOpts.type = 'translation';
                                var tlList = tl.ranges();
                                var readingFrame = 0;

                                var tlOffset = 0;
                                while (tlList[0].min() > tsList[tlOffset].max())
                                tlOffset++;

                                for (var s = 0; s < tlList.length; ++s) {
                                    // Record reading frame for every exon
                                    var index = s;
                                    if (featureOpts.orientation == '-')
                                    index = tlList.length - s - 1;
                                    var ts = tlList[index];
                                    featureOpts.readframe = readingFrame;
                                    if (exonFrames) {
                                        var brf = parseInt(exonFrames[index + tlOffset]);
                                        if (typeof(brf) === 'number' && brf >= 0 && brf <= 2) {
                                            featureOpts.readframe = brf;
                                            featureOpts.readframeExplicit = true;
                                        }
                                    }
                                    var length = ts.max() - ts.min();
                                    readingFrame = (readingFrame + length) % 3;
                                    createFeature(chromId, ts.min() + 1, ts.max(), featureOpts);
                                }
                            }
                        }
                    }
                }
            }
        } else {
            throw Error("Don't know what to do with " + this.bwg.type);
        }
    }

    //
    // nasty cut/paste, should roll back in!
    //

    BigWigView.prototype.getFirstAdjacent = function(chrName, pos, dir, callback) {
        var chr = this.bwg.chromsToIDs[chrName];
        if (chr === undefined) {
            // Not an error because some .bwgs won't have data for all chromosomes.
            return callback([]);
        } else {
            this.getFirstAdjacentById(chr, pos, dir, callback);
        }
    }

    BigWigView.prototype.getFirstAdjacentById = function(chr, pos, dir, callback) {
        var thisB = this;
        if (!this.cirHeader) {
            this.bwg.data.slice(this.cirTreeOffset, 48).fetch(function(result) {
                thisB.cirHeader = result;
                var la = new Int32Array(thisB.cirHeader);
                thisB.cirBlockSize = la[1];
                thisB.getFirstAdjacentById(chr, pos, dir, callback);
            });
            return;
        }

        var blockToFetch = null;
        var bestBlockChr = -1;
        var bestBlockOffset = -1;

        var outstanding = 0;

        var beforeBWG = Date.now();

        var cirFobRecur = function(offset, level) {
            outstanding += offset.length;

            var maxCirBlockSpan = 4 +  (thisB.cirBlockSize * 32);   // Upper bound on size, based on a completely full leaf node.
            var spans;
            for (var i = 0; i < offset.length; ++i) {
                var blockSpan = new Range(offset[i], offset[i] + maxCirBlockSpan);
                spans = spans ? union(spans, blockSpan) : blockSpan;
            }

            var fetchRanges = spans.ranges();
            for (var r = 0; r < fetchRanges.length; ++r) {
                var fr = fetchRanges[r];
                cirFobStartFetch(offset, fr, level);
            }
        }

        var cirFobStartFetch = function(offset, fr, level, attempts) {
            var length = fr.max() - fr.min();
            thisB.bwg.data.slice(fr.min(), fr.max() - fr.min()).fetch(function(resultBuffer) {
                for (var i = 0; i < offset.length; ++i) {
                    if (fr.contains(offset[i])) {
                        cirFobRecur2(resultBuffer, offset[i] - fr.min(), level);
                        --outstanding;
                        if (outstanding == 0) {
                            if (!blockToFetch) {
                                if (dir > 0 && (chr != 0 || pos > 0)) {
                                    return thisB.getFirstAdjacentById(0, 0, dir, callback);
                                } else if (dir < 0 && (chr != thisB.bwg.maxID || pos < 1000000000)) {
                                    return thisB.getFirstAdjacentById(thisB.bwg.maxID, 1000000000, dir, callback);
                                }
                                return callback([]);
                            }

                            thisB.fetchFeatures(function(chrx, fmin, fmax, toks) {
                                return (dir < 0 && (chrx < chr || fmax < pos)) || (dir > 0 && (chrx > chr || fmin > pos));
                            }, [blockToFetch], function(features) {
                                var bestFeature = null;
                                var bestChr = -1;
                                var bestPos = -1;
                                for (var fi = 0; fi < features.length; ++fi) {
                                    var f = features[fi];
                                    var chrx = f._chromId, fmin = f.min, fmax = f.max;
                                    if (bestFeature == null || ((dir < 0) && (chrx > bestChr || fmax > bestPos)) || ((dir > 0) && (chrx < bestChr || fmin < bestPos))) {
                                        bestFeature = f;
                                        bestPos = (dir < 0) ? fmax : fmin;
                                        bestChr = chrx;
                                    }
                                }

                                if (bestFeature != null)
                                return callback([bestFeature]);
                                else
                                return callback([]);
                            });
                        }
                    }
                }
            });
        }

        var cirFobRecur2 = function(cirBlockData, offset, level) {
            var ba = new Uint8Array(cirBlockData);
            var sa = new Int16Array(cirBlockData);
            var la = new Int32Array(cirBlockData);

            var isLeaf = ba[offset];
            var cnt = sa[offset/2 + 1];
            offset += 4;

            if (isLeaf != 0) {
                for (var i = 0; i < cnt; ++i) {
                    var lo = offset/4;
                    var startChrom = la[lo];
                    var startBase = la[lo + 1];
                    var endChrom = la[lo + 2];
                    var endBase = la[lo + 3];
                    var blockOffset = bwg_readOffset(ba, offset+16);
                    var blockSize = bwg_readOffset(ba, offset+24);
                    if ((dir < 0 && ((startChrom < chr || (startChrom == chr && startBase <= pos)))) ||
                    (dir > 0 && ((endChrom > chr || (endChrom == chr && endBase >= pos)))))
                    {
                        // console.log('Got an interesting block: startBase=' + startChrom + ':' + startBase + '; endBase=' + endChrom + ':' + endBase + '; offset=' + blockOffset + '; size=' + blockSize);
                        if (/_random/.exec(thisB.bwg.idsToChroms[startChrom])) {
                            // dlog('skipping random: ' + thisB.bwg.idsToChroms[startChrom]);
                        } else if (blockToFetch == null || ((dir < 0) && (endChrom > bestBlockChr || (endChrom == bestBlockChr && endBase > bestBlockOffset)) ||
                        (dir > 0) && (startChrom < bestBlockChr || (startChrom == bestBlockChr && startBase < bestBlockOffset))))
                        {
                            //                        dlog('best is: startBase=' + startChrom + ':' + startBase + '; endBase=' + endChrom + ':' + endBase + '; offset=' + blockOffset + '; size=' + blockSize);
                            blockToFetch = {offset: blockOffset, size: blockSize};
                            bestBlockOffset = (dir < 0) ? endBase : startBase;
                            bestBlockChr = (dir < 0) ? endChrom : startChrom;
                        }
                    }
                    offset += 32;
                }
            } else {
                var bestRecur = -1;
                var bestPos = -1;
                var bestChr = -1;
                for (var i = 0; i < cnt; ++i) {
                    var lo = offset/4;
                    var startChrom = la[lo];
                    var startBase = la[lo + 1];
                    var endChrom = la[lo + 2];
                    var endBase = la[lo + 3];
                    var blockOffset = (la[lo + 4]<<32) | (la[lo + 5]);
                    if ((dir < 0 && ((startChrom < chr || (startChrom == chr && startBase <= pos)) &&
                    (endChrom   >= chr))) ||
                    (dir > 0 && ((endChrom > chr || (endChrom == chr && endBase >= pos)) &&
                    (startChrom <= chr))))
                    {
                        if (bestRecur < 0 || endBase > bestPos) {
                            bestRecur = blockOffset;
                            bestPos = (dir < 0) ? endBase : startBase;
                            bestChr = (dir < 0) ? endChrom : startChrom;
                        }
                    }
                    offset += 24;
                }
                if (bestRecur >= 0) {
                    cirFobRecur([bestRecur], level + 1);
                }
            }
        };


        cirFobRecur([thisB.cirTreeOffset + 48], 1);
    }

    /**
    * Automatically choose a zoom level and return data from that level.
    */
    BigWig.prototype.readWigData = function(chrName, min, max) {
        // Maximum number of data points to return when reading a bigwig. This is used
        // to choose the appropriate level. One data point ~= 25-65 bytes.
        // FIXME: For targeted sequencing, data points returned is going to be much lower,
        // so this will need to be tuned appropriately.
        var MAX_DATA_POINTS = 25000;

        var range = max - min,
        view;
        // If no zooming needed or available (common in bigbed), use unzoomed view.
        if (range <= MAX_DATA_POINTS || this.zoomLevels.length === 0) {
            view = this.getUnzoomedView();
        }
        else {
            // Find reasonable zoom level. Reduction is the # of bases represented
            // by each data point at that level.
            for (var i = 0; i < this.zoomLevels.length; i++) {
                if (range/this.zoomLevels[i].reduction < MAX_DATA_POINTS) {
                    view = this.getZoomedView(i);
                    break;
                }
            }
        }

        return view.readWigData(chrName, min, max);
    }

    BigWig.prototype.getUnzoomedView = function() {
        if (!this.unzoomedView) {
            var cirLen = 4000;
            var nzl = this.zoomLevels[0];
            if (nzl) {
                cirLen = this.zoomLevels[0].dataOffset - this.unzoomedIndexOffset;
            }
            this.unzoomedView = new BigWigView(this, this.unzoomedIndexOffset, cirLen, false);
        }
        return this.unzoomedView;
    }

    BigWig.prototype.getZoomedView = function(z) {
        var zh = this.zoomLevels[z];
        if (!zh.view) {
            zh.view = new BigWigView(this, zh.indexOffset, /* this.zoomLevels[z + 1].dataOffset - zh.indexOffset */ 4000, true);
        }
        return zh.view;
    }

    /**
     * Create a BigWig object using a URL to a bigwig/bigbed file. Returns a promise
     * that resolves to the object when it's available.
     */
    function makeBwg(url) {
        var promise = $.Deferred(),
        bwg = new BigWig();
        bwg.url = url;

        // Read and parse bigwig header, including chrom tree.
        $.when(read(bwg.url, 0, 512)).then(function(result) {
            if (!result) {
                return promise.resolve(null, "Couldn't fetch file");
            }

            var header = result;
            var ba = new Uint8Array(header);
            var sa = new Int16Array(header);
            var la = new Int32Array(header);
            var magic = ba[0] + (M1 * ba[1]) + (M2 * ba[2]) + (M3 * ba[3]);
            if (magic == BIG_WIG_MAGIC) {
                bwg.type = 'bigwig';
            } else if (magic == BIG_BED_MAGIC) {
                bwg.type = 'bigbed';
            } else if (magic == BIG_WIG_MAGIC_BE || magic == BIG_BED_MAGIC_BE) {
                return promise.resolve(null, "Currently don't support big-endian BBI files");

            } else {
                return promise.resolve(null, "Not a supported format, magic=0x" + magic.toString(16));

            }

            bwg.version = sa[2];             // 4
            bwg.numZoomLevels = sa[3];       // 6
            bwg.chromTreeOffset = bwg_readOffset(ba, 8);
            bwg.unzoomedDataOffset = bwg_readOffset(ba, 16);
            bwg.unzoomedIndexOffset = bwg_readOffset(ba, 24);
            bwg.fieldCount = sa[16];         // 32
            bwg.definedFieldCount = sa[17];  // 34
            bwg.asOffset = bwg_readOffset(ba, 36);
            bwg.totalSummaryOffset = bwg_readOffset(ba, 44);
            bwg.uncompressBufSize = la[13];  // 52
            bwg.extHeaderOffset = bwg_readOffset(ba, 56);

            bwg.zoomLevels = [];
            for (var zl = 0; zl < bwg.numZoomLevels; ++zl) {
                var zlReduction = la[zl*6 + 16]
                var zlData = bwg_readOffset(ba, zl*24 + 72);
                var zlIndex = bwg_readOffset(ba, zl*24 + 80);
                bwg.zoomLevels.push({reduction: zlReduction, dataOffset: zlData, indexOffset: zlIndex});
            }

            $.when(bwg.readChromTree()).then(function() {
                bwg.getAutoSQL(function(as) {
                    bwg.schema = as;
                    return promise.resolve(bwg);
                });
            });
        });

        return promise;
    }


    BigWig.prototype._tsFetch = function(zoom, chr, min, max, callback) {
        var bwg = this;
        if (zoom >= this.zoomLevels.length - 1) {
            if (!this.topLevelReductionCache) {
                this.getZoomedView(this.zoomLevels.length - 1).readWigDataById(-1, 0, 300000000, function(feats) {
                    bwg.topLevelReductionCache = feats;
                    return bwg._tsFetch(zoom, chr, min, max, callback);
                });
            } else {
                var f = [];
                var c = this.topLevelReductionCache;
                for (var fi = 0; fi < c.length; ++fi) {
                    if (c[fi]._chromId == chr) {
                        f.push(c[fi]);
                    }
                }
                return callback(f);
            }
        } else {
            var view;
            if (zoom < 0) {
                view = this.getUnzoomedView();
            } else {
                view = this.getZoomedView(zoom);
            }
            return view.readWigDataById(chr, min, max, callback);
        }
    }

    BigWig.prototype.thresholdSearch = function(chrName, referencePoint, dir, threshold, callback) {
        dir = (dir<0) ? -1 : 1;
        var bwg = this;
        var initialChr = this.chromsToIDs[chrName];
        var candidates = [{chrOrd: 0, chr: initialChr, zoom: bwg.zoomLevels.length - 4, min: 0, max: 300000000, fromRef: true}]
        for (var i = 1; i <= this.maxID + 1; ++i) {
            var chrId = (initialChr + (dir*i)) % (this.maxID + 1);
            if (chrId < 0)
            chrId += (this.maxID + 1);
            candidates.push({chrOrd: i, chr: chrId, zoom: bwg.zoomLevels.length - 1, min: 0, max: 300000000})
        }

        function fbThresholdSearchRecur() {
            if (candidates.length == 0) {
                return callback(null);
            }
            candidates.sort(function(c1, c2) {
                var d = c1.zoom - c2.zoom;
                if (d != 0)
                return d;

                d = c1.chrOrd - c2.chrOrd;
                if (d != 0)
                return d;
                else
                return c1.min - c2.min * dir;
            });

            var candidate = candidates.splice(0, 1)[0];
            bwg._tsFetch(candidate.zoom, candidate.chr, candidate.min, candidate.max, function(feats) {
                var rp = dir > 0 ? 0 : 300000000;
                if (candidate.fromRef)
                rp = referencePoint;

                for (var fi = 0; fi < feats.length; ++fi) {
                    var f = feats[fi];
                    var score;
                    if (f.maxScore != undefined)
                    score = f.maxScore;
                    else
                    score = f.score;

                    if (dir > 0) {
                        if (score > threshold) {
                            if (candidate.zoom < 0) {
                                if (f.min > rp)
                                return callback(f);
                            } else if (f.max > rp) {
                                candidates.push({chr: candidate.chr, chrOrd: candidate.chrOrd, zoom: candidate.zoom - 2, min: f.min, max: f.max, fromRef: candidate.fromRef});
                            }
                        }
                    } else {
                        if (score > threshold) {
                            if (candidate.zoom < 0) {
                                if (f.max < rp)
                                return callback(f);
                            } else if (f.min < rp) {
                                candidates.push({chr: candidate.chr, chrOrd: candidate.chrOrd, zoom: candidate.zoom - 2, min: f.min, max: f.max, fromRef: candidate.fromRef});
                            }
                        }
                    }
                }
                fbThresholdSearchRecur();
            });
        }

        fbThresholdSearchRecur();
    }

    BigWig.prototype.getAutoSQL = function(callback) {
        var thisB = this;
        if (!this.asOffset)
        return callback(null);

        $.when(read(this.url, this.asOffset, 2048)).then(function(result) {
            var ba = new Uint8Array(result);
            var s = '';
            for (var i = 0; i < ba.length; ++i) {
                if (ba[i] == 0)
                break;
                s += String.fromCharCode(ba[i]);
            }

            /*
            * Quick'n'dirty attempt to parse autoSql format.
            * See: http://www.linuxjournal.com/files/linuxjournal.com/linuxjournal/articles/059/5949/5949l2.html
            */

            var header_re = /(\w+)\s+(\w+)\s+("([^"]+)")?\s+\(\s*/;
                var field_re = /([\w\[\]]+)\s+(\w+)\s*;\s*("([^"]+)")?\s*/g;

            var headerMatch = header_re.exec(s);
            if (headerMatch) {
                var as = {
                    declType: headerMatch[1],
                    name: headerMatch[2],
                    comment: headerMatch[4],

                    fields: []
                };

                s = s.substring(headerMatch[0]);
                for (var m = field_re.exec(s); m != null; m = field_re.exec(s)) {
                    as.fields.push({type: m[1],
                        name: m[2],
                        comment: m[4]});
                    }

                    return callback(as);
                }
        });
    };

    BigWig.prototype.getExtraIndices = function(callback) {
        var thisB = this;
        if (this.version < 4 || this.extHeaderOffset == 0 || this.type != 'bigbed') {
            return callback(null);
        } else {
            this.data.slice(this.extHeaderOffset, 64).fetch(function(result) {
                if (!result) {
                    return callback(null, "Couldn't fetch extension header");
                }

                var ba = new Uint8Array(result);
                var sa = new Int16Array(result);
                var la = new Int32Array(result);

                var extHeaderSize = sa[0];
                var extraIndexCount = sa[1];
                var extraIndexListOffset = bwg_readOffset(ba, 4);

                if (extraIndexCount == 0) {
                    return callback(null);
                }

                // FIXME 20byte records only make sense for single-field indices.
                // Right now, these seem to be the only things around, but the format
                // is actually more general.
                thisB.data.slice(extraIndexListOffset, extraIndexCount * 20).fetch(function(eil) {
                    if (!eil) {
                        return callback(null, "Couldn't fetch index info");
                    }

                    var ba = new Uint8Array(eil);
                    var sa = new Int16Array(eil);
                    var la = new Int32Array(eil);

                    var indices = [];
                    for (var ii = 0; ii < extraIndexCount; ++ii) {
                        var eiType = sa[ii*10];
                        var eiFieldCount = sa[ii*10 + 1];
                        var eiOffset = bwg_readOffset(ba, ii*20 + 4);
                        var eiField = sa[ii*10 + 8]
                        var index = new BBIExtraIndex(thisB, eiType, eiFieldCount, eiOffset, eiField);
                        indices.push(index);
                    }
                    callback(indices);
                });
            });
        }
    }

    function BBIExtraIndex(bbi, type, fieldCount, offset, field) {
        this.bbi = bbi;
        this.type = type;
        this.fieldCount = fieldCount;
        this.offset = offset;
        this.field = field;
    }

    BBIExtraIndex.prototype.lookup = function(name, callback) {
        var thisB = this;

        this.bbi.data.slice(this.offset, 32).fetch(function(bpt) {
            var ba = new Uint8Array(bpt);
            var sa = new Int16Array(bpt);
            var la = new Int32Array(bpt);
            var bptMagic = la[0];
            var blockSize = la[1];
            var keySize = la[2];
            var valSize = la[3];
            var itemCount = bwg_readOffset(ba, 16);
            var rootNodeOffset = 32;

            function bptReadNode(nodeOffset) {
                thisB.bbi.data.slice(nodeOffset, 4 + (blockSize * (keySize + valSize))).fetch(function(node) {
                    var ba = new Uint8Array(node);
                    var sa = new Uint16Array(node);
                    var la = new Uint32Array(node);

                    var nodeType = ba[0];
                    var cnt = sa[1];

                    var offset = 4;
                    if (nodeType == 0) {
                        var lastChildOffset = null;
                        for (var n = 0; n < cnt; ++n) {
                            var key = '';
                            for (var ki = 0; ki < keySize; ++ki) {
                                var charCode = ba[offset++];
                                if (charCode != 0) {
                                    key += String.fromCharCode(charCode);
                                }
                            }

                            var childOffset = bwg_readOffset(ba, offset);
                            offset += 8;

                            if (name.localeCompare(key) < 0 && lastChildOffset) {
                                bptReadNode(lastChildOffset);
                                return;
                            }
                            lastChildOffset = childOffset;
                        }
                        bptReadNode(lastChildOffset);
                    } else {
                        for (var n = 0; n < cnt; ++n) {
                            var key = '';
                            for (var ki = 0; ki < keySize; ++ki) {
                                var charCode = ba[offset++];
                                if (charCode != 0) {
                                    key += String.fromCharCode(charCode);
                                }
                            }

                            // Specific for EI case.
                            if (key == name) {
                                var start = bwg_readOffset(ba, offset);
                                var length = readInt(ba, offset + 8);

                                return thisB.bbi.getUnzoomedView().fetchFeatures(
                                    function(chr, min, max, toks) {
                                        if (toks && toks.length > thisB.field - 3)
                                        return toks[thisB.field - 3] == name;
                                    },
                                    [{offset: start, size: length}],
                                    callback);
                                }
                                offset += valSize;
                            }
                            return callback([]);
                        }
                    });
                }

                bptReadNode(thisB.offset + rootNodeOffset);
        });
    }

    return {
        makeBwg: makeBwg
    };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* -*- mode: javascript; c-basic-offset: 4; indent-tabs-mode: nil -*- */

//
// Dalliance Genome Explorer
// (c) Thomas Down 2006-2010
//
// spans.js: JavaScript Intset/Location port.
//

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {

"use strict";


function Range(min, max)
{
    if (typeof(min) != 'number' || typeof(max) != 'number')
        throw 'Bad range ' + min + ',' + max;
    this._min = min;
    this._max = max;
}

Range.prototype.min = function() {
    return this._min;
}

Range.prototype.max = function() {
    return this._max;
}

Range.prototype.contains = function(pos) {
    return pos >= this._min && pos <= this._max;
}

Range.prototype.isContiguous = function() {
    return true;
}

Range.prototype.ranges = function() {
    return [this];
}

Range.prototype._pushRanges = function(ranges) {
    ranges.push(this);
}

Range.prototype.toString = function() {
    return '[' + this._min + '-' + this._max + ']';
}

function _Compound(ranges) {
    // given: a set of unsorted possibly overlapping ranges
    // sort the input ranges
    var sorted = ranges.sort(_rangeOrder);
    // merge overlaps between adjacent ranges
    var merged = [];
    var current = sorted.shift();
    sorted.forEach(function(range) {
        if (range._min <= current._max) {
            if (range._max > current._max) {
                current._max = range._max;
            }
        }
        else {
            merged.push(current);
            current = range;
        }
    });
    merged.push(current);
    this._ranges = merged;
}

_Compound.prototype.min = function() {
    return this._ranges[0].min();
}

_Compound.prototype.max = function() {
    return this._ranges[this._ranges.length - 1].max();
}

// returns the index of the first range that is not less than pos
_Compound.prototype.lower_bound = function(pos) {
    // first check if pos is out of range
    var r = this.ranges();
    if (pos > this.max()) return r.length;
    if (pos < this.min()) return 0;
    // do a binary search
    var a=0, b=r.length - 1;
    while (a <= b) {
        var m = Math.floor((a+b)/2);
        if (pos > r[m]._max) {
            a = m+1;
        }
        else if (pos < r[m]._min) {
            b = m-1;
        }
        else {
            return m;
        }
    }
    return a;
}

_Compound.prototype.contains = function(pos) {
    var lb = this.lower_bound(pos);
    if (lb < this._ranges.length && this._ranges[lb].contains(pos)) {
        return true;
    }
    return false;
}

_Compound.prototype.insertRange = function(range) {
    var lb = this.lower_bound(range._min);
    if (lb === this._ranges.length) { // range follows this
        this._ranges.push(range);
        return;
    }

    var r = this.ranges();
    if (range._max < r[lb]._min) { // range preceeds lb
        this._ranges.splice(lb,0,range);
        return;
    }

    // range overlaps lb (at least)
    if (r[lb]._min < range._min) range._min = r[lb]._min;
    var ub = lb+1;
    while (ub < r.length && r[ub]._min <= range._max) {
        ub++;
    }
    ub--;
    // ub is the upper bound of the new range
    if (r[ub]._max > range._max) range._max = r[ub]._max;

    // splice range into this._ranges
    this._ranges.splice(lb,ub-lb+1,range);
    return;
}

_Compound.prototype.isContiguous = function() {
    return this._ranges.length > 1;
}

_Compound.prototype.ranges = function() {
    return this._ranges;
}

_Compound.prototype._pushRanges = function(ranges) {
    for (var ri = 0; ri < this._ranges.length; ++ri)
        ranges.push(this._ranges[ri]);
}

_Compound.prototype.toString = function() {
    var s = '';
    for (var r = 0; r < this._ranges.length; ++r) {
        if (r>0) {
            s = s + ',';
        }
        s = s + this._ranges[r].toString();
    }
    return s;
}

function union(s0, s1) {
    if (! (s0 instanceof _Compound)) {
        if (! (s0 instanceof Array))
            s0 = [s0];
        s0 = new _Compound(s0);
    }

    if (s1)
        s0.insertRange(s1);

    return s0;
}

function intersection(s0, s1) {
    var r0 = s0.ranges();
    var r1 = s1.ranges();
    var l0 = r0.length, l1 = r1.length;
    var i0 = 0, i1 = 0;
    var or = [];

    while (i0 < l0 && i1 < l1) {
        var s0 = r0[i0], s1 = r1[i1];
        var lapMin = Math.max(s0.min(), s1.min());
        var lapMax = Math.min(s0.max(), s1.max());
        if (lapMax >= lapMin) {
            or.push(new Range(lapMin, lapMax));
        }
        if (s0.max() > s1.max()) {
            ++i1;
        } else {
            ++i0;
        }
    }

    if (or.length == 0) {
        return null; // FIXME
    } else if (or.length == 1) {
        return or[0];
    } else {
        return new _Compound(or);
    }
}

function coverage(s) {
    var tot = 0;
    var rl = s.ranges();
    for (var ri = 0; ri < rl.length; ++ri) {
        var r = rl[ri];
        tot += (r.max() - r.min() + 1);
    }
    return tot;
}



function rangeOrder(a, b)
{
    if (a.min() < b.min()) {
        return -1;
    } else if (a.min() > b.min()) {
        return 1;
    } else if (a.max() < b.max()) {
        return -1;
    } else if (b.max() > a.max()) {
        return 1;
    } else {
        return 0;
    }
}

function _rangeOrder(a, b)
{
    if (a._min < b._min) {
        return -1;
    } else if (a._min > b._min) {
        return 1;
    } else if (a._max < b._max) {
        return -1;
    } else if (b._max > a._max) {
        return 1;
    } else {
        return 0;
    }
}

return {
        Range: Range,
        union: union,
        intersection: intersection,
        coverage: coverage,
        rangeOver: rangeOrder,
        _rangeOrder: _rangeOrder
};
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* -*- mode: javascript; c-basic-offset: 4; indent-tabs-mode: nil -*- */

//
// Javascript ZLib
// By Thomas Down 2010-2011
//
// Based very heavily on portions of jzlib (by ymnk@jcraft.com), who in
// turn credits Jean-loup Gailly and Mark Adler for the original zlib code.
//
// inflate.js: ZLib inflate code
//

//
// Shared constants
//

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {

var MAX_WBITS=15; // 32K LZ77 window
var DEF_WBITS=MAX_WBITS;
var MAX_MEM_LEVEL=9;
var MANY=1440;
var BMAX = 15;

// preset dictionary flag in zlib header
var PRESET_DICT=0x20;

var Z_NO_FLUSH=0;
var Z_PARTIAL_FLUSH=1;
var Z_SYNC_FLUSH=2;
var Z_FULL_FLUSH=3;
var Z_FINISH=4;

var Z_DEFLATED=8;

var Z_OK=0;
var Z_STREAM_END=1;
var Z_NEED_DICT=2;
var Z_ERRNO=-1;
var Z_STREAM_ERROR=-2;
var Z_DATA_ERROR=-3;
var Z_MEM_ERROR=-4;
var Z_BUF_ERROR=-5;
var Z_VERSION_ERROR=-6;

var METHOD=0;   // waiting for method byte
var FLAG=1;     // waiting for flag byte
var DICT4=2;    // four dictionary check bytes to go
var DICT3=3;    // three dictionary check bytes to go
var DICT2=4;    // two dictionary check bytes to go
var DICT1=5;    // one dictionary check byte to go
var DICT0=6;    // waiting for inflateSetDictionary
var BLOCKS=7;   // decompressing blocks
var CHECK4=8;   // four check bytes to go
var CHECK3=9;   // three check bytes to go
var CHECK2=10;  // two check bytes to go
var CHECK1=11;  // one check byte to go
var DONE=12;    // finished check, done
var BAD=13;     // got an error--stay here

var inflate_mask = [0x00000000, 0x00000001, 0x00000003, 0x00000007, 0x0000000f, 0x0000001f, 0x0000003f, 0x0000007f, 0x000000ff, 0x000001ff, 0x000003ff, 0x000007ff, 0x00000fff, 0x00001fff, 0x00003fff, 0x00007fff, 0x0000ffff];

var IB_TYPE=0;  // get type bits (3, including end bit)
var IB_LENS=1;  // get lengths for stored
var IB_STORED=2;// processing stored block
var IB_TABLE=3; // get table lengths
var IB_BTREE=4; // get bit lengths tree for a dynamic block
var IB_DTREE=5; // get length, distance trees for a dynamic block
var IB_CODES=6; // processing fixed or dynamic block
var IB_DRY=7;   // output remaining window bytes
var IB_DONE=8;  // finished last block, done
var IB_BAD=9;   // ot a data error--stuck here

var fixed_bl = 9;
var fixed_bd = 5;

var fixed_tl = [
    96,7,256, 0,8,80, 0,8,16, 84,8,115,
    82,7,31, 0,8,112, 0,8,48, 0,9,192,
    80,7,10, 0,8,96, 0,8,32, 0,9,160,
    0,8,0, 0,8,128, 0,8,64, 0,9,224,
    80,7,6, 0,8,88, 0,8,24, 0,9,144,
    83,7,59, 0,8,120, 0,8,56, 0,9,208,
    81,7,17, 0,8,104, 0,8,40, 0,9,176,
    0,8,8, 0,8,136, 0,8,72, 0,9,240,
    80,7,4, 0,8,84, 0,8,20, 85,8,227,
    83,7,43, 0,8,116, 0,8,52, 0,9,200,
    81,7,13, 0,8,100, 0,8,36, 0,9,168,
    0,8,4, 0,8,132, 0,8,68, 0,9,232,
    80,7,8, 0,8,92, 0,8,28, 0,9,152,
    84,7,83, 0,8,124, 0,8,60, 0,9,216,
    82,7,23, 0,8,108, 0,8,44, 0,9,184,
    0,8,12, 0,8,140, 0,8,76, 0,9,248,
    80,7,3, 0,8,82, 0,8,18, 85,8,163,
    83,7,35, 0,8,114, 0,8,50, 0,9,196,
    81,7,11, 0,8,98, 0,8,34, 0,9,164,
    0,8,2, 0,8,130, 0,8,66, 0,9,228,
    80,7,7, 0,8,90, 0,8,26, 0,9,148,
    84,7,67, 0,8,122, 0,8,58, 0,9,212,
    82,7,19, 0,8,106, 0,8,42, 0,9,180,
    0,8,10, 0,8,138, 0,8,74, 0,9,244,
    80,7,5, 0,8,86, 0,8,22, 192,8,0,
    83,7,51, 0,8,118, 0,8,54, 0,9,204,
    81,7,15, 0,8,102, 0,8,38, 0,9,172,
    0,8,6, 0,8,134, 0,8,70, 0,9,236,
    80,7,9, 0,8,94, 0,8,30, 0,9,156,
    84,7,99, 0,8,126, 0,8,62, 0,9,220,
    82,7,27, 0,8,110, 0,8,46, 0,9,188,
    0,8,14, 0,8,142, 0,8,78, 0,9,252,
    96,7,256, 0,8,81, 0,8,17, 85,8,131,
    82,7,31, 0,8,113, 0,8,49, 0,9,194,
    80,7,10, 0,8,97, 0,8,33, 0,9,162,
    0,8,1, 0,8,129, 0,8,65, 0,9,226,
    80,7,6, 0,8,89, 0,8,25, 0,9,146,
    83,7,59, 0,8,121, 0,8,57, 0,9,210,
    81,7,17, 0,8,105, 0,8,41, 0,9,178,
    0,8,9, 0,8,137, 0,8,73, 0,9,242,
    80,7,4, 0,8,85, 0,8,21, 80,8,258,
    83,7,43, 0,8,117, 0,8,53, 0,9,202,
    81,7,13, 0,8,101, 0,8,37, 0,9,170,
    0,8,5, 0,8,133, 0,8,69, 0,9,234,
    80,7,8, 0,8,93, 0,8,29, 0,9,154,
    84,7,83, 0,8,125, 0,8,61, 0,9,218,
    82,7,23, 0,8,109, 0,8,45, 0,9,186,
    0,8,13, 0,8,141, 0,8,77, 0,9,250,
    80,7,3, 0,8,83, 0,8,19, 85,8,195,
    83,7,35, 0,8,115, 0,8,51, 0,9,198,
    81,7,11, 0,8,99, 0,8,35, 0,9,166,
    0,8,3, 0,8,131, 0,8,67, 0,9,230,
    80,7,7, 0,8,91, 0,8,27, 0,9,150,
    84,7,67, 0,8,123, 0,8,59, 0,9,214,
    82,7,19, 0,8,107, 0,8,43, 0,9,182,
    0,8,11, 0,8,139, 0,8,75, 0,9,246,
    80,7,5, 0,8,87, 0,8,23, 192,8,0,
    83,7,51, 0,8,119, 0,8,55, 0,9,206,
    81,7,15, 0,8,103, 0,8,39, 0,9,174,
    0,8,7, 0,8,135, 0,8,71, 0,9,238,
    80,7,9, 0,8,95, 0,8,31, 0,9,158,
    84,7,99, 0,8,127, 0,8,63, 0,9,222,
    82,7,27, 0,8,111, 0,8,47, 0,9,190,
    0,8,15, 0,8,143, 0,8,79, 0,9,254,
    96,7,256, 0,8,80, 0,8,16, 84,8,115,
    82,7,31, 0,8,112, 0,8,48, 0,9,193,

    80,7,10, 0,8,96, 0,8,32, 0,9,161,
    0,8,0, 0,8,128, 0,8,64, 0,9,225,
    80,7,6, 0,8,88, 0,8,24, 0,9,145,
    83,7,59, 0,8,120, 0,8,56, 0,9,209,
    81,7,17, 0,8,104, 0,8,40, 0,9,177,
    0,8,8, 0,8,136, 0,8,72, 0,9,241,
    80,7,4, 0,8,84, 0,8,20, 85,8,227,
    83,7,43, 0,8,116, 0,8,52, 0,9,201,
    81,7,13, 0,8,100, 0,8,36, 0,9,169,
    0,8,4, 0,8,132, 0,8,68, 0,9,233,
    80,7,8, 0,8,92, 0,8,28, 0,9,153,
    84,7,83, 0,8,124, 0,8,60, 0,9,217,
    82,7,23, 0,8,108, 0,8,44, 0,9,185,
    0,8,12, 0,8,140, 0,8,76, 0,9,249,
    80,7,3, 0,8,82, 0,8,18, 85,8,163,
    83,7,35, 0,8,114, 0,8,50, 0,9,197,
    81,7,11, 0,8,98, 0,8,34, 0,9,165,
    0,8,2, 0,8,130, 0,8,66, 0,9,229,
    80,7,7, 0,8,90, 0,8,26, 0,9,149,
    84,7,67, 0,8,122, 0,8,58, 0,9,213,
    82,7,19, 0,8,106, 0,8,42, 0,9,181,
    0,8,10, 0,8,138, 0,8,74, 0,9,245,
    80,7,5, 0,8,86, 0,8,22, 192,8,0,
    83,7,51, 0,8,118, 0,8,54, 0,9,205,
    81,7,15, 0,8,102, 0,8,38, 0,9,173,
    0,8,6, 0,8,134, 0,8,70, 0,9,237,
    80,7,9, 0,8,94, 0,8,30, 0,9,157,
    84,7,99, 0,8,126, 0,8,62, 0,9,221,
    82,7,27, 0,8,110, 0,8,46, 0,9,189,
    0,8,14, 0,8,142, 0,8,78, 0,9,253,
    96,7,256, 0,8,81, 0,8,17, 85,8,131,
    82,7,31, 0,8,113, 0,8,49, 0,9,195,
    80,7,10, 0,8,97, 0,8,33, 0,9,163,
    0,8,1, 0,8,129, 0,8,65, 0,9,227,
    80,7,6, 0,8,89, 0,8,25, 0,9,147,
    83,7,59, 0,8,121, 0,8,57, 0,9,211,
    81,7,17, 0,8,105, 0,8,41, 0,9,179,
    0,8,9, 0,8,137, 0,8,73, 0,9,243,
    80,7,4, 0,8,85, 0,8,21, 80,8,258,
    83,7,43, 0,8,117, 0,8,53, 0,9,203,
    81,7,13, 0,8,101, 0,8,37, 0,9,171,
    0,8,5, 0,8,133, 0,8,69, 0,9,235,
    80,7,8, 0,8,93, 0,8,29, 0,9,155,
    84,7,83, 0,8,125, 0,8,61, 0,9,219,
    82,7,23, 0,8,109, 0,8,45, 0,9,187,
    0,8,13, 0,8,141, 0,8,77, 0,9,251,
    80,7,3, 0,8,83, 0,8,19, 85,8,195,
    83,7,35, 0,8,115, 0,8,51, 0,9,199,
    81,7,11, 0,8,99, 0,8,35, 0,9,167,
    0,8,3, 0,8,131, 0,8,67, 0,9,231,
    80,7,7, 0,8,91, 0,8,27, 0,9,151,
    84,7,67, 0,8,123, 0,8,59, 0,9,215,
    82,7,19, 0,8,107, 0,8,43, 0,9,183,
    0,8,11, 0,8,139, 0,8,75, 0,9,247,
    80,7,5, 0,8,87, 0,8,23, 192,8,0,
    83,7,51, 0,8,119, 0,8,55, 0,9,207,
    81,7,15, 0,8,103, 0,8,39, 0,9,175,
    0,8,7, 0,8,135, 0,8,71, 0,9,239,
    80,7,9, 0,8,95, 0,8,31, 0,9,159,
    84,7,99, 0,8,127, 0,8,63, 0,9,223,
    82,7,27, 0,8,111, 0,8,47, 0,9,191,
    0,8,15, 0,8,143, 0,8,79, 0,9,255
];
var fixed_td = [
    80,5,1, 87,5,257, 83,5,17, 91,5,4097,
    81,5,5, 89,5,1025, 85,5,65, 93,5,16385,
    80,5,3, 88,5,513, 84,5,33, 92,5,8193,
    82,5,9, 90,5,2049, 86,5,129, 192,5,24577,
    80,5,2, 87,5,385, 83,5,25, 91,5,6145,
    81,5,7, 89,5,1537, 85,5,97, 93,5,24577,
    80,5,4, 88,5,769, 84,5,49, 92,5,12289,
    82,5,13, 90,5,3073, 86,5,193, 192,5,24577
];

  // Tables for deflate from PKZIP's appnote.txt.
  var cplens = [ // Copy lengths for literal codes 257..285
        3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31,
        35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0
  ];

  // see note #13 above about 258
  var cplext = [ // Extra bits for literal codes 257..285
        0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2,
        3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0, 112, 112  // 112==invalid
  ];

 var cpdist = [ // Copy offsets for distance codes 0..29
        1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193,
        257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145,
        8193, 12289, 16385, 24577
  ];

  var cpdext = [ // Extra bits for distance codes
        0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6,
        7, 7, 8, 8, 9, 9, 10, 10, 11, 11,
        12, 12, 13, 13];

//
// ZStream.java
//

function ZStream() {
}


ZStream.prototype.inflateInit = function(w, nowrap) {
    if (!w) {
	w = DEF_WBITS;
    }
    if (nowrap) {
	nowrap = false;
    }
    this.istate = new Inflate();
    return this.istate.inflateInit(this, nowrap?-w:w);
}

ZStream.prototype.inflate = function(f) {
    if(this.istate==null) return Z_STREAM_ERROR;
    return this.istate.inflate(this, f);
}

ZStream.prototype.inflateEnd = function(){
    if(this.istate==null) return Z_STREAM_ERROR;
    var ret=istate.inflateEnd(this);
    this.istate = null;
    return ret;
}
ZStream.prototype.inflateSync = function(){
    // if(istate == null) return Z_STREAM_ERROR;
    return istate.inflateSync(this);
}
ZStream.prototype.inflateSetDictionary = function(dictionary, dictLength){
    // if(istate == null) return Z_STREAM_ERROR;
    return istate.inflateSetDictionary(this, dictionary, dictLength);
}

/*

  public int deflateInit(int level){
    return deflateInit(level, MAX_WBITS);
  }
  public int deflateInit(int level, boolean nowrap){
    return deflateInit(level, MAX_WBITS, nowrap);
  }
  public int deflateInit(int level, int bits){
    return deflateInit(level, bits, false);
  }
  public int deflateInit(int level, int bits, boolean nowrap){
    dstate=new Deflate();
    return dstate.deflateInit(this, level, nowrap?-bits:bits);
  }
  public int deflate(int flush){
    if(dstate==null){
      return Z_STREAM_ERROR;
    }
    return dstate.deflate(this, flush);
  }
  public int deflateEnd(){
    if(dstate==null) return Z_STREAM_ERROR;
    int ret=dstate.deflateEnd();
    dstate=null;
    return ret;
  }
  public int deflateParams(int level, int strategy){
    if(dstate==null) return Z_STREAM_ERROR;
    return dstate.deflateParams(this, level, strategy);
  }
  public int deflateSetDictionary (byte[] dictionary, int dictLength){
    if(dstate == null)
      return Z_STREAM_ERROR;
    return dstate.deflateSetDictionary(this, dictionary, dictLength);
  }

*/

/*
  // Flush as much pending output as possible. All deflate() output goes
  // through this function so some applications may wish to modify it
  // to avoid allocating a large strm->next_out buffer and copying into it.
  // (See also read_buf()).
  void flush_pending(){
    int len=dstate.pending;

    if(len>avail_out) len=avail_out;
    if(len==0) return;

    if(dstate.pending_buf.length<=dstate.pending_out ||
       next_out.length<=next_out_index ||
       dstate.pending_buf.length<(dstate.pending_out+len) ||
       next_out.length<(next_out_index+len)){
      System.out.println(dstate.pending_buf.length+", "+dstate.pending_out+
			 ", "+next_out.length+", "+next_out_index+", "+len);
      System.out.println("avail_out="+avail_out);
    }

    System.arraycopy(dstate.pending_buf, dstate.pending_out,
		     next_out, next_out_index, len);

    next_out_index+=len;
    dstate.pending_out+=len;
    total_out+=len;
    avail_out-=len;
    dstate.pending-=len;
    if(dstate.pending==0){
      dstate.pending_out=0;
    }
  }

  // Read a new buffer from the current input stream, update the adler32
  // and total number of bytes read.  All deflate() input goes through
  // this function so some applications may wish to modify it to avoid
  // allocating a large strm->next_in buffer and copying from it.
  // (See also flush_pending()).
  int read_buf(byte[] buf, int start, int size) {
    int len=avail_in;

    if(len>size) len=size;
    if(len==0) return 0;

    avail_in-=len;

    if(dstate.noheader==0) {
      adler=_adler.adler32(adler, next_in, next_in_index, len);
    }
    System.arraycopy(next_in, next_in_index, buf, start, len);
    next_in_index  += len;
    total_in += len;
    return len;
  }

  public void free(){
    next_in=null;
    next_out=null;
    msg=null;
    _adler=null;
  }
}
*/


//
// Inflate.java
//

function Inflate() {
    this.was = [0];
}

Inflate.prototype.inflateReset = function(z) {
    if(z == null || z.istate == null) return Z_STREAM_ERROR;

    z.total_in = z.total_out = 0;
    z.msg = null;
    z.istate.mode = z.istate.nowrap!=0 ? BLOCKS : METHOD;
    z.istate.blocks.reset(z, null);
    return Z_OK;
}

Inflate.prototype.inflateEnd = function(z){
    if(this.blocks != null)
      this.blocks.free(z);
    this.blocks=null;
    return Z_OK;
}

Inflate.prototype.inflateInit = function(z, w){
    z.msg = null;
    this.blocks = null;

    // handle undocumented nowrap option (no zlib header or check)
    nowrap = 0;
    if(w < 0){
      w = - w;
      nowrap = 1;
    }

    // set window size
    if(w<8 ||w>15){
      this.inflateEnd(z);
      return Z_STREAM_ERROR;
    }
    this.wbits=w;

    z.istate.blocks=new InfBlocks(z,
				  z.istate.nowrap!=0 ? null : this,
				  1<<w);

    // reset state
    this.inflateReset(z);
    return Z_OK;
  }

Inflate.prototype.inflate = function(z, f){
    var r, b;

    if(z == null || z.istate == null || z.next_in == null)
      return Z_STREAM_ERROR;
    f = f == Z_FINISH ? Z_BUF_ERROR : Z_OK;
    r = Z_BUF_ERROR;
    while (true){
      switch (z.istate.mode){
      case METHOD:

        if(z.avail_in==0)return r;r=f;

        z.avail_in--; z.total_in++;
        if(((z.istate.method = z.next_in[z.next_in_index++])&0xf)!=Z_DEFLATED){
          z.istate.mode = BAD;
          z.msg="unknown compression method";
          z.istate.marker = 5;       // can't try inflateSync
          break;
        }
        if((z.istate.method>>4)+8>z.istate.wbits){
          z.istate.mode = BAD;
          z.msg="invalid window size";
          z.istate.marker = 5;       // can't try inflateSync
          break;
        }
        z.istate.mode=FLAG;
      case FLAG:

        if(z.avail_in==0)return r;r=f;

        z.avail_in--; z.total_in++;
        b = (z.next_in[z.next_in_index++])&0xff;

        if((((z.istate.method << 8)+b) % 31)!=0){
          z.istate.mode = BAD;
          z.msg = "incorrect header check";
          z.istate.marker = 5;       // can't try inflateSync
          break;
        }

        if((b&PRESET_DICT)==0){
          z.istate.mode = BLOCKS;
          break;
        }
        z.istate.mode = DICT4;
      case DICT4:

        if(z.avail_in==0)return r;r=f;

        z.avail_in--; z.total_in++;
        z.istate.need=((z.next_in[z.next_in_index++]&0xff)<<24)&0xff000000;
        z.istate.mode=DICT3;
      case DICT3:

        if(z.avail_in==0)return r;r=f;

        z.avail_in--; z.total_in++;
        z.istate.need+=((z.next_in[z.next_in_index++]&0xff)<<16)&0xff0000;
        z.istate.mode=DICT2;
      case DICT2:

        if(z.avail_in==0)return r;r=f;

        z.avail_in--; z.total_in++;
        z.istate.need+=((z.next_in[z.next_in_index++]&0xff)<<8)&0xff00;
        z.istate.mode=DICT1;
      case DICT1:

        if(z.avail_in==0)return r;r=f;

        z.avail_in--; z.total_in++;
        z.istate.need += (z.next_in[z.next_in_index++]&0xff);
        z.adler = z.istate.need;
        z.istate.mode = DICT0;
        return Z_NEED_DICT;
      case DICT0:
        z.istate.mode = BAD;
        z.msg = "need dictionary";
        z.istate.marker = 0;       // can try inflateSync
        return Z_STREAM_ERROR;
      case BLOCKS:

        r = z.istate.blocks.proc(z, r);
        if(r == Z_DATA_ERROR){
          z.istate.mode = BAD;
          z.istate.marker = 0;     // can try inflateSync
          break;
        }
        if(r == Z_OK){
          r = f;
        }
        if(r != Z_STREAM_END){
          return r;
        }
        r = f;
        z.istate.blocks.reset(z, z.istate.was);
        if(z.istate.nowrap!=0){
          z.istate.mode=DONE;
          break;
        }
        z.istate.mode=CHECK4;
      case CHECK4:

        if(z.avail_in==0)return r;r=f;

        z.avail_in--; z.total_in++;
        z.istate.need=((z.next_in[z.next_in_index++]&0xff)<<24)&0xff000000;
        z.istate.mode=CHECK3;
      case CHECK3:

        if(z.avail_in==0)return r;r=f;

        z.avail_in--; z.total_in++;
        z.istate.need+=((z.next_in[z.next_in_index++]&0xff)<<16)&0xff0000;
        z.istate.mode = CHECK2;
      case CHECK2:

        if(z.avail_in==0)return r;r=f;

        z.avail_in--; z.total_in++;
        z.istate.need+=((z.next_in[z.next_in_index++]&0xff)<<8)&0xff00;
        z.istate.mode = CHECK1;
      case CHECK1:

        if(z.avail_in==0)return r;r=f;

        z.avail_in--; z.total_in++;
        z.istate.need+=(z.next_in[z.next_in_index++]&0xff);

        if(((z.istate.was[0])) != ((z.istate.need))){
          z.istate.mode = BAD;
          z.msg = "incorrect data check";
          z.istate.marker = 5;       // can't try inflateSync
          break;
        }

        z.istate.mode = DONE;
      case DONE:
        return Z_STREAM_END;
      case BAD:
        return Z_DATA_ERROR;
      default:
        return Z_STREAM_ERROR;
      }
    }
  }


Inflate.prototype.inflateSetDictionary = function(z,  dictionary, dictLength) {
    var index=0;
    var length = dictLength;
    if(z==null || z.istate == null|| z.istate.mode != DICT0)
      return Z_STREAM_ERROR;

    if(z._adler.adler32(1, dictionary, 0, dictLength)!=z.adler){
      return Z_DATA_ERROR;
    }

    z.adler = z._adler.adler32(0, null, 0, 0);

    if(length >= (1<<z.istate.wbits)){
      length = (1<<z.istate.wbits)-1;
      index=dictLength - length;
    }
    z.istate.blocks.set_dictionary(dictionary, index, length);
    z.istate.mode = BLOCKS;
    return Z_OK;
  }

//  static private byte[] mark = {(byte)0, (byte)0, (byte)0xff, (byte)0xff};
var mark = [0, 0, 255, 255]

Inflate.prototype.inflateSync = function(z){
    var n;       // number of bytes to look at
    var p;       // pointer to bytes
    var m;       // number of marker bytes found in a row
    var r, w;   // temporaries to save total_in and total_out

    // set up
    if(z == null || z.istate == null)
      return Z_STREAM_ERROR;
    if(z.istate.mode != BAD){
      z.istate.mode = BAD;
      z.istate.marker = 0;
    }
    if((n=z.avail_in)==0)
      return Z_BUF_ERROR;
    p=z.next_in_index;
    m=z.istate.marker;

    // search
    while (n!=0 && m < 4){
      if(z.next_in[p] == mark[m]){
        m++;
      }
      else if(z.next_in[p]!=0){
        m = 0;
      }
      else{
        m = 4 - m;
      }
      p++; n--;
    }

    // restore
    z.total_in += p-z.next_in_index;
    z.next_in_index = p;
    z.avail_in = n;
    z.istate.marker = m;

    // return no joy or set up to restart on a new block
    if(m != 4){
      return Z_DATA_ERROR;
    }
    r=z.total_in;  w=z.total_out;
    this.inflateReset(z);
    z.total_in=r;  z.total_out = w;
    z.istate.mode = BLOCKS;
    return Z_OK;
}

  // Returns true if inflate is currently at the end of a block generated
  // by Z_SYNC_FLUSH or Z_FULL_FLUSH. This function is used by one PPP
  // implementation to provide an additional safety check. PPP uses Z_SYNC_FLUSH
  // but removes the length bytes of the resulting empty stored block. When
  // decompressing, PPP checks that at the end of input packet, inflate is
  // waiting for these length bytes.
Inflate.prototype.inflateSyncPoint = function(z){
    if(z == null || z.istate == null || z.istate.blocks == null)
      return Z_STREAM_ERROR;
    return z.istate.blocks.sync_point();
}


//
// InfBlocks.java
//

var INFBLOCKS_BORDER = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15];

function InfBlocks(z, checkfn, w) {
    this.hufts=new Int32Array(MANY*3);
    this.window=new Uint8Array(w);
    this.end=w;
    this.checkfn = checkfn;
    this.mode = IB_TYPE;
    this.reset(z, null);

    this.left = 0;            // if STORED, bytes left to copy

    this.table = 0;           // table lengths (14 bits)
    this.index = 0;           // index into blens (or border)
    this.blens = null;         // bit lengths of codes
    this.bb=new Int32Array(1); // bit length tree depth
    this.tb=new Int32Array(1); // bit length decoding tree

    this.codes = new InfCodes();

    this.last = 0;            // true if this block is the last block

  // mode independent information
    this.bitk = 0;            // bits in bit buffer
    this.bitb = 0;            // bit buffer
    this.read = 0;            // window read pointer
    this.write = 0;           // window write pointer
    this.check = 0;          // check on output

    this.inftree=new InfTree();
}




InfBlocks.prototype.reset = function(z, c){
    if(c) c[0]=this.check;
    if(this.mode==IB_CODES){
      this.codes.free(z);
    }
    this.mode=IB_TYPE;
    this.bitk=0;
    this.bitb=0;
    this.read=this.write=0;

    if(this.checkfn)
      z.adler=this.check=z._adler.adler32(0, null, 0, 0);
  }

 InfBlocks.prototype.proc = function(z, r){
    var t;              // temporary storage
    var b;              // bit buffer
    var k;              // bits in bit buffer
    var p;              // input data pointer
    var n;              // bytes available there
    var q;              // output window write pointer
    var m;              // bytes to end of window or read pointer

    // copy input/output information to locals (UPDATE macro restores)
    {p=z.next_in_index;n=z.avail_in;b=this.bitb;k=this.bitk;}
    {q=this.write;m=(q<this.read ? this.read-q-1 : this.end-q);}

    // process input based on current state
    while(true){
      switch (this.mode){
      case IB_TYPE:

	while(k<(3)){
	  if(n!=0){
	    r=Z_OK;
	  }
	  else{
	    this.bitb=b; this.bitk=k;
	    z.avail_in=n;
	    z.total_in+=p-z.next_in_index;z.next_in_index=p;
	    this.write=q;
	    return this.inflate_flush(z,r);
	  };
	  n--;
	  b|=(z.next_in[p++]&0xff)<<k;
	  k+=8;
	}
	t = (b & 7);
	this.last = t & 1;

	switch (t >>> 1){
        case 0:                         // stored
          {b>>>=(3);k-=(3);}
          t = k & 7;                    // go to byte boundary

          {b>>>=(t);k-=(t);}
          this.mode = IB_LENS;                  // get length of stored block
          break;
        case 1:                         // fixed
          {
              var bl=new Int32Array(1);
	      var bd=new Int32Array(1);
              var tl=[];
	      var td=[];

	      inflate_trees_fixed(bl, bd, tl, td, z);
              this.codes.init(bl[0], bd[0], tl[0], 0, td[0], 0, z);
          }

          {b>>>=(3);k-=(3);}

          this.mode = IB_CODES;
          break;
        case 2:                         // dynamic

          {b>>>=(3);k-=(3);}

          this.mode = IB_TABLE;
          break;
        case 3:                         // illegal

          {b>>>=(3);k-=(3);}
          this.mode = BAD;
          z.msg = "invalid block type";
          r = Z_DATA_ERROR;

	  this.bitb=b; this.bitk=k;
	  z.avail_in=n;z.total_in+=p-z.next_in_index;z.next_in_index=p;
	  this.write=q;
	  return this.inflate_flush(z,r);
	}
	break;
      case IB_LENS:
	while(k<(32)){
	  if(n!=0){
	    r=Z_OK;
	  }
	  else{
	    this.bitb=b; this.bitk=k;
	    z.avail_in=n;
	    z.total_in+=p-z.next_in_index;z.next_in_index=p;
	    this.write=q;
	    return this.inflate_flush(z,r);
	  };
	  n--;
	  b|=(z.next_in[p++]&0xff)<<k;
	  k+=8;
	}

	if ((((~b) >>> 16) & 0xffff) != (b & 0xffff)){
	  this.mode = BAD;
	  z.msg = "invalid stored block lengths";
	  r = Z_DATA_ERROR;

	  this.bitb=b; this.bitk=k;
	  z.avail_in=n;z.total_in+=p-z.next_in_index;z.next_in_index=p;
	  this.write=q;
	  return this.inflate_flush(z,r);
	}
	this.left = (b & 0xffff);
	b = k = 0;                       // dump bits
	this.mode = this.left!=0 ? IB_STORED : (this.last!=0 ? IB_DRY : IB_TYPE);
	break;
      case IB_STORED:
	if (n == 0){
	  this.bitb=b; this.bitk=k;
	  z.avail_in=n;z.total_in+=p-z.next_in_index;z.next_in_index=p;
	  write=q;
	  return this.inflate_flush(z,r);
	}

	if(m==0){
	  if(q==end&&read!=0){
	    q=0; m=(q<this.read ? this.read-q-1 : this.end-q);
	  }
	  if(m==0){
	    this.write=q;
	    r=this.inflate_flush(z,r);
	    q=this.write; m = (q < this.read ? this.read-q-1 : this.end-q);
	    if(q==this.end && this.read != 0){
	      q=0; m = (q < this.read ? this.read-q-1 : this.end-q);
	    }
	    if(m==0){
	      this.bitb=b; this.bitk=k;
	      z.avail_in=n;z.total_in+=p-z.next_in_index;z.next_in_index=p;
	      this.write=q;
	      return this.inflate_flush(z,r);
	    }
	  }
	}
	r=Z_OK;

	t = this.left;
	if(t>n) t = n;
	if(t>m) t = m;
	arrayCopy(z.next_in, p, this.window, q, t);
	p += t;  n -= t;
	q += t;  m -= t;
	if ((this.left -= t) != 0)
	  break;
	this.mode = (this.last != 0 ? IB_DRY : IB_TYPE);
	break;
      case IB_TABLE:

	while(k<(14)){
	  if(n!=0){
	    r=Z_OK;
	  }
	  else{
	    this.bitb=b; this.bitk=k;
	    z.avail_in=n;
	    z.total_in+=p-z.next_in_index;z.next_in_index=p;
	    this.write=q;
	    return this.inflate_flush(z,r);
	  };
	  n--;
	  b|=(z.next_in[p++]&0xff)<<k;
	  k+=8;
	}

	this.table = t = (b & 0x3fff);
	if ((t & 0x1f) > 29 || ((t >> 5) & 0x1f) > 29)
	  {
	    this.mode = IB_BAD;
	    z.msg = "too many length or distance symbols";
	    r = Z_DATA_ERROR;

	    this.bitb=b; this.bitk=k;
	    z.avail_in=n;z.total_in+=p-z.next_in_index;z.next_in_index=p;
	    this.write=q;
	    return this.inflate_flush(z,r);
	  }
	t = 258 + (t & 0x1f) + ((t >> 5) & 0x1f);
	if(this.blens==null || this.blens.length<t){
	    this.blens=new Int32Array(t);
	}
	else{
	  for(var i=0; i<t; i++){
              this.blens[i]=0;
          }
	}

	{b>>>=(14);k-=(14);}

	this.index = 0;
	mode = IB_BTREE;
      case IB_BTREE:
	while (this.index < 4 + (this.table >>> 10)){
	  while(k<(3)){
	    if(n!=0){
	      r=Z_OK;
	    }
	    else{
	      this.bitb=b; this.bitk=k;
	      z.avail_in=n;
	      z.total_in+=p-z.next_in_index;z.next_in_index=p;
	      this.write=q;
	      return this.inflate_flush(z,r);
	    };
	    n--;
	    b|=(z.next_in[p++]&0xff)<<k;
	    k+=8;
	  }

	  this.blens[INFBLOCKS_BORDER[this.index++]] = b&7;

	  {b>>>=(3);k-=(3);}
	}

	while(this.index < 19){
	  this.blens[INFBLOCKS_BORDER[this.index++]] = 0;
	}

	this.bb[0] = 7;
	t = this.inftree.inflate_trees_bits(this.blens, this.bb, this.tb, this.hufts, z);
	if (t != Z_OK){
	  r = t;
	  if (r == Z_DATA_ERROR){
	    this.blens=null;
	    this.mode = IB_BAD;
	  }

	  this.bitb=b; this.bitk=k;
	  z.avail_in=n;z.total_in+=p-z.next_in_index;z.next_in_index=p;
	  write=q;
	  return this.inflate_flush(z,r);
	}

	this.index = 0;
	this.mode = IB_DTREE;
      case IB_DTREE:
	while (true){
	  t = this.table;
	  if(!(this.index < 258 + (t & 0x1f) + ((t >> 5) & 0x1f))){
	    break;
	  }

	  var h; //int[]
	  var i, j, c;

	  t = this.bb[0];

	  while(k<(t)){
	    if(n!=0){
	      r=Z_OK;
	    }
	    else{
	      this.bitb=b; this.bitk=k;
	      z.avail_in=n;
	      z.total_in+=p-z.next_in_index;z.next_in_index=p;
	      this.write=q;
	      return this.inflate_flush(z,r);
	    };
	    n--;
	    b|=(z.next_in[p++]&0xff)<<k;
	    k+=8;
	  }

//	  if (this.tb[0]==-1){
//            dlog("null...");
//	  }

	  t=this.hufts[(this.tb[0]+(b & inflate_mask[t]))*3+1];
	  c=this.hufts[(this.tb[0]+(b & inflate_mask[t]))*3+2];

	  if (c < 16){
	    b>>>=(t);k-=(t);
	    this.blens[this.index++] = c;
	  }
	  else { // c == 16..18
	    i = c == 18 ? 7 : c - 14;
	    j = c == 18 ? 11 : 3;

	    while(k<(t+i)){
	      if(n!=0){
		r=Z_OK;
	      }
	      else{
		this.bitb=b; this.bitk=k;
		z.avail_in=n;
		z.total_in+=p-z.next_in_index;z.next_in_index=p;
		this.write=q;
		return this.inflate_flush(z,r);
	      };
	      n--;
	      b|=(z.next_in[p++]&0xff)<<k;
	      k+=8;
	    }

	    b>>>=(t);k-=(t);

	    j += (b & inflate_mask[i]);

	    b>>>=(i);k-=(i);

	    i = this.index;
	    t = this.table;
	    if (i + j > 258 + (t & 0x1f) + ((t >> 5) & 0x1f) ||
		(c == 16 && i < 1)){
	      this.blens=null;
	      this.mode = IB_BAD;
	      z.msg = "invalid bit length repeat";
	      r = Z_DATA_ERROR;

	      this.bitb=b; this.bitk=k;
	      z.avail_in=n;z.total_in+=p-z.next_in_index;z.next_in_index=p;
	      this.write=q;
	      return this.inflate_flush(z,r);
	    }

	    c = c == 16 ? this.blens[i-1] : 0;
	    do{
	      this.blens[i++] = c;
	    }
	    while (--j!=0);
	    this.index = i;
	  }
	}

	this.tb[0]=-1;
	{
	    var bl=new Int32Array(1);
	    var bd=new Int32Array(1);
	    var tl=new Int32Array(1);
	    var td=new Int32Array(1);
	    bl[0] = 9;         // must be <= 9 for lookahead assumptions
	    bd[0] = 6;         // must be <= 9 for lookahead assumptions

	    t = this.table;
	    t = this.inftree.inflate_trees_dynamic(257 + (t & 0x1f),
					      1 + ((t >> 5) & 0x1f),
					      this.blens, bl, bd, tl, td, this.hufts, z);

	    if (t != Z_OK){
	        if (t == Z_DATA_ERROR){
	            this.blens=null;
	            this.mode = BAD;
	        }
	        r = t;

	        this.bitb=b; this.bitk=k;
	        z.avail_in=n;z.total_in+=p-z.next_in_index;z.next_in_index=p;
	        this.write=q;
	        return this.inflate_flush(z,r);
	    }
	    this.codes.init(bl[0], bd[0], this.hufts, tl[0], this.hufts, td[0], z);
	}
	this.mode = IB_CODES;
      case IB_CODES:
	this.bitb=b; this.bitk=k;
	z.avail_in=n; z.total_in+=p-z.next_in_index;z.next_in_index=p;
	this.write=q;

	if ((r = this.codes.proc(this, z, r)) != Z_STREAM_END){
	  return this.inflate_flush(z, r);
	}
	r = Z_OK;
	this.codes.free(z);

	p=z.next_in_index; n=z.avail_in;b=this.bitb;k=this.bitk;
	q=this.write;m = (q < this.read ? this.read-q-1 : this.end-q);

	if (this.last==0){
	  this.mode = IB_TYPE;
	  break;
	}
	this.mode = IB_DRY;
      case IB_DRY:
	this.write=q;
	r = this.inflate_flush(z, r);
	q=this.write; m = (q < this.read ? this.read-q-1 : this.end-q);
	if (this.read != this.write){
	  this.bitb=b; this.bitk=k;
	  z.avail_in=n;z.total_in+=p-z.next_in_index;z.next_in_index=p;
	  this.write=q;
	  return this.inflate_flush(z, r);
	}
	mode = DONE;
      case IB_DONE:
	r = Z_STREAM_END;

	this.bitb=b; this.bitk=k;
	z.avail_in=n;z.total_in+=p-z.next_in_index;z.next_in_index=p;
	this.write=q;
	return this.inflate_flush(z, r);
      case IB_BAD:
	r = Z_DATA_ERROR;

	this.bitb=b; this.bitk=k;
	z.avail_in=n;z.total_in+=p-z.next_in_index;z.next_in_index=p;
	this.write=q;
	return this.inflate_flush(z, r);

      default:
	r = Z_STREAM_ERROR;

	this.bitb=b; this.bitk=k;
	z.avail_in=n;z.total_in+=p-z.next_in_index;z.next_in_index=p;
	this.write=q;
	return this.inflate_flush(z, r);
      }
    }
  }

InfBlocks.prototype.free = function(z){
    this.reset(z, null);
    this.window=null;
    this.hufts=null;
}

InfBlocks.prototype.set_dictionary = function(d, start, n){
    arrayCopy(d, start, window, 0, n);
    this.read = this.write = n;
}

  // Returns true if inflate is currently at the end of a block generated
  // by Z_SYNC_FLUSH or Z_FULL_FLUSH.
InfBlocks.prototype.sync_point = function(){
    return this.mode == IB_LENS;
}

  // copy as much as possible from the sliding window to the output area
InfBlocks.prototype.inflate_flush = function(z, r){
    var n;
    var p;
    var q;

    // local copies of source and destination pointers
    p = z.next_out_index;
    q = this.read;

    // compute number of bytes to copy as far as end of window
    n = ((q <= this.write ? this.write : this.end) - q);
    if (n > z.avail_out) n = z.avail_out;
    if (n!=0 && r == Z_BUF_ERROR) r = Z_OK;

    // update counters
    z.avail_out -= n;
    z.total_out += n;

    // update check information
    if(this.checkfn != null)
      z.adler=this.check=z._adler.adler32(this.check, this.window, q, n);

    // copy as far as end of window
    arrayCopy(this.window, q, z.next_out, p, n);
    p += n;
    q += n;

    // see if more to copy at beginning of window
    if (q == this.end){
      // wrap pointers
      q = 0;
      if (this.write == this.end)
        this.write = 0;

      // compute bytes to copy
      n = this.write - q;
      if (n > z.avail_out) n = z.avail_out;
      if (n!=0 && r == Z_BUF_ERROR) r = Z_OK;

      // update counters
      z.avail_out -= n;
      z.total_out += n;

      // update check information
      if(this.checkfn != null)
	z.adler=this.check=z._adler.adler32(this.check, this.window, q, n);

      // copy
      arrayCopy(this.window, q, z.next_out, p, n);
      p += n;
      q += n;
    }

    // update pointers
    z.next_out_index = p;
    this.read = q;

    // done
    return r;
  }

//
// InfCodes.java
//

var IC_START=0;  // x: set up for LEN
var IC_LEN=1;    // i: get length/literal/eob next
var IC_LENEXT=2; // i: getting length extra (have base)
var IC_DIST=3;   // i: get distance next
var IC_DISTEXT=4;// i: getting distance extra
var IC_COPY=5;   // o: copying bytes in window, waiting for space
var IC_LIT=6;    // o: got literal, waiting for output space
var IC_WASH=7;   // o: got eob, possibly still output waiting
var IC_END=8;    // x: got eob and all data flushed
var IC_BADCODE=9;// x: got error

function InfCodes() {
}

InfCodes.prototype.init = function(bl, bd, tl, tl_index, td, td_index, z) {
    this.mode=IC_START;
    this.lbits=bl;
    this.dbits=bd;
    this.ltree=tl;
    this.ltree_index=tl_index;
    this.dtree = td;
    this.dtree_index=td_index;
    this.tree=null;
}

InfCodes.prototype.proc = function(s, z, r){
    var j;              // temporary storage
    var t;              // temporary pointer (int[])
    var tindex;         // temporary pointer
    var e;              // extra bits or operation
    var b=0;            // bit buffer
    var k=0;            // bits in bit buffer
    var p=0;            // input data pointer
    var n;              // bytes available there
    var q;              // output window write pointer
    var m;              // bytes to end of window or read pointer
    var f;              // pointer to copy strings from

    // copy input/output information to locals (UPDATE macro restores)
    p=z.next_in_index;n=z.avail_in;b=s.bitb;k=s.bitk;
    q=s.write;m=q<s.read?s.read-q-1:s.end-q;

    // process input and output based on current state
    while (true){
      switch (this.mode){
	// waiting for "i:"=input, "o:"=output, "x:"=nothing
      case IC_START:         // x: set up for LEN
	if (m >= 258 && n >= 10){

	  s.bitb=b;s.bitk=k;
	  z.avail_in=n;z.total_in+=p-z.next_in_index;z.next_in_index=p;
	  s.write=q;
	  r = this.inflate_fast(this.lbits, this.dbits,
			   this.ltree, this.ltree_index,
			   this.dtree, this.dtree_index,
			   s, z);

	  p=z.next_in_index;n=z.avail_in;b=s.bitb;k=s.bitk;
	  q=s.write;m=q<s.read?s.read-q-1:s.end-q;

	  if (r != Z_OK){
	    this.mode = r == Z_STREAM_END ? IC_WASH : IC_BADCODE;
	    break;
	  }
	}
	this.need = this.lbits;
	this.tree = this.ltree;
	this.tree_index=this.ltree_index;

	this.mode = IC_LEN;
      case IC_LEN:           // i: get length/literal/eob next
	j = this.need;

	while(k<(j)){
	  if(n!=0)r=Z_OK;
	  else{

	    s.bitb=b;s.bitk=k;
	    z.avail_in=n;z.total_in+=p-z.next_in_index;z.next_in_index=p;
	    s.write=q;
	    return s.inflate_flush(z,r);
	  }
	  n--;
	  b|=(z.next_in[p++]&0xff)<<k;
	  k+=8;
	}

	tindex=(this.tree_index+(b&inflate_mask[j]))*3;

	b>>>=(this.tree[tindex+1]);
	k-=(this.tree[tindex+1]);

	e=this.tree[tindex];

	if(e == 0){               // literal
	  this.lit = this.tree[tindex+2];
	  this.mode = IC_LIT;
	  break;
	}
	if((e & 16)!=0 ){          // length
	  this.get = e & 15;
	  this.len = this.tree[tindex+2];
	  this.mode = IC_LENEXT;
	  break;
	}
	if ((e & 64) == 0){        // next table
	  this.need = e;
	  this.tree_index = tindex/3 + this.tree[tindex+2];
	  break;
	}
	if ((e & 32)!=0){               // end of block
	  this.mode = IC_WASH;
	  break;
	}
	this.mode = IC_BADCODE;        // invalid code
	z.msg = "invalid literal/length code";
	r = Z_DATA_ERROR;

	s.bitb=b;s.bitk=k;
	z.avail_in=n;z.total_in+=p-z.next_in_index;z.next_in_index=p;
	s.write=q;
	return s.inflate_flush(z,r);

      case IC_LENEXT:        // i: getting length extra (have base)
	j = this.get;

	while(k<(j)){
	  if(n!=0)r=Z_OK;
	  else{

	    s.bitb=b;s.bitk=k;
	    z.avail_in=n;z.total_in+=p-z.next_in_index;z.next_in_index=p;
	    s.write=q;
	    return s.inflate_flush(z,r);
	  }
	  n--; b|=(z.next_in[p++]&0xff)<<k;
	  k+=8;
	}

	this.len += (b & inflate_mask[j]);

	b>>=j;
	k-=j;

	this.need = this.dbits;
	this.tree = this.dtree;
	this.tree_index = this.dtree_index;
	this.mode = IC_DIST;
      case IC_DIST:          // i: get distance next
	j = this.need;

	while(k<(j)){
	  if(n!=0)r=Z_OK;
	  else{

	    s.bitb=b;s.bitk=k;
	    z.avail_in=n;z.total_in+=p-z.next_in_index;z.next_in_index=p;
	    s.write=q;
	    return s.inflate_flush(z,r);
	  }
	  n--; b|=(z.next_in[p++]&0xff)<<k;
	  k+=8;
	}

	tindex=(this.tree_index+(b & inflate_mask[j]))*3;

	b>>=this.tree[tindex+1];
	k-=this.tree[tindex+1];

	e = (this.tree[tindex]);
	if((e & 16)!=0){               // distance
	  this.get = e & 15;
	  this.dist = this.tree[tindex+2];
	  this.mode = IC_DISTEXT;
	  break;
	}
	if ((e & 64) == 0){        // next table
	  this.need = e;
	  this.tree_index = tindex/3 + this.tree[tindex+2];
	  break;
	}
	this.mode = IC_BADCODE;        // invalid code
	z.msg = "invalid distance code";
	r = Z_DATA_ERROR;

	s.bitb=b;s.bitk=k;
	z.avail_in=n;z.total_in+=p-z.next_in_index;z.next_in_index=p;
	s.write=q;
	return s.inflate_flush(z,r);

      case IC_DISTEXT:       // i: getting distance extra
	j = this.get;

	while(k<(j)){
	  if(n!=0)r=Z_OK;
	  else{

	    s.bitb=b;s.bitk=k;
	    z.avail_in=n;z.total_in+=p-z.next_in_index;z.next_in_index=p;
	    s.write=q;
	    return s.inflate_flush(z,r);
	  }
	  n--; b|=(z.next_in[p++]&0xff)<<k;
	  k+=8;
	}

	this.dist += (b & inflate_mask[j]);

	b>>=j;
	k-=j;

	this.mode = IC_COPY;
      case IC_COPY:          // o: copying bytes in window, waiting for space
        f = q - this.dist;
        while(f < 0){     // modulo window size-"while" instead
          f += s.end;     // of "if" handles invalid distances
	}
	while (this.len!=0){

	  if(m==0){
	    if(q==s.end&&s.read!=0){q=0;m=q<s.read?s.read-q-1:s.end-q;}
	    if(m==0){
	      s.write=q; r=s.inflate_flush(z,r);
	      q=s.write;m=q<s.read?s.read-q-1:s.end-q;

	      if(q==s.end&&s.read!=0){q=0;m=q<s.read?s.read-q-1:s.end-q;}

	      if(m==0){
		s.bitb=b;s.bitk=k;
		z.avail_in=n;z.total_in+=p-z.next_in_index;z.next_in_index=p;
		s.write=q;
		return s.inflate_flush(z,r);
	      }
	    }
	  }

	  s.window[q++]=s.window[f++]; m--;

	  if (f == s.end)
            f = 0;
	  this.len--;
	}
	this.mode = IC_START;
	break;
      case IC_LIT:           // o: got literal, waiting for output space
	if(m==0){
	  if(q==s.end&&s.read!=0){q=0;m=q<s.read?s.read-q-1:s.end-q;}
	  if(m==0){
	    s.write=q; r=s.inflate_flush(z,r);
	    q=s.write;m=q<s.read?s.read-q-1:s.end-q;

	    if(q==s.end&&s.read!=0){q=0;m=q<s.read?s.read-q-1:s.end-q;}
	    if(m==0){
	      s.bitb=b;s.bitk=k;
	      z.avail_in=n;z.total_in+=p-z.next_in_index;z.next_in_index=p;
	      s.write=q;
	      return s.inflate_flush(z,r);
	    }
	  }
	}
	r=Z_OK;

	s.window[q++]=this.lit; m--;

	this.mode = IC_START;
	break;
      case IC_WASH:           // o: got eob, possibly more output
	if (k > 7){        // return unused byte, if any
	  k -= 8;
	  n++;
	  p--;             // can always return one
	}

	s.write=q; r=s.inflate_flush(z,r);
	q=s.write;m=q<s.read?s.read-q-1:s.end-q;

	if (s.read != s.write){
	  s.bitb=b;s.bitk=k;
	  z.avail_in=n;z.total_in+=p-z.next_in_index;z.next_in_index=p;
	  s.write=q;
	  return s.inflate_flush(z,r);
	}
	this.mode = IC_END;
      case IC_END:
	r = Z_STREAM_END;
	s.bitb=b;s.bitk=k;
	z.avail_in=n;z.total_in+=p-z.next_in_index;z.next_in_index=p;
	s.write=q;
	return s.inflate_flush(z,r);

      case IC_BADCODE:       // x: got error

	r = Z_DATA_ERROR;

	s.bitb=b;s.bitk=k;
	z.avail_in=n;z.total_in+=p-z.next_in_index;z.next_in_index=p;
	s.write=q;
	return s.inflate_flush(z,r);

      default:
	r = Z_STREAM_ERROR;

	s.bitb=b;s.bitk=k;
	z.avail_in=n;z.total_in+=p-z.next_in_index;z.next_in_index=p;
	s.write=q;
	return s.inflate_flush(z,r);
      }
    }
  }

InfCodes.prototype.free = function(z){
    //  ZFREE(z, c);
}

  // Called with number of bytes left to write in window at least 258
  // (the maximum string length) and number of input bytes available
  // at least ten.  The ten bytes are six bytes for the longest length/
  // distance pair plus four bytes for overloading the bit buffer.

InfCodes.prototype.inflate_fast = function(bl, bd, tl, tl_index, td, td_index, s, z) {
    var t;                // temporary pointer
    var   tp;             // temporary pointer (int[])
    var tp_index;         // temporary pointer
    var e;                // extra bits or operation
    var b;                // bit buffer
    var k;                // bits in bit buffer
    var p;                // input data pointer
    var n;                // bytes available there
    var q;                // output window write pointer
    var m;                // bytes to end of window or read pointer
    var ml;               // mask for literal/length tree
    var md;               // mask for distance tree
    var c;                // bytes to copy
    var d;                // distance back to copy from
    var r;                // copy source pointer

    var tp_index_t_3;     // (tp_index+t)*3

    // load input, output, bit values
    p=z.next_in_index;n=z.avail_in;b=s.bitb;k=s.bitk;
    q=s.write;m=q<s.read?s.read-q-1:s.end-q;

    // initialize masks
    ml = inflate_mask[bl];
    md = inflate_mask[bd];

    // do until not enough input or output space for fast loop
    do {                          // assume called with m >= 258 && n >= 10
      // get literal/length code
      while(k<(20)){              // max bits for literal/length code
	n--;
	b|=(z.next_in[p++]&0xff)<<k;k+=8;
      }

      t= b&ml;
      tp=tl;
      tp_index=tl_index;
      tp_index_t_3=(tp_index+t)*3;
      if ((e = tp[tp_index_t_3]) == 0){
	b>>=(tp[tp_index_t_3+1]); k-=(tp[tp_index_t_3+1]);

	s.window[q++] = tp[tp_index_t_3+2];
	m--;
	continue;
      }
      do {

	b>>=(tp[tp_index_t_3+1]); k-=(tp[tp_index_t_3+1]);

	if((e&16)!=0){
	  e &= 15;
	  c = tp[tp_index_t_3+2] + (b & inflate_mask[e]);

	  b>>=e; k-=e;

	  // decode distance base of block to copy
	  while(k<(15)){           // max bits for distance code
	    n--;
	    b|=(z.next_in[p++]&0xff)<<k;k+=8;
	  }

	  t= b&md;
	  tp=td;
	  tp_index=td_index;
          tp_index_t_3=(tp_index+t)*3;
	  e = tp[tp_index_t_3];

	  do {

	    b>>=(tp[tp_index_t_3+1]); k-=(tp[tp_index_t_3+1]);

	    if((e&16)!=0){
	      // get extra bits to add to distance base
	      e &= 15;
	      while(k<(e)){         // get extra bits (up to 13)
		n--;
		b|=(z.next_in[p++]&0xff)<<k;k+=8;
	      }

	      d = tp[tp_index_t_3+2] + (b&inflate_mask[e]);

	      b>>=(e); k-=(e);

	      // do the copy
	      m -= c;
	      if (q >= d){                // offset before dest
		//  just copy
		r=q-d;
		if(q-r>0 && 2>(q-r)){
		  s.window[q++]=s.window[r++]; // minimum count is three,
		  s.window[q++]=s.window[r++]; // so unroll loop a little
		  c-=2;
		}
		else{
		  s.window[q++]=s.window[r++]; // minimum count is three,
		  s.window[q++]=s.window[r++]; // so unroll loop a little
		  c-=2;
		}
	      }
	      else{                  // else offset after destination
                r=q-d;
                do{
                  r+=s.end;          // force pointer in window
                }while(r<0);         // covers invalid distances
		e=s.end-r;
		if(c>e){             // if source crosses,
		  c-=e;              // wrapped copy
		  if(q-r>0 && e>(q-r)){
		    do{s.window[q++] = s.window[r++];}
		    while(--e!=0);
		  }
		  else{
		    arrayCopy(s.window, r, s.window, q, e);
		    q+=e; r+=e; e=0;
		  }
		  r = 0;                  // copy rest from start of window
		}

	      }

	      // copy all or what's left
              do{s.window[q++] = s.window[r++];}
		while(--c!=0);
	      break;
	    }
	    else if((e&64)==0){
	      t+=tp[tp_index_t_3+2];
	      t+=(b&inflate_mask[e]);
	      tp_index_t_3=(tp_index+t)*3;
	      e=tp[tp_index_t_3];
	    }
	    else{
	      z.msg = "invalid distance code";

	      c=z.avail_in-n;c=(k>>3)<c?k>>3:c;n+=c;p-=c;k-=c<<3;

	      s.bitb=b;s.bitk=k;
	      z.avail_in=n;z.total_in+=p-z.next_in_index;z.next_in_index=p;
	      s.write=q;

	      return Z_DATA_ERROR;
	    }
	  }
	  while(true);
	  break;
	}

	if((e&64)==0){
	  t+=tp[tp_index_t_3+2];
	  t+=(b&inflate_mask[e]);
	  tp_index_t_3=(tp_index+t)*3;
	  if((e=tp[tp_index_t_3])==0){

	    b>>=(tp[tp_index_t_3+1]); k-=(tp[tp_index_t_3+1]);

	    s.window[q++]=tp[tp_index_t_3+2];
	    m--;
	    break;
	  }
	}
	else if((e&32)!=0){

	  c=z.avail_in-n;c=(k>>3)<c?k>>3:c;n+=c;p-=c;k-=c<<3;

	  s.bitb=b;s.bitk=k;
	  z.avail_in=n;z.total_in+=p-z.next_in_index;z.next_in_index=p;
	  s.write=q;

	  return Z_STREAM_END;
	}
	else{
	  z.msg="invalid literal/length code";

	  c=z.avail_in-n;c=(k>>3)<c?k>>3:c;n+=c;p-=c;k-=c<<3;

	  s.bitb=b;s.bitk=k;
	  z.avail_in=n;z.total_in+=p-z.next_in_index;z.next_in_index=p;
	  s.write=q;

	  return Z_DATA_ERROR;
	}
      }
      while(true);
    }
    while(m>=258 && n>= 10);

    // not enough input or output--restore pointers and return
    c=z.avail_in-n;c=(k>>3)<c?k>>3:c;n+=c;p-=c;k-=c<<3;

    s.bitb=b;s.bitk=k;
    z.avail_in=n;z.total_in+=p-z.next_in_index;z.next_in_index=p;
    s.write=q;

    return Z_OK;
}

//
// InfTree.java
//

function InfTree() {
}

InfTree.prototype.huft_build = function(b, bindex, n, s, d, e, t, m, hp, hn, v) {

    // Given a list of code lengths and a maximum table size, make a set of
    // tables to decode that set of codes.  Return Z_OK on success, Z_BUF_ERROR
    // if the given code set is incomplete (the tables are still built in this
    // case), Z_DATA_ERROR if the input is invalid (an over-subscribed set of
    // lengths), or Z_MEM_ERROR if not enough memory.

    var a;                       // counter for codes of length k
    var f;                       // i repeats in table every f entries
    var g;                       // maximum code length
    var h;                       // table level
    var i;                       // counter, current code
    var j;                       // counter
    var k;                       // number of bits in current code
    var l;                       // bits per table (returned in m)
    var mask;                    // (1 << w) - 1, to avoid cc -O bug on HP
    var p;                       // pointer into c[], b[], or v[]
    var q;                       // points to current table
    var w;                       // bits before this table == (l * h)
    var xp;                      // pointer into x
    var y;                       // number of dummy codes added
    var z;                       // number of entries in current table

    // Generate counts for each bit length

    p = 0; i = n;
    do {
      this.c[b[bindex+p]]++; p++; i--;   // assume all entries <= BMAX
    }while(i!=0);

    if(this.c[0] == n){                // null input--all zero length codes
      t[0] = -1;
      m[0] = 0;
      return Z_OK;
    }

    // Find minimum and maximum length, bound *m by those
    l = m[0];
    for (j = 1; j <= BMAX; j++)
      if(this.c[j]!=0) break;
    k = j;                        // minimum code length
    if(l < j){
      l = j;
    }
    for (i = BMAX; i!=0; i--){
      if(this.c[i]!=0) break;
    }
    g = i;                        // maximum code length
    if(l > i){
      l = i;
    }
    m[0] = l;

    // Adjust last length count to fill out codes, if needed
    for (y = 1 << j; j < i; j++, y <<= 1){
      if ((y -= this.c[j]) < 0){
        return Z_DATA_ERROR;
      }
    }
    if ((y -= this.c[i]) < 0){
      return Z_DATA_ERROR;
    }
    this.c[i] += y;

    // Generate starting offsets into the value table for each length
    this.x[1] = j = 0;
    p = 1;  xp = 2;
    while (--i!=0) {                 // note that i == g from above
      this.x[xp] = (j += this.c[p]);
      xp++;
      p++;
    }

    // Make a table of values in order of bit lengths
    i = 0; p = 0;
    do {
      if ((j = b[bindex+p]) != 0){
        this.v[this.x[j]++] = i;
      }
      p++;
    }
    while (++i < n);
    n = this.x[g];                     // set n to length of v

    // Generate the Huffman codes and for each, make the table entries
    this.x[0] = i = 0;                 // first Huffman code is zero
    p = 0;                        // grab values in bit order
    h = -1;                       // no tables yet--level -1
    w = -l;                       // bits decoded == (l * h)
    this.u[0] = 0;                     // just to keep compilers happy
    q = 0;                        // ditto
    z = 0;                        // ditto

    // go through the bit lengths (k already is bits in shortest code)
    for (; k <= g; k++){
      a = this.c[k];
      while (a--!=0){
	// here i is the Huffman code of length k bits for value *p
	// make tables up to required level
        while (k > w + l){
          h++;
          w += l;                 // previous table always l bits
	  // compute minimum size table less than or equal to l bits
          z = g - w;
          z = (z > l) ? l : z;        // table size upper limit
          if((f=1<<(j=k-w))>a+1){     // try a k-w bit table
                                      // too few codes for k-w bit table
            f -= a + 1;               // deduct codes from patterns left
            xp = k;
            if(j < z){
              while (++j < z){        // try smaller tables up to z bits
                if((f <<= 1) <= this.c[++xp])
                  break;              // enough codes to use up j bits
                f -= this.c[xp];           // else deduct codes from patterns
              }
	    }
          }
          z = 1 << j;                 // table entries for j-bit table

	  // allocate new table
          if (this.hn[0] + z > MANY){       // (note: doesn't matter for fixed)
            return Z_DATA_ERROR;       // overflow of MANY
          }
          this.u[h] = q = /*hp+*/ this.hn[0];   // DEBUG
          this.hn[0] += z;

	  // connect to last table, if there is one
	  if(h!=0){
            this.x[h]=i;           // save pattern for backing up
            this.r[0]=j;     // bits in this table
            this.r[1]=l;     // bits to dump before this table
            j=i>>>(w - l);
            this.r[2] = (q - this.u[h-1] - j);               // offset to this table
            arrayCopy(this.r, 0, hp, (this.u[h-1]+j)*3, 3); // connect to last table
          }
          else{
            t[0] = q;               // first table is returned result
	  }
        }

	// set up table entry in r
        this.r[1] = (k - w);
        if (p >= n){
          this.r[0] = 128 + 64;      // out of values--invalid code
	}
        else if (v[p] < s){
          this.r[0] = (this.v[p] < 256 ? 0 : 32 + 64);  // 256 is end-of-block
          this.r[2] = this.v[p++];          // simple code is just the value
        }
        else{
          this.r[0]=(e[this.v[p]-s]+16+64); // non-simple--look up in lists
          this.r[2]=d[this.v[p++] - s];
        }

        // fill code-like entries with r
        f=1<<(k-w);
        for (j=i>>>w;j<z;j+=f){
          arrayCopy(this.r, 0, hp, (q+j)*3, 3);
	}

	// backwards increment the k-bit code i
        for (j = 1 << (k - 1); (i & j)!=0; j >>>= 1){
          i ^= j;
	}
        i ^= j;

	// backup over finished tables
        mask = (1 << w) - 1;      // needed on HP, cc -O bug
        while ((i & mask) != this.x[h]){
          h--;                    // don't need to update q
          w -= l;
          mask = (1 << w) - 1;
        }
      }
    }
    // Return Z_BUF_ERROR if we were given an incomplete table
    return y != 0 && g != 1 ? Z_BUF_ERROR : Z_OK;
}

InfTree.prototype.inflate_trees_bits = function(c, bb, tb, hp, z) {
    var result;
    this.initWorkArea(19);
    this.hn[0]=0;
    result = this.huft_build(c, 0, 19, 19, null, null, tb, bb, hp, this.hn, this.v);

    if(result == Z_DATA_ERROR){
      z.msg = "oversubscribed dynamic bit lengths tree";
    }
    else if(result == Z_BUF_ERROR || bb[0] == 0){
      z.msg = "incomplete dynamic bit lengths tree";
      result = Z_DATA_ERROR;
    }
    return result;
}

InfTree.prototype.inflate_trees_dynamic = function(nl, nd, c, bl, bd, tl, td, hp, z) {
    var result;

    // build literal/length tree
    this.initWorkArea(288);
    this.hn[0]=0;
    result = this.huft_build(c, 0, nl, 257, cplens, cplext, tl, bl, hp, this.hn, this.v);
    if (result != Z_OK || bl[0] == 0){
      if(result == Z_DATA_ERROR){
        z.msg = "oversubscribed literal/length tree";
      }
      else if (result != Z_MEM_ERROR){
        z.msg = "incomplete literal/length tree";
        result = Z_DATA_ERROR;
      }
      return result;
    }

    // build distance tree
    this.initWorkArea(288);
    result = this.huft_build(c, nl, nd, 0, cpdist, cpdext, td, bd, hp, this.hn, this.v);

    if (result != Z_OK || (bd[0] == 0 && nl > 257)){
      if (result == Z_DATA_ERROR){
        z.msg = "oversubscribed distance tree";
      }
      else if (result == Z_BUF_ERROR) {
        z.msg = "incomplete distance tree";
        result = Z_DATA_ERROR;
      }
      else if (result != Z_MEM_ERROR){
        z.msg = "empty distance tree with lengths";
        result = Z_DATA_ERROR;
      }
      return result;
    }

    return Z_OK;
}
/*
  static int inflate_trees_fixed(int[] bl,  //literal desired/actual bit depth
                                 int[] bd,  //distance desired/actual bit depth
                                 int[][] tl,//literal/length tree result
                                 int[][] td,//distance tree result
                                 ZStream z  //for memory allocation
				 ){

*/

function inflate_trees_fixed(bl, bd, tl, td, z) {
    bl[0]=fixed_bl;
    bd[0]=fixed_bd;
    tl[0]=fixed_tl;
    td[0]=fixed_td;
    return Z_OK;
}

InfTree.prototype.initWorkArea = function(vsize){
    if(this.hn==null){
        this.hn=new Int32Array(1);
        this.v=new Int32Array(vsize);
        this.c=new Int32Array(BMAX+1);
        this.r=new Int32Array(3);
        this.u=new Int32Array(BMAX);
        this.x=new Int32Array(BMAX+1);
    }
    if(this.v.length<vsize){
        this.v=new Int32Array(vsize);
    }
    for(var i=0; i<vsize; i++){this.v[i]=0;}
    for(var i=0; i<BMAX+1; i++){this.c[i]=0;}
    for(var i=0; i<3; i++){this.r[i]=0;}
//  for(int i=0; i<BMAX; i++){u[i]=0;}
    arrayCopy(this.c, 0, this.u, 0, BMAX);
//  for(int i=0; i<BMAX+1; i++){x[i]=0;}
    arrayCopy(this.c, 0, this.x, 0, BMAX+1);
}

var testArray = new Uint8Array(1);
var hasSubarray = (typeof testArray.subarray === 'function');
var hasSlice = false; /* (typeof testArray.slice === 'function'); */ // Chrome slice performance is so dire that we're currently not using it...

function arrayCopy(src, srcOffset, dest, destOffset, count) {
    if (count == 0) {
        return;
    }
    if (!src) {
        throw "Undef src";
    } else if (!dest) {
        throw "Undef dest";
    }

    if (srcOffset == 0 && count == src.length) {
        arrayCopy_fast(src, dest, destOffset);
    } else if (hasSubarray) {
        arrayCopy_fast(src.subarray(srcOffset, srcOffset + count), dest, destOffset);
    } else if (src.BYTES_PER_ELEMENT == 1 && count > 100) {
        arrayCopy_fast(new Uint8Array(src.buffer, src.byteOffset + srcOffset, count), dest, destOffset);
    } else {
        arrayCopy_slow(src, srcOffset, dest, destOffset, count);
    }

}

function arrayCopy_slow(src, srcOffset, dest, destOffset, count) {

    // dlog('_slow call: srcOffset=' + srcOffset + '; destOffset=' + destOffset + '; count=' + count);

     for (var i = 0; i < count; ++i) {
        dest[destOffset + i] = src[srcOffset + i];
    }
}

function arrayCopy_fast(src, dest, destOffset) {
    dest.set(src, destOffset);
}


  // largest prime smaller than 65536
var ADLER_BASE=65521;
  // NMAX is the largest n such that 255n(n+1)/2 + (n+1)(BASE-1) <= 2^32-1
var ADLER_NMAX=5552;

function adler32(adler, /* byte[] */ buf,  index, len){
    if(buf == null){ return 1; }

    var s1=adler&0xffff;
    var s2=(adler>>16)&0xffff;
    var k;

    while(len > 0) {
      k=len<ADLER_NMAX?len:ADLER_NMAX;
      len-=k;
      while(k>=16){
        s1+=buf[index++]&0xff; s2+=s1;
        s1+=buf[index++]&0xff; s2+=s1;
        s1+=buf[index++]&0xff; s2+=s1;
        s1+=buf[index++]&0xff; s2+=s1;
        s1+=buf[index++]&0xff; s2+=s1;
        s1+=buf[index++]&0xff; s2+=s1;
        s1+=buf[index++]&0xff; s2+=s1;
        s1+=buf[index++]&0xff; s2+=s1;
        s1+=buf[index++]&0xff; s2+=s1;
        s1+=buf[index++]&0xff; s2+=s1;
        s1+=buf[index++]&0xff; s2+=s1;
        s1+=buf[index++]&0xff; s2+=s1;
        s1+=buf[index++]&0xff; s2+=s1;
        s1+=buf[index++]&0xff; s2+=s1;
        s1+=buf[index++]&0xff; s2+=s1;
        s1+=buf[index++]&0xff; s2+=s1;
        k-=16;
      }
      if(k!=0){
        do{
          s1+=buf[index++]&0xff; s2+=s1;
        }
        while(--k!=0);
      }
      s1%=ADLER_BASE;
      s2%=ADLER_BASE;
    }
    return (s2<<16)|s1;
}



function jszlib_inflate_buffer(buffer, start, length, afterUncOffset) {
    if (!start) {
        buffer = new Uint8Array(buffer);
    } else if (!length) {
        buffer = new Uint8Array(buffer, start, buffer.byteLength - start);
    } else {
        buffer = new Uint8Array(buffer, start, length);
    }

    var z = new ZStream();
    z.inflateInit(DEF_WBITS, true);
    z.next_in = buffer;
    z.next_in_index = 0;
    z.avail_in = buffer.length;

    var oBlockList = [];
    var totalSize = 0;
    while (true) {
        var obuf = new Uint8Array(32000);
        z.next_out = obuf;
        z.next_out_index = 0;
        z.avail_out = obuf.length;
        var status = z.inflate(Z_NO_FLUSH);
        if (status != Z_OK && status != Z_STREAM_END && status != Z_BUF_ERROR) {
            throw z.msg;
        }
        if (z.avail_out != 0) {
            var newob = new Uint8Array(obuf.length - z.avail_out);
            arrayCopy(obuf, 0, newob, 0, (obuf.length - z.avail_out));
            obuf = newob;
        }
        oBlockList.push(obuf);
        totalSize += obuf.length;
        if (status == Z_STREAM_END || status == Z_BUF_ERROR) {
            break;
        }
    }

    if (afterUncOffset) {
        afterUncOffset[0] = (start || 0) + z.next_in_index;
    }

    if (oBlockList.length == 1) {
        return oBlockList[0].buffer;
    } else {
        var out = new Uint8Array(totalSize);
        var cursor = 0;
        for (var i = 0; i < oBlockList.length; ++i) {
            var b = oBlockList[i];
            arrayCopy(b, 0, out, cursor, b.length);
            cursor += b.length;
        }
        return out.buffer;
    }
}

return {
    inflateBuffer: jszlib_inflate_buffer,
    arrayCopy: arrayCopy
  };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//     jQuery Ajax Native Plugin

//     (c) 2015 Tarik Zakaria Benmerar, Acigna Inc.
//      jQuery Ajax Native Plugin may be freely distributed under the MIT license.
(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports === 'object') {
        // Node. Does not work with strict CommonJS, but
        // only CommonJS-like environments that support module.exports,
        // like Node.
        module.exports = factory(require('jquery'));
    } else {
        // Browser globals (root is window)
        factory(root.jQuery);
    }
}(this, function ( $ ) {
    var ajaxSettings = $.ajaxSettings;
    ajaxSettings.responseFields.native = 'responseNative';
    ajaxSettings.converters[ '* native' ] = true;
    var support = {},
        xhrId = 0,
        xhrSuccessStatus = {
            // file protocol always yields status code 0, assume 200
            0: 200,
            // Support: IE9
            // #1450: sometimes IE returns 1223 when it should be 204
            1223: 204
        },
        xhrCallbacks = {},
        xhrSupported = jQuery.ajaxSettings.xhr();
    // Support: IE9
    // Open requests must be manually aborted on unload (#5280)
    if ( window.ActiveXObject ) {
        $( window ).on( "unload", function() {
            for ( var key in xhrCallbacks ) {
                xhrCallbacks[ key ]();
            }
        });
    }
    support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
    support.ajax = xhrSupported = !!xhrSupported;

    //Native Data Type Ajax Transport
    $.ajaxTransport('native', function ( options ) {
        var callback;
        // Cross domain only allowed if supported through XMLHttpRequest
        if ( support.cors || xhrSupported && !options.crossDomain ) {
            return {
                send: function( headers, complete ) {
                    var i,
                        xhr = options.xhr(),
                        id = ++xhrId,
                        responses = {};

                    xhr.open( options.type, options.url, options.async, options.username, options.password );

                    // Apply custom fields if provided
                    if ( options.xhrFields ) {
                        for ( i in options.xhrFields ) {
                            xhr[ i ] = options.xhrFields[ i ];
                        }
                    }

                    // Override mime type if needed
                    if ( options.mimeType && xhr.overrideMimeType ) {
                        xhr.overrideMimeType( options.mimeType );
                    }

                    // X-Requested-With header
                    // For cross-domain requests, seeing as conditions for a preflight are
                    // akin to a jigsaw puzzle, we simply never set it to be sure.
                    // (it can always be set on a per-request basis or even using ajaxSetup)
                    // For same-domain requests, won't change header if already provided.
                    if ( !options.crossDomain && !headers["X-Requested-With"] ) {
                        headers["X-Requested-With"] = "XMLHttpRequest";
                    }

                    // Set headers
                    for ( i in headers ) {
                        xhr.setRequestHeader( i, headers[ i ] );
                    }

                    // Callback
                    callback = function( type ) {
                        return function() {
                            if ( callback ) {
                                delete xhrCallbacks[ id ];
                                callback = xhr.onload = xhr.onerror = null;

                                if ( type === "abort" ) {
                                    xhr.abort();
                                } else if ( type === "error" ) {
                                    complete(
                                        // file: protocol always yields status 0; see #8605, #14207
                                        xhr.status,
                                        xhr.statusText
                                    );
                                } else {
                                    // The native response associated with the responseType
                                    // Stored in the xhr.response attribute (XHR2 Spec)
                                    if ( xhr.response ) {
                                        responses.native = xhr.response;
                                    }

                                    complete(
                                        xhrSuccessStatus[ xhr.status ] || xhr.status,
                                        xhr.statusText,
                                        responses,
                                        xhr.getAllResponseHeaders()
                                    );
                                }
                            }
                        };
                    };

                    // Listen to events
                    xhr.onload = callback();
                    xhr.onerror = callback("error");

                    // Create the abort callback
                    callback = xhrCallbacks[ id ] = callback("abort");

                    try {
                        // Do send the request (this may raise an exception)
                        xhr.send( options.hasContent && options.data || null );
                    } catch ( e ) {
                        // #14683: Only rethrow if this hasn't been notified as an error yet
                        if ( callback ) {
                            throw e;
                        }
                    }
                },

                abort: function() {
                    if ( callback ) {
                        callback();
                    }
                }
            };
        }
    });


    //$.getNative wrapper
    $.getNative = function ( url, callback ) {
        return $.ajax({
            dataType: 'native',
            url: url,
            xhrFields: {
                responseType: 'arraybuffer'
            },
            success: callback
        });
    }
}));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _backbone = __webpack_require__(7);

var Backbone = _interopRequireWildcard(_backbone);

var _underscore = __webpack_require__(1);

var _ = _interopRequireWildcard(_underscore);

var _baseMvc = __webpack_require__(6);

var _baseMvc2 = _interopRequireDefault(_baseMvc);

var _localization = __webpack_require__(3);

var _localization2 = _interopRequireDefault(_localization);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/* global $ */

var logNamespace = "user";
//==============================================================================
/** @class View to display a user's disk/storage usage
 *      either as a progress bar representing the percentage of a quota used
 *      or a simple text element displaying the human readable size used.
 *  @name UserQuotaMeter
 *  @augments Backbone.View
 */
var UserQuotaMeter = Backbone.View.extend(_baseMvc2.default.LoggableMixin).extend(
/** @lends UserQuotaMeter.prototype */{
    _logNamespace: logNamespace,

    /** Defaults for optional settings passed to initialize */
    options: {
        warnAtPercent: 85,
        errorAtPercent: 100
    },

    /** Set up, accept options, and bind events */
    initialize: function initialize(options) {
        this.log(this + ".initialize:", options);
        _.extend(this.options, options);

        //this.bind( 'all', function( event, data ){ this.log( this + ' event:', event, data ); }, this );
        this.listenTo(this.model, "change:quota_percent change:total_disk_usage", this.render);
    },

    /** Re-load user model data from the api */
    update: function update(options) {
        this.log(this + " updating user data...", options);
        this.model.loadFromApi(this.model.get("id"), options);
        return this;
    },

    /** Is the user over their quota (if there is one)?
     * @returns {Boolean} true if over quota, false if no quota or under quota
     */
    isOverQuota: function isOverQuota() {
        return this.model.get("quota_percent") !== null && this.model.get("quota_percent") >= this.options.errorAtPercent;
    },

    /** Render the meter when they have an applicable quota. Will render as a progress bar
     *      with their percentage of that quota in text over the bar.
     *  @fires quota:over when user is over quota (>= this.errorAtPercent)
     *  @fires quota:under when user is under quota
     *  @fires quota:under:approaching when user is >= this.warnAtPercent of their quota
     *  @fires quota:under:ok when user is below this.warnAtPercent
     *  @returns {jQuery} the rendered meter
     */
    _render_quota: function _render_quota() {
        var modelJson = this.model.toJSON();

        var //prevPercent = this.model.previous( 'quota_percent' ),
        percent = modelJson.quota_percent;

        var //meter = $( UserQuotaMeter.templates.quota( modelJson ) );
        $meter = $(this._templateQuotaMeter(modelJson));

        var $bar = $meter.find(".progress-bar");
        //this.log( this + '.rendering quota, percent:', percent, 'meter:', meter );

        // OVER QUOTA: color the quota bar and show the quota error message
        if (this.isOverQuota()) {
            //this.log( '\t over quota' );
            $bar.attr("class", "progress-bar bg-danger");
            $meter.find(".quota-meter-text").css("color", "white");
            //TODO: only trigger event if state has changed
            this.trigger("quota:over", modelJson);

            // APPROACHING QUOTA: color the quota bar
        } else if (percent >= this.options.warnAtPercent) {
            //this.log( '\t approaching quota' );
            $bar.attr("class", "progress-bar bg-warning");
            //TODO: only trigger event if state has changed
            this.trigger("quota:under quota:under:approaching", modelJson);

            // otherwise, hide/don't use the msg box
        } else {
            $bar.attr("class", "progress-bar bg-success");
            //TODO: only trigger event if state has changed
            this.trigger("quota:under quota:under:ok", modelJson);
        }
        return $meter;
    },

    /** Render the meter when the user has NO applicable quota. Will render as text
     *      showing the human readable sum storage their data is using.
     *  @returns {jQuery} the rendered text
     */
    _render_usage: function _render_usage() {
        //var usage = $( UserQuotaMeter.templates.usage( this.model.toJSON() ) );
        var usage = $(this._templateUsage(this.model.toJSON()));
        this.log(this + ".rendering usage:", usage);
        return usage;
    },

    /** Render either the quota percentage meter or the human readable disk usage
     *      depending on whether the user model has quota info (quota_percent === null -> no quota)
     *  @returns {Object} this UserQuotaMeter
     */
    render: function render() {
        //this.log( this + '.rendering' );
        var meterHtml = null;

        // no quota on server ('quota_percent' === null (can be valid at 0)), show usage instead
        this.log(this + ".model.quota_percent:", this.model.get("quota_percent"));
        if (this.model.get("quota_percent") === null || this.model.get("quota_percent") === undefined) {
            meterHtml = this._render_usage();

            // otherwise, render percent of quota (and warning, error)
        } else {
            meterHtml = this._render_quota();
            //TODO: add the original text for unregistered quotas
            //tooltip = "Your disk quota is %s.  You can increase your quota by registering a Galaxy account."
        }

        this.$el.html(meterHtml);
        this.$el.find(".quota-meter-text").tooltip();
        return this;
    },

    _templateQuotaMeter: function _templateQuotaMeter(data) {
        return ['<div id="quota-meter" class="quota-meter progress">', '<div class="progress-bar" style="width: ', data.quota_percent, '%"></div>', '<div class="quota-meter-text" data-placement="left" style="top: 6px"', data.nice_total_disk_usage ? " title=\"Using " + data.nice_total_disk_usage + ". Click for details.\">" : ">", '<a href="https://galaxyproject.org/support/account-quotas/" target="_blank">', (0, _localization2.default)("Using"), " ", data.quota_percent, "%", "</a>", "</div>", "</div>"].join("");
    },

    _templateUsage: function _templateUsage(data) {
        return ['<div id="quota-meter" class="quota-meter" style="background-color: transparent">', '<div class="quota-meter-text" data-placement="left" data-original-title="This value is recalculated when you log out." style="top: 6px; color: white">', data.nice_total_disk_usage ? (0, _localization2.default)("Using ") + data.nice_total_disk_usage : "", "</div>", "</div>"].join("");
    },

    toString: function toString() {
        return "UserQuotaMeter(" + this.model + ")";
    }
});

//==============================================================================
exports.default = {
    UserQuotaMeter: UserQuotaMeter
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_, jQuery, $) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _uiModal = __webpack_require__(19);

var _uiModal2 = _interopRequireDefault(_uiModal);

var _errorModal = __webpack_require__(165);

var _errorModal2 = _interopRequireDefault(_errorModal);

var _localization = __webpack_require__(3);

var _localization2 = _interopRequireDefault(_localization);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//==============================================================================
/**
 * A dialog/modal that allows copying a user history or 'importing' from user
 * another. Generally called via historyCopyDialog below.
 * @type {Object}
 */
var CopyDialog = {
    // language related strings/fns
    defaultName: _.template("Copy of '<%- name %>'"),
    title: _.template((0, _localization2.default)("Copying history") + " \"<%- name %>\""),
    submitLabel: (0, _localization2.default)("Copy"),
    errorMessage: (0, _localization2.default)("History could not be copied."),
    progressive: (0, _localization2.default)("Copying history"),
    activeLabel: (0, _localization2.default)("Copy only the active, non-deleted datasets"),
    allLabel: (0, _localization2.default)("Copy all datasets including deleted ones"),
    anonWarning: (0, _localization2.default)("As an anonymous user, unless you login or register, you will lose your current history ") + (0, _localization2.default)("after copying this history. "),

    // template for modal body
    _template: _.template([
    //TODO: remove inline styles
    // show a warning message for losing current to anon users
    "<% if( isAnon ){ %>", '<div class="warningmessage">', "<%- anonWarning %>", (0, _localization2.default)("You can"), ' <a href="/user/login">', (0, _localization2.default)("login here"), "</a> ", (0, _localization2.default)("or"), " ", ' <a href="/user/create">', (0, _localization2.default)("register here"), "</a>.", "</div>", "<% } %>", "<form>", '<label for="copy-modal-title">', (0, _localization2.default)("Enter a title for the new history"), ":", "</label><br />",
    // TODO: could use required here and the form validators
    // NOTE: use unescaped here if escaped in the modal function below
    '<input id="copy-modal-title" class="form-control" style="width: 100%" value="<%= name %>" />', '<p class="invalid-title bg-danger" style="color: red; margin: 8px 0px 8px 0px; display: none">', (0, _localization2.default)("Please enter a valid history title"), "</p>",
    // if allowAll, add the option to copy deleted datasets, too
    "<% if( allowAll ){ %>", "<br />", "<p>", (0, _localization2.default)("Choose which datasets from the original history to include:"), "</p>",
    // copy non-deleted is the default
    '<input name="copy-what" type="radio" id="copy-non-deleted" value="copy-non-deleted" ', '<% if( copyWhat === "copy-non-deleted" ){ print( "checked" ); } %>/>', '<label for="copy-non-deleted"> <%- activeLabel %></label>', "<br />", '<input name="copy-what" type="radio" id="copy-all" value="copy-all" ', '<% if( copyWhat === "copy-all" ){ print( "checked" ); } %>/>', '<label for="copy-all"> <%- allLabel %></label>', "<% } %>", "</form>"].join("")),

    // empty modal body and let the user know the copy is happening
    _showAjaxIndicator: function _showAjaxIndicator() {
        var indicator = "<p><span class=\"fa fa-spinner fa-spin\"></span> " + this.progressive + "...</p>";
        this.modal.$(".modal-body").empty().append(indicator).css({ "margin-top": "8px" });
    },

    // (sorta) public interface - display the modal, render the form, and potentially copy the history
    // returns a jQuery.Deferred done->history copied, fail->user cancelled
    dialog: function _dialog(modal, history, options) {
        options = options || {};

        var dialog = this;
        var deferred = jQuery.Deferred();

        var // TODO: getting a little byzantine here
        defaultCopyNameFn = options.nameFn || this.defaultName;

        var defaultCopyName = defaultCopyNameFn({
            name: history.get("name")
        });

        var // TODO: these two might be simpler as one 3 state option (all,active,no-choice)
        defaultCopyWhat = options.allDatasets ? "copy-all" : "copy-non-deleted";

        var allowAll = !_.isUndefined(options.allowAll) ? options.allowAll : true;

        var autoClose = !_.isUndefined(options.autoClose) ? options.autoClose : true;

        this.modal = modal;

        // validate the name and copy if good
        function checkNameAndCopy() {
            var name = modal.$("#copy-modal-title").val();
            if (!name) {
                modal.$(".invalid-title").show();
                return;
            }
            // get further settings, shut down and indicate the ajax call, then hide and resolve/reject
            var copyAllDatasets = modal.$('input[name="copy-what"]:checked').val() === "copy-all";
            modal.$("button").prop("disabled", true);
            dialog._showAjaxIndicator();
            history.copy(true, name, copyAllDatasets).done(function (response) {
                deferred.resolve(response);
            }).fail(function (xhr, status, message) {
                var options = {
                    name: name,
                    copyAllDatasets: copyAllDatasets
                };
                _errorModal2.default.ajaxErrorModal(history, xhr, options, dialog.errorMessage);
                deferred.rejectWith(deferred, arguments);
            }).done(function () {
                if (autoClose) {
                    modal.hide();
                }
            });
        }

        var originalClosingCallback = options.closing_callback;
        modal.show(_.extend(options, {
            title: this.title({ name: history.get("name") }),
            body: $(dialog._template({
                name: defaultCopyName,
                isAnon: Galaxy.user.isAnonymous(),
                allowAll: allowAll,
                copyWhat: defaultCopyWhat,
                activeLabel: this.activeLabel,
                allLabel: this.allLabel,
                anonWarning: this.anonWarning
            })),
            buttons: _.object([[(0, _localization2.default)("Cancel"), function () {
                modal.hide();
            }], [this.submitLabel, checkNameAndCopy]]),
            height: "auto",
            closing_events: true,
            closing_callback: function _historyCopyClose(cancelled) {
                if (cancelled) {
                    deferred.reject({ cancelled: true });
                }
                if (originalClosingCallback) {
                    originalClosingCallback(cancelled);
                }
            }
        }));

        // set the default dataset copy, autofocus the title, and set up for a simple return
        modal.$("#copy-modal-title").focus().select();
        modal.$("#copy-modal-title").on("keydown", function (ev) {
            if (ev.keyCode === 13) {
                ev.preventDefault();
                checkNameAndCopy();
            }
        });

        return deferred;
    }
};

//==============================================================================
// maintain the (slight) distinction between copy and import
/**
 * Subclass CopyDialog to use the import language.
 */
var ImportDialog = _.extend({}, CopyDialog, {
    defaultName: _.template("imported: <%- name %>"),
    title: _.template((0, _localization2.default)("Importing history") + " \"<%- name %>\""),
    submitLabel: (0, _localization2.default)("Import"),
    errorMessage: (0, _localization2.default)("History could not be imported."),
    progressive: (0, _localization2.default)("Importing history"),
    activeLabel: (0, _localization2.default)("Import only the active, non-deleted datasets"),
    allLabel: (0, _localization2.default)("Import all datasets including deleted ones"),
    anonWarning: (0, _localization2.default)("As an anonymous user, unless you login or register, you will lose your current history ") + (0, _localization2.default)("after importing this history. ")
});

//==============================================================================
/**
 * Main interface for both history import and history copy dialogs.
 * @param  {Backbone.Model} history     the history to copy
 * @param  {Object}         options     a hash
 * @return {jQuery.Deferred}            promise that fails on close and succeeds on copy
 *
 * options:
 *     (this object is also passed to the modal used to display the dialog and accepts modal options)
 *     {Function} nameFn    if defined, use this to build the default name shown to the user
 *                          (the fn is passed: {name: <original history's name>})
 *     {bool} useImport     if true, use the 'import' language (instead of Copy)
 *     {bool} allowAll      if true, allow the user to choose between copying all datasets and
 *                          only non-deleted datasets
 *     {String} allDatasets default initial checked radio button: 'copy-all' or 'copy-non-deleted',
 */
var historyCopyDialog = function historyCopyDialog(history, options) {
    options = options || {};
    // create our own modal if Galaxy doesn't have one (mako tab without use_panels)
    var modal = window.parent.Galaxy.modal || new _uiModal2.default.View({});
    return options.useImport ? ImportDialog.dialog(modal, history, options) : CopyDialog.dialog(modal, history, options);
};

//==============================================================================
exports.default = historyCopyDialog;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(0), __webpack_require__(0)))

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Backbone, $, _, jQuery) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _baseMvc = __webpack_require__(6);

var _baseMvc2 = _interopRequireDefault(_baseMvc);

var _localization = __webpack_require__(3);

var _localization2 = _interopRequireDefault(_localization);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var logNamespace = "list";
//==============================================================================
/** A view which, when first rendered, shows only summary data/attributes, but
 *      can be expanded to show further details (and optionally fetch those
 *      details from the server).
 */
var ExpandableView = Backbone.View.extend(_baseMvc2.default.LoggableMixin).extend({
    _logNamespace: logNamespace,

    //TODO: Although the reasoning behind them is different, this shares a lot with HiddenUntilActivated above: combine them
    //PRECONDITION: model must have method hasDetails
    //PRECONDITION: subclasses must have templates.el and templates.details

    initialize: function initialize(attributes) {
        /** are the details of this view expanded/shown or not? */
        this.expanded = attributes.expanded || false;
        this.log("\t expanded:", this.expanded);
        this.fxSpeed = attributes.fxSpeed !== undefined ? attributes.fxSpeed : this.fxSpeed;
    },

    // ........................................................................ render main
    /** jq fx speed */
    fxSpeed: "fast",

    /** Render this content, set up ui.
     *  @param {Number or String} speed   the speed of the render
     */
    render: function render(speed) {
        var $newRender = this._buildNewRender();
        this._setUpBehaviors($newRender);
        this._queueNewRender($newRender, speed);
        return this;
    },

    /** Build a temp div containing the new children for the view's $el.
     *      If the view is already expanded, build the details as well.
     */
    _buildNewRender: function _buildNewRender() {
        // create a new render using a skeleton template, render title buttons, render body, and set up events, etc.
        var $newRender = $(this.templates.el(this.model.toJSON(), this));
        if (this.expanded) {
            this.$details($newRender).replaceWith(this._renderDetails().show());
        }
        return $newRender;
    },

    /** Fade out the old el, swap in the new contents, then fade in.
     *  @param {Number or String} speed   jq speed to use for rendering effects
     *  @fires rendered when rendered
     */
    _queueNewRender: function _queueNewRender($newRender, speed) {
        speed = speed === undefined ? this.fxSpeed : speed;
        var view = this;

        if (speed === 0) {
            view._swapNewRender($newRender);
            view.trigger("rendered", view);
        } else {
            $(view).queue("fx", [function (next) {
                view.$el.fadeOut(speed, next);
            }, function (next) {
                view._swapNewRender($newRender);
                next();
            }, function (next) {
                view.$el.fadeIn(speed, next);
            }, function (next) {
                view.trigger("rendered", view);
                next();
            }]);
        }
    },

    /** empty out the current el, move the $newRender's children in */
    _swapNewRender: function _swapNewRender($newRender) {
        return this.$el.empty().attr("class", _.isFunction(this.className) ? this.className() : this.className).append($newRender.children());
    },

    /** set up js behaviors, event handlers for elements within the given container
     *  @param {jQuery} $container jq object that contains the elements to process (defaults to this.$el)
     */
    _setUpBehaviors: function _setUpBehaviors($where) {
        $where = $where || this.$el;
        // set up canned behavior on children (bootstrap, popupmenus, editable_text, etc.)
        //make_popup_menus( $where );
        $where.find("[title]").tooltip({ placement: "bottom" });
    },

    // ......................................................................... details
    /** shortcut to details DOM (as jQ) */
    $details: function $details($where) {
        $where = $where || this.$el;
        return $where.find("> .details");
    },

    /** build the DOM for the details and set up behaviors on it */
    _renderDetails: function _renderDetails() {
        var $newDetails = $(this.templates.details(this.model.toJSON(), this));
        this._setUpBehaviors($newDetails);
        return $newDetails;
    },

    // ......................................................................... expansion/details
    /** Show or hide the details
     *  @param {Boolean} expand if true, expand; if false, collapse
     */
    toggleExpanded: function toggleExpanded(expand) {
        expand = expand === undefined ? !this.expanded : expand;
        if (expand) {
            this.expand();
        } else {
            this.collapse();
        }
        return this;
    },

    /** Render and show the full, detailed body of this view including extra data and controls.
     *      note: if the model does not have detailed data, fetch that data before showing the body
     *  @fires expanded when a body has been expanded
     */
    expand: function expand() {
        var view = this;
        return view._fetchModelDetails().always(function () {
            view._expand();
        });
    },

    /** Check for model details and, if none, fetch them.
     *  @returns {jQuery.promise} the model.fetch.xhr if details are being fetched, an empty promise if not
     */
    _fetchModelDetails: function _fetchModelDetails() {
        if (!this.model.hasDetails()) {
            return this.model.fetch();
        }
        return jQuery.when();
    },

    /** Inner fn called when expand (public) has fetched the details */
    _expand: function _expand() {
        var view = this;
        var $newDetails = view._renderDetails();
        view.$details().replaceWith($newDetails);
        // needs to be set after the above or the slide will not show
        view.expanded = true;
        view.$details().slideDown(view.fxSpeed, function () {
            view.trigger("expanded", view);
        });
    },

    /** Hide the body/details of an HDA.
     *  @fires collapsed when a body has been collapsed
     */
    collapse: function collapse() {
        this.debug(this + "(ExpandableView).collapse");
        var view = this;
        view.expanded = false;
        this.$details().slideUp(view.fxSpeed, function () {
            view.trigger("collapsed", view);
        });
    }
});

//==============================================================================
/** A view that is displayed in some larger list/grid/collection.
 *      Inherits from Expandable, Selectable, Draggable.
 *  The DOM contains warnings, a title bar, and a series of primary action controls.
 *      Primary actions are meant to be easily accessible item functions (such as delete)
 *      that are rendered in the title bar.
 *
 *  Details are rendered when the user clicks the title bar or presses enter/space when
 *      the title bar is in focus.
 *
 *  Designed as a base class for history panel contents - but usable elsewhere (I hope).
 */
var ListItemView = ExpandableView.extend(_baseMvc2.default.mixin(_baseMvc2.default.SelectableViewMixin, _baseMvc2.default.DraggableViewMixin, {
    tagName: "div",
    className: "list-item",

    /** Set up the base class and all mixins */
    initialize: function initialize(attributes) {
        ExpandableView.prototype.initialize.call(this, attributes);
        _baseMvc2.default.SelectableViewMixin.initialize.call(this, attributes);
        _baseMvc2.default.DraggableViewMixin.initialize.call(this, attributes);
        this._setUpListeners();
    },

    /** event listeners */
    _setUpListeners: function _setUpListeners() {
        // hide the primary actions in the title bar when selectable and narrow
        this.on("selectable", function (isSelectable) {
            if (isSelectable) {
                this.$(".primary-actions").hide();
            } else {
                this.$(".primary-actions").show();
            }
        }, this);
        return this;
    },

    // ........................................................................ rendering
    /** In this override, call methods to build warnings, titlebar and primary actions */
    _buildNewRender: function _buildNewRender() {
        var $newRender = ExpandableView.prototype._buildNewRender.call(this);
        $newRender.children(".warnings").replaceWith(this._renderWarnings());
        $newRender.children(".title-bar").replaceWith(this._renderTitleBar());
        $newRender.children(".primary-actions").append(this._renderPrimaryActions());
        $newRender.find("> .title-bar .subtitle").replaceWith(this._renderSubtitle());
        return $newRender;
    },

    /** In this override, render the selector controls and set up dragging before the swap */
    _swapNewRender: function _swapNewRender($newRender) {
        ExpandableView.prototype._swapNewRender.call(this, $newRender);
        if (this.selectable) {
            this.showSelector(0);
        }
        if (this.draggable) {
            this.draggableOn();
        }
        return this.$el;
    },

    /** Render any warnings the item may need to show (e.g. "I'm deleted") */
    _renderWarnings: function _renderWarnings() {
        var view = this;
        var $warnings = $('<div class="warnings"></div>');
        var json = view.model.toJSON();
        //TODO:! unordered (map)
        _.each(view.templates.warnings, function (templateFn) {
            $warnings.append($(templateFn(json, view)));
        });
        return $warnings;
    },

    /** Render the title bar (the main/exposed SUMMARY dom element) */
    _renderTitleBar: function _renderTitleBar() {
        return $(this.templates.titleBar(this.model.toJSON(), this));
    },

    /** Return an array of jQ objects containing common/easily-accessible item controls */
    _renderPrimaryActions: function _renderPrimaryActions() {
        // override this
        return [];
    },

    /** Render the title bar (the main/exposed SUMMARY dom element) */
    _renderSubtitle: function _renderSubtitle() {
        return $(this.templates.subtitle(this.model.toJSON(), this));
    },

    // ......................................................................... events
    /** event map */
    events: {
        // expand the body when the title is clicked or when in focus and space or enter is pressed
        "click .title-bar": "_clickTitleBar",
        "keydown .title-bar": "_keyDownTitleBar",
        "click .selector": "toggleSelect"
    },

    /** expand when the title bar is clicked */
    _clickTitleBar: function _clickTitleBar(event) {
        event.stopPropagation();
        if (event.altKey) {
            this.toggleSelect(event);
            if (!this.selectable) {
                this.showSelector();
            }
        } else {
            this.toggleExpanded();
        }
    },

    /** expand when the title bar is in focus and enter or space is pressed */
    _keyDownTitleBar: function _keyDownTitleBar(event) {
        // bail (with propagation) if keydown and not space or enter
        var KEYCODE_SPACE = 32;

        var KEYCODE_RETURN = 13;
        if (event && event.type === "keydown" && (event.keyCode === KEYCODE_SPACE || event.keyCode === KEYCODE_RETURN)) {
            this.toggleExpanded();
            event.stopPropagation();
            return false;
        }
        return true;
    },

    // ......................................................................... misc
    /** String representation */
    toString: function toString() {
        var modelString = this.model ? "" + this.model : "(no model)";
        return "ListItemView(" + modelString + ")";
    }
}));

// ............................................................................ TEMPLATES
/** underscore templates */
ListItemView.prototype.templates = function () {
    var elTemplato = _baseMvc2.default.wrapTemplate(['<div class="list-element">',
    // errors, messages, etc.
    '<div class="warnings"></div>',

    // multi-select checkbox
    '<div class="selector">', '<span class="fa fa-2x fa-square-o"></span>', "</div>",
    // space for title bar buttons - gen. floated to the right
    '<div class="primary-actions"></div>', '<div class="title-bar"></div>',

    // expandable area for more details
    '<div class="details"></div>', "</div>"]);

    var warnings = {};

    var titleBarTemplate = _baseMvc2.default.wrapTemplate([
    // adding a tabindex here allows focusing the title bar and the use of keydown to expand the dataset display
    '<div class="title-bar clear" tabindex="0">',
    //TODO: prob. belongs in dataset-list-item
    '<span class="state-icon"></span>', '<div class="title">', '<span class="name"><%- element.name %></span>', "</div>", '<div class="subtitle"></div>', "</div>"], "element");

    var subtitleTemplate = _baseMvc2.default.wrapTemplate([
    // override this
    '<div class="subtitle"></div>']);

    var detailsTemplate = _baseMvc2.default.wrapTemplate([
    // override this
    '<div class="details"></div>']);

    return {
        el: elTemplato,
        warnings: warnings,
        titleBar: titleBarTemplate,
        subtitle: subtitleTemplate,
        details: detailsTemplate
    };
}();

//==============================================================================
/** A view that is displayed in some larger list/grid/collection.
 *  *AND* can display some sub-list of it's own when expanded (e.g. dataset collections).
 *  This list will 'foldout' when the item is expanded depending on this.foldoutStyle:
 *      If 'foldout': will expand vertically to show the nested list
 *      If 'drilldown': will overlay the parent list
 *
 *  Inherits from ListItemView.
 *
 *  _renderDetails does the work of creating this.details: a sub-view that shows the nested list
 */
var FoldoutListItemView = ListItemView.extend({
    /** If 'foldout': show the sub-panel inside the expanded item
     *  If 'drilldown': only fire events and handle by pub-sub
     *      (allow the panel containing this item to attach it, hide itself, etc.)
     */
    foldoutStyle: "foldout",
    /** Panel view class to instantiate for the sub-panel */
    foldoutPanelClass: null,

    /** override to:
     *      add attributes foldoutStyle and foldoutPanelClass for config poly
     *      disrespect attributes.expanded if drilldown
     */
    initialize: function initialize(attributes) {
        if (this.foldoutStyle === "drilldown") {
            this.expanded = false;
        }
        this.foldoutStyle = attributes.foldoutStyle || this.foldoutStyle;
        this.foldoutPanelClass = attributes.foldoutPanelClass || this.foldoutPanelClass;

        ListItemView.prototype.initialize.call(this, attributes);
        this.foldout = this._createFoldoutPanel();
    },

    /** in this override, attach the foldout panel when rendering details */
    _renderDetails: function _renderDetails() {
        if (this.foldoutStyle === "drilldown") {
            return $();
        }
        var $newDetails = ListItemView.prototype._renderDetails.call(this);
        return this._attachFoldout(this.foldout, $newDetails);
    },

    /** In this override, handle collection expansion. */
    _createFoldoutPanel: function _createFoldoutPanel() {
        var model = this.model;
        var FoldoutClass = this._getFoldoutPanelClass(model);
        var options = this._getFoldoutPanelOptions(model);

        var foldout = new FoldoutClass(_.extend(options, {
            model: model
        }));

        return foldout;
    },

    /** Stub to return proper foldout panel class */
    _getFoldoutPanelClass: function _getFoldoutPanelClass() {
        // override
        return this.foldoutPanelClass;
    },

    /** Stub to return proper foldout panel options */
    _getFoldoutPanelOptions: function _getFoldoutPanelOptions() {
        return {
            // propagate foldout style down
            foldoutStyle: this.foldoutStyle,
            fxSpeed: this.fxSpeed
        };
    },

    /** Render the foldout panel inside the view, hiding controls */
    _attachFoldout: function _attachFoldout(foldout, $whereTo) {
        $whereTo = $whereTo || this.$("> .details");
        this.foldout = foldout.render(0);
        foldout.$("> .controls").hide();
        return $whereTo.append(foldout.$el);
    },

    /** In this override, branch on foldoutStyle to show expanded */
    expand: function expand() {
        var view = this;
        return view._fetchModelDetails().always(function () {
            if (view.foldoutStyle === "foldout") {
                view._expand();
            } else if (view.foldoutStyle === "drilldown") {
                view._expandByDrilldown();
            }
        });
    },

    /** For drilldown, set up close handler and fire expanded:drilldown
     *      containing views can listen to this and handle other things
     *      (like hiding themselves) by listening for expanded/collapsed:drilldown
     */
    _expandByDrilldown: function _expandByDrilldown() {
        var view = this;
        // attachment and rendering done by listener
        view.listenTo(view.foldout, "close", function () {
            view.trigger("collapsed:drilldown", view, view.foldout);
        });
        view.trigger("expanded:drilldown", view, view.foldout);
    }
});

// ............................................................................ TEMPLATES
/** underscore templates */
FoldoutListItemView.prototype.templates = function () {
    var detailsTemplate = _baseMvc2.default.wrapTemplate(['<div class="details">',
    // override with more info (that goes above the panel)
    "</div>"], "collection");

    return _.extend({}, ListItemView.prototype.templates, {
        details: detailsTemplate
    });
}();

//==============================================================================
exports.default = {
    ExpandableView: ExpandableView,
    ListItemView: ListItemView,
    FoldoutListItemView: FoldoutListItemView
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(0), __webpack_require__(1), __webpack_require__(0)))

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _datasetModel = __webpack_require__(225);

var _datasetModel2 = _interopRequireDefault(_datasetModel);

var _historyContentModel = __webpack_require__(226);

var _historyContentModel2 = _interopRequireDefault(_historyContentModel);

var _baseMvc = __webpack_require__(6);

var _baseMvc2 = _interopRequireDefault(_baseMvc);

var _localization = __webpack_require__(3);

var _localization2 = _interopRequireDefault(_localization);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//==============================================================================
var _super = _datasetModel2.default.DatasetAssociation;

var hcontentMixin = _historyContentModel2.default.HistoryContentMixin;
/** @class (HDA) model for a Galaxy dataset contained in and related to a history.
 */
var HistoryDatasetAssociation = _super.extend(_baseMvc2.default.mixin(hcontentMixin,
/** @lends HistoryDatasetAssociation.prototype */{
    /** default attributes for a model */
    defaults: _.extend({}, _super.prototype.defaults, hcontentMixin.defaults, {
        history_content_type: "dataset",
        model_class: "HistoryDatasetAssociation"
    })
}));

//==============================================================================
exports.default = {
    HistoryDatasetAssociation: HistoryDatasetAssociation
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_, jQuery, Backbone, $) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _listItem = __webpack_require__(151);

var _listItem2 = _interopRequireDefault(_listItem);

var _states = __webpack_require__(59);

var _states2 = _interopRequireDefault(_states);

var _faIconButton = __webpack_require__(53);

var _faIconButton2 = _interopRequireDefault(_faIconButton);

var _baseMvc = __webpack_require__(6);

var _baseMvc2 = _interopRequireDefault(_baseMvc);

var _localization = __webpack_require__(3);

var _localization2 = _interopRequireDefault(_localization);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var logNamespace = "dataset";
/*==============================================================================
TODO:
    straighten out state rendering and templates used
    inaccessible/STATES.NOT_VIEWABLE is a special case
    simplify button rendering

==============================================================================*/
var _super = _listItem2.default.ListItemView;
/** @class Read only list view for either LDDAs, HDAs, or HDADCEs.
 *      Roughly, any DatasetInstance (and not a raw Dataset).
 */
var DatasetListItemView = _super.extend(
/** @lends DatasetListItemView.prototype */{
    _logNamespace: logNamespace,

    className: _super.prototype.className + " dataset",
    //TODO:?? doesn't exactly match an hda's type_id
    id: function id() {
        return ["dataset", this.model.get("id")].join("-");
    },

    /** Set up: instance vars, options, and event handlers */
    initialize: function initialize(attributes) {
        if (attributes.logger) {
            this.logger = this.model.logger = attributes.logger;
        }
        this.log(this + ".initialize:", attributes);
        _super.prototype.initialize.call(this, attributes);

        /** where should pages from links be displayed? (default to new tab/window) */
        this.linkTarget = attributes.linkTarget || "_blank";
    },

    /** event listeners */
    _setUpListeners: function _setUpListeners() {
        _super.prototype._setUpListeners.call(this);
        var self = this;

        // re-rendering on any model changes
        return self.listenTo(self.model, {
            change: function change(model) {
                // if the model moved into the ready state and is expanded without details, fetch those details now
                if (self.model.changedAttributes().state && self.model.inReadyState() && self.expanded && !self.model.hasDetails()) {
                    // normally, will render automatically (due to fetch -> change),
                    // but! setting_metadata sometimes doesn't cause any other changes besides state
                    // so, not rendering causes it to seem frozen in setting_metadata state
                    self.model.fetch({ silent: true }).done(function () {
                        self.render();
                    });
                } else {
                    if (_.has(model.changed, "tags") && _.keys(model.changed).length === 1) {
                        // If only the tags have changed, rerender specifically
                        // the titlebar region.  Otherwise default to the full
                        // render.
                        self.$(".nametags").html(self._renderNametags());
                    } else {
                        self.render();
                    }
                }
            }
        });
    },

    // ......................................................................... expandable
    /** In this override, only get details if in the ready state, get rerunnable if in other states.
     *  Note: fetch with no 'change' event triggering to prevent automatic rendering.
     */
    _fetchModelDetails: function _fetchModelDetails() {
        var view = this;
        if (view.model.inReadyState() && !view.model.hasDetails()) {
            return view.model.fetch({ silent: true });
        }
        return jQuery.when();
    },

    // ......................................................................... removal
    /** Remove this view's html from the DOM and remove all event listeners.
     *  @param {Number or String} speed jq effect speed
     *  @param {Function} callback      an optional function called when removal is done (scoped to this view)
     */
    remove: function remove(speed, callback) {
        var view = this;
        speed = speed || this.fxSpeed;
        this.$el.fadeOut(speed, function () {
            Backbone.View.prototype.remove.call(view);
            if (callback) {
                callback.call(view);
            }
        });
    },

    // ......................................................................... rendering
    /* TODO:
    dataset states are the issue primarily making dataset rendering complex
        each state should have it's own way of displaying/set of details
        often with different actions that can be applied
    throw in deleted/purged/visible and things get complicated easily
    I've considered (a couple of times) - creating a view for each state
        - but recreating the view during an update...seems wrong
    */
    /** In this override, add the dataset state as a class for use with state-based CSS */
    _swapNewRender: function _swapNewRender($newRender) {
        _super.prototype._swapNewRender.call(this, $newRender);
        if (this.model.has("state")) {
            this.$el.addClass("state-" + this.model.get("state"));
        }
        return this.$el;
    },

    // ................................................................................ titlebar
    /** In this override, add the dataset display button. */
    _renderPrimaryActions: function _renderPrimaryActions() {
        // render just the display for read-only
        return [this._renderDisplayButton()];
    },

    /** Render icon-button to display dataset data */
    _renderDisplayButton: function _renderDisplayButton() {
        // don't show display if not viewable or not accessible
        var state = this.model.get("state");
        if (state === _states2.default.NOT_VIEWABLE || state === _states2.default.DISCARDED || !this.model.get("accessible")) {
            return null;
        }

        var displayBtnData = {
            target: this.linkTarget,
            classes: "display-btn"
        };

        // show a disabled display if the data's been purged
        if (this.model.get("purged")) {
            displayBtnData.disabled = true;
            displayBtnData.title = (0, _localization2.default)("Cannot display datasets removed from disk");

            // disable if still uploading
        } else if (state === _states2.default.UPLOAD) {
            displayBtnData.disabled = true;
            displayBtnData.title = (0, _localization2.default)("This dataset must finish uploading before it can be viewed");

            // disable if still new
        } else if (state === _states2.default.NEW) {
            displayBtnData.disabled = true;
            displayBtnData.title = (0, _localization2.default)("This dataset is not yet viewable");
        } else {
            displayBtnData.title = (0, _localization2.default)("View data");

            // default link for dataset
            displayBtnData.href = this.model.urls.display;

            // add frame manager option onclick event
            var self = this;
            displayBtnData.onclick = function (ev) {
                if (Galaxy.frame && Galaxy.frame.active) {
                    // Add dataset to frames.
                    Galaxy.frame.addDataset(self.model.get("id"));
                    ev.preventDefault();
                }
            };
        }
        displayBtnData.faIcon = "fa-eye";
        return (0, _faIconButton2.default)(displayBtnData);
    },

    // ......................................................................... rendering details
    /** Render the enclosing div of the hda body and, if expanded, the html in the body
     *  @returns {jQuery} rendered DOM
     */
    _renderDetails: function _renderDetails() {
        //TODO: generalize to be allow different details for each state

        // no access - render nothing but a message
        if (this.model.get("state") === _states2.default.NOT_VIEWABLE) {
            return $(this.templates.noAccess(this.model.toJSON(), this));
        }

        var $details = _super.prototype._renderDetails.call(this);
        $details.find(".actions .left").empty().append(this._renderSecondaryActions());
        $details.find(".summary").html(this._renderSummary()).prepend(this._renderDetailMessages());
        $details.find(".display-applications").html(this._renderDisplayApplications());

        this._setUpBehaviors($details);
        return $details;
    },

    /** Defer to the appropo summary rendering fn based on state */
    _renderSummary: function _renderSummary() {
        var json = this.model.toJSON();
        var summaryRenderFn = this.templates.summaries[json.state];
        summaryRenderFn = summaryRenderFn || this.templates.summaries.unknown;
        return summaryRenderFn(json, this);
    },

    /** Render messages to be displayed only when the details are shown */
    _renderDetailMessages: function _renderDetailMessages() {
        var view = this;
        var $warnings = $('<div class="detail-messages"></div>');
        var json = view.model.toJSON();
        //TODO:! unordered (map)
        _.each(view.templates.detailMessages, function (templateFn) {
            $warnings.append($(templateFn(json, view)));
        });
        return $warnings;
    },

    /** Render the external display application links */
    _renderDisplayApplications: function _renderDisplayApplications() {
        if (this.model.isDeletedOrPurged()) {
            return "";
        }
        // render both old and new display apps using the same template
        return [this.templates.displayApplications(this.model.get("display_apps"), this), this.templates.displayApplications(this.model.get("display_types"), this)].join("");
    },

    // ......................................................................... secondary/details actions
    /** A series of links/buttons for less commonly used actions: re-run, info, etc. */
    _renderSecondaryActions: function _renderSecondaryActions() {
        this.debug("_renderSecondaryActions");
        switch (this.model.get("state")) {
            case _states2.default.NOT_VIEWABLE:
                return [];
            case _states2.default.OK:
            case _states2.default.FAILED_METADATA:
            case _states2.default.ERROR:
                return [this._renderDownloadButton(), this._renderShowParamsButton()];
        }
        return [this._renderShowParamsButton()];
    },

    /** Render icon-button to show the input and output (stdout/err) for the job that created this.
     *  @returns {jQuery} rendered DOM
     */
    _renderShowParamsButton: function _renderShowParamsButton() {
        // gen. safe to show in all cases
        return (0, _faIconButton2.default)({
            title: (0, _localization2.default)("View details"),
            classes: "params-btn",
            href: this.model.urls.show_params,
            target: this.linkTarget,
            faIcon: "fa-info-circle",
            onclick: function onclick(ev) {
                if (Galaxy.frame && Galaxy.frame.active) {
                    Galaxy.frame.add({
                        title: (0, _localization2.default)("Dataset details"),
                        url: this.href
                    });
                    ev.preventDefault();
                    ev.stopPropagation();
                }
            }
        });
    },

    /** Render icon-button/popupmenu to download the data (and/or the associated meta files (bai, etc.)) for this.
     *  @returns {jQuery} rendered DOM
     */
    _renderDownloadButton: function _renderDownloadButton() {
        // don't show anything if the data's been purged
        if (this.model.get("purged") || !this.model.hasData()) {
            return null;
        }

        // return either: a popupmenu with links to download assoc. meta files (if there are meta files)
        //  or a single download icon-button (if there are no meta files)
        if (!_.isEmpty(this.model.get("meta_files"))) {
            return this._renderMetaFileDownloadButton();
        }

        return $("\n                <a class=\"download-btn icon-btn\" href=\"" + this.model.urls.download + "\" title=\"" + (0, _localization2.default)("Download") + "\">\n                    <span class=\"fa fa-floppy-o\"></span>\n                </a>");
    },

    /** Render the download button which opens a dropdown with links to download assoc. meta files (indices, etc.) */
    _renderMetaFileDownloadButton: function _renderMetaFileDownloadButton() {
        var urls = this.model.urls;
        return $("\n                <div class=\"metafile-dropdown dropdown\">\n                    <a class=\"download-btn icon-btn\" href=\"" + urls.download + "\" data-toggle=\"dropdown\" title=\"" + (0, _localization2.default)("Download") + "\">\n                        <span class=\"fa fa-floppy-o\"></span>\n                    </a>\n                    <ul class=\"dropdown-menu\" role=\"menu\">\n                        <li>\n                            <a href=\"" + urls.download + "\">\n                                " + (0, _localization2.default)("Download dataset") + "\n                            </a>\n                        </li>\n                        " + _.map(this.model.get("meta_files"), function (meta_file) {
            return "<li>\n                                    <a href=\"" + (urls.meta_download + meta_file.file_type) + "\">\n                                        " + (0, _localization2.default)("Download") + " " + meta_file.file_type + "\n                                    </a>\n                                </li>";
        }) + "\n                    </ul>\n                </div>");
    },

    _renderNametags: function _renderNametags() {
        var tpl = _.template(["<% _.each(_.sortBy(_.uniq(tags), function(x) { return x }), function(tag){ %>", '<% if (tag.indexOf("name:") == 0){ %>', '<span class="badge badge-primary badge-tags"><%- tag.slice(5) %></span>', "<% } %>", "<% }); %>"].join(""));
        return tpl({ tags: this.model.get("tags") });
    },

    // ......................................................................... misc
    events: _.extend(_.clone(_super.prototype.events), {
        "click .display-btn": function clickDisplayBtn(ev) {
            this.trigger("display", this, ev);
        },
        "click .params-btn": function clickParamsBtn(ev) {
            this.trigger("params", this, ev);
        },
        "click .download-btn": function clickDownloadBtn(ev) {
            this.trigger("download", this, ev);
        }
    }),

    // ......................................................................... misc
    /** String representation */
    toString: function toString() {
        var modelString = this.model ? "" + this.model : "(no model)";
        return "DatasetListItemView(" + modelString + ")";
    }
});

// ............................................................................ TEMPLATES
/** underscore templates */
DatasetListItemView.prototype.templates = function () {
    //TODO: move to require text! plugin

    var warnings = _.extend({}, _super.prototype.templates.warnings, {
        failed_metadata: _baseMvc2.default.wrapTemplate([
        // failed metadata is rendered as a warning on an otherwise ok dataset view
        '<% if( model.state === "failed_metadata" ){ %>', '<div class="warningmessagesmall">', (0, _localization2.default)("An error occurred setting the metadata for this dataset"), "</div>", "<% } %>"]),
        error: _baseMvc2.default.wrapTemplate([
        // error during index fetch - show error on dataset
        "<% if( model.error ){ %>", '<div class="errormessagesmall">', (0, _localization2.default)("There was an error getting the data for this dataset"), ": <%- model.error %>", "</div>", "<% } %>"]),
        purged: _baseMvc2.default.wrapTemplate(["<% if( model.purged ){ %>", '<div class="purged-msg warningmessagesmall">', (0, _localization2.default)("This dataset has been deleted and removed from disk"), "</div>", "<% } %>"]),
        deleted: _baseMvc2.default.wrapTemplate([
        // deleted not purged
        "<% if( model.deleted && !model.purged ){ %>", '<div class="deleted-msg warningmessagesmall">', (0, _localization2.default)("This dataset has been deleted"), "</div>", "<% } %>"])

        //NOTE: hidden warning is only needed for HDAs
    });

    var detailsTemplate = _baseMvc2.default.wrapTemplate(['<div class="details">', '<div class="summary"></div>', '<div class="actions clear">', '<div class="left"></div>', '<div class="right"></div>', "</div>",

    // do not display tags, annotation, display apps, or peek when deleted
    "<% if( !dataset.deleted && !dataset.purged ){ %>", '<div class="tags-display"></div>', '<div class="annotation-display"></div>', '<div class="display-applications"></div>', "<% if( dataset.peek ){ %>", '<pre class="dataset-peek"><%= dataset.peek %></pre>', "<% } %>", "<% } %>", "</div>"], "dataset");

    var noAccessTemplate = _baseMvc2.default.wrapTemplate(['<div class="details">', '<div class="summary">', (0, _localization2.default)("You do not have permission to view this dataset"), "</div>", "</div>"], "dataset");

    //TODO: still toooooooooooooo complex - rework
    var summaryTemplates = {};
    summaryTemplates[_states2.default.OK] = summaryTemplates[_states2.default.FAILED_METADATA] = _baseMvc2.default.wrapTemplate(["<% if( dataset.misc_blurb ){ %>", '<div class="blurb">', '<span class="value"><%- dataset.misc_blurb %></span>', "</div>", "<% } %>", "<% if( dataset.file_ext ){ %>", '<div class="datatype">', '<label class="prompt">', (0, _localization2.default)("format"), "</label>", '<span class="value"><%- dataset.file_ext %></span>', "</div>", "<% } %>", "<% if( dataset.metadata_dbkey ){ %>", '<div class="dbkey">', '<label class="prompt">', (0, _localization2.default)("database"), "</label>", '<span class="value">', "<%- dataset.metadata_dbkey %>", "</span>", "</div>", "<% } %>", "<% if( dataset.misc_info ){ %>", '<div class="info">', '<span class="value"><%- dataset.misc_info %></span>', "</div>", "<% } %>"], "dataset");
    summaryTemplates[_states2.default.NEW] = _baseMvc2.default.wrapTemplate(["<div>", (0, _localization2.default)("This is a new dataset and not all of its data are available yet"), "</div>"], "dataset");
    summaryTemplates[_states2.default.NOT_VIEWABLE] = _baseMvc2.default.wrapTemplate(["<div>", (0, _localization2.default)("You do not have permission to view this dataset"), "</div>"], "dataset");
    summaryTemplates[_states2.default.DISCARDED] = _baseMvc2.default.wrapTemplate(["<div>", (0, _localization2.default)("The job creating this dataset was cancelled before completion"), "</div>"], "dataset");
    summaryTemplates[_states2.default.QUEUED] = _baseMvc2.default.wrapTemplate(["<div>", (0, _localization2.default)("This job is waiting to run"), "</div>"], "dataset");
    summaryTemplates[_states2.default.RUNNING] = _baseMvc2.default.wrapTemplate(["<div>", (0, _localization2.default)("This job is currently running"), "</div>"], "dataset");
    summaryTemplates[_states2.default.UPLOAD] = _baseMvc2.default.wrapTemplate(["<div>", (0, _localization2.default)("This dataset is currently uploading"), "</div>"], "dataset");
    summaryTemplates[_states2.default.SETTING_METADATA] = _baseMvc2.default.wrapTemplate(["<div>", (0, _localization2.default)("Metadata is being auto-detected"), "</div>"], "dataset");
    summaryTemplates[_states2.default.PAUSED] = _baseMvc2.default.wrapTemplate(["<div>", (0, _localization2.default)('This job is paused. Use the "Resume Paused Jobs" in the history menu to resume'), "</div>", '<div class="info"><%- dataset.misc_info %></div>'], "dataset");
    summaryTemplates[_states2.default.ERROR] = _baseMvc2.default.wrapTemplate(["<% if( !dataset.purged ){ %>", "<div><%- dataset.misc_blurb %></div>", "<% } %>", '<span class="help-text">', (0, _localization2.default)("An error occurred with this dataset"), ":</span>", '<div class="job-error-text"><%- dataset.misc_info %></div>'], "dataset");
    summaryTemplates[_states2.default.EMPTY] = _baseMvc2.default.wrapTemplate(["<div>", (0, _localization2.default)("No data"), ": <i><%- dataset.misc_blurb %></i></div>"], "dataset");
    summaryTemplates.unknown = _baseMvc2.default.wrapTemplate(['<div>Error: unknown dataset state: "<%- dataset.state %>"</div>'], "dataset");

    // messages to be displayed only within the details section ('below the fold')
    var detailMessageTemplates = {
        resubmitted: _baseMvc2.default.wrapTemplate([
        // deleted not purged
        "<% if( model.resubmitted ){ %>", '<div class="resubmitted-msg infomessagesmall">', (0, _localization2.default)("The job creating this dataset has been resubmitted"), "</div>", "<% } %>"])
    };

    // this is applied to both old and new style display apps
    var displayApplicationsTemplate = _baseMvc2.default.wrapTemplate(["<% _.each( apps, function( app ){ %>", '<div class="display-application">', '<span class="display-application-location"><%- app.label %></span> ', '<span class="display-application-links">', "<% _.each( app.links, function( link ){ %>", '<a target="<%- link.target %>" href="<%- link.href %>">', "<% print( _l( link.text ) ); %>", "</a> ", "<% }); %>", "</span>", "</div>", "<% }); %>"], "apps");

    return _.extend({}, _super.prototype.templates, {
        warnings: warnings,
        details: detailsTemplate,
        noAccess: noAccessTemplate,
        summaries: summaryTemplates,
        detailMessages: detailMessageTemplates,
        displayApplications: displayApplicationsTemplate
    });
}();

// ============================================================================
exports.default = {
    DatasetListItemView: DatasetListItemView
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(0), __webpack_require__(2), __webpack_require__(0)))

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_, $, jQuery) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _listItem = __webpack_require__(151);

var _listItem2 = _interopRequireDefault(_listItem);

var _datasetLi = __webpack_require__(153);

var _datasetLi2 = _interopRequireDefault(_datasetLi);

var _baseMvc = __webpack_require__(6);

var _baseMvc2 = _interopRequireDefault(_baseMvc);

var _localization = __webpack_require__(3);

var _localization2 = _interopRequireDefault(_localization);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//==============================================================================
var FoldoutListItemView = _listItem2.default.FoldoutListItemView;

var ListItemView = _listItem2.default.ListItemView;
/** @class Read only view for DatasetCollection.
 */
var DCListItemView = FoldoutListItemView.extend(
/** @lends DCListItemView.prototype */{
    className: FoldoutListItemView.prototype.className + " dataset-collection",
    id: function id() {
        return ["dataset_collection", this.model.get("id")].join("-");
    },

    /** override to add linkTarget */
    initialize: function initialize(attributes) {
        this.linkTarget = attributes.linkTarget || "_blank";
        this.hasUser = attributes.hasUser;
        FoldoutListItemView.prototype.initialize.call(this, attributes);
    },

    /** event listeners */
    _setUpListeners: function _setUpListeners() {
        FoldoutListItemView.prototype._setUpListeners.call(this);
        this.listenTo(this.model, "change", function (model, options) {
            // if the model has changed deletion status render it entirely
            if (_.has(model.changed, "deleted")) {
                this.render();

                // if the model has been decorated after the fact with the element count,
                // render the subtitle where the count is displayed
            } else if (_.has(model.changed, "element_count")) {
                this.$("> .title-bar .subtitle").replaceWith(this._renderSubtitle());
            }
        });
    },

    // ......................................................................... rendering
    /** render a subtitle to show the user what sort of collection this is */
    _renderSubtitle: function _renderSubtitle() {
        return $(this.templates.subtitle(this.model.toJSON(), this));
    },

    // ......................................................................... foldout
    /** override to add linktarget to sub-panel */
    _getFoldoutPanelOptions: function _getFoldoutPanelOptions() {
        var options = FoldoutListItemView.prototype._getFoldoutPanelOptions.call(this);
        return _.extend(options, {
            linkTarget: this.linkTarget,
            hasUser: this.hasUser
        });
    },

    /** override to not catch sub-panel selectors */
    $selector: function $selector() {
        return this.$("> .selector");
    },

    // ......................................................................... misc
    /** String representation */
    toString: function toString() {
        var modelString = this.model ? "" + this.model : "(no model)";
        return "DCListItemView(" + modelString + ")";
    }
});

// ............................................................................ TEMPLATES
/** underscore templates */
DCListItemView.prototype.templates = function () {
    var warnings = _.extend({}, FoldoutListItemView.prototype.templates.warnings, {
        error: _baseMvc2.default.wrapTemplate([
        // error during index fetch - show error on dataset
        "<% if( model.error ){ %>", '<div class="errormessagesmall">', (0, _localization2.default)("There was an error getting the data for this collection"), ": <%- model.error %>", "</div>", "<% } %>"]),
        purged: _baseMvc2.default.wrapTemplate(["<% if( model.purged ){ %>", '<div class="purged-msg warningmessagesmall">', (0, _localization2.default)("This collection has been deleted and removed from disk"), "</div>", "<% } %>"]),
        deleted: _baseMvc2.default.wrapTemplate([
        // deleted not purged
        "<% if( model.deleted && !model.purged ){ %>", '<div class="deleted-msg warningmessagesmall">', (0, _localization2.default)("This collection has been deleted"), "</div>", "<% } %>"])
    });

    // use element identifier
    var titleBarTemplate = _baseMvc2.default.wrapTemplate(['<div class="title-bar clear" tabindex="0">', '<div class="title">', '<span class="name"><%- collection.element_identifier || collection.name %></span>', "</div>", '<div class="subtitle"></div>', "</div>"], "collection");

    // use element identifier
    var subtitleTemplate = _baseMvc2.default.wrapTemplate(['<div class="subtitle">', '<% var countText = collection.element_count? ( collection.element_count + " " ) : ""; %>', '<%        if( collection.collection_type === "list" ){ %>', (0, _localization2.default)("a list of <%- countText %>datasets"), '<% } else if( collection.collection_type === "paired" ){ %>', (0, _localization2.default)("a pair of datasets"), '<% } else if( collection.collection_type === "list:paired" ){ %>', (0, _localization2.default)("a list of <%- countText %>dataset pairs"), '<% } else if( collection.collection_type === "list:list" ){ %>', (0, _localization2.default)("a list of <%- countText %>dataset lists"), "<% } %>", "</div>"], "collection");

    return _.extend({}, FoldoutListItemView.prototype.templates, {
        warnings: warnings,
        titleBar: titleBarTemplate,
        subtitle: subtitleTemplate
    });
}();

//==============================================================================
/** @class Read only view for DatasetCollectionElement.
 */
var DCEListItemView = ListItemView.extend(
/** @lends DCEListItemView.prototype */{
    /** add the DCE class to the list item */
    className: ListItemView.prototype.className + " dataset-collection-element",

    /** set up */
    initialize: function initialize(attributes) {
        if (attributes.logger) {
            this.logger = this.model.logger = attributes.logger;
        }
        this.log("DCEListItemView.initialize:", attributes);
        ListItemView.prototype.initialize.call(this, attributes);
    },

    // ......................................................................... misc
    /** String representation */
    toString: function toString() {
        var modelString = this.model ? "" + this.model : "(no model)";
        return "DCEListItemView(" + modelString + ")";
    }
});

// ............................................................................ TEMPLATES
/** underscore templates */
DCEListItemView.prototype.templates = function () {
    // use the element identifier here - since that will persist and the user will need it
    var titleBarTemplate = _baseMvc2.default.wrapTemplate(['<div class="title-bar clear" tabindex="0">', '<div class="title">', '<span class="name"><%- element.element_identifier %></span>', "</div>", '<div class="subtitle"></div>', "</div>"], "element");

    return _.extend({}, ListItemView.prototype.templates, {
        titleBar: titleBarTemplate
    });
}();

//==============================================================================
/** @class Read only view for a DatasetCollectionElement that is also an DatasetAssociation
 *      (a dataset contained in a dataset collection).
 */
var DatasetDCEListItemView = _datasetLi2.default.DatasetListItemView.extend(
/** @lends DatasetDCEListItemView.prototype */{
    className: _datasetLi2.default.DatasetListItemView.prototype.className + " dataset-collection-element",

    /** set up */
    initialize: function initialize(attributes) {
        if (attributes.logger) {
            this.logger = this.model.logger = attributes.logger;
        }
        this.log("DatasetDCEListItemView.initialize:", attributes);
        _datasetLi2.default.DatasetListItemView.prototype.initialize.call(this, attributes);
    },

    /** In this override, only get details if in the ready state.
     *  Note: fetch with no 'change' event triggering to prevent automatic rendering.
     */
    _fetchModelDetails: function _fetchModelDetails() {
        var view = this;
        if (view.model.inReadyState() && !view.model.hasDetails()) {
            return view.model.fetch({ silent: true });
        }
        return jQuery.when();
    },

    // ......................................................................... misc
    /** String representation */
    toString: function toString() {
        var modelString = this.model ? "" + this.model : "(no model)";
        return "DatasetDCEListItemView(" + modelString + ")";
    }
});

// ............................................................................ TEMPLATES
/** underscore templates */
DatasetDCEListItemView.prototype.templates = function () {
    // use the element identifier here and not the dataset name
    //TODO:?? can we steal the DCE titlebar?
    var titleBarTemplate = _baseMvc2.default.wrapTemplate(['<div class="title-bar clear" tabindex="0">', '<span class="state-icon"></span>', '<div class="title">', '<span class="name"><%- element.element_identifier %></span>', "</div>", "</div>"], "element");

    return _.extend({}, _datasetLi2.default.DatasetListItemView.prototype.templates, {
        titleBar: titleBarTemplate
    });
}();

//==============================================================================
/** @class Read only view for a DatasetCollectionElement that is also a DatasetCollection
 *      (a nested DC).
 */
var NestedDCDCEListItemView = DCListItemView.extend(
/** @lends NestedDCDCEListItemView.prototype */{
    className: DCListItemView.prototype.className + " dataset-collection-element",

    /** In this override, add the state as a class for use with state-based CSS */
    _swapNewRender: function _swapNewRender($newRender) {
        DCListItemView.prototype._swapNewRender.call(this, $newRender);
        var state = this.model.get("state") || "ok";
        this.$el.addClass("state-" + state);
        return this.$el;
    },

    // ......................................................................... misc
    /** String representation */
    toString: function toString() {
        var modelString = this.model ? "" + this.model : "(no model)";
        return "NestedDCDCEListItemView(" + modelString + ")";
    }
});

//==============================================================================
exports.default = {
    DCListItemView: DCListItemView,
    DCEListItemView: DCEListItemView,
    DatasetDCEListItemView: DatasetDCEListItemView,
    NestedDCDCEListItemView: NestedDCDCEListItemView
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(0), __webpack_require__(0)))

/***/ }),
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, _) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _localization = __webpack_require__(3);

var _localization2 = _interopRequireDefault(_localization);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//TODO: toastr is another possibility - I didn't see where I might add details, tho

/* ============================================================================
Error modals meant to replace the o-so-easy alerts.

These are currently styled as errormessages but use the Galaxy.modal
infrastructure to be shown/closed. They're capable of showing details in a
togglable dropdown and the details are formatted in a pre.

Example:
    errorModal( 'Heres a message', 'A Title', { some_details: 'here' });
    errorModal( 'Heres a message' ); // no details, title is 'Error'

There are three specialized forms:
    offlineErrorModal       a canned response for when there's no connection
    badGatewayErrorModal    canned response for when Galaxy is restarting
    ajaxErrorModal          plugable into any Backbone class as an
        error event handler by accepting the error args: model, xhr, options

Examples:
    if( navigator.offLine ){ offlineErrorModal(); }
    if( xhr.status === 502 ){ badGatewayErrorModal(); }
    this.listenTo( this.model, 'error', ajaxErrorModal );

============================================================================ */

var CONTACT_MSG = (0, _localization2.default)("Please contact a Galaxy administrator if the problem persists.");
var DEFAULT_AJAX_ERR_MSG = (0, _localization2.default)("An error occurred while updating information with the server.");
var DETAILS_MSG = (0, _localization2.default)("The following information can assist the developers in finding the source of the error:");

/** private helper that builds the modal and handles adding details */
function _errorModal(message, title, details) {
    // create and return the modal, adding details button only if needed
    Galaxy.modal.show({
        title: title,
        body: message,
        closing_events: true,
        buttons: {
            Ok: function Ok() {
                Galaxy.modal.hide();
            }
        }
    });
    Galaxy.modal.$el.addClass("error-modal");

    if (details) {
        Galaxy.modal.$(".error-details").add(Galaxy.modal.$('button:contains("Details")')).remove();
        $("<div/>").addClass("error-details").hide().appendTo(Galaxy.modal.$(".modal-content")).append([$("<p/>").text(DETAILS_MSG), $("<pre/>").text(JSON.stringify(details, null, "  "))]);

        $("<button id=\"button-1\" class=\"float-left\">" + (0, _localization2.default)("Details") + "</button>").appendTo(Galaxy.modal.$(".buttons")).click(function () {
            Galaxy.modal.$(".error-details").toggle();
        });
    }
    return Galaxy.modal;
}

/** Display a modal showing an error message but fallback to alert if there's no modal */
function errorModal(message, title, details) {
    if (!message) {
        return;
    }

    message = (0, _localization2.default)(message);
    title = (0, _localization2.default)(title) || (0, _localization2.default)("Error:");
    if (window.Galaxy && Galaxy.modal) {
        return _errorModal(message, title, details);
    }

    alert(title + "\n\n" + message);
    console.log("error details:", JSON.stringify(details));
}

// ----------------------------------------------------------------------------
/** display a modal when the user may be offline */
function offlineErrorModal() {
    return errorModal((0, _localization2.default)("You appear to be offline. Please check your connection and try again."), (0, _localization2.default)("Offline?"));
}

// ----------------------------------------------------------------------------
/** 502 messages that should be displayed when galaxy is restarting */
function badGatewayErrorModal() {
    return errorModal((0, _localization2.default)("Galaxy is currently unreachable. Please try again in a few minutes.") + " " + CONTACT_MSG, (0, _localization2.default)("Cannot connect to Galaxy"));
}

// ----------------------------------------------------------------------------
/** display a modal (with details) about a failed Backbone ajax operation */
function ajaxErrorModal(model, xhr, options, message, title) {
    message = message || DEFAULT_AJAX_ERR_MSG;
    message += " " + CONTACT_MSG;
    title = title || (0, _localization2.default)("An error occurred");
    var details = _ajaxDetails(model, xhr, options);
    return errorModal(message, title, details);
}

/** build details which may help debugging the ajax call */
function _ajaxDetails(model, xhr, options) {
    return {
        //TODO: still can't manage Raven id
        raven: _.result(window.Raven, "lastEventId"),
        userAgent: navigator.userAgent,
        onLine: navigator.onLine,
        version: _.result(Galaxy.config, "version_major"),
        xhr: _.omit(xhr, _.functions(xhr)),
        options: _.omit(options, "xhr"),
        // add ajax data from Galaxy object cache
        url: _.result(Galaxy.lastAjax, "url"),
        data: _.result(Galaxy.lastAjax, "data"),
        // backbone stuff (auto-redacting email for user)
        model: _.result(model, "toJSON", "" + model),
        user: _.omit(_.result(Galaxy.user, "toJSON"), "email")
    };
}

//=============================================================================
exports.default = {
    errorModal: errorModal,
    offlineErrorModal: offlineErrorModal,
    badGatewayErrorModal: badGatewayErrorModal,
    ajaxErrorModal: ajaxErrorModal
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(1)))

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.historyEntry = historyEntry;

var _underscore = __webpack_require__(1);

var _ = _interopRequireWildcard(_underscore);

var _localization = __webpack_require__(3);

var _localization2 = _interopRequireDefault(_localization);

var _listView = __webpack_require__(192);

var _listView2 = _interopRequireDefault(_listView);

var _historyModel = __webpack_require__(168);

var _historyModel2 = _interopRequireDefault(_historyModel);

var _historyContents = __webpack_require__(169);

var _historyContents2 = _interopRequireDefault(_historyContents);

var _hdaLi = __webpack_require__(170);

var _hdaLi2 = _interopRequireDefault(_hdaLi);

var _hdcaLi = __webpack_require__(171);

var _hdcaLi2 = _interopRequireDefault(_hdcaLi);

var _errorModal = __webpack_require__(165);

var _errorModal2 = _interopRequireDefault(_errorModal);

var _faIconButton = __webpack_require__(53);

var _faIconButton2 = _interopRequireDefault(_faIconButton);

var _baseMvc = __webpack_require__(6);

var _baseMvc2 = _interopRequireDefault(_baseMvc);

var _historyViewEdit = __webpack_require__(191);

var _historyViewEdit2 = _interopRequireDefault(_historyViewEdit);

var _copyDialog = __webpack_require__(150);

var _copyDialog2 = _interopRequireDefault(_copyDialog);

__webpack_require__(167);

__webpack_require__(236);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/* global $ */
/* global Galaxy */

/* =============================================================================
TODO:

============================================================================= */
/** @class  non-editable, read-only View/Controller for a history model.
 *  Allows:
 *      changing the loaded history
 *      displaying data, info, and download
 *      tracking history attrs: size, tags, annotations, name, etc.
 *  Does not allow:
 *      changing the name
 */
var _super = _listView2.default.ModelListPanel;
var HistoryView = _super.extend(
/** @lends HistoryView.prototype */{
    _logNamespace: "history",

    /** class to use for constructing the HDA views */
    HDAViewClass: _hdaLi2.default.HDAListItemView,
    /** class to use for constructing the HDCA views */
    HDCAViewClass: _hdcaLi2.default.HDCAListItemView,
    /** class to used for constructing collection of sub-view models */
    collectionClass: _historyContents2.default.HistoryContents,
    /** key of attribute in model to assign to this.collection */
    modelCollectionKey: "contents",

    tagName: "div",
    className: _super.prototype.className + " history-panel",

    /** string to display when the collection is empty */
    emptyMsg: (0, _localization2.default)("This history is empty"),
    /** displayed when no items match the search terms */
    noneFoundMsg: (0, _localization2.default)("No matching datasets found"),
    /** string used for search placeholder */
    searchPlaceholder: (0, _localization2.default)("search datasets"),

    // ......................................................................... SET UP
    /** Set up the view, bind listeners.
     *  @param {Object} attributes optional settings for the panel
     */
    initialize: function initialize(attributes) {
        _super.prototype.initialize.call(this, attributes);
        // ---- instance vars
        // control contents/behavior based on where (and in what context) the panel is being used
        /** where should pages from links be displayed? (default to new tab/window) */
        this.linkTarget = attributes.linkTarget || "_blank";
    },

    /** create and return a collection for when none is initially passed */
    _createDefaultCollection: function _createDefaultCollection() {
        // override
        return new this.collectionClass([], {
            history: this.model
        });
    },

    /** In this override, clear the update timer on the model */
    freeModel: function freeModel() {
        _super.prototype.freeModel.call(this);
        if (this.model) {
            this.model.stopPolling();
        }
        return this;
    },

    /** create any event listeners for the panel
     *  @fires: rendered:initial    on the first render
     *  @fires: empty-history       when switching to a history with no contents or creating a new history
     */
    _setUpListeners: function _setUpListeners() {
        _super.prototype._setUpListeners.call(this);
        this.on({
            error: function error(model, xhr, options, msg, details) {
                this.errorHandler(model, xhr, options, msg, details);
            },
            "views:ready view:attached view:removed": function viewsReadyViewAttachedViewRemoved(view) {
                this._renderSelectButton();
            },
            "view:attached": function viewAttached(view) {
                this.scrollTo(0);
            }
        });
        // this.on( 'all', function(){ console.debug( arguments ); });
    },

    // ------------------------------------------------------------------------ loading history/hda models
    /** load the history with the given id then it's contents, sending ajax options to both */
    loadHistory: function loadHistory(historyId, options, contentsOptions) {
        var _this = this;

        contentsOptions = _.extend(contentsOptions || { silent: true });
        this.info("loadHistory:", historyId, options, contentsOptions);
        this.setModel(new _historyModel2.default.History({ id: historyId }));

        contentsOptions.silent = true;
        this.trigger("loading");
        return this.model.fetchWithContents(options, contentsOptions).always(function () {
            _this.render();
            _this.trigger("loading-done");
        });
    },

    /** convenience alias to the model. Updates the item list only (not the history) */
    refreshContents: function refreshContents(options) {
        if (this.model) {
            return this.model.refresh(options);
        }
        // may have callbacks - so return an empty promise
        return $.when();
    },

    /** Override to reset web storage when the id changes (since it needs the id) */
    _setUpCollectionListeners: function _setUpCollectionListeners() {
        _super.prototype._setUpCollectionListeners.call(this);
        return this.listenTo(this.collection, {
            // 'all' : function(){ console.log( this.collection + ':', arguments ); },
            "fetching-more": function fetchingMore() {
                this._toggleContentsLoadingIndicator(true);
                this.$emptyMessage().hide();
            },
            "fetching-more-done": function fetchingMoreDone() {
                this._toggleContentsLoadingIndicator(false);
            }
        });
    },

    // ------------------------------------------------------------------------ panel rendering
    /** hide the $el and display a loading indicator (in the $el's parent) when loading new data */
    _showLoadingIndicator: function _showLoadingIndicator(msg, speed, callback) {
        var $indicator = $('<div class="loading-indicator"/>');
        this.$el.html($indicator.text(msg).slideDown(!_.isUndefined(speed) ? speed : this.fxSpeed));
    },

    /** hide the loading indicator */
    _hideLoadingIndicator: function _hideLoadingIndicator(speed) {
        // make speed a bit slower to compensate for slow rendering of up to 500 contents
        this.$(".loading-indicator").slideUp(!_.isUndefined(speed) ? speed : this.fxSpeed + 200, function () {
            $(this).remove();
        });
    },

    /** In this override, add a btn to toggle the selectors */
    _buildNewRender: function _buildNewRender() {
        var $newRender = _super.prototype._buildNewRender.call(this);
        this._renderSelectButton($newRender);
        return $newRender;
    },

    /** button for starting select mode */
    _renderSelectButton: function _renderSelectButton($where) {
        $where = $where || this.$el;
        // do not render selector option if no actions
        if (!this.multiselectActions().length) {
            return null;
        }
        // do not render (and remove even) if nothing to select
        if (!this.views.length) {
            this.hideSelectors();
            $where.find(".controls .actions .show-selectors-btn").remove();
            return null;
        }
        // don't bother rendering if there's one already
        var $existing = $where.find(".controls .actions .show-selectors-btn");
        if ($existing.length) {
            return $existing;
        }

        return (0, _faIconButton2.default)({
            title: (0, _localization2.default)("Operations on multiple datasets"),
            classes: "show-selectors-btn",
            faIcon: "fa-check-square-o",
            tooltipConfig: { placement: "top" }
        }).prependTo($where.find(".controls .actions"));
    },

    /** override to avoid showing intial empty message using contents_active */
    _renderEmptyMessage: function _renderEmptyMessage($whereTo) {
        var $emptyMsg = this.$emptyMessage($whereTo);
        var empty = this.model.get("contents_active").active <= 0;
        if (empty) {
            return $emptyMsg.empty().append(this.emptyMsg).show();
        } else if (this.searchFor && this.model.contents.haveSearchDetails() && !this.views.length) {
            return $emptyMsg.empty().append(this.noneFoundMsg).show();
        }
        $emptyMsg.hide();
        return $();
    },

    /** the scroll container for this panel - can be $el, $el.parent(), or grandparent depending on context */
    $scrollContainer: function $scrollContainer($where) {
        // override or set via attributes.$scrollContainer
        return this.$list($where);
    },

    // ------------------------------------------------------------------------ subviews
    _toggleContentsLoadingIndicator: function _toggleContentsLoadingIndicator(show) {
        if (!show) {
            this.$list().find(".contents-loading-indicator").remove();
        } else {
            this.$list().html('<div class="contents-loading-indicator">' + '<span class="fa fa-2x fa-spinner fa-spin"/></div>');
        }
    },

    /** override to render pagination also */
    renderItems: function renderItems($whereTo) {
        // console.log( this + '.renderItems-----------------', new Date() );
        $whereTo = $whereTo || this.$el;
        var $list = this.$list($whereTo);

        // TODO: bootstrap hack to remove orphaned tooltips
        $(".tooltip").remove();

        $list.empty();
        this.views = [];

        var models = this._filterCollection();
        if (models.length) {
            this._renderPagination($whereTo);
            this.views = this._renderSomeItems(models, $list);
        } else {
            // TODO: consolidate with _renderPagination above by (???) passing in models/length?
            $whereTo.find("> .controls .list-pagination").empty();
        }
        this._renderEmptyMessage($whereTo).toggle(!models.length);

        this.trigger("views:ready", this.views);
        return this.views;
    },

    /** render pagination controls if not searching and contents says we're paginating */
    _renderPagination: function _renderPagination($whereTo) {
        var $paginationControls = $whereTo.find("> .controls .list-pagination");
        if (this.searchFor || !this.model.contents.shouldPaginate()) return $paginationControls.empty();

        $paginationControls.html(this.templates.pagination({
            // pagination is 1-based for the user
            current: this.model.contents.currentPage + 1,
            last: this.model.contents.getLastPage() + 1
        }, this));
        $paginationControls.find("select.pages").tooltip();
        return $paginationControls;
    },

    /** render a subset of the entire collection (client-side pagination) */
    _renderSomeItems: function _renderSomeItems(models, $list) {
        var _this2 = this;

        var views = [];
        $list.append(models.map(function (m) {
            var view = _this2._createItemView(m);
            views.push(view);
            return _this2._renderItemView$el(view);
        }));
        return views;
    },

    // ------------------------------------------------------------------------ sub-views
    /** in this override, check if the contents would also display based on includeDeleted/hidden */
    _filterItem: function _filterItem(model) {
        var contents = this.model.contents;
        return (contents.includeHidden || !model.hidden()) && (contents.includeDeleted || !model.isDeletedOrPurged()) && _super.prototype._filterItem.call(this, model);
    },

    /** In this override, since history contents are mixed,
     *      get the appropo view class based on history_content_type
     */
    _getItemViewClass: function _getItemViewClass(model) {
        var contentType = model.get("history_content_type");
        switch (contentType) {
            case "dataset":
                return this.HDAViewClass;
            case "dataset_collection":
                return this.HDCAViewClass;
        }
        throw new TypeError("Unknown history_content_type: " + contentType);
    },

    /** in this override, add a linktarget, and expand if id is in web storage */
    _getItemViewOptions: function _getItemViewOptions(model) {
        var options = _super.prototype._getItemViewOptions.call(this, model);
        return _.extend(options, {
            linkTarget: this.linkTarget,
            expanded: this.model.contents.storage.isExpanded(model.id),
            hasUser: this.model.ownedByCurrUser()
        });
    },

    /** In this override, add/remove expanded/collapsed model ids to/from web storage */
    _setUpItemViewListeners: function _setUpItemViewListeners(view) {
        var panel = this;
        _super.prototype._setUpItemViewListeners.call(panel, view);
        //TODO: send from content view: this.model.collection.storage.addExpanded
        // maintain a list of items whose bodies are expanded
        return panel.listenTo(view, {
            expanded: function expanded(v) {
                panel.model.contents.storage.addExpanded(v.model);
            },
            collapsed: function collapsed(v) {
                panel.model.contents.storage.removeExpanded(v.model);
            }
        });
    },

    /** override to remove expandedIds from webstorage */
    collapseAll: function collapseAll() {
        this.model.contents.storage.clearExpanded();
        _super.prototype.collapseAll.call(this);
    },

    // ------------------------------------------------------------------------ selection
    /** Override to correctly set the historyId of the new collection */
    getSelectedModels: function getSelectedModels() {
        var collection = _super.prototype.getSelectedModels.call(this);
        collection.historyId = this.collection.historyId;
        return collection;
    },

    // ------------------------------------------------------------------------ panel events
    /** event map */
    events: _.extend(_.clone(_super.prototype.events), {
        "click .show-selectors-btn": "toggleSelectors",
        "click > .controls .prev": "_clickPrevPage",
        "click > .controls .next": "_clickNextPage",
        "change > .controls .pages": "_changePageSelect",
        // allow (error) messages to be clicked away
        "click .messages [class$=message]": "clearMessages"
    }),

    _clickPrevPage: function _clickPrevPage(ev) {
        this.model.stopPolling();
        this.model.contents.fetchPrevPage();
    },

    _clickNextPage: function _clickNextPage(ev) {
        this.model.stopPolling();
        this.model.contents.fetchNextPage();
    },

    _changePageSelect: function _changePageSelect(ev) {
        this.model.stopPolling();
        var page = $(ev.currentTarget).val();
        this.model.contents.fetchPage(page);
    },

    /** Toggle and store the deleted visibility and re-render items
     * @returns {Boolean} new setting
     */
    toggleShowDeleted: function toggleShowDeleted(show, options) {
        show = show !== undefined ? show : !this.model.contents.includeDeleted;
        var contents = this.model.contents;
        contents.setIncludeDeleted(show, options);
        this.trigger("show-deleted", show);

        contents.fetchCurrentPage({ renderAll: true });
        return show;
    },

    /** Toggle and store whether to render explicity hidden contents
     * @returns {Boolean} new setting
     */
    toggleShowHidden: function toggleShowHidden(show, store, options) {
        // console.log( 'toggleShowHidden', show, store );
        show = show !== undefined ? show : !this.model.contents.includeHidden;
        var contents = this.model.contents;
        contents.setIncludeHidden(show, options);
        this.trigger("show-hidden", show);

        contents.fetchCurrentPage({ renderAll: true });
        return show;
    },

    /** On the first search, if there are no details - load them, then search */
    _firstSearch: function _firstSearch(searchFor) {
        var _this3 = this;

        var inputSelector = "> .controls .search-input";
        this.log("onFirstSearch", searchFor);

        // if the contents already have enough details to search, search and return now
        if (this.model.contents.haveSearchDetails()) {
            this.searchItems(searchFor);
            return;
        }

        // otherwise, load the details progressively here
        this.$(inputSelector).searchInput("toggle-loading");
        // set this now so that only results will show during progress
        this.searchFor = searchFor;
        this.model.contents.progressivelyFetchDetails({ silent: true }).progress(function (response, limit, offset) {
            _this3.renderItems();
            _this3.trigger("search:loading-progress", limit, offset);
        }).always(function () {
            _this3.$el.find(inputSelector).searchInput("toggle-loading");
        }).done(function () {
            _this3.searchItems(searchFor, "force");
        });
    },

    /** clear the search filters and show all views that are normally shown */
    clearSearch: function clearSearch(searchFor) {
        var _this4 = this;

        if (!this.searchFor) return this;
        //this.log( 'onSearchClear', this );
        this.searchFor = "";
        this.trigger("search:clear", this);
        this.$("> .controls .search-query").val("");
        // NOTE: silent + render prevents collection update event with merge only
        // - which causes an empty page due to event handler above
        this.model.contents.fetchCurrentPage({ silent: true }).done(function () {
            _this4.renderItems();
        });
        return this;
    },

    // ........................................................................ error handling
    /** Event handler for errors (from the panel, the history, or the history's contents)
     *  Alternately use two strings for model and xhr to use custom message and title (respectively)
     *  @param {Model or View} model    the (Backbone) source of the error
     *  @param {XMLHTTPRequest} xhr     any ajax obj. assoc. with the error
     *  @param {Object} options         the options map commonly used with bbone ajax
     */
    errorHandler: function errorHandler(model, xhr, options) {
        //TODO: to mixin or base model
        // interrupted ajax or no connection
        if (xhr && xhr.status === 0 && xhr.readyState === 0) {
            // return ERROR_MODAL.offlineErrorModal();
            // fail silently
            return;
        }
        // otherwise, leave something to report in the console
        this.error(model, xhr, options);
        // and feedback to a modal
        // if sent two strings (and possibly details as 'options'), use those as message and title
        if (_.isString(model) && _.isString(xhr)) {
            var message = model;
            var title = xhr;
            return _errorModal2.default.errorModal(message, title, options);
        }
        // bad gateway
        // TODO: possibly to global handler
        if (xhr && xhr.status === 502) {
            return _errorModal2.default.badGatewayErrorModal();
        }
        return _errorModal2.default.ajaxErrorModal(model, xhr, options);
    },

    /** Remove all messages from the panel. */
    clearMessages: function clearMessages(ev) {
        var $target = !_.isUndefined(ev) ? $(ev.currentTarget) : this.$messages().children('[class$="message"]');
        $target.fadeOut(this.fxSpeed, function () {
            $(this).remove();
        });
        return this;
    },

    // ........................................................................ scrolling
    /** Scrolls the panel to show the content sub-view with the given hid.
     *  @param {Integer} hid    the hid of item to scroll into view
     *  @returns {HistoryView} the panel
     */
    scrollToHid: function scrollToHid(hid) {
        return this.scrollToItem(_.first(this.viewsWhereModel({ hid: hid })));
    },

    // ........................................................................ misc
    /** utility for adding -st, -nd, -rd, -th to numbers */
    ordinalIndicator: function ordinalIndicator(number) {
        var numStr = "" + number;
        switch (numStr.charAt(numStr.length - 1)) {
            case "1":
                return numStr + "st";
            case "2":
                return numStr + "nd";
            case "3":
                return numStr + "rd";
            default:
                return numStr + "th";
        }
    },

    /** Return a string rep of the history */
    toString: function toString() {
        return "HistoryView(" + (this.model ? this.model.get("name") : "") + ")";
    }
});

//------------------------------------------------------------------------------ TEMPLATES
HistoryView.prototype.templates = function () {
    var mainTemplate = function mainTemplate() {
        return "<div>\n            <div class=\"controls\"></div>\n            <ul class=\"list-items\"></ul>\n            <div class=\"empty-message infomessagesmall\"></div>',\n        </div>";
    };

    var controlsTemplate = _baseMvc2.default.wrapTemplate(['<div class="controls">', '<div class="title">', '<div class="name"><%- history.name %></div>', "</div>", '<div class="subtitle"></div>', '<div class="history-size"><%- history.nice_size %></div>', '<div class="actions"></div>', '<div class="messages">', "<% if( history.deleted && history.purged ){ %>", '<div class="deleted-msg warningmessagesmall">', (0, _localization2.default)("This history has been purged and deleted"), "</div>", "<% } else if( history.deleted ){ %>", '<div class="deleted-msg warningmessagesmall">', (0, _localization2.default)("This history has been deleted"), "</div>", "<% } else if( history.purged ){ %>", '<div class="deleted-msg warningmessagesmall">', (0, _localization2.default)("This history has been purged"), "</div>", "<% } %>", "<% if( history.message ){ %>",
    // should already be localized
    '<div class="<%= history.message.level || "info" %>messagesmall">', "<%= history.message.text %>", "</div>", "<% } %>", "</div>",

    // add tags and annotations
    '<div class="tags-display"></div>', '<div class="annotation-display"></div>', '<div class="search">', '<div class="search-input"></div>', "</div>", '<div class="list-actions">', '<div class="btn-group">', '<button class="select-all btn btn-secondary"', 'data-mode="select">', (0, _localization2.default)("All"), "</button>", '<button class="deselect-all btn btn-secondary"', 'data-mode="select">', (0, _localization2.default)("None"), "</button>", "</div>", '<div class="list-action-menu btn-group">', "</div>", "</div>", '<div class="list-pagination form-inline"></div>', "</div>"], "history");

    var paginationTemplate = _baseMvc2.default.wrapTemplate(['<button class="prev" <%- pages.current === 1 ? "disabled" : "" %>>previous</button>', '<select class="pages form-control" ', 'title="', (0, _localization2.default)("Click to open and select a page. Begin typing a page number to select it"), '">', "<% _.range( 1, pages.last + 1 ).forEach( function( i ){ %>", '<option value="<%- i - 1 %>" <%- i === pages.current ? "selected" : "" %>>', "<%- view.ordinalIndicator( i ) %> of <%- pages.last %> pages", "</option>", "<% }); %>", "</select>", '<button class="next" <%- pages.current === pages.last ? "disabled" : "" %>>next</button>'], "pages");

    return _.extend(_.clone(_super.prototype.templates), {
        el: mainTemplate,
        controls: controlsTemplate,
        pagination: paginationTemplate
    });
}();

function historyEntry(options) {
    $("#toggle-deleted").modeButton({
        initialMode: options.initialModeDeleted,
        modes: [{ mode: "showing_deleted", html: (0, _localization2.default)("Exclude deleted") }, { mode: "not_showing_deleted", html: (0, _localization2.default)("Include deleted") }]
    });
    $("#toggle-hidden").modeButton({
        initialMode: options.initialModeHidden,
        modes: [{ mode: "showing_hidden", html: (0, _localization2.default)("Exclude hidden") }, { mode: "not_showing_hidden", html: (0, _localization2.default)("Include hidden") }]
    });
    $("#switch").click(function () {
        //##HACK:ity hack hack
        //##TODO: remove when out of iframe
        var hview = Galaxy.currHistoryPanel || window.top.Galaxy && window.top.Galaxy.currHistoryPanel ? window.top.Galaxy.currHistoryPanel : null;
        if (hview) {
            hview.switchToHistory("${ history[ 'id' ] }");
        } else {
            window.location = "${ switch_to_url }";
        }
    });
    // use_panels affects where the the center_panel() is rendered:
    //  w/o it renders to the body, w/ it renders to #center - we need to adjust a few things for scrolling to work
    if (options.hasMasthead) {
        $("#center").addClass("flex-vertical-container");
    }

    var viewClass = options.userIsOwner ? _historyViewEdit2.default.HistoryViewEdit : HistoryView.HistoryView;
    var historyModel = new _historyModel2.default.History(options.historyJSON);

    // attach the copy dialog to the import button now that we have a history
    $("#import").click(function () {
        (0, _copyDialog2.default)(historyModel, {
            useImport: true,
            // use default datasets option to match the toggle-deleted button
            allDatasets: $("#toggle-deleted").modeButton("getMode").mode === "showing_deleted"
        }).done(function () {
            if (window === window.parent) {
                window.location = Galaxy.root;
            } else if (Galaxy.currHistoryPanel) {
                Galaxy.currHistoryPanel.loadCurrentHistory();
            }
        });
    });

    var historyView = new viewClass({
        el: $("#history-" + options.historyJSON.id),
        className: viewClass.prototype.className + " wide",
        $scrollContainer: options.hasMasthead ? function () {
            return this.$el.parent();
        } : undefined,
        model: historyModel,
        show_deleted: options.showDeletedJson,
        show_hidden: options.showHiddenJson,
        purgeAllowed: options.allow_user_dataset_purge
    });
    historyView.trigger("loading");
    historyModel.fetchContents({ silent: true }).fail(function () {
        alert("Galaxy history failed to load");
    }).done(function () {
        historyView.trigger("loading-done");
        historyView.render();
    });
    $("#toggle-deleted").on("click", function () {
        historyView.toggleShowDeleted();
    });
    $("#toggle-hidden").on("click", function () {
        historyView.toggleShowHidden();
    });
}

//==============================================================================
exports.default = {
    HistoryView: HistoryView,
    historyEntry: historyEntry
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

"use_strict";

var $ = _jquery2.default;
var _l = window._l || function (s) {
    return s;
};

//TODO: consolidate with tool menu functionality, use there

/** searchInput: (jQuery plugin)
 *      Creates a search input, a clear button, and loading indicator
 *      within the selected node.
 *
 *      When the user either presses return or enters some minimal number
 *      of characters, a callback is called. Pressing ESC when the input
 *      is focused will clear the input and call a separate callback.
 */
function searchInput(parentNode, options) {
    var KEYCODE_ESC = 27;
    var KEYCODE_RETURN = 13;
    var $parentNode = $(parentNode);
    var firstSearch = true;

    var defaults = {
        initialVal: "",
        name: "search",
        placeholder: "search",
        classes: "",
        onclear: function onclear() {},
        onfirstsearch: null,
        onsearch: function onsearch(inputVal) {},
        minSearchLen: 0,
        escWillClear: true,
        oninit: function oninit() {}
    };

    // .................................................................... input rendering and events
    // visually clear the search, trigger an event, and call the callback
    function clearSearchInput(event) {
        var $input = $(this).parent().children("input");
        $input.val("").trigger("searchInput.clear").blur();
        options.onclear();
    }

    // search for searchTerms, trigger an event, call the appropo callback (based on whether this is the first)
    function search(event, searchTerms) {
        if (!searchTerms) {
            return clearSearchInput();
        }
        $(this).trigger("search.search", searchTerms);
        if (typeof options.onfirstsearch === "function" && firstSearch) {
            firstSearch = false;
            options.onfirstsearch(searchTerms);
        } else {
            options.onsearch(searchTerms);
        }
    }

    // .................................................................... input rendering and events
    function inputTemplate() {
        // class search-query is bootstrap 2.3 style that now lives in base.less
        return ['<input type="text" name="', options.name, '" placeholder="', options.placeholder, '" ', 'class="search-query ', options.classes, '" ', "/>"].join("");
    }

    // the search input that responds to keyboard events and displays the search value
    function $input() {
        return $(inputTemplate())
        // select all text on a focus
        .focus(function (event) {
            $(this).select();
        })
        // attach behaviors to esc, return if desired, search on some min len string
        .keyup(function (event) {
            event.preventDefault();
            event.stopPropagation();

            // esc key will clear if desired
            if (event.which === KEYCODE_ESC && options.escWillClear) {
                clearSearchInput.call(this, event);
            } else {
                var searchTerms = $(this).val();
                // return key or the search string len > minSearchLen (if not 0) triggers search
                if (event.which === KEYCODE_RETURN || options.minSearchLen && searchTerms.length >= options.minSearchLen) {
                    search.call(this, event, searchTerms);
                }
            }
        }).val(options.initialVal);
    }

    // .................................................................... clear button rendering and events
    // a button for clearing the search bar, placed on the right hand side
    function $clearBtn() {
        return $(['<span class="search-clear fa fa-times-circle" ', 'title="', _l("clear search (esc)"), '"></span>'].join("")).tooltip({ placement: "bottom" }).click(function (event) {
            clearSearchInput.call(this, event);
        });
    }

    // .................................................................... loadingIndicator rendering
    // a button for clearing the search bar, placed on the right hand side
    function $loadingIndicator() {
        return $(['<span class="search-loading fa fa-spinner fa-spin" ', 'title="', _l("loading..."), '"></span>'].join("")).hide().tooltip({ placement: "bottom" });
    }

    // .................................................................... commands
    // visually swap the load, clear buttons
    function toggleLoadingIndicator() {
        $parentNode.find(".search-loading").toggle();
        $parentNode.find(".search-clear").toggle();
    }

    // .................................................................... init
    // string command (not constructor)
    if (_jquery2.default.type(options) === "string") {
        if (options === "toggle-loading") {
            toggleLoadingIndicator();
        }
        return $parentNode;
    }

    // initial render
    if (_jquery2.default.type(options) === "object") {
        options = _jquery2.default.extend(true, {}, defaults, options);
    }
    //NOTE: prepended
    return $parentNode.addClass("search-input").prepend([$input(), $clearBtn(), $loadingIndicator()]);
}

// as jq plugin
_jquery2.default.fn.extend({
    searchInput: function $searchInput(options) {
        return this.each(function () {
            return searchInput(this, options);
        });
    }
});

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _historyContents = __webpack_require__(169);

var _historyContents2 = _interopRequireDefault(_historyContents);

var _controlledFetchCollection = __webpack_require__(193);

var _controlledFetchCollection2 = _interopRequireDefault(_controlledFetchCollection);

var _utils = __webpack_require__(5);

var _utils2 = _interopRequireDefault(_utils);

var _baseMvc = __webpack_require__(6);

var _baseMvc2 = _interopRequireDefault(_baseMvc);

var _localization = __webpack_require__(3);

var _localization2 = _interopRequireDefault(_localization);

var _underscore = __webpack_require__(1);

var _ = _interopRequireWildcard(_underscore);

var _backbone = __webpack_require__(2);

var Backbone = _interopRequireWildcard(_backbone);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global jQuery */
/* global Galaxy */

//==============================================================================
/** @class Model for a Galaxy history resource - both a record of user
 *      tool use and a collection of the datasets those tools produced.
 *  @name History
 *  @augments Backbone.Model
 */
var History = Backbone.Model.extend(_baseMvc2.default.LoggableMixin).extend(_baseMvc2.default.mixin(_baseMvc2.default.SearchableModelMixin,
/** @lends History.prototype */{
    _logNamespace: "history",

    /** ms between fetches when checking running jobs/datasets for updates */
    UPDATE_DELAY: 4000,

    // values from api (may need more)
    defaults: {
        model_class: "History",
        id: null,
        name: "Unnamed History",
        state: "new",

        deleted: false,
        contents_active: {},
        contents_states: {}
    },

    contentsClass: _historyContents2.default.HistoryContents,

    /** What model fields to search with */
    searchAttributes: ["name", "annotation", "tags"],

    /** Adding title and singular tag */
    searchAliases: {
        title: "name",
        tag: "tags"
    },

    // ........................................................................ set up/tear down
    /** Set up the model
     *  @param {Object} historyJSON model data for this History
     *  @param {Object} options     any extra settings including logger
     */
    initialize: function initialize(historyJSON, options) {
        options = options || {};
        this.logger = options.logger || null;
        this.log(this + ".initialize:", historyJSON, options);

        this.urlRoot = Galaxy.root + "api/histories";
        /** HistoryContents collection of the HDAs contained in this history. */
        this.contents = new this.contentsClass([], {
            history: this,
            historyId: this.get("id"),
            order: options.order
        });

        this._setUpListeners();
        this._setUpCollectionListeners();

        /** cached timeout id for the dataset updater */
        this.updateTimeoutId = null;
    },

    /** set up any event listeners for this history including those to the contained HDAs
     *  events: error:contents  if an error occurred with the contents collection
     */
    _setUpListeners: function _setUpListeners() {
        // if the model's id changes ('current' or null -> an actual id), update the contents history_id
        return this.on({
            error: function error(model, xhr, options, msg, details) {
                this.clearUpdateTimeout();
            },
            "change:id": function changeId(model, newId) {
                if (this.contents) {
                    this.contents.historyId = newId;
                }
            }
        });
    },

    /** event handlers for the contents submodels */
    _setUpCollectionListeners: function _setUpCollectionListeners() {
        if (!this.contents) {
            return this;
        }
        // bubble up errors
        return this.listenTo(this.contents, {
            error: function error() {
                this.trigger.apply(this, jQuery.makeArray(arguments));
            }
        });
    },

    // ........................................................................ derived attributes
    /**  */
    contentsShown: function contentsShown() {
        var contentsActive = this.get("contents_active");
        var shown = contentsActive.active || 0;
        shown += this.contents.includeDeleted ? contentsActive.deleted : 0;
        shown += this.contents.includeHidden ? contentsActive.hidden : 0;
        return shown;
    },

    /** convert size in bytes to a more human readable version */
    nice_size: function nice_size() {
        var size = this.get("size");
        return size ? _utils2.default.bytesToString(size, true, 2) : (0, _localization2.default)("(empty)");
    },

    /** override to add nice_size */
    toJSON: function toJSON() {
        return _.extend(Backbone.Model.prototype.toJSON.call(this), {
            nice_size: this.nice_size()
        });
    },

    /** override to allow getting nice_size */
    get: function get(key) {
        if (key === "nice_size") {
            return this.nice_size();
        }
        return Backbone.Model.prototype.get.apply(this, arguments);
    },

    // ........................................................................ common queries
    /** T/F is this history owned by the current user (Galaxy.user)
     *      Note: that this will return false for an anon user even if the history is theirs.
     */
    ownedByCurrUser: function ownedByCurrUser() {
        // no currUser
        if (!Galaxy || !Galaxy.user) {
            return false;
        }
        // user is anon or history isn't owned
        if (Galaxy.user.isAnonymous() || Galaxy.user.id !== this.get("user_id")) {
            return false;
        }
        return true;
    },

    /** Return the number of running jobs assoc with this history (note: unknown === 0) */
    numOfUnfinishedJobs: function numOfUnfinishedJobs() {
        var unfinishedJobIds = this.get("non_ready_jobs");
        return unfinishedJobIds ? unfinishedJobIds.length : 0;
    },

    /** Return the number of running hda/hdcas in this history (note: unknown === 0) */
    numOfUnfinishedShownContents: function numOfUnfinishedShownContents() {
        return this.contents.runningAndActive().length || 0;
    },

    // ........................................................................ updates
    _fetchContentRelatedAttributes: function _fetchContentRelatedAttributes() {
        var contentRelatedAttrs = ["size", "non_ready_jobs", "contents_active", "hid_counter"];
        return this.fetch({
            data: jQuery.param({
                keys: contentRelatedAttrs.join(",")
            })
        });
    },

    /** check for any changes since the last time we updated (or fetch all if ) */
    refresh: function refresh(options) {
        var _this = this;

        // console.log( this + '.refresh' );
        options = options || {};

        // note if there was no previous update time, all summary contents will be fetched
        var lastUpdateTime = this.lastUpdateTime;
        // if we don't flip this, then a fully-fetched list will not be re-checked via fetch
        this.contents.allFetched = false;
        var fetchFn = this.contents.currentPage !== 0 ? function () {
            return _this.contents.fetchPage(_this.contents.currentPage);
        } : function () {
            return _this.contents.fetchUpdated(lastUpdateTime);
        };
        // note: if there was no previous update time, all summary contents will be fetched
        return fetchFn().done(function (response, status, xhr) {
            var serverResponseDatetime;
            try {
                serverResponseDatetime = new Date(xhr.getResponseHeader("Date"));
            } catch (err) {
                console.error(err);
            }
            _this.lastUpdateTime = serverResponseDatetime || new Date();
            _this.checkForUpdates(options);
        });
    },

    /** continuously fetch updated contents every UPDATE_DELAY ms if this history's datasets or jobs are unfinished */
    checkForUpdates: function checkForUpdates(options) {
        var _this2 = this;

        // console.log( this + '.checkForUpdates' );
        options = options || {};
        var delay = this.UPDATE_DELAY;
        if (!this.id) {
            return;
        }

        var _delayThenUpdate = function _delayThenUpdate() {
            // prevent buildup of updater timeouts by clearing previous if any, then set new and cache id
            _this2.clearUpdateTimeout();
            _this2.updateTimeoutId = setTimeout(function () {
                _this2.refresh(options);
            }, delay);
        };

        // if there are still datasets in the non-ready state, recurse into this function with the new time
        var nonReadyContentCount = this.numOfUnfinishedShownContents();
        // console.log( 'nonReadyContentCount:', nonReadyContentCount );
        if (nonReadyContentCount > 0) {
            _delayThenUpdate();
        } else {
            // no datasets are running, but currently runnning jobs may still produce new datasets
            // see if the history has any running jobs and continue to update if so
            // (also update the size for the user in either case)
            this._fetchContentRelatedAttributes().done(function (historyData) {
                // console.log( 'non_ready_jobs:', historyData.non_ready_jobs );
                if (_this2.numOfUnfinishedJobs() > 0) {
                    _delayThenUpdate();
                } else {
                    // otherwise, let listeners know that all updates have stopped
                    _this2.trigger("ready");
                }
            });
        }
    },

    /** clear the timeout and the cached timeout id */
    clearUpdateTimeout: function clearUpdateTimeout() {
        if (this.updateTimeoutId) {
            clearTimeout(this.updateTimeoutId);
            this.updateTimeoutId = null;
        }
    },

    stopPolling: function stopPolling() {
        this.clearUpdateTimeout();
        if (this.contents) {
            this.contents.stopPolling();
        }
    },

    // ........................................................................ ajax
    /** override to use actual Dates objects for create/update times */
    parse: function parse(response, options) {
        var parsed = Backbone.Model.prototype.parse.call(this, response, options);
        if (parsed.create_time) {
            parsed.create_time = new Date(parsed.create_time);
        }
        if (parsed.update_time) {
            parsed.update_time = new Date(parsed.update_time);
        }
        return parsed;
    },

    /** fetch this histories data (using options) then it's contents (using contentsOptions) */
    fetchWithContents: function fetchWithContents(options, contentsOptions) {
        options = options || {};
        var self = this;

        // console.log( this + '.fetchWithContents' );
        // TODO: push down to a base class
        options.view = "dev-detailed";

        // fetch history then use history data to fetch (paginated) contents
        return this.fetch(options).then(function getContents(history) {
            self.contents.history = self;
            self.contents.setHistoryId(history.id);
            return self.fetchContents(contentsOptions);
        });
    },

    /** fetch this histories contents, adjusting options based on the stored history preferences */
    fetchContents: function fetchContents(options) {
        options = options || {};

        // we're updating, reset the update time
        this.lastUpdateTime = new Date();
        return this.contents.fetchCurrentPage(options);
    },

    /** save this history, _Mark_ing it as deleted (just a flag) */
    _delete: function _delete(options) {
        if (this.get("deleted")) {
            return jQuery.when();
        }
        return this.save({ deleted: true }, options);
    },
    /** purge this history, _Mark_ing it as purged and removing all dataset data from the server */
    purge: function purge(options) {
        if (this.get("purged")) {
            return jQuery.when();
        }
        return this.save({ deleted: true, purged: true }, options);
    },
    /** save this history, _Mark_ing it as undeleted */
    undelete: function undelete(options) {
        if (!this.get("deleted")) {
            return jQuery.when();
        }
        return this.save({ deleted: false }, options);
    },

    /** Make a copy of this history on the server
     *  @param {Boolean} current    if true, set the copy as the new current history (default: true)
     *  @param {String} name        name of new history (default: none - server sets to: Copy of <current name>)
     *  @fires copied               passed this history and the response JSON from the copy
     *  @returns {xhr}
     */
    copy: function copy(current, name, allDatasets) {
        current = current !== undefined ? current : true;
        if (!this.id) {
            throw new Error("You must set the history ID before copying it.");
        }

        var postData = { history_id: this.id };
        if (current) {
            postData.current = true;
        }
        if (name) {
            postData.name = name;
        }
        if (!allDatasets) {
            postData.all_datasets = false;
        }
        postData.view = "dev-detailed";

        var history = this;
        var copy = jQuery.post(this.urlRoot, postData);
        // if current - queue to setAsCurrent before firing 'copied'
        if (current) {
            return copy.then(function (response) {
                var newHistory = new History(response);
                return newHistory.setAsCurrent().done(function () {
                    history.trigger("copied", history, response);
                });
            });
        }
        return copy.done(function (response) {
            history.trigger("copied", history, response);
        });
    },

    setAsCurrent: function setAsCurrent() {
        var history = this;

        var xhr = jQuery.getJSON(Galaxy.root + "history/set_as_current?id=" + this.id);

        xhr.done(function () {
            history.trigger("set-as-current", history);
        });
        return xhr;
    },

    // ........................................................................ misc
    toString: function toString() {
        return "History(" + this.get("id") + "," + this.get("name") + ")";
    }
}));

//==============================================================================
var _collectionSuper = _controlledFetchCollection2.default.InfinitelyScrollingCollection;
/** @class A collection of histories (per user)
 *      that maintains the current history as the first in the collection.
 *  New or copied histories become the current history.
 */
var HistoryCollection = _collectionSuper.extend(_baseMvc2.default.LoggableMixin).extend({
    _logNamespace: "history",

    model: History,
    /** @type {String} initial order used by collection */
    order: "update_time",
    /** @type {Number} limit used for the first fetch (or a reset) */
    limitOnFirstFetch: 10,
    /** @type {Number} limit used for each subsequent fetch */
    limitPerFetch: 10,

    initialize: function initialize(models, options) {
        options = options || {};
        this.log("HistoryCollection.initialize", models, options);
        this.urlRoot = Galaxy.root + "api/histories";
        _collectionSuper.prototype.initialize.call(this, models, options);

        /** @type {boolean} should deleted histories be included */
        this.includeDeleted = options.includeDeleted || false;

        /** @type {String} encoded id of the history that's current */
        this.currentHistoryId = options.currentHistoryId;

        this.setUpListeners();
        // note: models are sent to reset *after* this fn ends; up to this point
        // the collection *is empty*
    },

    url: function url() {
        return this.urlRoot;
    },

    /** set up reflexive event handlers */
    setUpListeners: function setUpListeners() {
        return this.on({
            // when a history is deleted, remove it from the collection (if optionally set to do so)
            "change:deleted": function changeDeleted(history) {
                // TODO: this becomes complicated when more filters are used
                this.debug("change:deleted", this.includeDeleted, history.get("deleted"));
                if (!this.includeDeleted && history.get("deleted")) {
                    this.remove(history);
                }
            },
            // listen for a history copy, setting it to current
            copied: function copied(original, newData) {
                this.setCurrent(new History(newData, []));
            },
            // when a history is made current, track the id in the collection
            "set-as-current": function setAsCurrent(history) {
                var oldCurrentId = this.currentHistoryId;
                this.trigger("no-longer-current", oldCurrentId);
                this.currentHistoryId = history.id;
            }
        });
    },

    /** override to change view */
    _buildFetchData: function _buildFetchData(options) {
        return _.extend(_collectionSuper.prototype._buildFetchData.call(this, options), {
            view: "dev-detailed"
        });
    },

    /** override to filter out deleted and purged */
    _buildFetchFilters: function _buildFetchFilters(options) {
        var superFilters = _collectionSuper.prototype._buildFetchFilters.call(this, options) || {};
        var filters = {};
        if (this.includeDeleted !== true) {
            filters.deleted = false;
            filters.purged = false;
        } else {
            // force API to return both deleted and non
            //TODO: when the API is updated, remove this
            filters.deleted = null;
        }
        return _.defaults(superFilters, filters);
    },

    /** override to fetch current as well (as it may be outside the first 10, etc.) */
    fetchFirst: function fetchFirst(options) {
        var _this3 = this;

        // TODO: batch?
        var xhr = jQuery.when();
        if (this.currentHistoryId) {
            xhr = _collectionSuper.prototype.fetchFirst.call(this, {
                silent: true,
                limit: 1,
                filters: {
                    "encoded_id-in": this.currentHistoryId,
                    // without these a deleted current history will return [] here and block the other xhr
                    deleted: null,
                    purged: ""
                }
            });
        }
        return xhr.then(function () {
            options = options || {};
            options.offset = 0;
            return _this3.fetchMore(options);
        });
    },

    /** @type {Object} map of collection available sorting orders containing comparator fns */
    comparators: _.extend(_.clone(_collectionSuper.prototype.comparators), {
        name: _baseMvc2.default.buildComparator("name", {
            ascending: true
        }),
        "name-dsc": _baseMvc2.default.buildComparator("name", {
            ascending: false
        }),
        size: _baseMvc2.default.buildComparator("size", {
            ascending: false
        }),
        "size-asc": _baseMvc2.default.buildComparator("size", {
            ascending: true
        })
    }),

    /** override to always have the current history first */
    sort: function sort(options) {
        options = options || {};
        var silent = options.silent;
        var currentHistory = this.remove(this.get(this.currentHistoryId));
        _collectionSuper.prototype.sort.call(this, _.defaults({ silent: true }, options));
        this.unshift(currentHistory, { silent: true });
        if (!silent) {
            this.trigger("sort", this, options);
        }
        return this;
    },

    /** create a new history and by default set it to be the current history */
    create: function create(data, hdas, historyOptions, xhrOptions) {
        //TODO: .create is actually a collection function that's overridden here
        var collection = this;

        var xhr = jQuery.getJSON(Galaxy.root + "history/create_new_current");
        return xhr.done(function (newData) {
            collection.setCurrent(new History(newData, [], historyOptions || {}));
        });
    },

    /** set the current history to the given history, placing it first in the collection.
     *  Pass standard bbone options for use in unshift.
     *  @triggers new-current passed history and this collection
     */
    setCurrent: function setCurrent(history, options) {
        options = options || {};
        // new histories go in the front
        this.unshift(history, options);
        this.currentHistoryId = history.get("id");
        if (!options.silent) {
            this.trigger("new-current", history, this);
        }
        return this;
    },

    toString: function toString() {
        return "HistoryCollection(" + this.length + ",current:" + this.currentHistoryId + ")";
    }
});

//==============================================================================
exports.default = {
    History: History,
    HistoryCollection: HistoryCollection
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _controlledFetchCollection = __webpack_require__(193);

var _controlledFetchCollection2 = _interopRequireDefault(_controlledFetchCollection);

var _hdaModel = __webpack_require__(152);

var _hdaModel2 = _interopRequireDefault(_hdaModel);

var _hdcaModel = __webpack_require__(163);

var _hdcaModel2 = _interopRequireDefault(_hdcaModel);

var _historyPreferences = __webpack_require__(235);

var _historyPreferences2 = _interopRequireDefault(_historyPreferences);

var _jobStatesModel = __webpack_require__(204);

var _jobStatesModel2 = _interopRequireDefault(_jobStatesModel);

var _baseMvc = __webpack_require__(6);

var _baseMvc2 = _interopRequireDefault(_baseMvc);

var _ajaxQueue = __webpack_require__(164);

var _ajaxQueue2 = _interopRequireDefault(_ajaxQueue);

var _underscore = __webpack_require__(1);

var _ = _interopRequireWildcard(_underscore);

var _backbone = __webpack_require__(2);

var Backbone = _interopRequireWildcard(_backbone);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global Galaxy */
/* global jQuery */

var limitPerPageDefault = window.localStorage.getItem("historyContentsLimitPerPageDefault") || 500;

//==============================================================================
var _super = _controlledFetchCollection2.default.PaginatedCollection;
/** @class Backbone collection for history content.
 *      NOTE: history content seems like a dataset collection, but differs in that it is mixed:
 *          each element can be either an HDA (dataset) or a DatasetCollection and co-exist on
 *          the same level.
 *      Dataset collections on the other hand are not mixed and (so far) can only contain either
 *          HDAs or child dataset collections on one level.
 *      This is why this does not inherit from any of the DatasetCollections (currently).
 */
var HistoryContents = _super.extend(_baseMvc2.default.LoggableMixin).extend({
    _logNamespace: "history",

    // ........................................................................ set up
    limitPerPage: limitPerPageDefault,

    /** @type {Integer} how many contents per call to fetch when using progressivelyFetchDetails */
    limitPerProgressiveFetch: limitPerPageDefault,

    /** @type {String} order used here and when fetching from server */
    order: "hid",

    /** complete api url */
    url: function url() {
        return this.urlRoot + "/" + this.historyId + "/contents";
    },

    /** Set up */
    initialize: function initialize(models, options) {
        this.on({
            "sync add": this.trackJobStates
        });

        options = options || {};
        this.urlRoot = Galaxy.root + "api/histories";
        _super.prototype.initialize.call(this, models, options);

        this.history = options.history || null;
        this.setHistoryId(options.historyId || null);
        /** @type {Boolean} does this collection contain and fetch deleted elements */
        this.includeDeleted = options.includeDeleted || this.includeDeleted;
        /** @type {Boolean} does this collection contain and fetch non-visible elements */
        this.includeHidden = options.includeHidden || this.includeHidden;

        // backbonejs uses collection.model.prototype.idAttribute to determine if a model is *already* in a collection
        //  and either merged or replaced. In this case, our 'model' is a function so we need to add idAttribute
        //  manually here - if we don't, contents will not merge but be replaced/swapped.
        this.model.prototype.idAttribute = "type_id";
    },

    trackJobStates: function trackJobStates() {
        var _this = this;

        this.each(function (historyContent) {
            if (historyContent.has("job_states_summary")) {
                return;
            }

            if (historyContent.attributes.history_content_type === "dataset_collection") {
                var jobSourceType = historyContent.attributes.job_source_type;
                var jobSourceId = historyContent.attributes.job_source_id;
                if (jobSourceType && _this.jobStateSummariesCollection) {
                    _this.jobStateSummariesCollection.add({
                        id: jobSourceId,
                        model: jobSourceType,
                        history_id: _this.history_id,
                        collection_id: historyContent.attributes.id
                    });
                    var jobStatesSummary = _this.jobStateSummariesCollection.get(jobSourceId);
                    historyContent.jobStatesSummary = jobStatesSummary;
                }
            }
        });
    },

    // ........................................................................ composite collection
    /** since history content is a mix, override model fn into a factory, creating based on history_content_type */
    model: function model(attrs, options) {
        if (attrs.history_content_type === "dataset") {
            return new _hdaModel2.default.HistoryDatasetAssociation(attrs, options);
        } else if (attrs.history_content_type === "dataset_collection") {
            return new _hdcaModel2.default.HistoryDatasetCollection(attrs, options);
        } else {
            return {
                validationError: "Unknown history_content_type: " + attrs.history_content_type
            };
        }
    },

    stopPolling: function stopPolling() {
        if (this.jobStateSummariesCollection) {
            this.jobStateSummariesCollection.active = false;
            this.jobStateSummariesCollection.clearUpdateTimeout();
        }
    },

    setHistoryId: function setHistoryId(newId) {
        this.stopPolling();
        this.historyId = newId;
        if (newId) {
            // If actually reflecting a history - setup storage and monitor jobs.

            this._setUpWebStorage();

            this.jobStateSummariesCollection = new _jobStatesModel2.default.JobStatesSummaryCollection();
            this.jobStateSummariesCollection.historyId = newId;
            this.jobStateSummariesCollection.monitor();
        }
    },

    /** Set up client side storage. Currently PersistanStorage keyed under 'history:<id>' */
    _setUpWebStorage: function _setUpWebStorage(initialSettings) {
        // TODO: use initialSettings
        this.storage = new _historyPreferences2.default.HistoryPrefs({
            id: _historyPreferences2.default.HistoryPrefs.historyStorageKey(this.historyId)
        });
        this.trigger("new-storage", this.storage, this);

        this.on({
            "include-deleted": function includeDeleted(newVal) {
                this.storage.includeDeleted(newVal);
            },
            "include-hidden": function includeHidden(newVal) {
                this.storage.includeHidden(newVal);
            }
        });

        this.includeDeleted = this.storage.includeDeleted() || false;
        this.includeHidden = this.storage.includeHidden() || false;
        return this;
    },

    // ........................................................................ common queries
    /** @type {Object} map of collection available sorting orders containing comparator fns */
    comparators: _.extend(_.clone(_super.prototype.comparators), {
        name: _baseMvc2.default.buildComparator("name", { ascending: true }),
        "name-dsc": _baseMvc2.default.buildComparator("name", {
            ascending: false
        }),
        hid: _baseMvc2.default.buildComparator("hid", { ascending: false }),
        "hid-asc": _baseMvc2.default.buildComparator("hid", { ascending: true })
    }),

    /** Get every model in this collection not in a 'ready' state (running). */
    running: function running() {
        return this.filter(function (c) {
            return !c.inReadyState();
        });
    },

    /** return contents that are not ready and not deleted/hidden */
    runningAndActive: function runningAndActive() {
        return this.filter(function (c) {
            return !c.inReadyState() && c.get("visible") &&
            // TODO: deletedOrPurged?
            !c.get("deleted");
        });
    },

    /** Get the model with the given hid
     *  @param {Int} hid the hid to search for
     *  @returns {HistoryDatasetAssociation} the model with the given hid or undefined if not found
     */
    getByHid: function getByHid(hid) {
        // note: there *can* be more than one content with a given hid, this finds the first based on order
        return this.findWhere({ hid: hid });
    },

    /** return true if all contents have details */
    haveDetails: function haveDetails() {
        return this.all(function (c) {
            return c.hasDetails();
        });
    },

    // ........................................................................ hidden / deleted
    /** return a new contents collection of only hidden items */
    hidden: function hidden() {
        return this.filter(function (c) {
            return c.hidden();
        });
    },

    /** return a new contents collection of only hidden items */
    deleted: function deleted() {
        return this.filter(function (c) {
            return c.get("deleted");
        });
    },

    /** return a new contents collection of only hidden items */
    visibleAndUndeleted: function visibleAndUndeleted() {
        return this.filter(function (c) {
            return c.get("visible") &&
            // TODO: deletedOrPurged?
            !c.get("deleted");
        });
    },

    /** create a setter in order to publish the change */
    setIncludeDeleted: function setIncludeDeleted(setting, options) {
        if (_.isBoolean(setting) && setting !== this.includeDeleted) {
            this.includeDeleted = setting;
            if (_.result(options, "silent")) {
                return;
            }
            this.trigger("include-deleted", setting, this);
        }
    },

    /** create a setter in order to publish the change */
    setIncludeHidden: function setIncludeHidden(setting, options) {
        if (_.isBoolean(setting) && setting !== this.includeHidden) {
            this.includeHidden = setting;
            options = options || {};
            if (_.result(options, "silent")) {
                return;
            }
            this.trigger("include-hidden", setting, this);
        }
    },

    // ........................................................................ ajax
    // ............ controlled fetch collection
    /** override to get expanded ids from sessionStorage and pass to API as details */
    fetch: function fetch(options) {
        options = options || {};
        if (this.historyId && !options.details) {
            var prefs = _historyPreferences2.default.HistoryPrefs.get(this.historyId).toJSON();
            if (!_.isEmpty(prefs.expandedIds)) {
                options.details = _.values(prefs.expandedIds).join(",");
            }
        }
        return _super.prototype.fetch.call(this, options);
    },

    // ............. ControlledFetch stuff
    /** override to include the API versioning flag */
    _buildFetchData: function _buildFetchData(options) {
        return _.extend(_super.prototype._buildFetchData.call(this, options), {
            v: "dev"
        });
    },

    /** Extend to include details and version */
    _fetchParams: _super.prototype._fetchParams.concat([
    // TODO: remove (the need for) both
    /** version */
    "v",
    /** dataset ids to get full details of */
    "details"]),

    /** override to add deleted/hidden filters */
    _buildFetchFilters: function _buildFetchFilters(options) {
        var superFilters = _super.prototype._buildFetchFilters.call(this, options) || {};
        var filters = {};
        if (!this.includeDeleted) {
            filters.deleted = false;
            filters.purged = false;
        }
        if (!this.includeHidden) {
            filters.visible = true;
        }
        return _.defaults(superFilters, filters);
    },

    // ............ paginated collection
    getTotalItemCount: function getTotalItemCount() {
        return this.history.contentsShown();
    },

    // ............ history contents specific ajax
    /** override to filter requested contents to those updated after the Date 'since' */
    fetchUpdated: function fetchUpdated(since, options) {
        if (since) {
            options = options || { filters: {} };
            options.remove = false;
            options.filters = {
                "update_time-ge": since.toISOString(),
                // workflows will produce hidden datasets (non-output datasets) that still
                // need to be updated in the collection or they'll update forever
                // we can remove the default visible filter by using an 'empty' value
                visible: ""
            };
        }
        return this.fetch(options);
    },

    /** fetch all the deleted==true contents of this collection */
    fetchDeleted: function fetchDeleted(options) {
        var _this2 = this;

        options = options || {};
        options.filters = _.extend(options.filters, {
            // all deleted, purged or not
            deleted: true,
            purged: undefined
        });
        options.remove = false;

        this.trigger("fetching-deleted", this);
        return this.fetch(options).always(function () {
            _this2.trigger("fetching-deleted-done", _this2);
        });
    },

    /** fetch all the visible==false contents of this collection */
    fetchHidden: function fetchHidden(options) {
        var _this3 = this;

        options = options || {};
        options.filters = _.extend(options.filters, {
            visible: false
        });
        options.remove = false;

        this.trigger("fetching-hidden", this);
        return this.fetch(options).always(function () {
            _this3.trigger("fetching-hidden-done", _this3);
        });
    },

    /** fetch detailed model data for all contents in this collection */
    fetchAllDetails: function fetchAllDetails(options) {
        options = options || {};
        var detailsFlag = { details: "all" };
        options.data = _.extend(options.data || {}, detailsFlag);
        return this.fetch(options);
    },

    // ............. quasi-batch ops
    // TODO: to batch
    /** helper that fetches using filterParams then calls save on each fetched using updateWhat as the save params */
    _filterAndUpdate: function _filterAndUpdate(filterParams, updateWhat) {
        var _this4 = this;

        var idAttribute = this.model.prototype.idAttribute;
        var updateArgs = [updateWhat];

        return this.fetch({ filters: filterParams, remove: false }).then(function (fetched) {
            // convert filtered json array to model array
            fetched = fetched.reduce(function (modelArray, currJson, i) {
                var model = _this4.get(currJson[idAttribute]);
                return model ? modelArray.concat(model) : modelArray;
            }, []);
            return _this4.ajaxQueue("save", updateArgs, fetched);
        });
    },

    /** using a queue, perform ajaxFn on each of the models in this collection */
    ajaxQueue: function ajaxQueue(ajaxFn, args, collection) {
        collection = collection || this.models;
        return new _ajaxQueue2.default.AjaxQueue(collection.slice().reverse().map(function (content, i) {
            var fn = _.isString(ajaxFn) ? content[ajaxFn] : ajaxFn;
            return function () {
                return fn.apply(content, args);
            };
        })).deferred;
    },

    _recursivelyFetch: function _recursivelyFetch(options, detailKeys, deferred, limit, offset) {
        var _this5 = this;

        offset = offset || 0;
        var _options = _.extend(_.clone(options), {
            view: "summary",
            keys: detailKeys,
            limit: limit,
            offset: offset,
            reset: offset === 0,
            remove: false
        });

        _.defer(function () {
            _this5.fetch.call(_this5, _options).fail(deferred.reject).done(function (response) {
                deferred.notify(response, limit, offset);
                if (response.length !== limit) {
                    _this5.allFetched = true;
                    deferred.resolve(response, limit, offset);
                } else {
                    _this5._recursivelyFetch(options, detailKeys, deferred, limit, offset + limit);
                }
            });
        });
    },

    /** fetch contents' details in batches of limitPerCall - note: only get searchable details here */
    progressivelyFetchDetails: function progressivelyFetchDetails(options) {
        // TODO: only fetch tags and annotations if specifically requested
        options = options || {};
        var deferred = jQuery.Deferred();
        this._recursivelyFetch(options, _hdaModel2.default.HistoryDatasetAssociation.prototype.searchAttributes.join(","), deferred, options.limitPerCall || this.limitPerProgressiveFetch);
        return deferred;
    },

    /** does some bit of JSON represent something that can be copied into this contents collection */
    isCopyable: function isCopyable(contentsJSON) {
        var copyableModelClasses = ["HistoryDatasetAssociation", "HistoryDatasetCollectionAssociation"];
        return _.isObject(contentsJSON) && contentsJSON.id && _.contains(copyableModelClasses, contentsJSON.model_class);
    },

    /** copy an existing, accessible hda into this collection */
    copy: function copy(json) {
        // TODO: somehow showhorn all this into 'save'
        var id;

        var type;
        var contentType;
        if (_.isString(json)) {
            id = json;
            contentType = "hda";
            type = "dataset";
        } else {
            id = json.id;
            contentType = {
                HistoryDatasetAssociation: "hda",
                LibraryDatasetDatasetAssociation: "ldda",
                HistoryDatasetCollectionAssociation: "hdca"
            }[json.model_class] || "hda";
            type = contentType === "hdca" ? "dataset_collection" : "dataset";
        }
        var collection = this;

        var xhr = jQuery.ajax(this.url(), {
            method: "POST",
            contentType: "application/json",
            data: JSON.stringify({
                content: id,
                source: contentType,
                type: type
            })
        }).done(function (response) {
            collection.add([response], { parse: true });
        }).fail(function (error, status, message) {
            collection.trigger("error", collection, xhr, {}, "Error copying contents", {
                type: type,
                id: id,
                source: contentType
            });
        });

        return xhr;
    },

    /** create a new HDCA in this collection */
    createHDCA: function createHDCA(elementIdentifiers, collectionType, name, hideSourceItems, copyElements, options) {
        // normally collection.create returns the new model, but we need the promise from the ajax, so we fake create
        //precondition: elementIdentifiers is an array of plain js objects
        //  in the proper form to create the collectionType
        if (copyElements === undefined) {
            copyElements = true;
        }

        var hdca = this.model({
            history_content_type: "dataset_collection",
            collection_type: collectionType,
            history_id: this.historyId,
            name: name,
            hide_source_items: hideSourceItems || false,
            copy_elements: copyElements,
            // should probably be able to just send in a bunch of json here and restruct per class
            // note: element_identifiers is now (incorrectly) an attribute
            element_identifiers: elementIdentifiers
            // do not create the model on the client until the ajax returns
        });
        return hdca.save(options);
    },

    // ........................................................................ searching
    /** return true if all contents have the searchable attributes */
    haveSearchDetails: function haveSearchDetails() {
        return this.allFetched && this.all(function (content // null (which is a valid returned annotation value)
        ) {
            return (
                // will return false when using content.has( 'annotation' )
                //TODO: a bit hacky - formalize
                _.has(content.attributes, "annotation")
            );
        });
    },

    /** return a new collection of contents whose attributes contain the substring matchesWhat */
    matches: function matches(matchesWhat) {
        return this.filter(function (content) {
            return content.matches(matchesWhat);
        });
    },

    // ........................................................................ misc
    /** In this override, copy the historyId to the clone */
    clone: function clone() {
        var clone = Backbone.Collection.prototype.clone.call(this);
        clone.historyId = this.historyId;
        return clone;
    },

    /** String representation. */
    toString: function toString() {
        return ["HistoryContents(", [this.historyId, this.length].join(), ")"].join("");
    }
});

//==============================================================================
exports.default = {
    HistoryContents: HistoryContents
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _datasetLi = __webpack_require__(153);

var _datasetLi2 = _interopRequireDefault(_datasetLi);

var _baseMvc = __webpack_require__(6);

var _baseMvc2 = _interopRequireDefault(_baseMvc);

var _historyItemLi = __webpack_require__(194);

var _historyItemLi2 = _interopRequireDefault(_historyItemLi);

var _localization = __webpack_require__(3);

var _localization2 = _interopRequireDefault(_localization);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//==============================================================================
var _super = _datasetLi2.default.DatasetListItemView;
/** @class Read only view for HistoryDatasetAssociation.
 *      Since there are no controls on the HDAView to hide the dataset,
 *      the primary thing this class does (currently) is override templates
 *      to render the HID.
 */
var HDAListItemView = _super.extend(
/** @lends HDAListItemView.prototype */{
    className: _super.prototype.className + " history-content",

    initialize: function initialize(attributes, options) {
        _super.prototype.initialize.call(this, attributes, options);
    },

    // ......................................................................... misc
    /** String representation */
    toString: function toString() {
        var modelString = this.model ? "" + this.model : "(no model)";
        return "HDAListItemView(" + modelString + ")";
    }
});

// ............................................................................ TEMPLATES
/** underscore templates */
HDAListItemView.prototype.templates = function () {
    var titleBarTemplate = function titleBarTemplate(dataset) {
        return "\n        <div class=\"title-bar clear\" tabindex=\"0\">\n            <span class=\"state-icon\"></span>\n            <div class=\"title\">\n                <span class=\"hid\">" + dataset.hid + "</span>\n                <span class=\"name\">" + _.escape(dataset.name) + "</span>\n            </div>\n            </br>\n            " + _historyItemLi2.default.nametagTemplate(dataset) + "\n        </div>\n    ";
    };

    var warnings = _.extend({}, _super.prototype.templates.warnings, {
        hidden: _baseMvc2.default.wrapTemplate([
        // add a warning when hidden
        "<% if( !dataset.visible ){ %>", '<div class="hidden-msg warningmessagesmall">', (0, _localization2.default)("This dataset has been hidden"), "</div>", "<% } %>"], "dataset")
    });

    return _.extend({}, _super.prototype.templates, {
        titleBar: titleBarTemplate,
        warnings: warnings
    });
}();

//==============================================================================
exports.default = {
    HDAListItemView: HDAListItemView
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _states = __webpack_require__(59);

var _states2 = _interopRequireDefault(_states);

var _collectionLi = __webpack_require__(154);

var _collectionLi2 = _interopRequireDefault(_collectionLi);

var _collectionView = __webpack_require__(195);

var _collectionView2 = _interopRequireDefault(_collectionView);

var _baseMvc = __webpack_require__(6);

var _baseMvc2 = _interopRequireDefault(_baseMvc);

var _historyItemLi = __webpack_require__(194);

var _historyItemLi2 = _interopRequireDefault(_historyItemLi);

var _localization = __webpack_require__(3);

var _localization2 = _interopRequireDefault(_localization);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//==============================================================================
var _super = _collectionLi2.default.DCListItemView;
/** @class Read only view for HistoryDatasetCollectionAssociation (a dataset collection inside a history).
 */
var HDCAListItemView = _super.extend(
/** @lends HDCAListItemView.prototype */{
    className: _super.prototype.className + " history-content",

    /** event listeners */
    _setUpListeners: function _setUpListeners() {
        var _this = this;

        _super.prototype._setUpListeners.call(this);
        var renderListen = function renderListen(model, options) {
            _this.render();
        };
        if (this.model.jobStatesSummary) {
            this.listenTo(this.model.jobStatesSummary, "change", renderListen);
        }
        this.listenTo(this.model, {
            "change:tags change:visible change:state": renderListen
        });
    },

    /** Override to provide the proper collections panels as the foldout */
    _getFoldoutPanelClass: function _getFoldoutPanelClass() {
        return _collectionView2.default.CollectionView;
    },

    /** In this override, add the state as a class for use with state-based CSS */
    _swapNewRender: function _swapNewRender($newRender) {
        _super.prototype._swapNewRender.call(this, $newRender);
        //TODO: model currently has no state
        var state;
        var jobStatesSummary = this.model.jobStatesSummary;
        if (jobStatesSummary) {
            if (jobStatesSummary.new()) {
                state = "loading";
            } else if (jobStatesSummary.errored()) {
                state = "error";
            } else if (jobStatesSummary.terminal()) {
                state = "ok";
            } else if (jobStatesSummary.running()) {
                state = "running";
            } else {
                state = "queued";
            }
        } else if (this.model.get("job_source_id")) {
            // Initial rendering - polling will fill in more details in a bit.
            state = "loading";
        } else {
            state = this.model.get("populated_state") ? _states2.default.OK : _states2.default.RUNNING;
        }
        this.$el.addClass("state-" + state);
        var stateDescription = this.stateDescription();
        this.$(".state-description").html(stateDescription);
        return this.$el;
    },

    stateDescription: function stateDescription() {
        var collection = this.model;
        var elementCount = collection.get("element_count");
        var jobStateSource = collection.get("job_source_type");
        var collectionType = this.model.get("collection_type");
        var collectionTypeDescription = _collectionView2.default.collectionTypeDescription(collection);
        var simpleDescription = _collectionView2.default.collectionDescription(collection);
        var jobStatesSummary = collection.jobStatesSummary;
        if (!jobStateSource || jobStateSource == "Job") {
            return simpleDescription;
        } else if (!jobStatesSummary || !jobStatesSummary.hasDetails()) {
            return "\n                    <div class=\"progress state-progress\">\n                        <span class=\"note\">Loading job data for " + collectionTypeDescription + ".<span class=\"blinking\">..</span></span>\n                        <div class=\"progress-bar info\" style=\"width:100%\">\n                    </div>";
        } else {
            var isNew = jobStatesSummary.new();
            var jobCount = isNew ? null : jobStatesSummary.jobCount();
            if (isNew) {
                return "\n                        <div class=\"progress state-progress\">\n                            <span class=\"note\">Creating jobs.<span class=\"blinking\">..</span></span>\n                            <div class=\"progress-bar info\" style=\"width:100%\">\n                        </div>";
            } else if (jobStatesSummary.errored()) {
                var errorCount = jobStatesSummary.numInError();
                return "a " + collectionTypeDescription + " with " + errorCount + " / " + jobCount + " jobs in error";
            } else if (jobStatesSummary.terminal()) {
                return simpleDescription;
            } else {
                var running = jobStatesSummary.states()["running"] || 0;
                var ok = jobStatesSummary.states()["ok"] || 0;
                var okPercent = ok / (jobCount * 1.0);
                var runningPercent = running / (jobCount * 1.0);
                var otherPercent = 1.0 - okPercent - runningPercent;
                var jobsStr = jobCount && jobCount > 1 ? jobCount + " jobs" : "a job";
                return "\n                        <div class=\"progress state-progress\">\n                            <span class=\"note\">" + jobsStr + " generating a " + collectionTypeDescription + "</span>\n                            <div class=\"progress-bar ok\" style=\"width:" + okPercent * 100.0 + "%\"></div>\n                            <div class=\"progress-bar running\" style=\"width:" + runningPercent * 100.0 + "%\"></div>\n                            <div class=\"progress-bar new\" style=\"width:" + otherPercent * 100.0 + "%\">\n                        </div>";
            }
        }
    },

    // ......................................................................... misc
    /** String representation */
    toString: function toString() {
        var modelString = this.model ? "" + this.model : "(no model)";
        return "HDCAListItemView(" + modelString + ")";
    }
});

/** underscore templates */
HDCAListItemView.prototype.templates = function () {
    var warnings = _.extend({}, _super.prototype.templates.warnings, {
        hidden: function hidden(collection) {
            collection.visible ? "" : "<div class=\"hidden-msg warningmessagesmall\">" + (0, _localization2.default)("This collection has been hidden") + "</div>";
        }
    });

    var titleBarTemplate = function titleBarTemplate(collection) {
        return "\n        <div class=\"title-bar clear\" tabindex=\"0\">\n            <span class=\"state-icon\"></span>\n            <div class=\"title\">\n                <span class=\"hid\">" + collection.hid + "</span>\n                <span class=\"name\">" + _.escape(collection.name) + "</span>\n            </div>\n            <div class=\"state-description\">\n            </div>\n            " + _historyItemLi2.default.nametagTemplate(collection) + "\n        </div>\n    ";
    };

    return _.extend({}, _super.prototype.templates, {
        warnings: warnings,
        titleBar: titleBarTemplate
    });
}();

//==============================================================================
exports.default = {
    HDCAListItemView: HDCAListItemView
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Backbone, _, $) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _data = __webpack_require__(180);

var _data2 = _interopRequireDefault(_data);

var _masthead = __webpack_require__(78);

var _masthead2 = _interopRequireDefault(_masthead);

var _panel = __webpack_require__(178);

var _panel2 = _interopRequireDefault(_panel);

var _uiModal = __webpack_require__(19);

var _uiModal2 = _interopRequireDefault(_uiModal);

var _utils = __webpack_require__(5);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var View = Backbone.View.extend({
    el: "body",
    className: "full-content",
    _panelids: ["left", "right"],

    initialize: function initialize(options) {
        var _this = this;

        var self = this;
        this.config = _.defaults(options.config || {}, {
            message_box_visible: false,
            message_box_content: "",
            message_box_class: "info",
            show_inactivity_warning: false,
            inactivity_box_content: "",
            hide_panels: false,
            hide_masthead: false
        });

        // attach global objects, build mastheads
        Galaxy.modal = this.modal = new _uiModal2.default.View();
        Galaxy.router = this.router = options.Router && new options.Router(self, options);
        Galaxy.data = this.data = new _data2.default(this);
        this.masthead = new _masthead2.default.View(this.config);
        this.center = new _panel2.default.CenterPanel();

        // display helper
        Galaxy.display = this.display = function (view) {
            if (view.title) {
                _utils2.default.setWindowTitle(view.title);
                view.allow_title_display = false;
            } else {
                _utils2.default.setWindowTitle();
                view.allow_title_display = true;
            }
            if (view.active_tab) {
                self.masthead.highlight(view.active_tab);
            }
            self.center.display(view);
        };

        // build page template
        this.$el.attr("scroll", "no");
        this.$el.html(this._template());
        this.$masthead = this.$("#masthead");
        this.$center = this.$("#center");
        this.$messagebox = this.$("#messagebox");
        this.$inactivebox = this.$("#inactivebox");

        // build components
        if (this.config.hide_masthead) {
            this.$masthead.remove();
            this.$center.css("top", 0);
        } else {
            this.$masthead.replaceWith(this.masthead.$el);
        }
        this.$center.append(this.center.$el);
        this.$el.append(this.masthead.frame.$el);
        this.$el.append(this.modal.$el);

        // build panels
        this.panels = {};
        if (!this.config.hide_panels) {
            _.each(this._panelids, function (panel_id) {
                var panel_class_name = panel_id.charAt(0).toUpperCase() + panel_id.slice(1);
                var panel_class = options[panel_class_name];
                if (panel_class) {
                    var panel_instance = new panel_class(self, options);
                    var panel_el = self.$("#" + panel_id);
                    self[panel_instance.toString()] = panel_instance;
                    self.panels[panel_id] = new _panel2.default.SidePanel({
                        id: panel_id,
                        el: panel_el,
                        view: panel_instance
                    });
                    if (_this.config.hide_masthead) {
                        panel_el.css("top", 0);
                    }
                }
            });
        }
        this.render();

        // start the router
        if (this.router) {
            Backbone.history.start({
                root: Galaxy.root,
                pushState: true
            });
        }
    },

    render: function render() {
        // TODO: Remove this line after select2 update
        $(".select2-hidden-accessible").remove();
        if (!this.config.hide_masthead) {
            this.masthead.render();
            this.renderMessageBox();
            this.renderInactivityBox();
        }
        this.renderPanels();
        this._checkCommunicationServerOnline();
        return this;
    },

    /** Render message box */
    renderMessageBox: function renderMessageBox() {
        if (this.config.message_box_visible) {
            var content = this.config.message_box_content || "";
            var level = this.config.message_box_class || "info";
            this.$el.addClass("has-message-box");
            this.$messagebox.attr("class", "panel-" + level + "-message").html(content).toggle(!!content).show();
        } else {
            this.$el.removeClass("has-message-box");
            this.$messagebox.hide();
        }
        return this;
    },

    /** Render inactivity warning */
    renderInactivityBox: function renderInactivityBox() {
        if (this.config.show_inactivity_warning) {
            var content = this.config.inactivity_box_content || "";
            var verificationLink = $("<a/>").attr("href", Galaxy.root + "user/resend_verification").text("Resend verification");
            this.$el.addClass("has-inactivity-box");
            this.$inactivebox.html(content + " ").append(verificationLink).toggle(!!content).show();
        } else {
            this.$el.removeClass("has-inactivity-box");
            this.$inactivebox.hide();
        }
        return this;
    },

    /** Render panels */
    renderPanels: function renderPanels() {
        var self = this;
        _.each(this._panelids, function (panel_id) {
            var panel = self.panels[panel_id];
            if (panel) {
                panel.render();
            } else {
                self.$center.css(panel_id, 0);
                self.$("#" + panel_id).hide();
            }
        });
        return this;
    },

    /** body template */
    _template: function _template() {
        return ["<div id=\"everything\">\n                <div id=\"background\"/>\n                <div id=\"masthead\"/>\n                <div id=\"messagebox\"/>\n                <div id=\"inactivebox\" class=\"panel-warning-message\" />\n                <div id=\"columns\">\n                    <div id=\"left\" class=\"unified-panel\"/>\n                    <div id=\"center\" />\n                    <div id=\"right\" class=\"unified-panel\" />\n                </div>\n            </div>\n            <div id=\"dd-helper\" />"].join("");
    },

    toString: function toString() {
        return "PageLayoutView";
    },

    /** Check if the communication server is online and show the icon otherwise hide the icon */
    _checkCommunicationServerOnline: function _checkCommunicationServerOnline() {
        var host = window.Galaxy.config.communication_server_host;
        var port = window.Galaxy.config.communication_server_port;
        var preferences = window.Galaxy.user.attributes.preferences;
        var $chat_icon_element = $("#show-chat-online");
        /** Check if the user has deactivated the communication in it's personal settings */
        if (preferences && ["1", "true"].indexOf(preferences.communication_server) != -1) {
            // See if the configured communication server is available
            $.ajax({
                url: host + ":" + port
            }).success(function (data) {
                // enable communication only when a user is logged in
                if (window.Galaxy.user.id !== null) {
                    if ($chat_icon_element.css("visibility") === "hidden") {
                        $chat_icon_element.css("visibility", "visible");
                    }
                }
            }).error(function (data) {
                // hide the communication icon if the communication server is not available
                $chat_icon_element.css("visibility", "hidden");
            });
        } else {
            $chat_icon_element.css("visibility", "hidden");
        }
    }
});

exports.default = { View: View };
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(1), __webpack_require__(0)))

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _DataDialog = __webpack_require__(181);

var _DataDialog2 = _interopRequireDefault(_DataDialog);

var _vue = __webpack_require__(18);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Data = function () {
    function Data() {
        _classCallCheck(this, Data);
    }

    _createClass(Data, [{
        key: "dialog",

        /**
         * Opens a modal dialog for data selection
         * @param {function} callback - Result function called with selection
         */
        value: function dialog(callback) {
            var instance = _vue2.default.extend(_DataDialog2.default);
            var vm = document.createElement("div");
            $("body").append(vm);
            new instance({
                propsData: {
                    callback: callback
                }
            }).$mount(vm);
        }
    }]);

    return Data;
}();

exports.default = Data;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DataDialog_vue_vue_type_template_id_acc46ac2__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DataDialog_vue_vue_type_script_lang_js__ = __webpack_require__(62);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__DataDialog_vue_vue_type_script_lang_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__DataDialog_vue_vue_type_script_lang_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DataDialog_vue_vue_type_style_index_0_lang_css__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(17);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__DataDialog_vue_vue_type_script_lang_js__["default"],
  __WEBPACK_IMPORTED_MODULE_0__DataDialog_vue_vue_type_template_id_acc46ac2__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__DataDialog_vue_vue_type_template_id_acc46ac2__["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_DataDialog_vue_vue_type_template_id_acc46ac2__ = __webpack_require__(183);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_DataDialog_vue_vue_type_template_id_acc46ac2__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_DataDialog_vue_vue_type_template_id_acc46ac2__["b"]; });


/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{staticClass:"data-dialog-modal",attrs:{"ok-only":true,"ok-title":"Close"},model:{value:(_vm.modalShow),callback:function ($$v) {_vm.modalShow=$$v},expression:"modalShow"}},[_c('template',{slot:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v(_vm._s(_vm.modalTitle))]),_vm._v(" "),(_vm.optionsShow)?_c('b-input-group',[_c('b-input',{attrs:{"placeholder":"Type to Search"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_vm._v(" "),_c('b-input-group-append',[_c('b-btn',{attrs:{"disabled":!_vm.filter},on:{"click":function($event){_vm.filter = ''}}},[_vm._v("Clear")])],1)],1):_vm._e()],1),_vm._v(" "),(_vm.errorMessage)?_c('b-alert',{attrs:{"variant":"danger","show":_vm.errorShow}},[_vm._v("\n        "+_vm._s(_vm.errorMessage)+"\n    ")]):_c('div',[(_vm.optionsShow)?_c('div',[_c('b-table',{attrs:{"small":"","hover":"","items":_vm.items,"fields":_vm.fields,"filter":_vm.filter},on:{"row-clicked":_vm.clicked,"filtered":_vm.filtered},scopedSlots:_vm._u([{key:"name",fn:function(data){return [(data.item.history_content_type == 'dataset')?_c('i',{staticClass:"fa fa-file-o"}):_c('i',{staticClass:"fa fa-copy"}),_vm._v("\n                    "+_vm._s(data.item.hid)+": "+_vm._s(data.value)+"\n                ")]}},{key:"extension",fn:function(data){return [_vm._v("\n                    "+_vm._s(data.value ? data.value : "-")+"\n                ")]}},{key:"update_time",fn:function(data){return [_vm._v("\n                    "+_vm._s(data.value ? data.value.substring(0, 16).replace("T", " ") : "-")+"\n                ")]}}])}),_vm._v(" "),(_vm.nItems == 0)?_c('div',[_vm._v("\n                No search results found for: "+_vm._s(this.filter)+".\n            ")]):_vm._e()],1):_c('div',[_c('span',{staticClass:"fa fa-spinner fa-spin"}),_vm._v(" "),_c('span',[_vm._v("Please wait...")])])])],2)}
var staticRenderFns = []



/***/ }),
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_DataDialog_vue_vue_type_style_index_0_lang_css__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_DataDialog_vue_vue_type_style_index_0_lang_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_DataDialog_vue_vue_type_style_index_0_lang_css__);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_DataDialog_vue_vue_type_style_index_0_lang_css___default.a); 

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(26)(false);
// imports


// module
exports.push([module.i, ".data-dialog-modal .modal-body{max-height:50vh;overflow-y:auto}", ""]);

// exports


/***/ }),
/* 189 */,
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Backbone) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var Model = Backbone.Model.extend({
    defaults: {
        extension: "auto",
        genome: "?",
        url_paste: "",
        status: "init",
        info: null,
        file_name: "",
        file_mode: "",
        file_size: 0,
        file_type: null,
        file_path: "",
        file_data: null,
        percentage: 0,
        space_to_tab: false,
        to_posix_lines: true,
        enabled: true
    },
    reset: function reset(attr) {
        this.clear().set(this.defaults).set(attr);
    }
});
var Collection = Backbone.Collection.extend({ model: Model });
exports.default = { Model: Model, Collection: Collection };
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery, $) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _underscore = __webpack_require__(1);

var _ = _interopRequireWildcard(_underscore);

var _historyView = __webpack_require__(166);

var _historyView2 = _interopRequireDefault(_historyView);

var _hdaModel = __webpack_require__(152);

var _hdaModel2 = _interopRequireDefault(_hdaModel);

var _hdaLiEdit = __webpack_require__(196);

var _hdaLiEdit2 = _interopRequireDefault(_hdaLiEdit);

var _hdcaLiEdit = __webpack_require__(237);

var _hdcaLiEdit2 = _interopRequireDefault(_hdcaLiEdit);

var _tag = __webpack_require__(71);

var _tag2 = _interopRequireDefault(_tag);

var _annotation = __webpack_require__(198);

var _annotation2 = _interopRequireDefault(_annotation);

var _listCollectionCreator = __webpack_require__(90);

var _listCollectionCreator2 = _interopRequireDefault(_listCollectionCreator);

var _pairCollectionCreator = __webpack_require__(207);

var _pairCollectionCreator2 = _interopRequireDefault(_pairCollectionCreator);

var _listOfPairsCollectionCreator = __webpack_require__(208);

var _listOfPairsCollectionCreator2 = _interopRequireDefault(_listOfPairsCollectionCreator);

var _faIconButton = __webpack_require__(53);

var _faIconButton2 = _interopRequireDefault(_faIconButton);

var _baseMvc = __webpack_require__(6);

var _baseMvc2 = _interopRequireDefault(_baseMvc);

var _localization = __webpack_require__(3);

var _localization2 = _interopRequireDefault(_localization);

__webpack_require__(22);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/* global Galaxy */
/* global jQuery */
/* global $ */

/* =============================================================================
TODO:

============================================================================= */
var _super = _historyView2.default.HistoryView;
// base class for history-view-edit-current and used as-is in history/view.mako
/** @class Editable View/Controller for the history model.
 *
 *  Allows:
 *      (everything HistoryView allows)
 *      changing the name
 *      displaying and editing tags and annotations
 *      multi-selection and operations on mulitple content items
 */
var HistoryViewEdit = _super.extend(
/** @lends HistoryViewEdit.prototype */{
    /** class to use for constructing the HistoryDatasetAssociation views */
    HDAViewClass: _hdaLiEdit2.default.HDAListItemEdit,
    /** class to use for constructing the HistoryDatasetCollectionAssociation views */
    HDCAViewClass: _hdcaLiEdit2.default.HDCAListItemEdit,

    // ......................................................................... SET UP
    /** Set up the view, set up storage, bind listeners to HistoryContents events
     *  @param {Object} attributes
     */
    initialize: function initialize(attributes) {
        attributes = attributes || {};
        _super.prototype.initialize.call(this, attributes);

        // ---- set up instance vars
        /** editor for tags - sub-view */
        this.tagsEditor = null;

        /** enable drag and drop - sub-view */
        this.dragItems = true;

        /** editor for annotations - sub-view */
        this.annotationEditor = null;

        /** allow user purge of dataset files? */
        this.purgeAllowed = attributes.purgeAllowed || false;

        // states/modes the panel can be in
        /** is the panel currently showing the dataset selection controls? */
        this.annotationEditorShown = attributes.annotationEditorShown || false;
        this.tagsEditorShown = attributes.tagsEditorShown || false;
    },

    /** Override to handle history as drag-drop target */
    _setUpListeners: function _setUpListeners() {
        _super.prototype._setUpListeners.call(this);
        return this.on({
            "droptarget:drop": function droptargetDrop(ev, data) {
                // process whatever was dropped and re-hide the drop target
                this.dataDropped(data);
                this.dropTargetOff();
            },
            "view:attached view:removed": function viewAttachedViewRemoved() {
                this._renderCounts();
            },
            "search:loading-progress": this._renderSearchProgress,
            "search:searching": this._renderSearchFindings
        });
    },

    // ------------------------------------------------------------------------ listeners
    /** listening for history and HDA events */
    _setUpModelListeners: function _setUpModelListeners() {
        _super.prototype._setUpModelListeners.call(this);
        this.listenTo(this.model, "change:size", this.updateHistoryDiskSize);
        return this;
    },

    /** listening for collection events */
    _setUpCollectionListeners: function _setUpCollectionListeners() {
        _super.prototype._setUpCollectionListeners.call(this);
        this.listenTo(this.collection, {
            "change:deleted": this._handleItemDeletedChange,
            "change:visible": this._handleItemVisibleChange,
            "change:purged": function changePurged(model) {
                // hafta get the new nice-size w/o the purged model
                this.model.fetch();
            },
            // loading indicators for deleted/hidden
            "fetching-deleted": function fetchingDeleted(collection) {
                this.$("> .controls .deleted-count").html("<i>" + (0, _localization2.default)("loading...") + "</i>");
            },
            "fetching-hidden": function fetchingHidden(collection) {
                this.$("> .controls .hidden-count").html("<i>" + (0, _localization2.default)("loading...") + "</i>");
            },
            "fetching-deleted-done fetching-hidden-done": this._renderCounts
        });
        return this;
    },

    // ------------------------------------------------------------------------ panel rendering
    /** In this override, add tag and annotation editors and a btn to toggle the selectors */
    _buildNewRender: function _buildNewRender() {
        // create a new render using a skeleton template, render title buttons, render body, and set up events, etc.
        var $newRender = _super.prototype._buildNewRender.call(this);
        if (!this.model) {
            return $newRender;
        }

        if (Galaxy && Galaxy.user && Galaxy.user.id && Galaxy.user.id === this.model.get("user_id")) {
            this._renderTags($newRender);
            this._renderAnnotation($newRender);
        }
        return $newRender;
    },

    /** Update the history size display (curr. upper right of panel). */
    updateHistoryDiskSize: function updateHistoryDiskSize() {
        this.$(".history-size").text(this.model.get("nice_size"));
    },

    /** override to render counts when the items are rendered */
    renderItems: function renderItems($whereTo) {
        var views = _super.prototype.renderItems.call(this, $whereTo);
        if (!this.searchFor) {
            this._renderCounts($whereTo);
        } else {
            this._renderSearchFindings($whereTo);
        }
        return views;
    },

    /** override to show counts, what's deleted/hidden, and links to toggle those */
    _renderCounts: function _renderCounts($whereTo) {
        $whereTo = $whereTo instanceof jQuery ? $whereTo : this.$el;
        var html = this.templates.counts(this.model.toJSON(), this);
        return $whereTo.find("> .controls .subtitle").html(html);
    },

    /** render the tags sub-view controller */
    _renderTags: function _renderTags($where) {
        var panel = this;
        this.tagsEditor = new _tag2.default.TagsEditor({
            model: this.model,
            el: $where.find(".controls .tags-display"),
            onshowFirstTime: function onshowFirstTime() {
                this.render();
            },
            // show hide sub-view tag editors when this is shown/hidden
            onshow: function onshow() {
                panel.toggleHDATagEditors(true, panel.fxSpeed);
            },
            onhide: function onhide() {
                panel.toggleHDATagEditors(false, panel.fxSpeed);
            },
            $activator: (0, _faIconButton2.default)({
                title: (0, _localization2.default)("Edit history tags"),
                classes: "history-tag-btn",
                faIcon: "fa-tags",
                tooltipConfig: { placement: "top" }
            }).appendTo($where.find(".controls .actions"))
        });
    },
    /** render the annotation sub-view controller */
    _renderAnnotation: function _renderAnnotation($where) {
        var panel = this;
        this.annotationEditor = new _annotation2.default.AnnotationEditor({
            model: this.model,
            el: $where.find(".controls .annotation-display"),
            onshowFirstTime: function onshowFirstTime() {
                this.render();
            },
            // show hide sub-view view annotation editors when this is shown/hidden
            onshow: function onshow() {
                panel.toggleHDAAnnotationEditors(true, panel.fxSpeed);
            },
            onhide: function onhide() {
                panel.toggleHDAAnnotationEditors(false, panel.fxSpeed);
            },
            $activator: (0, _faIconButton2.default)({
                title: (0, _localization2.default)("Edit history annotation"),
                classes: "history-annotate-btn",
                faIcon: "fa-comment",
                tooltipConfig: { placement: "top" }
            }).appendTo($where.find(".controls .actions"))
        });
    },

    /** Set up HistoryViewEdit js/widget behaviours
     *  In this override, make the name editable
     */
    _setUpBehaviors: function _setUpBehaviors($where) {
        $where = $where || this.$el;
        _super.prototype._setUpBehaviors.call(this, $where);
        if (!this.model) {
            return;
        }

        // anon users shouldn't have access to any of the following
        if (!Galaxy.user || Galaxy.user.isAnonymous() || Galaxy.user.id !== this.model.get("user_id")) {
            return;
        }

        var panel = this;
        var nameSelector = "> .controls .name";
        $where.find(nameSelector).attr("title", (0, _localization2.default)("Click to rename history")).tooltip({ placement: "bottom" }).make_text_editable({
            on_finish: function on_finish(newName) {
                var previousName = panel.model.get("name");
                if (newName && newName !== previousName) {
                    panel.$el.find(nameSelector).text(newName);
                    panel.model.save({ name: newName }).fail(function () {
                        panel.$el.find(nameSelector).text(panel.model.previous("name"));
                    });
                } else {
                    panel.$el.find(nameSelector).text(previousName);
                }
            }
        });
    },

    /** return a new popup menu for choosing a multi selection action
     *  ajax calls made for multiple datasets are queued
     */
    multiselectActions: function multiselectActions() {
        var panel = this;

        var actions = [{
            html: (0, _localization2.default)("Hide datasets"),
            func: function func() {
                var action = _hdaModel2.default.HistoryDatasetAssociation.prototype.hide;
                panel.getSelectedModels().ajaxQueue(action);
            }
        }, {
            html: (0, _localization2.default)("Unhide datasets"),
            func: function func() {
                var action = _hdaModel2.default.HistoryDatasetAssociation.prototype.unhide;
                panel.getSelectedModels().ajaxQueue(action);
            }
        }, {
            html: (0, _localization2.default)("Delete datasets"),
            func: function func() {
                var action = _hdaModel2.default.HistoryDatasetAssociation.prototype["delete"];
                panel.getSelectedModels().ajaxQueue(action);
            }
        }, {
            html: (0, _localization2.default)("Undelete datasets"),
            func: function func() {
                var action = _hdaModel2.default.HistoryDatasetAssociation.prototype.undelete;
                panel.getSelectedModels().ajaxQueue(action);
            }
        }];

        if (panel.purgeAllowed) {
            actions.push({
                html: (0, _localization2.default)("Permanently delete datasets"),
                func: function func() {
                    if (window.confirm((0, _localization2.default)("This will permanently remove the data in your datasets. Are you sure?"))) {
                        var action = _hdaModel2.default.HistoryDatasetAssociation.prototype.purge;
                        var historyContents = panel.getSelectedModels();
                        var selectedDatasets = historyContents.filter(function (c) {
                            return c.get("history_content_type") == "dataset";
                        });
                        historyContents.ajaxQueue(action, {}, selectedDatasets);
                    }
                }
            });
        }
        actions = actions.concat(panel._collectionActions());
        return actions;
    },

    /**   */
    _collectionActions: function _collectionActions() {
        var panel = this;
        return [{
            html: (0, _localization2.default)("Build Dataset List"),
            func: function func() {
                return panel.buildCollection("list");
            }
        },
        // TODO: Only show quick pair if two things selected.
        {
            html: (0, _localization2.default)("Build Dataset Pair"),
            func: function func() {
                return panel.buildCollection("paired");
            }
        }, {
            html: (0, _localization2.default)("Build List of Dataset Pairs"),
            func: function func() {
                return panel.buildCollection("list:paired");
            }
        }, {
            html: (0, _localization2.default)("Build Collection from Rules"),
            func: function func() {
                return panel.buildCollection("rules");
            }
        }];
    },

    buildCollection: function buildCollection(collectionType, selection, hideSourceItems) {
        var panel = this;
        selection = selection || panel.getSelectedModels();
        hideSourceItems = hideSourceItems || false;
        var createFunc;
        if (collectionType == "list") {
            createFunc = _listCollectionCreator2.default.createListCollection;
        } else if (collectionType == "paired") {
            createFunc = _pairCollectionCreator2.default.createPairCollection;
        } else if (collectionType == "list:paired") {
            createFunc = _listOfPairsCollectionCreator2.default.createListOfPairsCollection;
        } else if (collectionType.startsWith("rules")) {
            createFunc = _listCollectionCreator2.default.createCollectionViaRules;
        } else {
            console.warn("Unknown collectionType encountered " + collectionType);
        }
        createFunc(selection, hideSourceItems).done(function () {
            panel.model.refresh();
        });
    },

    // ------------------------------------------------------------------------ sub-views
    /** In this override, add purgeAllowed and whether tags/annotation editors should be shown */
    _getItemViewOptions: function _getItemViewOptions(model) {
        var options = _super.prototype._getItemViewOptions.call(this, model);
        _.extend(options, {
            purgeAllowed: this.purgeAllowed,
            tagsEditorShown: this.tagsEditor && !this.tagsEditor.hidden,
            annotationEditorShown: this.annotationEditor && !this.annotationEditor.hidden
        });
        return options;
    },

    /** If this item is deleted and we're not showing deleted items, remove the view
     *  @param {Model} the item model to check
     */
    _handleItemDeletedChange: function _handleItemDeletedChange(itemModel) {
        if (itemModel.get("deleted")) {
            this._handleItemDeletion(itemModel);
        } else {
            this._handleItemUndeletion(itemModel);
        }
        this._renderCounts();
    },

    _handleItemDeletion: function _handleItemDeletion(itemModel) {
        var contentsShown = this.model.get("contents_active");
        contentsShown.deleted += 1;
        contentsShown.active -= 1;
        if (!this.model.contents.includeDeleted) {
            this.removeItemView(itemModel);
        }
        this.model.set("contents_active", contentsShown);
    },

    _handleItemUndeletion: function _handleItemUndeletion(itemModel) {
        var contentsShown = this.model.get("contents_active");
        contentsShown.deleted -= 1;
        if (!this.model.contents.includeDeleted) {
            contentsShown.active -= 1;
        }
        this.model.set("contents_active", contentsShown);
    },

    /** If this item is hidden and we're not showing hidden items, remove the view
     *  @param {Model} the item model to check
     */
    _handleItemVisibleChange: function _handleItemVisibleChange(itemModel) {
        if (itemModel.hidden()) {
            this._handleItemHidden(itemModel);
        } else {
            this._handleItemUnhidden(itemModel);
        }
        this._renderCounts();
    },

    _handleItemHidden: function _handleItemHidden(itemModel) {
        var contentsShown = this.model.get("contents_active");
        contentsShown.hidden += 1;
        contentsShown.active -= 1;
        if (!this.model.contents.includeHidden) {
            this.removeItemView(itemModel);
        }
        this.model.set("contents_active", contentsShown);
    },

    _handleItemUnhidden: function _handleItemUnhidden(itemModel) {
        var contentsShown = this.model.get("contents_active");
        contentsShown.hidden -= 1;
        if (!this.model.contents.includeHidden) {
            contentsShown.active -= 1;
        }
        this.model.set("contents_active", contentsShown);
    },

    /** toggle the visibility of each content's tagsEditor applying all the args sent to this function */
    toggleHDATagEditors: function toggleHDATagEditors(showOrHide, speed) {
        _.each(this.views, function (view) {
            if (view.tagsEditor) {
                view.tagsEditor.toggle(showOrHide, speed);
            }
        });
    },

    /** toggle the visibility of each content's annotationEditor applying all the args sent to this function */
    toggleHDAAnnotationEditors: function toggleHDAAnnotationEditors(showOrHide, speed) {
        _.each(this.views, function (view) {
            if (view.annotationEditor) {
                view.annotationEditor.toggle(showOrHide, speed);
            }
        });
    },

    // ------------------------------------------------------------------------ panel events
    /** event map */
    events: _.extend(_.clone(_super.prototype.events), {
        "click .show-selectors-btn": "toggleSelectors",
        "click .toggle-deleted-link": function clickToggleDeletedLink(ev) {
            this.toggleShowDeleted();
        },
        "click .toggle-hidden-link": function clickToggleHiddenLink(ev) {
            this.toggleShowHidden();
        }
    }),

    // ------------------------------------------------------------------------ search
    _renderSearchProgress: function _renderSearchProgress(limit, offset) {
        var stop = limit + offset;
        return this.$("> .controls .subtitle").html(["<i>", (0, _localization2.default)("Searching "), stop, "/", this.model.contentsShown(), "</i>"].join(""));
    },

    /** override to display number found in subtitle */
    _renderSearchFindings: function _renderSearchFindings($whereTo) {
        $whereTo = $whereTo instanceof jQuery ? $whereTo : this.$el;
        var html = this.templates.found(this.model.toJSON(), this);
        $whereTo.find("> .controls .subtitle").html(html);
        return this;
    },

    // ------------------------------------------------------------------------ as drop target
    /** turn all the drag and drop handlers on and add some help text above the drop area */
    dropTargetOn: function dropTargetOn() {
        if (this.dropTarget) {
            return this;
        }
        this.dropTarget = true;

        //TODO: to init
        var dropHandlers = {
            dragenter: _.bind(this.dragenter, this),
            dragover: _.bind(this.dragover, this),
            dragleave: _.bind(this.dragleave, this),
            drop: _.bind(this.drop, this)
        };

        var $dropTarget = this._renderDropTarget();
        this.$list().before([this._renderDropTargetHelp(), $dropTarget]);
        for (var evName in dropHandlers) {
            if (dropHandlers.hasOwnProperty(evName)) {
                //console.debug( evName, dropHandlers[ evName ] );
                $dropTarget.on(evName, dropHandlers[evName]);
            }
        }
        return this;
    },

    /** render a box to serve as a 'drop here' area on the history */
    _renderDropTarget: function _renderDropTarget() {
        this.$(".history-drop-target").remove();
        return $("<div/>").addClass("history-drop-target");
    },

    /** tell the user how it works  */
    _renderDropTargetHelp: function _renderDropTargetHelp() {
        this.$(".history-drop-target-help").remove();
        return $("<div/>").addClass("history-drop-target-help").text((0, _localization2.default)("Drag datasets here to copy them to the current history"));
    },

    /** shut down drag and drop event handlers and remove drop target */
    dropTargetOff: function dropTargetOff() {
        if (!this.dropTarget) {
            return this;
        }
        //this.log( 'dropTargetOff' );
        this.dropTarget = false;
        var dropTarget = this.$(".history-drop-target").get(0);
        for (var evName in this._dropHandlers) {
            if (this._dropHandlers.hasOwnProperty(evName)) {
                dropTarget.off(evName, this._dropHandlers[evName]);
            }
        }
        this.$(".history-drop-target").remove();
        this.$(".history-drop-target-help").remove();
        return this;
    },
    /** toggle the target on/off */
    dropTargetToggle: function dropTargetToggle() {
        if (this.dropTarget) {
            this.dropTargetOff();
        } else {
            this.dropTargetOn();
        }
        return this;
    },

    dragenter: function dragenter(ev) {
        //console.debug( 'dragenter:', this, ev );
        ev.preventDefault();
        ev.stopPropagation();
        this.$(".history-drop-target").css("border", "2px solid black");
    },
    dragover: function dragover(ev) {
        ev.preventDefault();
        ev.stopPropagation();
    },
    dragleave: function dragleave(ev) {
        //console.debug( 'dragleave:', this, ev );
        ev.preventDefault();
        ev.stopPropagation();
        this.$(".history-drop-target").css("border", "1px dashed black");
    },
    /** when (text) is dropped try to parse as json and trigger an event */
    drop: function drop(ev) {
        ev.preventDefault();
        //ev.stopPropagation();

        var dataTransfer = ev.originalEvent.dataTransfer;
        var data = dataTransfer.getData("text");

        dataTransfer.dropEffect = "move";
        try {
            data = JSON.parse(data);
        } catch (err) {
            this.warn("error parsing JSON from drop:", data);
        }

        this.trigger("droptarget:drop", ev, data, this);
        return false;
    },

    /** handler that copies data into the contents */
    dataDropped: function dataDropped(data) {
        var _this = this;

        // HDA: dropping will copy it to the history
        if (_.isObject(data) && data.model_class === "HistoryDatasetAssociation" && data.id) {
            if (this.contents.currentPage !== 0) {
                return this.contents.fetchPage(0).then(function () {
                    return _this.model.contents.copy(data.id);
                });
            }
            return this.model.contents.copy(data.id);
        }
        return jQuery.when();
    },

    // ........................................................................ misc
    /** Return a string rep of the history */
    toString: function toString() {
        return "HistoryViewEdit(" + (this.model ? this.model.get("name") : "") + ")";
    }
});

//------------------------------------------------------------------------------ TEMPLATES
HistoryViewEdit.prototype.templates = function () {
    var countsTemplate = _baseMvc2.default.wrapTemplate(["<% var shown = Math.max( view.views.length, history.contents_active.active ) %>", "<% if( shown ){ %>", '<span class="shown-count">', "<%- shown %> ", (0, _localization2.default)("shown"), "</span>", "<% } %>", "<% if( history.contents_active.deleted ){ %>", '<span class="deleted-count">', "<% if( view.model.contents.includeDeleted ){ %>", '<a class="toggle-deleted-link" href="javascript:void(0);">', (0, _localization2.default)("hide deleted"), "</a>", "<% } else { %>", "<%- history.contents_active.deleted %> ", '<a class="toggle-deleted-link" href="javascript:void(0);">', (0, _localization2.default)("deleted"), "</a>", "<% } %>", "</span>", "<% } %>", "<% if( history.contents_active.hidden ){ %>", '<span class="hidden-count">', "<% if( view.model.contents.includeHidden ){ %>", '<a class="toggle-hidden-link" href="javascript:void(0);">', (0, _localization2.default)("hide hidden"), "</a>", "<% } else { %>", "<%- history.contents_active.hidden %> ", '<a class="toggle-hidden-link" href="javascript:void(0);">', (0, _localization2.default)("hidden"), "</a>", "<% } %>", "</span>", "<% } %>"], "history");

    var foundTemplate = _baseMvc2.default.wrapTemplate([(0, _localization2.default)("Found"), " <%- view.views.length %>, ", "<% if( history.contents_active.deleted ){ %>", "<% if( view.model.contents.includeDeleted ){ %>", '<a class="toggle-deleted-link" href="javascript:void(0);">', (0, _localization2.default)("hide deleted"), "</a>, ", "<% } else { %>", '<a class="toggle-deleted-link" href="javascript:void(0);">', (0, _localization2.default)("show deleted"), "</a>, ", "<% } %>", "<% } %>", "<% if( history.contents_active.hidden ){ %>", "<% if( view.model.contents.includeHidden ){ %>", '<a class="toggle-hidden-link" href="javascript:void(0);">', (0, _localization2.default)("hide hidden"), "</a>", "<% } else { %>", '<a class="toggle-hidden-link" href="javascript:void(0);">', (0, _localization2.default)("show hidden"), "</a>", "<% } %>", "<% } %>"], "history");

    return _.extend(_.clone(_super.prototype.templates), {
        counts: countsTemplate,
        found: foundTemplate
    });
}();

//==============================================================================
exports.default = {
    HistoryViewEdit: HistoryViewEdit
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(0)))

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Backbone, _, $) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _listItem = __webpack_require__(151);

var _listItem2 = _interopRequireDefault(_listItem);

var _loadingIndicator = __webpack_require__(38);

var _loadingIndicator2 = _interopRequireDefault(_loadingIndicator);

var _baseMvc = __webpack_require__(6);

var _baseMvc2 = _interopRequireDefault(_baseMvc);

var _localization = __webpack_require__(3);

var _localization2 = _interopRequireDefault(_localization);

__webpack_require__(167);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var logNamespace = "list";
/* ============================================================================
TODO:

============================================================================ */
/** @class View for a list/collection of models and the sub-views of those models.
 *      Sub-views must (at least have the interface if not) inherit from ListItemView.
 *      (For a list panel that also includes some 'container' model (History->HistoryContents)
 *      use ModelWithListPanel)
 *
 *  Allows for:
 *      searching collection/sub-views
 *      selecting/multi-selecting sub-views
 *
 *  Currently used:
 *      for dataset/dataset-choice
 *      as superclass of ModelListPanel
 */
var ListPanel = Backbone.View.extend(_baseMvc2.default.LoggableMixin).extend(
/** @lends ListPanel.prototype */{
    _logNamespace: logNamespace,

    /** class to use for constructing the sub-views */
    viewClass: _listItem2.default.ListItemView,
    /** class to used for constructing collection of sub-view models */
    collectionClass: Backbone.Collection,

    tagName: "div",
    className: "list-panel",

    /** (in ms) that jquery effects will use */
    fxSpeed: "fast",

    /** string to display when the collection has no contents */
    emptyMsg: (0, _localization2.default)("This list is empty"),
    /** displayed when no items match the search terms */
    noneFoundMsg: (0, _localization2.default)("No matching items found"),
    /** string used for search placeholder */
    searchPlaceholder: (0, _localization2.default)("search"),

    // ......................................................................... SET UP
    /** Set up the view, set up storage, bind listeners to HistoryContents events
     *  @param {Object} attributes optional settings for the list
     */
    initialize: function initialize(attributes, options) {
        attributes = attributes || {};
        // set the logger if requested
        if (attributes.logger) {
            this.logger = attributes.logger;
        }
        this.log(this + ".initialize:", attributes);

        // ---- instance vars
        /** how quickly should jquery fx run? */
        this.fxSpeed = _.has(attributes, "fxSpeed") ? attributes.fxSpeed : this.fxSpeed;

        /** filters for displaying subviews */
        this.filters = [];
        /** current search terms */
        this.searchFor = attributes.searchFor || "";

        /** loading indicator */
        // this.indicator = new LoadingIndicator( this.$el );

        /** currently showing selectors on items? */
        this.selecting = attributes.selecting !== undefined ? attributes.selecting : true;
        //this.selecting = false;

        /** cached selected item.model.ids to persist btwn renders */
        this.selected = attributes.selected || [];
        /** the last selected item.model.id */
        this.lastSelected = null;

        /** are sub-views draggable */
        this.dragItems = attributes.dragItems || false;

        /** list item view class (when passed models) */
        this.viewClass = attributes.viewClass || this.viewClass;

        /** list item views */
        this.views = [];
        /** list item models */
        this.collection = attributes.collection || this._createDefaultCollection();

        /** filter fns run over collection items to see if they should show in the list */
        this.filters = attributes.filters || [];

        /** override $scrollContainer fn via attributes - fn should return jq for elem to call scrollTo on */
        this.$scrollContainer = attributes.$scrollContainer || this.$scrollContainer;

        /** @type {String} generic title */
        this.title = attributes.title || "";
        /** @type {String} generic subtitle */
        this.subtitle = attributes.subtitle || "";

        this._setUpListeners();
    },

    // ------------------------------------------------------------------------ listeners
    /** create any event listeners for the list */
    _setUpListeners: function _setUpListeners() {
        this.off();

        //TODO: move errorHandler down into list-view from history-view or
        //  pass to global error handler (Galaxy)
        this.on({
            error: function error(model, xhr, options, msg, details) {
                //this.errorHandler( model, xhr, options, msg, details );
                console.error(model, xhr, options, msg, details);
            },
            // show hide the loading indicator
            loading: function loading() {
                this._showLoadingIndicator("loading...", 40);
            },
            "loading-done": function loadingDone() {
                this._hideLoadingIndicator(40);
            }
        });

        // throw the first render up as a diff namespace using once (for outside consumption)
        this.once("rendered", function () {
            this.trigger("rendered:initial", this);
        });

        this._setUpCollectionListeners();
        this._setUpViewListeners();
        return this;
    },

    /** create and return a collection for when none is initially passed */
    _createDefaultCollection: function _createDefaultCollection() {
        // override
        return new this.collectionClass([]);
    },

    /** listening for collection events */
    _setUpCollectionListeners: function _setUpCollectionListeners() {
        this.log(this + "._setUpCollectionListeners", this.collection);
        this.stopListening(this.collection);

        // bubble up error events
        this.listenTo(this.collection, {
            error: function error(model, xhr, options, msg, details) {
                this.trigger("error", model, xhr, options, msg, details);
            },
            update: function update(collection, options) {
                var changes = options.changes;
                // console.info( collection + ', update:', changes, '\noptions:', options );
                // more than one: render everything
                if (options.renderAll || changes.added.length + changes.removed.length > 1) {
                    return this.renderItems();
                }
                // otherwise, let the single add/remove handlers do it
                if (changes.added.length === 1) {
                    return this.addItemView(_.first(changes.added), collection, options);
                }
                if (changes.removed.length === 1) {
                    return this.removeItemView(_.first(changes.removed), collection, options);
                }
            }
        });
        return this;
    },

    /** listening for sub-view events that bubble up with the 'view:' prefix */
    _setUpViewListeners: function _setUpViewListeners() {
        this.log(this + "._setUpViewListeners");

        // shift to select a range
        this.on({
            "view:selected": function viewSelected(view, ev) {
                if (ev && ev.shiftKey && this.lastSelected) {
                    var lastSelectedView = this.viewFromModelId(this.lastSelected);
                    if (lastSelectedView) {
                        this.selectRange(view, lastSelectedView);
                    }
                } else if (ev && ev.altKey && !this.selecting) {
                    this.showSelectors();
                }
                this.selected.push(view.model.id);
                this.lastSelected = view.model.id;
            },

            "view:de-selected": function viewDeSelected(view, ev) {
                this.selected = _.without(this.selected, view.model.id);
            }
        });
    },

    // ------------------------------------------------------------------------ rendering
    /** Render this content, set up ui.
     *  @param {Number or String} speed   the speed of the render
     */
    render: function render(speed) {
        this.log(this + ".render", speed);
        var $newRender = this._buildNewRender();
        this._setUpBehaviors($newRender);
        this._queueNewRender($newRender, speed);
        return this;
    },

    /** Build a temp div containing the new children for the view's $el. */
    _buildNewRender: function _buildNewRender() {
        this.debug(this + "(ListPanel)._buildNewRender");
        var $newRender = $(this.templates.el({}, this));
        this._renderControls($newRender);
        this._renderTitle($newRender);
        this._renderSubtitle($newRender);
        this._renderSearch($newRender);
        this.renderItems($newRender);
        return $newRender;
    },

    /** Build a temp div containing the new children for the view's $el. */
    _renderControls: function _renderControls($newRender) {
        this.debug(this + "(ListPanel)._renderControls");
        var $controls = $(this.templates.controls({}, this));
        $newRender.find(".controls").replaceWith($controls);
        return $controls;
    },

    /** return a jQuery object containing the title DOM */
    _renderTitle: function _renderTitle($where) {
        //$where = $where || this.$el;
        //$where.find( '.title' ).replaceWith( ... )
    },

    /** return a jQuery object containing the subtitle DOM (if any) */
    _renderSubtitle: function _renderSubtitle($where) {
        //$where = $where || this.$el;
        //$where.find( '.title' ).replaceWith( ... )
    },

    /** Fade out the old el, swap in the new contents, then fade in.
     *  @param {Number or String} speed   jq speed to use for rendering effects
     *  @fires rendered when rendered
     */
    _queueNewRender: function _queueNewRender($newRender, speed) {
        speed = speed === undefined ? this.fxSpeed : speed;
        var panel = this;
        panel.log("_queueNewRender:", $newRender, speed);

        $(panel).queue("fx", [function (next) {
            panel.$el.fadeOut(speed, next);
        }, function (next) {
            panel._swapNewRender($newRender);
            next();
        }, function (next) {
            panel.$el.fadeIn(speed, next);
        }, function (next) {
            panel.trigger("rendered", panel);
            next();
        }]);
    },

    /** empty out the current el, move the $newRender's children in */
    _swapNewRender: function _swapNewRender($newRender) {
        this.$el.empty().attr("class", this.className).append($newRender.children());
        if (this.selecting) {
            this.showSelectors(0);
        }
        return this;
    },

    /** Set up any behaviors, handlers (ep. plugins) that need to be called when the entire view has been built but
     *  not attached to the page yet.
     */
    _setUpBehaviors: function _setUpBehaviors($where) {
        $where = $where || this.$el;
        this.$controls($where).find("[title]").tooltip();
        // set up the pupup for actions available when multi selecting
        this._renderMultiselectActionMenu($where);
        return this;
    },

    /** render a menu containing the actions available to sets of selected items */
    _renderMultiselectActionMenu: function _renderMultiselectActionMenu($where) {
        $where = $where || this.$el;
        var $menu = $where.find(".list-action-menu");
        var actions = this.multiselectActions();
        if (!actions.length) {
            return $menu.empty();
        }

        var $newMenu = $(['<div class="list-action-menu btn-group">', '<button class="list-action-menu-btn btn btn-secondary dropdown-toggle" data-toggle="dropdown">', (0, _localization2.default)("For all selected"), "...", "</button>", '<ul class="dropdown-menu float-right" role="menu">', "</ul>", "</div>"].join(""));
        var $actions = actions.map(function (action) {
            var html = ['<li><a href="javascript:void(0);">', action.html, "</a></li>"].join("");
            return $(html).click(function (ev) {
                ev.preventDefault();
                return action.func(ev);
            });
        });
        $newMenu.find("ul").append($actions);
        $menu.replaceWith($newMenu);
        return $newMenu;
    },

    /** return a list of plain objects used to render multiselect actions menu. Each object should have:
     *      html: an html string used as the anchor contents
     *      func: a function called when the anchor is clicked (passed the click event)
     */
    multiselectActions: function multiselectActions() {
        return [];
    },

    // ------------------------------------------------------------------------ sub-$element shortcuts
    /** the scroll container for this panel - can be $el, $el.parent(), or grandparent depending on context */
    $scrollContainer: function $scrollContainer($where) {
        // override or set via attributes.$scrollContainer
        return ($where || this.$el).parent().parent();
    },
    /** convenience selector for the section that displays the list controls */
    $controls: function $controls($where) {
        return ($where || this.$el).find("> .controls");
    },
    /** list-items: where the subviews are contained in the view's dom */
    $list: function $list($where) {
        return ($where || this.$el).find("> .list-items");
    },
    /** container where list messages are attached */
    $messages: function $messages($where) {
        //TODO: controls isn't really correct here (only for ModelListPanel)
        return ($where || this.$el).find("> .controls .messages");
    },
    /** the message displayed when no views can be shown (no views, none matching search) */
    $emptyMessage: function $emptyMessage($where) {
        return ($where || this.$el).find("> .empty-message");
    },

    // ------------------------------------------------------------------------ hda sub-views
    /** render the subviews for the list's collection */
    renderItems: function renderItems($whereTo) {
        $whereTo = $whereTo || this.$el;
        var panel = this;
        panel.log(this + ".renderItems", $whereTo);

        var $list = panel.$list($whereTo);
        panel.freeViews();
        // console.log( 'views freed' );
        //TODO:? cache and re-use views?
        var shownModels = panel._filterCollection();
        // console.log( 'models filtered:', shownModels );

        panel.views = shownModels.map(function (itemModel) {
            var view = panel._createItemView(itemModel);
            return view;
        });

        $list.empty();
        // console.log( 'list emptied' );
        if (panel.views.length) {
            panel._attachItems($whereTo);
            // console.log( 'items attached' );
        }
        panel._renderEmptyMessage($whereTo).toggle(!panel.views.length);
        panel.trigger("views:ready", panel.views);

        // console.log( '------------------------------------------- rendering items' );
        return panel.views;
    },

    /** Filter the collection to only those models that should be currently viewed */
    _filterCollection: function _filterCollection() {
        // override this
        var panel = this;
        return panel.collection.filter(_.bind(panel._filterItem, panel));
    },

    /** Should the model be viewable in the current state?
     *     Checks against this.filters and this.searchFor
     */
    _filterItem: function _filterItem(model) {
        // override this
        var panel = this;
        return _.every(panel.filters.map(function (fn) {
            return fn.call(model);
        })) && (!panel.searchFor || model.matchesAll(panel.searchFor));
    },

    /** Create a view for a model and set up it's listeners */
    _createItemView: function _createItemView(model) {
        var ViewClass = this._getItemViewClass(model);
        var options = _.extend(this._getItemViewOptions(model), {
            model: model
        });
        var view = new ViewClass(options);
        this._setUpItemViewListeners(view);
        return view;
    },

    /** Free a view for a model. Note: does not remove it from the DOM */
    _destroyItemView: function _destroyItemView(view) {
        this.stopListening(view);
        this.views = _.without(this.views, view);
    },

    _destroyItemViews: function _destroyItemViews(view) {
        var self = this;
        self.views.forEach(function (v) {
            self.stopListening(v);
        });
        self.views = [];
        return self;
    },

    /** free any sub-views the list has */
    freeViews: function freeViews() {
        return this._destroyItemViews();
    },

    /** Get the bbone view class based on the model */
    _getItemViewClass: function _getItemViewClass(model) {
        // override this
        return this.viewClass;
    },

    /** Get the options passed to the new view based on the model */
    _getItemViewOptions: function _getItemViewOptions(model) {
        // override this
        return {
            //logger      : this.logger,
            fxSpeed: this.fxSpeed,
            expanded: false,
            selectable: this.selecting,
            selected: _.contains(this.selected, model.id),
            draggable: this.dragItems
        };
    },

    /** Set up listeners for new models */
    _setUpItemViewListeners: function _setUpItemViewListeners(view) {
        var panel = this;
        // send all events to the panel, re-namspaceing them with the view prefix
        this.listenTo(view, "all", function () {
            var args = Array.prototype.slice.call(arguments, 0);
            args[0] = "view:" + args[0];
            panel.trigger.apply(panel, args);
        });

        // drag multiple - hijack ev.setData to add all selected items
        this.listenTo(view, "draggable:dragstart", function (ev, v) {
            //TODO: set multiple drag data here
            var json = {};

            var selected = this.getSelectedModels();
            if (selected.length) {
                json = selected.toJSON();
            } else {
                json = [v.model.toJSON()];
            }
            ev.dataTransfer.setData("text", JSON.stringify(json));
            //ev.dataTransfer.setDragImage( v.el, 60, 60 );
        }, this);

        return panel;
    },

    /** Attach views in this.views to the model based on $whereTo */
    _attachItems: function _attachItems($whereTo) {
        var self = this;
        // console.log( '_attachItems:', $whereTo, this.$list( $whereTo ) );
        //ASSUMES: $list has been emptied
        this.$list($whereTo).append(this.views.map(function (view) {
            return self._renderItemView$el(view);
        }));
        return this;
    },

    /** get a given subview's $el (or whatever may wrap it) and return it */
    _renderItemView$el: function _renderItemView$el(view) {
        // useful to wrap and override
        return view.render(0).$el;
    },

    /** render the empty/none-found message */
    _renderEmptyMessage: function _renderEmptyMessage($whereTo) {
        this.debug("_renderEmptyMessage", $whereTo, this.searchFor);
        var text = this.searchFor ? this.noneFoundMsg : this.emptyMsg;
        return this.$emptyMessage($whereTo).text(text);
    },

    /** expand all item views */
    expandAll: function expandAll() {
        _.each(this.views, function (view) {
            view.expand();
        });
    },

    /** collapse all item views */
    collapseAll: function collapseAll() {
        _.each(this.views, function (view) {
            view.collapse();
        });
    },

    // ------------------------------------------------------------------------ collection/views syncing
    /** Add a view (if the model should be viewable) to the panel */
    addItemView: function addItemView(model, collection, options) {
        // console.log( this + '.addItemView:', model );
        var panel = this;
        // get the index of the model in the list of filtered models shown by this list
        // in order to insert the view in the proper place
        //TODO:? potentially expensive
        var modelIndex = panel._filterCollection().indexOf(model);
        if (modelIndex === -1) {
            return undefined;
        }
        var view = panel._createItemView(model);
        // console.log( 'adding and rendering:', modelIndex, view.toString() );

        $(view).queue("fx", [function (next) {
            // hide the empty message first if only view
            if (panel.$emptyMessage().is(":visible")) {
                panel.$emptyMessage().fadeOut(panel.fxSpeed, next);
            } else {
                next();
            }
        }, function (next) {
            panel._attachView(view, modelIndex);
            next();
        }]);
        return view;
    },

    /** internal fn to add view (to both panel.views and panel.$list) */
    _attachView: function _attachView(view, modelIndex, useFx) {
        // console.log( this + '._attachView:', view, modelIndex, useFx );
        useFx = _.isUndefined(useFx) ? true : useFx;
        modelIndex = modelIndex || 0;
        var panel = this;

        // use the modelIndex to splice into views and insert at the proper index in the DOM
        panel.views.splice(modelIndex, 0, view);
        panel._insertIntoListAt(modelIndex, panel._renderItemView$el(view).hide());

        panel.trigger("view:attached", view);
        if (useFx) {
            view.$el.slideDown(panel.fxSpeed, function () {
                panel.trigger("view:attached:rendered");
            });
        } else {
            view.$el.show();
            panel.trigger("view:attached:rendered");
        }
        return view;
    },

    /** insert a jq object as a child of list-items at the specified *DOM index* */
    _insertIntoListAt: function _insertIntoListAt(index, $what) {
        // console.log( this + '._insertIntoListAt:', index, $what );
        var $list = this.$list();
        if (index === 0) {
            $list.prepend($what);
        } else {
            $list.children().eq(index - 1).after($what);
        }
        return $what;
    },

    /** Remove a view from the panel (if found) */
    removeItemView: function removeItemView(model, collection, options) {
        var panel = this;
        var view = _.find(panel.views, function (v) {
            return v.model === model;
        });
        if (!view) {
            return undefined;
        }
        panel.views = _.without(panel.views, view);
        panel.trigger("view:removed", view);

        // potentially show the empty message if no views left
        // use anonymous queue here - since remove can happen multiple times
        $({}).queue("fx", [function (next) {
            view.$el.fadeOut(panel.fxSpeed, next);
        }, function (next) {
            view.remove();
            panel.trigger("view:removed:rendered");
            if (!panel.views.length) {
                panel._renderEmptyMessage().fadeIn(panel.fxSpeed, next);
            } else {
                next();
            }
        }]);
        return view;
    },

    /** get views based on model.id */
    viewFromModelId: function viewFromModelId(id) {
        return _.find(this.views, function (v) {
            return v.model.id === id;
        });
    },

    /** get views based on model */
    viewFromModel: function viewFromModel(model) {
        return model ? this.viewFromModelId(model.id) : undefined;
    },

    /** get views based on model properties */
    viewsWhereModel: function viewsWhereModel(properties) {
        return this.views.filter(function (view) {
            return _.isMatch(view.model.attributes, properties);
        });
    },

    /** A range of views between (and including) viewA and viewB */
    viewRange: function viewRange(viewA, viewB) {
        if (viewA === viewB) {
            return viewA ? [viewA] : [];
        }

        var indexA = this.views.indexOf(viewA);
        var indexB = this.views.indexOf(viewB);

        // handle not found
        if (indexA === -1 || indexB === -1) {
            if (indexA === indexB) {
                return [];
            }
            return indexA === -1 ? [viewB] : [viewA];
        }
        // reverse if indeces are
        //note: end inclusive
        return indexA < indexB ? this.views.slice(indexA, indexB + 1) : this.views.slice(indexB, indexA + 1);
    },

    // ------------------------------------------------------------------------ searching
    /** render a search input for filtering datasets shown
     *      (see SearchableMixin in base-mvc for implementation of the actual searching)
     *      return will start the search
     *      esc will clear the search
     *      clicking the clear button will clear the search
     *      uses searchInput in ui.js
     */
    _renderSearch: function _renderSearch($where) {
        $where.find(".controls .search-input").searchInput({
            placeholder: this.searchPlaceholder,
            initialVal: this.searchFor,
            onfirstsearch: _.bind(this._firstSearch, this),
            onsearch: _.bind(this.searchItems, this),
            onclear: _.bind(this.clearSearch, this)
        });
        return $where;
    },

    /** What to do on the first search entered */
    _firstSearch: function _firstSearch(searchFor) {
        // override to load model details if necc.
        this.log("onFirstSearch", searchFor);
        return this.searchItems(searchFor);
    },

    /** filter view list to those that contain the searchFor terms */
    searchItems: function searchItems(searchFor, force) {
        this.log("searchItems", searchFor, this.searchFor, force);
        if (!force && this.searchFor === searchFor) {
            return this;
        }
        this.searchFor = searchFor;
        this.renderItems();
        this.trigger("search:searching", searchFor, this);
        var $search = this.$("> .controls .search-query");
        if ($search.val() !== searchFor) {
            $search.val(searchFor);
        }
        return this;
    },

    /** clear the search filters and show all views that are normally shown */
    clearSearch: function clearSearch(searchFor) {
        //this.log( 'onSearchClear', this );
        this.searchFor = "";
        this.trigger("search:clear", this);
        this.$("> .controls .search-query").val("");
        this.renderItems();
        return this;
    },

    // ------------------------------------------------------------------------ selection
    /** @type Integer when the number of list item views is >= to this, don't animate selectors */
    THROTTLE_SELECTOR_FX_AT: 20,

    /** show selectors on all visible itemViews and associated controls */
    showSelectors: function showSelectors(speed) {
        speed = speed !== undefined ? speed : this.fxSpeed;
        this.selecting = true;
        this.$(".list-actions").slideDown(speed);
        speed = this.views.length >= this.THROTTLE_SELECTOR_FX_AT ? 0 : speed;
        _.each(this.views, function (view) {
            view.showSelector(speed);
        });
        //this.selected = [];
        //this.lastSelected = null;
    },

    /** hide selectors on all visible itemViews and associated controls */
    hideSelectors: function hideSelectors(speed) {
        speed = speed !== undefined ? speed : this.fxSpeed;
        this.selecting = false;
        this.$(".list-actions").slideUp(speed);
        speed = this.views.length >= this.THROTTLE_SELECTOR_FX_AT ? 0 : speed;
        _.each(this.views, function (view) {
            view.hideSelector(speed);
        });
        this.selected = [];
        this.lastSelected = null;
    },

    /** show or hide selectors on all visible itemViews and associated controls */
    toggleSelectors: function toggleSelectors() {
        if (!this.selecting) {
            this.showSelectors();
        } else {
            this.hideSelectors();
        }
    },

    /** select all visible items */
    selectAll: function selectAll(event) {
        _.each(this.views, function (view) {
            view.select(event);
        });
    },

    /** deselect all visible items */
    deselectAll: function deselectAll(event) {
        this.lastSelected = null;
        _.each(this.views, function (view) {
            view.deselect(event);
        });
    },

    /** select a range of datasets between A and B */
    selectRange: function selectRange(viewA, viewB) {
        var range = this.viewRange(viewA, viewB);
        _.each(range, function (view) {
            view.select();
        });
        return range;
    },

    /** return an array of all currently selected itemViews */
    getSelectedViews: function getSelectedViews() {
        return _.filter(this.views, function (v) {
            return v.selected;
        });
    },

    /** return a collection of the models of all currenly selected items */
    getSelectedModels: function getSelectedModels() {
        // console.log( '(getSelectedModels)' );
        return new this.collection.constructor(_.map(this.getSelectedViews(), function (view) {
            return view.model;
        }));
    },

    // ------------------------------------------------------------------------ loading indicator
    /** hide the $el and display a loading indicator (in the $el's parent) when loading new data */
    _showLoadingIndicator: function _showLoadingIndicator(msg, speed, callback) {
        this.debug("_showLoadingIndicator", this.indicator, msg, speed, callback);
        speed = speed !== undefined ? speed : this.fxSpeed;
        if (!this.indicator) {
            this.indicator = new _loadingIndicator2.default.LoadingIndicator(this.$el);
            this.debug("\t created", this.indicator);
        }
        if (!this.$el.is(":visible")) {
            this.indicator.show(0, callback);
        } else {
            this.$el.fadeOut(speed);
            this.indicator.show(msg, speed, callback);
        }
    },

    /** hide the loading indicator */
    _hideLoadingIndicator: function _hideLoadingIndicator(speed, callback) {
        this.debug("_hideLoadingIndicator", this.indicator, speed, callback);
        speed = speed !== undefined ? speed : this.fxSpeed;
        if (this.indicator) {
            this.indicator.hide(speed, callback);
        }
    },

    // ------------------------------------------------------------------------ scrolling
    /** get the current scroll position of the panel in its parent */
    scrollPosition: function scrollPosition() {
        return this.$scrollContainer().scrollTop();
    },

    /** set the current scroll position of the panel in its parent */
    scrollTo: function scrollTo(pos, speed) {
        speed = speed || 0;
        this.$scrollContainer().animate({ scrollTop: pos }, speed);
        return this;
    },

    /** Scrolls the panel to the top. */
    scrollToTop: function scrollToTop(speed) {
        return this.scrollTo(0, speed);
    },

    /** scroll to the given view in list-items */
    scrollToItem: function scrollToItem(view, speed) {
        if (!view) {
            return this;
        }
        return this;
    },

    /** Scrolls the panel to show the content with the given id. */
    scrollToId: function scrollToId(id, speed) {
        return this.scrollToItem(this.viewFromModelId(id), speed);
    },

    // ------------------------------------------------------------------------ panel events
    /** event map */
    events: {
        "click .select-all": "selectAll",
        "click .deselect-all": "deselectAll"
    },

    // ------------------------------------------------------------------------ misc
    /** Return a string rep of the panel */
    toString: function toString() {
        return "ListPanel(" + this.collection + ")";
    }
});

// ............................................................................ TEMPLATES
/** underscore templates */
ListPanel.prototype.templates = function () {
    var elTemplate = _baseMvc2.default.wrapTemplate([
    // temp container
    "<div>", '<div class="controls"></div>', '<div class="list-items"></div>', '<div class="empty-message infomessagesmall"></div>', "</div>"]);

    var controlsTemplate = _baseMvc2.default.wrapTemplate(['<div class="controls">', '<div class="title">', '<div class="name"><%- view.title %></div>', "</div>", '<div class="subtitle"><%- view.subtitle %></div>',
    // buttons, controls go here
    '<div class="actions"></div>',
    // deleted msg, etc.
    '<div class="messages"></div>', '<div class="search">', '<div class="search-input"></div>', "</div>",

    // show when selectors are shown
    '<div class="list-actions">', '<div class="btn-group">', '<button class="select-all btn btn-secondary"', 'data-mode="select">', (0, _localization2.default)("All"), "</button>", '<button class="deselect-all btn btn-secondary"', 'data-mode="select">', (0, _localization2.default)("None"), "</button>", "</div>", '<div class="list-action-menu btn-group">', "</div>", "</div>", "</div>"]);

    return {
        el: elTemplate,
        controls: controlsTemplate
    };
}();

//=============================================================================
/** View for a model that has a sub-collection (e.g. History, DatasetCollection)
 *  Allows:
 *      the model to be reset
 *      auto assign panel.collection to panel.model[ panel.modelCollectionKey ]
 *
 */
var ModelListPanel = ListPanel.extend({
    /** key of attribute in model to assign to this.collection */
    modelCollectionKey: "contents",

    initialize: function initialize(attributes) {
        ListPanel.prototype.initialize.call(this, attributes);
        this.selecting = attributes.selecting !== undefined ? attributes.selecting : false;

        this.setModel(this.model, attributes);
    },

    /** release/free/shutdown old models and set up panel for new models
     *  @fires new-model with the panel as parameter
     */
    setModel: function setModel(model, attributes) {
        attributes = attributes || {};
        this.debug(this + ".setModel:", model, attributes);

        this.freeModel();
        this.freeViews();

        if (model) {
            var oldModelId = this.model ? this.model.get("id") : null;

            // set up the new model with user, logger, storage, events
            this.model = model;
            if (this.logger) {
                this.model.logger = this.logger;
            }
            this._setUpModelListeners();

            //TODO: relation btwn model, collection becoming tangled here
            // free the collection, and assign the new collection to either
            //  the model[ modelCollectionKey ], attributes.collection, or an empty vanilla collection
            this.stopListening(this.collection);
            this.collection = this.model[this.modelCollectionKey] || attributes.collection || this._createDefaultCollection();
            this._setUpCollectionListeners();

            if (oldModelId && model.get("id") !== oldModelId) {
                this.trigger("new-model", this);
            }
        }
        return this;
    },

    /** free the current model and all listeners for it, free any views for the model */
    freeModel: function freeModel() {
        // stop/release the previous model, and clear cache to sub-views
        if (this.model) {
            this.stopListening(this.model);
            //TODO: see base-mvc
            //this.model.free();
            //this.model = null;
        }
        return this;
    },

    // ------------------------------------------------------------------------ listening
    /** listening for model events */
    _setUpModelListeners: function _setUpModelListeners() {
        // override
        this.log(this + "._setUpModelListeners", this.model);
        // bounce model errors up to the panel
        this.listenTo(this.model, "error", function () {
            var args = Array.prototype.slice.call(arguments, 0);
            //args.unshift( 'model:error' );
            args.unshift("error");
            this.trigger.apply(this, args);
        }, this);

        // debugging
        if (this.logger) {
            this.listenTo(this.model, "all", function (event) {
                this.info(this + "(model)", event, arguments);
            });
        }
        return this;
    },

    /** Build a temp div containing the new children for the view's $el.
     */
    _renderControls: function _renderControls($newRender) {
        this.debug(this + "(ModelListPanel)._renderControls");
        var json = this.model ? this.model.toJSON() : {};
        var $controls = $(this.templates.controls(json, this));
        $newRender.find(".controls").replaceWith($controls);
        return $controls;
    },

    // ------------------------------------------------------------------------ misc
    /** Return a string rep of the panel */
    toString: function toString() {
        return "ModelListPanel(" + this.model + ")";
    }
});

// ............................................................................ TEMPLATES
/** underscore templates */
ModelListPanel.prototype.templates = function () {
    var controlsTemplate = _baseMvc2.default.wrapTemplate(['<div class="controls">', '<div class="title">',
    //TODO: this is really the only difference - consider factoring titlebar out
    '<div class="name"><%- model.name %></div>', "</div>", '<div class="subtitle"><%- view.subtitle %></div>', '<div class="actions"></div>', '<div class="messages"></div>', '<div class="search">', '<div class="search-input"></div>', "</div>", '<div class="list-actions">', '<div class="btn-group">', '<button class="select-all btn btn-secondary"', 'data-mode="select">', (0, _localization2.default)("All"), "</button>", '<button class="deselect-all btn btn-secondary"', 'data-mode="select">', (0, _localization2.default)("None"), "</button>", "</div>", '<div class="list-action-menu btn-group">', "</div>", "</div>", "</div>"]);

    return _.extend(_.clone(ListPanel.prototype.templates), {
        controls: controlsTemplate
    });
}();

//=============================================================================
exports.default = {
    ListPanel: ListPanel,
    ModelListPanel: ModelListPanel
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(1), __webpack_require__(0)))

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _underscore = __webpack_require__(1);

var _ = _interopRequireWildcard(_underscore);

var _backbone = __webpack_require__(2);

var Backbone = _interopRequireWildcard(_backbone);

var _baseMvc = __webpack_require__(6);

var _baseMvc2 = _interopRequireDefault(_baseMvc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/* global Galaxy */
/* global jQuery */

//=============================================================================
/**
 * A Collection that can be limited/offset/re-ordered/filtered.
 * @type {Backbone.Collection}
 */
var ControlledFetchCollection = Backbone.Collection.extend({
    /** call setOrder on initialization to build the comparator based on options */
    initialize: function initialize(models, options) {
        Backbone.Collection.prototype.initialize.call(this, models, options);
        this.setOrder(options.order || this.order, { silent: true });
    },

    /** set up to track order changes and re-sort when changed */
    _setUpListeners: function _setUpListeners() {
        return this.on({
            "changed-order": this.sort
        });
    },

    /** override to provide order and offsets based on instance vars, set limit if passed,
     *  and set allFetched/fire 'all-fetched' when xhr returns
     */
    fetch: function fetch(options) {
        options = this._buildFetchOptions(options);
        Galaxy.debug("fetch options:", options);
        return Backbone.Collection.prototype.fetch.call(this, options);
    },

    /** build ajax data/parameters from options */
    _buildFetchOptions: function _buildFetchOptions(options) {
        // note: we normally want options passed in to override the defaults built here
        // so most of these fns will generate defaults
        options = _.clone(options) || {};

        // jquery ajax option; allows multiple q/qv for filters (instead of 'q[]')
        options.traditional = true;

        // options.data
        // we keep limit, offset, etc. in options *as well as move it into data* because:
        // - it makes fetch calling convenient to add it to a single options map (instead of as mult. args)
        // - it allows the std. event handlers (for fetch, etc.) to have access
        //   to the pagination options too
        //      (i.e. this.on( 'sync', function( options ){ if( options.limit ){ ... } }))
        // however, when we send to xhr/jquery we copy them to data also so that they become API query params
        options.data = options.data || this._buildFetchData(options);
        Galaxy.debug("data:", options.data);

        // options.data.filters --> options.data.q, options.data.qv
        var filters = this._buildFetchFilters(options);
        Galaxy.debug("filters:", filters);
        if (!_.isEmpty(filters)) {
            _.extend(options.data, this._fetchFiltersToAjaxData(filters));
        }
        Galaxy.debug("data:", options.data);
        return options;
    },

    /** Build the dictionary to send to fetch's XHR as data */
    _buildFetchData: function _buildFetchData(options) {
        var defaults = {};
        if (this.order) {
            defaults.order = this.order;
        }
        return _.defaults(_.pick(options, this._fetchParams), defaults);
    },

    /** These attribute keys are valid params to fetch/API-index */
    _fetchParams: [
    /** model dependent string to control the order of models returned */
    "order",
    /** limit the number of models returned from a fetch */
    "limit",
    /** skip this number of models when fetching */
    "offset",
    /** what series of attributes to return (model dependent) */
    "view",
    /** individual keys to return for the models (see api/histories.index) */
    "keys"],

    /** add any needed filters here based on collection state */
    _buildFetchFilters: function _buildFetchFilters(options) {
        // override
        return _.clone(options.filters || {});
    },

    /** Convert dictionary filters to qqv style arrays */
    _fetchFiltersToAjaxData: function _fetchFiltersToAjaxData(filters) {
        // return as a map so ajax.data can extend from it
        var filterMap = {
            q: [],
            qv: []
        };
        _.each(filters, function (v, k) {
            // don't send if filter value is empty
            if (v === undefined || v === "") {
                return;
            }
            // json to python
            if (v === true) {
                v = "True";
            }
            if (v === false) {
                v = "False";
            }
            if (v === null) {
                v = "None";
            }
            // map to k/v arrays (q/qv)
            filterMap.q.push(k);
            filterMap.qv.push(v);
        });
        return filterMap;
    },

    /** override to reset allFetched flag to false */
    reset: function reset(models, options) {
        this.allFetched = false;
        return Backbone.Collection.prototype.reset.call(this, models, options);
    },

    // ........................................................................ order
    order: null,

    /** @type {Object} map of collection available sorting orders containing comparator fns */
    comparators: {
        update_time: _baseMvc2.default.buildComparator("update_time", {
            ascending: false
        }),
        "update_time-asc": _baseMvc2.default.buildComparator("update_time", {
            ascending: true
        }),
        create_time: _baseMvc2.default.buildComparator("create_time", {
            ascending: false
        }),
        "create_time-asc": _baseMvc2.default.buildComparator("create_time", {
            ascending: true
        })
    },

    /** set the order and comparator for this collection then sort with the new order
     *  @event 'changed-order' passed the new order and the collection
     */
    setOrder: function setOrder(order, options) {
        options = options || {};
        var collection = this;
        var comparator = collection.comparators[order];
        if (_.isUndefined(comparator)) {
            throw new Error("unknown order: " + order);
        }
        // if( _.isUndefined( comparator ) ){ return; }
        if (comparator === collection.comparator) {
            return;
        }

        collection.order = order;
        collection.comparator = comparator;

        if (!options.silent) {
            collection.trigger("changed-order", options);
        }
        return collection;
    }
});

//=============================================================================
/**
 *
 */
var PaginatedCollection = ControlledFetchCollection.extend({
    /** @type {Number} limit used for each page's fetch */
    limitPerPage: 500,

    initialize: function initialize(models, options) {
        ControlledFetchCollection.prototype.initialize.call(this, models, options);
        this.currentPage = options.currentPage || 0;
    },

    getTotalItemCount: function getTotalItemCount() {
        return this.length;
    },

    shouldPaginate: function shouldPaginate() {
        return this.getTotalItemCount() >= this.limitPerPage;
    },

    getLastPage: function getLastPage() {
        return Math.floor(this.getTotalItemCount() / this.limitPerPage);
    },

    getPageCount: function getPageCount() {
        return this.getLastPage() + 1;
    },

    getPageLimitOffset: function getPageLimitOffset(pageNum) {
        pageNum = this.constrainPageNum(pageNum);
        return {
            limit: this.limitPerPage,
            offset: pageNum * this.limitPerPage
        };
    },

    constrainPageNum: function constrainPageNum(pageNum) {
        return Math.max(0, Math.min(pageNum, this.getLastPage()));
    },

    /** fetch the next page of data */
    fetchPage: function fetchPage(pageNum, options) {
        var self = this;
        pageNum = self.constrainPageNum(pageNum);
        self.currentPage = pageNum;
        options = _.defaults(options || {}, self.getPageLimitOffset(pageNum));

        self.trigger("fetching-more");
        return self.fetch(options).always(function () {
            self.trigger("fetching-more-done");
        });
    },

    fetchCurrentPage: function fetchCurrentPage(options) {
        return this.fetchPage(this.currentPage, options);
    },

    fetchPrevPage: function fetchPrevPage(options) {
        return this.fetchPage(this.currentPage - 1, options);
    },

    fetchNextPage: function fetchNextPage(options) {
        return this.fetchPage(this.currentPage + 1, options);
    }
});

//=============================================================================
/**
 * A Collection that will load more elements without reseting.
 */
var InfinitelyScrollingCollection = ControlledFetchCollection.extend({
    /** @type {Number} limit used for the first fetch (or a reset) */
    limitOnFirstFetch: null,
    /** @type {Number} limit used for each subsequent fetch */
    limitPerFetch: 100,

    initialize: function initialize(models, options) {
        ControlledFetchCollection.prototype.initialize.call(this, models, options);
        /** @type {Integer} number of contents to return from the first fetch */
        this.limitOnFirstFetch = options.limitOnFirstFetch || this.limitOnFirstFetch;
        /** @type {Integer} limit for every fetch after the first */
        this.limitPerFetch = options.limitPerFetch || this.limitPerFetch;
        /** @type {Boolean} are all contents fetched? */
        this.allFetched = false;
        /** @type {Integer} what was the offset of the last content returned */
        this.lastFetched = options.lastFetched || 0;
    },

    /** build ajax data/parameters from options */
    _buildFetchOptions: function _buildFetchOptions(options) {
        // options (options for backbone.fetch and jquery.ajax generally)
        // backbone option; false here to make fetching an addititive process
        options.remove = options.remove || false;
        return ControlledFetchCollection.prototype._buildFetchOptions.call(this, options);
    },

    /** fetch the first 'page' of data */
    fetchFirst: function fetchFirst(options) {
        Galaxy.debug("ControlledFetchCollection.fetchFirst:", options);
        options = options ? _.clone(options) : {};
        this.allFetched = false;
        this.lastFetched = 0;
        return this.fetchMore(_.defaults(options, {
            reset: true,
            limit: this.limitOnFirstFetch
        }));
    },

    /** fetch the next page of data */
    fetchMore: function fetchMore(options) {
        Galaxy.debug("ControlledFetchCollection.fetchMore:", options);
        options = _.clone(options || {});
        var collection = this;

        Galaxy.debug("fetchMore, options.reset:", options.reset);
        if (!options.reset && collection.allFetched) {
            return jQuery.when();
        }

        // TODO: this fails in the edge case where
        //  the first fetch offset === limit (limit 4, offset 4, collection.length 4)
        if (options.reset) {
            options.offset = 0;
        } else if (options.offset === undefined) {
            options.offset = collection.lastFetched;
        }
        var limit = options.limit = options.limit || collection.limitPerFetch || null;
        Galaxy.debug("fetchMore, limit:", limit, "offset:", options.offset);

        collection.trigger("fetching-more");
        return collection.fetch(options).always(function () {
            collection.trigger("fetching-more-done");
        })
        // maintain allFetched flag and trigger if all were fetched this time
        .done(function _postFetchMore(fetchedData) {
            var numFetched = _.isArray(fetchedData) ? fetchedData.length : 0;
            collection.lastFetched += numFetched;
            Galaxy.debug("fetchMore, lastFetched:", collection.lastFetched);
            // anything less than a full page means we got all there is to get
            if (!limit || numFetched < limit) {
                collection.allFetched = true;
                collection.trigger("all-fetched", this);
            }
        });
    },

    /** fetch all the collection */
    fetchAll: function fetchAll(options) {
        // whitelist options to prevent allowing limit/offset/filters
        // (use vanilla fetch instead)
        options = options || {};
        var self = this;
        options = _.pick(options, "silent");
        options.filters = {};
        return self.fetch(options).done(function () {
            self.allFetched = true;
            self.trigger("all-fetched", self);
        });
    }
});

//==============================================================================
exports.default = {
    ControlledFetchCollection: ControlledFetchCollection,
    PaginatedCollection: PaginatedCollection,
    InfinitelyScrollingCollection: InfinitelyScrollingCollection
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
function _templateNametag(tag) {
    return "<span class=\"badge badge-primary badge-tags\">" + _.escape(tag.slice(5)) + "</span>";
}

function nametagTemplate(historyItem) {
    var uniqueNametags = _.filter(_.uniq(historyItem.tags), function (t) {
        return t.indexOf("name:") === 0;
    });
    var nametagsDisplay = _.sortBy(uniqueNametags).map(_templateNametag);
    return "\n        <div class=\"nametags\" title=\"" + uniqueNametags.length + " nametags\">\n            " + nametagsDisplay.join("") + "\n        </div>";
}

exports.default = {
    nametagTemplate: nametagTemplate
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _listView = __webpack_require__(192);

var _listView2 = _interopRequireDefault(_listView);

var _collectionModel = __webpack_require__(189);

var _collectionModel2 = _interopRequireDefault(_collectionModel);

var _collectionLi = __webpack_require__(154);

var _collectionLi2 = _interopRequireDefault(_collectionLi);

var _baseMvc = __webpack_require__(6);

var _baseMvc2 = _interopRequireDefault(_baseMvc);

var _localization = __webpack_require__(3);

var _localization2 = _interopRequireDefault(_localization);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var logNamespace = "collections";
/* =============================================================================
TODO:

============================================================================= */
/** @class non-editable, read-only View/Controller for a dataset collection.
 */
var _super = _listView2.default.ModelListPanel;
var CollectionView = _super.extend(
/** @lends CollectionView.prototype */{
    //MODEL is either a DatasetCollection (or subclass) or a DatasetCollectionElement (list of pairs)
    _logNamespace: logNamespace,

    className: _super.prototype.className + " dataset-collection-panel",

    /** sub view class used for datasets */
    DatasetDCEViewClass: _collectionLi2.default.DatasetDCEListItemView,

    /** key of attribute in model to assign to this.collection */
    modelCollectionKey: "elements",

    // ......................................................................... SET UP
    /** Set up the view, set up storage, bind listeners to HistoryContents events
     *  @param {Object} attributes optional settings for the panel
     */
    initialize: function initialize(attributes) {
        _super.prototype.initialize.call(this, attributes);
        this.linkTarget = attributes.linkTarget || "_blank";
        this.dragItems = true;
        this.hasUser = attributes.hasUser;
        /** A stack of panels that currently cover or hide this panel */
        this.panelStack = [];
        /** The text of the link to go back to the panel containing this one */
        this.parentName = attributes.parentName;
        /** foldout or drilldown */
        this.foldoutStyle = attributes.foldoutStyle || "foldout";
        this.downloadUrl = Galaxy.root + "api/dataset_collections/" + this.model.attributes.id + "/download";
    },

    getNestedDCDCEViewClass: function getNestedDCDCEViewClass() {
        return _collectionLi2.default.NestedDCDCEListItemView.extend({
            foldoutPanelClass: CollectionView
        });
    },

    _queueNewRender: function _queueNewRender($newRender, speed) {
        speed = speed === undefined ? this.fxSpeed : speed;
        var panel = this;
        this.handleWarning($newRender);
        panel.log("_queueNewRender:", $newRender, speed);

        // TODO: jquery@1.12 doesn't change display when the elem has display: flex
        // this causes display: block for those elems after the use of show/hide animations
        // animations are removed from this view for now until fixed
        panel._swapNewRender($newRender);
        panel.trigger("rendered", panel);
    },

    handleWarning: function handleWarning($newRender) {
        var viewLength = this.views.length;
        var elementCount = this.model.get("element_count");
        if (elementCount && elementCount !== viewLength) {
            var warning = (0, _localization2.default)("displaying only " + viewLength + " of " + elementCount + " items");
            var $warns = $newRender.find(".elements-warning");
            $warns.html("<div class=\"warningmessagesmall\">" + warning + "</div>");
        }
    },

    // ------------------------------------------------------------------------ sub-views
    /** In this override, use model.getVisibleContents */
    _filterCollection: function _filterCollection() {
        //TODO: should *not* be model.getVisibleContents - visibility is not model related
        return this.model.getVisibleContents();
    },

    /** override to return proper view class based on element_type */
    _getItemViewClass: function _getItemViewClass(model) {
        //this.debug( this + '._getItemViewClass:', model );
        //TODO: subclasses use DCEViewClass - but are currently unused - decide
        switch (model.get("element_type")) {
            case "hda":
                return this.DatasetDCEViewClass;
            case "dataset_collection":
                return this.getNestedDCDCEViewClass();
        }
        throw new TypeError("Unknown element type:", model.get("element_type"));
    },

    /** override to add link target and anon */
    _getItemViewOptions: function _getItemViewOptions(model) {
        var options = _super.prototype._getItemViewOptions.call(this, model);
        return _.extend(options, {
            linkTarget: this.linkTarget,
            hasUser: this.hasUser,
            //TODO: could move to only nested: list:paired
            foldoutStyle: this.foldoutStyle
        });
    },

    // ------------------------------------------------------------------------ collection sub-views
    /** In this override, add/remove expanded/collapsed model ids to/from web storage */
    _setUpItemViewListeners: function _setUpItemViewListeners(view) {
        var panel = this;
        _super.prototype._setUpItemViewListeners.call(panel, view);

        // use pub-sub to: handle drilldown expansion and collapse
        panel.listenTo(view, {
            "expanded:drilldown": function expandedDrilldown(v, drilldown) {
                this._expandDrilldownPanel(drilldown);
            },
            "collapsed:drilldown": function collapsedDrilldown(v, drilldown) {
                this._collapseDrilldownPanel(drilldown);
            }
        });
        return this;
    },

    /** Handle drill down by hiding this panels list and controls and showing the sub-panel */
    _expandDrilldownPanel: function _expandDrilldownPanel(drilldown) {
        this.panelStack.push(drilldown);
        // hide this panel's controls and list, set the name for back navigation, and attach to the $el
        this.$("> .controls").add(this.$list()).hide();
        drilldown.parentName = this.model.get("name");
        this.$el.append(drilldown.render().$el);
    },

    /** Handle drilldown close by freeing the panel and re-rendering this panel */
    _collapseDrilldownPanel: function _collapseDrilldownPanel(drilldown) {
        this.panelStack.pop();
        this.render();
    },

    // ------------------------------------------------------------------------ panel events
    /** event map */
    events: {
        "click .navigation .back": "close"
    },

    /** close/remove this collection panel */
    close: function close(event) {
        this.remove();
        this.trigger("close");
    },

    // ........................................................................ misc
    /** string rep */
    toString: function toString() {
        return "CollectionView(" + (this.model ? this.model.get("name") : "") + ")";
    }
});

//------------------------------------------------------------------------------ TEMPLATES
CollectionView.prototype.templates = function () {
    var controlsTemplate = function controlsTemplate(collection, view) {
        var subtitle = collectionDescription(view.model);
        return "\n        <div class=\"controls\">\n            <div class=\"navigation\">\n            <a class=\"back\" href=\"javascript:void(0)\">\n                <span class=\"fa fa-icon fa-angle-left\"></span>\n                " + (0, _localization2.default)("Back to ") + "\n                " + _.escape(view.parentName) + "\n            </a>\n            </div>\n            <div class=\"title\">\n                <div class=\"name\">" + (_.escape(collection.name) || _.escape(collection.element_identifier)) + "</div>\n                <div class=\"subtitle\">\n                    " + subtitle + "\n                </div>\n            </div>\n            <div class=\"elements-warning\">\n            </div>\n            <div class=\"tags-display\"></div>\n            <div class=\"actions\">\n                <a class=\"download-btn icon-btn\" href=\"" + view.downloadUrl + "\"\n                   title=\"\" download=\"\" data-original-title=\"Download Collection\">\n                   <span class=\"fa fa-floppy-o\"></span>\n                </a>\n            </div>\n        </div>";
    };

    return _.extend(_.clone(_super.prototype.templates), {
        controls: controlsTemplate
    });
}();

function collectionTypeDescription(collection) {
    var collectionType = collection.get("collection_type");
    var collectionTypeDescription;
    if (collectionType == "list") {
        collectionTypeDescription = (0, _localization2.default)("list");
    } else if (collectionType == "paired") {
        collectionTypeDescription = (0, _localization2.default)("dataset pair");
    } else if (collectionType == "list:paired") {
        collectionTypeDescription = (0, _localization2.default)("list of pairs");
    } else {
        collectionTypeDescription = (0, _localization2.default)("nested list");
    }
    return collectionTypeDescription;
}

function collectionDescription(collection) {
    var elementCount = collection.get("element_count");

    var itemsDescription = "a " + collectionTypeDescription(collection);
    if (elementCount) {
        var countDescription;
        if (elementCount == 1) {
            countDescription = "with 1 item";
        } else if (elementCount) {
            countDescription = "with " + elementCount + " items";
        }
        itemsDescription = itemsDescription + " " + (0, _localization2.default)(countDescription);
    }
    return itemsDescription;
}

//==============================================================================
exports.default = {
    collectionTypeDescription: collectionTypeDescription,
    collectionDescription: collectionDescription,
    CollectionView: CollectionView
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery, _) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _datasetLiEdit = __webpack_require__(197);

var _datasetLiEdit2 = _interopRequireDefault(_datasetLiEdit);

var _hdaLi = __webpack_require__(170);

var _hdaLi2 = _interopRequireDefault(_hdaLi);

var _baseMvc = __webpack_require__(6);

var _baseMvc2 = _interopRequireDefault(_baseMvc);

var _localization = __webpack_require__(3);

var _localization2 = _interopRequireDefault(_localization);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//==============================================================================
var _super = _datasetLiEdit2.default.DatasetListItemEdit;
/** @class Editing view for HistoryDatasetAssociation.
 */
var HDAListItemEdit = _super.extend(
/** @lends HDAListItemEdit.prototype */{
    className: _super.prototype.className + " history-content",

    /** In this override, only get details if in the ready state, get rerunnable if in other states.
     *  Note: fetch with no 'change' event triggering to prevent automatic rendering.
     */
    _fetchModelDetails: function _fetchModelDetails() {
        var view = this;
        if (view.model.inReadyState() && !view.model.hasDetails()) {
            return view.model.fetch({ silent: true });

            // special case the need for the rerunnable and creating_job attributes
            // needed for rendering re-run button on queued, running datasets
        } else if (!view.model.has("rerunnable")) {
            return view.model.fetch({
                silent: true,
                data: {
                    // only fetch rerunnable and creating_job to keep overhead down
                    keys: ["rerunnable", "creating_job"].join(",")
                }
            });
        }
        return jQuery.when();
    },

    /** event map */
    events: _.extend(_.clone(_super.prototype.events), {
        "click .unhide-link": function clickUnhideLink(ev) {
            this.model.unhide();
            return false;
        }
    }),

    /** string rep */
    toString: function toString() {
        var modelString = this.model ? "" + this.model : "(no model)";
        return "HDAListItemEdit(" + modelString + ")";
    }
});

// ............................................................................ TEMPLATES
/** underscore templates */
HDAListItemEdit.prototype.templates = function () {
    var warnings = _.extend({}, _super.prototype.templates.warnings, {
        hidden: _baseMvc2.default.wrapTemplate(["<% if( !dataset.visible ){ %>",
        // add a link to unhide a dataset
        '<div class="hidden-msg warningmessagesmall">', (0, _localization2.default)("This dataset has been hidden"), '<br /><a class="unhide-link" a href="javascript:void(0);">', (0, _localization2.default)("Unhide it"), "</a>", "</div>", "<% } %>"], "dataset")
    });

    return _.extend({}, _super.prototype.templates, {
        //NOTE: *steal* the HDAListItemView titleBar
        titleBar: _hdaLi2.default.HDAListItemView.prototype.templates.titleBar,
        warnings: warnings
    });
}();

//==============================================================================
exports.default = {
    HDAListItemEdit: HDAListItemEdit
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(1)))

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _states = __webpack_require__(59);

var _states2 = _interopRequireDefault(_states);

var _datasetLi = __webpack_require__(153);

var _datasetLi2 = _interopRequireDefault(_datasetLi);

var _tag = __webpack_require__(71);

var _tag2 = _interopRequireDefault(_tag);

var _annotation = __webpack_require__(198);

var _annotation2 = _interopRequireDefault(_annotation);

var _faIconButton = __webpack_require__(53);

var _faIconButton2 = _interopRequireDefault(_faIconButton);

var _baseMvc = __webpack_require__(6);

var _baseMvc2 = _interopRequireDefault(_baseMvc);

var _localization = __webpack_require__(3);

var _localization2 = _interopRequireDefault(_localization);

var _underscore = __webpack_require__(1);

var _ = _interopRequireWildcard(_underscore);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global Galaxy */
/* global $ */

//==============================================================================
var _super = _datasetLi2.default.DatasetListItemView;
/** @class Editing view for DatasetAssociation.
 */
var DatasetListItemEdit = _super.extend(
/** @lends DatasetListItemEdit.prototype */{
    /** set up: options */
    initialize: function initialize(attributes) {
        _super.prototype.initialize.call(this, attributes);
        this.hasUser = attributes.hasUser;

        /** allow user purge of dataset files? */
        this.purgeAllowed = attributes.purgeAllowed || false;

        //TODO: move to HiddenUntilActivatedViewMixin
        /** should the tags editor be shown or hidden initially? */
        this.tagsEditorShown = attributes.tagsEditorShown || false;
        /** should the tags editor be shown or hidden initially? */
        this.annotationEditorShown = attributes.annotationEditorShown || false;
    },

    // ......................................................................... titlebar actions
    /** In this override, add the other two primary actions: edit and delete */
    _renderPrimaryActions: function _renderPrimaryActions() {
        var actions = _super.prototype._renderPrimaryActions.call(this);
        if (this.model.get("state") === _states2.default.NOT_VIEWABLE) {
            return actions;
        }
        // render the display, edit attr and delete icon-buttons
        return _super.prototype._renderPrimaryActions.call(this).concat([this._renderEditButton(), this._renderDeleteButton()]);
    },

    //TODO: move titleButtons into state renderers, remove state checks in the buttons

    /** Render icon-button to edit the attributes (format, permissions, etc.) this dataset. */
    _renderEditButton: function _renderEditButton() {
        var self = this;
        // don't show edit while uploading, in-accessible
        // DO show if in error (ala previous history panel)
        if (this.model.get("state") === _states2.default.DISCARDED || !this.model.get("accessible")) {
            return null;
        }
        var purged = this.model.get("purged");
        var deleted = this.model.get("deleted");

        var editBtnData = {
            title: (0, _localization2.default)("Edit attributes"),
            href: Galaxy.root + "datasets/edit?dataset_id=" + this.model.attributes.id,
            faIcon: "fa-pencil",
            classes: "edit-btn",
            onclick: function onclick(ev) {
                if (Galaxy.router) {
                    ev.preventDefault();
                    Galaxy.router.push("datasets/edit", {
                        dataset_id: self.model.attributes.id
                    });
                }
            }
        };

        // disable if purged or deleted and explain why in the tooltip
        if (deleted || purged) {
            editBtnData.disabled = true;
            if (purged) {
                editBtnData.title = (0, _localization2.default)("Cannot edit attributes of datasets removed from disk");
            } else if (deleted) {
                editBtnData.title = (0, _localization2.default)("Undelete dataset to edit attributes");
            }

            // disable if still uploading or new
        } else if (_.contains([_states2.default.UPLOAD, _states2.default.NEW], this.model.get("state"))) {
            editBtnData.disabled = true;
            editBtnData.title = (0, _localization2.default)("This dataset is not yet editable");
        }
        return (0, _faIconButton2.default)(editBtnData);
    },

    /** Render icon-button to delete this hda. */
    _renderDeleteButton: function _renderDeleteButton() {
        // don't show delete if...
        if (!this.model.get("accessible")) {
            return null;
        }

        var self = this;
        var deletedAlready = this.model.isDeletedOrPurged();
        return (0, _faIconButton2.default)({
            title: !deletedAlready ? (0, _localization2.default)("Delete") : (0, _localization2.default)("Dataset is already deleted"),
            disabled: deletedAlready,
            faIcon: "fa-times",
            classes: "delete-btn",
            onclick: function onclick() {
                self.$el.find(".icon-btn.delete-btn").tooltip("dispose");
                self.model["delete"]();
            }
        });
    },

    // ......................................................................... details
    /** In this override, add tags and annotations controls, make the ? dbkey a link to editing page */
    _renderDetails: function _renderDetails() {
        //TODO: generalize to be allow different details for each state
        var $details = _super.prototype._renderDetails.call(this);

        var state = this.model.get("state");

        if (!this.model.isDeletedOrPurged() && _.contains([_states2.default.OK, _states2.default.FAILED_METADATA], state)) {
            this._renderTags($details);
            this._renderAnnotation($details);
            this._makeDbkeyEditLink($details);
        }

        this._setUpBehaviors($details);
        return $details;
    },

    /**************************************************************************
     * Render help button to show tool help text without rerunning the tool.
     * Issue #2100
     */
    _renderToolHelpButton: function _renderToolHelpButton() {
        var datasetID = this.model.attributes.dataset_id;
        var jobID = this.model.attributes.creating_job;
        var self = this;

        var parseToolBuild = function parseToolBuild(data) {
            var helpString = "<div id=\"thdiv-" + datasetID + "\" class=\"toolhelp\">";
            if (data.name && data.help) {
                helpString += "<strong>Tool help for " + data.name + "</strong><hr/>";
                helpString += data.help;
            } else {
                helpString += "<strong>Tool help is unavailable for this dataset.</strong><hr/>";
            }
            helpString += "</div>";
            self.$el.find(".details").append($.parseHTML(helpString));
        };
        var parseToolID = function parseToolID(data) {
            $.ajax({
                url: Galaxy.root + "api/tools/" + data.tool_id + "/build"
            }).done(function (data) {
                parseToolBuild(data);
            }).fail(function () {
                parseToolBuild({});
            });
        };
        if (Galaxy.user.id === null) {
            return null;
        }
        return (0, _faIconButton2.default)({
            title: (0, _localization2.default)("Tool Help"),
            classes: "icon-btn",
            href: "#",
            faIcon: "fa-question",
            onclick: function onclick() {
                if (self.$el.find(".toolhelp").length > 0) {
                    self.$el.find(".toolhelp").toggle();
                } else {
                    $.ajax({
                        url: Galaxy.root + "api/jobs/" + jobID
                    }).done(function (data) {
                        parseToolID(data);
                    }).fail(function () {
                        console.log("Failed at recovering job information from the  Galaxy API for job id \"" + jobID + "\".");
                    });
                }
            }
        });
    },
    //*************************************************************************

    /** Add less commonly used actions in the details section based on state */
    _renderSecondaryActions: function _renderSecondaryActions() {
        var actions = _super.prototype._renderSecondaryActions.call(this);
        switch (this.model.get("state")) {
            case _states2.default.UPLOAD:
            case _states2.default.NOT_VIEWABLE:
                return actions;
            case _states2.default.ERROR:
                // error button comes first
                actions.unshift(this._renderErrButton());
                return actions.concat([this._renderRerunButton(), this._renderToolHelpButton()]);
            case _states2.default.OK:
            case _states2.default.FAILED_METADATA:
                return actions.concat([this._renderRerunButton(), this._renderVisualizationsButton(), this._renderToolHelpButton()]);
        }
        return actions.concat([this._renderRerunButton(), this._renderToolHelpButton()]);
    },

    /** Render icon-button to report an error on this dataset to the galaxy admin. */
    _renderErrButton: function _renderErrButton() {
        var self = this;
        return (0, _faIconButton2.default)({
            title: (0, _localization2.default)("View or report this error"),
            href: Galaxy.root + "datasets/error?dataset_id=" + this.model.attributes.id,
            classes: "report-error-btn",
            faIcon: "fa-bug",
            onclick: function onclick(ev) {
                if (Galaxy.router) {
                    ev.preventDefault();
                    Galaxy.router.push("datasets/error", {
                        dataset_id: self.model.attributes.id
                    });
                }
            }
        });
    },

    /** Render icon-button to re-run the job that created this dataset. */
    _renderRerunButton: function _renderRerunButton() {
        var creating_job = this.model.get("creating_job");
        if (this.model.get("rerunnable")) {
            return (0, _faIconButton2.default)({
                title: (0, _localization2.default)("Run this job again"),
                href: this.model.urls.rerun,
                classes: "rerun-btn",
                target: this.linkTarget,
                faIcon: "fa-refresh",
                onclick: function onclick(ev) {
                    if (Galaxy.router) {
                        ev.preventDefault();
                        Galaxy.router.push("/", {
                            job_id: creating_job
                        });
                    }
                }
            });
        }
    },

    /** Render an icon-button or popupmenu of links based on the applicable visualizations */
    _renderVisualizationsButton: function _renderVisualizationsButton() {
        //TODO: someday - lazyload visualizations
        var visualizations = this.model.get("visualizations");
        if (this.model.isDeletedOrPurged() || !this.hasUser || !this.model.hasData() || _.isEmpty(visualizations)) {
            return null;
        }
        if (!_.isObject(visualizations[0])) {
            this.warn("Visualizations have been switched off");
            return null;
        }

        if (visualizations.length >= 1) {
            var dsid = this.model.get("id");
            var url = Galaxy.root + "visualizations?dataset_id=" + dsid;
            return (0, _faIconButton2.default)({
                title: (0, _localization2.default)("Visualize this data"),
                href: url,
                classes: "visualization-link",
                faIcon: "fa-bar-chart-o",
                onclick: function onclick(ev) {
                    if (Galaxy.frame && Galaxy.frame.active) {
                        ev.preventDefault();
                        Galaxy.frame.add({ url: url, title: "Visualization" });
                    } else if (Galaxy.router) {
                        ev.preventDefault();
                        Galaxy.router.push("visualizations", {
                            dataset_id: dsid
                        });
                        Galaxy.trigger("activate-hda", dsid);
                    }
                }
            });
        }
    },

    //TODO: if possible move these to readonly view - but display the owner's tags/annotation (no edit)
    /** Render the tags list/control */
    _renderTags: function _renderTags($where) {
        if (!this.hasUser) {
            return;
        }
        var view = this;
        this.tagsEditor = new _tag2.default.TagsEditor({
            model: this.model,
            el: $where.find(".tags-display"),
            onshowFirstTime: function onshowFirstTime() {
                this.render();
            },
            // persist state on the hda view (and not the editor) since these are currently re-created each time
            onshow: function onshow() {
                view.tagsEditorShown = true;
            },
            onhide: function onhide() {
                view.tagsEditorShown = false;
            },
            $activator: (0, _faIconButton2.default)({
                title: (0, _localization2.default)("Edit dataset tags"),
                classes: "tag-btn",
                faIcon: "fa-tags"
            }).appendTo($where.find(".actions .right"))
        });
        if (this.tagsEditorShown) {
            this.tagsEditor.toggle(true);
        }
    },

    /** Render the annotation display/control */
    _renderAnnotation: function _renderAnnotation($where) {
        if (!this.hasUser) {
            return;
        }
        var view = this;
        this.annotationEditor = new _annotation2.default.AnnotationEditor({
            model: this.model,
            el: $where.find(".annotation-display"),
            onshowFirstTime: function onshowFirstTime() {
                this.render();
            },
            // persist state on the hda view (and not the editor) since these are currently re-created each time
            onshow: function onshow() {
                view.annotationEditorShown = true;
            },
            onhide: function onhide() {
                view.annotationEditorShown = false;
            },
            $activator: (0, _faIconButton2.default)({
                title: (0, _localization2.default)("Edit dataset annotation"),
                classes: "annotate-btn",
                faIcon: "fa-comment"
            }).appendTo($where.find(".actions .right"))
        });
        if (this.annotationEditorShown) {
            this.annotationEditor.toggle(true);
        }
    },

    /** If the format/dbkey/genome_build isn't set, make the display a link to the edit page */
    _makeDbkeyEditLink: function _makeDbkeyEditLink($details) {
        // make the dbkey a link to editing
        if (this.model.get("metadata_dbkey") === "?" && !this.model.isDeletedOrPurged()) {
            var editableDbkey = $('<a class="value">?</a>').attr("href", this.model.urls.edit).attr("target", "_top");
            $details.find(".dbkey .value").replaceWith(editableDbkey);
        }
    },

    // ......................................................................... events
    /** event map */
    events: _.extend(_.clone(_super.prototype.events), {
        "click .undelete-link": "_clickUndeleteLink",
        "click .purge-link": "_clickPurgeLink",

        "click .edit-btn": function clickEditBtn(ev) {
            this.trigger("edit", this, ev);
        },
        "click .delete-btn": function clickDeleteBtn(ev) {
            this.trigger("delete", this, ev);
        },
        "click .rerun-btn": function clickRerunBtn(ev) {
            this.trigger("rerun", this, ev);
        },
        "click .report-err-btn": function clickReportErrBtn(ev) {
            this.trigger("report-err", this, ev);
        },
        "click .visualization-btn": function clickVisualizationBtn(ev) {
            this.trigger("visualize", this, ev);
        },
        "click .dbkey a": function clickDbkeyA(ev) {
            this.trigger("edit", this, ev);
        }
    }),

    /** listener for item undelete (in the messages section) */
    _clickUndeleteLink: function _clickUndeleteLink(ev) {
        this.model.undelete();
        return false;
    },

    /** listener for item purge (in the messages section) */
    _clickPurgeLink: function _clickPurgeLink(ev) {
        if (window.confirm((0, _localization2.default)("This will permanently remove the data in your dataset. Are you sure?"))) {
            this.model.purge();
        }
        return false;
    },

    // ......................................................................... misc
    /** string rep */
    toString: function toString() {
        var modelString = this.model ? "" + this.model : "(no model)";
        return "HDAEditView(" + modelString + ")";
    }
});

// ............................................................................ TEMPLATES
/** underscore templates */
DatasetListItemEdit.prototype.templates = function () {
    var warnings = _.extend({}, _super.prototype.templates.warnings, {
        failed_metadata: _baseMvc2.default.wrapTemplate([
        // in this override, provide a link to the edit page
        '<% if( dataset.state === "failed_metadata" ){ %>', '<div class="failed_metadata-warning warningmessagesmall">', (0, _localization2.default)("An error occurred setting the metadata for this dataset"), '<br /><a href="<%- dataset.urls.edit %>" target="_top">', (0, _localization2.default)("Set it manually or retry auto-detection"), "</a>", "</div>", "<% } %>"], "dataset"),

        deleted: _baseMvc2.default.wrapTemplate([
        // in this override, provide links to undelete or purge the dataset
        "<% if( dataset.deleted && !dataset.purged ){ %>",
        // deleted not purged
        '<div class="deleted-msg warningmessagesmall">', (0, _localization2.default)("This dataset has been deleted"), '<br /><a class="undelete-link" href="javascript:void(0);">', (0, _localization2.default)("Undelete it"), "</a>", "<% if( view.purgeAllowed ){ %>", '<br /><a class="purge-link" href="javascript:void(0);">', (0, _localization2.default)("Permanently remove it from disk"), "</a>", "<% } %>", "</div>", "<% } %>"], "dataset")
    });

    var visualizationsTemplate = _baseMvc2.default.wrapTemplate(["<% if( visualizations.length === 1 ){ %>", '<a class="visualization-link icon-btn" href="<%- visualizations[0].href %>"', ' target="<%- visualizations[0].target %>" title="', (0, _localization2.default)("Visualize in"), ' <%- visualizations[0].html %>">', '<span class="fa fa-bar-chart-o"></span>', "</a>", "<% } else { %>", '<div class="visualizations-dropdown dropdown icon-btn">', '<a data-toggle="dropdown" title="', (0, _localization2.default)("Visualize"), '">', '<span class="fa fa-bar-chart-o"></span>', "</a>", '<ul class="dropdown-menu" role="menu">', "<% _.each( visualizations, function( visualization ){ %>", '<li><a class="visualization-link" href="<%- visualization.href %>"', ' target="<%- visualization.target %>">', "<%- visualization.html %>", "</a></li>", "<% }); %>", "</ul>", "</div>", "<% } %>"], "visualizations");

    return _.extend({}, _super.prototype.templates, {
        warnings: warnings,
        visualizations: visualizationsTemplate
    });
}();

//==============================================================================
exports.default = {
    DatasetListItemEdit: DatasetListItemEdit
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Backbone, _) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _baseMvc = __webpack_require__(6);

var _baseMvc2 = _interopRequireDefault(_baseMvc);

var _localization = __webpack_require__(3);

var _localization2 = _interopRequireDefault(_localization);

__webpack_require__(22);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// =============================================================================
/** A view on any model that has a 'annotation' attribute
 */
var AnnotationEditor = Backbone.View.extend(_baseMvc2.default.LoggableMixin).extend(_baseMvc2.default.HiddenUntilActivatedViewMixin).extend({
    tagName: "div",
    className: "annotation-display",

    /** Set up listeners, parse options */
    initialize: function initialize(options) {
        options = options || {};
        this.tooltipConfig = options.tooltipConfig || {
            placement: "bottom"
        };
        //console.debug( this, options );
        // only listen to the model only for changes to annotations
        this.listenTo(this.model, "change:annotation", function () {
            this.render();
        });
        this.hiddenUntilActivated(options.$activator, options);
    },

    /** Build the DOM elements, call select to on the created input, and set up behaviors */
    render: function render() {
        var view = this;
        this.$el.html(this._template());

        //TODO: handle empties better
        this.$annotation().make_text_editable({
            use_textarea: true,
            on_finish: function on_finish(newAnnotation) {
                view.$annotation().text(newAnnotation);
                view.model.save({ annotation: newAnnotation }, { silent: true }).fail(function () {
                    view.$annotation().text(view.model.previous("annotation"));
                });
            }
        });
        return this;
    },

    /** @returns {String} the html text used to build the view's DOM */
    _template: function _template() {
        var annotation = this.model.get("annotation");
        return [
        //TODO: make prompt optional
        '<label class="prompt">', (0, _localization2.default)("Annotation"), "</label>",
        // set up initial tags by adding as CSV to input vals (necc. to init select2)
        '<div class="annotation">', _.escape(annotation), "</div>"].join("");
    },

    /** @returns {jQuery} the main element for this view */
    $annotation: function $annotation() {
        return this.$el.find(".annotation");
    },

    /** shut down event listeners and remove this view's DOM */
    remove: function remove() {
        this.$annotation.off();
        this.stopListening(this.model);
        Backbone.View.prototype.remove.call(this);
    },

    /** string rep */
    toString: function toString() {
        return ["AnnotationEditor(", "" + this.model, ")"].join("");
    }
});
// =============================================================================
exports.default = {
    AnnotationEditor: AnnotationEditor
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(1)))

/***/ }),
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Backbone, _) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _utils = __webpack_require__(5);

var _utils2 = _interopRequireDefault(_utils);

var _uiPopover = __webpack_require__(69);

var _uiPopover2 = _interopRequireDefault(_uiPopover);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** This renders a popover with extension details **/
exports.default = Backbone.View.extend({
    initialize: function initialize(options) {
        this.model = new Backbone.Model(options);
        this.setElement("<div/>");
        this.render();
    },

    render: function render() {
        var self = this;
        var options = this.model.attributes;
        var description = _.findWhere(options.list, {
            id: options.extension
        });
        this.extension_popup && this.extension_popup.remove();
        this.extension_popup = new _uiPopover2.default.View({
            placement: options.placement || "bottom",
            container: options.$el
        });
        this.extension_popup.title(options.title);
        this.extension_popup.empty();
        this.extension_popup.append(this._templateDescription(description));
        this.extension_popup.show();
    },

    /** Template for extensions description */
    _templateDescription: function _templateDescription(options) {
        if (options.description) {
            var tmpl = options.description;
            if (options.description_url) {
                tmpl += "&nbsp;(<a href=\"" + options.description_url + "\" target=\"_blank\">read more</a>)";
            }
            return tmpl;
        } else {
            return "There is no description available for this file extension.";
        }
    }
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(1)))

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Backbone, _, jQuery) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _listCollectionCreator = __webpack_require__(90);

var _listCollectionCreator2 = _interopRequireDefault(_listCollectionCreator);

var _hdcaModel = __webpack_require__(163);

var _hdcaModel2 = _interopRequireDefault(_hdcaModel);

var _baseMvc = __webpack_require__(6);

var _baseMvc2 = _interopRequireDefault(_baseMvc);

var _localization = __webpack_require__(3);

var _localization2 = _interopRequireDefault(_localization);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var logNamespace = "collections";
/*==============================================================================
TODO:
    the paired creator doesn't really mesh with the list creator as parent
        it may be better to make an abstract super class for both
    composites may inherit from this (or vis-versa)
    PairedDatasetCollectionElementView doesn't make a lot of sense

==============================================================================*/
/**  */
var PairedDatasetCollectionElementView = Backbone.View.extend(_baseMvc2.default.LoggableMixin).extend({
    _logNamespace: logNamespace,

    //TODO: use proper class (DatasetDCE or NestedDCDCE (or the union of both))
    tagName: "li",
    className: "collection-element",

    initialize: function initialize(attributes) {
        this.element = attributes.element || {};
        this.identifier = attributes.identifier;
    },

    render: function render() {
        this.$el.attr("data-element-id", this.element.id).html(this.template({
            identifier: this.identifier,
            element: this.element
        }));
        return this;
    },

    //TODO: lots of unused space in the element - possibly load details and display them horiz.
    template: _.template(['<span class="identifier"><%- identifier %></span>', '<span class="name"><%- element.name %></span>'].join("")),

    /** remove the DOM and any listeners */
    destroy: function destroy() {
        this.off();
        this.$el.remove();
    },

    /** string rep */
    toString: function toString() {
        return "DatasetCollectionElementView()";
    }
});

// ============================================================================
var _super = _listCollectionCreator2.default.ListCollectionCreator;

/** An interface for building collections.
 */
var PairCollectionCreator = _super.extend({
    /** the class used to display individual elements */
    elementViewClass: PairedDatasetCollectionElementView,
    /** the class this creator will create and save */
    collectionClass: _hdcaModel2.default.HistoryDatasetCollection,
    className: "pair-collection-creator collection-creator flex-row-container",

    /** override to no-op */
    _mangleDuplicateNames: function _mangleDuplicateNames() {},

    // TODO: this whole pattern sucks. There needs to be two classes of problem area:
    //      bad inital choices and
    //      when the user has painted his/her self into a corner during creation/use-of-the-creator
    /** render the entire interface */
    render: function render(speed, callback) {
        if (this.workingElements.length === 2) {
            return _super.prototype.render.call(this, speed, callback);
        }
        return this._renderInvalid(speed, callback);
    },

    // ------------------------------------------------------------------------ rendering elements
    /** render forward/reverse */
    _renderList: function _renderList(speed, callback) {
        //this.debug( '-- _renderList' );
        //precondition: there are two valid elements in workingElements
        var creator = this;

        var $tmp = jQuery("<div/>");
        var $list = creator.$list();

        // lose the original views, create the new, append all at once, then call their renders
        _.each(this.elementViews, function (view) {
            view.destroy();
            creator.removeElementView(view);
        });
        $tmp.append(creator._createForwardElementView().$el);
        $tmp.append(creator._createReverseElementView().$el);
        $list.empty().append($tmp.children());
        _.invoke(creator.elementViews, "render");
    },

    /** create the forward element view */
    _createForwardElementView: function _createForwardElementView() {
        return this._createElementView(this.workingElements[0], {
            identifier: "forward"
        });
    },

    /** create the forward element view */
    _createReverseElementView: function _createReverseElementView() {
        return this._createElementView(this.workingElements[1], {
            identifier: "reverse"
        });
    },

    /** create an element view, cache in elementViews, and return */
    _createElementView: function _createElementView(element, options) {
        var elementView = new this.elementViewClass(_.extend(options, {
            element: element
        }));
        this.elementViews.push(elementView);
        return elementView;
    },

    /** swap the forward, reverse elements and re-render */
    swap: function swap() {
        this.workingElements = [this.workingElements[1], this.workingElements[0]];
        this._renderList();
    },

    events: _.extend(_.clone(_super.prototype.events), {
        "click .swap": "swap"
    }),

    // ------------------------------------------------------------------------ templates
    //TODO: move to require text plugin and load these as text
    //TODO: underscore currently unnecc. bc no vars are used
    //TODO: better way of localizing text-nodes in long strings
    /** underscore template fns attached to class */
    templates: _.extend(_.clone(_super.prototype.templates), {
        /** the middle: element list */
        middle: _.template(['<div class="collection-elements-controls">', '<a class="swap" href="javascript:void(0);" title="', (0, _localization2.default)("Swap forward and reverse datasets"), '">', (0, _localization2.default)("Swap"), "</a>", "</div>", '<div class="collection-elements scroll-container flex-row">', "</div>"].join("")),

        /** help content */
        helpContent: _.template(["<p>", (0, _localization2.default)(["Pair collections are permanent collections containing two datasets: one forward and one reverse. ", "Often these are forward and reverse reads. The pair collections can be passed to tools and ", "workflows in order to have analyses done on both datasets. This interface allows ", "you to create a pair, name it, and swap which is forward and which reverse."].join("")), "</p>", "<ul>", "<li>", (0, _localization2.default)(['Click the <i data-target=".swap">"Swap"</i> link to make your forward dataset the reverse ', "and the reverse dataset forward."].join("")), "</li>", "<li>", (0, _localization2.default)(['Click the <i data-target=".cancel-create">"Cancel"</i> button to exit the interface.'].join("")), "</li>", "</ul><br />", "<p>", (0, _localization2.default)(['Once your collection is complete, enter a <i data-target=".collection-name">name</i> and ', 'click <i data-target=".create-collection">"Create list"</i>.'].join("")), "</p>"].join("")),

        /** a simplified page communicating what went wrong and why the user needs to reselect something else */
        invalidInitial: _.template(['<div class="header flex-row no-flex">', '<div class="alert alert-warning" style="display: block">', '<span class="alert-message">', "<% if( _.size( problems ) ){ %>", (0, _localization2.default)("The following selections could not be included due to problems"), "<ul><% _.each( problems, function( problem ){ %>", "<li><b><%- problem.element.name %></b>: <%- problem.text %></li>", "<% }); %></ul>", "<% } else if( _.size( elements ) === 0 ){ %>", (0, _localization2.default)("No datasets were selected"), ".", "<% } else if( _.size( elements ) === 1 ){ %>", (0, _localization2.default)("Only one dataset was selected"), ": <%- elements[0].name %>", "<% } else if( _.size( elements ) > 2 ){ %>", (0, _localization2.default)("Too many datasets were selected"), ': <%- _.pluck( elements, "name" ).join( ", ") %>', "<% } %>", "<br />", (0, _localization2.default)("Two (and only two) elements are needed for the pair"), ". ", (0, _localization2.default)("You may need to "), '<a class="cancel-create" href="javascript:void(0)">', (0, _localization2.default)("cancel"), "</a> ", (0, _localization2.default)("and reselect new elements"), ".", "</span>", "</div>", "</div>", '<div class="footer flex-row no-flex">', '<div class="actions clear vertically-spaced">', '<div class="other-options float-left">', '<button class="cancel-create btn" tabindex="-1">', (0, _localization2.default)("Cancel"), "</button>",
        // _l( 'Create a different kind of collection' ),
        "</div>", "</div>", "</div>"].join(""))
    }),

    // ------------------------------------------------------------------------ misc
    /** string rep */
    toString: function toString() {
        return "PairCollectionCreator";
    }
});

//==============================================================================
/** List collection flavor of collectionCreatorModal. */
var pairCollectionCreatorModal = function _pairCollectionCreatorModal(elements, options) {
    options = options || {};
    options.title = (0, _localization2.default)("Create a collection from a pair of datasets");
    return _listCollectionCreator2.default.collectionCreatorModal(elements, options, PairCollectionCreator);
};

//==============================================================================
/** Use a modal to create a pair collection, then add it to the given history contents.
 *  @returns {Deferred} resolved when the collection is added to the history.
 */
function createPairCollection(contents, defaultHideSourceItems) {
    var elements = contents.toJSON();
    var copyElements = !defaultHideSourceItems;

    var promise = pairCollectionCreatorModal(elements, {
        defaultHideSourceItems: defaultHideSourceItems,
        creationFn: function creationFn(elements, name, hideSourceItems) {
            elements = [{ name: "forward", src: "hda", id: elements[0].id }, { name: "reverse", src: "hda", id: elements[1].id }];
            return contents.createHDCA(elements, "paired", name, hideSourceItems, copyElements);
        }
    });

    return promise;
}

//==============================================================================
exports.default = {
    PairCollectionCreator: PairCollectionCreator,
    pairCollectionCreatorModal: pairCollectionCreatorModal,
    createPairCollection: createPairCollection
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(1), __webpack_require__(0)))

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Backbone, _, jQuery, $) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _levenshtein = __webpack_require__(240);

var _levenshtein2 = _interopRequireDefault(_levenshtein);

var _naturalSort = __webpack_require__(228);

var _naturalSort2 = _interopRequireDefault(_naturalSort);

var _baseCreator = __webpack_require__(227);

var _baseCreator2 = _interopRequireDefault(_baseCreator);

var _baseMvc = __webpack_require__(6);

var _baseMvc2 = _interopRequireDefault(_baseMvc);

var _localization = __webpack_require__(3);

var _localization2 = _interopRequireDefault(_localization);

__webpack_require__(229);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var logNamespace = "collections";
/* ============================================================================
TODO:


PROGRAMMATICALLY:
currPanel.once( 'rendered', function(){
    currPanel.showSelectors();
    currPanel.selectAll();
    _.last( currPanel.actionsPopup.options ).func();
});

============================================================================ */
/** A view for paired datasets in the collections creator.
 */
var PairView = Backbone.View.extend(_baseMvc2.default.LoggableMixin).extend({
    _logNamespace: logNamespace,

    tagName: "li",
    className: "dataset paired",

    initialize: function initialize(attributes) {
        this.pair = attributes.pair || {};
    },

    template: _.template(['<span class="forward-dataset-name flex-column"><%- pair.forward.name %></span>', '<span class="pair-name-column flex-column">', '<span class="pair-name"><%- pair.name %></span>', "</span>", '<span class="reverse-dataset-name flex-column"><%- pair.reverse.name %></span>'].join("")),

    render: function render() {
        this.dragStartHandler = _.bind(this._dragstart, this);
        this.dragEndHandler = _.bind(this._dragend, this);
        var handle = this.$el.attr("draggable", true).data("pair", this.pair).html(this.template({ pair: this.pair })).addClass("flex-column-container").get(0);
        handle.addEventListener("dragstart", this.dragStartHandler, false);
        handle.addEventListener("dragend", this.dragEndHandler, false);
        return this;
    },

    events: {
        dragover: "_sendToParent",
        drop: "_sendToParent"
    },

    /** dragging pairs for re-ordering */
    _dragstart: function _dragstart(ev) {
        ev.currentTarget.style.opacity = "0.4";
        if (ev.originalEvent) {
            ev = ev.originalEvent;
        }

        ev.dataTransfer.effectAllowed = "move";
        ev.dataTransfer.setData("text/plain", JSON.stringify(this.pair));

        this.$el.parent().trigger("pair.dragstart", [this]);
    },

    /** dragging pairs for re-ordering */
    _dragend: function _dragend(ev) {
        ev.currentTarget.style.opacity = "1.0";
        this.$el.parent().trigger("pair.dragend", [this]);
    },

    /** manually bubble up an event to the parent/container */
    _sendToParent: function _sendToParent(ev) {
        this.$el.parent().trigger(ev);
    },

    /** string rep */
    toString: function toString() {
        return "PairView(" + this.pair.name + ")";
    }
});

// ============================================================================
/** returns an autopair function that uses the provided options.match function */
function autoPairFnBuilder(options) {
    options = options || {};
    options.createPair = options.createPair || function _defaultCreatePair(params) {
        params = params || {};
        var a = params.listA.splice(params.indexA, 1)[0];
        var b = params.listB.splice(params.indexB, 1)[0];
        var aInBIndex = params.listB.indexOf(a);
        var bInAIndex = params.listA.indexOf(b);
        if (aInBIndex !== -1) {
            params.listB.splice(aInBIndex, 1);
        }
        if (bInAIndex !== -1) {
            params.listA.splice(bInAIndex, 1);
        }
        return this._pair(a, b, { silent: true });
    };
    // compile these here outside of the loop
    var _regexps = [];
    function getRegExps() {
        if (!_regexps.length) {
            _regexps = [new RegExp(this.filters[0]), new RegExp(this.filters[1])];
        }
        return _regexps;
    }
    // mangle params as needed
    options.preprocessMatch = options.preprocessMatch || function _defaultPreprocessMatch(params) {
        var regexps = getRegExps.call(this);
        return _.extend(params, {
            matchTo: params.matchTo.name.replace(regexps[0], ""),
            possible: params.possible.name.replace(regexps[1], "")
        });
    };

    return function _strategy(params) {
        this.debug("autopair _strategy ---------------------------");
        params = params || {};
        var listA = params.listA;
        var listB = params.listB;
        var indexA = 0;
        var indexB;

        var bestMatch = {
            score: 0.0,
            index: null
        };

        var paired = [];
        //console.debug( 'params:', JSON.stringify( params, null, '  ' ) );
        this.debug("starting list lens:", listA.length, listB.length);
        this.debug("bestMatch (starting):", JSON.stringify(bestMatch, null, "  "));

        while (indexA < listA.length) {
            var matchTo = listA[indexA];
            bestMatch.score = 0.0;

            for (indexB = 0; indexB < listB.length; indexB++) {
                var possible = listB[indexB];
                this.debug(indexA + ":" + matchTo.name);
                this.debug(indexB + ":" + possible.name);

                // no matching with self
                if (listA[indexA] !== listB[indexB]) {
                    bestMatch = options.match.call(this, options.preprocessMatch.call(this, {
                        matchTo: matchTo,
                        possible: possible,
                        index: indexB,
                        bestMatch: bestMatch
                    }));
                    this.debug("bestMatch:", JSON.stringify(bestMatch, null, "  "));
                    if (bestMatch.score === 1.0) {
                        this.debug("breaking early due to perfect match");
                        break;
                    }
                }
            }
            var scoreThreshold = options.scoreThreshold.call(this);
            this.debug("scoreThreshold:", scoreThreshold);
            this.debug("bestMatch.score:", bestMatch.score);

            if (bestMatch.score >= scoreThreshold) {
                //console.debug( 'autoPairFnBuilder.strategy', listA[ indexA ].name, listB[ bestMatch.index ].name );
                paired.push(options.createPair.call(this, {
                    listA: listA,
                    indexA: indexA,
                    listB: listB,
                    indexB: bestMatch.index
                }));
                //console.debug( 'list lens now:', listA.length, listB.length );
            } else {
                indexA += 1;
            }
            if (!listA.length || !listB.length) {
                return paired;
            }
        }
        this.debug("paired:", JSON.stringify(paired, null, "  "));
        this.debug("autopair _strategy ---------------------------");
        return paired;
    };
}

// ============================================================================
/** An interface for building collections of paired datasets.
 */
var PairedCollectionCreator = Backbone.View.extend(_baseMvc2.default.LoggableMixin).extend(_baseCreator2.default.CollectionCreatorMixin).extend({
    _logNamespace: logNamespace,

    className: "list-of-pairs-collection-creator collection-creator flex-row-container",

    /** set up initial options, instance vars, behaviors, and autopair (if set to do so) */
    initialize: function initialize(attributes) {
        this.metric("PairedCollectionCreator.initialize", attributes);
        //this.debug( '-- PairedCollectionCreator:', attributes );

        attributes = _.defaults(attributes, {
            datasets: [],
            filters: this.DEFAULT_FILTERS,
            automaticallyPair: true,
            strategy: "lcs",
            matchPercentage: 0.9,
            twoPassAutopairing: true
        });

        /** unordered, original list */
        this.initialList = attributes.datasets;

        /** is this from a history? if so, what's its id? */
        this.historyId = attributes.historyId;

        /** which filters should be used initially? (String[2] or name in commonFilters) */
        this.filters = this.commonFilters[attributes.filters] || this.commonFilters[this.DEFAULT_FILTERS];
        if (_.isArray(attributes.filters)) {
            this.filters = attributes.filters;
        }

        /** try to auto pair the unpaired datasets on load? */
        this.automaticallyPair = attributes.automaticallyPair;

        /** what method to use for auto pairing (will be passed aggression level) */
        this.strategy = this.strategies[attributes.strategy] || this.strategies[this.DEFAULT_STRATEGY];
        if (_.isFunction(attributes.strategy)) {
            this.strategy = attributes.strategy;
        }

        /** distance/mismatch level allowed for autopairing */
        this.matchPercentage = attributes.matchPercentage;

        /** try to autopair using simple first, then this.strategy on the remainder */
        this.twoPassAutopairing = attributes.twoPassAutopairing;

        /** remove file extensions (\.*) from created pair names? */
        this.removeExtensions = true;
        //this.removeExtensions = false;

        /** fn to call when the cancel button is clicked (scoped to this) - if falsy, no btn is displayed */
        this.oncancel = attributes.oncancel;
        /** fn to call when the collection is created (scoped to this) */
        this.oncreate = attributes.oncreate;

        /** fn to call when the cancel button is clicked (scoped to this) - if falsy, no btn is displayed */
        this.autoscrollDist = attributes.autoscrollDist || 24;

        /** is the unpaired panel shown? */
        this.unpairedPanelHidden = false;
        /** is the paired panel shown? */
        this.pairedPanelHidden = false;

        /** DOM elements currently being dragged */
        this.$dragging = null;

        /** Used for blocking UI events during ajax/operations (don't post twice) */
        this.blocking = false;

        this._setUpCommonSettings(attributes);
        this._setUpBehaviors();
        this._dataSetUp();
    },

    /** map of common filter pairs by name */
    commonFilters: {
        illumina: ["_1", "_2"],
        Rs: ["_R1", "_R2"]
    },
    /** which commonFilter to use by default */
    DEFAULT_FILTERS: "illumina",

    /** map of name->fn for autopairing */
    strategies: {
        simple: "autopairSimple",
        lcs: "autopairLCS",
        levenshtein: "autopairLevenshtein"
    },
    /** default autopair strategy name */
    DEFAULT_STRATEGY: "lcs",

    // ------------------------------------------------------------------------ process raw list
    /** set up main data: cache initialList, sort, and autopair */
    _dataSetUp: function _dataSetUp() {
        //this.debug( '-- _dataSetUp' );

        this.paired = [];
        this.unpaired = [];

        this.selectedIds = [];

        // sort initial list, add ids if needed, and save new working copy to unpaired
        this._sortInitialList();
        this._ensureIds();
        this.unpaired = this.initialList.slice(0);

        if (this.automaticallyPair) {
            this.autoPair();
            this.once("rendered:initial", function () {
                this.trigger("autopair");
            });
        }
    },

    /** sort initial list */
    _sortInitialList: function _sortInitialList() {
        //this.debug( '-- _sortInitialList' );
        this._sortDatasetList(this.initialList);
    },

    /** sort a list of datasets */
    _sortDatasetList: function _sortDatasetList(list) {
        // currently only natural sort by name
        list.sort(function (a, b) {
            return (0, _naturalSort2.default)(a.name, b.name);
        });
        return list;
    },

    /** add ids to dataset objs in initial list if none */
    _ensureIds: function _ensureIds() {
        this.initialList.forEach(function (dataset) {
            if (!dataset.hasOwnProperty("id")) {
                dataset.id = _.uniqueId();
            }
        });
        return this.initialList;
    },

    /** split initial list into two lists, those that pass forward filters & those passing reverse */
    _splitByFilters: function _splitByFilters() {
        var regexFilters = this.filters.map(function (stringFilter) {
            return new RegExp(stringFilter);
        });

        var split = [[], []];

        function _filter(unpaired, filter) {
            return filter.test(unpaired.name);
            //return dataset.name.indexOf( filter ) >= 0;
        }
        this.unpaired.forEach(function _filterEach(unpaired) {
            // 90% of the time this seems to work, but:
            //TODO: this treats *all* strings as regex which may confuse people - possibly check for // surrounding?
            //  would need explanation in help as well
            regexFilters.forEach(function (filter, i) {
                if (_filter(unpaired, filter)) {
                    split[i].push(unpaired);
                }
            });
        });
        return split;
    },

    /** add a dataset to the unpaired list in it's proper order */
    _addToUnpaired: function _addToUnpaired(dataset) {
        var _this = this;

        // currently, unpaired is natural sorted by name, use binary search to find insertion point
        var binSearchSortedIndex = function binSearchSortedIndex(low, hi) {
            if (low === hi) {
                return low;
            }

            var mid = Math.floor((hi - low) / 2) + low;

            var compared = (0, _naturalSort2.default)(dataset.name, _this.unpaired[mid].name);

            if (compared < 0) {
                return binSearchSortedIndex(low, mid);
            } else if (compared > 0) {
                return binSearchSortedIndex(mid + 1, hi);
            }
            // walk the equal to find the last
            while (_this.unpaired[mid] && _this.unpaired[mid].name === dataset.name) {
                mid++;
            }
            return mid;
        };

        this.unpaired.splice(binSearchSortedIndex(0, this.unpaired.length), 0, dataset);
    },

    // ------------------------------------------------------------------------ auto pairing
    /** two passes to automatically create pairs:
     *  use both simpleAutoPair, then the fn mentioned in strategy
     */
    autoPair: function autoPair(strategy) {
        // split first using exact matching
        var split = this._splitByFilters();

        var paired = [];
        if (this.twoPassAutopairing) {
            paired = this.autopairSimple({
                listA: split[0],
                listB: split[1]
            });
            split = this._splitByFilters();
        }

        // uncomment to see printlns while running tests
        //this.debug = function(){ console.log.apply( console, arguments ); };

        // then try the remainder with something less strict
        strategy = strategy || this.strategy;
        split = this._splitByFilters();
        paired = paired.concat(this[strategy].call(this, {
            listA: split[0],
            listB: split[1]
        }));
        return paired;
    },

    /** autopair by exact match */
    autopairSimple: autoPairFnBuilder({
        scoreThreshold: function scoreThreshold() {
            return 0.6;
        },
        match: function _match(params) {
            params = params || {};
            if (params.matchTo === params.possible) {
                return {
                    index: params.index,
                    score: 1.0
                };
            }
            return params.bestMatch;
        }
    }),

    /** autopair by levenshtein edit distance scoring */
    autopairLevenshtein: autoPairFnBuilder({
        scoreThreshold: function scoreThreshold() {
            return this.matchPercentage;
        },
        match: function _matches(params) {
            params = params || {};

            var distance = (0, _levenshtein2.default)(params.matchTo, params.possible);

            var score = 1.0 - distance / Math.max(params.matchTo.length, params.possible.length);

            if (score > params.bestMatch.score) {
                return {
                    index: params.index,
                    score: score
                };
            }
            return params.bestMatch;
        }
    }),

    /** autopair by longest common substrings scoring */
    autopairLCS: autoPairFnBuilder({
        scoreThreshold: function scoreThreshold() {
            return this.matchPercentage;
        },
        match: function _matches(params) {
            params = params || {};

            var match = this._naiveStartingAndEndingLCS(params.matchTo, params.possible).length;

            var score = match / Math.max(params.matchTo.length, params.possible.length);

            if (score > params.bestMatch.score) {
                return {
                    index: params.index,
                    score: score
                };
            }
            return params.bestMatch;
        }
    }),

    /** return the concat'd longest common prefix and suffix from two strings */
    _naiveStartingAndEndingLCS: function _naiveStartingAndEndingLCS(s1, s2) {
        var fwdLCS = "";
        var revLCS = "";
        var i = 0;
        var j = 0;
        while (i < s1.length && i < s2.length) {
            if (s1[i] !== s2[i]) {
                break;
            }
            fwdLCS += s1[i];
            i += 1;
        }
        if (i === s1.length) {
            return s1;
        }
        if (i === s2.length) {
            return s2;
        }

        i = s1.length - 1;
        j = s2.length - 1;
        while (i >= 0 && j >= 0) {
            if (s1[i] !== s2[j]) {
                break;
            }
            revLCS = [s1[i], revLCS].join("");
            i -= 1;
            j -= 1;
        }
        return fwdLCS + revLCS;
    },

    // ------------------------------------------------------------------------ pairing / unpairing
    /** create a pair from fwd and rev, removing them from unpaired, and placing the new pair in paired */
    _pair: function _pair(fwd, rev, options) {
        options = options || {};
        this.debug("_pair:", fwd, rev);
        var pair = this._createPair(fwd, rev, options.name);
        this.paired.push(pair);
        this.unpaired = _.without(this.unpaired, fwd, rev);
        if (!options.silent) {
            this.trigger("pair:new", pair);
        }
        return pair;
    },

    /** create a pair Object from fwd and rev, adding the name attribute (will guess if not given) */
    _createPair: function _createPair(fwd, rev, name) {
        // ensure existance and don't pair something with itself
        if (!(fwd && rev) || fwd === rev) {
            throw new Error("Bad pairing: " + [JSON.stringify(fwd), JSON.stringify(rev)]);
        }
        name = name || this._guessNameForPair(fwd, rev);
        return { forward: fwd, name: name, reverse: rev };
    },

    /** try to find a good pair name for the given fwd and rev datasets */
    _guessNameForPair: function _guessNameForPair(fwd, rev, removeExtensions) {
        removeExtensions = removeExtensions !== undefined ? removeExtensions : this.removeExtensions;
        var fwdName = fwd.name;
        var revName = rev.name;

        var lcs = this._naiveStartingAndEndingLCS(fwdName.replace(new RegExp(this.filters[0]), ""), revName.replace(new RegExp(this.filters[1]), ""));

        if (removeExtensions) {
            var lastDotIndex = lcs.lastIndexOf(".");
            if (lastDotIndex > 0) {
                var extension = lcs.slice(lastDotIndex, lcs.length);
                lcs = lcs.replace(extension, "");
                fwdName = fwdName.replace(extension, "");
                revName = revName.replace(extension, "");
            }
        }
        return lcs || fwdName + " & " + revName;
    },

    /** unpair a pair, removing it from paired, and adding the fwd,rev datasets back into unpaired */
    _unpair: function _unpair(pair, options) {
        options = options || {};
        if (!pair) {
            throw new Error("Bad pair: " + JSON.stringify(pair));
        }
        this.paired = _.without(this.paired, pair);
        this._addToUnpaired(pair.forward);
        this._addToUnpaired(pair.reverse);

        if (!options.silent) {
            this.trigger("pair:unpair", [pair]);
        }
        return pair;
    },

    /** unpair all paired datasets */
    unpairAll: function unpairAll() {
        var pairs = [];
        while (this.paired.length) {
            pairs.push(this._unpair(this.paired[0], { silent: true }));
        }
        this.trigger("pair:unpair", pairs);
    },

    // ------------------------------------------------------------------------ API
    /** convert a pair into JSON compatible with the collections API */
    _pairToJSON: function _pairToJSON(pair) {
        //TODO: consider making this the pair structure when created instead
        return {
            collection_type: "paired",
            src: "new_collection",
            name: pair.name,
            element_identifiers: [{
                name: "forward",
                id: pair.forward.id,
                src: pair.forward.src || "hda"
            }, {
                name: "reverse",
                id: pair.reverse.id,
                src: pair.reverse.src || "hda"
            }]
        };
    },

    /** create the collection via the API
     *  @returns {jQuery.xhr Object}    the jquery ajax request
     */
    createList: function createList(name) {
        var self = this;

        var url = Galaxy.root + "api/histories/" + this.historyId + "/contents/dataset_collections";

        var ajaxData = {
            type: "dataset_collection",
            collection_type: "list:paired",
            hide_source_items: self.hideOriginals || false,
            copy_elements: self.copyElements,
            name: _.escape(name || self.$(".collection-name").val()),
            element_identifiers: self.paired.map(function (pair) {
                return self._pairToJSON(pair);
            })
        };
        //this.debug( JSON.stringify( ajaxData ) );
        self.blocking = true;
        return jQuery.ajax(url, {
            type: "POST",
            contentType: "application/json",
            dataType: "json",
            data: JSON.stringify(ajaxData)
        }).always(function () {
            self.blocking = false;
        }).fail(function (xhr, status, message) {
            self._ajaxErrHandler(xhr, status, message);
        }).done(function (response, message, xhr) {
            //this.info( 'ok', response, message, xhr );
            self.trigger("collection:created", response, message, xhr);
            self.metric("collection:created", response);
            if (typeof self.oncreate === "function") {
                self.oncreate.call(this, response, message, xhr);
            }
        });
    },

    /** handle ajax errors with feedback and details to the user (if available) */
    _ajaxErrHandler: function _ajaxErrHandler(xhr, status, message) {
        this.error(xhr, status, message);
        var self = this;
        var content = (0, _localization2.default)("An error occurred while creating this collection");
        if (xhr) {
            if (xhr.readyState === 0 && xhr.status === 0) {
                content += ": " + (0, _localization2.default)("Galaxy could not be reached and may be updating.") + (0, _localization2.default)(" Try again in a few minutes.");
            } else if (xhr.responseJSON) {
                content += "<br /><pre>" + JSON.stringify(xhr.responseJSON) + "</pre>";
            } else {
                content += ": " + message;
            }
        }
        self._showAlert(content, "alert-danger");
    },

    // ------------------------------------------------------------------------ rendering
    /** render the entire interface */
    render: function render(speed, callback) {
        //this.debug( '-- _render' );
        //this.$el.empty().html( this.templates.main() );
        this.$el.empty().html(this.templates.main());
        this._renderHeader(speed);
        this._renderMiddle(speed);
        this._renderFooter(speed);
        this._addPluginComponents();
        this.trigger("rendered", this);
        return this;
    },

    /** render the header section */
    _renderHeader: function _renderHeader(speed, callback) {
        //this.debug( '-- _renderHeader' );
        var $header = this.$(".header").empty().html(this.templates.header()).find(".help-content").prepend($(this.templates.helpContent()));

        this._renderFilters();
        return $header;
    },
    /** fill the filter inputs with the filter values */
    _renderFilters: function _renderFilters() {
        return this.$(".forward-column .column-header input").val(this.filters[0]).add(this.$(".reverse-column .column-header input").val(this.filters[1]));
    },

    /** render the middle including unpaired and paired sections (which may be hidden) */
    _renderMiddle: function _renderMiddle(speed, callback) {
        var $middle = this.$(".middle").empty().html(this.templates.middle());

        // (re-) hide the un/paired panels based on instance vars
        if (this.unpairedPanelHidden) {
            this.$(".unpaired-columns").hide();
        } else if (this.pairedPanelHidden) {
            this.$(".paired-columns").hide();
        }

        this._renderUnpaired();
        this._renderPaired();
        return $middle;
    },
    /** render the unpaired section, showing datasets accrd. to filters, update the unpaired counts */
    _renderUnpaired: function _renderUnpaired(speed, callback) {
        //this.debug( '-- _renderUnpaired' );
        var self = this;

        var $fwd;
        var $rev;
        var $prd = [];
        var split = this._splitByFilters();
        // update unpaired counts
        this.$(".forward-column .title").text([split[0].length, (0, _localization2.default)("unpaired forward")].join(" "));
        this.$(".forward-column .unpaired-info").text(this._renderUnpairedDisplayStr(this.unpaired.length - split[0].length));
        this.$(".reverse-column .title").text([split[1].length, (0, _localization2.default)("unpaired reverse")].join(" "));
        this.$(".reverse-column .unpaired-info").text(this._renderUnpairedDisplayStr(this.unpaired.length - split[1].length));

        this.$(".unpaired-columns .column-datasets").empty();

        // show/hide the auto pair button if any unpaired are left
        this.$(".autopair-link").toggle(this.unpaired.length !== 0);
        if (this.unpaired.length === 0) {
            this._renderUnpairedEmpty();
            return;
        }

        // create the dataset dom arrays
        $rev = split[1].map(function (dataset, i) {
            // if there'll be a fwd dataset across the way, add a button to pair the row
            if (split[0][i] !== undefined && split[0][i] !== dataset) {
                $prd.push(self._renderPairButton());
            }
            return self._renderUnpairedDataset(dataset);
        });
        $fwd = split[0].map(function (dataset) {
            return self._renderUnpairedDataset(dataset);
        });

        if (!$fwd.length && !$rev.length) {
            this._renderUnpairedNotShown();
            return;
        }
        // add to appropo cols
        //TODO: not the best way to render - consider rendering the entire unpaired-columns section in a fragment
        //  and swapping out that
        this.$(".unpaired-columns .forward-column .column-datasets").append($fwd).add(this.$(".unpaired-columns .paired-column .column-datasets").append($prd)).add(this.$(".unpaired-columns .reverse-column .column-datasets").append($rev));
        this._adjUnpairedOnScrollbar();
    },
    /** return a string to display the count of filtered out datasets */
    _renderUnpairedDisplayStr: function _renderUnpairedDisplayStr(numFiltered) {
        return ["(", numFiltered, " ", (0, _localization2.default)("filtered out"), ")"].join("");
    },
    /** return an unattached jQuery DOM element to represent an unpaired dataset */
    _renderUnpairedDataset: function _renderUnpairedDataset(dataset) {
        //TODO: to underscore template
        return $("<li/>").attr("id", "dataset-" + dataset.id).addClass("dataset unpaired").attr("draggable", true).addClass(dataset.selected ? "selected" : "").append($("<span/>").addClass("dataset-name").text(dataset.name))
        //??
        .data("dataset", dataset);
    },
    /** render the button that may go between unpaired datasets, allowing the user to pair a row */
    _renderPairButton: function _renderPairButton() {
        //TODO: *not* a dataset - don't pretend like it is
        return $("<li/>").addClass("dataset unpaired").append($("<span/>").addClass("dataset-name").text((0, _localization2.default)("Pair these datasets")));
    },
    /** a message to display when no unpaired left */
    _renderUnpairedEmpty: function _renderUnpairedEmpty() {
        //this.debug( '-- renderUnpairedEmpty' );
        var $msg = $('<div class="empty-message"></div>').text("(" + (0, _localization2.default)("no remaining unpaired datasets") + ")");
        this.$(".unpaired-columns .paired-column .column-datasets").empty().prepend($msg);
        return $msg;
    },
    /** a message to display when no unpaired can be shown with the current filters */
    _renderUnpairedNotShown: function _renderUnpairedNotShown() {
        //this.debug( '-- renderUnpairedEmpty' );
        var $msg = $('<div class="empty-message"></div>').text("(" + (0, _localization2.default)("no datasets were found matching the current filters") + ")");
        this.$(".unpaired-columns .paired-column .column-datasets").empty().prepend($msg);
        return $msg;
    },
    /** try to detect if the unpaired section has a scrollbar and adjust left column for better centering of all */
    _adjUnpairedOnScrollbar: function _adjUnpairedOnScrollbar() {
        var $unpairedColumns = this.$(".unpaired-columns").last();

        var $firstDataset = this.$(".unpaired-columns .reverse-column .dataset").first();

        if (!$firstDataset.length) {
            return;
        }

        var ucRight = $unpairedColumns.offset().left + $unpairedColumns.outerWidth();

        var dsRight = $firstDataset.offset().left + $firstDataset.outerWidth();

        var rightDiff = Math.floor(ucRight) - Math.floor(dsRight);
        //this.debug( 'rightDiff:', ucRight, '-', dsRight, '=', rightDiff );
        this.$(".unpaired-columns .forward-column").css("margin-left", rightDiff > 0 ? rightDiff : 0);
    },

    /** render the paired section and update counts of paired datasets */
    _renderPaired: function _renderPaired(speed, callback) {
        //this.debug( '-- _renderPaired' );
        this.$(".paired-column-title .title").text([this.paired.length, (0, _localization2.default)("paired")].join(" "));
        // show/hide the unpair all link
        this.$(".unpair-all-link").toggle(this.paired.length !== 0);
        if (this.paired.length === 0) {
            this._renderPairedEmpty();
            return;
            //TODO: would be best to return here (the $columns)
        } else {
            // show/hide 'remove extensions link' when any paired and they seem to have extensions
            this.$(".remove-extensions-link").show();
        }

        this.$(".paired-columns .column-datasets").empty();
        var self = this;
        this.paired.forEach(function (pair, i) {
            //TODO: cache these?
            var pairView = new PairView({ pair: pair });
            self.$(".paired-columns .column-datasets").append(pairView.render().$el).append(['<button class="unpair-btn">', '<span class="fa fa-unlink" title="', (0, _localization2.default)("Unpair"), '"></span>', "</button>"].join(""));
        });
    },
    /** a message to display when none paired */
    _renderPairedEmpty: function _renderPairedEmpty() {
        var $msg = $('<div class="empty-message"></div>').text("(" + (0, _localization2.default)("no paired datasets yet") + ")");
        this.$(".paired-columns .column-datasets").empty().prepend($msg);
        return $msg;
    },

    footerSettings: {
        ".hide-originals": "hideOriginals",
        ".remove-extensions": "removeExtensions"
    },

    /** add any jQuery/bootstrap/custom plugins to elements rendered */
    _addPluginComponents: function _addPluginComponents() {
        this._chooseFiltersPopover(".choose-filters-link");
        this.$(".help-content i").hoverhighlight(".collection-creator", "rgba( 64, 255, 255, 1.0 )");
    },

    /** build a filter selection popover allowing selection of common filter pairs */
    _chooseFiltersPopover: function _chooseFiltersPopover(selector) {
        function filterChoice(val1, val2) {
            return ['<button class="filter-choice btn" ', 'data-forward="', val1, '" data-reverse="', val2, '">', (0, _localization2.default)("Forward"), ": ", val1, ", ", (0, _localization2.default)("Reverse"), ": ", val2, "</button>"].join("");
        }
        var $popoverContent = $(_.template(['<div class="choose-filters">', '<div class="help">', (0, _localization2.default)("Choose from the following filters to change which unpaired reads are shown in the display"), ":</div>", _.values(this.commonFilters).map(function (filterSet) {
            return filterChoice(filterSet[0], filterSet[1]);
        }).join(""), "</div>"].join(""))({}));

        return this.$(selector).popover({
            container: ".collection-creator",
            placement: "bottom",
            html: true,
            //animation   : false,
            content: $popoverContent
        });
    },

    /** add (or clear if clear is truthy) a validation warning to what */
    _validationWarning: function _validationWarning(what, clear) {
        var VALIDATION_CLASS = "validation-warning";
        if (what === "name") {
            what = this.$(".collection-name").add(this.$(".collection-name-prompt"));
            this.$(".collection-name").focus().select();
        }
        if (clear) {
            what = what || this.$("." + VALIDATION_CLASS);
            what.removeClass(VALIDATION_CLASS);
        } else {
            what.addClass(VALIDATION_CLASS);
        }
    },

    // ------------------------------------------------------------------------ events
    /** set up event handlers on self */
    _setUpBehaviors: function _setUpBehaviors() {
        this.once("rendered", function () {
            this.trigger("rendered:initial", this);
        });

        this.on("pair:new", function () {
            //TODO: ideally only re-render the columns (or even elements) involved
            this._renderUnpaired();
            this._renderPaired();

            // scroll to bottom where new pairs are added
            //TODO: this doesn't seem to work - innerHeight sticks at 133...
            //  may have to do with improper flex columns
            //var $pairedView = this.$( '.paired-columns' );
            //$pairedView.scrollTop( $pairedView.innerHeight() );
            //this.debug( $pairedView.height() )
            this.$(".paired-columns").scrollTop(8000000);
        });
        this.on("pair:unpair", function (pairs) {
            //TODO: ideally only re-render the columns (or even elements) involved
            this._renderUnpaired();
            this._renderPaired();
            this.splitView();
        });

        this.on("filter-change", function () {
            this.filters = [this.$(".forward-unpaired-filter input").val(), this.$(".reverse-unpaired-filter input").val()];
            this.metric("filter-change", this.filters);
            this._renderFilters();
            this._renderUnpaired();
        });

        this.on("autopair", function () {
            this._renderUnpaired();
            this._renderPaired();

            var message;
            var msgClass = null;
            if (this.paired.length) {
                msgClass = "alert-success";
                message = this.paired.length + " " + (0, _localization2.default)("pairs created");
                if (!this.unpaired.length) {
                    message += ": " + (0, _localization2.default)("all datasets have been successfully paired");
                    this.hideUnpaired();
                    this.$(".collection-name").focus();
                }
            } else {
                message = (0, _localization2.default)(["Could not automatically create any pairs from the given dataset names.", "You may want to choose or enter different filters and try auto-pairing again.", "Close this message using the X on the right to view more help."].join(" "));
            }
            this._showAlert(message, msgClass);
        });

        //this.on( 'all', function(){
        //    this.info( arguments );
        //});
        return this;
    },

    events: {
        // header
        "click .more-help": "_clickMoreHelp",
        "click .less-help": "_clickLessHelp",
        "click .main-help": "_toggleHelp",
        "click .header .alert button": "_hideAlert",
        "click .forward-column .column-title": "_clickShowOnlyUnpaired",
        "click .reverse-column .column-title": "_clickShowOnlyUnpaired",
        "click .unpair-all-link": "_clickUnpairAll",
        //TODO: this seems kinda backasswards - re-sending jq event as a backbone event, can we listen directly?
        "change .forward-unpaired-filter input": function changeForwardUnpairedFilterInput(ev) {
            this.trigger("filter-change");
        },
        "focus .forward-unpaired-filter input": function focusForwardUnpairedFilterInput(ev) {
            $(ev.currentTarget).select();
        },
        "click .autopair-link": "_clickAutopair",
        "click .choose-filters .filter-choice": "_clickFilterChoice",
        "click .clear-filters-link": "_clearFilters",
        "change .reverse-unpaired-filter input": function changeReverseUnpairedFilterInput(ev) {
            this.trigger("filter-change");
        },
        "focus .reverse-unpaired-filter input": function focusReverseUnpairedFilterInput(ev) {
            $(ev.currentTarget).select();
        },
        // unpaired
        "click .forward-column .dataset.unpaired": "_clickUnpairedDataset",
        "click .reverse-column .dataset.unpaired": "_clickUnpairedDataset",
        "click .paired-column .dataset.unpaired": "_clickPairRow",
        "click .unpaired-columns": "clearSelectedUnpaired",
        "mousedown .unpaired-columns .dataset": "_mousedownUnpaired",
        // divider
        "click .paired-column-title": "_clickShowOnlyPaired",
        "mousedown .flexible-partition-drag": "_startPartitionDrag",
        // paired
        "click .paired-columns .dataset.paired": "selectPair",
        "click .paired-columns": "clearSelectedPaired",
        "click .paired-columns .pair-name": "_clickPairName",
        "click .unpair-btn": "_clickUnpair",
        // paired - drop target
        //'dragenter .paired-columns'                 : '_dragenterPairedColumns',
        //'dragleave .paired-columns .column-datasets': '_dragleavePairedColumns',
        "dragover .paired-columns .column-datasets": "_dragoverPairedColumns",
        "drop .paired-columns .column-datasets": "_dropPairedColumns",

        "pair.dragstart .paired-columns .column-datasets": "_pairDragstart",
        "pair.dragend   .paired-columns .column-datasets": "_pairDragend",

        // footer
        "change .remove-extensions": function changeRemoveExtensions(ev) {
            this.toggleExtensions();
        },
        "change .collection-name": "_changeName",
        "keydown .collection-name": "_nameCheckForEnter",
        "change .hide-originals": "_changeHideOriginals",
        "click .cancel-create": "_cancelCreate",
        "click .create-collection": "_clickCreate" //,
    },

    /** toggle between showing only unpaired and split view */
    _clickShowOnlyUnpaired: function _clickShowOnlyUnpaired(ev) {
        //this.debug( 'click unpaired', ev.currentTarget );
        if (this.$(".paired-columns").is(":visible")) {
            this.hidePaired();
        } else {
            this.splitView();
        }
    },
    /** toggle between showing only paired and split view */
    _clickShowOnlyPaired: function _clickShowOnlyPaired(ev) {
        //this.debug( 'click paired' );
        if (this.$(".unpaired-columns").is(":visible")) {
            this.hideUnpaired();
        } else {
            this.splitView();
        }
    },

    /** hide unpaired, show paired */
    hideUnpaired: function hideUnpaired(speed, callback) {
        this.unpairedPanelHidden = true;
        this.pairedPanelHidden = false;
        this._renderMiddle(speed, callback);
    },
    /** hide paired, show unpaired */
    hidePaired: function hidePaired(speed, callback) {
        this.unpairedPanelHidden = false;
        this.pairedPanelHidden = true;
        this._renderMiddle(speed, callback);
    },
    /** show both paired and unpaired (splitting evenly) */
    splitView: function splitView(speed, callback) {
        this.unpairedPanelHidden = this.pairedPanelHidden = false;
        this._renderMiddle(speed, callback);
        return this;
    },

    /** unpair all paired and do other super neat stuff which I'm not really sure about yet... */
    _clickUnpairAll: function _clickUnpairAll(ev) {
        this.metric("unpairAll");
        this.unpairAll();
    },

    /** attempt to autopair */
    _clickAutopair: function _clickAutopair(ev) {
        var paired = this.autoPair();
        this.metric("autopair", paired.length, this.unpaired.length);
        this.trigger("autopair");
    },

    /** set the filters based on the data attributes of the button click target */
    _clickFilterChoice: function _clickFilterChoice(ev) {
        var $selected = $(ev.currentTarget);
        this.$(".forward-unpaired-filter input").val($selected.data("forward"));
        this.$(".reverse-unpaired-filter input").val($selected.data("reverse"));
        this._hideChooseFilters();
        this.trigger("filter-change");
    },

    /** hide the choose filters popover */
    _hideChooseFilters: function _hideChooseFilters() {
        //TODO: update bootstrap and remove the following hack
        //  see also: https://github.com/twbs/bootstrap/issues/10260
        this.$(".choose-filters-link").popover("hide");
        this.$(".popover").css("display", "none");
    },

    /** clear both filters */
    _clearFilters: function _clearFilters(ev) {
        this.$(".forward-unpaired-filter input").val("");
        this.$(".reverse-unpaired-filter input").val("");
        this.trigger("filter-change");
    },

    // ........................................................................ unpaired
    /** select an unpaired dataset */
    _clickUnpairedDataset: function _clickUnpairedDataset(ev) {
        ev.stopPropagation();
        return this.toggleSelectUnpaired($(ev.currentTarget));
    },

    /** Toggle the selection of an unpaired dataset representation.
     *  @param [jQuery] $dataset        the unpaired dataset dom rep to select
     *  @param [Boolean] options.force  if defined, force selection based on T/F; otherwise, toggle
     */
    toggleSelectUnpaired: function toggleSelectUnpaired($dataset, options) {
        options = options || {};
        var dataset = $dataset.data("dataset");

        var select = options.force !== undefined ? options.force : !$dataset.hasClass("selected");

        //this.debug( id, options.force, $dataset, dataset );
        if (!$dataset.length || dataset === undefined) {
            return $dataset;
        }

        if (select) {
            $dataset.addClass("selected");
            if (!options.waitToPair) {
                this.pairAllSelected();
            }
        } else {
            $dataset.removeClass("selected");
            //delete dataset.selected;
        }
        return $dataset;
    },

    /** pair all the currently selected unpaired datasets */
    pairAllSelected: function pairAllSelected(options) {
        options = options || {};
        var self = this;
        var fwds = [];
        var revs = [];
        var pairs = [];
        self.$(".unpaired-columns .forward-column .dataset.selected").each(function () {
            fwds.push($(this).data("dataset"));
        });
        self.$(".unpaired-columns .reverse-column .dataset.selected").each(function () {
            revs.push($(this).data("dataset"));
        });
        fwds.length = revs.length = Math.min(fwds.length, revs.length);
        //this.debug( fwds );
        //this.debug( revs );
        fwds.forEach(function (fwd, i) {
            try {
                pairs.push(self._pair(fwd, revs[i], { silent: true }));
            } catch (err) {
                //TODO: preserve selected state of those that couldn't be paired
                //TODO: warn that some could not be paired
                self.error(err);
            }
        });
        if (pairs.length && !options.silent) {
            this.trigger("pair:new", pairs);
        }
        return pairs;
    },

    /** clear the selection on all unpaired datasets */
    clearSelectedUnpaired: function clearSelectedUnpaired() {
        this.$(".unpaired-columns .dataset.selected").removeClass("selected");
    },

    /** when holding down the shift key on a click, 'paint' the moused over datasets as selected */
    _mousedownUnpaired: function _mousedownUnpaired(ev) {
        if (ev.shiftKey) {
            var self = this;
            var $startTarget = $(ev.target).addClass("selected");

            var moveListener = function moveListener(ev) {
                self.$(ev.target).filter(".dataset").addClass("selected");
            };

            $startTarget.parent().on("mousemove", moveListener);

            // on any mouseup, stop listening to the move and try to pair any selected
            $(document).one("mouseup", function (ev) {
                $startTarget.parent().off("mousemove", moveListener);
                self.pairAllSelected();
            });
        }
    },

    /** attempt to pair two datasets directly across from one another */
    _clickPairRow: function _clickPairRow(ev) {
        //if( !ev.currentTarget ){ return true; }
        var rowIndex = $(ev.currentTarget).index();

        var fwd = $(".unpaired-columns .forward-column .dataset").eq(rowIndex).data("dataset");

        var rev = $(".unpaired-columns .reverse-column .dataset").eq(rowIndex).data("dataset");

        //this.debug( 'row:', rowIndex, fwd, rev );
        this._pair(fwd, rev);
    },

    // ........................................................................ divider/partition
    /** start dragging the visible divider/partition between unpaired and paired panes */
    _startPartitionDrag: function _startPartitionDrag(ev) {
        var self = this;
        var startingY = ev.pageY;
        //this.debug( 'partition drag START:', ev );
        $("body").css("cursor", "ns-resize");
        self.$(".flexible-partition-drag").css("color", "black");

        function endDrag(ev) {
            self.$(".flexible-partition-drag").css("color", "");
            $("body").css("cursor", "").unbind("mousemove", trackMouse);
        }
        function trackMouse(ev) {
            var offset = ev.pageY - startingY;
            if (!self.adjPartition(offset)) {
                $("body").trigger("mouseup");
            }
            self._adjUnpairedOnScrollbar();
            startingY += offset;
        }
        $("body").mousemove(trackMouse);
        $("body").one("mouseup", endDrag);
    },

    /** adjust the parition up/down +/-adj pixels */
    adjPartition: function adjPartition(adj) {
        var $unpaired = this.$(".unpaired-columns");
        var $paired = this.$(".paired-columns");
        var unpairedHi = parseInt($unpaired.css("height"), 10);
        var pairedHi = parseInt($paired.css("height"), 10);
        //this.debug( adj, 'hi\'s:', unpairedHi, pairedHi, unpairedHi + adj, pairedHi - adj );

        unpairedHi = Math.max(10, unpairedHi + adj);
        pairedHi = pairedHi - adj;

        var movingUpwards = adj < 0;
        // when the divider gets close to the top - lock into hiding the unpaired section
        if (movingUpwards) {
            if (this.unpairedPanelHidden) {
                return false;
            } else if (unpairedHi <= 10) {
                this.hideUnpaired();
                return false;
            }
        } else {
            if (this.unpairedPanelHidden) {
                $unpaired.show();
                this.unpairedPanelHidden = false;
            }
        }

        // when the divider gets close to the bottom - lock into hiding the paired section
        if (!movingUpwards) {
            if (this.pairedPanelHidden) {
                return false;
            } else if (pairedHi <= 15) {
                this.hidePaired();
                return false;
            }
        } else {
            if (this.pairedPanelHidden) {
                $paired.show();
                this.pairedPanelHidden = false;
            }
        }

        $unpaired.css({
            height: unpairedHi + "px",
            flex: "0 0 auto"
        });
        return true;
    },

    // ........................................................................ paired
    /** select a pair when clicked */
    selectPair: function selectPair(ev) {
        ev.stopPropagation();
        $(ev.currentTarget).toggleClass("selected");
    },

    /** deselect all pairs */
    clearSelectedPaired: function clearSelectedPaired(ev) {
        this.$(".paired-columns .dataset.selected").removeClass("selected");
    },

    /** rename a pair when the pair name is clicked */
    _clickPairName: function _clickPairName(ev) {
        ev.stopPropagation();
        var $name = $(ev.currentTarget);
        var $pair = $name.parent().parent();
        var index = $pair.index(".dataset.paired");
        var pair = this.paired[index];
        var response = prompt("Enter a new name for the pair:", pair.name);
        if (response) {
            pair.name = response;
            // set a flag (which won't be passed in json creation) for manual naming so we don't overwrite these
            //  when adding/removing extensions
            //hackish
            pair.customizedName = true;
            $name.text(pair.name);
        }
    },

    /** unpair this pair */
    _clickUnpair: function _clickUnpair(ev) {
        //if( !ev.currentTarget ){ return true; }
        var pairIndex = Math.floor($(ev.currentTarget).index(".unpair-btn"));
        //this.debug( 'pair:', pairIndex );
        this._unpair(this.paired[pairIndex]);
    },

    // ........................................................................ paired - drag and drop re-ordering
    //_dragenterPairedColumns : function( ev ){
    //    this.debug( '_dragenterPairedColumns:', ev );
    //},
    //_dragleavePairedColumns : function( ev ){
    //    //this.debug( '_dragleavePairedColumns:', ev );
    //},
    /** track the mouse drag over the paired list adding a placeholder to show where the drop would occur */
    _dragoverPairedColumns: function _dragoverPairedColumns(ev) {
        //this.debug( '_dragoverPairedColumns:', ev );
        ev.preventDefault();

        var $list = this.$(".paired-columns .column-datasets");
        this._checkForAutoscroll($list, ev.originalEvent.clientY);
        //this.debug( ev.originalEvent.clientX, ev.originalEvent.clientY );
        var $nearest = this._getNearestPairedDatasetLi(ev.originalEvent.clientY);

        $(".element-drop-placeholder").remove();
        var $placeholder = $('<div class="element-drop-placeholder"></div>');
        if (!$nearest.length) {
            $list.append($placeholder);
        } else {
            $nearest.before($placeholder);
        }
    },

    /** If the mouse is near enough to the list's top or bottom, scroll the list */
    _checkForAutoscroll: function _checkForAutoscroll($element, y) {
        var AUTOSCROLL_SPEED = 2;
        var offset = $element.offset();
        var scrollTop = $element.scrollTop();
        var upperDist = y - offset.top;
        var lowerDist = offset.top + $element.outerHeight() - y;
        //this.debug( '_checkForAutoscroll:', scrollTop, upperDist, lowerDist );
        if (upperDist >= 0 && upperDist < this.autoscrollDist) {
            $element.scrollTop(scrollTop - AUTOSCROLL_SPEED);
        } else if (lowerDist >= 0 && lowerDist < this.autoscrollDist) {
            $element.scrollTop(scrollTop + AUTOSCROLL_SPEED);
        }
    },

    /** get the nearest *previous* paired dataset PairView based on the mouse's Y coordinate.
     *      If the y is at the end of the list, return an empty jQuery object.
     */
    _getNearestPairedDatasetLi: function _getNearestPairedDatasetLi(y) {
        var WIGGLE = 4;
        var lis = this.$(".paired-columns .column-datasets li").toArray();
        for (var i = 0; i < lis.length; i++) {
            var $li = $(lis[i]);
            var top = $li.offset().top;
            var halfHeight = Math.floor($li.outerHeight() / 2) + WIGGLE;
            if (top + halfHeight > y && top - halfHeight < y) {
                //this.debug( y, top + halfHeight, top - halfHeight )
                return $li;
            }
        }
        return $();
    },
    /** drop (dragged/selected PairViews) onto the list, re-ordering both the DOM and the internal array of pairs */
    _dropPairedColumns: function _dropPairedColumns(ev) {
        // both required for firefox
        ev.preventDefault();
        ev.dataTransfer.dropEffect = "move";

        var $nearest = this._getNearestPairedDatasetLi(ev.originalEvent.clientY);
        if ($nearest.length) {
            this.$dragging.insertBefore($nearest);
        } else {
            // no nearest before - insert after last element (unpair button)
            this.$dragging.insertAfter(this.$(".paired-columns .unpair-btn").last());
        }
        // resync the creator's list of paired based on the new DOM order
        this._syncPairsToDom();
        return false;
    },
    /** resync the creator's list of paired based on the DOM order of pairs */
    _syncPairsToDom: function _syncPairsToDom() {
        var newPaired = [];
        //TODO: doesn't seem wise to use the dom to store these - can't we sync another way?
        this.$(".paired-columns .dataset.paired").each(function () {
            newPaired.push($(this).data("pair"));
        });
        //this.debug( newPaired );
        this.paired = newPaired;
        this._renderPaired();
    },
    /** drag communication with pair sub-views: dragstart */
    _pairDragstart: function _pairDragstart(ev, pair) {
        //this.debug( '_pairDragstart', ev, pair )
        // auto select the pair causing the event and move all selected
        pair.$el.addClass("selected");
        var $selected = this.$(".paired-columns .dataset.selected");
        this.$dragging = $selected;
    },
    /** drag communication with pair sub-views: dragend - remove the placeholder */
    _pairDragend: function _pairDragend(ev, pair) {
        //this.debug( '_pairDragend', ev, pair )
        $(".element-drop-placeholder").remove();
        this.$dragging = null;
    },

    // ........................................................................ footer
    toggleExtensions: function toggleExtensions(force) {
        var self = this;
        self.removeExtensions = force !== undefined ? force : !self.removeExtensions;

        _.each(self.paired, function (pair) {
            // don't overwrite custom names
            if (pair.customizedName) {
                return;
            }
            pair.name = self._guessNameForPair(pair.forward, pair.reverse);
        });

        self._renderPaired();
        self._renderFooter();
    },

    // ------------------------------------------------------------------------ misc
    /** debug a dataset list */
    _printList: function _printList(list) {
        var self = this;
        _.each(list, function (e) {
            if (list === self.paired) {
                self._printPair(e);
            } else {
                self.debug(e);
            }
        });
    },

    /** print a pair Object */
    _printPair: function _printPair(pair) {
        this.debug(pair.forward.name, pair.reverse.name, ": ->", pair.name);
    },

    /** string rep */
    toString: function toString() {
        return "PairedCollectionCreator";
    },

    templates: _.extend({}, _baseCreator2.default.CollectionCreatorMixin._creatorTemplates, {
        /** the header (not including help text) */
        header: _.template(['<div class="main-help well clear">', '<a class="more-help" href="javascript:void(0);">', (0, _localization2.default)("More help"), "</a>", '<div class="help-content">', '<a class="less-help" href="javascript:void(0);">', (0, _localization2.default)("Less"), "</a>", "</div>", "</div>", '<div class="alert alert-dismissable">', '<button type="button" class="close" data-dismiss="alert" aria-hidden="true">&times;</button>', '<span class="alert-message"></span>', "</div>", '<div class="column-headers vertically-spaced flex-column-container">', '<div class="forward-column flex-column column">', '<div class="column-header">', '<div class="column-title">', '<span class="title">', (0, _localization2.default)("Unpaired forward"), "</span>", '<span class="title-info unpaired-info"></span>', "</div>", '<div class="unpaired-filter forward-unpaired-filter float-left">', '<input class="search-query" placeholder="', (0, _localization2.default)("Filter this list"), '" />', "</div>", "</div>", "</div>", '<div class="paired-column flex-column no-flex column">', '<div class="column-header">', '<a class="choose-filters-link" href="javascript:void(0)">', (0, _localization2.default)("Choose filters"), "</a>", '<a class="clear-filters-link" href="javascript:void(0);">', (0, _localization2.default)("Clear filters"), "</a><br />", '<a class="autopair-link" href="javascript:void(0);">', (0, _localization2.default)("Auto-pair"), "</a>", "</div>", "</div>", '<div class="reverse-column flex-column column">', '<div class="column-header">', '<div class="column-title">', '<span class="title">', (0, _localization2.default)("Unpaired reverse"), "</span>", '<span class="title-info unpaired-info"></span>', "</div>", '<div class="unpaired-filter reverse-unpaired-filter float-left">', '<input class="search-query" placeholder="', (0, _localization2.default)("Filter this list"), '" />', "</div>", "</div>", "</div>", "</div>"].join("")),

        /** the middle: unpaired, divider, and paired */
        middle: _.template([
        // contains two flex rows (rows that fill available space) and a divider btwn
        '<div class="unpaired-columns flex-column-container scroll-container flex-row">', '<div class="forward-column flex-column column">', '<ol class="column-datasets"></ol>', "</div>", '<div class="paired-column flex-column no-flex column">', '<ol class="column-datasets"></ol>', "</div>", '<div class="reverse-column flex-column column">', '<ol class="column-datasets"></ol>', "</div>", "</div>", '<div class="flexible-partition">', '<div class="flexible-partition-drag" title="', (0, _localization2.default)("Drag to change"), '"></div>', '<div class="column-header">', '<div class="column-title paired-column-title">', '<span class="title"></span>', "</div>", '<a class="unpair-all-link" href="javascript:void(0);">', (0, _localization2.default)("Unpair all"), "</a>", "</div>", "</div>", '<div class="paired-columns flex-column-container scroll-container flex-row">', '<ol class="column-datasets"></ol>', "</div>"].join("")),

        /** creation and cancel controls */
        footer: _.template(['<div class="attributes clear">', '<div class="clear">', '<label class="setting-prompt float-right">', (0, _localization2.default)("Hide original elements"), "?", '<input class="hide-originals float-right" type="checkbox" />', "</label>", '<label class="setting-prompt float-right">', (0, _localization2.default)("Remove file extensions from pair names"), "?", '<input class="remove-extensions float-right" type="checkbox" />', "</label>", "</div>", '<div class="clear">', '<input class="collection-name form-control float-right" ', 'placeholder="', (0, _localization2.default)("Enter a name for your new list"), '" />', '<div class="collection-name-prompt float-right">', (0, _localization2.default)("Name"), ":</div>", "</div>", "</div>", '<div class="actions clear vertically-spaced">', '<div class="other-options float-left">', '<button class="cancel-create btn" tabindex="-1">', (0, _localization2.default)("Cancel"), "</button>", '<div class="create-other btn-group dropup">', '<button class="btn btn-secondary dropdown-toggle" data-toggle="dropdown">', (0, _localization2.default)("Create a different kind of collection"), ' <span class="caret"></span>', "</button>", '<ul class="dropdown-menu" role="menu">', '<li><a href="#">', (0, _localization2.default)("Create a <i>single</i> pair"), "</a></li>", '<li><a href="#">', (0, _localization2.default)("Create a list of <i>unpaired</i> datasets"), "</a></li>", "</ul>", "</div>", "</div>", '<div class="main-options float-right">', '<button class="create-collection btn btn-primary">', (0, _localization2.default)("Create list"), "</button>", "</div>", "</div>"].join("")),

        /** help content */
        helpContent: _.template(["<p>", (0, _localization2.default)(["Collections of paired datasets are ordered lists of dataset pairs (often forward and reverse reads). ", "These collections can be passed to tools and workflows in order to have analyses done on each member of ", "the entire group. This interface allows you to create a collection, choose which datasets are paired, ", "and re-order the final collection."].join("")), "</p>", "<p>", (0, _localization2.default)(['Unpaired datasets are shown in the <i data-target=".unpaired-columns">unpaired section</i> ', "(hover over the underlined words to highlight below). ", 'Paired datasets are shown in the <i data-target=".paired-columns">paired section</i>.', "<ul>To pair datasets, you can:", "<li>Click a dataset in the ", '<i data-target=".unpaired-columns .forward-column .column-datasets,', '.unpaired-columns .forward-column">forward column</i> ', "to select it then click a dataset in the ", '<i data-target=".unpaired-columns .reverse-column .column-datasets,', '.unpaired-columns .reverse-column">reverse column</i>.', "</li>", '<li>Click one of the "Pair these datasets" buttons in the ', '<i data-target=".unpaired-columns .paired-column .column-datasets,', '.unpaired-columns .paired-column">middle column</i> ', "to pair the datasets in a particular row.", "</li>", '<li>Click <i data-target=".autopair-link">"Auto-pair"</i> ', "to have your datasets automatically paired based on name.", "</li>", "</ul>"].join("")), "</p>", "<p>", (0, _localization2.default)(["<ul>You can filter what is shown in the unpaired sections by:", "<li>Entering partial dataset names in either the ", '<i data-target=".forward-unpaired-filter input">forward filter</i> or ', '<i data-target=".reverse-unpaired-filter input">reverse filter</i>.', "</li>", "<li>Choosing from a list of preset filters by clicking the ", '<i data-target=".choose-filters-link">"Choose filters" link</i>.', "</li>", "<li>Entering regular expressions to match dataset names. See: ", '<a href="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions"', ' target="_blank">MDN\'s JavaScript Regular Expression Tutorial</a>. ', "Note: forward slashes (\\) are not needed.", "</li>", "<li>Clearing the filters by clicking the ", '<i data-target=".clear-filters-link">"Clear filters" link</i>.', "</li>", "</ul>"].join("")), "</p>", "<p>", (0, _localization2.default)(["To unpair individual dataset pairs, click the ", '<i data-target=".unpair-btn">unpair buttons ( <span class="fa fa-unlink"></span> )</i>. ', 'Click the <i data-target=".unpair-all-link">"Unpair all" link</i> to unpair all pairs.'].join("")), "</p>", "<p>", (0, _localization2.default)(['You can include or remove the file extensions (e.g. ".fastq") from your pair names by toggling the ', '<i data-target=".remove-extensions-prompt">"Remove file extensions from pair names?"</i> control.'].join("")), "</p>", "<p>", (0, _localization2.default)(['Once your collection is complete, enter a <i data-target=".collection-name">name</i> and ', 'click <i data-target=".create-collection">"Create list"</i>. ', "(Note: you do not have to pair all unpaired datasets to finish.)"].join("")), "</p>"].join(""))
    })
});

//=============================================================================
/** a modal version of the paired collection creator */
var pairedCollectionCreatorModal = function _pairedCollectionCreatorModal(datasets, options) {
    var deferred = jQuery.Deferred();
    var creator;

    options = _.defaults(options || {}, {
        datasets: datasets,
        oncancel: function oncancel() {
            Galaxy.modal.hide();
            deferred.reject("cancelled");
        },
        oncreate: function oncreate(creator, response) {
            Galaxy.modal.hide();
            deferred.resolve(response);
        },
        title: (0, _localization2.default)("Create a collection of paired datasets")
    });

    if (!window.Galaxy || !Galaxy.modal) {
        throw new Error("Galaxy or Galaxy.modal not found");
    }

    creator = new PairedCollectionCreator(options);
    Galaxy.modal.show({
        title: options.title,
        body: creator.$el,
        width: "80%",
        height: "800px",
        closing_events: true
    });
    creator.render();
    window.creator = creator;

    //TODO: remove modal header
    return deferred;
};

//=============================================================================
function createListOfPairsCollection(collection, defaultHideSourceItems) {
    var elements = collection.toJSON();
    //TODO: validate elements
    return pairedCollectionCreatorModal(elements, {
        historyId: collection.historyId,
        defaultHideSourceItems: defaultHideSourceItems,
        copyElements: !defaultHideSourceItems
    });
}

//=============================================================================
exports.default = {
    PairedCollectionCreator: PairedCollectionCreator,
    pairedCollectionCreatorModal: pairedCollectionCreatorModal,
    createListOfPairsCollection: createListOfPairsCollection
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(1), __webpack_require__(0), __webpack_require__(0)))

/***/ }),
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Backbone) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

var _queryStringParsing = __webpack_require__(35);

var _queryStringParsing2 = _interopRequireDefault(_queryStringParsing);

var _uiMisc = __webpack_require__(11);

var _uiMisc2 = _interopRequireDefault(_uiMisc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var $ = _jquery2.default;


var Router = Backbone.Router.extend({
    // TODO: not many client routes at this point - fill and remove from server.
    // since we're at root here, this may be the last to be routed entirely on the client.
    initialize: function initialize(page, options) {
        this.page = page;
        this.options = options;
    },

    /** helper to push a new navigation state */
    push: function push(url, data) {
        data = data || {};
        data.__identifer = Math.random().toString(36).substr(2);
        url += url.indexOf("?") == -1 ? "?" : "&";
        url += $.param(data, true);
        Galaxy.params = data;
        this.navigate(url, { trigger: true });
    },

    /** override to parse query string into obj and send to each route */
    execute: function execute(callback, args, name) {
        Galaxy.debug("router execute:", callback, args, name);
        var queryObj = _queryStringParsing2.default.parse(args.pop());
        args.push(queryObj);
        if (callback) {
            if (this.authenticate(args, name)) {
                callback.apply(this, args);
            } else {
                this.access_denied();
            }
        }
    },

    authenticate: function authenticate(args, name) {
        return true;
    },

    access_denied: function access_denied() {
        this.page.display(new _uiMisc2.default.Message({
            status: "danger",
            message: "You must be logged in with proper credentials to make this request.",
            persistent: true
        }));
    }
});

exports.default = Router;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Backbone, $, _) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _utils = __webpack_require__(5);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = Backbone.View.extend({
    options: {
        class_check: "fa-check-square-o",
        class_uncheck: "fa-square-o",
        parameters: [{
            id: "space_to_tab",
            title: "Convert spaces to tabs"
        }, {
            id: "to_posix_lines",
            title: "Use POSIX standard"
        }]
    },

    initialize: function initialize(options) {
        var self = this;
        this.model = options.model;
        this.setElement($("<div/>").addClass("upload-settings"));
        this.$el.append($("<div/>").addClass("upload-settings-cover"));
        this.$el.append($("<table/>").addClass("upload-settings-table ui-table-striped").append("<tbody/>"));
        this.$cover = this.$(".upload-settings-cover");
        this.$table = this.$(".upload-settings-table > tbody");
        this.listenTo(this.model, "change", this.render, this);
        this.model.trigger("change");
    },

    render: function render() {
        var self = this;
        this.$table.empty();
        _.each(this.options.parameters, function (parameter) {
            var $checkbox = $("<div/>").addClass("upload-" + parameter.id + " upload-icon-button fa").addClass(self.model.get(parameter.id) && self.options.class_check || self.options.class_uncheck).on("click", function () {
                self.model.get("enabled") && self.model.set(parameter.id, !self.model.get(parameter.id));
            });
            self.$table.append($("<tr/>").append($("<td/>").append($checkbox)).append($("<td/>").append(parameter.title)));
        });
        this.$cover[this.model.get("enabled") && "hide" || "show"]();
    }
}); /** This renders the content of the settings popup, allowing users to specify flags i.e. for space-to-tab conversion **/
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(0), __webpack_require__(1)))

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Backbone, _, $) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _utils = __webpack_require__(5);

var _utils2 = _interopRequireDefault(_utils);

var _uploadUtils = __webpack_require__(203);

var _uploadUtils2 = _interopRequireDefault(_uploadUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** This renders the content of the ftp popup **/
exports.default = Backbone.View.extend({
    initialize: function initialize(options) {
        var self = this;
        this.model = new Backbone.Model({
            cls: "upload-ftp",
            class_add: "upload-icon-button fa fa-square-o",
            class_remove: "upload-icon-button fa fa-check-square-o",
            class_partial: "upload-icon-button fa fa-minus-square-o",
            help_enabled: true,
            oidc_text: "<br/>If you are signed-in to Galaxy using a third-party identity and you <strong>don't have a Galaxy password</strong> please go to <a href=\"" + Galaxy.root + "user/reset_password\" target=\"_blank\">this</a> page and request a password for your Galaxy account.",
            help_text: "This Galaxy server allows you to upload files via FTP. To upload some files, log in to the FTP server at <strong>" + options.ftp_upload_site + "</strong> using your Galaxy credentials.\n            For help visit the <a href=\"https://galaxyproject.org/ftp-upload/\" target=\"_blank\">tutorial</a>.",
            collection: null,
            onchange: function onchange() {},
            onadd: function onadd() {},
            onremove: function onremove() {}
        }).set(options);

        this.collection = this.model.get("collection");
        if (Galaxy.config.enable_oidc) {
            this.model.set("help_text", this.model.get("help_text") + this.model.get("oidc_text"));
        }
        this.setElement(this._template());
        this.$content = this.$(".upload-ftp-content");
        this.$wait = this.$(".upload-ftp-wait");
        this.$help = this.$(".upload-ftp-help");
        this.$number = this.$(".upload-ftp-number");
        this.$disk = this.$(".upload-ftp-disk");
        this.$body = this.$(".upload-ftp-body");
        this.$warning = this.$(".upload-ftp-warning");
        this.$select = this.$(".upload-ftp-select-all");
        this.render();
    },

    render: function render() {
        var self = this;
        this.$wait.show();
        this.$content.hide();
        this.$warning.hide();
        this.$help.hide();
        _uploadUtils2.default.getRemoteFiles(function (ftp_files) {
            self.model.set("ftp_files", ftp_files);
            self._index();
            self._renderTable();
        }, function () {
            self._renderTable();
        });
    },

    /** Fill table with ftp entries */
    _renderTable: function _renderTable() {
        var self = this;
        var ftp_files = this.model.get("ftp_files");
        this.rows = [];
        if (ftp_files && ftp_files.length > 0) {
            this.$body.empty();
            var size = 0;
            _.each(ftp_files, function (ftp_file) {
                self.rows.push(self._renderRow(ftp_file));
                size += ftp_file.size;
            });
            this.$number.html(ftp_files.length + " files");
            this.$disk.html(_utils2.default.bytesToString(size, true));
            if (this.collection) {
                this.$("._has_collection").show();
                this.$select.addClass(this.model.get("class_add")).off().on("click", function () {
                    self._all();
                });
                this._refresh();
            }
            this.$content.show();
        } else {
            this.$warning.show();
        }
        this.model.get("help_enabled") && this.$help.show();
        this.$wait.hide();
    },

    /** Add row */
    _renderRow: function _renderRow(ftp_file) {
        var self = this;
        var options = this.model.attributes;
        var $it = $(this._templateRow(ftp_file));
        var $icon = $it.find(".icon");
        this.$body.append($it);
        if (this.collection) {
            var model_index = this.ftp_index[ftp_file.path];
            $icon.addClass(model_index === undefined ? options.class_add : options.class_remove);
            $it.on("click", function () {
                self._switch($icon, ftp_file);
                self._refresh();
            });
        } else {
            $it.on("click", function () {
                options.onchange(ftp_file);
            });
        }
        return $icon;
    },

    /** Create ftp index */
    _index: function _index() {
        var self = this;
        this.ftp_index = {};
        this.collection && this.collection.each(function (model) {
            if (model.get("file_mode") == "ftp") {
                self.ftp_index[model.get("file_path")] = model.id;
            }
        });
    },

    /** Select all event handler */
    _all: function _all() {
        var options = this.model.attributes;
        var ftp_files = this.model.get("ftp_files");
        var add = this.$select.hasClass(options.class_add);
        for (var index in ftp_files) {
            var ftp_file = ftp_files[index];
            var model_index = this.ftp_index[ftp_file.path];
            if (model_index === undefined && add || model_index !== undefined && !add) {
                this._switch(this.rows[index], ftp_file);
            }
        }
        this._refresh();
    },

    /** Handle collection changes */
    _switch: function _switch($icon, ftp_file) {
        $icon.removeClass();
        var options = this.model.attributes;
        var model_index = this.ftp_index[ftp_file.path];
        if (model_index === undefined) {
            var new_index = options.onadd(ftp_file);
            $icon.addClass(options.class_remove);
            this.ftp_index[ftp_file.path] = new_index;
        } else {
            options.onremove(model_index);
            $icon.addClass(options.class_add);
            this.ftp_index[ftp_file.path] = undefined;
        }
    },

    /** Refresh select all button state */
    _refresh: function _refresh() {
        var counts = _.reduce(this.ftp_index, function (memo, element) {
            element !== undefined && memo++;
            return memo;
        }, 0);
        this.$select.removeClass();
        if (counts == 0) {
            this.$select.addClass(this.model.get("class_add"));
        } else {
            this.$select.addClass(counts == this.rows.length ? this.model.get("class_remove") : this.model.get("class_partial"));
        }
    },

    /** Template of row */
    _templateRow: function _templateRow(options) {
        return "<tr class=\"upload-ftp-row\"><td class=\"_has_collection\" style=\"display: none;\"><div class=\"icon\"/></td><td class=\"ftp-name\">" + _.escape(options.path) + "</td><td class=\"ftp-size\">" + _utils2.default.bytesToString(options.size) + "</td><td class=\"ftp-time\">" + options.ctime + "</td></tr>";
    },

    /** Template of main view */
    _template: function _template() {
        return "<div class=\"" + this.model.get("cls") + "\"><div class=\"upload-ftp-wait fa fa-spinner fa-spin\"/><div class=\"upload-ftp-help\">" + this.model.get("help_text") + "</div><div class=\"upload-ftp-content\"><span style=\"whitespace: nowrap; float: left;\">Available files: </span><span style=\"whitespace: nowrap; float: right;\"><span class=\"upload-icon fa fa-file-text-o\"/><span class=\"upload-ftp-number\"/>&nbsp;&nbsp;<span class=\"upload-icon fa fa-hdd-o\"/><span class=\"upload-ftp-disk\"/></span><table class=\"grid\" style=\"float: left;\"><thead><tr><th class=\"_has_collection\" style=\"display: none;\"><div class=\"upload-ftp-select-all\"></th><th>Name</th><th>Size</th><th>Created</th></tr></thead><tbody class=\"upload-ftp-body\"/></table></div><div class=\"upload-ftp-warning warningmessage\">Your FTP directory does not contain any files.</div>";
        "<div>";
    }
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(1), __webpack_require__(0)))

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery, _) {

/*
    galaxy upload plugins - requires FormData and XMLHttpRequest
*/
(function ($) {
    // add event properties
    jQuery.event.props.push("dataTransfer");

    /**
        xhr request helper
    */
    var _uploadrequest = function _uploadrequest(config) {
        var cnf = $.extend({
            error_default: "Please make sure the file is available.",
            error_server: "Upload request failed.",
            error_login: "Uploads require you to log in.",
            error_retry: "Waiting for server to resume..."
        }, config);
        console.debug(cnf);
        var xhr = new XMLHttpRequest();
        xhr.open("POST", cnf.url, true);
        xhr.setRequestHeader("Cache-Control", "no-cache");
        xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
        xhr.setRequestHeader("Accept", "application/json");
        xhr.onreadystatechange = function () {
            if (xhr.readyState == xhr.DONE) {
                if ([502, 0].indexOf(xhr.status) !== -1 && cnf.warning) {
                    cnf.warning(cnf.error_retry);
                } else if (xhr.status < 200 || xhr.status > 299) {
                    var text = xhr.statusText;
                    if (xhr.status == 403) {
                        text = cnf.error_login;
                    } else if (xhr.status == 0) {
                        text = cnf.error_server;
                    } else if (!text) {
                        text = cnf.error_default;
                    }
                    cnf.error(text + " (" + xhr.status + ")");
                } else {
                    var response = null;
                    if (xhr.responseText) {
                        try {
                            response = jQuery.parseJSON(xhr.responseText);
                        } catch (e) {
                            response = xhr.responseText;
                        }
                    }
                    cnf.success(response);
                }
            }
        };
        xhr.upload.addEventListener("progress", cnf.progress, false);
        xhr.send(cnf.data);
    };

    /**
        Posts chunked files to the API.
    */
    $.uploadchunk = function (config) {
        // parse options
        var cnf = $.extend({}, {
            data: {},
            success: function success() {},
            error: function error() {},
            warning: function warning() {},
            progress: function progress() {},
            attempts: 70000,
            timeout: 5000,
            url: null,
            error_file: "File not provided.",
            error_attempt: "Maximum number of attempts reached.",
            error_tool: "Tool submission failed."
        }, config);

        // initial validation
        var data = cnf.data;
        if (data.error_message) {
            cnf.error(data.error_message);
            return;
        }
        var file_data = data.files && data.files[0];
        if (!file_data) {
            cnf.error(cnf.error_file);
            return;
        }
        var file = file_data.file;
        var attempts = cnf.attempts;
        var session_id = cnf.session.id + "-" + new Date().valueOf() + "-" + file.size;
        var chunk_size = cnf.session.chunk_upload_size;
        console.debug("Starting chunked uploads [size=" + chunk_size + "].");

        // chunk processing helper
        function process(start) {
            start = start || 0;
            var slicer = file.mozSlice || file.webkitSlice || file.slice;
            if (!slicer) {
                cnf.error("Browser does not support chunked uploads.");
                return;
            }
            var end = Math.min(start + chunk_size, file.size);
            var size = file.size;
            console.debug("Submitting chunk at " + start + " bytes...");
            var form = new FormData();
            form.append("session_id", session_id);
            form.append("session_start", start);
            form.append("session_chunk", slicer.bind(file)(start, end));
            _uploadrequest({
                url: Galaxy.root + "api/uploads",
                data: form,
                success: function success(upload_response) {
                    var new_start = start + chunk_size;
                    if (new_start < size) {
                        attempts = cnf.attempts;
                        process(new_start);
                    } else {
                        console.debug("Upload completed.");
                        data.payload.inputs = JSON.parse(data.payload.inputs);
                        data.payload.inputs["files_0|file_data"] = {
                            session_id: session_id,
                            name: file.name
                        };
                        data.payload.inputs = JSON.stringify(data.payload.inputs);
                        $.ajax({
                            url: Galaxy.root + "api/tools",
                            method: "POST",
                            data: data.payload,
                            success: function success(tool_response) {
                                cnf.success(tool_response);
                            },
                            error: function error(tool_response) {
                                var err_msg = tool_response && tool_response.responseJSON && tool_response.responseJSON.err_msg;
                                cnf.error(err_msg || cnf.error_tool);
                            }
                        });
                    }
                },
                warning: function warning(upload_response) {
                    if (--attempts > 0) {
                        console.debug("Retrying last chunk...");
                        cnf.warning(upload_response);
                        setTimeout(function () {
                            return process(start);
                        }, cnf.timeout);
                    } else {
                        console.debug(cnf.error_attempt);
                        cnf.error(cnf.error_attempt);
                    }
                },
                error: function error(upload_response) {
                    console.debug(upload_response);
                    cnf.error(upload_response);
                },
                progress: function progress(e) {
                    if (e.lengthComputable) {
                        cnf.progress(Math.min(Math.round((start + e.loaded) * 100 / file.size), 100));
                    }
                }
            });
        }

        // initiate processing queue for chunks
        process();
    };

    /**
        Posts multiple files without chunking to the API.
    */
    $.uploadpost = function (config) {
        var cnf = $.extend({}, {
            data: {},
            success: function success() {},
            error: function error() {},
            progress: function progress() {},
            url: null,
            maxfilesize: 1048576 * 2048,
            error_filesize: "File exceeds 2GB. Please use a FTP client."
        }, config);
        var data = cnf.data;
        if (data.error_message) {
            cnf.error(data.error_message);
            return;
        }

        // construct form data
        var form = new FormData();
        for (var key in data.payload) {
            form.append(key, data.payload[key]);
        }

        // add files to submission
        var sizes = 0;
        for (var _key in data.files) {
            var d = data.files[_key];
            form.append(d.name, d.file, d.file.name);
            sizes += d.file.size;
        }

        // check file size, unless it's an ftp file
        if (sizes > cnf.maxfilesize) {
            cnf.error(cnf.error_filesize);
            return;
        }

        // submit request
        _uploadrequest({
            url: cnf.url,
            data: form,
            success: cnf.success,
            error: cnf.error,
            progress: function progress(e) {
                if (e.lengthComputable) {
                    cnf.progress(Math.round(e.loaded * 100 / e.total));
                }
            }
        });
    };

    /**
        Handles the upload events drag/drop etc.
    */
    $.fn.uploadinput = function (options) {
        // initialize
        var el = this;
        var opts = $.extend({}, {
            ondragover: function ondragover() {},
            ondragleave: function ondragleave() {},
            onchange: function onchange() {},
            multiple: false
        }, options);

        // append hidden upload field
        var $input = $("<input type=\"file\" style=\"display: none\" " + (opts.multiple && "multiple" || "") + "/>");
        el.append($input.change(function (e) {
            opts.onchange(e.target.files);
            e.target.value = null;
        }));

        // drag/drop events
        el.on("drop", function (e) {
            opts.ondragleave(e);
            if (e.dataTransfer) {
                opts.onchange(e.dataTransfer.files);
                e.preventDefault();
            }
        });
        el.on("dragover", function (e) {
            e.preventDefault();
            opts.ondragover(e);
        });
        el.on("dragleave", function (e) {
            e.stopPropagation();
            opts.ondragleave(e);
        });

        // exports
        return {
            dialog: function dialog() {
                $input.trigger("click");
            }
        };
    };

    /**
        Handles the upload queue and events such as drag/drop etc.
    */
    $.fn.uploadbox = function (options) {
        // parse options
        var opts = $.extend({}, {
            dragover: function dragover() {},
            dragleave: function dragleave() {},
            announce: function announce(d) {},
            initialize: function initialize(d) {},
            progress: function progress(d, m) {},
            success: function success(d, m) {},
            warning: function warning(d, m) {},
            error: function error(d, m) {
                alert(m);
            },
            complete: function complete() {}
        }, options);

        // file queue
        var queue = {};

        // session options
        var session = null;

        // queue index/length counter
        var queue_index = 0;
        var queue_length = 0;

        // indicates if queue is currently running
        var queue_running = false;
        var queue_stop = false;

        // element
        var uploadinput = $(this).uploadinput({
            multiple: true,
            onchange: function onchange(files) {
                _.each(files, function (file) {
                    file.chunk_mode = true;
                });
                add(files);
            },
            ondragover: options.ondragover,
            ondragleave: options.ondragleave
        });

        // add new files to upload queue
        function add(files) {
            if (files && files.length && !queue_running) {
                var index = undefined;
                _.each(files, function (file, key) {
                    if (file.mode !== "new" && _.filter(queue, function (f) {
                        return f.name === file.name && f.size === file.size;
                    }).length) {
                        file.duplicate = true;
                    }
                });
                _.each(files, function (file) {
                    if (!file.duplicate) {
                        index = String(queue_index++);
                        queue[index] = file;
                        opts.announce(index, queue[index]);
                        queue_length++;
                    }
                });
                return index;
            }
        }

        // remove file from queue
        function remove(index) {
            if (queue[index]) {
                delete queue[index];
                queue_length--;
            }
        }

        // process an upload, recursive
        function process() {
            // validate
            if (queue_length == 0 || queue_stop) {
                queue_stop = false;
                queue_running = false;
                opts.complete();
                return;
            } else {
                queue_running = true;
            }

            // get an identifier from the queue
            var index = -1;
            for (var key in queue) {
                index = key;
                break;
            }

            // get current file from queue
            var file = queue[index];

            // remove from queue
            remove(index);

            // create and submit data
            var submitter = $.uploadpost;
            if (file.chunk_mode && session && session.id && session.chunk_upload_size && session.chunk_upload_size > 0) {
                submitter = $.uploadchunk;
            }
            submitter({
                url: opts.url,
                data: opts.initialize(index),
                session: session,
                success: function success(message) {
                    opts.success(index, message);
                    process();
                },
                warning: function warning(message) {
                    opts.warning(index, message);
                },
                error: function error(message) {
                    opts.error(index, message);
                    process();
                },
                progress: function progress(percentage) {
                    opts.progress(index, percentage);
                }
            });
        }

        /*
            public interface
        */

        // open file browser for selection
        function select() {
            uploadinput.dialog();
        }

        // remove all entries from queue
        function reset(index) {
            for (index in queue) {
                remove(index);
            }
        }

        // initiate upload process
        function start(_session) {
            session = _session;
            if (!queue_running) {
                queue_running = true;
                process();
            }
        }

        // stop upload process
        function stop() {
            queue_stop = true;
        }

        // set options
        function configure(options) {
            opts = $.extend({}, opts, options);
            return opts;
        }

        // verify browser compatibility
        function compatible() {
            return window.File && window.FormData && window.XMLHttpRequest && window.FileList;
        }

        // export functions
        return {
            select: select,
            add: add,
            remove: remove,
            start: start,
            stop: stop,
            reset: reset,
            configure: configure,
            compatible: compatible
        };
    };
})(jQuery);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(1)))

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    tool: "fa-wrench",
    data_input: "fa-file-o",
    data_collection_input: "fa-folder-o",
    subworkflow: "fa-sitemap fa-rotate-270",
    pause: "fa-pause"
};

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _baseMvc = __webpack_require__(6);

var _baseMvc2 = _interopRequireDefault(_baseMvc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var logNamespace = "history";

// ============================================================================
/** session storage for individual history preferences */
var HistoryPrefs = _baseMvc2.default.SessionStorageModel.extend(
/** @lends HistoryPrefs.prototype */{
    //TODO:?? move to user prefs?
    defaults: {
        //TODO:?? expandedIds to array?
        expandedIds: {},
        show_deleted: false,
        show_hidden: false
    },

    /** add an hda id to the hash of expanded hdas */
    addExpanded: function addExpanded(model) {
        //TODO: use type_id and not model
        var current = this.get("expandedIds");
        current[model.id] = model.get("id");
        this.save("expandedIds", current);
    },

    /** remove an hda id from the hash of expanded hdas */
    removeExpanded: function removeExpanded(model) {
        var current = this.get("expandedIds");
        delete current[model.id];
        this.save("expandedIds", current);
    },

    isExpanded: function isExpanded(contentId) {
        return _.result(this.get("expandedIds"), contentId, false);
    },

    allExpanded: function allExpanded() {
        return _.values(this.get("expandedIds"));
    },

    clearExpanded: function clearExpanded() {
        this.set("expandedIds", {});
    },

    includeDeleted: function includeDeleted(val) {
        // moving the invocation here so other components don't need to know the key
        // TODO: change this key later
        if (!_.isUndefined(val)) {
            this.set("show_deleted", val);
        }
        return this.get("show_deleted");
    },

    includeHidden: function includeHidden(val) {
        // TODO: change this key later
        if (!_.isUndefined(val)) {
            this.set("show_hidden", val);
        }
        return this.get("show_hidden");
    },

    toString: function toString() {
        return "HistoryPrefs(" + this.id + ")";
    }
}, {
    // ........................................................................ class vars
    // class lvl for access w/o instantiation
    storageKeyPrefix: "history:",

    /** key string to store each histories settings under */
    historyStorageKey: function historyStorageKey(historyId) {
        if (!historyId) {
            throw new Error("HistoryPrefs.historyStorageKey needs valid id: " + historyId);
        }
        // single point of change
        return HistoryPrefs.storageKeyPrefix + historyId;
    },

    /** return the existing storage for the history with the given id (or create one if it doesn't exist) */
    get: function get(historyId) {
        return new HistoryPrefs({
            id: HistoryPrefs.historyStorageKey(historyId)
        });
    },

    /** clear all history related items in sessionStorage */
    clearAll: function clearAll(historyId) {
        for (var key in sessionStorage) {
            if (key.indexOf(HistoryPrefs.storageKeyPrefix) === 0) {
                sessionStorage.removeItem(key);
            }
        }
    }
});

//==============================================================================
exports.default = {
    HistoryPrefs: HistoryPrefs
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

"use_strict";

var $ = _jquery2.default;

/** Multi 'mode' button (or any element really) that changes the html
 *      contents of itself when clicked. Pass in an ordered list of
 *      objects with 'html' and (optional) onclick functions.
 *
 *      When clicked in a particular node, the onclick function will
 *      be called (with the element as this) and the element will
 *      switch to the next mode, replacing its html content with
 *      that mode's html.
 *
 *      If there is no next mode, the element will switch back to
 *      the first mode.
 * @example:
 *     $( '.myElement' ).modeButton({
 *         modes : [
 *             {
 *                 mode: 'bler',
 *                 html: '<h5>Bler</h5>',
 *                 onclick : function(){
 *                     $( 'body' ).css( 'background-color', 'red' );
 *                 }
 *             },
 *             {
 *                 mode: 'bloo',
 *                 html: '<h4>Bloo</h4>',
 *                 onclick : function(){
 *                     $( 'body' ).css( 'background-color', 'blue' );
 *                 }
 *             },
 *             {
 *                 mode: 'blah',
 *                 html: '<h3>Blah</h3>',
 *                 onclick : function(){
 *                     $( 'body' ).css( 'background-color', 'grey' );
 *                 }
 *             },
 *         ]
 *     });
 *     $( '.myElement' ).modeButton( 'callModeFn', 'bler' );
 */
/** constructor */
function ModeButton(element, options) {
    this.currModeIndex = 0;
    return this._init(element, options);
}

/** html5 data key to store this object inside an element */
ModeButton.prototype.DATA_KEY = "mode-button";
/** default options */
ModeButton.prototype.defaults = {
    switchModesOnClick: true
};

// ---- private interface
/** set up options, intial mode, and the click handler */
ModeButton.prototype._init = function _init(element, options) {
    //console.debug( 'ModeButton._init:', element, options );
    options = options || {};
    this.$element = $(element);
    this.options = $.extend(true, {}, this.defaults, options);
    if (!options.modes) {
        throw new Error('ModeButton requires a "modes" array');
    }

    var modeButton = this;
    this.$element.click(function _ModeButtonClick(event) {
        // call the curr mode fn
        modeButton.callModeFn();
        // inc the curr mode index
        if (modeButton.options.switchModesOnClick) {
            modeButton._incModeIndex();
        }
        // set the element html
        $(this).html(modeButton.options.modes[modeButton.currModeIndex].html);
    });
    return this.reset();
};
/** increment the mode index to the next in the array, looping back to zero if at the last */
ModeButton.prototype._incModeIndex = function _incModeIndex() {
    this.currModeIndex += 1;
    if (this.currModeIndex >= this.options.modes.length) {
        this.currModeIndex = 0;
    }
    return this;
};
/** get the mode index in the modes array for the given key (mode name) */
ModeButton.prototype._getModeIndex = function _getModeIndex(modeKey) {
    for (var i = 0; i < this.options.modes.length; i += 1) {
        if (this.options.modes[i].mode === modeKey) {
            return i;
        }
    }
    throw new Error("mode not found: " + modeKey);
};
/** set the current mode to the one with the given index and set button html */
ModeButton.prototype._setModeByIndex = function _setModeByIndex(index) {
    var newMode = this.options.modes[index];
    if (!newMode) {
        throw new Error("mode index not found: " + index);
    }
    this.currModeIndex = index;
    if (newMode.html) {
        this.$element.html(newMode.html);
    }
    return this;
};

// ---- public interface
/** get the current mode object (not just the mode name) */
ModeButton.prototype.currentMode = function currentMode() {
    return this.options.modes[this.currModeIndex];
};
/** return the mode key of the current mode */
ModeButton.prototype.current = function current() {
    // sugar for returning mode name
    return this.currentMode().mode;
};
/** get the mode with the given modeKey or the current mode if modeKey is undefined */
ModeButton.prototype.getMode = function getMode(modeKey) {
    if (!modeKey) {
        return this.currentMode();
    }
    return this.options.modes[this._getModeIndex(modeKey)];
};
/** T/F if the button has the given mode */
ModeButton.prototype.hasMode = function hasMode(modeKey) {
    try {
        return !!this.getMode(modeKey);
    } catch (err) {}
    return false;
};
/** set the current mode to the mode with the given name */
ModeButton.prototype.setMode = function setMode(modeKey) {
    return this._setModeByIndex(this._getModeIndex(modeKey));
};
/** reset to the initial mode */
ModeButton.prototype.reset = function reset() {
    this.currModeIndex = 0;
    if (this.options.initialMode) {
        this.currModeIndex = this._getModeIndex(this.options.initialMode);
    }
    return this._setModeByIndex(this.currModeIndex);
};
/** manually call the click handler of the given mode */
ModeButton.prototype.callModeFn = function callModeFn(modeKey) {
    var modeFn = this.getMode(modeKey).onclick;
    if (modeFn && $.type(modeFn === "function")) {
        // call with the element as context (std jquery pattern)
        return modeFn.call(this.$element.get(0));
    }
    return undefined;
};

// as jq plugin
$.fn.modeButton = function $modeButton(options) {
    if (!this.length) {
        return this;
    }

    //TODO: does map still work with jq multi selection (i.e. $( '.class-for-many-btns' ).modeButton)?
    if ($.type(options) === "object") {
        return this.map(function () {
            var $this = $(this);
            $this.data("mode-button", new ModeButton($this, options));
            return this;
        });
    }

    var $first = $(this[0]);
    var button = $first.data("mode-button");

    if (!button) {
        throw new Error("modeButton needs an options object or string name of a function");
    }

    if (button && $.type(options) === "string") {
        var fnName = options;
        if (button && $.type(button[fnName]) === "function") {
            return button[fnName].apply(button, $.makeArray(arguments).slice(1));
        }
    }
    return button;
};

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _underscore = __webpack_require__(1);

var _ = _interopRequireWildcard(_underscore);

var _hdcaLi = __webpack_require__(171);

var _hdcaLi2 = _interopRequireDefault(_hdcaLi);

var _collectionViewEdit = __webpack_require__(238);

var _collectionViewEdit2 = _interopRequireDefault(_collectionViewEdit);

var _localization = __webpack_require__(3);

var _localization2 = _interopRequireDefault(_localization);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/* global $ */

//==============================================================================
var _super = _hdcaLi2.default.HDCAListItemView;
/** @class Editing view for HistoryDatasetCollectionAssociation.
 */
var HDCAListItemEdit = _super.extend(
/** @lends HDCAListItemEdit.prototype */{
    /** logger used to record this.log messages, commonly set to console */
    //logger              : console,
    /** set up: options */
    initialize: function initialize(attributes) {
        _super.prototype.initialize.call(this, attributes);

        /** allow user purge of dataset files? */
        this.purgeAllowed = attributes.purgeAllowed || false;
    },

    /** Override to return editable versions of the collection panels */
    _getFoldoutPanelClass: function _getFoldoutPanelClass() {
        return _collectionViewEdit2.default.CollectionViewEdit;
    },

    // ......................................................................... delete
    /** In this override, add the delete button. */
    _renderPrimaryActions: function _renderPrimaryActions() {
        this.log(this + "._renderPrimaryActions");
        // render the display, edit attr and delete icon-buttons
        return _super.prototype._renderPrimaryActions.call(this).concat([this._renderDeleteButton()]);
    },

    _renderDeleteButton: function _renderDeleteButton() {
        return $("\n                <div class=\"dropdown\">\n                    <a class=\"delete-btn icon-btn\" title=\"" + (0, _localization2.default)("Delete") + "\" data-toggle=\"dropdown\">\n                        <span class=\"fa fa-times\"></span>\n                    </a>\n                    <div class=\"dropdown-menu\" role=\"menu\">\n                            <a href=\"#\" class=\"dropdown-item delete-collection\">\n                                " + (0, _localization2.default)("Collection Only") + "\n                            </a>\n                            <a href=\"#\" class=\"dropdown-item delete-collection-and-datasets\">\n                                " + (0, _localization2.default)("Delete Datasets") + "\n                            </a>\n                            <a href=\"#\" style=\"display: " + (this.purgeAllowed ? "inherit" : "none") + "\" class=\"dropdown-item delete-collection-and-purge-datasets\">\n                                " + (0, _localization2.default)("Permanently Delete Datasets") + "\n                            </a>\n                    </div>\n                </div>");
    },

    // ......................................................................... misc
    events: _.extend(_.clone(_super.prototype.events), {
        "click .delete-collection": function clickDeleteCollection(ev) {
            this.model["delete"]();
        },
        "click .delete-collection-and-datasets": function clickDeleteCollectionAndDatasets(ev) {
            this.model["delete"](true);
        },
        "click .delete-collection-and-purge-datasets": function clickDeleteCollectionAndPurgeDatasets(ev) {
            this.model["delete"](true, true);
        }
    }),

    // ......................................................................... misc
    /** string rep */
    toString: function toString() {
        var modelString = this.model ? "" + this.model : "(no model)";
        return "HDCAListItemEdit(" + modelString + ")";
    }
});

//==============================================================================
exports.default = {
    HDCAListItemEdit: HDCAListItemEdit
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _collectionView = __webpack_require__(195);

var _collectionView2 = _interopRequireDefault(_collectionView);

var _collectionModel = __webpack_require__(189);

var _collectionModel2 = _interopRequireDefault(_collectionModel);

var _collectionLiEdit = __webpack_require__(239);

var _collectionLiEdit2 = _interopRequireDefault(_collectionLiEdit);

var _baseMvc = __webpack_require__(6);

var _baseMvc2 = _interopRequireDefault(_baseMvc);

var _tag = __webpack_require__(71);

var _tag2 = _interopRequireDefault(_tag);

var _faIconButton = __webpack_require__(53);

var _faIconButton2 = _interopRequireDefault(_faIconButton);

var _localization = __webpack_require__(3);

var _localization2 = _interopRequireDefault(_localization);

__webpack_require__(22);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* =============================================================================
TODO:

============================================================================= */
/** @class editable View/Controller for a dataset collection.
 */
var _super = _collectionView2.default.CollectionView;
var CollectionViewEdit = _super.extend(
/** @lends CollectionView.prototype */{
    //MODEL is either a DatasetCollection (or subclass) or a DatasetCollectionElement (list of pairs)

    /** logger used to record this.log messages, commonly set to console */
    //logger              : console,

    /** sub view class used for datasets */
    DatasetDCEViewClass: _collectionLiEdit2.default.DatasetDCEListItemEdit,
    /** sub view class used for nested collections */
    NestedDCDCEViewClass: _collectionLiEdit2.default.NestedDCDCEListItemEdit,

    getNestedDCDCEViewClass: function getNestedDCDCEViewClass() {
        return _collectionLiEdit2.default.NestedDCDCEListItemEdit.extend({
            foldoutPanelClass: CollectionViewEdit
        });
    },

    // ......................................................................... SET UP
    /** Set up the view, set up storage, bind listeners to HistoryContents events
     *  @param {Object} attributes optional settings for the panel
     */
    initialize: function initialize(attributes) {
        _super.prototype.initialize.call(this, attributes);
    },

    /** In this override, make the collection name editable
     */
    _setUpBehaviors: function _setUpBehaviors($where) {
        $where = $where || this.$el;
        _super.prototype._setUpBehaviors.call(this, $where);
        if (!this.model) {
            return;
        }

        // anon users shouldn't have access to any of the following
        if (!Galaxy.user || Galaxy.user.isAnonymous()) {
            return;
        }

        this.tagsEditorShown = true;

        //TODO: extract
        var panel = this;

        var nameSelector = "> .controls .name";
        $where.find(nameSelector).attr("title", (0, _localization2.default)("Click to rename collection")).tooltip({ placement: "bottom" }).make_text_editable({
            on_finish: function on_finish(newName) {
                var previousName = panel.model.get("name");
                if (newName && newName !== previousName) {
                    panel.$el.find(nameSelector).text(newName);
                    panel.model.save({ name: newName }).fail(function () {
                        panel.$el.find(nameSelector).text(panel.model.previous("name"));
                    });
                } else {
                    panel.$el.find(nameSelector).text(previousName);
                }
            }
        });
        this.tagsEditor = new _tag2.default.TagsEditor({
            model: this.model,
            el: $where.find(".tags-display"),
            onshowFirstTime: function onshowFirstTime() {
                this.render();
            },
            usePrompt: false
        });
        this.tagsEditor.toggle(true);
    },

    // ........................................................................ misc
    /** string rep */
    toString: function toString() {
        return "CollectionViewEdit(" + (this.model ? this.model.get("name") : "") + ")";
    }
});

//==============================================================================
exports.default = {
    CollectionViewEdit: CollectionViewEdit
};

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery, _) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _collectionLi = __webpack_require__(154);

var _collectionLi2 = _interopRequireDefault(_collectionLi);

var _datasetLiEdit = __webpack_require__(197);

var _datasetLiEdit2 = _interopRequireDefault(_datasetLiEdit);

var _baseMvc = __webpack_require__(6);

var _baseMvc2 = _interopRequireDefault(_baseMvc);

var _localization = __webpack_require__(3);

var _localization2 = _interopRequireDefault(_localization);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//==============================================================================
var DCListItemView = _collectionLi2.default.DCListItemView;
/** @class Edit view for DatasetCollection.
 */
var DCListItemEdit = DCListItemView.extend(
/** @lends DCListItemEdit.prototype */{
    /** override to add linkTarget */
    initialize: function initialize(attributes) {
        DCListItemView.prototype.initialize.call(this, attributes);
    },

    // ......................................................................... misc
    /** String representation */
    toString: function toString() {
        var modelString = this.model ? "" + this.model : "(no model)";
        return "DCListItemEdit(" + modelString + ")";
    }
});

//==============================================================================
var DCEListItemView = _collectionLi2.default.DCEListItemView;
/** @class Read only view for DatasetCollectionElement.
 */
var DCEListItemEdit = DCEListItemView.extend(
/** @lends DCEListItemEdit.prototype */{
    //TODO: this might be expendable - compacted with HDAListItemView

    /** set up */
    initialize: function initialize(attributes) {
        DCEListItemView.prototype.initialize.call(this, attributes);
    },

    // ......................................................................... misc
    /** String representation */
    toString: function toString() {
        var modelString = this.model ? "" + this.model : "(no model)";
        return "DCEListItemEdit(" + modelString + ")";
    }
});

//==============================================================================
// NOTE: this does not inherit from DatasetDCEListItemView as you would expect
//TODO: but should - if we can find something simpler than using diamond
/** @class Editable view for a DatasetCollectionElement that is also an DatasetAssociation
 *      (a dataset contained in a dataset collection).
 */
var DatasetDCEListItemEdit = _datasetLiEdit2.default.DatasetListItemEdit.extend(
/** @lends DatasetDCEListItemEdit.prototype */{
    /** set up */
    initialize: function initialize(attributes) {
        _datasetLiEdit2.default.DatasetListItemEdit.prototype.initialize.call(this, attributes);
    },

    // NOTE: this does not inherit from DatasetDCEListItemView - so we duplicate this here
    //TODO: fix
    /** In this override, only get details if in the ready state.
     *  Note: fetch with no 'change' event triggering to prevent automatic rendering.
     */
    _fetchModelDetails: function _fetchModelDetails() {
        var view = this;
        if (view.model.inReadyState() && !view.model.hasDetails()) {
            return view.model.fetch({ silent: true });
        }
        return jQuery.when();
    },

    /** Override to remove delete button */
    _renderDeleteButton: function _renderDeleteButton() {
        return null;
    },

    // ......................................................................... misc
    /** String representation */
    toString: function toString() {
        var modelString = this.model ? "" + this.model : "(no model)";
        return "DatasetDCEListItemEdit(" + modelString + ")";
    }
});

// ............................................................................ TEMPLATES
/** underscore templates */
DatasetDCEListItemEdit.prototype.templates = function () {
    return _.extend({}, _datasetLiEdit2.default.DatasetListItemEdit.prototype.templates, {
        titleBar: _collectionLi2.default.DatasetDCEListItemView.prototype.templates.titleBar
    });
}();

//==============================================================================
/** @class Read only view for a DatasetCollectionElement that is also a DatasetCollection
 *      (a nested DC).
 */
var NestedDCDCEListItemEdit = _collectionLi2.default.NestedDCDCEListItemView.extend(
/** @lends NestedDCDCEListItemEdit.prototype */{
    /** String representation */
    toString: function toString() {
        var modelString = this.model ? "" + this.model : "(no model)";
        return "NestedDCDCEListItemEdit(" + modelString + ")";
    }
});

//==============================================================================
exports.default = {
    DCListItemEdit: DCListItemEdit,
    DCEListItemEdit: DCEListItemEdit,
    DatasetDCEListItemEdit: DatasetDCEListItemEdit,
    NestedDCDCEListItemEdit: NestedDCDCEListItemEdit
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(1)))

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//=============================================================================
/**
(Imported for edit distance algorith. From: https://gist.github.com/andrei-m/982927)
Copyright (c) 2011 Andrei Mackenzie

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated
documentation files (the "Software"), to deal in the Software without restriction, including without limitation the
rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit
persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the
Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE
WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/
// Compute the edit distance between the two given strings
//exports.getEditDistance = function(a, b){
function levenshteinDistance(a, b) {
    if (a.length === 0) {
        return b.length;
    }
    if (b.length === 0) {
        return a.length;
    }

    var matrix = [];

    // increment along the first column of each row
    var i;
    for (i = 0; i <= b.length; i++) {
        matrix[i] = [i];
    }

    // increment each column in the first row
    var j;
    for (j = 0; j <= a.length; j++) {
        matrix[0][j] = j;
    }

    // Fill in the rest of the matrix
    for (i = 1; i <= b.length; i++) {
        for (j = 1; j <= a.length; j++) {
            if (b.charAt(i - 1) === a.charAt(j - 1)) {
                matrix[i][j] = matrix[i - 1][j - 1];
            } else {
                matrix[i][j] = Math.min(matrix[i - 1][j - 1] + 1, // substitution
                Math.min(matrix[i][j - 1] + 1, // insertion
                matrix[i - 1][j] + 1)); // deletion
            }
        }
    }

    //console.debug( '\t\t levenshteinDistance', a, b, matrix[b.length][a.length] );
    return matrix[b.length][a.length];
}

//=============================================================================
exports.default = levenshteinDistance;

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Backbone, $) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _formView = __webpack_require__(30);

var _formView2 = _interopRequireDefault(_formView);

var _uiMisc = __webpack_require__(11);

var _uiMisc2 = _interopRequireDefault(_uiMisc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** Generic form view */
var View = Backbone.View.extend({
    initialize: function initialize(options) {
        this.model = new Backbone.Model(options);
        this.url = this.model.get("url");
        this.redirect = this.model.get("redirect");
        if (options && options.active_tab) {
            this.active_tab = options.active_tab;
        }
        this.setElement("<div/>");
        this.render();
    },

    render: function render() {
        var self = this;
        $.ajax({
            url: Galaxy.root + this.url,
            type: "GET"
        }).done(function (response) {
            var options = $.extend({}, self.model.attributes, response);
            var form = new _formView2.default({
                title: options.title,
                title_id: options.title_id,
                message: options.message,
                status: options.status || "warning",
                icon: options.icon,
                initial_errors: true,
                errors: options.errors,
                inputs: options.inputs,
                buttons: {
                    submit: new _uiMisc2.default.Button({
                        tooltip: options.submit_tooltip,
                        title: options.submit_title || "Save",
                        icon: options.submit_icon || "fa-save",
                        cls: "btn btn-primary ui-clear-float",
                        onclick: function onclick() {
                            self._submit(form);
                        }
                    })
                }
            });
            self.$el.empty().append(form.$el);
        }).fail(function (response) {
            self.$el.empty().append(new _uiMisc2.default.Message({
                message: "Failed to load resource " + self.url + ".",
                status: "danger",
                persistent: true
            }).$el);
        });
    },

    _submit: function _submit(form) {
        var self = this;
        $.ajax({
            url: Galaxy.root + self.url,
            data: JSON.stringify(form.data.create()),
            type: "PUT",
            contentType: "application/json"
        }).done(function (response) {
            var params = {};
            if (response.id) {
                params.id = response.id;
            } else {
                params = {
                    message: response.message,
                    status: "success",
                    persistent: false
                };
            }
            if (self.redirect) {
                window.location = Galaxy.root + self.redirect + "?" + $.param(params);
            } else {
                form.data.matchModel(response, function (input, input_id) {
                    form.field_list[input_id].value(input.value);
                });
                self._showMessage(form, response.message);
            }
        }).fail(function (response) {
            self._showMessage(form, {
                message: response.responseJSON.err_msg,
                status: "danger",
                persistent: false
            });
        });
    },

    _showMessage: function _showMessage(form, options) {
        var $panel = form.$el.parents().filter(function () {
            return ["auto", "scroll"].indexOf($(this).css("overflow")) != -1;
        }).first();
        $panel.animate({ scrollTop: 0 }, 500);
        form.message.update(options);
    }
});

exports.default = {
    View: View
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(0)))

/***/ }),
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _backbone = __webpack_require__(7);

var Backbone = _interopRequireWildcard(_backbone);

var _underscore = __webpack_require__(1);

var _ = _interopRequireWildcard(_underscore);

var _localization = __webpack_require__(3);

var _localization2 = _interopRequireDefault(_localization);

var _utils = __webpack_require__(5);

var _utils2 = _interopRequireDefault(_utils);

var _deferred = __webpack_require__(162);

var _deferred2 = _interopRequireDefault(_deferred);

var _uiMisc = __webpack_require__(11);

var _uiMisc2 = _interopRequireDefault(_uiMisc);

var _formView = __webpack_require__(30);

var _formView2 = _interopRequireDefault(_formView);

var _formData = __webpack_require__(205);

var _formData2 = _interopRequireDefault(_formData);

var _toolFormBase = __webpack_require__(58);

var _toolFormBase2 = _interopRequireDefault(_toolFormBase);

var _uiModal = __webpack_require__(19);

var _uiModal2 = _interopRequireDefault(_uiModal);

var _webhooks = __webpack_require__(29);

var _webhooks2 = _interopRequireDefault(_webhooks);

var _workflowIcons = __webpack_require__(234);

var _workflowIcons2 = _interopRequireDefault(_workflowIcons);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/* global $ */
/* global Galaxy */

/** This is the run workflow tool form view. */
var View = Backbone.View.extend({
    initialize: function initialize(options) {
        this.modal = window.parent.Galaxy.modal || new _uiModal2.default.View();
        this.model = options && options.model || new Backbone.Model(options);
        this.deferred = new _deferred2.default();
        if (options && options.active_tab) {
            this.active_tab = options.active_tab;
        }
        this.setElement($("<div/>").addClass("ui-form-composite").append(this.$message = $("<div/>")).append(this.$header = $("<div/>")).append(this.$steps = $("<div/>")));
        $("body").append(this.$el);
        this._configure();
        this.render();
    },

    /** Configures form/step options for each workflow step */
    _configure: function _configure() {
        var self = this;
        this.forms = [];
        this.steps = [];
        this.links = [];
        this.parms = [];
        _.each(this.model.get("steps"), function (step, i) {
            Galaxy.emit.debug("tool-form-composite::initialize()", i + " : Preparing workflow step.");
            var icon = _workflowIcons2.default[step.step_type];
            var title = parseInt(i + 1) + ": " + (step.step_label || step.step_name);
            if (step.annotation) {
                title += " - " + step.annotation;
            }
            if (step.step_version) {
                title += " (Galaxy Version " + step.step_version + ")";
            }
            step = _utils2.default.merge({
                index: i,
                fixed_title: _.escape(title),
                icon: icon || "",
                help: null,
                citations: null,
                collapsible: true,
                collapsed: i > 0 && !self._isDataStep(step),
                sustain_version: true,
                sustain_repeats: true,
                sustain_conditionals: true,
                narrow: true,
                text_enable: "Edit",
                text_disable: "Undo",
                cls_enable: "fa fa-edit",
                cls_disable: "fa fa-undo",
                errors: step.messages,
                initial_errors: true,
                cls: "ui-portlet-narrow",
                hide_operations: true,
                needs_refresh: false,
                always_refresh: step.step_type != "tool"
            }, step);
            self.steps[i] = step;
            self.links[i] = [];
            self.parms[i] = {};
        });

        // build linear index of step input pairs
        _.each(this.steps, function (step, i) {
            _formData2.default.visitInputs(step.inputs, function (input, name) {
                self.parms[i][name] = input;
            });
        });

        // iterate through data input modules and collect linked sub steps
        _.each(this.steps, function (step, i) {
            _.each(step.output_connections, function (output_connection) {
                _.each(self.steps, function (sub_step, j) {
                    if (sub_step.step_index === output_connection.input_step_index) {
                        self.links[i].push(sub_step);
                    }
                });
            });
        });

        // convert all connected data inputs to hidden fields with proper labels,
        // and track the linked source step
        _.each(this.steps, function (step, i) {
            _.each(self.steps, function (sub_step, j) {
                var connections_by_name = {};
                _.each(step.output_connections, function (connection) {
                    if (sub_step.step_index === connection.input_step_index) {
                        connections_by_name[connection.input_name] = connection;
                    }
                });
                _.each(self.parms[j], function (input, name) {
                    var connection = connections_by_name[name];
                    if (connection) {
                        input.type = "hidden";
                        input.help = input.step_linked ? input.help + ", " : "";
                        input.help += "Output dataset '" + connection.output_name + "' from step " + (parseInt(i) + 1);
                        input.step_linked = input.step_linked || [];
                        input.step_linked.push({ index: step.index, step_type: step.step_type });
                    }
                });
            });
        });

        // identify and configure workflow parameters
        var wp_count = 0;
        this.wp_inputs = {};

        function _ensureWorkflowParameter(wp_name) {
            return self.wp_inputs[wp_name] = self.wp_inputs[wp_name] || {
                label: wp_name,
                name: wp_name,
                type: "text",
                color: "hsl( " + ++wp_count * 100 + ", 70%, 30% )",
                style: "ui-form-wp-source",
                links: []
            };
        }

        function _handleWorkflowParameter(value, callback) {
            var re = /\$\{(.+?)\}/g;
            var match;
            while (match = re.exec(String(value))) {
                var wp_name = match[1];
                callback(_ensureWorkflowParameter(wp_name));
            }
        }
        _.each(this.steps, function (step, i) {
            _.each(self.parms[i], function (input, name) {
                _handleWorkflowParameter(input.value, function (wp_input) {
                    wp_input.links.push(step);
                    input.wp_linked = true;
                    input.type = "text";
                    input.backdrop = true;
                    input.style = "ui-form-wp-target";
                });
            });
            _.each(step.replacement_parameters, function (wp_name) {
                _ensureWorkflowParameter(wp_name);
            });
        });

        // select fields are shown for dynamic fields if all putative data inputs are available,
        // or if an explicit reference is specified as data_ref and available
        _.each(this.steps, function (step, i) {
            if (step.step_type == "tool") {
                var data_resolved = true;
                _formData2.default.visitInputs(step.inputs, function (input, name, context) {
                    var is_runtime_value = input.value && input.value.__class__ == "RuntimeValue";
                    var is_data_input = ["data", "data_collection"].indexOf(input.type) != -1;
                    var data_ref = context[input.data_ref];
                    if (input.step_linked && !self._isDataStep(input.step_linked)) {
                        data_resolved = false;
                    }
                    if (input.options && (input.options.length == 0 && !data_resolved || input.wp_linked)) {
                        input.is_workflow = true;
                    }
                    if (data_ref) {
                        input.is_workflow = data_ref.step_linked && !self._isDataStep(data_ref.step_linked) || input.wp_linked;
                    }
                    if (is_data_input || input.value && input.value.__class__ == "RuntimeValue" && !input.step_linked) {
                        step.collapsed = false;
                    }
                    if (is_runtime_value) {
                        input.value = input.default_value;
                    }
                    input.flavor = "workflow";
                    if (!is_runtime_value && !is_data_input && input.type !== "hidden" && !input.wp_linked) {
                        if (input.optional || !_utils2.default.isEmpty(input.value) && input.value !== "") {
                            input.collapsible_value = input.value;
                            input.collapsible_preview = true;
                        }
                    }
                });
            }
        });
    },

    render: function render() {
        var self = this;
        this.deferred.reset();
        this._renderHeader();
        this._renderMessage();
        this._renderParameters();
        this._renderHistory();
        this._renderUseCachedJob();
        this._renderResourceParameters();
        _.each(this.steps, function (step) {
            self._renderStep(step);
        });
    },

    /** Render header */
    _renderHeader: function _renderHeader() {
        var self = this;
        this.execute_btn = new _uiMisc2.default.Button({
            icon: "fa-check",
            title: (0, _localization2.default)("Run workflow"),
            cls: "btn btn-primary",
            onclick: function onclick() {
                self._execute();
            }
        });
        this.$header.addClass("ui-form-header").empty().append(new _uiMisc2.default.Label({
            title: "Workflow: " + this.model.get("name")
        }).$el).append(this.execute_btn.$el);
    },

    /** Render message */
    _renderMessage: function _renderMessage() {
        this.$message.empty();
        if (this.model.get("has_upgrade_messages")) {
            this.$message.append(new _uiMisc2.default.Message({
                message: "Some tools in this workflow may have changed since it was last saved or some errors were found. The workflow may still run, but any new options will have default values. Please review the messages below to make a decision about whether the changes will affect your analysis.",
                status: "warning",
                persistent: true,
                fade: false
            }).$el);
        }
        var step_version_changes = this.model.get("step_version_changes");
        if (step_version_changes && step_version_changes.length > 0) {
            this.$message.append(new _uiMisc2.default.Message({
                message: "Some tools are being executed with different versions compared to those available when this workflow was last saved because the other versions are not or no longer available on this Galaxy instance. To upgrade your workflow and dismiss this message simply edit the workflow and re-save it.",
                status: "warning",
                persistent: true,
                fade: false
            }).$el);
        }
    },

    /** Render workflow parameters */
    _renderParameters: function _renderParameters() {
        var self = this;
        this.wp_form = null;
        if (!_.isEmpty(this.wp_inputs)) {
            this.wp_form = new _formView2.default({
                title: "<b>Workflow Parameters</b>",
                inputs: this.wp_inputs,
                cls: "ui-portlet-narrow",
                onchange: function onchange() {
                    _.each(self.wp_form.input_list, function (input_def, i) {
                        _.each(input_def.links, function (step) {
                            self._refreshStep(step);
                        });
                    });
                }
            });
            this._append(this.$steps.empty(), this.wp_form.$el);
        }
    },

    /** Render workflow parameters */
    _renderHistory: function _renderHistory() {
        this.history_form = new _formView2.default({
            cls: "ui-portlet-narrow",
            title: "<b>History Options</b>",
            inputs: [{
                type: "conditional",
                name: "new_history",
                test_param: {
                    name: "check",
                    label: "Send results to a new history",
                    type: "boolean",
                    value: "false",
                    help: ""
                },
                cases: [{
                    value: "true",
                    inputs: [{
                        name: "name",
                        label: "History name",
                        type: "text",
                        value: this.model.get("name")
                    }]
                }]
            }]
        });
        this._append(this.$steps, this.history_form.$el);
    },

    /** Render Workflow Options */
    _renderResourceParameters: function _renderResourceParameters() {
        this.workflow_resource_parameters_form = null;
        if (!_.isEmpty(this.model.get("workflow_resource_parameters"))) {
            this.workflow_resource_parameters_form = new _formView2.default({
                cls: "ui-portlet-narrow",
                title: "<b>Workflow Resource Options</b>",
                inputs: this.model.get("workflow_resource_parameters")
            });
            this._append(this.$steps, this.workflow_resource_parameters_form.$el);
        }
    },

    /** Render job caching option */
    _renderUseCachedJob: function _renderUseCachedJob() {
        var extra_user_preferences = {};
        if (Galaxy.user.attributes.preferences && "extra_user_preferences" in Galaxy.user.attributes.preferences) {
            extra_user_preferences = JSON.parse(Galaxy.user.attributes.preferences.extra_user_preferences);
        }
        var display_use_cached_job_checkbox = "use_cached_job|use_cached_job_checkbox" in extra_user_preferences ? extra_user_preferences["use_cached_job|use_cached_job_checkbox"] : false;
        this.display_use_cached_job_checkbox = display_use_cached_job_checkbox === "true";
        if (this.display_use_cached_job_checkbox) {
            this.job_options_form = new _formView2.default({
                cls: "ui-portlet-narrow",
                title: "<b>Job re-use Options</b>",
                inputs: [{
                    type: "conditional",
                    name: "use_cached_job",
                    test_param: {
                        name: "check",
                        label: "BETA: Attempt to reuse jobs with identical parameters?",
                        type: "boolean",
                        value: "false",
                        help: "This may skip executing jobs that you have already run."
                    }
                }]
            });
            this._append(this.$steps, this.job_options_form.$el);
        }
    },

    /** Render step */
    _renderStep: function _renderStep(step) {
        var self = this;
        var form = null;
        this.deferred.execute(function (promise) {
            self.$steps.addClass("ui-steps");
            if (step.step_type == "tool") {
                step.postchange = function (process, form) {
                    var current_state = {
                        tool_id: step.id,
                        tool_version: step.version,
                        inputs: $.extend(true, {}, form.data.create())
                    };
                    form.wait(true);
                    Galaxy.emit.debug("tool-form-composite::postchange()", "Sending current state.", current_state);
                    _utils2.default.request({
                        type: "POST",
                        url: Galaxy.root + "api/tools/" + step.id + "/build",
                        data: current_state,
                        success: function success(data) {
                            form.update(data);
                            form.wait(false);
                            Galaxy.emit.debug("tool-form-composite::postchange()", "Received new model.", data);
                            process.resolve();
                        },
                        error: function error(response) {
                            Galaxy.emit.debug("tool-form-composite::postchange()", "Refresh request failed.", response);
                            process.reject();
                        }
                    });
                };
                form = new _toolFormBase2.default(step);
                if (step.post_job_actions && step.post_job_actions.length) {
                    form.portlet.append($("<div/>").addClass("ui-form-element-disabled").append($("<div/>").addClass("ui-form-title").html("<b>Job Post Actions</b>")).append($("<div/>").addClass("ui-form-preview").html(_.reduce(step.post_job_actions, function (memo, value) {
                        return memo + " " + value.short_str;
                    }, ""))));
                }
            } else {
                var is_simple_input = ["data_input", "data_collection_input"].indexOf(step.step_type) != -1;
                _.each(step.inputs, function (input) {
                    input.flavor = "module";
                    input.hide_label = is_simple_input;
                });
                form = new _formView2.default(_utils2.default.merge({
                    title: step.fixed_title,
                    onchange: function onchange() {
                        _.each(self.links[step.index], function (link) {
                            self._refreshStep(link);
                        });
                    },
                    inputs: step.inputs && step.inputs.length > 0 ? step.inputs : [{
                        type: "hidden",
                        name: "No options available.",
                        ignore: null
                    }]
                }, step));
                if (step.step_label) {
                    form.$el.attr("step-label", step.step_label);
                }
            }
            self.forms[step.index] = form;
            self._append(self.$steps, form.$el);
            if (step.needs_refresh) {
                self._refreshStep(step);
            }
            form.portlet[!self.show_progress ? "enable" : "disable"]();
            if (self.show_progress) {
                self.execute_btn.model.set({
                    wait: true,
                    wait_text: "Preparing...",
                    percentage: (step.index + 1) * 100.0 / self.steps.length
                });
            }
            Galaxy.emit.debug("tool-form-composite::initialize()", step.index + " : Workflow step state ready.", step);
            window.setTimeout(function () {
                promise.resolve();
            }, 0);
        });
    },

    /** Refreshes step values from source step values */
    _refreshStep: function _refreshStep(step) {
        var self = this;
        var form = this.forms[step.index];
        if (form) {
            _.each(self.parms[step.index], function (input, name) {
                if (input.step_linked || input.wp_linked) {
                    var field = form.field_list[form.data.match(name)];
                    if (field) {
                        var new_value;
                        if (input.step_linked) {
                            new_value = { values: [] };
                            _.each(input.step_linked, function (source_step) {
                                if (self._isDataStep(source_step)) {
                                    var value = self.forms[source_step.index].data.create().input;
                                    if (value) {
                                        _.each(value.values, function (v) {
                                            new_value.values.push(v);
                                        });
                                    }
                                }
                            });
                            if (!input.multiple && new_value.values.length > 0) {
                                new_value = {
                                    values: [new_value.values[0]]
                                };
                            }
                        } else if (input.wp_linked) {
                            new_value = input.value;
                            var re = /\$\{(.+?)\}/g;
                            var match;
                            while (match = re.exec(input.value)) {
                                var wp_field = self.wp_form.field_list[self.wp_form.data.match(match[1])];
                                var wp_value = wp_field && wp_field.value();
                                if (wp_value) {
                                    new_value = new_value.split(match[0]).join(wp_value);
                                }
                            }
                        }
                        if (new_value !== undefined) {
                            field.value(new_value);
                        }
                    }
                }
            });
            form.trigger("change");
        } else {
            step.needs_refresh = true;
        }
    },

    /** Refresh the history after job submission while form is shown */
    _refreshHistory: function _refreshHistory() {
        var self = this;
        var history = window.parent.Galaxy && window.parent.Galaxy.currHistoryPanel && window.parent.Galaxy.currHistoryPanel.model;
        if (this._refresh_history) {
            window.clearTimeout(this._refresh_history);
        }
        if (history) {
            history.refresh().success(function () {
                if (history.numOfUnfinishedShownContents() === 0) {
                    self._refresh_history = window.setTimeout(function () {
                        self._refreshHistory();
                    }, history.UPDATE_DELAY);
                }
            });
        }
    },

    /** Build remaining steps */
    _execute: function _execute() {
        var self = this;
        this.show_progress = true;
        this._enabled(false);
        this.deferred.execute(function (promise) {
            window.setTimeout(function () {
                promise.resolve();
                self._submit();
            }, 0);
        });
    },

    /** Validate and submit workflow */
    _submit: function _submit() {
        var self = this;
        var history_form_data = this.history_form.data.create();
        var job_def = {
            new_history_name: history_form_data["new_history|name"] ? history_form_data["new_history|name"] : null,
            history_id: !history_form_data["new_history|name"] ? this.model.get("history_id") : null,
            resource_params: this.workflow_resource_parameters_form ? this.workflow_resource_parameters_form.data.create() : {},
            replacement_params: this.wp_form ? this.wp_form.data.create() : {},
            parameters: {},
            // Tool form will submit flat maps for each parameter
            // (e.g. "repeat_0|cond|param": "foo" instead of nested
            // data structures).
            parameters_normalized: true,
            // Tool form always wants a list of invocations back
            // so that inputs can be batched.
            batch: true
        };
        if (this.display_use_cached_job_checkbox) {
            job_def.use_cached_job = this.job_options_form.data.create()["use_cached_job|check"] === "true";
        }
        var validated = true;
        for (var i in this.forms) {
            var form = this.forms[i];
            var job_inputs = form.data.create();
            var step = self.steps[i];
            var step_index = step.step_index;
            form.trigger("reset");
            for (var job_input_id in job_inputs) {
                var input_value = job_inputs[job_input_id];
                var input_id = form.data.match(job_input_id);
                var input_def = form.input_list[input_id];
                if (!input_def.step_linked) {
                    if (this._isDataStep(step)) {
                        validated = input_value && input_value.values && input_value.values.length > 0;
                    } else {
                        validated = input_def.optional || input_def.is_workflow && input_value !== "" || !input_def.is_workflow && input_value !== null;
                    }
                    if (!validated) {
                        form.highlight(input_id);
                        break;
                    }
                    job_def.parameters[step_index] = job_def.parameters[step_index] || {};
                    job_def.parameters[step_index][job_input_id] = job_inputs[job_input_id];
                }
            }
            if (!validated) {
                break;
            }
        }
        if (!validated) {
            self._enabled(true);
            Galaxy.emit.debug("tool-form-composite::submit()", "Validation failed.", job_def);
        } else {
            Galaxy.emit.debug("tool-form-composite::submit()", "Validation complete.", job_def);
            _utils2.default.request({
                type: "POST",
                url: Galaxy.root + "api/workflows/" + this.model.id + "/invocations",
                data: job_def,
                success: function success(response) {
                    Galaxy.emit.debug("tool-form-composite::submit", "Submission successful.", response);
                    self.$el.children().hide();
                    self.$el.append(self._templateSuccess(response));

                    // Show Webhook if job is running
                    if ($.isArray(response) && response.length > 0) {
                        self.$el.append($("<div/>", { id: "webhook-view" }));
                        new _webhooks2.default.WebhookView({
                            type: "workflow",
                            toolId: job_def.tool_id,
                            toolVersion: job_def.tool_version
                        });
                    }

                    self._refreshHistory();
                },
                error: function error(response) {
                    Galaxy.emit.debug("tool-form-composite::submit", "Submission failed.", response);
                    var input_found = false;
                    if (response && response.err_data) {
                        for (var i in self.forms) {
                            var form = self.forms[i];
                            var step_related_errors = response.err_data[form.model.get("step_index")];
                            if (step_related_errors) {
                                var error_messages = form.data.matchResponse(step_related_errors);
                                for (var input_id in error_messages) {
                                    form.highlight(input_id, error_messages[input_id]);
                                    input_found = true;
                                    break;
                                }
                            }
                        }
                    }
                    if (!input_found) {
                        self.modal.show({
                            title: (0, _localization2.default)("Workflow submission failed"),
                            body: self._templateError(job_def, response && response.err_msg),
                            buttons: {
                                Close: function Close() {
                                    self.modal.hide();
                                }
                            }
                        });
                    }
                },
                complete: function complete() {
                    self._enabled(true);
                }
            });
        }
    },

    /** Append new dom to body */
    _append: function _append($container, $el) {
        $container.append("<p/>").append($el);
    },

    /** Set enabled/disabled state */
    _enabled: function _enabled(enabled) {
        this.execute_btn.model.set({
            wait: !enabled,
            wait_text: "Sending...",
            percentage: -1
        });
        if (this.wp_form) {
            this.wp_form.portlet[enabled ? "enable" : "disable"]();
        }
        if (this.history_form) {
            this.history_form.portlet[enabled ? "enable" : "disable"]();
        }
        _.each(this.forms, function (form) {
            if (form) {
                form.portlet[enabled ? "enable" : "disable"]();
            }
        });
    },

    /** Is data input module/step */
    _isDataStep: function _isDataStep(steps) {
        var lst = $.isArray(steps) ? steps : [steps];
        for (var i = 0; i < lst.length; i++) {
            var step = lst[i];
            if (!step || !step.step_type || !step.step_type.startsWith("data")) {
                return false;
            }
        }
        return true;
    },

    /** Templates */
    _templateSuccess: function _templateSuccess(response) {
        if ($.isArray(response) && response.length > 0) {
            var timesExecuted = "";
            // Default destination blurb, used for a single execution, same history.
            var destinationBlurb = "You can check the status of queued jobs and view the resulting data by refreshing the History pane, if this has not already happened automatically.";
            var newHistoryTarget = response[0].history_id && Galaxy.currHistoryPanel && Galaxy.currHistoryPanel.model.id != response[0].history_id || false;
            if (response.length > 1) {
                // Executed more than one time, build blurb but skip history link.
                timesExecuted = "<em> - " + response.length + " times</em>";
                if (newHistoryTarget) {
                    destinationBlurb = "This workflow will generate results in multiple histories.  You can observe progress in the <a href=\"" + Galaxy.root + "history/view_multiple\">history multi-view</a>.";
                }
            } else if (newHistoryTarget) {
                // Single execution, with a destination other than the
                // current history.  Present a link.
                destinationBlurb = "This workflow will generate results in a new history. <a href=\"" + Galaxy.root + "history/switch_to_history?hist_id=" + response[0].history_id + "\">Switch to that history now</a>.";
            }
            return $("\n                <div class=\"donemessagelarge\">\n                    <p>\n                        Successfully invoked workflow <b>" + _utils2.default.sanitize(this.model.get("name")) + "</b>" + timesExecuted + ".\n                    </p>\n                    <p>\n                        " + destinationBlurb + "\n                    </p>\n                </div>");
        } else {
            return this._templateError(response, "Invalid success response. No invocations found.");
        }
    },

    _templateError: function _templateError(response, err_msg) {
        return $("<div/>").addClass("errormessagelarge").append($("<p/>").text("The server could not complete the request. Please contact the Galaxy Team if this error persists. " + (JSON.stringify(err_msg) || ""))).append($("<pre/>").text(JSON.stringify(response, null, 4)));
    }
});
exports.default = {
    View: View
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Sharing_vue_vue_type_script_lang_js__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Sharing_vue_vue_type_script_lang_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Sharing_vue_vue_type_script_lang_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Sharing_vue_vue_type_script_lang_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Sharing_vue_vue_type_script_lang_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Sharing_vue_vue_type_script_lang_js___default.a); 

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _axios = __webpack_require__(21);

var _axios2 = _interopRequireDefault(_axios);

var _asyncSaveText = __webpack_require__(211);

var _asyncSaveText2 = _interopRequireDefault(_asyncSaveText);

var _vue = __webpack_require__(18);

var _vue2 = _interopRequireDefault(_vue);

var _bootstrapVue = __webpack_require__(76);

var _bootstrapVue2 = _interopRequireDefault(_bootstrapVue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

_vue2.default.use(_bootstrapVue2.default);

exports.default = {
    props: {
        id: {
            type: String,
            required: true
        },
        plural_name: {
            type: String,
            required: true
        },
        model_class: {
            type: String,
            required: true
        }
    },
    computed: {
        model_class_lc: function model_class_lc() {
            return this.model_class.toLowerCase();
        },
        plural_name_lc: function plural_name_lc() {
            return this.plural_name.toLowerCase();
        },
        item_status: function item_status() {
            return this.item.published ? "accessible via link and published" : "accessible via link";
        },
        item_url: function item_url() {
            return window.location.protocol + "//" + window.location.hostname + ":" + window.location.port + Galaxy.root + this.item.username_and_slug;
        },
        item_url_parts: function item_url_parts() {
            var str = this.item_url;
            var index = str.lastIndexOf("/");
            return [str.substring(0, index + 1), str.substring(index + 1)];
        },
        published_url: function published_url() {
            return "" + Galaxy.root + this.plural_name_lc + "/list_published";
        },
        share_url: function share_url() {
            return "" + Galaxy.root + this.model_class_lc + "/share/?id=" + this.id;
        },
        slug_url: function slug_url() {
            return "" + Galaxy.root + this.model_class_lc + "/set_slug_async/?id=" + this.id;
        },
        has_possible_members: function has_possible_members() {
            return ["history"].indexOf(this.model_class_lc) > -1;
        },
        show_danger: function show_danger() {
            return this.err_msg !== null;
        }
    },
    data: function data() {
        return {
            ready: false,
            has_username: Galaxy.user.get("username"),
            new_username: "",
            err_msg: null,
            pencil_url: Galaxy.root + "static/images/fugue/pencil.png",
            item: {
                title: "title",
                username_and_slug: "username_and_slug",
                importable: false,
                published: false,
                users_shared_with: []
            },
            share_fields: ["email", { key: "id", label: "" }],
            make_members_public: false
        };
    },

    created: function created() {
        this.getModel();
    },
    updated: function updated() {
        this.createSlugHandler();
    },
    methods: {
        getModel: function getModel() {
            var _this = this;

            this.ready = false;
            _axios2.default.get(Galaxy.root + "api/" + this.plural_name_lc + "/" + this.id + "/sharing").then(function (response) {
                _this.item = response.data;
                _this.ready = true;
            }).catch(function (error) {
                return _this.err_msg = error.response.data.err_msg;
            });
        },
        setUsername: function setUsername() {
            var _this2 = this;

            _axios2.default.put(Galaxy.root + "api/users/" + Galaxy.user.id + "/information/inputs", {
                username: this.new_username || ""
            }).then(function (response) {
                _this2.err_msg = null;
                _this2.has_username = true;
                _this2.getModel();
            }).catch(function (error) {
                return _this2.err_msg = error.response.data.err_msg;
            });
        },
        setSharing: function setSharing(action, user_id) {
            var _this3 = this;

            var data = {
                action: action,
                user_id: user_id
            };
            if (this.has_possible_members) {
                data.make_members_public = this.make_members_public;
            }
            _axios2.default.post(Galaxy.root + "api/" + this.plural_name_lc + "/" + this.id + "/sharing", data).then(function (response) {
                Object.assign(_this3.item, response.data);
                if (response.data.skipped) {
                    _this3.err_msg = "Some of the items within this object were not published due to an error.";
                }
            }).catch(function (error) {
                return _this3.err_msg = error.response.data.err_msg;
            });
        },
        createSlugHandler: function createSlugHandler() {
            var on_start = function on_start(text_elt) {
                // Replace URL with URL text.
                $("#item-url").hide();
                $("#item-url-text").show();

                // Allow only lowercase alphanumeric and '-' characters in slug.
                text_elt.keyup(function () {
                    text_elt.val($(this).val().replace(/\s+/g, "-").replace(/[^a-zA-Z0-9\-]/g, "").toLowerCase());
                });
            };
            var on_finish = function on_finish(text_elt) {
                // Replace URL text with URL.
                $("#item-url-text").hide();
                $("#item-url").show();

                // Set URL to new value.
                var new_url = $("#item-url-text").text();
                var item_url_obj = $("#item-url");
                item_url_obj.attr("href", new_url);
                item_url_obj.text(new_url);
            };
            (0, _asyncSaveText2.default)("edit-identifier", "item-identifier", this.slug_url, "new_slug", null, false, 0, on_start, on_finish);
        }
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(702);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(27)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../node_modules/vue-loader/lib/index.js?{\"loaders\":{\"js\":\"babel-loader\"}}!./Sharing.vue?vue&type=style&index=0&lang=css", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../node_modules/vue-loader/lib/index.js?{\"loaders\":{\"js\":\"babel-loader\"}}!./Sharing.vue?vue&type=style&index=0&lang=css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_WorkflowImport_vue_vue_type_script_lang_js__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_WorkflowImport_vue_vue_type_script_lang_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_WorkflowImport_vue_vue_type_script_lang_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_WorkflowImport_vue_vue_type_script_lang_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_WorkflowImport_vue_vue_type_script_lang_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_WorkflowImport_vue_vue_type_script_lang_js___default.a); 

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _axios = __webpack_require__(21);

var _axios2 = _interopRequireDefault(_axios);

var _vue = __webpack_require__(18);

var _vue2 = _interopRequireDefault(_vue);

var _bootstrapVue = __webpack_require__(76);

var _bootstrapVue2 = _interopRequireDefault(_bootstrapVue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_bootstrapVue2.default); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    data: function data() {
        return {
            sourceFile: null,
            sourceURL: null,
            errorMessage: null,
            myexperiment_target_url: "http://" + Galaxy.config.myexperiment_target_url + "/galaxy?galaxy_url=" + window.location.protocol + "//" + window.location.host
        };
    },

    computed: {
        hasErrorMessage: function hasErrorMessage() {
            return this.errorMessage != null;
        }
    },
    methods: {
        submit: function submit(ev) {
            var _this = this;

            ev.preventDefault();
            if (!this.sourceFile && !this.sourceURL) {
                this.errorMessage = "You must provide a workflow archive URL or file.";
            } else {
                var formData = new FormData();
                formData.append("archive_file", this.sourceFile);
                formData.append("archive_source", this.sourceURL);
                _axios2.default.post(Galaxy.root + "api/workflows", formData).then(function (response) {
                    window.location = Galaxy.root + "workflows/list?message=" + response.data.message + "&status=success";
                }).catch(function (error) {
                    var message = error.response.data && error.response.data.err_msg;
                    _this.errorMessage = message || "Import failed for unkown reason.";
                });
            }
        }
    }
};

/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_HistoryImport_vue_vue_type_script_lang_js__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_HistoryImport_vue_vue_type_script_lang_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_HistoryImport_vue_vue_type_script_lang_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_HistoryImport_vue_vue_type_script_lang_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_HistoryImport_vue_vue_type_script_lang_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_HistoryImport_vue_vue_type_script_lang_js___default.a); 

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _axios = __webpack_require__(21);

var _axios2 = _interopRequireDefault(_axios);

var _vue = __webpack_require__(18);

var _vue2 = _interopRequireDefault(_vue);

var _bootstrapVue = __webpack_require__(76);

var _bootstrapVue2 = _interopRequireDefault(_bootstrapVue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_bootstrapVue2.default); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    data: function data() {
        return {
            sourceFile: null,
            sourceURL: null,
            errorMessage: null
        };
    },

    computed: {
        hasErrorMessage: function hasErrorMessage() {
            return this.errorMessage != null;
        }
    },
    methods: {
        submit: function submit(ev) {
            var _this = this;

            ev.preventDefault();
            if (!this.sourceFile && !this.sourceURL) {
                this.errorMessage = "You must provide a history archive URL or file.";
            } else {
                var formData = new FormData();
                formData.append("archive_file", this.sourceFile);
                formData.append("archive_source", this.sourceURL);
                _axios2.default.post(Galaxy.root + "api/histories", formData).then(function (response) {
                    window.location = Galaxy.root + "histories/list?message=" + response.data.message + "&status=success";
                }).catch(function (error) {
                    var message = error.response.data && error.response.data.err_msg;
                    _this.errorMessage = message || "Import failed for unkown reason.";
                });
            }
        }
    }
};

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_HistoryView_vue_vue_type_script_lang_js__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_HistoryView_vue_vue_type_script_lang_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_HistoryView_vue_vue_type_script_lang_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_HistoryView_vue_vue_type_script_lang_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_HistoryView_vue_vue_type_script_lang_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_HistoryView_vue_vue_type_script_lang_js___default.a); 

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _axios = __webpack_require__(21);

var _axios2 = _interopRequireDefault(_axios);

var _vue = __webpack_require__(18);

var _vue2 = _interopRequireDefault(_vue);

var _DisplayStructured = __webpack_require__(427);

var _DisplayStructured2 = _interopRequireDefault(_DisplayStructured);

var _queryStringParsing = __webpack_require__(35);

var _queryStringParsing2 = _interopRequireDefault(_queryStringParsing);

var _historyView = __webpack_require__(166);

var _historyView2 = _interopRequireDefault(_historyView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        id: {
            type: String,
            required: true
        }
    },
    data: function data() {
        return {
            historyData: {},
            historyHistory: {},
            // TODO: Pick a standard messaging convention and use a child component for it here.
            errorMessages: []
        };
    },

    created: function created() {
        var url = Galaxy.root + "history/view/" + this.id;
        this.ajaxCall(url, this.updateHistoryView);
    },
    methods: {
        ajaxCall: function ajaxCall(url, callBack) {
            var _this = this;

            _axios2.default.get(url).then(function (response) {
                callBack(response);
            }).catch(function (e) {
                _this.showError("Error fetching histories -- reload the page to retry this request.  Please contact an administrator if the problem persists.", e);
            });
        },
        updateHistoryView: function updateHistoryView(response) {
            this.historyData = response.data;
            this.historyHistory = response.data.history;
        },
        showError: function showError(errorMsg, verbose) {
            console.error(verbose);
            this.errorMessages.push(errorMsg);
        },
        makeHistoryView: function makeHistoryView(history) {
            $(function () {
                var options = {
                    hasMasthead: history.use_panels ? "true" : "false",
                    userIsOwner: history.user_is_owner ? "true" : "false",
                    isCurrent: history.history_is_current ? "true" : "false",
                    historyJSON: history.history,
                    showDeletedJson: history.show_deleted,
                    showHiddenJson: history.show_hidden,
                    initialModeDeleted: history.show_deleted ? "showing_deleted" : "not_showing_deleted",
                    initialModeHidden: history.show_hidden ? "showing_hidden" : "not_showing_hidden",
                    allowUserDatasetPurge: history.allow_user_dataset_purge ? "true" : "false"
                };
                options.viewToUse = options.userIsOwner ? { location: "mvc/history/history-view-edit", className: "HistoryViewEdit" } : { location: "mvc/history/history-view", className: "HistoryView" };
                _historyView2.default.historyEntry(options);
            });
        },
        showStructure: function showStructure() {
            var displayStructureInstance = _vue2.default.extend(_DisplayStructured2.default),
                mountView = document.createElement("div");
            Galaxy.page.center.display(mountView);
            new displayStructureInstance({ propsData: { id: _queryStringParsing2.default.get("id") } }).$mount(mountView);
        },
        switchHistory: function switchHistory() {
            var url = Galaxy.root + "history/switch_to_history?hist_id=" + this.historyHistory["id"];
            this.ajaxCall(url, this.reloadPage);
        },
        reloadPage: function reloadPage() {
            window.location.reload();
        }
    },
    updated: function updated() {
        this.makeHistoryView(this.historyData);
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DisplayStructured_vue_vue_type_template_id_8893f368__ = __webpack_require__(718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DisplayStructured_vue_vue_type_script_lang_js__ = __webpack_require__(428);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__DisplayStructured_vue_vue_type_script_lang_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__DisplayStructured_vue_vue_type_script_lang_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DisplayStructured_vue_vue_type_style_index_0_lang_css__ = __webpack_require__(720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(17);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__DisplayStructured_vue_vue_type_script_lang_js__["default"],
  __WEBPACK_IMPORTED_MODULE_0__DisplayStructured_vue_vue_type_template_id_8893f368__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__DisplayStructured_vue_vue_type_template_id_8893f368__["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_DisplayStructured_vue_vue_type_script_lang_js__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_DisplayStructured_vue_vue_type_script_lang_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_DisplayStructured_vue_vue_type_script_lang_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_DisplayStructured_vue_vue_type_script_lang_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_DisplayStructured_vue_vue_type_script_lang_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_DisplayStructured_vue_vue_type_script_lang_js___default.a); 

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _axios = __webpack_require__(21);

var _axios2 = _interopRequireDefault(_axios);

var _hdaModel = __webpack_require__(152);

var _hdaModel2 = _interopRequireDefault(_hdaModel);

var _hdaLiEdit = __webpack_require__(196);

var _hdaLiEdit2 = _interopRequireDefault(_hdaLiEdit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        id: {
            type: String,
            required: false
        }
    },
    data: function data() {
        return {
            historyTemplate: "",
            historyJSON: {},
            // TODO: Error message standardization -- use bootstrap-vue component or the like.
            errorMessages: []
        };
    },

    created: function created() {
        var historyId = this.id,
            url = "";
        if (historyId !== undefined && historyId !== "" && historyId !== null) {
            url = Galaxy.root + "history/display_structured?id=" + historyId;
        } else {
            url = Galaxy.root + "history/display_structured";
        }
        this.ajaxCall(url);
    },
    methods: {
        ajaxCall: function ajaxCall(url) {
            var _this = this;

            _axios2.default.get(url).then(function (response) {
                _this._updateHistoryData(response);
            }).catch(function (e) {
                console.error(e);
                _this.errorMessages.push("Error fetching history data -- reload the page to retry this request.  Please contact an administrator if the problem persists.");
            });
        },
        _updateHistoryData: function _updateHistoryData(response) {
            var historyItems = response.data;
            this.historyTemplate = historyItems.template;
            this.historyJSON = historyItems.history_json;
        },
        makeHistoryView: function makeHistoryView(historyDict) {
            window.hdas = historyDict.map(function (hda) {
                return new _hdaLiEdit2.default.HDAListItemEdit({
                    model: new _hdaModel2.default.HistoryDatasetAssociation(hda),
                    el: $("#hda-" + hda.id),
                    linkTarget: "galaxy_main",
                    purgeAllowed: Galaxy.config.allow_user_dataset_purge,
                    logger: Galaxy.logger
                }).render(0);
            });
            // toggle the body section of each item in the structure
            $(function () {
                $(".workflow, .tool").each(function (index, element) {
                    var body = $(element).children(".body");
                    $(element).children(".header").click(function (e) {
                        body.toggle();
                    }).addClass("clickable");
                });
            });
        }
    },
    updated: function updated() {
        this.makeHistoryView(this.historyJSON);
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(721);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(27)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../node_modules/vue-loader/lib/index.js?{\"loaders\":{\"js\":\"babel-loader\"}}!./DisplayStructured.vue?vue&type=style&index=0&lang=css", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../node_modules/vue-loader/lib/index.js?{\"loaders\":{\"js\":\"babel-loader\"}}!./DisplayStructured.vue?vue&type=style&index=0&lang=css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(723);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(27)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../node_modules/vue-loader/lib/index.js?{\"loaders\":{\"js\":\"babel-loader\"}}!./HistoryView.vue?vue&type=style&index=0&lang=css", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../node_modules/vue-loader/lib/index.js?{\"loaders\":{\"js\":\"babel-loader\"}}!./HistoryView.vue?vue&type=style&index=0&lang=css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_PluginList_vue_vue_type_script_lang_js__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_PluginList_vue_vue_type_script_lang_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_PluginList_vue_vue_type_script_lang_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_PluginList_vue_vue_type_script_lang_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_PluginList_vue_vue_type_script_lang_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_PluginList_vue_vue_type_script_lang_js___default.a); 

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _axios = __webpack_require__(21);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            plugins: [],
            hdas: [],
            search: "",
            selected: null,
            name: null,
            error: null,
            fixed: false
        };
    },
    created: function created() {
        var _this = this;

        var url = Galaxy.root + "api/plugins";
        var dataset_id = Galaxy.params.dataset_id;
        if (dataset_id) {
            this.fixed = true;
            this.selected = dataset_id;
            url += "?dataset_id=" + dataset_id;
        }
        _axios2.default.get(url).then(function (response) {
            _this.plugins = response.data;
        }).catch(function (e) {
            _this.error = _this._errorMessage(e);
        });
    },

    methods: {
        select: function select(plugin) {
            var _this2 = this;

            if (this.fixed) {
                this.create(plugin);
            } else {
                var history_id = Galaxy.currHistoryPanel && Galaxy.currHistoryPanel.model.id;
                if (history_id) {
                    _axios2.default.get(Galaxy.root + "api/plugins/" + plugin.name + "?history_id=" + history_id).then(function (response) {
                        _this2.name = plugin.name;
                        _this2.hdas = response.data && response.data.hdas;
                        if (_this2.hdas && _this2.hdas.length > 0) {
                            _this2.selected = _this2.hdas[0].id;
                        }
                    }).catch(function (e) {
                        _this2.error = _this2._errorMessage(e);
                    });
                } else {
                    this.error = "This option requires an accessible history.";
                }
            }
        },
        create: function create(plugin) {
            var href = plugin.href + "?dataset_id=" + this.selected;
            if (plugin.target == "_top") {
                window.location.href = href;
            } else {
                $("#galaxy_main").attr("src", href);
            }
        },
        match: function match(plugin) {
            return !this.search || plugin.name.indexOf(this.search) != -1 || plugin.description && plugin.description.indexOf(this.search) != -1;
        },
        _errorMessage: function _errorMessage(e) {
            var message = e && e.response && e.response.data && e.response.data.err_msg;
            return message || "Request failed for unkown reason.";
        }
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

__webpack_require__(210);

var _underscore = __webpack_require__(1);

var _ = _interopRequireWildcard(_underscore);

var _decodeUriComponent = __webpack_require__(683);

var _decodeUriComponent2 = _interopRequireDefault(_decodeUriComponent);

var _galaxy = __webpack_require__(74);

var _galaxy2 = _interopRequireDefault(_galaxy);

var _router = __webpack_require__(230);

var _router2 = _interopRequireDefault(_router);

var _toolPanel = __webpack_require__(684);

var _toolPanel2 = _interopRequireDefault(_toolPanel);

var _historyPanel = __webpack_require__(695);

var _historyPanel2 = _interopRequireDefault(_historyPanel);

var _page = __webpack_require__(179);

var _page2 = _interopRequireDefault(_page);

var _toolForm = __webpack_require__(68);

var _toolForm2 = _interopRequireDefault(_toolForm);

var _formWrapper = __webpack_require__(241);

var _formWrapper2 = _interopRequireDefault(_formWrapper);

var _Sharing = __webpack_require__(698);

var _Sharing2 = _interopRequireDefault(_Sharing);

var _userPreferences = __webpack_require__(703);

var _userPreferences2 = _interopRequireDefault(_userPreferences);

var _userCustomBuilds = __webpack_require__(704);

var _userCustomBuilds2 = _interopRequireDefault(_userCustomBuilds);

var _tours = __webpack_require__(248);

var _tours2 = _interopRequireDefault(_tours);

var _gridView = __webpack_require__(28);

var _gridView2 = _interopRequireDefault(_gridView);

var _gridShared = __webpack_require__(706);

var _gridShared2 = _interopRequireDefault(_gridShared);

var _workflow = __webpack_require__(707);

var _workflow2 = _interopRequireDefault(_workflow);

var _WorkflowImport = __webpack_require__(709);

var _WorkflowImport2 = _interopRequireDefault(_WorkflowImport);

var _HistoryImport = __webpack_require__(712);

var _HistoryImport2 = _interopRequireDefault(_HistoryImport);

var _HistoryView = __webpack_require__(715);

var _HistoryView2 = _interopRequireDefault(_HistoryView);

var _historyList = __webpack_require__(724);

var _historyList2 = _interopRequireDefault(_historyList);

var _PluginList = __webpack_require__(725);

var _PluginList2 = _interopRequireDefault(_PluginList);

var _toolFormComposite = __webpack_require__(417);

var _toolFormComposite2 = _interopRequireDefault(_toolFormComposite);

var _queryStringParsing = __webpack_require__(35);

var _queryStringParsing2 = _interopRequireDefault(_queryStringParsing);

var _utils = __webpack_require__(5);

var _utils2 = _interopRequireDefault(_utils);

var _uiMisc = __webpack_require__(11);

var _uiMisc2 = _interopRequireDefault(_uiMisc);

var _datasetError = __webpack_require__(728);

var _datasetError2 = _interopRequireDefault(_datasetError);

var _datasetEditAttributes = __webpack_require__(729);

var _datasetEditAttributes2 = _interopRequireDefault(_datasetEditAttributes);

var _Citations = __webpack_require__(70);

var _Citations2 = _interopRequireDefault(_Citations);

var _DisplayStructured = __webpack_require__(427);

var _DisplayStructured2 = _interopRequireDefault(_DisplayStructured);

var _vue = __webpack_require__(18);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global Galaxy */

/** define the 'Analyze Data'/analysis/main/home page for Galaxy
 *  * has a masthead
 *  * a left tool menu to allow the user to load tools in the center panel
 *  * a right history menu that shows the user's current data
 *  * a center panel
 *  Both panels (generally) persist while the center panel shows any
 *  UI needed for the current step of an analysis, like:
 *      * tool forms to set tool parameters,
 *      * tables showing the contents of datasets
 *      * etc.
 */
window.app = function app(options, bootstrapped) {
    window.Galaxy = new _galaxy2.default.GalaxyApp(options, bootstrapped);
    Galaxy.debug("analysis app");

    /** Routes */
    var AnalysisRouter = _router2.default.extend({
        routes: {
            "(/)": "home",
            "(/)root*": "home",
            "(/)tours(/)(:tour_id)": "show_tours",
            "(/)user(/)": "show_user",
            "(/)user(/)(:form_id)": "show_user_form",
            "(/)openids(/)list": "show_openids",
            "(/)pages(/)create(/)": "show_pages_create",
            "(/)pages(/)edit(/)": "show_pages_edit",
            "(/)pages(/)sharing(/)": "show_pages_sharing",
            "(/)pages(/)(:action_id)": "show_pages",
            "(/)visualizations(/)": "show_plugins",
            "(/)visualizations(/)edit(/)": "show_visualizations_edit",
            "(/)visualizations(/)sharing(/)": "show_visualizations_sharing",
            "(/)visualizations/(:action_id)": "show_visualizations",
            "(/)workflows/import": "show_workflows_import",
            "(/)workflows/run(/)": "show_workflows_run",
            "(/)workflows(/)list": "show_workflows",
            "(/)workflows/list_published(/)": "show_workflows_published",
            "(/)workflows/create(/)": "show_workflows_create",
            "(/)histories(/)citations(/)": "show_history_citations",
            "(/)histories(/)rename(/)": "show_histories_rename",
            "(/)histories(/)sharing(/)": "show_histories_sharing",
            "(/)histories(/)import(/)": "show_histories_import",
            "(/)histories(/)permissions(/)": "show_histories_permissions",
            "(/)histories/view": "show_history_view",
            "(/)histories/show_structure": "show_history_structure",
            "(/)histories(/)(:action_id)": "show_histories",
            "(/)datasets(/)list(/)": "show_datasets",
            "(/)custom_builds": "show_custom_builds",
            "(/)datasets/edit": "show_dataset_edit_attributes",
            "(/)datasets/error": "show_dataset_error"
        },

        require_login: ["show_user", "show_user_form", "show_workflows"],

        authenticate: function authenticate(args, name) {
            return Galaxy.user && Galaxy.user.id || this.require_login.indexOf(name) == -1;
        },

        show_tours: function show_tours(tour_id) {
            if (tour_id) {
                _tours2.default.giveTourById(tour_id);
            } else {
                this.page.display(new _tours2.default.ToursView());
            }
        },

        show_user: function show_user() {
            this.page.display(new _userPreferences2.default.View());
        },

        show_user_form: function show_user_form(form_id) {
            var model = new _userPreferences2.default.Model({
                user_id: Galaxy.params.id
            });
            this.page.display(new _formWrapper2.default.View(_.extend(model.get(form_id), { active_tab: "user" })));
        },

        show_visualizations: function show_visualizations(action_id) {
            var activeTab = action_id == "list_published" ? "shared" : "user";
            this.page.display(new _gridShared2.default.View({
                action_id: action_id,
                plural: "Visualizations",
                item: "visualization",
                active_tab: activeTab
            }));
        },

        show_visualizations_edit: function show_visualizations_edit() {
            this.page.display(new _formWrapper2.default.View({
                url: "visualization/edit?id=" + _queryStringParsing2.default.get("id"),
                redirect: "visualizations/list",
                active_tab: "visualization"
            }));
        },

        show_visualizations_sharing: function show_visualizations_sharing() {
            var sharingInstance = _vue2.default.extend(_Sharing2.default);
            var vm = document.createElement("div");
            this.page.display(vm);
            new sharingInstance({
                propsData: {
                    id: _queryStringParsing2.default.get("id"),
                    plural_name: "Visualizations",
                    model_class: "Visualization"
                }
            }).$mount(vm);
        },

        show_workflows_published: function show_workflows_published() {
            this.page.display(new _gridView2.default({
                url_base: Galaxy.root + "workflow/list_published",
                active_tab: "shared"
            }));
        },

        show_history_view: function show_history_view() {
            var historyInstance = _vue2.default.extend(_HistoryView2.default);
            var vm = document.createElement("div");
            this.page.display(vm);
            new historyInstance({ propsData: { id: _queryStringParsing2.default.get("id") } }).$mount(vm);
        },

        show_history_structure: function show_history_structure() {
            var displayStructureInstance = _vue2.default.extend(_DisplayStructured2.default);
            var vm = document.createElement("div");
            this.page.display(vm);
            new displayStructureInstance({ propsData: { id: _queryStringParsing2.default.get(" id: ") } }).$mount(vm);
        },

        show_histories: function show_histories(action_id) {
            this.page.display(new _historyList2.default.View({ action_id: action_id }));
        },

        show_history_citations: function show_history_citations() {
            var citationInstance = _vue2.default.extend(_Citations2.default);
            var vm = document.createElement("div");
            this.page.display(vm);
            new citationInstance({ propsData: { id: _queryStringParsing2.default.get("id"), source: "histories" } }).$mount(vm);
        },

        show_histories_rename: function show_histories_rename() {
            this.page.display(new _formWrapper2.default.View({
                url: "history/rename?id=" + _queryStringParsing2.default.get("id"),
                redirect: "histories/list"
            }));
        },

        show_histories_sharing: function show_histories_sharing() {
            var sharingInstance = _vue2.default.extend(_Sharing2.default);
            var vm = document.createElement("div");
            this.page.display(vm);
            new sharingInstance({
                propsData: {
                    id: _queryStringParsing2.default.get("id"),
                    plural_name: "Histories",
                    model_class: "History"
                }
            }).$mount(vm);
        },

        show_histories_import: function show_histories_import() {
            var historyImportInstance = _vue2.default.extend(_HistoryImport2.default);
            var vm = document.createElement("div");
            this.page.display(vm);
            new historyImportInstance().$mount(vm);
        },

        show_histories_permissions: function show_histories_permissions() {
            this.page.display(new _formWrapper2.default.View({
                url: "history/permissions?id=" + _queryStringParsing2.default.get("id"),
                redirect: "histories/list"
            }));
        },

        show_openids: function show_openids() {
            this.page.display(new _gridView2.default({
                url_base: Galaxy.root + "user/openids_list",
                active_tab: "user"
            }));
        },

        show_datasets: function show_datasets() {
            this.page.display(new _gridView2.default({
                url_base: Galaxy.root + "dataset/list",
                active_tab: "user"
            }));
        },

        show_pages: function show_pages(action_id) {
            var activeTab = action_id == "list_published" ? "shared" : "user";
            this.page.display(new _gridShared2.default.View({
                action_id: action_id,
                plural: "Pages",
                item: "page",
                active_tab: activeTab
            }));
        },

        show_pages_create: function show_pages_create() {
            this.page.display(new _formWrapper2.default.View({
                url: "page/create",
                redirect: "pages/list",
                active_tab: "user"
            }));
        },

        show_pages_edit: function show_pages_edit() {
            this.page.display(new _formWrapper2.default.View({
                url: "page/edit?id=" + _queryStringParsing2.default.get("id"),
                redirect: "pages/list",
                active_tab: "user"
            }));
        },

        show_pages_sharing: function show_pages_sharing() {
            var sharingInstance = _vue2.default.extend(_Sharing2.default);
            var vm = document.createElement("div");
            this.page.display(vm);
            new sharingInstance({
                propsData: {
                    id: _queryStringParsing2.default.get("id"),
                    plural_name: "Pages",
                    model_class: "Page"
                }
            }).$mount(vm);
        },

        show_plugins: function show_plugins() {
            var pluginListInstance = _vue2.default.extend(_PluginList2.default);
            var vm = document.createElement("div");
            this.page.display(vm);
            new pluginListInstance().$mount(vm);
        },

        show_workflows: function show_workflows() {
            this.page.display(new _workflow2.default.View());
        },

        show_workflows_create: function show_workflows_create() {
            this.page.display(new _formWrapper2.default.View({
                url: "workflow/create",
                redirect: "workflow/editor",
                active_tab: "workflow"
            }));
        },

        show_workflows_run: function show_workflows_run() {
            this._loadWorkflow();
        },

        show_workflows_import: function show_workflows_import() {
            var workflowImportInstance = _vue2.default.extend(_WorkflowImport2.default);
            var vm = document.createElement("div");
            this.page.display(vm);
            new workflowImportInstance().$mount(vm);
        },

        show_custom_builds: function show_custom_builds() {
            var _this = this;

            var historyPanel = this.page.historyPanel.historyView;
            if (!historyPanel || !historyPanel.model || !historyPanel.model.id) {
                window.setTimeout(function () {
                    _this.show_custom_builds();
                }, 500);
                return;
            }
            this.page.display(new _userCustomBuilds2.default.View());
        },

        show_dataset_edit_attributes: function show_dataset_edit_attributes() {
            this.page.display(new _datasetEditAttributes2.default.View());
        },

        show_dataset_error: function show_dataset_error() {
            this.page.display(new _datasetError2.default.View());
        },

        /**  */
        home: function home(params) {
            // TODO: to router, remove Globals
            // load a tool by id (tool_id) or rerun a previous tool execution (job_id)
            if (params.tool_id || params.job_id) {
                if (params.tool_id === "upload1") {
                    this.page.toolPanel.upload.show();
                    this._loadCenterIframe("welcome");
                } else {
                    this._loadToolForm(params);
                }
            } else {
                // show the workflow run form
                if (params.workflow_id) {
                    this._loadWorkflow();
                    // load the center iframe with controller.action: galaxy.org/?m_c=history&m_a=list -> history/list
                } else if (params.m_c) {
                    this._loadCenterIframe(params.m_c + "/" + params.m_a);
                    // show the workflow run form
                } else {
                    this._loadCenterIframe("welcome");
                }
            }
        },

        /** load the center panel with a tool form described by the given params obj */
        _loadToolForm: function _loadToolForm(params) {
            //TODO: load tool form code async
            if (params.tool_id) {
                params.id = (0, _decodeUriComponent2.default)(params.tool_id);
            }
            if (params.version) {
                params.version = (0, _decodeUriComponent2.default)(params.version);
            }
            this.page.display(new _toolForm2.default.View(params));
        },

        /** load the center panel iframe using the given url */
        _loadCenterIframe: function _loadCenterIframe(url, root) {
            root = root || Galaxy.root;
            url = root + url;
            this.page.$("#galaxy_main").prop("src", url);
        },

        /** load workflow by its url in run mode */
        _loadWorkflow: function _loadWorkflow() {
            var _this2 = this;

            _utils2.default.get({
                url: Galaxy.root + "api/workflows/" + _utils2.default.getQueryString("id") + "/download?style=run",
                success: function success(response) {
                    _this2.page.display(new _toolFormComposite2.default.View(_.extend(response, { active_tab: "workflow" })));
                },
                error: function error(response) {
                    var error_msg = response.err_msg || "Error occurred while loading the resource.";
                    var options = {
                        message: error_msg,
                        status: "danger",
                        persistent: true,
                        active_tab: "workflow"
                    };
                    _this2.page.display(new _uiMisc2.default.Message(options));
                }
            });
        }
    });

    // render and start the router
    (0, _jquery2.default)(function () {
        options.config = _.extend(options.config, {
            hide_panels: Galaxy.params.hide_panels,
            hide_masthead: Galaxy.params.hide_masthead
        });
        Galaxy.page = new _page2.default.View(_.extend(options, {
            Left: _toolPanel2.default,
            Right: _historyPanel2.default,
            Router: AnalysisRouter
        }));
    });
};

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var token = '%[a-f0-9]{2}';
var singleMatcher = new RegExp(token, 'gi');
var multiMatcher = new RegExp('(' + token + ')+', 'gi');

function decodeComponents(components, split) {
	try {
		// Try to decode the entire string first
		return decodeURIComponent(components.join(''));
	} catch (err) {
		// Do nothing
	}

	if (components.length === 1) {
		return components;
	}

	split = split || 1;

	// Split the array in 2 parts
	var left = components.slice(0, split);
	var right = components.slice(split);

	return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
}

function decode(input) {
	try {
		return decodeURIComponent(input);
	} catch (err) {
		var tokens = input.match(singleMatcher);

		for (var i = 1; i < tokens.length; i++) {
			input = decodeComponents(tokens, i).join('');

			tokens = input.match(singleMatcher);
		}

		return input;
	}
}

function customDecodeURIComponent(input) {
	// Keep track of all the replacements and prefill the map with the `BOM`
	var replaceMap = {
		'%FE%FF': '\uFFFD\uFFFD',
		'%FF%FE': '\uFFFD\uFFFD'
	};

	var match = multiMatcher.exec(input);
	while (match) {
		try {
			// Decode as big chunks as possible
			replaceMap[match[0]] = decodeURIComponent(match[0]);
		} catch (err) {
			var result = decode(match[0]);

			if (result !== match[0]) {
				replaceMap[match[0]] = result;
			}
		}

		match = multiMatcher.exec(input);
	}

	// Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
	replaceMap['%C2'] = '\uFFFD';

	var entries = Object.keys(replaceMap);

	for (var i = 0; i < entries.length; i++) {
		// Replace all decoded components
		var key = entries[i];
		input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
	}

	return input;
}

module.exports = function (encodedURI) {
	if (typeof encodedURI !== 'string') {
		throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
	}

	try {
		encodedURI = encodedURI.replace(/\+/g, ' ');

		// Try the built in decoder first
		return decodeURIComponent(encodedURI);
	} catch (err) {
		// Fallback to a more advanced decoder
		return customDecodeURIComponent(encodedURI);
	}
};


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Backbone) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _tools = __webpack_require__(57);

var _tools2 = _interopRequireDefault(_tools);

var _uploadView = __webpack_require__(685);

var _uploadView2 = _interopRequireDefault(_uploadView);

var _localization = __webpack_require__(3);

var _localization2 = _interopRequireDefault(_localization);

var _toolFormComposite = __webpack_require__(417);

var _toolFormComposite2 = _interopRequireDefault(_toolFormComposite);

var _underscore = __webpack_require__(1);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ToolPanel = Backbone.View.extend({
    initialize: function initialize(page, options) {
        // access configuration options
        var config = options.config;
        this.root = options.root;

        /** @type {Object[]} descriptions of user's workflows to be shown in the tool menu */
        this.stored_workflow_menu_entries = config.stored_workflow_menu_entries || [];

        // create tool search, tool panel, and tool panel view.
        var tool_search = new _tools2.default.ToolSearch({
            hidden: false
        });
        var tools = new _tools2.default.ToolCollection(config.toolbox);
        this.tool_panel = new _tools2.default.ToolPanel({
            tool_search: tool_search,
            tools: tools,
            layout: config.toolbox_in_panel
        });
        this.tool_panel_view = new _tools2.default.ToolPanelView({
            model: this.tool_panel
        });

        // add upload modal
        this.upload_button = new _uploadView2.default({
            upload_path: config.nginx_upload_path || Galaxy.root + "api/tools",
            chunk_upload_size: config.chunk_upload_size,
            ftp_upload_site: config.ftp_upload_site,
            default_genome: config.default_genome,
            default_extension: config.default_extension
        });

        // add uploader button to Galaxy object
        Galaxy.upload = this.upload_button;

        // components for panel definition
        this.model = new Backbone.Model({
            title: (0, _localization2.default)("Tools"),
            buttons: [this.upload_button]
        });

        // build body template
        this.setElement(this._template());
    },

    render: function render() {
        // if there are tools, render panel and display everything
        var self = this;
        if (this.tool_panel.get("layout").size() > 0) {
            this.$el.find(".toolMenu").replaceWith(this.tool_panel_view.$el);
            this.tool_panel_view.render();
        }
        // build the dom for the workflow portion of the tool menu
        // add internal workflow list
        self.$("#internal-workflows").append(self._templateAllWorkflow({
            title: (0, _localization2.default)("All workflows"),
            href: "workflows/list"
        }));
        _underscore2.default.each(this.stored_workflow_menu_entries, function (menu_entry) {
            self.$("#internal-workflows").append(self._templateWorkflowLink({
                title: menu_entry.stored_workflow.name,
                href: "workflows/run?id=" + menu_entry.encoded_stored_workflow_id
            }));
        });
    },

    /** build a link to one tool */
    _templateTool: function _templateTool(tool) {
        return "<div class=\"toolTitle\">\n                    <a href=\"" + Galaxy.root + tool.href + "\" target=\"galaxy_main\">\n                        " + tool.title + "\n                    </a>\n                </div>";
    },

    /** build a link to 'All Workflows' */
    _templateAllWorkflow: function _templateAllWorkflow(tool) {
        return "<div class=\"toolTitle\">\n                    <a href=\"" + Galaxy.root + tool.href + "\">\n                        " + tool.title + "\n                    </a>\n                </div>";
    },

    /** build links to workflows in toolpanel */
    _templateWorkflowLink: function _templateWorkflowLink(wf) {
        return "<div class=\"toolTitle\">\n                    <a class=\"" + wf.cls + "\" href=\"" + Galaxy.root + wf.href + "\">\n                        " + _underscore2.default.escape(wf.title) + "\n                    </a>\n                </div>";
    },

    /** override to include inital menu dom and workflow section */
    _template: function _template() {
        return "<div class=\"toolMenuContainer\">\n                    <div class=\"toolMenu\" style=\"display: none\">\n                        <div id=\"search-no-results\" style=\"display: none; padding-top: 5px\">\n                            <em>\n                                <strong>\n                                    " + (0, _localization2.default)("Search did not match any tools.") + "\n                                </strong>\n                            </em>\n                        </div>\n                    </div>\n                    <div class=\"toolSectionPad\"/>\n                    <div class=\"toolSectionPad\"/>\n                    <div class=\"toolSectionTitle\" id=\"title_XXinternalXXworkflow\">\n                        <span>\n                            " + (0, _localization2.default)("Workflows") + "\n                        </span>\n                    </div>\n                        <div id=\"internal-workflows\" class=\"toolSectionBody\">\n                            <div class=\"toolSectionBg\"/>\n                        </div>\n                </div>";
    },

    toString: function toString() {
        return "toolPanel";
    }
});

exports.default = ToolPanel;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Backbone) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _localization = __webpack_require__(3);

var _localization2 = _interopRequireDefault(_localization);

var _utils = __webpack_require__(5);

var _utils2 = _interopRequireDefault(_utils);

var _uiModal = __webpack_require__(19);

var _uiModal2 = _interopRequireDefault(_uiModal);

var _uiTabs = __webpack_require__(85);

var _uiTabs2 = _interopRequireDefault(_uiTabs);

var _uploadUtils = __webpack_require__(203);

var _uploadUtils2 = _interopRequireDefault(_uploadUtils);

var _uploadButton = __webpack_require__(686);

var _uploadButton2 = _interopRequireDefault(_uploadButton);

var _defaultView = __webpack_require__(687);

var _defaultView2 = _interopRequireDefault(_defaultView);

var _compositeView = __webpack_require__(690);

var _compositeView2 = _interopRequireDefault(_compositeView);

var _collectionView = __webpack_require__(692);

var _collectionView2 = _interopRequireDefault(_collectionView);

var _rulesInputView = __webpack_require__(694);

var _rulesInputView2 = _interopRequireDefault(_rulesInputView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = Backbone.View.extend({
    options: {
        ftp_upload_site: "n/a",
        default_genome: _uploadUtils2.default.DEFAULT_GENOME,
        default_extension: _uploadUtils2.default.DEFAULT_EXTENSION,
        height: 500,
        width: 900,
        auto: _uploadUtils2.default.AUTO_EXTENSION
    },

    // contains all available dataset extensions/types
    list_extensions: [],

    // contains all available genomes
    list_genomes: [],

    initialize: function initialize(options) {
        var _this = this;

        this.options = _utils2.default.merge(options, this.options);

        // create view for upload/progress button
        this.ui_button = new _uploadButton2.default.View({
            onclick: function onclick(e) {
                e.preventDefault();
                _this.show();
            },
            onunload: function onunload() {
                var percentage = _this.ui_button.model.get("percentage", 0);
                if (percentage > 0 && percentage < 100) {
                    return "Several uploads are queued.";
                }
            }
        });

        // set element to button view
        this.setElement(this.ui_button.$el);

        // load extensions
        _uploadUtils2.default.getUploadDatatypes(function (list_extensions) {
            _this.list_extensions = list_extensions;
        }, this.options.datatypes_disable_auto, this.options.auto);

        // load genomes
        _uploadUtils2.default.getUploadGenomes(function (list_genomes) {
            _this.list_genomes = list_genomes;
        }, this.default_genome);
    },

    /** Show/hide upload dialog */
    show: function show() {
        var self = this;
        if (!Galaxy.currHistoryPanel || !Galaxy.currHistoryPanel.model) {
            window.setTimeout(function () {
                self.show();
            }, 500);
            return;
        }
        this.current_user = Galaxy.user.id;
        if (!this.modal) {
            this.tabs = new _uiTabs2.default.View();
            this.default_view = new _defaultView2.default(this);
            this.tabs.add({
                id: "regular",
                title: (0, _localization2.default)("Regular"),
                $el: this.default_view.$el
            });
            this.composite_view = new _compositeView2.default(this);
            this.tabs.add({
                id: "composite",
                title: (0, _localization2.default)("Composite"),
                $el: this.composite_view.$el
            });
            this.collection_view = new _collectionView2.default(this);
            this.tabs.add({
                id: "collection",
                title: (0, _localization2.default)("Collection"),
                $el: this.collection_view.$el
            });
            this.rule_based_view = new _rulesInputView2.default(this);
            this.tabs.add({
                id: "rule-based",
                title: (0, _localization2.default)("Rule-based"),
                $el: this.rule_based_view.$el
            });
            this.modal = new _uiModal2.default.View({
                title: (0, _localization2.default)("Download from web or upload from disk"),
                body: this.tabs.$el,
                height: this.options.height,
                width: this.options.width,
                closing_events: true,
                title_separator: false
            });
        }
        this.modal.show();
    },

    /** Refresh user and current history */
    currentHistory: function currentHistory() {
        return this.current_user && Galaxy.currHistoryPanel.model.get("id");
    },

    /** Get ftp configuration */
    currentFtp: function currentFtp() {
        return this.current_user && this.options.ftp_upload_site;
    },

    /**
     * Package API data from array of models
     * @param{Array} items - Upload items/rows filtered from a collection
     */
    toData: function toData(items, history_id) {
        // create dictionary for data submission
        var data = {
            payload: {
                tool_id: "upload1",
                history_id: history_id || this.currentHistory(),
                inputs: {}
            },
            files: [],
            error_message: null
        };
        // add upload tools input data
        if (items && items.length > 0) {
            var inputs = {
                file_count: items.length,
                dbkey: items[0].get("genome", "?"),
                // sometimes extension set to "" in automated testing after first upload of
                // a session. https://github.com/galaxyproject/galaxy/issues/5169
                file_type: items[0].get("extension") || "auto"
            };
            for (var index in items) {
                var it = items[index];
                it.set("status", "running");
                if (it.get("file_size") > 0) {
                    var prefix = "files_" + index + "|";
                    inputs[prefix + "type"] = "upload_dataset";
                    if (it.get("file_name") != "New File") {
                        inputs[prefix + "NAME"] = it.get("file_name");
                    }
                    inputs[prefix + "space_to_tab"] = it.get("space_to_tab") && "Yes" || null;
                    inputs[prefix + "to_posix_lines"] = it.get("to_posix_lines") && "Yes" || null;
                    inputs[prefix + "dbkey"] = it.get("genome", null);
                    inputs[prefix + "file_type"] = it.get("extension", null);
                    switch (it.get("file_mode")) {
                        case "new":
                            inputs[prefix + "url_paste"] = it.get("url_paste");
                            break;
                        case "ftp":
                            inputs[prefix + "ftp_files"] = it.get("file_path");
                            break;
                        case "local":
                            data.files.push({
                                name: prefix + "file_data",
                                file: it.get("file_data")
                            });
                    }
                } else {
                    data.error_message = "Upload content incomplete.";
                    it.set("status", "error");
                    it.set("info", data.error_message);
                    break;
                }
            }
            data.payload.inputs = JSON.stringify(inputs);
        }
        return data;
    }
});
/** Upload app contains the upload progress button and upload modal, compiles model data for API request **/
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Backbone, $) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _localization = __webpack_require__(3);

var _localization2 = _interopRequireDefault(_localization);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** View for upload/progress bar button */

var View = Backbone.View.extend({
    initialize: function initialize(options) {
        var self = this;
        this.model = options && options.model || new Backbone.Model({
            icon: "fa-upload",
            tooltip: (0, _localization2.default)("Download from URL or upload files from disk"),
            label: "Load Data",
            percentage: 0,
            status: "",
            onunload: function onunload() {},
            onclick: function onclick() {}
        }).set(options);
        this.setElement(this._template());
        this.$progress = this.$(".progress-bar");
        this.listenTo(this.model, "change", this.render, this);
        this.render();
        $(window).on("beforeunload", function () {
            return self.model.get("onunload")();
        });
    },

    render: function render() {
        var self = this;
        var options = this.model.attributes;
        this.$el.off("click").on("click", function (e) {
            options.onclick(e);
        }).tooltip({
            title: this.model.get("tooltip"),
            placement: "bottom",
            trigger: "hover"
        });
        this.$progress.removeClass().addClass("progress-bar").addClass("progress-bar-notransition").addClass(options.status != "" && "progress-bar-" + options.status).css({ width: options.percentage + "%" });
    },

    /** Template */
    _template: function _template() {
        return '<div class="upload-button">' + '<div class="progress">' + '<div class="progress-bar"/>' + '<a class="panel-header-button" href="javascript:void(0)" id="tool-panel-upload-button">' + '<span class="fa fa-upload"/>' + "</a>" + "</div>" + "</div>";
    }
});
exports.default = { View: View };
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(0)))

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _backbone = __webpack_require__(7);

var Backbone = _interopRequireWildcard(_backbone);

var _underscore = __webpack_require__(1);

var _ = _interopRequireWildcard(_underscore);

var _localization = __webpack_require__(3);

var _localization2 = _interopRequireDefault(_localization);

var _uploadModel = __webpack_require__(190);

var _uploadModel2 = _interopRequireDefault(_uploadModel);

var _defaultRow = __webpack_require__(688);

var _defaultRow2 = _interopRequireDefault(_defaultRow);

var _uploadFtp2 = __webpack_require__(232);

var _uploadFtp3 = _interopRequireDefault(_uploadFtp2);

var _uploadExtension = __webpack_require__(206);

var _uploadExtension2 = _interopRequireDefault(_uploadExtension);

var _uiPopover = __webpack_require__(69);

var _uiPopover2 = _interopRequireDefault(_uiPopover);

var _uiSelect = __webpack_require__(39);

var _uiSelect2 = _interopRequireDefault(_uiSelect);

var _uiMisc = __webpack_require__(11);

var _uiMisc2 = _interopRequireDefault(_uiMisc);

var _lazyLimited = __webpack_require__(689);

var _lazyLimited2 = _interopRequireDefault(_lazyLimited);

__webpack_require__(233);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/* global Galaxy */
/* global $ */

/** Renders contents of the default uploader */
exports.default = Backbone.View.extend({
    // current upload size in bytes
    upload_size: 0,

    // contains upload row models
    collection: new _uploadModel2.default.Collection(),

    // keeps track of the current uploader state
    counter: {
        announce: 0,
        success: 0,
        error: 0,
        running: 0,
        reset: function reset() {
            this.announce = this.success = this.error = this.running = 0;
        }
    },

    initialize: function initialize(app) {
        var self = this;
        this.app = app;
        this.options = app.options;
        this.list_extensions = app.list_extensions;
        this.list_genomes = app.list_genomes;
        this.ui_button = app.ui_button;
        this.ftp_upload_site = app.currentFtp();

        // build template
        this.setElement(this._template());
        this.$uploadbox = this.$(".upload-box");
        this.$uploadtable = this.$(".upload-table");

        // append buttons to dom
        this.btnLocal = new _uiMisc2.default.Button({
            id: "btn-local",
            title: (0, _localization2.default)("Choose local file"),
            onclick: function onclick() {
                self.uploadbox.select();
            },
            icon: "fa fa-laptop"
        });
        this.btnFtp = new _uiMisc2.default.Button({
            id: "btn-ftp",
            title: (0, _localization2.default)("Choose FTP file"),
            onclick: function onclick() {
                self._eventFtp();
            },
            icon: "fa fa-folder-open-o"
        });
        this.btnCreate = new _uiMisc2.default.Button({
            id: "btn-new",
            title: "Paste/Fetch data",
            onclick: function onclick() {
                self._eventCreate();
            },
            icon: "fa fa-edit"
        });
        this.btnStart = new _uiMisc2.default.Button({
            id: "btn-start",
            title: (0, _localization2.default)("Start"),
            onclick: function onclick() {
                self._eventStart();
            }
        });
        this.btnStop = new _uiMisc2.default.Button({
            id: "btn-stop",
            title: (0, _localization2.default)("Pause"),
            onclick: function onclick() {
                self._eventStop();
            }
        });
        this.btnReset = new _uiMisc2.default.Button({
            id: "btn-reset",
            title: (0, _localization2.default)("Reset"),
            onclick: function onclick() {
                self._eventReset();
            }
        });
        this.btnClose = new _uiMisc2.default.Button({
            id: "btn-close",
            title: (0, _localization2.default)("Close"),
            onclick: function onclick() {
                self.app.modal.hide();
            }
        });
        _.each([this.btnLocal, this.btnFtp, this.btnCreate, this.btnStop, this.btnReset, this.btnStart, this.btnClose], function (button) {
            self.$(".upload-buttons").prepend(button.$el);
        });

        // file upload
        this.uploadbox = this.$uploadbox.uploadbox({
            url: this.app.options.upload_path,
            announce: function announce(index, file) {
                self._eventAnnounce(index, file);
            },
            initialize: function initialize(index) {
                return self.app.toData([self.collection.get(index)], self.history_id);
            },
            progress: function progress(index, percentage) {
                self._eventProgress(index, percentage);
            },
            success: function success(index, message) {
                self._eventSuccess(index, message);
            },
            error: function error(index, message) {
                self._eventError(index, message);
            },
            warning: function warning(index, message) {
                self._eventWarning(index, message);
            },
            complete: function complete() {
                self._eventComplete();
            },
            ondragover: function ondragover() {
                self.$uploadbox.addClass("highlight");
            },
            ondragleave: function ondragleave() {
                self.$uploadbox.removeClass("highlight");
            }
        });

        // add ftp file viewer
        this.ftp = new _uiPopover2.default.View({
            title: (0, _localization2.default)("FTP files"),
            container: this.btnFtp.$el
        });

        // select extension
        this.select_extension = new _uiSelect2.default.View({
            css: "upload-footer-selection",
            container: this.$(".upload-footer-extension"),
            data: _.filter(this.list_extensions, function (ext) {
                return !ext.composite_files;
            }),
            value: this.options.default_extension,
            onchange: function onchange(extension) {
                self._changeExtension(extension);
            }
        });

        // handle extension info popover
        this.$(".upload-footer-extension-info").on("click", function (e) {
            new _uploadExtension2.default({
                $el: $(e.target),
                title: self.select_extension.text(),
                extension: self.select_extension.value(),
                list: self.list_extensions,
                placement: "top"
            });
        }).on("mousedown", function (e) {
            e.preventDefault();
        });

        // genome extension
        this.select_genome = new _uiSelect2.default.View({
            css: "upload-footer-selection",
            container: this.$(".upload-footer-genome"),
            data: this.list_genomes,
            value: this.options.default_genome,
            onchange: function onchange(genome) {
                self._changeGenome(genome);
            }
        });

        // Lazy load helper
        this.loader = new _lazyLimited2.default({
            $container: this.$uploadbox,
            collection: this.collection,
            new_content: function new_content(model) {
                var upload_row = new _defaultRow2.default(self, { model: model });
                self.$uploadtable.find("> tbody:first").append(upload_row.$el);
                upload_row.render();
                return upload_row;
            }
        });

        // events
        this.collection.on("remove", function (model) {
            self._eventRemove(model);
        });
        this.render();
    },

    render: function render() {
        var message = "";
        if (this.counter.announce === 0) {
            if (this.uploadbox.compatible()) {
                message = "&nbsp;";
            } else {
                message = "Browser does not support Drag & Drop. Try Firefox 4+, Chrome 7+, IE 10+, Opera 12+ or Safari 6+.";
            }
        } else {
            if (this.counter.running === 0) {
                message = "You added " + this.counter.announce + " file(s) to the queue. Add more files or click 'Start' to proceed.";
            } else {
                message = "Please wait..." + this.counter.announce + " out of " + this.counter.running + " remaining.";
            }
        }
        this.$(".upload-top-info").html(message);
        var enable_reset = this.counter.running === 0 && this.counter.announce + this.counter.success + this.counter.error > 0;
        var enable_start = this.counter.running === 0 && this.counter.announce > 0;
        var enable_sources = this.counter.running === 0;
        var show_table = this.counter.announce + this.counter.success + this.counter.error > 0;
        this.btnReset[enable_reset ? "enable" : "disable"]();
        this.btnStart[enable_start ? "enable" : "disable"]();
        this.btnStart.$el[enable_start ? "addClass" : "removeClass"]("btn-primary");
        this.btnStop[this.counter.running > 0 ? "enable" : "disable"]();
        this.btnLocal[enable_sources ? "enable" : "disable"]();
        this.btnFtp[enable_sources ? "enable" : "disable"]();
        this.btnCreate[enable_sources ? "enable" : "disable"]();
        this.btnFtp.$el[this.ftp_upload_site ? "show" : "hide"]();
        this.$(".upload-table")[show_table ? "show" : "hide"]();
        this.$(".upload-helper")[show_table ? "hide" : "show"]();
    },

    /** A new file has been dropped/selected through the uploadbox plugin */
    _eventAnnounce: function _eventAnnounce(index, file) {
        this.counter.announce++;
        var new_model = new _uploadModel2.default.Model({
            id: index,
            file_name: file.name,
            file_size: file.size,
            file_mode: file.mode || "local",
            file_path: file.path,
            file_data: file
        });
        this.render();
        this.collection.add(new_model);
    },

    /** Progress */
    _eventProgress: function _eventProgress(index, percentage) {
        var it = this.collection.get(index);
        it.set({ percentage: percentage, status: "running", info: "" });
        this.ui_button.model.set("percentage", this._uploadPercentage(percentage, it.get("file_size")));
    },

    /** Success */
    _eventSuccess: function _eventSuccess(index, message) {
        var it = this.collection.get(index);
        it.set({ percentage: 100, status: "success" });
        this.ui_button.model.set("percentage", this._uploadPercentage(100, it.get("file_size")));
        this.upload_completed += it.get("file_size") * 100;
        this.counter.announce--;
        this.counter.success++;
        this.render();
        Galaxy.currHistoryPanel.refreshContents();
    },

    /** Warning */
    _eventWarning: function _eventWarning(index, message) {
        var it = this.collection.get(index);
        it.set({ status: "warning", info: message });
    },

    /** Error */
    _eventError: function _eventError(index, message) {
        var it = this.collection.get(index);
        it.set({ percentage: 100, status: "error", info: message });
        this.ui_button.model.set({
            percentage: this._uploadPercentage(100, it.get("file_size")),
            status: "danger"
        });
        this.upload_completed += it.get("file_size") * 100;
        this.counter.announce--;
        this.counter.error++;
        this.render();
    },

    /** Queue is done */
    _eventComplete: function _eventComplete() {
        this.collection.each(function (model) {
            if (model.get("status") == "queued") {
                model.set("status", "init");
            }
        });
        this.counter.running = 0;
        this.render();
    },

    /** Remove model from upload list */
    _eventRemove: function _eventRemove(model) {
        var status = model.get("status");
        if (status == "success") {
            this.counter.success--;
        } else if (status == "error") {
            this.counter.error--;
        } else {
            this.counter.announce--;
        }
        this.uploadbox.remove(model.id);
        this.render();
    },

    //
    // events triggered by this view
    //

    /** Show/hide ftp popup */
    _eventFtp: function _eventFtp() {
        if (!this.ftp.visible) {
            this.ftp.empty();
            var self = this;
            this.ftp.append(new _uploadFtp3.default({
                collection: this.collection,
                ftp_upload_site: this.ftp_upload_site,
                onadd: function onadd(ftp_file) {
                    return self.uploadbox.add([{
                        mode: "ftp",
                        name: ftp_file.path,
                        size: ftp_file.size,
                        path: ftp_file.path
                    }]);
                },
                onremove: function onremove(model_index) {
                    self.collection.remove(model_index);
                }
            }).$el);
            this.ftp.show();
        } else {
            this.ftp.hide();
        }
    },

    /** Create a new file */
    _eventCreate: function _eventCreate() {
        this.uploadbox.add([{ name: "New File", size: 0, mode: "new" }]);
    },

    /** Start upload process */
    _eventStart: function _eventStart() {
        if (this.counter.announce !== 0 && this.counter.running === 0) {
            // prepare upload process
            var self = this;
            this.upload_size = 0;
            this.upload_completed = 0;
            this.collection.each(function (model) {
                if (model.get("status") == "init") {
                    model.set("status", "queued");
                    self.upload_size += model.get("file_size");
                }
            });
            this.ui_button.model.set({
                percentage: 0,
                status: "success"
            });
            this.counter.running = this.counter.announce;
            this.history_id = this.app.currentHistory();

            // package ftp files separately, and remove them from queue
            this._uploadFtp();

            // queue remaining files
            this.uploadbox.start({
                id: Galaxy.user.id,
                chunk_upload_size: this.app.options.chunk_upload_size
            });
            this.render();
        }
    },

    /** Pause upload process */
    _eventStop: function _eventStop() {
        if (this.counter.running > 0) {
            this.ui_button.model.set("status", "info");
            $(".upload-top-info").html("Queue will pause after completing the current file...");
            this.uploadbox.stop();
        }
    },

    /** Remove all */
    _eventReset: function _eventReset() {
        if (this.counter.running === 0) {
            this.collection.reset();
            this.counter.reset();
            this.uploadbox.reset();
            this.select_extension.value(this.options.default_extension);
            this.select_genome.value(this.options.default_genome);
            this.ui_button.model.set("percentage", 0);
            this.render();
        }
    },

    /** Update extension for all models */
    _changeExtension: function _changeExtension(extension, defaults_only) {
        var self = this;
        this.collection.each(function (model) {
            if (model.get("status") == "init" && (model.get("extension") == self.options.default_extension || !defaults_only)) {
                model.set("extension", extension);
            }
        });
    },

    /** Update genome for all models */
    _changeGenome: function _changeGenome(genome, defaults_only) {
        var self = this;
        this.collection.each(function (model) {
            if (model.get("status") == "init" && (model.get("genome") == self.options.default_genome || !defaults_only)) {
                model.set("genome", genome);
            }
        });
    },

    /** Package and upload ftp files in a single request */
    _uploadFtp: function _uploadFtp() {
        var self = this;
        var list = [];
        this.collection.each(function (model) {
            if (model.get("status") == "queued" && model.get("file_mode") == "ftp") {
                self.uploadbox.remove(model.id);
                list.push(model);
            }
        });
        if (list.length > 0) {
            $.uploadpost({
                data: this.app.toData(list),
                url: this.app.options.upload_path,
                success: function success(message) {
                    _.each(list, function (model) {
                        self._eventSuccess(model.id);
                    });
                },
                error: function error(message) {
                    _.each(list, function (model) {
                        self._eventError(model.id, message);
                    });
                }
            });
        }
    },

    /** Calculate percentage of all queued uploads */
    _uploadPercentage: function _uploadPercentage(percentage, size) {
        return (this.upload_completed + percentage * size) / this.upload_size;
    },

    /** Template */
    _template: function _template() {
        return "<div class=\"upload-view-default\">\n                    <div class=\"upload-top\">\n                        <h6 class=\"upload-top-info\"/>\n                    </div>\n                    <div class=\"upload-box\">\n                        <div class=\"upload-helper\">\n                            <i class=\"fa fa-files-o\"/>Drop files here\n                        </div>\n                        <table class=\"upload-table ui-table-striped\" style=\"display: none;\">\n                            <thead>\n                                <tr>\n                                    <th>Name</th>\n                                    <th>Size</th>\n                                    <th>Type</th>\n                                    <th>Genome</th>\n                                    <th>Settings</th>\n                                    <th>Status</th>\n                                    <th/>\n                                </tr>\n                            </thead>\n                            <tbody/>\n                        </table>\n                    </div>\n                    <div class=\"upload-footer\">\n                        <span class=\"upload-footer-title\">Type (set all):</span>\n                        <span class=\"upload-footer-extension\"/>\n                        <span class=\"upload-footer-extension-info upload-icon-button fa fa-search\"/>\n                        <span class=\"upload-footer-title\">Genome (set all):</span>\n                        <span class=\"upload-footer-genome\"/>\n                    </div>\n                    <div class=\"upload-buttons\"/>\n                </div>";
    }
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Backbone, _, $) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _localization = __webpack_require__(3);

var _localization2 = _interopRequireDefault(_localization);

var _utils = __webpack_require__(5);

var _utils2 = _interopRequireDefault(_utils);

var _uploadModel = __webpack_require__(190);

var _uploadModel2 = _interopRequireDefault(_uploadModel);

var _uploadSettings = __webpack_require__(231);

var _uploadSettings2 = _interopRequireDefault(_uploadSettings);

var _uiPopover = __webpack_require__(69);

var _uiPopover2 = _interopRequireDefault(_uiPopover);

var _uploadExtension = __webpack_require__(206);

var _uploadExtension2 = _interopRequireDefault(_uploadExtension);

var _uiSelect = __webpack_require__(39);

var _uiSelect2 = _interopRequireDefault(_uiSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** Renders the default uploader rows */
exports.default = Backbone.View.extend({
    /** Dictionary of upload states and associated icons */
    status_classes: {
        init: "upload-icon-button fa fa-trash-o",
        queued: "upload-icon fa fa-spinner fa-spin",
        running: "upload-icon fa fa-spinner fa-spin",
        warning: "upload-icon fa fa-spinner fa-spin",
        success: "upload-icon-button fa fa-check",
        error: "upload-icon-button fa fa-exclamation-triangle"
    },

    initialize: function initialize(app, options) {
        var _this = this;

        var self = this;
        this.app = app;
        this.list_extensions = app.list_extensions;
        this.model = options.model;
        this.setElement(this._template(options.model));
        this.$mode = this.$(".upload-mode");
        this.$title = this.$(".upload-title");
        this.$text = this.$(".upload-text");
        this.$size = this.$(".upload-size");
        this.$info_text = this.$(".upload-info-text");
        this.$info_progress = this.$(".upload-info-progress");
        this.$text_content = this.$(".upload-text-content");
        this.$settings = this.$(".upload-settings");
        this.$symbol = this.$(".upload-symbol");
        this.$progress_bar = this.$(".upload-progress-bar");
        this.$percentage = this.$(".upload-percentage");

        // append popup to settings icon
        this.settings = new _uiPopover2.default.View({
            title: (0, _localization2.default)("Upload configuration"),
            container: this.$(".upload-settings"),
            placement: "bottom"
        });

        // identify default genome and extension values
        var default_genome = this.app.select_genome.value();
        var default_extension = this.app.select_extension.value();

        // create select genomes
        this.select_genome = new _uiSelect2.default.View({
            css: "upload-genome",
            data: self.app.list_genomes,
            container: this.$(".upload-genome"),
            value: default_genome,
            onchange: function onchange(genome) {
                self.model.set("genome", genome);
            }
        });

        // create select extension
        this.select_extension = new _uiSelect2.default.View({
            css: "upload-extension",
            data: _.filter(this.list_extensions, function (ext) {
                return !ext.composite_files;
            }),
            container: this.$(".upload-extension"),
            value: default_extension,
            onchange: function onchange(extension) {
                self.model.set("extension", extension);
            }
        });

        // initialize genome and extension values
        this.model.set({
            genome: default_genome,
            extension: default_extension
        });

        // handle click event
        this.$symbol.on("click", function () {
            self._removeRow();
        });

        // handle extension info popover
        this.$(".upload-extension-info").on("click", function (e) {
            var upload_ext = _this.upload_extension;
            if (upload_ext) {
                if (upload_ext.extension_popup.visible) {
                    upload_ext.extension_popup.hide();
                } else {
                    upload_ext.extension_popup.remove();
                    _this._makeUploadExtensionsPopover(e);
                }
            } else {
                _this._makeUploadExtensionsPopover(e);
            }
        }).on("mousedown", function (e) {
            e.preventDefault();
        });

        // handle settings popover
        this.$settings.on("click", function (e) {
            self._showSettings();
        }).on("mousedown", function (e) {
            e.preventDefault();
        });

        // handle text editing event
        this.$text_content.on("change input", function (e) {
            self.model.set({
                url_paste: $(e.target).val(),
                file_size: $(e.target).val().length
            });
        });

        // handle text editing event
        this.$title.on("change input", function (e) {
            self.model.set({ file_name: $(e.target).val() });
        });

        // model events
        this.listenTo(this.model, "change:percentage", function () {
            self._refreshPercentage();
        });
        this.listenTo(this.model, "change:status", function () {
            self._refreshStatus();
        });
        this.listenTo(this.model, "change:info", function () {
            self._refreshInfo();
        });
        this.listenTo(this.model, "change:genome", function () {
            self._refreshGenome();
        });
        this.listenTo(this.model, "change:extension", function () {
            self._refreshExtension();
        });
        this.listenTo(this.model, "change:file_size", function () {
            self._refreshFileSize();
        });
    },

    render: function render() {
        this._refreshType();
        this._refreshPercentage();
        this._refreshStatus();
        this._refreshInfo();
        this._refreshGenome();
        this._refreshExtension();
        this._refreshFileSize();
    },

    /** Remove view */
    remove: function remove() {
        this.select_genome.remove();
        this.select_extension.remove();
        Backbone.View.prototype.remove.apply(this);
    },

    /** Render type */
    _refreshType: function _refreshType() {
        var options = this.model.attributes;
        this.$title.val(_.escape(options.file_name));
        this.$size.html(_utils2.default.bytesToString(options.file_size));
        this.$mode.removeClass().addClass("upload-mode").addClass("text-primary");
        if (options.file_mode == "new") {
            this.$text.css({
                width: this.$el.width() - 16 + "px",
                top: this.$el.height() - 8 + "px"
            }).show();
            this.$el.height(this.$el.height() - 8 + this.$text.height() + 16);
            this.$mode.addClass("fa fa-edit");
        } else if (options.file_mode == "local") {
            this.$mode.addClass("fa fa-laptop");
        } else if (options.file_mode == "ftp") {
            this.$mode.addClass("fa fa-folder-open-o");
        }
    },

    /** Update extension */
    _refreshExtension: function _refreshExtension() {
        this.select_extension.value(this.model.get("extension"));
    },

    /** Update genome */
    _refreshGenome: function _refreshGenome() {
        this.select_genome.value(this.model.get("genome"));
    },

    /** Refresh info text */
    _refreshInfo: function _refreshInfo() {
        var info = this.model.get("info");
        if (info) {
            this.$info_text.html("<strong>Warning: </strong>" + info).show();
        } else {
            this.$info_text.hide();
        }
    },

    /** Refresh percentage status */
    _refreshPercentage: function _refreshPercentage() {
        var percentage = parseInt(this.model.get("percentage"));
        this.$progress_bar.css({ width: percentage + "%" });
        this.$percentage.html(percentage != 100 ? percentage + "%" : "Adding to history...");
    },

    /** Refresh status */
    _refreshStatus: function _refreshStatus() {
        var status = this.model.get("status");
        this.$symbol.removeClass().addClass("upload-symbol").addClass(this.status_classes[status]);
        this.model.set("enabled", status == "init");
        var enabled = this.model.get("enabled");
        this.$text_content.attr("disabled", !enabled);
        if (enabled) {
            this.select_genome.enable();
            this.select_extension.enable();
        } else {
            this.select_genome.disable();
            this.select_extension.disable();
        }
        this.$info_progress.show();
        this.$el.removeClass().addClass("upload-row");
        if (status == "success") {
            this.$el.addClass("table-success");
            this.$percentage.html("100%");
        } else if (status == "error") {
            this.$el.addClass("table-danger");
            this.$info_progress.hide();
        } else if (status == "warning") {
            this.$el.addClass("table-warning");
            this.$info_progress.hide();
        }
    },

    /** Refresh file size */
    _refreshFileSize: function _refreshFileSize() {
        this.$size.html(_utils2.default.bytesToString(this.model.get("file_size")));
    },

    /** Remove row */
    _removeRow: function _removeRow() {
        if (["init", "success", "error"].indexOf(this.model.get("status")) !== -1) {
            this.app.collection.remove(this.model);
        }
    },

    /** Attach file info popup */
    _showSettings: function _showSettings() {
        if (!this.settings.visible) {
            this.settings.empty();
            this.settings.append(new _uploadSettings2.default(this).$el);
            this.settings.show();
        } else {
            this.settings.hide();
        }
    },

    /** Make extension popover */
    _makeUploadExtensionsPopover: function _makeUploadExtensionsPopover(e) {
        this.upload_extension = new _uploadExtension2.default({
            $el: $(e.target),
            title: this.select_extension.text(),
            extension: this.select_extension.value(),
            list: this.list_extensions
        });
    },

    /** View template */
    _template: function _template(options) {
        return "<tr id=\"upload-row-" + options.id + "\" class=\"upload-row\"><td><div class=\"upload-text-column\"><div class=\"upload-mode\"/><input class=\"upload-title\"/><div class=\"upload-text\"><div class=\"upload-text-info\">You can tell Galaxy to download data from web by entering URL in this box (one per line). You can also directly paste the contents of a file.</div><textarea class=\"upload-text-content form-control\"/></div></div></td><td><div class=\"upload-size\"/></td><td><div class=\"upload-extension\" style=\"float: left;\"/>&nbsp;&nbsp<div class=\"upload-extension-info upload-icon-button fa fa-search\"/></td><td><div class=\"upload-genome\"/></td><td><div class=\"upload-settings upload-icon-button fa fa-gear\"/></td><td><div class=\"upload-info\"><div class=\"upload-info-text\"/><div class=\"upload-info-progress progress\"><div class=\"upload-progress-bar progress-bar progress-bar-success\"/><div class=\"upload-percentage\">0%</div></div></div></td><td><div class=\"upload-symbol " + this.status_classes.init + "\"/></td></tr>";
    }
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(1), __webpack_require__(0)))

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Backbone, $, _) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
/** Contains helpers to limit/lazy load views for backbone views */

exports.default = Backbone.View.extend({
    initialize: function initialize(options) {
        var self = this;
        this.$container = options.$container;
        this.collection = options.collection;
        this.new_content = options.new_content;
        this.max = options.max || 50;
        this.content_list = {};
        this.$message = $("<div/>").addClass("ui-limitloader").append("...only the first " + this.max + " entries are visible.");
        this.$container.append(this.$message);
        this.listenTo(this.collection, "reset", this._reset, this);
        this.listenTo(this.collection, "add", this._refresh, this);
        this.listenTo(this.collection, "remove", this._remove, this);
    },

    /** Checks if the limit has been reached */
    _done: function _done() {
        var done = _.size(this.content_list) > this.max;
        this.$message[done ? "show" : "hide"]();
        return done;
    },

    /** Remove all content */
    _reset: function _reset() {
        _.each(this.content_list, function (content) {
            content.remove();
        });
        this.content_list = {};
        this.$message.hide();
    },

    /** Remove content */
    _remove: function _remove(model) {
        var model_id = model.id;
        var content = this.content_list[model_id];
        if (content) {
            content.remove();
            delete this.content_list[model_id];
        }
        this._refresh();
    },

    /** Refreshes container content by adding new views if visible */
    _refresh: function _refresh() {
        if (!this._done()) {
            for (var i in this.collection.models) {
                var model = this.collection.models[i];
                var view = this.content_list[model.id];
                if (!this.content_list[model.id]) {
                    var content = this.new_content(model);
                    this.content_list[model.id] = content;
                    if (this._done()) {
                        break;
                    }
                }
            }
        }
    }
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(0), __webpack_require__(1)))

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Backbone, _, $) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _localization = __webpack_require__(3);

var _localization2 = _interopRequireDefault(_localization);

var _utils = __webpack_require__(5);

var _utils2 = _interopRequireDefault(_utils);

var _uploadModel = __webpack_require__(190);

var _uploadModel2 = _interopRequireDefault(_uploadModel);

var _compositeRow = __webpack_require__(691);

var _compositeRow2 = _interopRequireDefault(_compositeRow);

var _uploadExtension = __webpack_require__(206);

var _uploadExtension2 = _interopRequireDefault(_uploadExtension);

var _uiPopover = __webpack_require__(69);

var _uiPopover2 = _interopRequireDefault(_uiPopover);

var _uiSelect = __webpack_require__(39);

var _uiSelect2 = _interopRequireDefault(_uiSelect);

var _uiMisc = __webpack_require__(11);

var _uiMisc2 = _interopRequireDefault(_uiMisc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = Backbone.View.extend({
    collection: new _uploadModel2.default.Collection(),
    initialize: function initialize(app) {
        var self = this;
        this.app = app;
        this.options = app.options;
        this.list_extensions = app.list_extensions;
        this.list_genomes = app.list_genomes;
        this.ftp_upload_site = app.currentFtp();
        this.setElement(this._template());

        // create button section
        this.btnStart = new _uiMisc2.default.Button({
            title: (0, _localization2.default)("Start"),
            onclick: function onclick() {
                self._eventStart();
            }
        });
        this.btnClose = new _uiMisc2.default.Button({
            title: (0, _localization2.default)("Close"),
            onclick: function onclick() {
                self.app.modal.hide();
            }
        });

        // append buttons to dom
        _.each([this.btnStart, this.btnClose], function (button) {
            self.$(".upload-buttons").prepend(button.$el);
        });

        // select extension
        this.select_extension = new _uiSelect2.default.View({
            css: "upload-footer-selection",
            container: this.$(".upload-footer-extension"),
            data: _.filter(this.list_extensions, function (ext) {
                return ext.composite_files;
            }),
            onchange: function onchange(extension) {
                self.collection.reset();
                var details = _.findWhere(self.list_extensions, {
                    id: extension
                });
                if (details && details.composite_files) {
                    _.each(details.composite_files, function (item) {
                        self.collection.add({
                            id: self.collection.size(),
                            file_desc: item.description || item.name
                        });
                    });
                }
            }
        });

        // handle extension info popover
        this.$(".upload-footer-extension-info").on("click", function (e) {
            new _uploadExtension2.default({
                $el: $(e.target),
                title: self.select_extension.text(),
                extension: self.select_extension.value(),
                list: self.list_extensions,
                placement: "top"
            });
        }).on("mousedown", function (e) {
            e.preventDefault();
        });

        // genome extension
        this.select_genome = new _uiSelect2.default.View({
            css: "upload-footer-selection",
            container: this.$(".upload-footer-genome"),
            data: this.list_genomes,
            value: this.options.default_genome
        });

        // listener for collection triggers on change in composite datatype and extension selection
        this.listenTo(this.collection, "add", function (model) {
            self._eventAnnounce(model);
        });
        this.listenTo(this.collection, "change add", function () {
            self.render();
        });
        this.select_extension.options.onchange(this.select_extension.value());
        this.render();
    },

    render: function render() {
        var model = this.collection.first();
        if (model && model.get("status") == "running") {
            this.select_genome.disable();
            this.select_extension.disable();
        } else {
            this.select_genome.enable();
            this.select_extension.enable();
        }
        if (this.collection.where({ status: "ready" }).length == this.collection.length && this.collection.length > 0) {
            this.btnStart.enable();
            this.btnStart.$el.addClass("btn-primary");
        } else {
            this.btnStart.disable();
            this.btnStart.$el.removeClass("btn-primary");
        }
        this.$(".upload-table")[this.collection.length > 0 ? "show" : "hide"]();
    },

    //
    // upload events / process pipeline
    //

    /** Builds the basic ui with placeholder rows for each composite data type file */
    _eventAnnounce: function _eventAnnounce(model) {
        var upload_row = new _compositeRow2.default(this, { model: model });
        this.$(".upload-table > tbody:first").append(upload_row.$el);
        this.$(".upload-table")[this.collection.length > 0 ? "show" : "hide"]();
        upload_row.render();
    },

    /** Start upload process */
    _eventStart: function _eventStart() {
        var self = this;
        this.collection.each(function (model) {
            model.set({
                genome: self.select_genome.value(),
                extension: self.select_extension.value()
            });
        });
        $.uploadpost({
            url: this.app.options.upload_path,
            data: this.app.toData(this.collection.filter()),
            success: function success(message) {
                self._eventSuccess(message);
            },
            error: function error(message) {
                self._eventError(message);
            },
            progress: function progress(percentage) {
                self._eventProgress(percentage);
            }
        });
    },

    /** Refresh progress state */
    _eventProgress: function _eventProgress(percentage) {
        this.collection.each(function (it) {
            it.set("percentage", percentage);
        });
    },

    /** Refresh success state */
    _eventSuccess: function _eventSuccess(message) {
        this.collection.each(function (it) {
            it.set("status", "success");
        });
        Galaxy.currHistoryPanel.refreshContents();
    },

    /** Refresh error state */
    _eventError: function _eventError(message) {
        this.collection.each(function (it) {
            it.set({ status: "error", info: message });
        });
    },

    /** Load html template */
    _template: function _template() {
        return '<div class="upload-view-composite">' + '<div class="upload-top">' + '<h6 class="upload-top-info"/>' + "</div>" + '<div class="upload-box">' + '<table class="upload-table ui-table-striped" style="display: none;">' + "<thead>" + "<tr>" + "<th/>" + "<th/>" + "<th>Description</th>" + "<th>Name</th>" + "<th>Size</th>" + "<th>Settings</th>" + "<th>Status</th>" + "</tr>" + "</thead>" + "<tbody/>" + "</table>" + "</div>" + '<div class="upload-footer">' + '<span class="upload-footer-title">Composite Type:</span>' + '<span class="upload-footer-extension"/>' + '<span class="upload-footer-extension-info upload-icon-button fa fa-search"/> ' + '<span class="upload-footer-title">Genome/Build:</span>' + '<span class="upload-footer-genome"/>' + "</div>" + '<div class="upload-buttons"/>' + "</div>";
    }
});
/** Renders contents of the composite uploader */
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(1), __webpack_require__(0)))

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Backbone, $, _) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _localization = __webpack_require__(3);

var _localization2 = _interopRequireDefault(_localization);

var _utils = __webpack_require__(5);

var _utils2 = _interopRequireDefault(_utils);

var _uploadSettings = __webpack_require__(231);

var _uploadSettings2 = _interopRequireDefault(_uploadSettings);

var _uploadFtp = __webpack_require__(232);

var _uploadFtp2 = _interopRequireDefault(_uploadFtp);

var _uiPopover = __webpack_require__(69);

var _uiPopover2 = _interopRequireDefault(_uiPopover);

var _uiMisc = __webpack_require__(11);

var _uiMisc2 = _interopRequireDefault(_uiMisc);

var _uiSelect = __webpack_require__(39);

var _uiSelect2 = _interopRequireDefault(_uiSelect);

__webpack_require__(233);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = Backbone.View.extend({
    /** Dictionary of upload states and associated icons */
    status_classes: {
        init: "upload-mode fa fa-exclamation text-primary",
        ready: "upload-mode fa fa-check text-success",
        running: "upload-mode fa fa-spinner fa-spin",
        success: "upload-mode fa fa-check",
        error: "upload-mode fa fa-exclamation-triangle"
    },

    initialize: function initialize(app, options) {
        var self = this;
        this.app = app;
        this.model = options.model;
        this.setElement(this._template());
        this.$source = this.$(".upload-source");
        this.$settings = this.$(".upload-settings");
        this.$status = this.$(".upload-status");
        this.$text = this.$(".upload-text");
        this.$text_content = this.$(".upload-text-content");
        this.$info_text = this.$(".upload-info-text");
        this.$info_progress = this.$(".upload-info-progress");
        this.$file_name = this.$(".upload-file-name");
        this.$file_desc = this.$(".upload-file-desc");
        this.$file_size = this.$(".upload-file-size");
        this.$progress_bar = this.$(".upload-progress-bar");
        this.$percentage = this.$(".upload-percentage");

        // build upload functions
        this.uploadinput = this.$el.uploadinput({
            ondragover: function ondragover() {
                self.model.get("enabled") && self.$el.addClass("warning");
            },
            ondragleave: function ondragleave() {
                self.$el.removeClass("warning");
            },
            onchange: function onchange(files) {
                if (self.model.get("status") != "running" && files && files.length > 0) {
                    self.model.reset({
                        file_data: files[0],
                        file_name: files[0].name,
                        file_size: files[0].size,
                        file_mode: files[0].mode || "local"
                    });
                    self._refreshReady();
                }
            }
        });

        // source selection popup
        this.button_menu = new _uiMisc2.default.ButtonMenu({
            icon: "fa-caret-down",
            title: (0, _localization2.default)("Select"),
            pull: "left"
        });
        this.$source.append(this.button_menu.$el);
        this.button_menu.addMenu({
            icon: "fa-laptop",
            title: (0, _localization2.default)("Choose local file"),
            onclick: function onclick() {
                self.uploadinput.dialog();
            }
        });
        if (this.app.ftp_upload_site) {
            this.button_menu.addMenu({
                icon: "fa-folder-open-o",
                title: (0, _localization2.default)("Choose FTP file"),
                onclick: function onclick() {
                    self._showFtp();
                }
            });
        }
        this.button_menu.addMenu({
            icon: "fa-edit",
            title: "Paste/Fetch data",
            onclick: function onclick() {
                self.model.reset({
                    file_mode: "new",
                    file_name: "New File"
                });
            }
        });

        // add ftp file viewer
        this.ftp = new _uiPopover2.default.View({
            title: "Choose FTP file:",
            container: this.$source.find(".ui-button-menu"),
            placement: "right"
        });

        // append popup to settings icon
        this.settings = new _uiPopover2.default.View({
            title: (0, _localization2.default)("Upload configuration"),
            container: this.$settings,
            placement: "bottom"
        });

        // handle text editing event
        this.$text_content.on("change input", function (e) {
            self.model.set({
                url_paste: $(e.target).val(),
                file_size: $(e.target).val().length
            });
            self._refreshReady();
        });

        // handle settings popover
        this.$settings.on("click", function (e) {
            self._showSettings();
        }).on("mousedown", function (e) {
            e.preventDefault();
        });

        // model events
        this.listenTo(this.model, "change:percentage", function () {
            self._refreshPercentage();
        });
        this.listenTo(this.model, "change:status", function () {
            self._refreshStatus();
        });
        this.listenTo(this.model, "change:info", function () {
            self._refreshInfo();
        });
        this.listenTo(this.model, "change:file_name", function () {
            self._refreshFileName();
        });
        this.listenTo(this.model, "change:file_mode", function () {
            self._refreshMode();
        });
        this.listenTo(this.model, "change:file_size", function () {
            self._refreshFileSize();
        });
        this.listenTo(this.model, "remove", function () {
            self.remove();
        });
        this.app.collection.on("reset", function () {
            self.remove();
        });
    },

    render: function render() {
        this.$el.attr("id", "upload-row-" + this.model.id);
        this.$file_name.html(_.escape(this.model.get("file_name") || "-"));
        this.$file_desc.html(this.model.get("file_desc") || "Unavailable");
        this.$file_size.html(_utils2.default.bytesToString(this.model.get("file_size")));
        this.$status.removeClass().addClass(this.status_classes.init);
    },

    /** Remove view */
    remove: function remove() {
        // call the base class remove method
        Backbone.View.prototype.remove.apply(this);
    },

    //
    // handle model events
    //

    /** Refresh ready or not states */
    _refreshReady: function _refreshReady() {
        this.app.collection.each(function (model) {
            model.set("status", model.get("file_size") > 0 && "ready" || "init");
        });
    },

    /** Refresh mode and e.g. show/hide textarea field */
    _refreshMode: function _refreshMode() {
        var file_mode = this.model.get("file_mode");
        if (file_mode == "new") {
            this.height = this.$el.height();
            this.$text.css({
                width: this.$el.width() - 16 + "px",
                top: this.$el.height() - 8 + "px"
            }).show();
            this.$el.height(this.$el.height() - 8 + this.$text.height() + 16);
            this.$text_content.val("").trigger("keyup");
        } else {
            this.$el.height(this.height);
            this.$text.hide();
        }
    },

    /** Refresh information */
    _refreshInfo: function _refreshInfo() {
        var info = this.model.get("info");
        if (info) {
            this.$info_text.html("<strong>Failed: </strong>" + info).show();
        } else {
            this.$info_text.hide();
        }
    },

    /** Refresh percentage */
    _refreshPercentage: function _refreshPercentage() {
        var percentage = parseInt(this.model.get("percentage"));
        if (percentage != 0) {
            this.$progress_bar.css({ width: percentage + "%" });
        } else {
            this.$progress_bar.addClass("no-transition");
            this.$progress_bar.css({ width: "0%" });
            this.$progress_bar[0].offsetHeight;
            this.$progress_bar.removeClass("no-transition");
        }
        this.$percentage.html(percentage != 100 ? percentage + "%" : "Adding to history...");
    },

    /** Refresh status */
    _refreshStatus: function _refreshStatus() {
        var status = this.model.get("status");
        this.$status.removeClass().addClass(this.status_classes[status]);
        this.model.set("enabled", status != "running");
        this.$text_content.attr("disabled", !this.model.get("enabled"));
        this.$el.removeClass("table-success table-danger table-warning");
        if (status == "running" || status == "ready") {
            this.model.set("percentage", 0);
        }
        this.$source.find(".button")[status == "running" ? "addClass" : "removeClass"]("disabled");
        if (status == "success") {
            this.$el.addClass("table-success");
            this.model.set("percentage", 100);
            this.$percentage.html("100%");
        }
        if (status == "error") {
            this.$el.addClass("table-danger");
            this.model.set("percentage", 0);
            this.$info_progress.hide();
            this.$info_text.show();
        } else {
            this.$info_progress.show();
            this.$info_text.hide();
        }
    },

    /** File name */
    _refreshFileName: function _refreshFileName() {
        this.$file_name.html(this.model.get("file_name") || "-");
    },

    /** File size */
    _refreshFileSize: function _refreshFileSize() {
        this.$file_size.html(_utils2.default.bytesToString(this.model.get("file_size")));
    },

    /** Show/hide ftp popup */
    _showFtp: function _showFtp() {
        if (!this.ftp.visible) {
            var self = this;
            this.ftp.empty();
            this.ftp.append(new _uploadFtp2.default({
                ftp_upload_site: this.app.ftp_upload_site,
                onchange: function onchange(ftp_file) {
                    self.ftp.hide();
                    if (self.model.get("status") != "running" && ftp_file) {
                        self.model.reset({
                            file_mode: "ftp",
                            file_name: ftp_file.path,
                            file_size: ftp_file.size,
                            file_path: ftp_file.path
                        });
                        self._refreshReady();
                    }
                }
            }).$el);
            this.ftp.show();
        } else {
            this.ftp.hide();
        }
    },

    /** Show/hide settings popup */
    _showSettings: function _showSettings() {
        if (!this.settings.visible) {
            this.settings.empty();
            this.settings.append(new _uploadSettings2.default(this).$el);
            this.settings.show();
        } else {
            this.settings.hide();
        }
    },

    /** Template */
    _template: function _template() {
        return '<tr class="upload-row">' + "<td>" + '<div class="upload-source"/>' + '<div class="upload-text-column">' + '<div class="upload-text">' + '<div class="upload-text-info">You can tell Galaxy to download data from web by entering URL in this box (one per line). You can also directly paste the contents of a file.</div>' + '<textarea class="upload-text-content form-control"/>' + "</div>" + "</div>" + "</td>" + "<td>" + '<div class="upload-status"/>' + "</td>" + "<td>" + '<div class="upload-file-desc upload-title"/>' + "</td>" + "<td>" + '<div class="upload-file-name upload-title"/>' + "</td>" + "<td>" + '<div class="upload-file-size upload-size"/>' + "</td>" + '<td><div class="upload-settings upload-icon-button fa fa-gear"/></td>' + "<td>" + '<div class="upload-info">' + '<div class="upload-info-text"/>' + '<div class="upload-info-progress progress">' + '<div class="upload-progress-bar progress-bar progress-bar-success"/>' + '<div class="upload-percentage">0%</div>' + "</div>" + "</div>" + "</td>" + "</tr>";
    }
});
/** Renders the composite upload row view */
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(0), __webpack_require__(1)))

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Backbone, _, $) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _localization = __webpack_require__(3);

var _localization2 = _interopRequireDefault(_localization);

var _utils = __webpack_require__(5);

var _utils2 = _interopRequireDefault(_utils);

var _uploadModel = __webpack_require__(190);

var _uploadModel2 = _interopRequireDefault(_uploadModel);

var _collectionRow = __webpack_require__(693);

var _collectionRow2 = _interopRequireDefault(_collectionRow);

var _uploadFtp = __webpack_require__(232);

var _uploadFtp2 = _interopRequireDefault(_uploadFtp);

var _uploadExtension = __webpack_require__(206);

var _uploadExtension2 = _interopRequireDefault(_uploadExtension);

var _uiPopover = __webpack_require__(69);

var _uiPopover2 = _interopRequireDefault(_uiPopover);

var _uiSelect = __webpack_require__(39);

var _uiSelect2 = _interopRequireDefault(_uiSelect);

var _uiMisc = __webpack_require__(11);

var _uiMisc2 = _interopRequireDefault(_uiMisc);

var _listCollectionCreator = __webpack_require__(90);

var _listCollectionCreator2 = _interopRequireDefault(_listCollectionCreator);

__webpack_require__(233);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** Renders contents of the collection uploader */
exports.default = Backbone.View.extend({
    // current upload size in bytes
    upload_size: 0,

    // contains upload row models
    collection: new _uploadModel2.default.Collection(),

    // keeps track of the current uploader state
    counter: {
        announce: 0,
        success: 0,
        error: 0,
        running: 0,
        reset: function reset() {
            this.announce = this.success = this.error = this.running = 0;
        }
    },

    initialize: function initialize(app) {
        var self = this;
        this.app = app;
        this.options = app.options;
        this.list_extensions = app.list_extensions;
        this.list_genomes = app.list_genomes;
        this.ui_button = app.ui_button;
        this.ftp_upload_site = app.currentFtp();
        this.setElement(this._template());

        // append buttons to dom
        this.btnLocal = new _uiMisc2.default.Button({
            id: "btn-local",
            title: (0, _localization2.default)("Choose local files"),
            onclick: function onclick() {
                self.uploadbox.select();
            },
            icon: "fa fa-laptop"
        });
        this.btnFtp = new _uiMisc2.default.Button({
            id: "btn-ftp",
            title: (0, _localization2.default)("Choose FTP files"),
            onclick: function onclick() {
                self._eventFtp();
            },
            icon: "fa fa-folder-open-o"
        });
        this.btnCreate = new _uiMisc2.default.Button({
            id: "btn-new",
            title: "Paste/Fetch data",
            onclick: function onclick() {
                self._eventCreate();
            },
            icon: "fa fa-edit"
        });
        this.btnStart = new _uiMisc2.default.Button({
            id: "btn-start",
            title: (0, _localization2.default)("Start"),
            onclick: function onclick() {
                self._eventStart();
            }
        });
        this.btnBuild = new _uiMisc2.default.Button({
            id: "btn-build",
            title: (0, _localization2.default)("Build"),
            onclick: function onclick() {
                self._eventBuild();
            }
        });
        this.btnStop = new _uiMisc2.default.Button({
            id: "btn-stop",
            title: (0, _localization2.default)("Pause"),
            onclick: function onclick() {
                self._eventStop();
            }
        });
        this.btnReset = new _uiMisc2.default.Button({
            id: "btn-reset",
            title: (0, _localization2.default)("Reset"),
            onclick: function onclick() {
                self._eventReset();
            }
        });
        this.btnClose = new _uiMisc2.default.Button({
            id: "btn-close",
            title: (0, _localization2.default)("Close"),
            onclick: function onclick() {
                self.app.modal.hide();
            }
        });
        _.each([this.btnLocal, this.btnFtp, this.btnCreate, this.btnStop, this.btnReset, this.btnStart, this.btnBuild, this.btnClose], function (button) {
            self.$(".upload-buttons").prepend(button.$el);
        });

        // file upload
        this.uploadbox = this.$(".upload-box").uploadbox({
            url: this.app.options.upload_path,
            announce: function announce(index, file) {
                self._eventAnnounce(index, file);
            },
            initialize: function initialize(index) {
                return self.app.toData([self.collection.get(index)], self.history_id);
            },
            progress: function progress(index, percentage) {
                self._eventProgress(index, percentage);
            },
            success: function success(index, message) {
                self._eventSuccess(index, message);
            },
            error: function error(index, message) {
                self._eventError(index, message);
            },
            complete: function complete() {
                self._eventComplete();
            },
            ondragover: function ondragover() {
                self.$(".upload-box").addClass("highlight");
            },
            ondragleave: function ondragleave() {
                self.$(".upload-box").removeClass("highlight");
            }
        });

        // add ftp file viewer
        this.ftp = new _uiPopover2.default.View({
            title: (0, _localization2.default)("FTP files"),
            container: this.btnFtp.$el
        });

        // select extension
        this.select_extension = new _uiSelect2.default.View({
            css: "upload-footer-selection-compressed",
            container: this.$(".upload-footer-extension"),
            data: _.filter(this.list_extensions, function (ext) {
                return !ext.composite_files;
            }),
            value: this.options.default_extension,
            onchange: function onchange(extension) {
                self.updateExtension(extension);
            }
        });

        this.collectionType = "list";
        this.select_collection = new _uiSelect2.default.View({
            css: "upload-footer-selection-compressed",
            container: this.$(".upload-footer-collection-type"),
            data: [{ id: "list", text: "List" }, { id: "paired", text: "Paired" }, { id: "list:paired", text: "List of Pairs" }],
            value: "list",
            onchange: function onchange(collectionType) {
                self.updateCollectionType(collectionType);
            }
        });

        // handle extension info popover
        this.$(".upload-footer-extension-info").on("click", function (e) {
            new _uploadExtension2.default({
                $el: $(e.target),
                title: self.select_extension.text(),
                extension: self.select_extension.value(),
                list: self.list_extensions,
                placement: "top"
            });
        }).on("mousedown", function (e) {
            e.preventDefault();
        });

        // genome extension
        this.select_genome = new _uiSelect2.default.View({
            css: "upload-footer-selection",
            container: this.$(".upload-footer-genome"),
            data: this.list_genomes,
            value: this.options.default_genome,
            onchange: function onchange(genome) {
                self.updateGenome(genome);
            }
        });

        // events
        this.collection.on("remove", function (model) {
            self._eventRemove(model);
        });
        this._updateScreen();
    },

    /** A new file has been dropped/selected through the uploadbox plugin */
    _eventAnnounce: function _eventAnnounce(index, file) {
        this.counter.announce++;
        var new_model = new _uploadModel2.default.Model({
            id: index,
            file_name: file.name,
            file_size: file.size,
            file_mode: file.mode || "local",
            file_path: file.path,
            file_data: file,
            extension: this.select_extension.value(),
            genome: this.select_genome.value()
        });
        this.collection.add(new_model);
        var upload_row = new _collectionRow2.default(this, { model: new_model });
        this.$(".upload-table > tbody:first").append(upload_row.$el);
        this._updateScreen();
        upload_row.render();
    },

    /** Progress */
    _eventProgress: function _eventProgress(index, percentage) {
        var it = this.collection.get(index);
        it.set("percentage", percentage);
        this.ui_button.model.set("percentage", this._uploadPercentage(percentage, it.get("file_size")));
    },

    /** Success */
    _eventSuccess: function _eventSuccess(index, message) {
        // var hdaId = message["outputs"][0]["id"];
        var hids = _.pluck(message["outputs"], "hid");
        var it = this.collection.get(index);
        it.set({ percentage: 100, status: "success", hids: hids });
        this.ui_button.model.set("percentage", this._uploadPercentage(100, it.get("file_size")));
        this.upload_completed += it.get("file_size") * 100;
        this.counter.announce--;
        this.counter.success++;
        this._updateScreen();
        Galaxy.currHistoryPanel.refreshContents();
    },

    /** Error */
    _eventError: function _eventError(index, message) {
        var it = this.collection.get(index);
        it.set({ percentage: 100, status: "error", info: message });
        this.ui_button.model.set({
            percentage: this._uploadPercentage(100, it.get("file_size")),
            status: "danger"
        });
        this.upload_completed += it.get("file_size") * 100;
        this.counter.announce--;
        this.counter.error++;
        this._updateScreen();
    },

    /** Queue is done */
    _eventComplete: function _eventComplete() {
        this.collection.each(function (model) {
            model.get("status") == "queued" && model.set("status", "init");
        });
        this.counter.running = 0;
        this._updateScreen();
    },

    _eventBuild: function _eventBuild() {
        var allHids = [];
        _.forEach(this.collection.models, function (upload) {
            allHids.push.apply(allHids, upload.get("hids"));
        });
        var models = _.map(allHids, function (hid) {
            return Galaxy.currHistoryPanel.collection.getByHid(hid);
        });
        var selection = new Galaxy.currHistoryPanel.collection.constructor(models);
        // I'm building the selection wrong because I need to set this historyId directly.
        selection.historyId = Galaxy.currHistoryPanel.collection.historyId;
        Galaxy.currHistoryPanel.buildCollection(this.collectionType, selection, true);
        this.counter.running = 0;
        this._updateScreen();
        this._eventReset();
        this.app.modal.hide();
    },

    /** Remove model from upload list */
    _eventRemove: function _eventRemove(model) {
        var status = model.get("status");
        if (status == "success") {
            this.counter.success--;
        } else if (status == "error") {
            this.counter.error--;
        } else {
            this.counter.announce--;
        }
        this.uploadbox.remove(model.id);
        this._updateScreen();
    },

    //
    // events triggered by this view
    //

    /** Show/hide ftp popup */
    _eventFtp: function _eventFtp() {
        if (!this.ftp.visible) {
            this.ftp.empty();
            var self = this;
            this.ftp.append(new _uploadFtp2.default({
                collection: this.collection,
                ftp_upload_site: this.ftp_upload_site,
                onadd: function onadd(ftp_file) {
                    return self.uploadbox.add([{
                        mode: "ftp",
                        name: ftp_file.path,
                        size: ftp_file.size,
                        path: ftp_file.path
                    }]);
                },
                onremove: function onremove(model_index) {
                    self.collection.remove(model_index);
                }
            }).$el);
            this.ftp.show();
        } else {
            this.ftp.hide();
        }
    },

    /** Create a new file */
    _eventCreate: function _eventCreate() {
        this.uploadbox.add([{ name: "New File", size: 0, mode: "new" }]);
    },

    /** Start upload process */
    _eventStart: function _eventStart() {
        if (this.counter.announce == 0 || this.counter.running > 0) {
            return;
        }
        var self = this;
        this.upload_size = 0;
        this.upload_completed = 0;
        this.collection.each(function (model) {
            if (model.get("status") == "init") {
                model.set("status", "queued");
                self.upload_size += model.get("file_size");
            }
        });
        this.ui_button.model.set({ percentage: 0, status: "success" });
        this.counter.running = this.counter.announce;
        this.history_id = this.app.currentHistory();
        this.uploadbox.start();
        this._updateScreen();
    },

    /** Pause upload process */
    _eventStop: function _eventStop() {
        if (this.counter.running > 0) {
            this.ui_button.model.set("status", "info");
            $(".upload-top-info").html("Queue will pause after completing the current file...");
            this.uploadbox.stop();
        }
    },

    /** Remove all */
    _eventReset: function _eventReset() {
        if (this.counter.running == 0) {
            this.collection.reset();
            this.counter.reset();
            this.uploadbox.reset();
            this.select_extension.value(this.options.default_extension);
            this.select_genome.value(this.options.default_genome);
            this.ui_button.model.set("percentage", 0);
            this._updateScreen();
        }
    },

    /** Update extension for all models */
    updateExtension: function updateExtension(extension, defaults_only) {
        var self = this;
        this.collection.each(function (model) {
            if (model.get("status") == "init" && (model.get("extension") == self.options.default_extension || !defaults_only)) {
                model.set("extension", extension);
            }
        });
    },

    /** Update collection type */
    updateCollectionType: function updateCollectionType(collectionType) {
        var self = this;
        this.collectionType = collectionType;
    },

    /** Update genome for all models */
    updateGenome: function updateGenome(genome, defaults_only) {
        var self = this;
        this.collection.each(function (model) {
            if (model.get("status") == "init" && (model.get("genome") == self.options.default_genome || !defaults_only)) {
                model.set("genome", genome);
            }
        });
    },

    /** Set screen */
    _updateScreen: function _updateScreen() {
        var message = "";
        if (this.counter.announce == 0) {
            if (this.uploadbox.compatible()) {
                message = "&nbsp;";
            } else {
                message = "Browser does not support Drag & Drop. Try Firefox 4+, Chrome 7+, IE 10+, Opera 12+ or Safari 6+.";
            }
        } else {
            if (this.counter.running == 0) {
                message = "You added " + this.counter.announce + " file(s) to the queue. Add more files or click 'Start' to proceed.";
            } else {
                message = "Please wait..." + this.counter.announce + " out of " + this.counter.running + " remaining.";
            }
        }
        this.$(".upload-top-info").html(message);
        var enable_reset = this.counter.running == 0 && this.counter.announce + this.counter.success + this.counter.error > 0;
        var enable_start = this.counter.running == 0 && this.counter.announce > 0;
        var enable_build = this.counter.running == 0 && this.counter.announce == 0 && this.counter.success > 0 && this.counter.error == 0;
        var enable_sources = this.counter.running == 0;
        var show_table = this.counter.announce + this.counter.success + this.counter.error > 0;
        this.btnReset[enable_reset ? "enable" : "disable"]();
        this.btnStart[enable_start ? "enable" : "disable"]();
        this.btnStart.$el[enable_start ? "addClass" : "removeClass"]("btn-primary");
        this.btnBuild[enable_build ? "enable" : "disable"]();
        this.btnBuild.$el[enable_build ? "addClass" : "removeClass"]("btn-primary");
        this.btnStop[this.counter.running > 0 ? "enable" : "disable"]();
        this.btnLocal[enable_sources ? "enable" : "disable"]();
        this.btnFtp[enable_sources ? "enable" : "disable"]();
        this.btnCreate[enable_sources ? "enable" : "disable"]();
        this.btnFtp.$el[this.ftp_upload_site ? "show" : "hide"]();
        this.$(".upload-table")[show_table ? "show" : "hide"]();
        this.$(".upload-helper")[show_table ? "hide" : "show"]();
    },

    /** Calculate percentage of all queued uploads */
    _uploadPercentage: function _uploadPercentage(percentage, size) {
        return (this.upload_completed + percentage * size) / this.upload_size;
    },

    /** Template */
    _template: function _template() {
        return '<div class="upload-view-default">' + '<div class="upload-top">' + '<h6 class="upload-top-info"/>' + "</div>" + '<div class="upload-box">' + '<div class="upload-helper"><i class="fa fa-files-o"/>Drop files here</div>' + '<table class="upload-table ui-table-striped" style="display: none;">' + "<thead>" + "<tr>" + "<th>Name</th>" + "<th>Size</th>" + "<th>Status</th>" + "<th/>" + "</tr>" + "</thead>" + "<tbody/>" + "</table>" + "</div>" + '<div class="upload-footer">' + '<span class="upload-footer-title-compressed">Collection Type:</span>' + '<span class="upload-footer-collection-type"/>' + '<span class="upload-footer-title-compressed">File Type:</span>' + '<span class="upload-footer-extension"/>' + '<span class="upload-footer-extension-info upload-icon-button fa fa-search"/> ' + '<span class="upload-footer-title-compressed">Genome (set all):</span>' + '<span class="upload-footer-genome"/>' + "</div>" + '<div class="upload-buttons"/>' + "</div>";
    }
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(1), __webpack_require__(0)))

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Backbone, $, _) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _localization = __webpack_require__(3);

var _localization2 = _interopRequireDefault(_localization);

var _utils = __webpack_require__(5);

var _utils2 = _interopRequireDefault(_utils);

var _uploadModel = __webpack_require__(190);

var _uploadModel2 = _interopRequireDefault(_uploadModel);

var _uploadSettings = __webpack_require__(231);

var _uploadSettings2 = _interopRequireDefault(_uploadSettings);

var _uiPopover = __webpack_require__(69);

var _uiPopover2 = _interopRequireDefault(_uiPopover);

var _uiSelect = __webpack_require__(39);

var _uiSelect2 = _interopRequireDefault(_uiSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = Backbone.View.extend({
    /** Dictionary of upload states and associated icons */
    status_classes: {
        init: "upload-icon-button fa fa-trash-o",
        queued: "upload-icon fa fa-spinner fa-spin",
        running: "upload-icon fa fa-spinner fa-spin",
        success: "upload-icon-button fa fa-check",
        error: "upload-icon-button fa fa-exclamation-triangle"
    },

    initialize: function initialize(app, options) {
        var self = this;
        this.app = app;
        this.model = options.model;
        this.setElement(this._template(options.model));
        this.$mode = this.$(".upload-mode");
        this.$title = this.$(".upload-title-extended");
        this.$text = this.$(".upload-text");
        this.$size = this.$(".upload-size");
        this.$info_text = this.$(".upload-info-text");
        this.$info_progress = this.$(".upload-info-progress");
        this.$text_content = this.$(".upload-text-content");
        this.$symbol = this.$(".upload-symbol");
        this.$progress_bar = this.$(".upload-progress-bar");
        this.$percentage = this.$(".upload-percentage");

        // append popup to settings icon
        this.settings = new _uiPopover2.default.View({
            title: (0, _localization2.default)("Upload configuration"),
            container: this.$(".upload-settings"),
            placement: "bottom"
        });

        // identify default genome and extension values
        var default_genome = this.app.select_genome.value();
        var default_extension = this.app.select_extension.value();

        // handle click event
        this.$symbol.on("click", function () {
            self._removeRow();
        });

        // handle text editing event
        this.$text_content.on("change input", function (e) {
            self.model.set({
                url_paste: $(e.target).val(),
                file_size: $(e.target).val().length
            });
        });

        // model events
        this.listenTo(this.model, "change:percentage", function () {
            self._refreshPercentage();
        });
        this.listenTo(this.model, "change:status", function () {
            self._refreshStatus();
        });
        this.listenTo(this.model, "change:info", function () {
            self._refreshInfo();
        });
        this.listenTo(this.model, "change:file_size", function () {
            self._refreshFileSize();
        });
        this.listenTo(this.model, "remove", function () {
            self.remove();
        });
        this.app.collection.on("reset", function () {
            self.remove();
        });
    },

    render: function render() {
        var options = this.model.attributes;
        this.$title.html(_.escape(options.file_name));
        this.$size.html(_utils2.default.bytesToString(options.file_size));
        this.$mode.removeClass().addClass("upload-mode").addClass("text-primary");
        if (options.file_mode == "new") {
            this.$text.css({
                width: this.$el.width() - 16 + "px",
                top: this.$el.height() - 8 + "px"
            }).show();
            this.$el.height(this.$el.height() - 8 + this.$text.height() + 16);
            this.$mode.addClass("fa fa-edit");
        } else if (options.file_mode == "local") {
            this.$mode.addClass("fa fa-laptop");
        } else if (options.file_mode == "ftp") {
            this.$mode.addClass("fa fa-folder-open-o");
        }
    },

    /** Refresh info text */
    _refreshInfo: function _refreshInfo() {
        var info = this.model.get("info");
        if (info) {
            this.$info_text.html("<strong>Failed: </strong>" + info).show();
        } else {
            this.$info_text.hide();
        }
    },

    /** Refresh percentage status */
    _refreshPercentage: function _refreshPercentage() {
        var percentage = parseInt(this.model.get("percentage"));
        this.$progress_bar.css({ width: percentage + "%" });
        this.$percentage.html(percentage != 100 ? percentage + "%" : "Adding to history...");
    },

    /** Refresh status */
    _refreshStatus: function _refreshStatus() {
        var status = this.model.get("status");
        this.$symbol.removeClass().addClass("upload-symbol").addClass(this.status_classes[status]);
        this.model.set("enabled", status == "init");
        var enabled = this.model.get("enabled");
        this.$text_content.attr("disabled", !enabled);
        if (status == "success") {
            this.$el.addClass("table-success");
            this.$percentage.html("100%");
        }
        if (status == "error") {
            this.$el.addClass("table-danger");
            this.$info_progress.hide();
        }
    },

    /** Refresh file size */
    _refreshFileSize: function _refreshFileSize() {
        this.$size.html(_utils2.default.bytesToString(this.model.get("file_size")));
    },

    /** Remove row */
    _removeRow: function _removeRow() {
        if (["init", "success", "error"].indexOf(this.model.get("status")) !== -1) {
            this.app.collection.remove(this.model);
        }
    },

    /** Attach file info popup */
    _showSettings: function _showSettings() {
        if (!this.settings.visible) {
            this.settings.empty();
            this.settings.append(new _uploadSettings2.default(this).$el);
            this.settings.show();
        } else {
            this.settings.hide();
        }
    },

    /** View template */
    _template: function _template(options) {
        return "<tr id=\"upload-row-" + options.id + "\" class=\"upload-row\"><td><div class=\"upload-text-column\"><div class=\"upload-mode\"/><div class=\"upload-title-extended\"/><div class=\"upload-text\"><div class=\"upload-text-info\">You can tell Galaxy to download data from web by entering URL in this box (one per line). You can also directly paste the contents of a file.</div><textarea class=\"upload-text-content form-control\"/></div></div></td><td><div class=\"upload-size\"/></td><td><div class=\"upload-info\"><div class=\"upload-info-text\"/><div class=\"upload-info-progress progress\"><div class=\"upload-progress-bar progress-bar progress-bar-success\"/><div class=\"upload-percentage\">0%</div></div></div></td><td><div class=\"upload-symbol " + this.status_classes.init + "\"/></td></tr>";
    }
});
/** Renders the collection uploader rows */
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(0), __webpack_require__(1)))

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Backbone, _) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _localization = __webpack_require__(3);

var _localization2 = _interopRequireDefault(_localization);

var _uiMisc = __webpack_require__(11);

var _uiMisc2 = _interopRequireDefault(_uiMisc);

var _uiSelect = __webpack_require__(39);

var _uiSelect2 = _interopRequireDefault(_uiSelect);

var _uploadUtils = __webpack_require__(203);

var _uploadUtils2 = _interopRequireDefault(_uploadUtils);

var _axios = __webpack_require__(21);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = Backbone.View.extend({
    initialize: function initialize(app) {
        var _this = this;

        this.app = app;
        this.options = app.options;
        this.ftpFiles = [];
        this.ftpUploadSite = app.currentFtp();
        this.setElement(this._template());
        this.btnBuild = new _uiMisc2.default.Button({
            id: "btn-build",
            title: (0, _localization2.default)("Build"),
            onclick: function onclick() {
                _this._eventBuild();
            }
        });
        this.btnBuild.$el.addClass("btn-primary");
        this.btnReset = new _uiMisc2.default.Button({
            id: "btn-reset",
            title: (0, _localization2.default)("Reset"),
            onclick: function onclick() {
                return _this._eventReset();
            }
        });
        this.btnClose = new _uiMisc2.default.Button({
            id: "btn-close",
            title: (0, _localization2.default)("Close"),
            onclick: function onclick() {
                return _this.app.modal.hide();
            }
        });
        _.each([this.btnReset, this.btnBuild, this.btnClose], function (button) {
            _this.$(".upload-buttons").prepend(button.$el);
        });
        var dataTypeOptions = [{ id: "datasets", text: "Datasets" }, { id: "collections", text: "Collection(s)" }];
        this.dataType = "datasets";
        this.dataTypeView = new _uiSelect2.default.View({
            css: "upload-footer-selection",
            container: this.$(".rule-data-type"),
            data: dataTypeOptions,
            value: this.dataType,
            onchange: function onchange(value) {
                _this.dataType = value;
                // this._renderSelectedType();
            }
        });

        var selectionTypeOptions = [{ id: "paste", text: "Pasted Table" }, { id: "dataset", text: "History Dataset" }];
        if (this.ftpUploadSite) {
            selectionTypeOptions.push({ id: "ftp", text: "FTP Directory" });
        }
        this.selectionType = "paste";
        this.selectionTypeView = new _uiSelect2.default.View({
            css: "upload-footer-selection",
            container: this.$(".rule-select-type"),
            data: selectionTypeOptions,
            value: this.selectionType,
            onchange: function onchange(value) {
                _this.selectionType = value;
                _this._renderSelectedType();
            }
        });
        this.selectedDatasetId = null;

        this.$sourceContent = this.$(".upload-rule-source-content");
        this.$sourceContent.on("change keyup paste", function () {
            _this._updateBuildState();
        });
        this._renderSelectedType();
    },

    _renderSelectedType: function _renderSelectedType() {
        var _this2 = this;

        var selectionType = this.selectionType;
        if (selectionType == "dataset") {
            if (!this.datasetSelectorView) {
                this.selectedDatasetId = null;
                var history = parent.Galaxy && parent.Galaxy.currHistoryPanel && parent.Galaxy.currHistoryPanel.model;
                var historyContentModels = history.contents.models;
                var options = [];
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = historyContentModels[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var historyContentModel = _step.value;

                        var attr = historyContentModel.attributes;
                        if (attr.history_content_type !== "dataset") {
                            continue;
                        }
                        options.push({ id: attr.id, text: attr.hid + ": " + _.escape(attr.name) });
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                this.datasetSelectorView = new _uiSelect2.default.View({
                    container: this.$(".dataset-selector"),
                    data: options,
                    placeholder: (0, _localization2.default)("Select a dataset"),
                    onchange: function onchange(val) {
                        _this2._onDataset(val);
                    }
                });
            } else {
                this.datasetSelectorView.value(null);
            }
        } else if (selectionType == "ftp") {
            _uploadUtils2.default.getRemoteFiles(function (ftp_files) {
                _this2._setPreview(ftp_files.map(function (file) {
                    return file["path"];
                }).join("\n"));
                _this2.ftpFiles = ftp_files;
            });
        }
        this._updateScreen();
    },

    _onDataset: function _onDataset(selectedDatasetId) {
        var _this3 = this;

        this.selectedDatasetId = selectedDatasetId;
        if (!selectedDatasetId) {
            this._setPreview("");
            return;
        }
        _axios2.default.get(Galaxy.root + "api/histories/" + Galaxy.currHistoryPanel.model.id + "/contents/" + selectedDatasetId + "/display").then(function (response) {
            _this3._setPreview(response.data);
        }).catch(function (error) {
            return console.log(error);
        });
    },

    /** Remove all */
    _eventReset: function _eventReset() {
        if (this.datasetSelectorView) {
            this.datasetSelectorView.value(null);
        }
        this.$sourceContent.val("");
        this._updateScreen();
    },

    _eventBuild: function _eventBuild() {
        var selection = this.$sourceContent.val();
        this._buildSelection(selection);
    },

    _buildSelection: function _buildSelection(content) {
        var selectionType = this.selectionType;
        var selection = {};
        if (selectionType == "dataset" || selectionType == "paste") {
            selection.selectionType = "raw";
            selection.content = content;
        } else if (selectionType == "ftp") {
            selection.selectionType = "ftp";
            selection.elements = this.ftpFiles;
            selection.ftpUploadSite = this.ftpUploadSite;
        }
        selection.dataType = this.dataType;
        Galaxy.currHistoryPanel.buildCollection("rules", selection, true);
        this.app.modal.hide();
    },

    _setPreview: function _setPreview(content) {
        this.$sourceContent.val(content);
        this._updateScreen();
    },

    _updateScreen: function _updateScreen() {
        this._updateBuildState();
        var selectionType = this.selectionType;
        this.$("#upload-rule-dataset-option")[selectionType == "dataset" ? "show" : "hide"]();
        this.$sourceContent.attr("disabled", selectionType !== "paste");
    },

    _updateBuildState: function _updateBuildState() {
        var selection = this.$sourceContent.val();
        this.btnBuild[selection ? "enable" : "disable"]();
        this.btnBuild.$el[selection ? "addClass" : "removeClass"]("btn-primary");
    },

    _template: function _template() {
        return "\n            <div class=\"upload-view-default\">\n                <div class=\"upload-top\">\n                    <h6 class=\"upload-top-info\">\n                        Tabular source data to extract collection files and metadata from\n                    </h6>\n                </div>\n                <div class=\"upload-box\" style=\"height: 335px;\">\n                    <span style=\"width: 25%; display: inline; height: 100%\" class=\"float-left\">\n                        <div class=\"upload-rule-option\">\n                            <div class=\"upload-rule-option-title\">" + (0, _localization2.default)("Upload data as") + ":</div>\n                            <div class=\"rule-data-type\" />\n                        </div>\n                        <div class=\"upload-rule-option\">\n                            <div class=\"upload-rule-option-title\">" + (0, _localization2.default)("Load tabular data from") + ":</div>\n                            <div class=\"rule-select-type\" />\n                        </div>\n                        <div id=\"upload-rule-dataset-option\" class=\"upload-rule-option\">\n                            <div class=\"upload-rule-option-title\">" + (0, _localization2.default)("Select dataset to load") + ":</div>\n                            <div class=\"dataset-selector\" />\n                        </div>\n                    </span>\n                    <span style=\"display: inline; float: right; width: 75%; height: 300px\">\n                    <textarea class=\"upload-rule-source-content form-control\" style=\"height: 100%\"></textarea>\n                    </span>\n                </div>\n                <div class=\"clear\" />\n                <!--\n                <div class=\"upload-footer\">\n                </div>\n                -->\n                <div class=\"upload-buttons\"/>\n                </div>\n        ";
    }
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(1)))

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Backbone) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _uiMisc = __webpack_require__(11);

var _uiMisc2 = _interopRequireDefault(_uiMisc);

var _optionsMenu = __webpack_require__(696);

var _optionsMenu2 = _interopRequireDefault(_optionsMenu);

var _historyViewEditCurrent = __webpack_require__(697);

var _historyViewEditCurrent2 = _interopRequireDefault(_historyViewEditCurrent);

var _localization = __webpack_require__(3);

var _localization2 = _interopRequireDefault(_localization);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** the right hand panel in the analysis page that shows the current history */
var HistoryPanel = Backbone.View.extend({
    initialize: function initialize(page, options) {
        var self = this;
        this.userIsAnonymous = Galaxy.user.isAnonymous();
        this.allow_user_dataset_purge = options.config.allow_user_dataset_purge;
        this.root = options.root;

        // view of the current history
        this.historyView = new _historyViewEditCurrent2.default.CurrentHistoryView({
            className: _historyViewEditCurrent2.default.CurrentHistoryView.prototype.className + " middle",
            purgeAllowed: this.allow_user_dataset_purge,
            linkTarget: "galaxy_main"
        });

        // add history panel to Galaxy object
        Galaxy.currHistoryPanel = this.historyView;
        Galaxy.currHistoryPanel.listenToGalaxy(Galaxy);

        // build buttons
        this.buttonRefresh = new _uiMisc2.default.ButtonLink({
            id: "history-refresh-button",
            title: (0, _localization2.default)("Refresh history"),
            cls: "panel-header-button",
            icon: "fa fa-refresh",
            onclick: function onclick() {
                self.historyView.loadCurrentHistory();
            }
        });
        this.buttonOptions = new _uiMisc2.default.ButtonLink({
            id: "history-options-button",
            title: (0, _localization2.default)("History options"),
            cls: "panel-header-button",
            target: "galaxy_main",
            icon: "fa fa-cog",
            href: this.root + "root/history_options"
        });
        this.buttonViewMulti = new _uiMisc2.default.ButtonLink({
            id: "history-view-multi-button",
            title: (0, _localization2.default)("View all histories"),
            cls: "panel-header-button",
            icon: "fa fa-columns",
            href: this.root + "history/view_multiple"
        });

        // define components
        this.model = new Backbone.Model({
            cls: "history-right-panel",
            title: (0, _localization2.default)("History"),
            buttons: [this.buttonRefresh, this.buttonOptions, this.buttonViewMulti]
        });

        // build body template and connect history view
        this.setElement(this._template());
        this.historyView.setElement(this.$el);
        this.historyView.connectToQuotaMeter(Galaxy.quotaMeter);
        this.historyView.loadCurrentHistory();

        // fetch to update the quota meter adding 'current' for any anon-user's id
        Galaxy.listenTo(this.historyView, "history-size-change", function () {
            Galaxy.user.fetch({
                url: Galaxy.user.urlRoot() + "/" + (Galaxy.user.id || "current")
            });
        });
    },

    render: function render() {
        this.optionsMenu = (0, _optionsMenu2.default)(this.buttonOptions.$el, {
            anonymous: this.userIsAnonymous,
            purgeAllowed: this.allow_user_dataset_purge,
            root: this.root
        });
        this.buttonViewMulti.$el[!this.userIsAnonymous ? "show" : "hide"]();
    },

    /** add history view div */
    _template: function _template(data) {
        return ['<div id="current-history-panel" class="history-panel middle"/>'].join("");
    },

    toString: function toString() {
        return "historyPanel";
    }
});

exports.default = HistoryPanel;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _underscore = __webpack_require__(1);

var _ = _interopRequireWildcard(_underscore);

var _localization = __webpack_require__(3);

var _localization2 = _interopRequireDefault(_localization);

var _popupMenu = __webpack_require__(56);

var _popupMenu2 = _interopRequireDefault(_popupMenu);

var _copyDialog = __webpack_require__(150);

var _copyDialog2 = _interopRequireDefault(_copyDialog);

var _webhooks = __webpack_require__(29);

var _webhooks2 = _interopRequireDefault(_webhooks);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/* global $ */
/* global Galaxy */

// ============================================================================
var menu = [{
    html: (0, _localization2.default)("History Lists"),
    header: true
}, {
    html: (0, _localization2.default)("Saved Histories"),
    href: "histories/list",
    target: "_top"
}, {
    html: (0, _localization2.default)("Histories Shared with Me"),
    href: "histories/list_shared",
    target: "_top"
}, {
    html: (0, _localization2.default)("Current History"),
    header: true,
    anon: true
}, {
    html: (0, _localization2.default)("Create New"),
    func: function func() {
        if (Galaxy && Galaxy.currHistoryPanel) {
            Galaxy.currHistoryPanel.createNewHistory();
        }
    }
}, {
    html: (0, _localization2.default)("Copy History"),
    func: function func() {
        (0, _copyDialog2.default)(Galaxy.currHistoryPanel.model).done(function () {
            Galaxy.currHistoryPanel.loadCurrentHistory();
        });
    }
}, {
    html: (0, _localization2.default)("Share or Publish"),
    func: function func() {
        if (Galaxy && Galaxy.currHistoryPanel && Galaxy.router) {
            Galaxy.router.push("/histories/sharing?id=" + Galaxy.currHistoryPanel.model.id);
        }
    }
}, {
    html: (0, _localization2.default)("Show Structure"),
    anon: true,
    func: function func() {
        if (Galaxy && Galaxy.currHistoryPanel && Galaxy.router) {
            Galaxy.router.push("/histories/show_structure");
        }
    }
}, {
    html: (0, _localization2.default)("Extract Workflow"),
    href: "workflow/build_from_current_history"
}, {
    html: (0, _localization2.default)("Delete"),
    anon: true,
    func: function func() {
        if (Galaxy && Galaxy.currHistoryPanel && confirm((0, _localization2.default)("Really delete the current history?"))) {
            Galaxy.currHistoryPanel.model._delete().done(function () {
                Galaxy.currHistoryPanel.loadCurrentHistory();
            });
        }
    }
}, {
    html: (0, _localization2.default)("Delete Permanently"),
    purge: true,
    anon: true,
    func: function func() {
        if (Galaxy && Galaxy.currHistoryPanel && confirm((0, _localization2.default)("Really delete the current history permanently? This cannot be undone."))) {
            Galaxy.currHistoryPanel.model.purge().done(function () {
                Galaxy.currHistoryPanel.loadCurrentHistory();
            });
        }
    }
}, {
    html: (0, _localization2.default)("Dataset Actions"),
    header: true,
    anon: true
}, {
    html: (0, _localization2.default)("Copy Datasets"),
    href: "dataset/copy_datasets"
}, {
    html: (0, _localization2.default)("Dataset Security"),
    func: function func() {
        if (Galaxy && Galaxy.currHistoryPanel && Galaxy.router) {
            Galaxy.router.push("/histories/permissions?id=" + Galaxy.currHistoryPanel.model.id);
        }
    }
}, {
    html: (0, _localization2.default)("Resume Paused Jobs"),
    href: "history/resume_paused_jobs?current=True",
    anon: true
}, {
    html: (0, _localization2.default)("Collapse Expanded Datasets"),
    func: function func() {
        if (Galaxy && Galaxy.currHistoryPanel) {
            Galaxy.currHistoryPanel.collapseAll();
        }
    }
}, {
    html: (0, _localization2.default)("Unhide Hidden Datasets"),
    anon: true,
    func: function func() {
        // TODO: Deprecate this functionality and replace with group dataset selector and action combination
        if (Galaxy && Galaxy.currHistoryPanel && confirm((0, _localization2.default)("Really unhide all hidden datasets?"))) {
            $.post(Galaxy.root + "history/adjust_hidden", { user_action: "unhide" }, function () {
                Galaxy.currHistoryPanel.loadCurrentHistory();
            });
        }
    }
}, {
    html: (0, _localization2.default)("Delete Hidden Datasets"),
    anon: true,
    func: function func() {
        // TODO: Deprecate this functionality and replace with group dataset selector and action combination
        if (Galaxy && Galaxy.currHistoryPanel && confirm((0, _localization2.default)("Really delete all hidden datasets?"))) {
            $.post(Galaxy.root + "history/adjust_hidden", { user_action: "delete" }, function () {
                Galaxy.currHistoryPanel.loadCurrentHistory();
            });
        }
    }
}, {
    html: (0, _localization2.default)("Purge Deleted Datasets"),
    confirm: (0, _localization2.default)("Really delete all deleted datasets permanently? This cannot be undone."),
    href: "history/purge_deleted_datasets",
    purge: true,
    anon: true
}, {
    html: (0, _localization2.default)("Downloads"),
    header: true
}, {
    html: (0, _localization2.default)("Export Tool Citations"),
    anon: true,
    func: function func() {
        if (Galaxy && Galaxy.currHistoryPanel && Galaxy.router) {
            Galaxy.router.push("/histories/citations?id=" + Galaxy.currHistoryPanel.model.id);
        }
    }
}, {
    html: (0, _localization2.default)("Export History to File"),
    href: "history/export_archive?preview=True",
    anon: true
}, {
    html: (0, _localization2.default)("Other Actions"),
    header: true
}, {
    html: (0, _localization2.default)("Import from File"),
    href: "histories/import",
    target: "_top"
}];

// Webhooks
_webhooks2.default.load({
    type: "history-menu",
    async: false, // (hypothetically) slows down the performance
    callback: function callback(webhooks) {
        var webhooks_menu = [];

        webhooks.each(function (model) {
            var webhook = model.toJSON();
            if (webhook.activate) {
                webhooks_menu.push({
                    html: (0, _localization2.default)(webhook.config.title),
                    // func: function() {},
                    anon: true
                });
            }
        });

        if (webhooks_menu.length > 0) {
            webhooks_menu.unshift({
                html: (0, _localization2.default)("Webhooks"),
                header: true
            });
            $.merge(menu, webhooks_menu);
        }
    }
});

function buildMenu(isAnon, purgeAllowed, urlRoot) {
    return _.clone(menu).filter(function (menuOption) {
        if (isAnon && !menuOption.anon) {
            return false;
        }
        if (!purgeAllowed && menuOption.purge) {
            return false;
        }

        //TODO:?? hard-coded galaxy_main
        if (menuOption.href) {
            menuOption.href = urlRoot + menuOption.href;
            menuOption.target = menuOption.target || "galaxy_main";
        }

        if (menuOption.confirm) {
            menuOption.func = function () {
                if (confirm(menuOption.confirm)) {
                    /* galaxy_main is a global here: TODO: Fix it! */
                    galaxy_main.location = menuOption.href;
                }
            };
        }
        return true;
    });
}

var create = function create($button, options) {
    options = options || {};
    var isAnon = options.anonymous === undefined ? true : options.anonymous;
    var purgeAllowed = options.purgeAllowed || false;
    var menu = buildMenu(isAnon, purgeAllowed, Galaxy.root);
    //console.debug( 'menu:', menu );
    return new _popupMenu2.default($button, menu);
};

// ============================================================================
exports.default = create;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _historyViewEdit = __webpack_require__(191);

var _historyViewEdit2 = _interopRequireDefault(_historyViewEdit);

var _baseMvc = __webpack_require__(6);

var _baseMvc2 = _interopRequireDefault(_baseMvc);

var _localization = __webpack_require__(3);

var _localization2 = _interopRequireDefault(_localization);

var _underscore = __webpack_require__(1);

var _ = _interopRequireWildcard(_underscore);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global Galaxy */
/* global $ */

// ============================================================================
/** session storage for history panel preferences (and to maintain state)
 */
var HistoryViewPrefs = _baseMvc2.default.SessionStorageModel.extend(
/** @lends HistoryViewPrefs.prototype */{
    defaults: {
        /** should the tags editor be shown or hidden initially? */
        tagsEditorShown: false,
        /** should the annotation editor be shown or hidden initially? */
        annotationEditorShown: false,
        ///** what is the currently focused content (dataset or collection) in the current history?
        // *      (the history panel will highlight and scroll to the focused content view)
        // */
        //focusedContentId : null
        /** Current scroll position */
        scrollPosition: 0
    },
    toString: function toString() {
        return "HistoryViewPrefs(" + JSON.stringify(this.toJSON()) + ")";
    }
});

/** key string to store panel prefs (made accessible on class so you can access sessionStorage directly) */
HistoryViewPrefs.storageKey = function storageKey() {
    return "history-panel";
};

/* =============================================================================
TODO:

============================================================================= */
var _super = _historyViewEdit2.default.HistoryViewEdit;
// used in root/index.mako
/** @class View/Controller for the user's current history model as used in the history
 *      panel (current right hand panel) of the analysis page.
 *
 *  The only history panel that:
 *      will poll for updates.
 *      displays datasets in reverse hid order.
 */
var CurrentHistoryView = _super.extend(
/** @lends CurrentHistoryView.prototype */{
    className: _super.prototype.className + " current-history-panel",

    /** override to use drilldown (and not foldout) for how collections are displayed */
    HDCAViewClass: _super.prototype.HDCAViewClass.extend({
        foldoutStyle: "drilldown"
    }),

    emptyMsg: [(0, _localization2.default)("This history is empty"), ". ", (0, _localization2.default)("You can "), '<a class="uploader-link" href="javascript:void(0)">', (0, _localization2.default)("load your own data"), "</a>", (0, _localization2.default)(" or "), '<a class="get-data-link" href="javascript:void(0)">', (0, _localization2.default)("get data from an external source"), "</a>"].join(""),

    // ......................................................................... SET UP
    /** Set up the view, set up storage, bind listeners to HistoryContents events */
    initialize: function initialize(attributes) {
        attributes = attributes || {};

        // ---- persistent preferences
        /** maintain state / preferences over page loads */
        this.preferences = new HistoryViewPrefs(_.extend({
            id: HistoryViewPrefs.storageKey()
        }, _.pick(attributes, _.keys(HistoryViewPrefs.prototype.defaults))));

        _super.prototype.initialize.call(this, attributes);

        /** sub-views that will overlay this panel (collections) */
        this.panelStack = [];

        /** id of currently focused content */
        this.currentContentId = attributes.currentContentId || null;
        //NOTE: purposely not sent to localstorage since panel recreation roughly lines up with a reset of this value
    },

    /** Override to cache the current scroll position with a listener */
    _setUpListeners: function _setUpListeners() {
        _super.prototype._setUpListeners.call(this);

        var panel = this;
        // reset scroll position when there's a new history
        this.on("new-model", function () {
            panel.preferences.set("scrollPosition", 0);
        });
    },

    // ------------------------------------------------------------------------ loading history/item models
    // TODO: next three more appropriate moved to the app level
    /** (re-)loads the user's current history & contents w/ details */
    loadCurrentHistory: function loadCurrentHistory() {
        return this.loadHistory(null, {
            url: Galaxy.root + "history/current_history_json"
        });
    },

    /** loads a history & contents w/ details and makes them the current history */
    switchToHistory: function switchToHistory(historyId, attributes) {
        if (Galaxy.user.isAnonymous()) {
            this.trigger("error", (0, _localization2.default)("You must be logged in to switch histories"), (0, _localization2.default)("Anonymous user"));
            return $.when();
        }
        return this.loadHistory(historyId, {
            url: Galaxy.root + "history/set_as_current?id=" + historyId
        });
    },

    /** creates a new history on the server and sets it as the user's current history */
    createNewHistory: function createNewHistory(attributes) {
        if (Galaxy.user.isAnonymous()) {
            this.trigger("error", (0, _localization2.default)("You must be logged in to create histories"), (0, _localization2.default)("Anonymous user"));
            return $.when();
        }
        return this.loadHistory(null, {
            url: Galaxy.root + "history/create_new_current"
        });
    },

    /** release/free/shutdown old models and set up panel for new models */
    setModel: function setModel(model, attributes, render) {
        _super.prototype.setModel.call(this, model, attributes, render);
        if (this.model && this.model.id) {
            this.log("checking for updates");
            this.model.checkForUpdates();
        }
        return this;
    },

    // ------------------------------------------------------------------------ history/content event listening
    /** listening for history events */
    _setUpModelListeners: function _setUpModelListeners() {
        _super.prototype._setUpModelListeners.call(this);
        // re-broadcast any model change events so that listeners don't have to re-bind to each history
        return this.listenTo(this.model, {
            "change:nice_size change:size": function changeNice_sizeChangeSize() {
                this.trigger("history-size-change", this, this.model, arguments);
            },
            "change:id": function changeId() {
                this.once("loading-done", function () {
                    this.model.checkForUpdates();
                });
            }
        });
    },

    /** listening for collection events */
    _setUpCollectionListeners: function _setUpCollectionListeners() {
        _super.prototype._setUpCollectionListeners.call(this);
        // if a hidden item is created (gen. by a workflow), moves thru the updater to the ready state,
        //  then: remove it from the collection if the panel is set to NOT show hidden datasets
        this.listenTo(this.collection, "state:ready", function (model, newState, oldState) {
            if (!model.get("visible") && !this.collection.storage.includeHidden()) {
                this.removeItemView(model);
            }
        });
    },

    // ------------------------------------------------------------------------ panel rendering
    /** override to add a handler to capture the scroll position when the parent scrolls */
    _setUpBehaviors: function _setUpBehaviors($where) {
        $where = $where || this.$el;
        // console.log( '_setUpBehaviors', this.$scrollContainer( $where ).get(0), this.$list( $where ) );
        // we need to call this in _setUpBehaviors which is called after render since the $el
        // may not be attached to $el.parent and $scrollContainer() may not work
        var panel = this;
        _super.prototype._setUpBehaviors.call(panel, $where);

        // cache the handler to remove and re-add so we don't pile up the handlers
        if (!this._debouncedScrollCaptureHandler) {
            this._debouncedScrollCaptureHandler = _.debounce(function scrollCapture() {
                // cache the scroll position (only if visible)
                if (panel.$el.is(":visible")) {
                    panel.preferences.set("scrollPosition", $(this).scrollTop());
                }
            }, 40);
        }

        panel.$scrollContainer($where).off("scroll", this._debouncedScrollCaptureHandler).on("scroll", this._debouncedScrollCaptureHandler);
        return panel;
    },

    /** In this override, handle null models and move the search input to the top */
    _buildNewRender: function _buildNewRender() {
        if (!this.model) {
            return $();
        }
        var $newRender = _super.prototype._buildNewRender.call(this);
        $newRender.find(".search").prependTo($newRender.find("> .controls"));
        this._renderQuotaMessage($newRender);
        return $newRender;
    },

    /** render the message displayed when a user is over quota and can't run jobs */
    _renderQuotaMessage: function _renderQuotaMessage($whereTo) {
        $whereTo = $whereTo || this.$el;
        return $(this.templates.quotaMsg({}, this)).prependTo($whereTo.find(".messages"));
    },

    /** In this override, get and set current panel preferences when editor is used */
    _renderTags: function _renderTags($where) {
        var panel = this;
        // render tags and show/hide based on preferences
        _super.prototype._renderTags.call(panel, $where);
        if (panel.preferences.get("tagsEditorShown")) {
            panel.tagsEditor.toggle(true);
        }
        // store preference when shown or hidden
        panel.listenTo(panel.tagsEditor, "hiddenUntilActivated:shown hiddenUntilActivated:hidden", function (tagsEditor) {
            panel.preferences.set("tagsEditorShown", tagsEditor.hidden);
        });
    },

    /** In this override, get and set current panel preferences when editor is used */
    _renderAnnotation: function _renderAnnotation($where) {
        var panel = this;
        // render annotation and show/hide based on preferences
        _super.prototype._renderAnnotation.call(panel, $where);
        if (panel.preferences.get("annotationEditorShown")) {
            panel.annotationEditor.toggle(true);
        }
        // store preference when shown or hidden
        panel.listenTo(panel.annotationEditor, "hiddenUntilActivated:shown hiddenUntilActivated:hidden", function (annotationEditor) {
            panel.preferences.set("annotationEditorShown", annotationEditor.hidden);
        });
    },

    /** Override to scroll to cached position (in prefs) after swapping */
    _swapNewRender: function _swapNewRender($newRender) {
        _super.prototype._swapNewRender.call(this, $newRender);
        var panel = this;
        _.delay(function () {
            var pos = panel.preferences.get("scrollPosition");
            if (pos) {
                panel.scrollTo(pos, 0);
            }
        }, 10);
        //TODO: is this enough of a delay on larger histories?

        return this;
    },

    // ------------------------------------------------------------------------ sub-views
    /** Override to add the current-content highlight class to currentContentId's view */
    _attachItems: function _attachItems($whereTo) {
        _super.prototype._attachItems.call(this, $whereTo);
        var panel = this;
        if (panel.currentContentId) {
            panel._setCurrentContentById(panel.currentContentId);
        }
        return this;
    },

    /** Override to remove any drill down panels */
    addItemView: function addItemView(model, collection, options) {
        var view = _super.prototype.addItemView.call(this, model, collection, options);
        if (!view) {
            return view;
        }
        if (this.panelStack.length) {
            return this._collapseDrilldownPanel();
        }
        return view;
    },

    // ------------------------------------------------------------------------ collection sub-views
    /** In this override, add/remove expanded/collapsed model ids to/from web storage */
    _setUpItemViewListeners: function _setUpItemViewListeners(view) {
        var panel = this;
        _super.prototype._setUpItemViewListeners.call(panel, view);
        // use pub-sub to: handle drilldown expansion and collapse
        return panel.listenTo(view, {
            "expanded:drilldown": function expandedDrilldown(v, drilldown) {
                this._expandDrilldownPanel(drilldown);
            },
            "collapsed:drilldown": function collapsedDrilldown(v, drilldown) {
                this._collapseDrilldownPanel(drilldown);
            }
        });
    },

    /** display 'current content': add a visible highlight and store the id of a content item */
    setCurrentContent: function setCurrentContent(view) {
        this.$(".history-content.current-content").removeClass("current-content");
        if (view) {
            view.$el.addClass("current-content");
            this.currentContentId = view.model.id;
        } else {
            this.currentContentId = null;
        }
    },

    /** find the view with the id and then call setCurrentContent on it */
    _setCurrentContentById: function _setCurrentContentById(id) {
        var view = this.viewFromModelId(id) || null;
        this.setCurrentContent(view);
    },

    /** Handle drill down by hiding this panels list and controls and showing the sub-panel */
    _expandDrilldownPanel: function _expandDrilldownPanel(drilldown) {
        this.panelStack.push(drilldown);
        // hide this panel's controls and list, set the name for back navigation, and attach to the $el
        this.$controls().add(this.$list()).hide();
        drilldown.parentName = this.model.get("name");
        drilldown.delegateEvents().render().$el.appendTo(this.$el);
    },

    /** Handle drilldown close by freeing the panel and re-rendering this panel */
    _collapseDrilldownPanel: function _collapseDrilldownPanel(drilldown) {
        this.panelStack.pop();
        //TODO: MEM: free the panel
        this.$controls().add(this.$list()).show();
    },

    // ........................................................................ panel events
    /** event map */
    events: _.extend(_.clone(_super.prototype.events), {
        // the two links in the empty message
        "click .uploader-link": function clickUploaderLink(ev) {
            Galaxy.upload.show(ev);
        },
        "click .get-data-link": function clickGetDataLink(ev) {
            var $toolMenu = $(".toolMenuContainer");
            $toolMenu.parent().scrollTop(0);
            $toolMenu.find('span:contains("Get Data")').click();
        }
    }),

    // ........................................................................ external objects/MVC
    listenToGalaxy: function listenToGalaxy(galaxy) {
        this.listenTo(galaxy, {
            // when the galaxy_main iframe is loaded with a new page,
            // compare the url to the following list and if there's a match
            // pull the id from url and indicate in the history view that
            // the dataset with that id is the 'current'ly active dataset
            "center-frame:load": function centerFrameLoad(data) {
                var pathToMatch = data.fullpath;
                var hdaId = null;
                var useToURLRegexMap = {
                    display: /datasets\/([a-f0-9]+)\/display/,
                    edit: /datasets\/([a-f0-9]+)\/edit/,
                    report_error: /dataset\/errors\?id=([a-f0-9]+)/,
                    rerun: /tool_runner\/rerun\?id=([a-f0-9]+)/,
                    show_params: /datasets\/([a-f0-9]+)\/show_params/
                    // no great way to do this here? (leave it in the dataset event handlers above?)
                    // 'visualization' : 'visualization',
                };
                _.find(useToURLRegexMap, function (regex, use) {
                    // grab the more specific match result (1), save, and use it as the find flag
                    hdaId = _.result(pathToMatch.match(regex), 1);
                    return hdaId;
                });
                // need to type mangle to go from web route to history contents
                this._setCurrentContentById(hdaId ? "dataset-" + hdaId : null);
            },
            // when the center panel is given a new view, clear the current indicator
            "center-panel:load": function centerPanelLoad(view) {
                try {
                    var hdaId = view.model.attributes.dataset_id || null;
                    if (hdaId === null) {
                        throw "Invalid id";
                    }
                    this._setCurrentContentById("dataset-" + hdaId);
                } catch (e) {
                    this._setCurrentContentById();
                }
            },
            "activate-hda": function activateHda(hdaId) {
                this._setCurrentContentById("dataset-" + hdaId);
            }
        });
    },

    //TODO: remove quota meter from panel and remove this
    /** add listeners to an external quota meter (mvc/user/user-quotameter.js) */
    connectToQuotaMeter: function connectToQuotaMeter(quotaMeter) {
        if (!quotaMeter) {
            return this;
        }
        // show/hide the 'over quota message' in the history when the meter tells it to
        this.listenTo(quotaMeter, "quota:over", this.showQuotaMessage);
        this.listenTo(quotaMeter, "quota:under", this.hideQuotaMessage);

        // having to add this to handle re-render of hview while overquota (the above do not fire)
        this.on("rendered rendered:initial", function () {
            if (quotaMeter && quotaMeter.isOverQuota()) {
                this.showQuotaMessage();
            }
        });
        return this;
    },

    /** Override to preserve the quota message */
    clearMessages: function clearMessages(ev) {
        var $target = !_.isUndefined(ev) ? $(ev.currentTarget) : this.$messages().children('[class$="message"]');
        $target = $target.not(".quota-message");
        $target.fadeOut(this.fxSpeed, function () {
            $(this).remove();
        });
        return this;
    },

    /** Show the over quota message (which happens to be in the history panel).
     */
    showQuotaMessage: function showQuotaMessage() {
        var $msg = this.$(".quota-message");
        if ($msg.is(":hidden")) {
            $msg.slideDown(this.fxSpeed);
        }
    },

    /** Hide the over quota message (which happens to be in the history panel).
     */
    hideQuotaMessage: function hideQuotaMessage() {
        var $msg = this.$(".quota-message");
        if (!$msg.is(":hidden")) {
            $msg.slideUp(this.fxSpeed);
        }
    },

    // ........................................................................ options menu
    //TODO: remove to batch
    /** unhide any hidden datasets */
    unhideHidden: function unhideHidden() {
        var self = this;
        if (window.confirm((0, _localization2.default)("Really unhide all hidden datasets?"))) {
            // get all hidden, regardless of deleted/purged
            return self.model.contents._filterAndUpdate({ visible: false, deleted: "", purged: "" }, { visible: true }).done(function () {
                // TODO: would be better to render these as they're unhidden instead of all at once
                if (!self.model.contents.includeHidden) {
                    self.renderItems();
                }
            });
        }
        return $.when();
    },

    /** delete any hidden datasets */
    deleteHidden: function deleteHidden() {
        var self = this;
        if (window.confirm((0, _localization2.default)("Really delete all hidden datasets?"))) {
            return self.model.contents._filterAndUpdate(
            // get all hidden, regardless of deleted/purged
            { visible: false, deleted: "", purged: "" },
            // both delete *and* unhide them
            { deleted: true, visible: true });
        }
        return $.when();
    },

    /** Return a string rep of the history */
    toString: function toString() {
        return "CurrentHistoryView(" + (this.model ? this.model.get("name") : "") + ")";
    }
});

//------------------------------------------------------------------------------ TEMPLATES
CurrentHistoryView.prototype.templates = function () {
    var quotaMsgTemplate = _baseMvc2.default.wrapTemplate(['<div class="quota-message errormessage">', (0, _localization2.default)("You are over your disk quota"), ". ", (0, _localization2.default)("Tool execution is on hold until your disk usage drops below your allocated quota"), ".", "</div>"], "history");
    return _.extend(_.clone(_super.prototype.templates), {
        quotaMsg: quotaMsgTemplate
    });
}();

//==============================================================================
exports.default = {
    CurrentHistoryView: CurrentHistoryView
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Sharing_vue_vue_type_template_id_4faa81d0__ = __webpack_require__(699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Sharing_vue_vue_type_script_lang_js__ = __webpack_require__(418);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__Sharing_vue_vue_type_script_lang_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__Sharing_vue_vue_type_script_lang_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sharing_vue_vue_type_style_index_0_lang_css__ = __webpack_require__(701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(17);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__Sharing_vue_vue_type_script_lang_js__["default"],
  __WEBPACK_IMPORTED_MODULE_0__Sharing_vue_vue_type_template_id_4faa81d0__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Sharing_vue_vue_type_template_id_4faa81d0__["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Sharing_vue_vue_type_template_id_4faa81d0__ = __webpack_require__(700);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Sharing_vue_vue_type_template_id_4faa81d0__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Sharing_vue_vue_type_template_id_4faa81d0__["b"]; });


/***/ }),
/* 700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ready)?_c('div',[_c('h2',[_vm._v("Share or Publish "+_vm._s(_vm.model_class)+" `"+_vm._s(_vm.item.title)+"`")]),_vm._v(" "),_c('b-alert',{attrs:{"show":_vm.show_danger,"variant":"danger","dismissible":""}},[_vm._v("\n        "+_vm._s(_vm.err_msg)+"\n    ")]),_vm._v(" "),_c('br'),_vm._v(" "),(!_vm.has_username)?_c('div',[_c('div',[_vm._v("To make a "+_vm._s(_vm.model_class_lc)+" accessible via link or publish it, you must create a public username:")]),_vm._v(" "),_c('form',{staticClass:"form-group",on:{"submit":function($event){$event.preventDefault();_vm.setUsername()}}},[_c('label'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.new_username),expression:"new_username"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.new_username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.new_username=$event.target.value}}})]),_vm._v(" "),_c('b-button',{attrs:{"type":"submit","variant":"primary"},on:{"click":function($event){_vm.setUsername()}}},[_vm._v("Set Username")])],1):_c('div',[_c('br'),_vm._v(" "),_c('h3',[_vm._v("Make "+_vm._s(_vm.model_class)+" Accessible via Link and Publish It")]),_vm._v(" "),(_vm.item.importable)?_c('div',[_vm._v("\n            This "+_vm._s(_vm.model_class_lc)+" is currently "),_c('strong',[_vm._v(_vm._s(_vm.item_status))]),_vm._v(".\n            "),_c('div',[_c('p',[_vm._v("Anyone can view and import this "+_vm._s(_vm.model_class_lc)+" by visiting the following URL:")]),_vm._v(" "),_c('blockquote',[_c('a',{attrs:{"id":"item-url","href":_vm.item_url,"target":"_top"}},[_vm._v(_vm._s(_vm.item_url))]),_vm._v(" "),_c('span',{staticStyle:{"display":"none"},attrs:{"id":"item-url-text"}},[_vm._v("\n                        "+_vm._s(_vm.item_url_parts[0])),_c('span',{attrs:{"id":"item-identifier"}},[_vm._v(_vm._s(_vm.item_url_parts[1]))])]),_vm._v(" "),_c('a',{attrs:{"href":"#","id":"edit-identifier"}},[_c('img',{attrs:{"src":_vm.pencil_url}})])]),_vm._v(" "),(_vm.item.published)?_c('div',[_c('p',[_vm._v("This "+_vm._s(_vm.model_class_lc)+" is publicly listed and searchable in Galaxy's "),_c('a',{attrs:{"href":_vm.published_url,"target":"_top"}},[_vm._v("Published "+_vm._s(_vm.plural_name))]),_vm._v(" section.")]),_vm._v(" "),_c('p',[_vm._v("You can:")])]):_vm._e()]),_vm._v(" "),(!_vm.item.published)?_c('div',[_c('b-button',{on:{"click":function($event){_vm.setSharing('disable_link_access')}}},[_vm._v("Disable Access to "+_vm._s(_vm.model_class)+" Link")]),_vm._v(" "),_c('div',{staticClass:"toolParamHelp"},[_vm._v("Disables "+_vm._s(_vm.model_class_lc)+"'s link so that it is not accessible.")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-button',{attrs:{"id":"make_accessible_and_publish"},on:{"click":function($event){_vm.setSharing('publish')}}},[_vm._v("Publish "+_vm._s(_vm.model_class))]),_vm._v(" "),_c('div',{staticClass:"toolParamHelp"},[_vm._v("Publishes the "+_vm._s(_vm.model_class_lc)+" to Galaxy's "),_c('a',{attrs:{"href":_vm.published_url,"target":"_top"}},[_vm._v("Published "+_vm._s(_vm.plural_name))]),_vm._v(" section, where it is publicly listed and searchable.")]),_vm._v(" "),_c('br')],1):_c('div',[_c('b-button',{attrs:{"id":"disable_link_access_and_unpublish"},on:{"click":function($event){_vm.setSharing('disable_link_access_and_unpublish')}}},[_vm._v("Disable Access to "+_vm._s(_vm.model_class)+" via Link and Unpublish")]),_vm._v(" "),_c('div',{staticClass:"toolParamHelp"},[_vm._v("Disables this "+_vm._s(_vm.model_class_lc)+"'s link so that it is not accessible and removes "+_vm._s(_vm.model_class_lc)+" from Galaxy's "),_c('a',{attrs:{"href":_vm.published_url,"target":"_top"}},[_vm._v("Published "+_vm._s(_vm.plural_name))]),_vm._v(" section so that it is not publicly listed or searchable.")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-button',{on:{"click":function($event){_vm.setSharing('unpublish')}}},[_vm._v("Unpublish "+_vm._s(_vm.model_class))]),_vm._v(" "),_c('div',{staticClass:"toolParamHelp"},[_vm._v("Removes this "+_vm._s(_vm.model_class_lc)+" from Galaxy's "),_c('a',{attrs:{"href":_vm.published_url,"target":"_top"}},[_vm._v("Published "+_vm._s(_vm.plural_name))]),_vm._v(" section so that it is not publicly listed or searchable.")])],1)]):_c('div',[_c('p',[_vm._v("This "+_vm._s(_vm.model_class_lc)+" is currently restricted so that only you and the users listed below can access it. You can:")]),_vm._v(" "),_c('b-button',{on:{"click":function($event){_vm.setSharing('make_accessible_via_link')}}},[_vm._v("Make "+_vm._s(_vm.model_class)+" Accessible via Link")]),_vm._v(" "),(_vm.has_possible_members)?_c('span',{staticClass:"chkk"},[_vm._v("\n            Also make all objects within the "+_vm._s(_vm.model_class)+" accessible.\n            "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.make_members_public),expression:"make_members_public"}],attrs:{"type":"checkbox","id":"chk_make_members_public"},domProps:{"checked":Array.isArray(_vm.make_members_public)?_vm._i(_vm.make_members_public,null)>-1:(_vm.make_members_public)},on:{"change":function($event){var $$a=_vm.make_members_public,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.make_members_public=$$a.concat([$$v]))}else{$$i>-1&&(_vm.make_members_public=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.make_members_public=$$c}}}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"toolParamHelp"},[_vm._v("Generates a web link that you can share with other people so that they can view and import the "+_vm._s(_vm.model_class_lc)+".")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-button',{attrs:{"id":"make_accessible_and_publish"},on:{"click":function($event){_vm.setSharing('make_accessible_and_publish')}}},[_vm._v("Make "+_vm._s(_vm.model_class)+" Accessible and Publish")]),_vm._v(" "),(_vm.has_possible_members)?_c('span',{staticClass:"chkk"},[_vm._v("\n            Also make all objects within the "+_vm._s(_vm.model_class)+" accessible.\n            "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.make_members_public),expression:"make_members_public"}],attrs:{"type":"checkbox","id":"chk_make_members_public"},domProps:{"checked":Array.isArray(_vm.make_members_public)?_vm._i(_vm.make_members_public,null)>-1:(_vm.make_members_public)},on:{"change":function($event){var $$a=_vm.make_members_public,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.make_members_public=$$a.concat([$$v]))}else{$$i>-1&&(_vm.make_members_public=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.make_members_public=$$c}}}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"toolParamHelp"},[_vm._v("Makes the "+_vm._s(_vm.model_class_lc)+" accessible via link (see above) and publishes the "+_vm._s(_vm.model_class_lc)+" to Galaxy's "),_c('a',{attrs:{"href":_vm.published_url,"target":"_top"}},[_vm._v("Published "+_vm._s(_vm.plural_name))]),_vm._v(" section, where it is publicly listed and searchable.")])],1),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Share "+_vm._s(_vm.model_class)+" with Individual Users")]),_vm._v(" "),_c('div',[(_vm.item.users_shared_with && _vm.item.users_shared_with.length > 0)?_c('div',[_c('b-table',{attrs:{"small":"","caption-top":"","fields":_vm.share_fields,"items":_vm.item.users_shared_with},scopedSlots:_vm._u([{key:"id",fn:function(cell){return [_c('b-button',{staticClass:"unshare_user",attrs:{"size":"sm"},on:{"click":function($event){$event.stopPropagation();_vm.setSharing('unshare_user', cell.value )}}},[_vm._v("Remove")])]}}])},[_c('template',{slot:"table-caption"},[_vm._v(" The following users will see this "+_vm._s(_vm.model_class_lc)+" in their "+_vm._s(_vm.model_class_lc)+" list and will be able to view, import and run it. ")])],2)],1):_c('div',[_c('p',[_vm._v("You have not shared this "+_vm._s(_vm.model_class_lc)+" with any users.")])]),_vm._v(" "),_c('b-button',{attrs:{"href":_vm.share_url,"id":"share_with_a_user"}},[_c('span',[_vm._v("Share with a user")])])],1)])],1):_vm._e()}
var staticRenderFns = []



/***/ }),
/* 701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Sharing_vue_vue_type_style_index_0_lang_css__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Sharing_vue_vue_type_style_index_0_lang_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Sharing_vue_vue_type_style_index_0_lang_css__);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Sharing_vue_vue_type_style_index_0_lang_css___default.a); 

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(26)(false);
// imports


// module
exports.push([module.i, ".chkk{display:inline-block}", ""]);

// exports


/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Backbone, $, _) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _localization = __webpack_require__(3);

var _localization2 = _interopRequireDefault(_localization);

var _formView = __webpack_require__(30);

var _formView2 = _interopRequireDefault(_formView);

var _uiMisc = __webpack_require__(11);

var _uiMisc2 = _interopRequireDefault(_uiMisc);

var _queryStringParsing = __webpack_require__(35);

var _queryStringParsing2 = _interopRequireDefault(_queryStringParsing);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** Contains descriptive dictionaries describing user forms */
var Model = Backbone.Model.extend({
    initialize: function initialize(options) {
        options = options || {};
        options.user_id = options.user_id || Galaxy.user.id;
        this.set({
            user_id: options.user_id,
            information: {
                title: (0, _localization2.default)("Manage information"),
                description: "Edit your email, addresses and custom parameters or change your username.",
                url: "api/users/" + options.user_id + "/information/inputs",
                icon: "fa-user",
                redirect: "user"
            },
            password: {
                title: (0, _localization2.default)("Change password"),
                description: (0, _localization2.default)("Allows you to change your login credentials."),
                icon: "fa-unlock-alt",
                url: "api/users/" + options.user_id + "/password/inputs",
                submit_title: "Save password",
                redirect: "user"
            },
            communication: {
                title: (0, _localization2.default)("Change communication settings"),
                description: (0, _localization2.default)("Enable or disable the communication feature to chat with other users."),
                url: "api/users/" + options.user_id + "/communication/inputs",
                icon: "fa-comments-o",
                redirect: "user"
            },
            permissions: {
                title: (0, _localization2.default)("Set dataset permissions for new histories"),
                description: "Grant others default access to newly created histories. Changes made here will only affect histories created after these settings have been stored.",
                url: "api/users/" + options.user_id + "/permissions/inputs",
                icon: "fa-users",
                submit_title: "Save permissions",
                redirect: "user"
            },
            api_key: {
                title: (0, _localization2.default)("Manage API key"),
                description: (0, _localization2.default)("Access your current API key or create a new one."),
                url: "api/users/" + options.user_id + "/api_key/inputs",
                icon: "fa-key",
                submit_title: "Create a new key",
                submit_icon: "fa-check"
            },
            toolbox_filters: {
                title: (0, _localization2.default)("Manage Toolbox filters"),
                description: (0, _localization2.default)("Customize your Toolbox by displaying or omitting sets of Tools."),
                url: "api/users/" + options.user_id + "/toolbox_filters/inputs",
                icon: "fa-filter",
                submit_title: "Save filters",
                redirect: "user"
            },
            openids: {
                title: (0, _localization2.default)("Manage OpenIDs"),
                description: (0, _localization2.default)("Associate OpenIDs with your account."),
                icon: "fa-openid",
                onclick: function onclick() {
                    Galaxy.page.router.push(Galaxy.root + "openids/list");
                }
            },
            custom_builds: {
                title: (0, _localization2.default)("Manage custom builds"),
                description: (0, _localization2.default)("Add or remove custom builds using history datasets."),
                icon: "fa-cubes",
                onclick: function onclick() {
                    Galaxy.page.router.push(Galaxy.root + "custom_builds");
                }
            },
            logout: {
                title: (0, _localization2.default)("Sign out"),
                description: (0, _localization2.default)("Click here to sign out of all sessions."),
                icon: "fa-sign-out",
                onclick: function onclick() {
                    Galaxy.modal.show({
                        title: (0, _localization2.default)("Sign out"),
                        body: "Do you want to continue and sign out of all active sessions?",
                        buttons: {
                            Cancel: function Cancel() {
                                Galaxy.modal.hide();
                            },
                            "Sign out": function SignOut() {
                                window.location.href = Galaxy.root + "user/logout?session_csrf_token=" + Galaxy.session_csrf_token;
                            }
                        }
                    });
                }
            }
        });
    }
});

/** View of the main user preference panel with links to individual user forms */

/** User Preferences view */
var View = Backbone.View.extend({
    title: (0, _localization2.default)("User Preferences"),
    active_tab: "user",
    initialize: function initialize() {
        this.model = new Model();
        this.setElement("<div/>");
        this.render();
    },

    render: function render() {
        var self = this;
        var config = Galaxy.config;
        $.getJSON(Galaxy.root + "api/users/" + Galaxy.user.id, function (data) {
            self.$preferences = $("<div/>").addClass("ui-panel").append($("<h2/>").append("User preferences")).append($("<p/>").append("You are logged in as <strong>" + _.escape(data.email) + "</strong>.")).append(self.$table = $("<table/>").addClass("ui-panel-table"));
            var message = _queryStringParsing2.default.get("message");
            var status = _queryStringParsing2.default.get("status");
            if (message && status) {
                self.$preferences.prepend(new _uiMisc2.default.Message({ message: message, status: status }).$el);
            }
            if (!config.use_remote_user) {
                self._addLink("information");
                self._addLink("password");
            }
            if (config.enable_communication_server) {
                self._addLink("communication");
            }
            self._addLink("custom_builds");
            self._addLink("permissions");
            self._addLink("api_key");
            if (config.has_user_tool_filters) {
                self._addLink("toolbox_filters");
            }
            if (config.enable_openid && !config.use_remote_user) {
                self._addLink("openids");
            }
            if (Galaxy.session_csrf_token) {
                self._addLink("logout");
            }
            self.$preferences.append(self._templateFooter(data));
            self.$el.empty().append(self.$preferences);
        });
    },

    _addLink: function _addLink(action) {
        var options = this.model.get(action);
        var $row = $(this._templateLink(options));
        var $a = $row.find("a");
        if (options.onclick) {
            $a.on("click", function () {
                options.onclick();
            });
        } else {
            $a.attr("href", Galaxy.root + "user/" + action);
        }
        this.$table.append($row);
    },

    _templateLink: function _templateLink(options) {
        return "<tr><td><div class=\"ui-panel-icon fa " + options.icon + "\"></td><td><a class=\"ui-panel-anchor\" href=\"javascript:void(0)\">" + options.title + "</a><div class=\"ui-form-info\">" + options.description + "</div></td></tr>";
    },

    _templateFooter: function _templateFooter(options) {
        return "<p class=\"ui-panel-footer\">You are using <strong>" + options.nice_total_disk_usage + "</strong> of disk space in this Galaxy instance. " + (Galaxy.config.enable_quotas ? "Your disk quota is: <strong>" + options.quota + "</strong>. " : "") + "Is your usage more than expected? See the <a href=\"https://galaxyproject.org/learn/managing-datasets/\" target=\"_blank\">documentation</a> for tips on how to find all of the data in your account.</p>";
    }
});

exports.default = {
    View: View,
    Model: Model
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(0), __webpack_require__(1)))

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Backbone, $) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _localization = __webpack_require__(3);

var _localization2 = _interopRequireDefault(_localization);

var _utils = __webpack_require__(5);

var _utils2 = _interopRequireDefault(_utils);

var _uiMisc = __webpack_require__(11);

var _uiMisc2 = _interopRequireDefault(_uiMisc);

var _formView = __webpack_require__(30);

var _formView2 = _interopRequireDefault(_formView);

var _uiTable = __webpack_require__(705);

var _uiTable2 = _interopRequireDefault(_uiTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** This class renders the chart configuration form. */
var Collection = Backbone.Collection.extend({
    comparator: function comparator(a, b) {
        a = a.get("name");
        b = b.get("name");
        return a > b ? 1 : a < b ? -1 : 0;
    }
});

var View = Backbone.View.extend({
    initialize: function initialize(options) {
        var self = this;
        this.active_tab = "user";
        var history_id = Galaxy.currHistoryPanel && Galaxy.currHistoryPanel.model.id;
        this.model = new Backbone.Model();
        this.model.url = Galaxy.root + "api/histories/" + history_id + "/custom_builds_metadata";
        this.collection = new Collection();
        this.collection.url = Galaxy.root + "api/users/" + Galaxy.user.id + "/custom_builds";
        this.message = new _uiMisc2.default.Message({});
        this.installed_builds = new _uiMisc2.default.Select.View({
            optional: true,
            onchange: function onchange() {
                self.installed_builds.value(null);
            },
            empty_text: "List of available builds:",
            error_text: "No system installed builds available."
        });
        this.table = new _uiTable2.default.View({ cls: "grid", selectable: false });
        this.table.addHeader("Name");
        this.table.addHeader("Key");
        this.table.addHeader("Number of chroms/contigs");
        this.table.addHeader("");
        this.table.appendHeader();
        this.setElement($("<div/>").append($("<h4/>").text("Current Custom Builds")).append(this.table.$el).append(this.$installed = $("<div/>").append($("<h4/>").text("System Installed Builds").addClass("ui-margin-top")).append(this.installed_builds.$el)).append($("<h4/>").text("Add a Custom Build").addClass("ui-margin-top")).append($("<span/>").addClass("ui-column").append($("<div/>").addClass("ui-column-left").append(this.message.$el).append(this.$form = $("<div/>").addClass("ui-margin-top"))).append(this.$help = $("<div/>").addClass("ui-column-right"))));
        this.listenTo(this.collection, "add remove reset", function () {
            self._renderTable();
        });
        this.listenTo(this.model, "change", function () {
            self._renderForm();
        });
        this.collection.fetch();
        this.model.fetch();
    },

    render: function render() {
        this._renderTable();
        this._renderForm();
    },

    _renderTable: function _renderTable() {
        var self = this;
        this.table.delAll();
        this.collection.sort();
        this.collection.each(function (model) {
            self.table.add(model.get("name"));
            self.table.add(model.id);
            self.table.add(model.get("count") !== undefined ? model.get("count") : "Processing...");
            self.table.add(new _uiMisc2.default.ButtonIcon({
                icon: "fa-trash-o",
                cls: "ui-button-icon-plain",
                tooltip: (0, _localization2.default)("Delete custom build."),
                onclick: function onclick() {
                    model.destroy();
                }
            }).$el);
            self.table.append(model.id);
        });
    },

    _renderForm: function _renderForm() {
        var self = this;
        var initial_type = "fasta";
        var form = new _formView2.default({
            inputs: [{
                type: "text",
                name: "name",
                label: "Name",
                help: "Specify a build name e.g. Hamster."
            }, {
                type: "text",
                name: "id",
                label: "Key",
                help: "Specify a build key e.g. hamster_v1."
            }, {
                name: "len",
                type: "conditional",
                test_param: {
                    name: "type",
                    label: "Definition",
                    help: (0, _localization2.default)("Provide the data source."),
                    type: "select",
                    value: initial_type,
                    data: [{
                        value: "fasta",
                        label: "FASTA-file from history"
                    }, {
                        value: "file",
                        label: "Len-file from disk"
                    }, {
                        value: "text",
                        label: "Len-file by copy/paste"
                    }]
                },
                cases: [{
                    value: "fasta",
                    inputs: [{
                        type: "select",
                        name: "value",
                        label: "FASTA-file",
                        data: this.model.get("fasta_hdas")
                    }]
                }, {
                    value: "file",
                    inputs: [{
                        type: "upload",
                        name: "value",
                        label: "Len-file",
                        data: this.model.get("len_hdas")
                    }]
                }, {
                    value: "text",
                    inputs: [{
                        type: "text",
                        area: true,
                        name: "value",
                        label: "Edit/Paste"
                    }]
                }]
            }],
            buttons: {
                save: new _uiMisc2.default.Button({
                    icon: "fa-save",
                    tooltip: (0, _localization2.default)("Create new Build"),
                    title: (0, _localization2.default)("Save"),
                    cls: "btn btn-primary ui-clear-float",
                    onclick: function onclick() {
                        var data = form.data.create();
                        if (!data.id || !data.name) {
                            self.message.update({
                                message: "All inputs are required.",
                                status: "danger"
                            });
                        } else {
                            self.collection.create(data, {
                                wait: true,
                                success: function success(response) {
                                    if (response.get("message")) {
                                        self.message.update({
                                            message: response.get("message"),
                                            status: "warning"
                                        });
                                    } else {
                                        self.message.update({
                                            message: "Successfully added a new custom build.",
                                            status: "success"
                                        });
                                    }
                                },
                                error: function error(response, err) {
                                    var message = err && err.responseJSON && err.responseJSON.err_msg;
                                    self.message.update({
                                        message: message || "Failed to create custom build.",
                                        status: "danger"
                                    });
                                }
                            });
                        }
                    }
                })
            },
            onchange: function onchange() {
                var input_id = form.data.match("len|type");
                if (input_id) {
                    var input_field = form.field_list[input_id];
                    self._renderHelp(input_field.value());
                }
            }
        });
        this.$form.empty().append(form.$el);
        var installed_builds = this.model.get("installed_builds");
        if (installed_builds && installed_builds.length) {
            this.$installed.show();
            this.installed_builds.update(this.model.get("installed_builds"));
        } else {
            this.$installed.hide();
        }
        this._renderHelp(initial_type);
    },

    _renderHelp: function _renderHelp(len_type) {
        this.$help.empty().addClass("alert alert-info").html(len_type == "fasta" ? this._templateFasta() : this._templateLen());
    },

    _templateLen: function _templateLen() {
        return "<h4>Length Format</h4>" + "<p>" + "The length format is two-column, separated by whitespace, of the form:" + "<pre>chrom/contig   length of chrom/contig</pre>" + "</p>" + "<p>" + "For example, the first few entries of <em>mm9.len</em> are as follows:" + "<pre>" + "chr1    197195432\n" + "chr2    181748087\n" + "chr3    159599783\n" + "chr4    155630120\n" + "chr5    152537259" + "</pre>" + "</p>" + "<p>Trackster uses this information to populate the select box for chrom/contig, and" + "to set the maximum basepair of the track browser. You may either upload a .len file" + "of this format (Len File option), or directly enter the information into the box " + "(Len Entry option).</p>";
    },

    _templateFasta: function _templateFasta() {
        return "<h4>FASTA format</h4>" + "<p>" + "This is a multi-fasta file from your current history that provides the genome" + "sequences for each chromosome/contig in your build." + "</p>" + "<p>" + "Here is a snippet from an example multi-fasta file:" + "<pre>" + ">chr1\n" + "ATTATATATAAGACCACAGAGAGAATATTTTGCCCGG...\n\n" + ">chr2\n" + "GGCGGCCGCGGCGATATAGAACTACTCATTATATATA...\n\n" + "..." + "</pre>" + "</p>";
    }
});

exports.default = {
    View: View
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(0)))

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Backbone, $) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _utils = __webpack_require__(5);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var View = Backbone.View.extend({
    initialize: function initialize(options) {
        this.options = _utils2.default.merge(options, {
            content: "No content available.",
            onchange: null,
            ondblclick: null,
            onconfirm: null,
            cls: "ui-table",
            selectable: true,
            cls_tr: ""
        });
        this.setElement(this._template());
        this.$thead = this.$("thead");
        this.$tbody = this.$("tbody");
        this.$tmessage = this.$("tmessage");
        this.row = this._row();
        this.row_count = 0;
    },

    events: {
        click: "_onclick",
        dblclick: "_ondblclick"
    },

    /** Add cell to header row */
    addHeader: function addHeader($el) {
        this.row.append($("<th/>").append($el));
    },

    /** Append header row to table */
    appendHeader: function appendHeader() {
        this.$thead.append(this.row);
        this.row = $("<tr/>");
    },

    /** Add cell to row */
    add: function add($el, width, align) {
        var wrapper = $("<td/>");
        if (width) {
            wrapper.css("width", width);
        }
        if (align) {
            wrapper.css("text-align", align);
        }
        this.row.append(wrapper.append($el));
    },

    /** Append row to table */
    append: function append(id, fade) {
        this._commit(id, fade, false);
    },

    /** Prepend row to table */
    prepend: function prepend(id, fade) {
        this._commit(id, fade, true);
    },

    /** Helper to get row element */
    get: function get(id) {
        return this.$("#" + id);
    },

    /** Delete row by id */
    del: function del(id) {
        var item = this.$tbody.find("#" + id);
        if (item.length > 0) {
            item.remove();
            this.row_count--;
            this._refresh();
        }
    },

    /** Delete all rows */
    delAll: function delAll() {
        this.$tbody.empty();
        this.row_count = 0;
        this._refresh();
    },

    /** Set a value i.e. selects/highlights a particular row by id */
    value: function value(new_value) {
        if (this.options.selectable) {
            this.before = this.$tbody.find(".current").attr("id");
            if (new_value !== undefined) {
                this.$tbody.find("tr").removeClass("current");
                if (new_value) {
                    this.$tbody.find("#" + new_value).addClass("current");
                }
            }
            var after = this.$tbody.find(".current").attr("id");
            if (after === undefined) {
                return null;
            } else {
                if (after != this.before && this.options.onchange) {
                    this.options.onchange(new_value);
                }
                return after;
            }
        }
    },

    /** Return the number of rows */
    size: function size() {
        return this.$tbody.find("tr").length;
    },

    /** Helper to append rows */
    _commit: function _commit(id, fade, prepend) {
        this.del(id);
        this.row.attr("id", id);
        if (prepend) {
            this.$tbody.prepend(this.row);
        } else {
            this.$tbody.append(this.row);
        }
        if (fade) {
            this.row.hide();
            this.row.fadeIn();
        }
        this.row = this._row();
        this.row_count++;
        this._refresh();
    },

    /** Helper to create new row */
    _row: function _row() {
        return $("<tr class=\"" + this.options.cls_tr + "\"></tr>");
    },

    /** Handles onclick events */
    _onclick: function _onclick(e) {
        var old_value = this.value();
        var new_value = $(e.target).closest("tr").attr("id");
        if (new_value != "") {
            if (new_value && old_value != new_value) {
                if (this.options.onconfirm) {
                    this.options.onconfirm(new_value);
                } else {
                    this.value(new_value);
                }
            }
        }
    },

    /** Handles ondblclick events */
    _ondblclick: function _ondblclick(e) {
        var value = this.value();
        if (value && this.options.ondblclick) {
            this.options.ondblclick(value);
        }
    },

    /** Refresh helper */
    _refresh: function _refresh() {
        if (this.row_count == 0) {
            this.$tmessage.show();
        } else {
            this.$tmessage.hide();
        }
    },

    /** Template */
    _template: function _template() {
        return "<div><table class=\"" + this.options.cls + "\"><thead/><tbody/></table><tmessage>" + this.options.content + "</tmessage><div>";
    }
}); /** This class creates a ui table element. */
exports.default = {
    View: View
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(0)))

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Backbone, $, _) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _gridView = __webpack_require__(28);

var _gridView2 = _interopRequireDefault(_gridView);

var _loadingIndicator = __webpack_require__(38);

var _loadingIndicator2 = _interopRequireDefault(_loadingIndicator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** This class renders the grid list with shared section. */
var View = Backbone.View.extend({
    initialize: function initialize(options) {
        var self = this;
        _loadingIndicator2.default.markViewAsLoading(this);
        this.model = new Backbone.Model(options);
        this.item = this.model.get("item");
        this.title = this.model.get("plural");
        if (options && options.active_tab) {
            this.active_tab = options.active_tab;
        }
        $.ajax({
            url: Galaxy.root + this.item + "/" + this.model.get("action_id") + "?" + $.param(Galaxy.params),
            success: function success(response) {
                self.model.set(response);
                self.render();
            }
        });
    },

    render: function render() {
        var grid = new _gridView2.default(this.model.attributes);
        this.$el.empty().append(grid.$el);
        this.$el.append(this._templateShared());
    },

    _templateShared: function _templateShared() {
        var self = this;
        var $tmpl = $("<div><br/><h2>" + this.model.get("plural") + " shared with you by others</h2></div>");
        var options = this.model.attributes;
        if (options.shared_by_others && options.shared_by_others.length > 0) {
            var $table = $('<table class="colored" border="0" cellspacing="0" cellpadding="0" width="100%">' + '<tr class="header">' + "<th>Title</th>" + "<th>Owner</th>" + "</tr>" + "</table>");
            _.each(options.shared_by_others, function (it, index) {
                var display_url = Galaxy.root + self.item + "/display_by_username_and_slug?username=" + it.username + "&slug=" + it.slug;
                $table.append("<tr><td><a href=\"" + display_url + "\">" + _.escape(it.title) + "</a></td><td>" + _.escape(it.username) + "</td></tr>");
            });
            $tmpl.append($table);
        } else {
            $tmpl.append("No " + this.model.get("plural").toLowerCase() + " have been shared with you.");
        }
        return $tmpl;
    }
});

exports.default = {
    View: View
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(0), __webpack_require__(1)))

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toastr = __webpack_require__(25);

var mod_toastr = _interopRequireWildcard(_toastr);

var _backbone = __webpack_require__(7);

var Backbone = _interopRequireWildcard(_backbone);

var _underscore = __webpack_require__(1);

var _ = _interopRequireWildcard(_underscore);

var _tag = __webpack_require__(71);

var _tag2 = _interopRequireDefault(_tag);

var _workflowModel = __webpack_require__(708);

var _workflowModel2 = _interopRequireDefault(_workflowModel);

var _queryStringParsing = __webpack_require__(35);

var _queryStringParsing2 = _interopRequireDefault(_queryStringParsing);

var _localization = __webpack_require__(3);

var _localization2 = _interopRequireDefault(_localization);

var _loadingIndicator = __webpack_require__(38);

var _loadingIndicator2 = _interopRequireDefault(_loadingIndicator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/* global $ */
/* global Galaxy */

/** View of the individual workflows */
/** Workflow view */
var WorkflowItemView = Backbone.View.extend({
    tagName: "tr", // name of (orphan) root tag in this.el
    initialize: function initialize() {
        _.bindAll(this, "render", "_rowTemplate", "renderTagEditor", "_templateActions", "removeWorkflow", "copyWorkflow"); // every function that uses 'this' as the current object should be in here
        mod_toastr.options.timeOut = 1500;
    },

    events: {
        "click #show-in-tool-panel": "showInToolPanel",
        "click #delete-workflow": "removeWorkflow",
        "click #rename-workflow": "renameWorkflow",
        "click #copy-workflow": "copyWorkflow"
    },

    render: function render() {
        $(this.el).html(this._rowTemplate());
        return this;
    },

    showInToolPanel: function showInToolPanel() {
        // This reloads the whole page, so that the workflow appears in the tool panel.
        // Ideally we would notify only the tool panel of a change
        this.model.save({ show_in_tool_panel: !this.model.get("show_in_tool_panel") }, {
            success: function success() {
                window.location = Galaxy.root + "workflows/list";
            }
        });
    },

    removeWorkflow: function removeWorkflow() {
        var wfName = this.model.get("name");
        if (window.confirm("Are you sure you want to delete workflow '" + wfName + "'?")) {
            this.model.destroy({
                success: function success() {
                    mod_toastr.success("Successfully deleted workflow '" + wfName + "'");
                }
            });
            this.remove();
        }
    },

    renameWorkflow: function renameWorkflow() {
        var oldName = this.model.get("name");
        var newName = window.prompt("Enter a new Name for workflow '" + oldName + "'", oldName);
        if (newName) {
            this.model.save({ name: newName }, {
                success: function success() {
                    mod_toastr.success("Successfully renamed workflow '" + oldName + "' to '" + newName + "'");
                }
            });
            this.render();
        }
    },

    copyWorkflow: function copyWorkflow() {
        var _this = this;

        var oldName = this.model.get("name");
        $.getJSON(this.model.urlRoot + "/" + this.model.id + "/download", function (wfJson) {
            var newName = "Copy of " + oldName;
            var currentOwner = _this.model.get("owner");
            if (currentOwner != Galaxy.user.attributes.username) {
                newName += " shared by user " + currentOwner;
            }
            wfJson.name = newName;
            _this.collection.create(wfJson, {
                at: 0,
                wait: true,
                success: function success() {
                    mod_toastr.success("Successfully copied workflow '" + oldName + "' to '" + newName + "'");
                },
                error: function error(model, resp, options) {
                    // signature seems to have changed over the course of backbone dev
                    // see https://github.com/jashkenas/backbone/issues/2606#issuecomment-19289483
                    mod_toastr.error(options.errorThrown);
                }
            });
        }).error(function (jqXHR, textStatus, errorThrown) {
            mod_toastr.error(jqXHR.responseJSON.err_msg);
        });
    },

    _rowTemplate: function _rowTemplate() {
        var show = this.model.get("show_in_tool_panel");
        var wfId = this.model.id;
        var checkboxHtml = "<input id=\"show-in-tool-panel\" type=\"checkbox\" class=\"show-in-tool-panel\" " + (show ? "checked=\"" + show + "\"" : "") + " value=\"" + wfId + "\">";
        return "\n            <td>\n                <div class=\"btn-group\">\n                    <a href=\"" + Galaxy.root + "workflow/editor?id=" + this.model.id + "\" class=\"btn btn-secondary\">\n                        " + _.escape(this.model.get("name")) + "\n                    </a>\n                    <button type=\"button\" class=\"btn btn-secondary dropdown-toggle dropdown-toggle-split\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">\n                      <span class=\"sr-only\">Toggle Dropdown</span>\n                    </button>\n                    " + this._templateActions() + "\n                </div>\n            </td>\n            <td>\n                <div class=\"" + wfId + " tags-display\">\n                </div>\n            </td>\n            <td>\n                " + (this.model.get("owner") === Galaxy.user.attributes.username ? "You" : this.model.get("owner")) + "\n            </td>\n            <td>" + this.model.get("number_of_steps") + "</td>\n            <td>" + (this.model.get("published") ? "Yes" : "No") + "</td>\n            <td>" + checkboxHtml + "</td>";
    },

    renderTagEditor: function renderTagEditor() {
        var TagEditor = new _tag2.default.TagsEditor({
            model: this.model,
            el: $.find("." + this.model.id + ".tags-display"),
            workflow_mode: true
        });
        TagEditor.toggle(true);
        TagEditor.render();
    },

    /** Template for user actions for workflows */
    _templateActions: function _templateActions() {
        if (this.model.get("owner") === Galaxy.user.attributes.username) {
            return "<div class=\"dropdown-menu\">\n                        <a class=\"dropdown-item\" href=\"" + Galaxy.root + "workflow/editor?id=" + this.model.id + "\">Edit</a>\n                        <a class=\"dropdown-item\" href=\"" + Galaxy.root + "workflows/run?id=" + this.model.id + "\">Run</a>\n                        <a class=\"dropdown-item\" href=\"" + Galaxy.root + "workflow/sharing?id=" + this.model.id + "\">Share</a>\n                        <a class=\"dropdown-item\" href=\"" + Galaxy.root + "api/workflows/" + this.model.id + "/download?format=json-download\">Download</a>\n                        <a class=\"dropdown-item\" id=\"copy-workflow\" style=\"cursor: pointer;\">Copy</a>\n                        <a class=\"dropdown-item\" id=\"rename-workflow\" style=\"cursor: pointer;\">Rename</a>\n                        <a class=\"dropdown-item\" href=\"" + Galaxy.root + "workflow/display_by_id?id=" + this.model.id + "\">View</a>\n                        <a class=\"dropdown-item\" id=\"delete-workflow\" style=\"cursor: pointer;\">Delete</a>\n                    </div>";
        } else {
            return "<ul class=\"dropdown-menu\">\n                        <li><a href=\"" + Galaxy.root + "workflow/display_by_username_and_slug?username=" + this.model.get("owner") + "&slug=" + this.model.get("slug") + "\">View</a></li>\n                        <li><a href=\"" + Galaxy.root + "workflows/run?id=" + this.model.id + "\">Run</a></li>\n                        <li><a id=\"copy-workflow\" style=\"cursor: pointer;\">Copy</a></li>\n                        <li><a class=\"link-confirm-shared-" + this.model.id + "\" href=\"" + Galaxy.root + "workflow/sharing?unshare_me=True&id=" + this.model.id + "\">Remove</a></li>\n                    </ul>";
        }
    }
});

/** View of the main workflow list page */
var WorkflowListView = Backbone.View.extend({
    title: (0, _localization2.default)("Workflows"),
    active_tab: "workflow",
    initialize: function initialize() {
        _loadingIndicator2.default.markViewAsLoading(this);
        _.bindAll(this, "adjustActiondropdown");
        this.collection = new _workflowModel2.default.WorkflowCollection();
        this.collection.fetch().done(this.render());
        this.collection.bind("add", this.appendItem);
        this.collection.on("sync", this.render, this);
    },

    events: {
        dragleave: "unhighlightDropZone",
        drop: "drop",
        dragover: function dragover(ev) {
            $(".hidden_description_layer").addClass("dragover");
            $(".menubutton").addClass("background-none");
            ev.preventDefault();
        }
    },

    unhighlightDropZone: function unhighlightDropZone() {
        $(".hidden_description_layer").removeClass("dragover");
        $(".menubutton").removeClass("background-none");
    },

    drop: function drop(e) {
        // TODO: check that file is valid galaxy workflow
        this.unhighlightDropZone();
        e.preventDefault();
        var files = e.dataTransfer.files;
        for (var i = 0, f; f = files[i]; i++) {
            this.readWorkflowFiles(f);
        }
    },

    readWorkflowFiles: function readWorkflowFiles(f) {
        var _this2 = this;

        var reader = new FileReader();
        reader.onload = function (theFile) {
            var wf_json = void 0;
            try {
                wf_json = JSON.parse(reader.result);
            } catch (e) {
                mod_toastr.error("Could not read file '" + f.name + "'. Verify it is a valid Galaxy workflow");
                wf_json = null;
            }
            if (wf_json) {
                _this2.collection.create(wf_json, {
                    at: 0,
                    wait: true,
                    success: function success() {
                        mod_toastr.success("Successfully imported workflow '" + wf_json.name + "'");
                    },
                    error: function error(model, resp, options) {
                        mod_toastr.error(options.errorThrown);
                    }
                });
            }
        };
        reader.readAsText(f, "utf-8");
    },

    _showArgErrors: _.once(function () {
        // Parse args out of params, display if there's a message.
        var msg_text = _queryStringParsing2.default.get("message");
        var msg_status = _queryStringParsing2.default.get("status");
        if (msg_status === "error") {
            mod_toastr.error(_.escape(msg_text || "Unknown Error, please report this to an administrator."));
        } else if (msg_text) {
            mod_toastr.info(_.escape(msg_text));
        }
    }),

    render: function render() {
        var _this3 = this;

        // Add workflow header
        var header = this._templateHeader();
        // Add the actions buttons
        var templateActions = this._templateActionButtons();
        var tableTemplate = this._templateWorkflowTable();
        this.$el.html(header + templateActions + tableTemplate);
        _.each(this.collection.models, function (item) {
            // in case collection is not empty
            _this3.appendItem(item);
            _this3.confirmDelete(item);
        });
        var minQueryLength = 3;
        this.searchWorkflow(this.$(".search-wf"), this.$(".workflow-search tr"), minQueryLength);
        this.adjustActiondropdown();
        this._showArgErrors();
        return this;
    },

    appendItem: function appendItem(item) {
        var workflowItemView = new WorkflowItemView({
            model: item,
            collection: this.collection
        });
        $(".workflow-search").append(workflowItemView.render().el);
        workflowItemView.renderTagEditor();
    },

    /** Add confirm box before removing/unsharing workflow */
    confirmDelete: function confirmDelete(workflow) {
        var $el_shared_wf_link = this.$(".link-confirm-shared-" + workflow.id);
        $el_shared_wf_link.click(function () {
            return window.confirm("Are you sure you want to remove the shared workflow '" + workflow.attributes.name + "'?");
        });
    },

    /** Implement client side workflow search/filtering */
    searchWorkflow: function searchWorkflow($el_searchinput, $el_tabletr, min_querylen) {
        $el_searchinput.on("keyup", function () {
            var query = $(this).val();
            // Filter when query is at least 3 characters
            // otherwise show all rows
            if (query.length >= min_querylen) {
                // Ignore the query's case using 'i'
                var regular_expression = new RegExp(query, "i");
                $el_tabletr.hide();
                $el_tabletr.filter(function () {
                    // Apply regular expression on each row's text
                    // and show when there is a match
                    return regular_expression.test($(this).text());
                }).show();
            } else {
                $el_tabletr.show();
            }
        });
    },

    /** Ajust the position of dropdown with respect to table */
    adjustActiondropdown: function adjustActiondropdown() {
        $(this.el).on("show.bs.dropdown", function () {
            $(this.el).css("overflow", "inherit");
        });
        $(this.el).on("hide.bs.dropdown", function () {
            $(this.el).css("overflow", "auto");
        });
    },

    /** Template for no workflow */
    _templateNoWorkflow: function _templateNoWorkflow() {
        return '<div class="wf-nodata"> You have no workflows. </div>';
    },

    /** Template for actions buttons */
    _templateActionButtons: function _templateActionButtons() {
        return "<ul class=\"manage-table-actions\"><li><input class=\"search-wf form-control\" type=\"text\" autocomplete=\"off\" placeholder=\"search for workflow...\"></li><li><a class=\"action-button fa fa-plus wf-action\" id=\"new-workflow\" title=\"Create new workflow\" href=\"" + Galaxy.root + "workflows/create\"></a></li><li><a class=\"action-button fa fa-upload wf-action\" id=\"import-workflow\" title=\"Upload or import workflow\" href=\"" + Galaxy.root + "workflows/import\"></a></li></ul>";
    },

    /** Template for workflow table */
    _templateWorkflowTable: function _templateWorkflowTable() {
        var tableHtml = '<table class="table colored"><thead>' + '<tr class="header">' + "<th>Name</th>" + "<th>Tags</th>" + "<th>Owner</th>" + "<th># of Steps</th>" + "<th>Published</th>" + "<th>Show in tools panel</th>" + "</tr></thead>";
        return tableHtml + "<tbody class=\"workflow-search \"><div class=\"hidden_description_layer\"><p>Drop workflow files here to import</p></tbody></table></div>";
    },

    /** Main template */
    _templateHeader: function _templateHeader() {
        return '<div class="page-container">' + '<div class="user-workflows wf">' + '<div class="response-message"></div>' + "<h2>" + (0, _localization2.default)("Your workflows") + "</h2>" + "</div>" + "</div>";
    }
});

exports.default = {
    View: WorkflowListView
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Backbone) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _baseMvc = __webpack_require__(6);

var _baseMvc2 = _interopRequireDefault(_baseMvc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global Backbone */
// workflow model

var logNamespace = "workflow";
//==============================================================================
/** @class model for a single workflow.
 *  @name WorkflowItem
 *  @augments Backbone.Model
 */
var WorkflowItem = Backbone.Model.extend(_baseMvc2.default.LoggableMixin).extend({
    _logNamespace: logNamespace,

    urlRoot: Galaxy.root + "api/workflows",

    toJSON: function toJSON() {
        // need to overwrite this as endpoint expects the 'workflow' key in payload
        return { workflow: this.attributes };
    }
});

//==============================================================================
/** @class collection for workflows.
 *  @name WorkflowCollection
 *  @augments Backbone.Collection
 */
var WorkflowCollection = Backbone.Collection.extend({
    model: WorkflowItem,
    url: Galaxy.root + "api/workflows"
});

//==============================================================================

exports.default = {
    WorkflowItem: WorkflowItem,
    WorkflowCollection: WorkflowCollection
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__WorkflowImport_vue_vue_type_template_id_66f8fb69__ = __webpack_require__(710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__WorkflowImport_vue_vue_type_script_lang_js__ = __webpack_require__(421);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__WorkflowImport_vue_vue_type_script_lang_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__WorkflowImport_vue_vue_type_script_lang_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(17);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__WorkflowImport_vue_vue_type_script_lang_js__["default"],
  __WEBPACK_IMPORTED_MODULE_0__WorkflowImport_vue_vue_type_template_id_66f8fb69__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__WorkflowImport_vue_vue_type_template_id_66f8fb69__["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_WorkflowImport_vue_vue_type_template_id_66f8fb69__ = __webpack_require__(711);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_WorkflowImport_vue_vue_type_template_id_66f8fb69__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_WorkflowImport_vue_vue_type_template_id_66f8fb69__["b"]; });


/***/ }),
/* 711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form',{on:{"submit":_vm.submit}},[_c('b-card',{attrs:{"title":"Import Workflow"}},[_c('b-alert',{attrs:{"show":_vm.hasErrorMessage,"variant":"danger"}},[_vm._v(_vm._s(_vm.errorMessage))]),_vm._v(" "),_c('p',[_vm._v("Please provide a Galaxy workflow export URL or a workflow file.")]),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Archived Workflow URL"}},[_c('b-form-input',{attrs:{"id":"workflow-import-url-input","type":"url"},model:{value:(_vm.sourceURL),callback:function ($$v) {_vm.sourceURL=$$v},expression:"sourceURL"}}),_vm._v("\n            If the workflow is accessible via a URL, enter the URL above and click Import.\n        ")],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Archived Workflow File"}},[_c('b-form-file',{model:{value:(_vm.sourceFile),callback:function ($$v) {_vm.sourceFile=$$v},expression:"sourceFile"}}),_vm._v("\n            If the workflow is in a file on your computer, choose it and then click Import.\n        ")],1),_vm._v(" "),_c('b-button',{attrs:{"id":"workflow-import-button","type":"submit"}},[_vm._v("Import workflow")]),_vm._v(" "),_c('p',{staticClass:"mt-4"}),_c('h4',[_vm._v("Import a Workflow from myExperiment")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.myexperiment_target_url}},[_vm._v("Visit myExperiment")]),_vm._v(" "),_c('div',{staticClass:"form-text"},[_vm._v("Click the link above to visit myExperiment and search for Galaxy workflows.")]),_vm._v(" "),_c('p')],1)],1)}
var staticRenderFns = []



/***/ }),
/* 712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HistoryImport_vue_vue_type_template_id_14e76dce__ = __webpack_require__(713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HistoryImport_vue_vue_type_script_lang_js__ = __webpack_require__(423);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__HistoryImport_vue_vue_type_script_lang_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__HistoryImport_vue_vue_type_script_lang_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(17);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__HistoryImport_vue_vue_type_script_lang_js__["default"],
  __WEBPACK_IMPORTED_MODULE_0__HistoryImport_vue_vue_type_template_id_14e76dce__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__HistoryImport_vue_vue_type_template_id_14e76dce__["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_HistoryImport_vue_vue_type_template_id_14e76dce__ = __webpack_require__(714);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_HistoryImport_vue_vue_type_template_id_14e76dce__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_HistoryImport_vue_vue_type_template_id_14e76dce__["b"]; });


/***/ }),
/* 714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form',{on:{"submit":_vm.submit}},[_c('b-card',{attrs:{"title":"Import a history from an archive"}},[_c('b-alert',{attrs:{"show":_vm.hasErrorMessage,"variant":"danger"}},[_vm._v(_vm._s(_vm.errorMessage))]),_vm._v(" "),_c('p',[_vm._v("Please provide a Galaxy history export URL or a history file.")]),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Archived History URL"}},[_c('b-form-input',{attrs:{"type":"url"},model:{value:(_vm.sourceURL),callback:function ($$v) {_vm.sourceURL=$$v},expression:"sourceURL"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Archived History File"}},[_c('b-form-file',{model:{value:(_vm.sourceFile),callback:function ($$v) {_vm.sourceFile=$$v},expression:"sourceFile"}})],1),_vm._v(" "),_c('b-button',{attrs:{"type":"submit"}},[_vm._v("Import history")])],1)],1)}
var staticRenderFns = []



/***/ }),
/* 715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HistoryView_vue_vue_type_template_id_67543b25__ = __webpack_require__(716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HistoryView_vue_vue_type_script_lang_js__ = __webpack_require__(425);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__HistoryView_vue_vue_type_script_lang_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__HistoryView_vue_vue_type_script_lang_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HistoryView_vue_vue_type_style_index_0_lang_css__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(17);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__HistoryView_vue_vue_type_script_lang_js__["default"],
  __WEBPACK_IMPORTED_MODULE_0__HistoryView_vue_vue_type_template_id_67543b25__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__HistoryView_vue_vue_type_template_id_67543b25__["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_HistoryView_vue_vue_type_template_id_67543b25__ = __webpack_require__(717);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_HistoryView_vue_vue_type_template_id_67543b25__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_HistoryView_vue_vue_type_template_id_67543b25__["b"]; });


/***/ }),
/* 717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"structured-history-view"}},[_c('div',{staticClass:"clear",attrs:{"id":"history-view-controls"}},[_c('div',{staticClass:"float-left"},[(_vm.historyHistory['purged'] == false)?_c('span',[(_vm.historyData.user_is_owner == false)?_c('span',[_c('button',{staticClass:"btn btn-secondary",attrs:{"id":"import"}},[_vm._v("Import and start using history")])]):_vm._e(),_vm._v(" "),(_vm.historyData.user_is_owner && _vm.historyData.history_is_current == false)?_c('span',[_c('button',{staticClass:"btn btn-secondary",attrs:{"id":"switch-history"},on:{"click":_vm.switchHistory}},[_vm._v("Switch to this history")])]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"id":"show-structure"},on:{"click":_vm.showStructure}},[_vm._v("Show structure")])]):_vm._e()]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_vm._l((_vm.errorMessages),function(error){return _c('div',[_c('div',{staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_vm._v("\n            "+_vm._s(error)+"\n        ")])])}),_vm._v(" "),_c('div',{staticClass:"history-panel unified-panel-body",staticStyle:{"overflow":"auto"},attrs:{"id":'history-' + _vm.historyHistory['id']}})],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"float-right"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"id":"toggle-deleted"}},[_vm._v("Include deleted")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"id":"toggle-hidden"}},[_vm._v("Include hidden")])])}]



/***/ }),
/* 718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_DisplayStructured_vue_vue_type_template_id_8893f368__ = __webpack_require__(719);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_DisplayStructured_vue_vue_type_template_id_8893f368__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_DisplayStructured_vue_vue_type_template_id_8893f368__["b"]; });


/***/ }),
/* 719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.errorMessages),function(error){return _c('div',[_c('div',{staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_vm._v("\n            "+_vm._s(error)+"\n        ")])])}),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.historyTemplate)}})],2)}
var staticRenderFns = []



/***/ }),
/* 720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_DisplayStructured_vue_vue_type_style_index_0_lang_css__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_DisplayStructured_vue_vue_type_style_index_0_lang_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_DisplayStructured_vue_vue_type_style_index_0_lang_css__);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_DisplayStructured_vue_vue_type_style_index_0_lang_css___default.a); 

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(26)(false);
// imports


// module
exports.push([module.i, ".bold{font-weight:700}.light{font-weight:lighter;color:grey}.right-aligned{text-align:right}.clickable{cursor:pointer}.workflow{border:1px solid gray;margin-bottom:1%}.workflow>.header{background:#d3d3d3;padding:5px 10px}.workflow>.light{color:gray}.workflow>.body{border-top:1px solid gray}.workflow>.body>.toolForm{border:0;margin:0}div.toolForm{border-width:1px;border-radius:0;margin-bottom:1%}.toolForm>.header{background-color:#ebd9b2;padding:5px 10px}.workflow div.toolForm:not(:first-child) .header{border-top:1px solid #d6b161}div.toolFormTitle{padding:0 0 4px;margin:0 0 4px;border:0;background-color:transparent;border-bottom:1px solid #d6b161}.toolForm em,.toolFormTitle>.light{color:#90743a}.job-inputs{margin:0 6px;text-align:left}.job-inputs td:first-child{text-align:right;font-weight:lighter;color:#90743a}.job-inputs td:first-child:after{content:\":\"}.job-inputs td:nth-child(2){padding-left:4px}.job-inputs-show{float:right}.copied-from{border:1px solid #d3d3d3;border-width:1px 1px 0;margin-bottom:1%}.copied-from .header{border-bottom:1px solid #d3d3d3;padding:5px}.copied-from .header .bold,.copied-from .header a{color:#888}.dataset.hda{min-height:37px;border-width:0 0 1px}.toolFormBody>.dataset.hda:last-child{border-bottom-width:0}.dataset.hda:first-child{border-top:1px solid #d6b161}.dataset.hda .dataset-title-bar{padding-top:8px;padding-left:10px}", ""]);

// exports


/***/ }),
/* 722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_HistoryView_vue_vue_type_style_index_0_lang_css__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_HistoryView_vue_vue_type_style_index_0_lang_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_HistoryView_vue_vue_type_style_index_0_lang_css__);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_HistoryView_vue_vue_type_style_index_0_lang_css___default.a); 

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(26)(false);
// imports


// module
exports.push([module.i, "#history-view-controls{flex:0 0 44px;background-color:#fff;border-bottom:1px solid #ddd;width:100%;padding:8px}.history-panel>.controls .title{font-size:120%}.history-panel>.controls .title input{font-size:100%}a.btn{text-decoration:none}", ""]);

// exports


/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _localization = __webpack_require__(3);

var _localization2 = _interopRequireDefault(_localization);

var _ajaxQueue = __webpack_require__(164);

var _ajaxQueue2 = _interopRequireDefault(_ajaxQueue);

var _utils = __webpack_require__(5);

var _utils2 = _interopRequireDefault(_utils);

var _gridView = __webpack_require__(28);

var _gridView2 = _interopRequireDefault(_gridView);

var _historyModel = __webpack_require__(168);

var _historyModel2 = _interopRequireDefault(_historyModel);

var _copyDialog = __webpack_require__(150);

var _copyDialog2 = _interopRequireDefault(_copyDialog);

var _loadingIndicator = __webpack_require__(38);

var _loadingIndicator2 = _interopRequireDefault(_loadingIndicator);

var _backbone = __webpack_require__(7);

var Backbone = _interopRequireWildcard(_backbone);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global $ */
/* global Galaxy */

/** This class renders the grid list. */
var HistoryGridView = _gridView2.default.extend({
    initialize: function initialize(grid_config) {
        this.ajaxQueue = new _ajaxQueue2.default.AjaxQueue();
        _gridView2.default.prototype.initialize.call(this, grid_config);
    },

    init_grid_elements: function init_grid_elements() {
        var ajaxQueue = this.ajaxQueue;
        ajaxQueue.stop();
        _gridView2.default.prototype.init_grid_elements.call(this);
        var fetchDetails = $.makeArray(this.$el.find(".delayed-value-datasets_by_state").map(function (i, el) {
            return function () {
                var historyId = $(el).data("id");
                var url = Galaxy.root + "api/histories/" + historyId + "?keys=nice_size,contents_active,contents_states";
                var options = {};
                options.url = url;
                options.type = "GET";
                options.success = function (req) {
                    var contentsStates = req.contents_states;
                    var stateHtml = "";
                    var _arr = ["ok", "running", "queued", "new", "error"];
                    for (var _i = 0; _i < _arr.length; _i++) {
                        var state = _arr[_i];
                        var stateCount = contentsStates[state];
                        if (stateCount) {
                            stateHtml += "<div class=\"count-box state-color-" + state + "\" title=\"Datasets in " + state + " state\">" + stateCount + "</div> ";
                        }
                    }
                    var contentsActive = req.contents_active;
                    var deleted = contentsActive.deleted;
                    if (deleted) {
                        stateHtml += "<div class=\"count-box state-color-deleted\" title=\"Deleted datasets\">" + deleted + "</div> ";
                    }
                    var hidden = contentsActive.hidden;
                    if (hidden) {
                        stateHtml += "<div class=\"count-box state-color-hidden\" title=\"Hidden datasets\">" + hidden + "</div> ";
                    }
                    $(".delayed-value-datasets_by_state[data-id='" + historyId + "']").html(stateHtml);
                    $(".delayed-value-disk_size[data-id='" + historyId + "']").html(req.nice_size);
                };
                var xhr = $.ajax(options);
                return xhr;
            };
        }));
        fetchDetails.forEach(function (fn) {
            return ajaxQueue.add(fn);
        });
        ajaxQueue.start();
    },
    _showCopyDialog: function _showCopyDialog(id) {
        var history = new _historyModel2.default.History({ id: id });
        history.fetch().fail(function () {
            alert("History could not be fetched. Please contact an administrator");
        }).done(function () {
            (0, _copyDialog2.default)(history, {}).done(function () {
                if (window.parent && window.parent.Galaxy && window.parent.Galaxy.currHistoryPanel) {
                    window.parent.Galaxy.currHistoryPanel.loadCurrentHistory();
                }
                window.location.reload(true);
            });
        });
    },
    /** Add an operation to the items menu */
    add_operation: function add_operation(popup, operation, item) {
        var _this = this;

        if (operation.label == "Copy") {
            operation.onclick = function (id) {
                _this._showCopyDialog(id);
            };
        }
        _gridView2.default.prototype.add_operation.call(this, popup, operation, item);
    }
});

var View = Backbone.View.extend({
    title: (0, _localization2.default)("Histories"),
    initialize: function initialize(options) {
        var _this2 = this;

        _loadingIndicator2.default.markViewAsLoading(this);

        if (options.action_id == "list_published") {
            this.active_tab = "shared";
        } else if (options.action_id == "list") {
            this.active_tab = "user";
        }
        this.model = new Backbone.Model();
        _utils2.default.get({
            url: Galaxy.root + "history/" + options.action_id + "?" + $.param(Galaxy.params),
            success: function success(response) {
                _this2.model.set(response);
                _this2.render();
            }
        });
    },

    render: function render() {
        var grid = new HistoryGridView(this.model.attributes);
        this.$el.empty().append(grid.$el);
    }
});

exports.default = {
    View: View
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PluginList_vue_vue_type_template_id_7e1adabe__ = __webpack_require__(726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PluginList_vue_vue_type_script_lang_js__ = __webpack_require__(432);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__PluginList_vue_vue_type_script_lang_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__PluginList_vue_vue_type_script_lang_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(17);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__PluginList_vue_vue_type_script_lang_js__["default"],
  __WEBPACK_IMPORTED_MODULE_0__PluginList_vue_vue_type_template_id_7e1adabe__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__PluginList_vue_vue_type_template_id_7e1adabe__["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_PluginList_vue_vue_type_template_id_7e1adabe__ = __webpack_require__(727);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_PluginList_vue_vue_type_template_id_7e1adabe__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_PluginList_vue_vue_type_template_id_7e1adabe__["b"]; });


/***/ }),
/* 727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-thumbnails"},[(_vm.error)?_c('div',{staticClass:"alert alert-danger"},[_vm._v("\n        "+_vm._s(_vm.error)+"\n    ")]):_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"search-query parent-width",attrs:{"name":"query","placeholder":"search visualizations","autocomplete":"off","type":"text"},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}}),_vm._v(" "),_vm._l((_vm.plugins),function(plugin){return _c('div',[(_vm.match(plugin))?_c('table',[_c('tr',{staticClass:"ui-thumbnails-item",on:{"click":function($event){_vm.select(plugin)}}},[_c('td',[(plugin.logo)?_c('img',{staticClass:"ui-thumbnails-image",attrs:{"src":plugin.logo}}):_c('div',{staticClass:"ui-thumbnails-icon fa fa-eye"})]),_vm._v(" "),_c('td',[_c('div',{staticClass:"ui-thumbnails-title font-weight-bold text-dark"},[_vm._v("\n                            "+_vm._s(plugin.html)+"\n                        ")]),_vm._v(" "),_c('div',{staticClass:"ui-thumbnails-text text-dark"},[_vm._v("\n                            "+_vm._s(plugin.description)+"\n                        ")])])]),_vm._v(" "),(!_vm.fixed)?_c('tr',[_c('td'),_vm._v(" "),(plugin.name == _vm.name)?_c('td',[(_vm.hdas && _vm.hdas.length > 0)?_c('div',[_c('div',{staticClass:"font-weight-bold text-dark"},[_vm._v("Select a dataset to visualize:")]),_vm._v(" "),_c('div',{staticClass:"ui-select"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],staticClass:"select",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.hdas),function(file){return _c('option',{domProps:{"value":file.id}},[_vm._v(_vm._s(file.name))])})),_vm._v(" "),_c('div',{staticClass:"icon-dropdown fa fa-caret-down"})]),_vm._v(" "),_c('button',{staticClass:"ui-button-default float-left mt-3 btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){_vm.create(plugin)}}},[_c('i',{staticClass:"icon fa fa-check ui-margin-right"}),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v("Create Visualization")])])]):_c('div',{staticClass:"alert alert-danger"},[_vm._v("\n                            There is no suitable dataset in your current history which can be visualized with this plugin.\n                        ")])]):_vm._e()]):_vm._e()]):_vm._e()])})],2)])}
var staticRenderFns = []



/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _localization = __webpack_require__(3);

var _localization2 = _interopRequireDefault(_localization);

var _utils = __webpack_require__(5);

var _utils2 = _interopRequireDefault(_utils);

var _uiMisc = __webpack_require__(11);

var _uiMisc2 = _interopRequireDefault(_uiMisc);

var _formView = __webpack_require__(30);

var _formView2 = _interopRequireDefault(_formView);

var _backbone = __webpack_require__(7);

var Backbone = _interopRequireWildcard(_backbone);

var _underscore = __webpack_require__(1);

var _ = _interopRequireWildcard(_underscore);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global Galaxy */
/* global $ */

/** Dataset edit attributes view */
var View = Backbone.View.extend({
    initialize: function initialize() {
        this.setElement("<div/>");
        this.model = new Backbone.Model({
            dataset_id: Galaxy.params.dataset_id
        });
        this.active_tab = "user";
        this.render();
    },

    // Fetch data for the selected dataset and
    render: function render() {
        var _this = this;

        var data_url = Galaxy.root + "api/datasets/" + this.model.get("dataset_id");

        _utils2.default.get({
            url: data_url,
            success: function success(dataset) {
                var job_url = Galaxy.root + "api/jobs/" + dataset.creating_job + "?full=True";
                _utils2.default.get({
                    url: job_url,
                    success: function success(job) {
                        _this.render_error_page(dataset, job);
                    },
                    error: function error(response) {
                        var error_response = {
                            status: "error",
                            message: "Error occured while loading the job.",
                            persistent: true,
                            cls: "errormessage"
                        };
                        _this.display_message(error_response, _this.$(".response-message"));
                    }
                });
            },
            error: function error(response) {
                var error_response = {
                    status: "error",
                    message: "Error occured while loading the dataset.",
                    persistent: true,
                    cls: "errormessage"
                };
                _this.display_message(error_response, _this.$(".response-message"));
            }
        });
    },

    /** Render the view */
    render_error_page: function render_error_page(dataset, job) {
        this.$el.empty().append("\n            " + this._templateHeader() + "\n            <h2>Dataset Error</h2>\n            <p>An error occured while running the tool <b>" + job.tool_id + "</b>.</p>\n            <p>Tool execution generated the following messages:</p>\n            <pre class=\"code\">" + _.escape(job.stderr) + "</pre>\n\n            <h3>Troubleshoot This Error</h3>\n            <p>\n                There are a number of help resources to self diagnose and\n                correct problems.\n                Start here: <a\n                href=\"https://galaxyproject.org/support/tool-error/\"\n                target=\"_blank\"> My job ended with an error. What can I do?</a>\n            </p>\n\n            <h3>Report This Error</h3>\n            <p>\n                Usually the local Galaxy administrators regularly review errors\n                that occur on the server However, if you would like to provide\n                additional information (such as what you were trying to do when\n                the error occurred) and a contact e-mail address, we will be\n                better able to investigate your problem and get back to you.\n            </p>");
        this.$el.append(this._getBugFormTemplate(dataset, job));
    },

    /** Display actions messages */
    display_message: function display_message(response, $el, doNotClear, safe) {
        if (!safe) {
            if (doNotClear) {
                $el.append(new _uiMisc2.default.Message(response).$el);
            } else {
                $el.empty().html(new _uiMisc2.default.Message(response).$el);
            }
        } else {
            if (doNotClear) {
                $el.append(new _uiMisc2.default.UnescapedMessage(response).$el);
            } else {
                $el.empty().html(new _uiMisc2.default.UnescapedMessage(response).$el);
            }
        }
    },

    /** Main template */
    _templateHeader: function _templateHeader() {
        return "<div class=\"page-container edit-attr\"><div class=\"response-message\"></div></div>";
    },

    /** Convert tab template */
    _getBugFormTemplate: function _getBugFormTemplate(dataset, job) {
        var _this2 = this;

        var inputs = [{
            help: (0, _localization2.default)("Your email address"),
            options: [],
            type: "text",
            name: "email",
            label: "Your email",
            value: Galaxy.user.get("email")
        }, {
            help: (0, _localization2.default)("Any additional comments you can provide regarding what you were doing at the time of the bug."),
            options: [],
            type: "text",
            area: true,
            name: "message",
            label: "Message"
        }];

        // TODO
        /*
        if (false && response.any_public) {
            inputs.push({
                name: "public_consent",
                label: "Public Disclosure Consent",
                help:
                    "This Galaxy is configured to report to one or more error reporting backends that public to the world. By selecting 'yes', you acknowledge that this bug report will be made public.",
                value: String(Boolean(false)),
                options: [],
                type: "boolean"
            });
        }
        */

        var form = new _formView2.default({
            title: (0, _localization2.default)("Error Report"),
            inputs: inputs,
            buttons: {
                save: new _uiMisc2.default.Button({
                    icon: "fa-bug",
                    title: (0, _localization2.default)("Report"),
                    cls: "ui-button btn btn-primary",
                    floating: "clear",
                    onclick: function onclick() {
                        var form_data = form.data.create();
                        var url = Galaxy.root + "api/jobs/" + job.id + "/error";
                        form_data.dataset_id = dataset.id;
                        _this2.submit(form_data, url);
                    }
                })
            }
        });
        return form.$el;
    },

    /** Make ajax request */
    submit: function submit(form_data, url) {
        var _this3 = this;

        // Some required metadata
        $.ajax({
            type: "POST",
            url: url,
            data: form_data,
            success: function success(response) {
                // Clear out the div
                _this3.$el.empty().append(_this3._templateHeader());
                // And display the messages.
                response.messages.forEach(function (message) {
                    _this3.display_message({
                        status: message[1],
                        message: message[0],
                        persistent: true
                    }, _this3.$(".response-message"), true, true);
                });
            },
            error: function error(response) {
                var error_response = {
                    status: "error",
                    message: "Error occured while saving. Please fill all the required fields and try again.",
                    persistent: true,
                    cls: "errormessage"
                };
                _this3.display_message(error_response, _this3.$(".response-message"));
            }
        });
    }
});

exports.default = {
    View: View
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Backbone, $, _) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _localization = __webpack_require__(3);

var _localization2 = _interopRequireDefault(_localization);

var _utils = __webpack_require__(5);

var _utils2 = _interopRequireDefault(_utils);

var _uiTabs = __webpack_require__(85);

var _uiTabs2 = _interopRequireDefault(_uiTabs);

var _uiMisc = __webpack_require__(11);

var _uiMisc2 = _interopRequireDefault(_uiMisc);

var _formView = __webpack_require__(30);

var _formView2 = _interopRequireDefault(_formView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** Dataset edit attributes view */
var View = Backbone.View.extend({
    initialize: function initialize() {
        this.setElement("<div/>");
        this.model = new Backbone.Model({
            dataset_id: Galaxy.params.dataset_id
        });
        this.message = new _uiMisc2.default.Message({ persistent: true });
        this.tabs = this._createTabs();
        this.active_tab = "user";
        this.$el.append($("<h4/>").append("Edit dataset attributes")).append(this.message.$el).append("<p/>").append(this.tabs.$el).hide();
        this.render();
    },

    /** fetch data for the selected dataset and build forms */
    render: function render() {
        var self = this;
        $.ajax({
            url: Galaxy.root + "dataset/get_edit?dataset_id=" + self.model.get("dataset_id"),
            success: function success(response) {
                !self.initial_message && self.message.update(response);
                self.initial_message = true;
                _.each(self.forms, function (form, key) {
                    form.model.set("inputs", response[key + "_inputs"]);
                    form.model.set("hide_operations", response[key + "_disable"]);
                    form.render();
                });
                self.$el.show();
            },
            error: function error(response) {
                var err_msg = response.responseJSON && response.responseJSON.err_msg;
                self.message.update({
                    status: "danger",
                    message: err_msg || "Error occured while loading the dataset."
                });
            }
        });
    },

    /** submit data to backend to update attributes */
    _submit: function _submit(operation, form) {
        var self = this;
        var data = form.data.create();
        data.dataset_id = this.model.get("dataset_id");
        data.operation = operation;
        $.ajax({
            type: "PUT",
            url: Galaxy.root + "dataset/set_edit",
            data: data,
            success: function success(response) {
                self.message.update(response);
                self.render();
                self._reloadHistory();
            },
            error: function error(response) {
                var err_msg = response.responseJSON && response.responseJSON.err_msg;
                self.message.update({
                    status: "danger",
                    message: err_msg || "Error occured while editing the dataset attributes."
                });
            }
        });
    },

    /** create tabs for different dataset attribute categories*/
    _createTabs: function _createTabs() {
        this.forms = {
            attribute: this._getAttribute(),
            conversion: this._getConversion(),
            datatype: this._getDatatype(),
            permission: this._getPermission()
        };
        var tabs = new _uiTabs2.default.View();
        tabs.add({
            id: "attribute",
            title: (0, _localization2.default)("Attributes"),
            icon: "fa fa-bars",
            tooltip: (0, _localization2.default)("Edit dataset attributes"),
            $el: this.forms.attribute.$el
        });
        tabs.add({
            id: "convert",
            title: (0, _localization2.default)("Convert"),
            icon: "fa-gear",
            tooltip: (0, _localization2.default)("Convert to new format"),
            $el: this.forms.conversion.$el
        });
        tabs.add({
            id: "datatype",
            title: (0, _localization2.default)("Datatypes"),
            icon: "fa-database",
            tooltip: (0, _localization2.default)("Change data type"),
            $el: this.forms.datatype.$el
        });
        tabs.add({
            id: "permissions",
            title: (0, _localization2.default)("Permissions"),
            icon: "fa-user",
            tooltip: (0, _localization2.default)("Permissions"),
            $el: this.forms.permission.$el
        });
        return tabs;
    },

    /** edit main attributes form */
    _getAttribute: function _getAttribute() {
        var self = this;
        var form = new _formView2.default({
            title: (0, _localization2.default)("Edit attributes"),
            operations: {
                submit_attributes: new _uiMisc2.default.ButtonIcon({
                    tooltip: (0, _localization2.default)("Save attributes of the dataset."),
                    icon: "fa-floppy-o",
                    title: (0, _localization2.default)("Save"),
                    onclick: function onclick() {
                        self._submit("attributes", form);
                    }
                }),
                submit_autodetect: new _uiMisc2.default.ButtonIcon({
                    tooltip: "This will inspect the dataset and attempt to correct the values of fields if they are not accurate.",
                    icon: "fa-undo",
                    title: "Auto-detect",
                    onclick: function onclick() {
                        self._submit("autodetect", form);
                    }
                })
            }
        });
        return form;
    },

    /** datatype conversion form */
    _getConversion: function _getConversion() {
        var self = this;
        var form = new _formView2.default({
            title: (0, _localization2.default)("Convert to new format"),
            operations: {
                submit_conversion: new _uiMisc2.default.ButtonIcon({
                    tooltip: (0, _localization2.default)("Convert the datatype to a new format."),
                    title: (0, _localization2.default)("Convert datatype"),
                    icon: "fa-exchange",
                    onclick: function onclick() {
                        self._submit("conversion", form);
                    }
                })
            }
        });
        return form;
    },

    /** change datatype form */
    _getDatatype: function _getDatatype() {
        var self = this;
        var form = new _formView2.default({
            title: (0, _localization2.default)("Change datatype"),
            operations: {
                submit_datatype: new _uiMisc2.default.ButtonIcon({
                    tooltip: (0, _localization2.default)("Change the datatype to a new type."),
                    title: (0, _localization2.default)("Change datatype"),
                    icon: "fa-exchange",
                    onclick: function onclick() {
                        self._submit("datatype", form);
                    }
                })
            }
        });
        return form;
    },

    /** dataset permissions form */
    _getPermission: function _getPermission() {
        var self = this;
        var form = new _formView2.default({
            title: (0, _localization2.default)("Manage dataset permissions"),
            operations: {
                submit_permission: new _uiMisc2.default.ButtonIcon({
                    tooltip: (0, _localization2.default)("Save permissions."),
                    title: (0, _localization2.default)("Save permissions"),
                    icon: "fa-floppy-o ",
                    onclick: function onclick() {
                        self._submit("permission", form);
                    }
                })
            }
        });
        return form;
    },

    /** reload Galaxy's history after updating dataset's attributes */
    _reloadHistory: function _reloadHistory() {
        if (window.Galaxy) {
            window.Galaxy.currHistoryPanel.loadCurrentHistory();
        }
    }
});

exports.default = {
    View: View
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(0), __webpack_require__(1)))

/***/ })
],[682]);


// WEBPACK FOOTER //
// analysis.bundled.js